/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 468);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(475);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(43);
var hide = __webpack_require__(50);
var redefine = __webpack_require__(51);
var ctx = __webpack_require__(59);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _isPlaceholder = __webpack_require__(170);


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2
             : _curry1(function(_b) { return fn(a, _b); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b); })
             : fn(a, b);
    }
  };
};


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_no_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_no_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react__);









function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var CloseIcon = function CloseIcon(_ref) {
  var classes = _ref.classes,
      classNames = _ref.classNames,
      styles = _ref.styles,
      closeIconSize = _ref.closeIconSize,
      closeIconSvgPath = _ref.closeIconSvgPath,
      onClickCloseIcon = _ref.onClickCloseIcon,
      id = _ref.id;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeButton, classNames.closeButton),
    style: styles.closeButton,
    onClick: onClickCloseIcon,
    id: id
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.closeIcon, classNames.closeIcon),
    style: styles.closeIcon,
    xmlns: "http://www.w3.org/2000/svg",
    width: closeIconSize,
    height: closeIconSize,
    viewBox: "0 0 36 36"
  }, closeIconSvgPath));
};

CloseIcon.propTypes = {
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  onClickCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
CloseIcon.defaultProps = {
  id: null
};

var _modals = [];
/**
 * Handle the order of the modals.
 * Inspired by the material-ui implementation.
 */

var modalManager = {
  /**
   * Return the modals array
   */
  modals: function modals() {
    return _modals;
  },

  /**
   * Register a new modal
   */
  add: function add(modal) {
    if (_modals.indexOf(modal) === -1) {
      _modals.push(modal);
    }
  },

  /**
   * Remove a modal
   */
  remove: function remove(modal) {
    var index = _modals.indexOf(modal);

    if (index !== -1) {
      _modals.splice(index, 1);
    }
  },

  /**
   * Check if the modal is the first one on the screen
   */
  isTopModal: function isTopModal(modal) {
    return !!_modals.length && _modals[_modals.length - 1] === modal;
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_overlayCenter__YHoO7 {\n  align-items: center;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n  margin: auto;\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
var cssClasses = {"overlay":"styles_overlay__CLSq-","overlayCenter":"styles_overlayCenter__YHoO7","modal":"styles_modal__gNwvD","closeButton":"styles_closeButton__20ID4","closeIcon":"styles_closeIcon__1QwbI","transitionEnter":"styles_transitionEnter__3j_-a","transitionEnterActive":"styles_transitionEnterActive___eQs7","transitionExit":"styles_transitionExit__1KmEf","transitionExitActive":"styles_transitionExitActive__1nQXw"};
styleInject(css,{"insertAt":"top"});

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldClose", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      showPortal: _this.props.open
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOpen", function () {
      modalManager.add(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        Modal.blockScroll();
      }

      document.addEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
      modalManager.remove(_assertThisInitialized(_assertThisInitialized(_this)));

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }

      document.removeEventListener('keydown', _this.handleKeydown);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOverlay", function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (!_this.shouldClose) {
        _this.shouldClose = null;
        return;
      }

      if (_this.props.onOverlayClick) {
        _this.props.onOverlayClick(event);
      }

      if (_this.props.closeOnOverlayClick) {
        _this.props.onClose(event);
      }

      _this.shouldClose = null;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickCloseIcon", function (event) {
      _this.props.onClose(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeydown", function (event) {
      // Only the last modal need to be escaped when pressing the esc key
      if (event.keyCode !== 27 || !modalManager.isTopModal(_assertThisInitialized(_assertThisInitialized(_this)))) {
        return;
      }

      if (_this.props.onEscKeyDown) {
        _this.props.onEscKeyDown(event);
      }

      if (_this.props.closeOnEsc) {
        _this.props.onClose(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleModalEvent", function () {
      _this.shouldClose = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntered", function () {
      if (_this.props.onEntered) {
        _this.props.onEntered();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleExited", function () {
      if (_this.props.onExited) {
        _this.props.onExited();
      }

      _this.setState({
        showPortal: false
      });

      if (_this.props.blockScroll) {
        _this.unblockScroll();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unblockScroll", function () {
      // Restore the scroll only if there is no modal on the screen
      if (modalManager.modals().length === 0) {
        __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.off();
      }
    });

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Block scroll when initial prop is open
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showPortal && !this.state.showPortal) {
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.open) {
        this.handleClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          open = _this$props.open,
          center = _this$props.center,
          classes = _this$props.classes,
          classNames = _this$props.classNames,
          styles = _this$props.styles,
          showCloseIcon = _this$props.showCloseIcon,
          closeIconSize = _this$props.closeIconSize,
          closeIconSvgPath = _this$props.closeIconSvgPath,
          animationDuration = _this$props.animationDuration,
          container = _this$props.container,
          focusTrapped = _this$props.focusTrapped,
          focusTrapOptions = _this$props.focusTrapOptions,
          overlayId = _this$props.overlayId,
          modalId = _this$props.modalId,
          closeIconId = _this$props.closeIconId;
      var showPortal = this.state.showPortal;

      if (!showPortal) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_minimalist_portal___default.a, {
        container: container
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group_CSSTransition___default.a, {
        in: open,
        appear: true,
        classNames: {
          appear: classNames.transitionEnter || classes.transitionEnter,
          appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          enter: classNames.transitionEnter || classes.transitionEnter,
          enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
          exit: classNames.transitionExit || classes.transitionExit,
          exitActive: classNames.transitionExitActive || classes.transitionExitActive
        },
        timeout: animationDuration,
        onEntered: this.handleEntered,
        onExited: this.handleExited
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.overlay, center ? classes.overlayCenter : null, classNames.overlay),
        onClick: this.handleClickOverlay,
        style: styles.overlay,
        id: overlayId
      }, focusTrapped ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_focus_trap_react___default.a, {
        focusTrapOptions: _objectSpread({}, {
          clickOutsideDeactivates: true
        }, focusTrapOptions)
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes.modal, classNames.modal),
        style: styles.modal,
        onMouseDown: this.handleModalEvent,
        onMouseUp: this.handleModalEvent,
        onClick: this.handleModalEvent,
        id: modalId
      }, this.props.children, showCloseIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseIcon, {
        classes: classes,
        classNames: classNames,
        styles: styles,
        closeIconSize: closeIconSize,
        closeIconSvgPath: closeIconSvgPath,
        onClickCloseIcon: this.handleClickCloseIcon,
        id: closeIconId
      })))));
    }
  }], [{
    key: "blockScroll",
    value: function blockScroll() {
      __WEBPACK_IMPORTED_MODULE_6_no_scroll___default.a.on();
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!prevState.showPortal && nextProps.open) {
        return {
          showPortal: true
        };
      }

      return null;
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Modal.propTypes = {
  /**
   * Is the modal closable when user press esc key.
   */
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Is the modal closable when user click on overlay.
   */
  closeOnOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Callback fired when the Modal is open and the animation is finished.
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal has exited and the animation is finished.
   */
  onExited: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
   */
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,

  /**
   * Callback fired when the escape key is pressed.
   */
  onEscKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Callback fired when the overlay is clicked.
   */
  onOverlayClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Control if the modal is open or not.
   */
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,

  /**
   * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
   */
  classNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
   */
  styles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * The content of the modal.
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * @internal
   */
  classes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Should the dialog be centered.
   */
  center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Show the close icon.
   */
  showCloseIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Close icon size.
   */
  closeIconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * A valid svg path to show as icon.
   */
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,

  /**
   * Animation duration in milliseconds.
   */
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * You can specify a container prop which should be of type `Element`. The portal will be rendered inside that element. The default behavior will create a div node and render it at the at the end of document.body.
   */
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  // eslint-disable-line

  /**
   * Whether to block scrolling when dialog is open
   */
  blockScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * When the modal is open, trap focus within it
   */
  focusTrapped: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Options to be passed to the focus trap, details available at https://github.com/davidtheclark/focus-trap#focustrap--createfocustrapelement-createoptions
   */
  focusTrapOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * id attribute for overlay
   */
  overlayId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for modal
   */
  modalId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * id attribute for close icon
   */
  closeIconId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Modal.defaultProps = {
  classes: cssClasses,
  closeOnEsc: true,
  closeOnOverlayClick: true,
  onEntered: null,
  onExited: null,
  onEscKeyDown: null,
  onOverlayClick: null,
  showCloseIcon: true,
  closeIconSize: 28,
  closeIconSvgPath: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
  }),
  classNames: {},
  styles: {},
  children: null,
  center: false,
  animationDuration: 500,
  blockScroll: true,
  focusTrapped: false,
  focusTrapOptions: {},
  overlayId: null,
  modalId: null,
  closeIconId: null
};
Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycles_compat__["polyfill"])(Modal);

/* harmony default export */ __webpack_exports__["a"] = (Modal);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var _isPlaceholder = __webpack_require__(170);


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _curry2 = __webpack_require__(3);
var _isPlaceholder = __webpack_require__(170);


/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3
             : _curry2(function(_b, _c) { return fn(a, _b, _c); });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
             : _isPlaceholder(a) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _curry1(function(_c) { return fn(a, b, _c); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function(_a, _b) { return fn(_a, _b, c); })
             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function(_b, _c) { return fn(a, _b, _c); })
             : _isPlaceholder(a) ? _curry1(function(_a) { return fn(_a, b, c); })
             : _isPlaceholder(b) ? _curry1(function(_b) { return fn(a, _b, c); })
             : _isPlaceholder(c) ? _curry1(function(_c) { return fn(a, b, _c); })
             : fn(a, b, c);
    }
  };
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function() {
  "use strict";

function immutableInit(config) {

  // https://github.com/facebook/react/blob/v15.0.1/src/isomorphic/classic/element/ReactElement.js#L21
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element');
  var REACT_ELEMENT_TYPE_FALLBACK = 0xeac7;

  var globalConfig = {
    use_static: false
  };
  if (isObject(config)) {
      if (config.use_static !== undefined) {
          globalConfig.use_static = Boolean(config.use_static);
      }
  }

  function isObject(data) {
    return (
      typeof data === 'object' &&
      !Array.isArray(data) &&
      data !== null
    );
  }

  function instantiateEmptyObject(obj) {
      var prototype = Object.getPrototypeOf(obj);
      if (!prototype) {
          return {};
      } else {
          return Object.create(prototype);
      }
  }

  function addPropertyTo(target, methodName, value) {
    Object.defineProperty(target, methodName, {
      enumerable: false,
      configurable: false,
      writable: false,
      value: value
    });
  }

  function banProperty(target, methodName) {
    addPropertyTo(target, methodName, function() {
      throw new ImmutableError("The " + methodName +
        " method cannot be invoked on an Immutable data structure.");
    });
  }

  var immutabilityTag = "__immutable_invariants_hold";

  function addImmutabilityTag(target) {
    addPropertyTo(target, immutabilityTag, true);
  }

  function isImmutable(target) {
    if (typeof target === "object") {
      return target === null || Boolean(
        Object.getOwnPropertyDescriptor(target, immutabilityTag)
      );
    } else {
      // In JavaScript, only objects are even potentially mutable.
      // strings, numbers, null, and undefined are all naturally immutable.
      return true;
    }
  }

  function isEqual(a, b) {
    // Avoid false positives due to (NaN !== NaN) evaluating to true
    return (a === b || (a !== a && b !== b));
  }

  function isMergableObject(target) {
    return target !== null && typeof target === "object" && !(Array.isArray(target)) && !(target instanceof Date);
  }

  var mutatingObjectMethods = [
    "setPrototypeOf"
  ];

  var nonMutatingObjectMethods = [
    "keys"
  ];

  var mutatingArrayMethods = mutatingObjectMethods.concat([
    "push", "pop", "sort", "splice", "shift", "unshift", "reverse"
  ]);

  var nonMutatingArrayMethods = nonMutatingObjectMethods.concat([
    "map", "filter", "slice", "concat", "reduce", "reduceRight"
  ]);

  var mutatingDateMethods = mutatingObjectMethods.concat([
    "setDate", "setFullYear", "setHours", "setMilliseconds", "setMinutes", "setMonth", "setSeconds",
    "setTime", "setUTCDate", "setUTCFullYear", "setUTCHours", "setUTCMilliseconds", "setUTCMinutes",
    "setUTCMonth", "setUTCSeconds", "setYear"
  ]);

  function ImmutableError(message) {
    this.name = 'MyError';
    this.message = message;
    this.stack = (new Error()).stack;
  }
  ImmutableError.prototype = new Error();
  ImmutableError.prototype.constructor = Error;

  function makeImmutable(obj, bannedMethods) {
    // Tag it so we can quickly tell it's immutable later.
    addImmutabilityTag(obj);

    if (true) {
      // Make all mutating methods throw exceptions.
      for (var index in bannedMethods) {
        if (bannedMethods.hasOwnProperty(index)) {
          banProperty(obj, bannedMethods[index]);
        }
      }

      // Freeze it and return it.
      Object.freeze(obj);
    }

    return obj;
  }

  function makeMethodReturnImmutable(obj, methodName) {
    var currentMethod = obj[methodName];

    addPropertyTo(obj, methodName, function() {
      return Immutable(currentMethod.apply(obj, arguments));
    });
  }

  function arraySet(idx, value, config) {
    var deep          = config && config.deep;

    if (idx in this) {
      if (deep && this[idx] !== value && isMergableObject(value) && isMergableObject(this[idx])) {
        value = Immutable.merge(this[idx], value, {deep: true, mode: 'replace'});
      }
      if (isEqual(this[idx], value)) {
        return this;
      }
    }

    var mutable = asMutableArray.call(this);
    mutable[idx] = Immutable(value);
    return makeImmutableArray(mutable);
  }

  var immutableEmptyArray = Immutable([]);

  function arraySetIn(pth, value, config) {
    var head = pth[0];

    if (pth.length === 1) {
      return arraySet.call(this, head, value, config);
    } else {
      var tail = pth.slice(1);
      var thisHead = this[head];
      var newValue;

      if (typeof(thisHead) === "object" && thisHead !== null) {
        // Might (validly) be object or array
        newValue = Immutable.setIn(thisHead, tail, value);
      } else {
        var nextHead = tail[0];
        // If the next path part is a number, then we are setting into an array, else an object.
        if (nextHead !== '' && isFinite(nextHead)) {
          newValue = arraySetIn.call(immutableEmptyArray, tail, value);
        } else {
          newValue = objectSetIn.call(immutableEmptyObject, tail, value);
        }
      }

      if (head in this && thisHead === newValue) {
        return this;
      }

      var mutable = asMutableArray.call(this);
      mutable[head] = newValue;
      return makeImmutableArray(mutable);
    }
  }

  function makeImmutableArray(array) {
    // Don't change their implementations, but wrap these functions to make sure
    // they always return an immutable value.
    for (var index in nonMutatingArrayMethods) {
      if (nonMutatingArrayMethods.hasOwnProperty(index)) {
        var methodName = nonMutatingArrayMethods[index];
        makeMethodReturnImmutable(array, methodName);
      }
    }

    if (!globalConfig.use_static) {
      addPropertyTo(array, "flatMap",  flatMap);
      addPropertyTo(array, "asObject", asObject);
      addPropertyTo(array, "asMutable", asMutableArray);
      addPropertyTo(array, "set", arraySet);
      addPropertyTo(array, "setIn", arraySetIn);
      addPropertyTo(array, "update", update);
      addPropertyTo(array, "updateIn", updateIn);
      addPropertyTo(array, "getIn", getIn);
    }

    for(var i = 0, length = array.length; i < length; i++) {
      array[i] = Immutable(array[i]);
    }

    return makeImmutable(array, mutatingArrayMethods);
  }

  function makeImmutableDate(date) {
    if (!globalConfig.use_static) {
      addPropertyTo(date, "asMutable", asMutableDate);
    }

    return makeImmutable(date, mutatingDateMethods);
  }

  function asMutableDate() {
    return new Date(this.getTime());
  }

  /**
   * Effectively performs a map() over the elements in the array, using the
   * provided iterator, except that whenever the iterator returns an array, that
   * array's elements are added to the final result instead of the array itself.
   *
   * @param {function} iterator - The iterator function that will be invoked on each element in the array. It will receive three arguments: the current value, the current index, and the current object.
   */
  function flatMap(iterator) {
    // Calling .flatMap() with no arguments is a no-op. Don't bother cloning.
    if (arguments.length === 0) {
      return this;
    }

    var result = [],
        length = this.length,
        index;

    for (index = 0; index < length; index++) {
      var iteratorResult = iterator(this[index], index, this);

      if (Array.isArray(iteratorResult)) {
        // Concatenate Array results into the return value we're building up.
        result.push.apply(result, iteratorResult);
      } else {
        // Handle non-Array results the same way map() does.
        result.push(iteratorResult);
      }
    }

    return makeImmutableArray(result);
  }

  /**
   * Returns an Immutable copy of the object without the given keys included.
   *
   * @param {array} keysToRemove - A list of strings representing the keys to exclude in the return value. Instead of providing a single array, this method can also be called by passing multiple strings as separate arguments.
   */
  function without(remove) {
    // Calling .without() with no arguments is a no-op. Don't bother cloning.
    if (typeof remove === "undefined" && arguments.length === 0) {
      return this;
    }

    if (typeof remove !== "function") {
      // If we weren't given an array, use the arguments list.
      var keysToRemoveArray = (Array.isArray(remove)) ?
         remove.slice() : Array.prototype.slice.call(arguments);

      // Convert numeric keys to strings since that's how they'll
      // come from the enumeration of the object.
      keysToRemoveArray.forEach(function(el, idx, arr) {
        if(typeof(el) === "number") {
          arr[idx] = el.toString();
        }
      });

      remove = function(val, key) {
        return keysToRemoveArray.indexOf(key) !== -1;
      };
    }

    var result = instantiateEmptyObject(this);

    for (var key in this) {
      if (this.hasOwnProperty(key) && remove(this[key], key) === false) {
        result[key] = this[key];
      }
    }

    return makeImmutableObject(result);
  }

  function asMutableArray(opts) {
    var result = [], i, length;

    if(opts && opts.deep) {
      for(i = 0, length = this.length; i < length; i++) {
        result.push(asDeepMutable(this[i]));
      }
    } else {
      for(i = 0, length = this.length; i < length; i++) {
        result.push(this[i]);
      }
    }

    return result;
  }

  /**
   * Effectively performs a [map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map) over the elements in the array, expecting that the iterator function
   * will return an array of two elements - the first representing a key, the other
   * a value. Then returns an Immutable Object constructed of those keys and values.
   *
   * @param {function} iterator - A function which should return an array of two elements - the first representing the desired key, the other the desired value.
   */
  function asObject(iterator) {
    // If no iterator was provided, assume the identity function
    // (suggesting this array is already a list of key/value pairs.)
    if (typeof iterator !== "function") {
      iterator = function(value) { return value; };
    }

    var result = {},
        length = this.length,
        index;

    for (index = 0; index < length; index++) {
      var pair  = iterator(this[index], index, this),
          key   = pair[0],
          value = pair[1];

      result[key] = value;
    }

    return makeImmutableObject(result);
  }

  function asDeepMutable(obj) {
    if (
      (!obj) ||
      (typeof obj !== 'object') ||
      (!Object.getOwnPropertyDescriptor(obj, immutabilityTag)) ||
      (obj instanceof Date)
    ) { return obj; }
    return Immutable.asMutable(obj, {deep: true});
  }

  function quickCopy(src, dest) {
    for (var key in src) {
      if (Object.getOwnPropertyDescriptor(src, key)) {
        dest[key] = src[key];
      }
    }

    return dest;
  }

  /**
   * Returns an Immutable Object containing the properties and values of both
   * this object and the provided object, prioritizing the provided object's
   * values whenever the same key is present in both objects.
   *
   * @param {object} other - The other object to merge. Multiple objects can be passed as an array. In such a case, the later an object appears in that list, the higher its priority.
   * @param {object} config - Optional config object that contains settings. Supported settings are: {deep: true} for deep merge and {merger: mergerFunc} where mergerFunc is a function
   *                          that takes a property from both objects. If anything is returned it overrides the normal merge behaviour.
   */
  function merge(other, config) {
    // Calling .merge() with no arguments is a no-op. Don't bother cloning.
    if (arguments.length === 0) {
      return this;
    }

    if (other === null || (typeof other !== "object")) {
      throw new TypeError("Immutable#merge can only be invoked with objects or arrays, not " + JSON.stringify(other));
    }

    var receivedArray = (Array.isArray(other)),
        deep          = config && config.deep,
        mode          = config && config.mode || 'merge',
        merger        = config && config.merger,
        result;

    // Use the given key to extract a value from the given object, then place
    // that value in the result object under the same key. If that resulted
    // in a change from this object's value at that key, set anyChanges = true.
    function addToResult(currentObj, otherObj, key) {
      var immutableValue = Immutable(otherObj[key]);
      var mergerResult = merger && merger(currentObj[key], immutableValue, config);
      var currentValue = currentObj[key];

      if ((result !== undefined) ||
        (mergerResult !== undefined) ||
        (!currentObj.hasOwnProperty(key)) ||
        !isEqual(immutableValue, currentValue)) {

        var newValue;

        if (mergerResult !== undefined) {
          newValue = mergerResult;
        } else if (deep && isMergableObject(currentValue) && isMergableObject(immutableValue)) {
          newValue = Immutable.merge(currentValue, immutableValue, config);
        } else {
          newValue = immutableValue;
        }

        if (!isEqual(currentValue, newValue) || !currentObj.hasOwnProperty(key)) {
          if (result === undefined) {
            // Make a shallow clone of the current object.
            result = quickCopy(currentObj, instantiateEmptyObject(currentObj));
          }

          result[key] = newValue;
        }
      }
    }

    function clearDroppedKeys(currentObj, otherObj) {
      for (var key in currentObj) {
        if (!otherObj.hasOwnProperty(key)) {
          if (result === undefined) {
            // Make a shallow clone of the current object.
            result = quickCopy(currentObj, instantiateEmptyObject(currentObj));
          }
          delete result[key];
        }
      }
    }

    var key;

    // Achieve prioritization by overriding previous values that get in the way.
    if (!receivedArray) {
      // The most common use case: just merge one object into the existing one.
      for (key in other) {
        if (Object.getOwnPropertyDescriptor(other, key)) {
          addToResult(this, other, key);
        }
      }
      if (mode === 'replace') {
        clearDroppedKeys(this, other);
      }
    } else {
      // We also accept an Array
      for (var index = 0, length = other.length; index < length; index++) {
        var otherFromArray = other[index];

        for (key in otherFromArray) {
          if (otherFromArray.hasOwnProperty(key)) {
            addToResult(result !== undefined ? result : this, otherFromArray, key);
          }
        }
      }
    }

    if (result === undefined) {
      return this;
    } else {
      return makeImmutableObject(result);
    }
  }

  function objectReplace(value, config) {
    var deep          = config && config.deep;

    // Calling .replace() with no arguments is a no-op. Don't bother cloning.
    if (arguments.length === 0) {
      return this;
    }

    if (value === null || typeof value !== "object") {
      throw new TypeError("Immutable#replace can only be invoked with objects or arrays, not " + JSON.stringify(value));
    }

    return Immutable.merge(this, value, {deep: deep, mode: 'replace'});
  }

  var immutableEmptyObject = Immutable({});

  function objectSetIn(path, value, config) {
    if (!(Array.isArray(path)) || path.length === 0) {
      throw new TypeError("The first argument to Immutable#setIn must be an array containing at least one \"key\" string.");
    }

    var head = path[0];
    if (path.length === 1) {
      return objectSet.call(this, head, value, config);
    }

    var tail = path.slice(1);
    var newValue;
    var thisHead = this[head];

    if (this.hasOwnProperty(head) && typeof(thisHead) === "object" && thisHead !== null) {
      // Might (validly) be object or array
      newValue = Immutable.setIn(thisHead, tail, value);
    } else {
      newValue = objectSetIn.call(immutableEmptyObject, tail, value);
    }

    if (this.hasOwnProperty(head) && thisHead === newValue) {
      return this;
    }

    var mutable = quickCopy(this, instantiateEmptyObject(this));
    mutable[head] = newValue;
    return makeImmutableObject(mutable);
  }

  function objectSet(property, value, config) {
    var deep          = config && config.deep;

    if (this.hasOwnProperty(property)) {
      if (deep && this[property] !== value && isMergableObject(value) && isMergableObject(this[property])) {
        value = Immutable.merge(this[property], value, {deep: true, mode: 'replace'});
      }
      if (isEqual(this[property], value)) {
        return this;
      }
    }

    var mutable = quickCopy(this, instantiateEmptyObject(this));
    mutable[property] = Immutable(value);
    return makeImmutableObject(mutable);
  }

  function update(property, updater) {
    var restArgs = Array.prototype.slice.call(arguments, 2);
    var initialVal = this[property];
    return Immutable.set(this, property, updater.apply(initialVal, [initialVal].concat(restArgs)));
  }

  function getInPath(obj, path) {
    /*jshint eqnull:true */
    for (var i = 0, l = path.length; obj != null && i < l; i++) {
      obj = obj[path[i]];
    }

    return (i && i == l) ? obj : undefined;
  }

  function updateIn(path, updater) {
    var restArgs = Array.prototype.slice.call(arguments, 2);
    var initialVal = getInPath(this, path);

    return Immutable.setIn(this, path, updater.apply(initialVal, [initialVal].concat(restArgs)));
  }

  function getIn(path, defaultValue) {
    var value = getInPath(this, path);
    return value === undefined ? defaultValue : value;
  }

  function asMutableObject(opts) {
    var result = instantiateEmptyObject(this), key;

    if(opts && opts.deep) {
      for (key in this) {
        if (this.hasOwnProperty(key)) {
          result[key] = asDeepMutable(this[key]);
        }
      }
    } else {
      for (key in this) {
        if (this.hasOwnProperty(key)) {
          result[key] = this[key];
        }
      }
    }

    return result;
  }

  // Creates plain object to be used for cloning
  function instantiatePlainObject() {
    return {};
  }

  // Finalizes an object with immutable methods, freezes it, and returns it.
  function makeImmutableObject(obj) {
    if (!globalConfig.use_static) {
      addPropertyTo(obj, "merge", merge);
      addPropertyTo(obj, "replace", objectReplace);
      addPropertyTo(obj, "without", without);
      addPropertyTo(obj, "asMutable", asMutableObject);
      addPropertyTo(obj, "set", objectSet);
      addPropertyTo(obj, "setIn", objectSetIn);
      addPropertyTo(obj, "update", update);
      addPropertyTo(obj, "updateIn", updateIn);
      addPropertyTo(obj, "getIn", getIn);
    }

    return makeImmutable(obj, mutatingObjectMethods);
  }

  // Returns true if object is a valid react element
  // https://github.com/facebook/react/blob/v15.0.1/src/isomorphic/classic/element/ReactElement.js#L326
  function isReactElement(obj) {
    return typeof obj === 'object' &&
           obj !== null &&
           (obj.$$typeof === REACT_ELEMENT_TYPE_FALLBACK || obj.$$typeof === REACT_ELEMENT_TYPE);
  }

  function isFileObject(obj) {
    return typeof File !== 'undefined' &&
           obj instanceof File;
  }

  function isBlobObject(obj) {
    return typeof Blob !== 'undefined' &&
           obj instanceof Blob;
  }

  function isPromise(obj) {
    return typeof obj === 'object' &&
           typeof obj.then === 'function';
  }

  function isError(obj) {
    return obj instanceof Error;
  }

  function Immutable(obj, options, stackRemaining) {
    if (isImmutable(obj) || isReactElement(obj) || isFileObject(obj) || isBlobObject(obj) || isError(obj)) {
      return obj;
    } else if (isPromise(obj)) {
      return obj.then(Immutable);
    } else if (Array.isArray(obj)) {
      return makeImmutableArray(obj.slice());
    } else if (obj instanceof Date) {
      return makeImmutableDate(new Date(obj.getTime()));
    } else {
      // Don't freeze the object we were given; make a clone and use that.
      var prototype = options && options.prototype;
      var instantiateEmptyObject =
        (!prototype || prototype === Object.prototype) ?
          instantiatePlainObject : (function() { return Object.create(prototype); });
      var clone = instantiateEmptyObject();

      if (true) {
        /*jshint eqnull:true */
        if (stackRemaining == null) {
          stackRemaining = 64;
        }
        if (stackRemaining <= 0) {
          throw new ImmutableError("Attempt to construct Immutable from a deeply nested object was detected." +
            " Have you tried to wrap an object with circular references (e.g. React element)?" +
            " See https://github.com/rtfeldman/seamless-immutable/wiki/Deeply-nested-object-was-detected for details.");
        }
        stackRemaining -= 1;
      }

      for (var key in obj) {
        if (Object.getOwnPropertyDescriptor(obj, key)) {
          clone[key] = Immutable(obj[key], undefined, stackRemaining);
        }
      }

      return makeImmutableObject(clone);
    }
  }

  // Wrapper to allow the use of object methods as static methods of Immutable.
  function toStatic(fn) {
    function staticWrapper() {
      var args = [].slice.call(arguments);
      var self = args.shift();
      return fn.apply(self, args);
    }

    return staticWrapper;
  }

  // Wrapper to allow the use of object methods as static methods of Immutable.
  // with the additional condition of choosing which function to call depending
  // if argument is an array or an object.
  function toStaticObjectOrArray(fnObject, fnArray) {
    function staticWrapper() {
      var args = [].slice.call(arguments);
      var self = args.shift();
      if (Array.isArray(self)) {
          return fnArray.apply(self, args);
      } else {
          return fnObject.apply(self, args);
      }
    }

    return staticWrapper;
  }

  // Wrapper to allow the use of object methods as static methods of Immutable.
  // with the additional condition of choosing which function to call depending
  // if argument is an array or an object or a date.
  function toStaticObjectOrDateOrArray(fnObject, fnArray, fnDate) {
    function staticWrapper() {
      var args = [].slice.call(arguments);
      var self = args.shift();
      if (Array.isArray(self)) {
          return fnArray.apply(self, args);
      } else if (self instanceof Date) {
          return fnDate.apply(self, args);
      } else {
          return fnObject.apply(self, args);
      }
    }

    return staticWrapper;
  }

  // Export the library
  Immutable.from           = Immutable;
  Immutable.isImmutable    = isImmutable;
  Immutable.ImmutableError = ImmutableError;
  Immutable.merge          = toStatic(merge);
  Immutable.replace        = toStatic(objectReplace);
  Immutable.without        = toStatic(without);
  Immutable.asMutable      = toStaticObjectOrDateOrArray(asMutableObject, asMutableArray, asMutableDate);
  Immutable.set            = toStaticObjectOrArray(objectSet, arraySet);
  Immutable.setIn          = toStaticObjectOrArray(objectSetIn, arraySetIn);
  Immutable.update         = toStatic(update);
  Immutable.updateIn       = toStatic(updateIn);
  Immutable.getIn          = toStatic(getIn);
  Immutable.flatMap        = toStatic(flatMap);
  Immutable.asObject       = toStatic(asObject);
  if (!globalConfig.use_static) {
      Immutable.static = immutableInit({
          use_static: true
      });
  }

  Object.freeze(Immutable);

  return Immutable;
}

  var Immutable = immutableInit();
  /* istanbul ignore if */
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return Immutable;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object") {
    module.exports = Immutable;
  } else if (typeof exports === "object") {
    exports.Immutable = Immutable;
  } else if (typeof window === "object") {
    window.Immutable = Immutable;
  } else if (typeof global === "object") {
    global.Immutable = Immutable;
  }
})();


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1279);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_localforage__);
var getToken=function getToken(){return __WEBPACK_IMPORTED_MODULE_0_localforage___default.a.getItem('access_token').then(function(value){return value;}).catch(function(){return false;});};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var R = __webpack_require__(230);
var R__default = _interopDefault(R);
var RS = _interopDefault(__webpack_require__(731));

/**
  Creates a reducer.
  @param {string} initialState - The initial state for this reducer.
  @param {object} handlers - Keys are action types (strings), values are reducers (functions).
  @return {object} A reducer object.
 */
var cr = (function (initialState, handlers) {
  // initial state is required
  if (R__default.isNil(initialState)) {
    throw new Error('initial state is required');
  }

  // handlers must be an object
  if (R__default.isNil(handlers) || !R__default.is(Object, handlers)) {
    throw new Error('handlers must be an object');
  }

  // handlers cannot have an undefined key
  if (R__default.any(R__default.equals('undefined'))(R__default.keys(handlers))) {
    throw new Error('handlers cannot have an undefined key');
  }

  // create the reducer function
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    // wrong actions, just return state
    if (R__default.isNil(action)) return state;
    if (!R__default.has('type', action)) return state;

    // look for the handler
    var handler = handlers[action.type];

    // no handler no cry
    if (R__default.isNil(handler)) return state;

    // execute the handler
    return handler(state, action);
  };
});

var defaultOptions = {
  prefix: ''
};

var createTypes$1 = (function (types, options) {
  if (RS.isNilOrEmpty(types)) throw new Error('valid types are required');

  var _R$merge = R__default.merge(defaultOptions, options),
      prefix = _R$merge.prefix;

  return R__default.pipe(R__default.trim, R__default.split(/\s/), R__default.map(R__default.pipe(R__default.trim)), R__default.without([null, '']), R__default.map(function (x) {
    return [x, prefix + x];
  }), R__default.fromPairs)(types);
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var defaultOptions$1 = {
  prefix: ''
};

// matches on capital letters (except at the start & end of the string)
var RX_CAPS = /(?!^)([A-Z])/g;

// converts a camelCaseWord into a SCREAMING_SNAKE_CASE word
var camelToScreamingSnake = R.pipe(R.replace(RX_CAPS, '_$1'), R.toUpper);

// build Action Types out of an object
var convertToTypes = function convertToTypes(config, options) {
  var typesCreator = R.curry(createTypes$1)(R.__, options);

  return R.pipe(R.keys, // just the keys
  R.map(camelToScreamingSnake), // CONVERT_THEM
  R.join(' '), // space separated
  typesCreator // make them into Redux Types
  )(config);
};

// an action creator with additional properties
var createActionCreator = function createActionCreator(name, extraPropNames, options) {
  var _merge = R.merge(defaultOptions$1, options),
      prefix = _merge.prefix;

  // types are upcase and snakey


  var type = prefix + camelToScreamingSnake(name);

  // do we need extra props for this?
  var noKeys = R.isNil(extraPropNames) || R.isEmpty(extraPropNames);

  // a type-only action creator
  if (noKeys) return function () {
    return { type: type };
  };

  // an action creator with type + properties
  return function () {
    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    var extraProps = R.zipObj(extraPropNames, values);
    return _extends({ type: type }, extraProps);
  };
};

// build Action Creators out of an objet
var convertToCreators = function convertToCreators(config, options) {
  return R.mapObjIndexed(function (num, key, value) {
    if (typeof value[key] === 'function') {
      // the user brought their own action creator
      return value[key];
    } else {
      // lets make an action creator for them!
      return createActionCreator(key, value[key], options);
    }
  })(config);
};

var ca = (function (config, options) {
  if (R.isNil(config)) {
    throw new Error('an object is required to setup types and creators');
  }
  if (R.isEmpty(config)) {
    throw new Error('empty objects are not supported');
  }

  return {
    Types: convertToTypes(config, options),
    Creators: convertToCreators(config, options)
  };
});

/**
 * Allows your reducers to be reset.
 *
 * @param {string} typeToReset - The action type to listen for.
 * @param {function} originalReducer - The reducer to wrap.
 */
function resettableReducer$1(typeToReset, originalReducer) {
  // a valid type is required
  if (!R.is(String, typeToReset) || typeToReset === '') {
    throw new Error('A valid reset type is required.');
  }

  // an original reducer is required
  if (typeof originalReducer !== 'function') {
    throw new Error('A reducer is required.');
  }
  // run it through first to get what the default state should be
  var resetState = originalReducer(undefined, {});

  // create our own reducer that wraps the original one and hijacks the reset
  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : resetState;
    var action = arguments[1];

    if (action && action.type === typeToReset) {
      return resetState;
    } else {
      return originalReducer(state, action);
    }
  }
  return reducer;
}

var rr = R.curry(resettableReducer$1);

var createReducer = cr;
var createTypes = createTypes$1;
var createActions = ca;
var resettableReducer = rr;

exports.createReducer = createReducer;
exports.createTypes = createTypes;
exports.createActions = createActions;
exports.resettableReducer = resettableReducer;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(20));

var _paginator = _interopRequireDefault(__webpack_require__(846));

var _Page = _interopRequireDefault(__webpack_require__(847));

var _classnames = _interopRequireDefault(__webpack_require__(196));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Pagination, _React$Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "isFirstPageVisible",
    value: function isFirstPageVisible(has_previous_page) {
      var _this$props = this.props,
          hideDisabled = _this$props.hideDisabled,
          hideNavigation = _this$props.hideNavigation,
          hideFirstLastPages = _this$props.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isPrevPageVisible",
    value: function isPrevPageVisible(has_previous_page) {
      var _this$props2 = this.props,
          hideDisabled = _this$props2.hideDisabled,
          hideNavigation = _this$props2.hideNavigation;
      if (hideNavigation || hideDisabled && !has_previous_page) return false;
      return true;
    }
  }, {
    key: "isNextPageVisible",
    value: function isNextPageVisible(has_next_page) {
      var _this$props3 = this.props,
          hideDisabled = _this$props3.hideDisabled,
          hideNavigation = _this$props3.hideNavigation;
      if (hideNavigation || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "isLastPageVisible",
    value: function isLastPageVisible(has_next_page) {
      var _this$props4 = this.props,
          hideDisabled = _this$props4.hideDisabled,
          hideNavigation = _this$props4.hideNavigation,
          hideFirstLastPages = _this$props4.hideFirstLastPages;
      if (hideFirstLastPages || hideDisabled && !has_next_page) return false;
      return true;
    }
  }, {
    key: "buildPages",
    value: function buildPages() {
      var pages = [];
      var _this$props5 = this.props,
          itemsCountPerPage = _this$props5.itemsCountPerPage,
          pageRangeDisplayed = _this$props5.pageRangeDisplayed,
          activePage = _this$props5.activePage,
          prevPageText = _this$props5.prevPageText,
          nextPageText = _this$props5.nextPageText,
          firstPageText = _this$props5.firstPageText,
          lastPageText = _this$props5.lastPageText,
          totalItemsCount = _this$props5.totalItemsCount,
          onChange = _this$props5.onChange,
          activeClass = _this$props5.activeClass,
          itemClass = _this$props5.itemClass,
          itemClassFirst = _this$props5.itemClassFirst,
          itemClassPrev = _this$props5.itemClassPrev,
          itemClassNext = _this$props5.itemClassNext,
          itemClassLast = _this$props5.itemClassLast,
          activeLinkClass = _this$props5.activeLinkClass,
          disabledClass = _this$props5.disabledClass,
          hideDisabled = _this$props5.hideDisabled,
          hideNavigation = _this$props5.hideNavigation,
          linkClass = _this$props5.linkClass,
          linkClassFirst = _this$props5.linkClassFirst,
          linkClassPrev = _this$props5.linkClassPrev,
          linkClassNext = _this$props5.linkClassNext,
          linkClassLast = _this$props5.linkClassLast,
          hideFirstLastPages = _this$props5.hideFirstLastPages,
          getPageUrl = _this$props5.getPageUrl;
      var paginationInfo = new _paginator["default"](itemsCountPerPage, pageRangeDisplayed).build(totalItemsCount, activePage);

      for (var i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
        pages.push(_react["default"].createElement(_Page["default"], {
          isActive: i === activePage,
          key: i,
          href: getPageUrl(i),
          pageNumber: i,
          pageText: i + "",
          onClick: onChange,
          itemClass: itemClass,
          linkClass: linkClass,
          activeClass: activeClass,
          activeLinkClass: activeLinkClass,
          ariaLabel: "Go to page number ".concat(i)
        }));
      }

      this.isPrevPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "prev" + paginationInfo.previous_page,
        href: getPageUrl(paginationInfo.previous_page),
        pageNumber: paginationInfo.previous_page,
        onClick: onChange,
        pageText: prevPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassPrev),
        linkClass: (0, _classnames["default"])(linkClass, linkClassPrev),
        disabledClass: disabledClass,
        ariaLabel: "Go to previous page"
      }));
      this.isFirstPageVisible(paginationInfo.has_previous_page) && pages.unshift(_react["default"].createElement(_Page["default"], {
        key: "first",
        href: getPageUrl(1),
        pageNumber: 1,
        onClick: onChange,
        pageText: firstPageText,
        isDisabled: !paginationInfo.has_previous_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassFirst),
        linkClass: (0, _classnames["default"])(linkClass, linkClassFirst),
        disabledClass: disabledClass,
        ariaLabel: "Go to first page"
      }));
      this.isNextPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "next" + paginationInfo.next_page,
        href: getPageUrl(paginationInfo.next_page),
        pageNumber: paginationInfo.next_page,
        onClick: onChange,
        pageText: nextPageText,
        isDisabled: !paginationInfo.has_next_page,
        itemClass: (0, _classnames["default"])(itemClass, itemClassNext),
        linkClass: (0, _classnames["default"])(linkClass, linkClassNext),
        disabledClass: disabledClass,
        ariaLabel: "Go to next page"
      }));
      this.isLastPageVisible(paginationInfo.has_next_page) && pages.push(_react["default"].createElement(_Page["default"], {
        key: "last",
        href: getPageUrl(paginationInfo.total_pages),
        pageNumber: paginationInfo.total_pages,
        onClick: onChange,
        pageText: lastPageText,
        isDisabled: paginationInfo.current_page === paginationInfo.total_pages,
        itemClass: (0, _classnames["default"])(itemClass, itemClassLast),
        linkClass: (0, _classnames["default"])(linkClass, linkClassLast),
        disabledClass: disabledClass,
        ariaLabel: "Go to last page"
      }));
      return pages;
    }
  }, {
    key: "render",
    value: function render() {
      var pages = this.buildPages();
      return _react["default"].createElement("ul", {
        className: this.props.innerClass
      }, pages);
    }
  }]);

  return Pagination;
}(_react["default"].Component);

exports["default"] = Pagination;

_defineProperty(Pagination, "propTypes", {
  totalItemsCount: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  activePage: _propTypes["default"].number,
  itemsCountPerPage: _propTypes["default"].number,
  pageRangeDisplayed: _propTypes["default"].number,
  prevPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  nextPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  lastPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  firstPageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  disabledClass: _propTypes["default"].string,
  hideDisabled: _propTypes["default"].bool,
  hideNavigation: _propTypes["default"].bool,
  innerClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  itemClassFirst: _propTypes["default"].string,
  itemClassPrev: _propTypes["default"].string,
  itemClassNext: _propTypes["default"].string,
  itemClassLast: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  linkClassFirst: _propTypes["default"].string,
  linkClassPrev: _propTypes["default"].string,
  linkClassNext: _propTypes["default"].string,
  linkClassLast: _propTypes["default"].string,
  hideFirstLastPages: _propTypes["default"].bool,
  getPageUrl: _propTypes["default"].func
});

_defineProperty(Pagination, "defaultProps", {
  itemsCountPerPage: 10,
  pageRangeDisplayed: 5,
  activePage: 1,
  prevPageText: "⟨",
  firstPageText: "«",
  nextPageText: "⟩",
  lastPageText: "»",
  innerClass: "pagination",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkClass: undefined,
  hideFirstLastPages: false,
  getPageUrl: function getPageUrl(i) {
    return "#";
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = baseListen;
/* harmony export (immutable) */ __webpack_exports__["b"] = baseFetchToken;
/* unused harmony export baseFetchTokenUpdate */
/* harmony export (immutable) */ __webpack_exports__["a"] = baseFetchNoToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = baseFetchTokenFullResponse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__ = __webpack_require__(26);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(baseListen),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(baseFetchToken),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(baseFetchTokenUpdate),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(baseFetchNoToken),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(baseFetchTokenFullResponse);function baseListen(type,fetchSaga,api,token){var action;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function baseListen$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* take */])(type);case 2:action=_context.sent;case 3:if(!(action!==__WEBPACK_IMPORTED_MODULE_2_redux_saga__["a" /* END */])){_context.next=16;break;}if(!token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(fetchSaga,api,token,action);case 7:_context.next=11;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(fetchSaga,api,action);case 11:_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* take */])(type);case 13:action=_context.sent;_context.next=3;break;case 16:case'end':return _context.stop();}}},_marked,this);}function baseFetchToken(api,data,getToken,successAction,failureAction){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function baseFetchToken$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getToken);case 3:token=_context2.sent;if(token){_context2.next=9;break;}_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context2.next=24;break;case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api,token,data);case 11:res=_context2.sent;if(res.ok){_context2.next=17;break;}_context2.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction(res.data.message||'Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context2.next=24;break;case 17:if(res.data.error){_context2.next=22;break;}_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(successAction(res.data.data));case 20:_context2.next=24;break;case 22:_context2.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction(res.data.message));case 24:_context2.next=30;break;case 26:_context2.prev=26;_context2.t0=_context2['catch'](0);_context2.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction());case 30:case'end':return _context2.stop();}}},_marked2,this,[[0,26]]);}function baseFetchTokenUpdate(api,data,getToken,successAction,failureAction){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function baseFetchTokenUpdate$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getToken);case 3:token=_context3.sent;if(token){_context3.next=9;break;}_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context3.next=24;break;case 9:_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api,token,data);case 11:res=_context3.sent;if(res.ok){_context3.next=17;break;}_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context3.next=24;break;case 17:if(res.data.error){_context3.next=22;break;}_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(successAction(data));case 20:_context3.next=24;break;case 22:_context3.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction(res.data.message));case 24:_context3.next=30;break;case 26:_context3.prev=26;_context3.t0=_context3['catch'](0);_context3.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction());case 30:case'end':return _context3.stop();}}},_marked3,this,[[0,26]]);}function baseFetchNoToken(api,data,successAction,failureAction){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function baseFetchNoToken$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api,data);case 3:res=_context4.sent;if(res.ok){_context4.next=9;break;}_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'));case 7:_context4.next=16;break;case 9:if(res.data.error){_context4.next=14;break;}_context4.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(successAction(res.data.data));case 12:_context4.next=16;break;case 14:_context4.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction(res.data.message));case 16:_context4.next=22;break;case 18:_context4.prev=18;_context4.t0=_context4['catch'](0);_context4.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction());case 22:case'end':return _context4.stop();}}},_marked4,this,[[0,18]]);}function baseFetchTokenFullResponse(api,data,getToken,successAction,failureAction){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function baseFetchTokenFullResponse$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getToken);case 3:token=_context5.sent;if(token){_context5.next=9;break;}_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context5.next=24;break;case 9:_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api,token,data);case 11:res=_context5.sent;if(res.ok){_context5.next=17;break;}_context5.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context5.next=24;break;case 17:if(res.data.error){_context5.next=22;break;}_context5.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(successAction(res.data));case 20:_context5.next=24;break;case 22:_context5.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction(res.data.message));case 24:_context5.next=30;break;case 26:_context5.prev=26;_context5.t0=_context5['catch'](0);_context5.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(failureAction());case 30:case'end':return _context5.stop();}}},_marked5,this,[[0,26]]);}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return currentRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentCurrency; });
var currentBranch=function currentBranch(){return window.localStorage.getItem('branch');};var currentRole=function currentRole(){return window.localStorage.getItem('user_role');};var currentCurrency=function currentCurrency(){var branch=window.localStorage.getItem('branch');switch(branch){case'ID':return'IDR';case'PH':return'PHP';default:return null;}};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144)(module)))

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export makeAsyncSelect */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export makeCreatableSelect */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* unused harmony export components */
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (_typeof(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_5_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty(_ref3, alignToControl(placement), '100%'), _defineProperty(_ref3, "backgroundColor", colors.neutral0), _defineProperty(_ref3, "borderRadius", borderRadius), _defineProperty(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty(_ref3, "marginBottom", spacing.menuGutter), _defineProperty(_ref3, "marginTop", spacing.menuGutter), _defineProperty(_ref3, "position", 'absolute'), _defineProperty(_ref3, "width", '100%'), _defineProperty(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  _inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  _createClass(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  var cn = cx(
  /*#__PURE__*/
  Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menu', props)), {
    menu: true
  }, className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cn
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuList', props)), {
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  _inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    _classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "state", {
      placement: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  _createClass(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('menuPortal', state))
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _objectSpread({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      label: 'a11yText',
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  _inherits(DummyInput, _Component);

  function DummyInput() {
    _classCallCheck(this, DummyInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyInput).apply(this, arguments));
  }

  _createClass(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = _objectWithoutProperties(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", _extends({
        ref: innerRef
      }, props, {
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  _inherits(NodeResolver, _Component);

  function NodeResolver() {
    _classCallCheck(this, NodeResolver);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeResolver).apply(this, arguments));
  }

  _createClass(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "originalStyles", {});

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  _createClass(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      touchScrollTarget: null
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  _createClass(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        onClick: this.blurSelectInput,
        className:
        /*#__PURE__*/

        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
          position: 'fixed',
          left: 0,
          bottom: 0,
          right: 0,
          top: 0
        })
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  _inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isBottom", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isTop", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollTarget", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "touchStart", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  _createClass(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no scroll available
      if (!el) return;
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return; // all the if statements are to appease Flow 😢

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  _inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    _classCallCheck(this, ScrollCaptorSwitch);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollCaptorSwitch).apply(this, arguments));
  }

  _createClass(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = _objectWithoutProperties(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('container', props)), {
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ValueContainer, _Component);

  function ValueContainer() {
    _classCallCheck(this, ValueContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValueContainer).apply(this, arguments));
  }

  _createClass(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
      'indicators': true
    }, className)
  }, children);
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg, _extends({
    size: 20
  }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
      'indicator': true,
      'dropdown-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
      'indicator': true,
      'clear-indicator': true
    }, className)
  }), children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), {
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';
var keyframesInjected = false;
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: "".concat(delay, "ms"),
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;
  var color = isFocused ? colors.neutral80 : colors.neutral20;

  if (!keyframesInjected) {
    // eslint-disable-next-line no-unused-expressions
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["b" /* injectGlobal */])("@keyframes ", keyframesName, "{0%,80%,100%{opacity:0;}40%{opacity:1;}};");
    keyframesInjected = true;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, innerProps, {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
      'indicator': true,
      'loading-indicator': true
    }, className)
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 0,
    offset: isRtl
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 160,
    offset: true
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingDot, {
    color: color,
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('control', props)), {
      'control': true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('group', props)), {
      'group': true
    }, className)
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading, _extends({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = _objectWithoutProperties(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('groupHeading', _objectSpread({
      theme: theme
    }, cleanProps))), {
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = _objectWithoutProperties(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('input', _objectSpread({
      theme: theme
    }, props)))
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_autosize___default.a, _extends({
    className: cx(null, {
      'input': true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    _classCallCheck(this, MultiValueRemove);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValueRemove).apply(this, arguments));
  }

  _createClass(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", innerProps, children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  _inherits(MultiValue, _Component2);

  function MultiValue() {
    _classCallCheck(this, MultiValue);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiValue).apply(this, arguments));
  }

  _createClass(MultiValue, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;

      var containerInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _objectSpread({
        className: cx(
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container, {
        data: data,
        innerProps: containerInnerProps,
        selectProps: selectProps
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, {
        data: data,
        innerProps: labelInnerProps,
        selectProps: selectProps
      }, children), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove, {
        data: data,
        innerProps: removeInnerProps,
        selectProps: selectProps
      }));
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    ref: innerRef,
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('option', props)), {
      'option': true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className)
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('placeholder', props)), {
      'placeholder': true
    }, className)
  }, innerProps), children);
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: cx(
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["a" /* css */])(getStyles('singleValue', props)), {
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _objectSpread({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _objectSpread({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
var baseUnit = 4;
/* Used to calculate consistent margin/padding on elements */

var controlHeight = 38;
/* The minimum height of the control */

var menuGutter = baseUnit * 2;
/* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blockOptionHover", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "isComposing", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearFocusValueOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "commonProps", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "components", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasGroups", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchX", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "initialTouchY", 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputIsHiddenAfterUpdate", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "instancePrefix", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "openAfterFocus", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollToFocusedOptionOnUpdate", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "userIsDragging", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "controlRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusedOptionRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "menuListRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "cacheComponents", function (components$$1) {
      _this.components = defaultComponents({
        components: components$$1
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focus", _this.focusInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blur", _this.blurInput);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _objectSpread({}, actionMeta, {
        name: name
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(_toConsumableArray(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      _this.onChange(selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      }), {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(selectValue.slice(0, selectValue.length - 1), {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _objectSpread({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;
      setTimeout(function () {
        return _this.focusInput();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(value);

    var _menuOptions = _this.buildMenuOptions(_props, _selectValue);

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = this.buildMenuOptions(nextProps, selectValue);
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = classNames.bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder, _extends({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MultiValue, _extends({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SingleValue, _extends({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu$$1 = _this$components3.Menu,
          MenuList$$1 = _this$components3.MenuList,
          MenuPortal$$1 = _this$components3.MenuPortal,
          LoadingMessage$$1 = _this$components3.LoadingMessage,
          NoOptionsMessage$$1 = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Option, _extends({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutProperties(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, _extends({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadingMessage$$1, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NoOptionsMessage$$1, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPlacer, _extends({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu$$1, _extends({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuList$$1, _extends({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuPortal$$1, _extends({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A11yText, {
        "aria-live": "assertive"
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectContainer, _extends({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Control, _extends({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorsContainer, _extends({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "defaultProps", defaultProps);

var defaultProps$1 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    _createClass(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = _objectWithoutProperties(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$1), _temp;
};

var defaultProps$2 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Async, _Component);

    function Async(props) {
      var _this;

      _classCallCheck(this, Async);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Async).call(this));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "lastRequest", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mounted", false);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "optionsCache", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleInputChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      });

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    _createClass(Async, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;
        var inputValue = this.state.inputValue;

        if (defaultOptions === true) {
          this.loadOptions(inputValue, function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;

            _this2.setState({
              defaultOptions: options || [],
              isLoading: isLoading
            });
          });
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }

        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "loadOptions",
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;
        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);

        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            loadOptions = _this$props2.loadOptions,
            props = _objectWithoutProperties(_this$props2, ["loadOptions"]);

        var _this$state = this.state,
            defaultOptions = _this$state.defaultOptions,
            inputValue = _this$state.inputValue,
            isLoading = _this$state.isLoading,
            loadedInputValue = _this$state.loadedInputValue,
            loadedOptions = _this$state.loadedOptions,
            passEmptyOptions = _this$state.passEmptyOptions;
        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this3.select = _ref;
          },
          options: options,
          isLoading: isLoading,
          onInputChange: this.handleInputChange
        }));
      }
    }]);

    return Async;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$2), _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps$3 = _objectSpread({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Creatable, _Component);

    function Creatable(props) {
      var _this;

      _classCallCheck(this, Creatable);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Creatable).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "select", void 0);

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option'
            };

            if (isMulti) {
              onChange([].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      });

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    _createClass(Creatable, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(_toConsumableArray(options)) : [].concat(_toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var props = _extends({}, this.props);

        var options = this.state.options;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);

    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _defineProperty(_class, "defaultProps", defaultProps$3), _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

var SelectCreatable$1 = makeCreatableSelect(Select);
var SelectCreatableState = manageState(SelectCreatable$1);
var AsyncCreatable = makeAsyncSelect(SelectCreatableState);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        props = _objectWithoutProperties(_ref, ["in", "onExited", "appear", "enter", "exit"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, props);
  };
};

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, ["component", "duration", "in", "onExited"]);

  var transition = {
    entering: {
      opacity: 0
    },
    entered: {
      opacity: 1,
      transition: "opacity ".concat(duration, "ms")
    },
    exiting: {
      opacity: 0
    },
    exited: {
      opacity: 0
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
    mountOnEnter: true,
    unmountOnExit: true,
    in: inProp,
    timeout: duration
  }, function (state) {
    var innerProps = {
      style: _objectSpread({}, transition[state])
    };
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag, _extends({
      innerProps: innerProps
    }, props));
  });
}; // ==============================
// Collapse Transition
// ==============================

var collapseDuration = 260;
// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse =
/*#__PURE__*/
function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "duration", collapseDuration);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rafID", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      width: 'auto'
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "transition", {
      exiting: {
        width: 0,
        transition: "width ".concat(_this.duration, "ms ease-out")
      },
      exited: {
        width: 0
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getWidth", function (ref) {
      if (ref && isNaN(_this.state.width)) {
        /*
          Here we're invoking requestAnimationFrame with a callback invoking our
          call to getBoundingClientRect and setState in order to resolve an edge case
          around portalling. Certain portalling solutions briefly remove children from the DOM
          before appending them to the target node. This is to avoid us trying to call getBoundingClientrect
          while the Select component is in this state.
        */
        // cannot use `offsetWidth` because it is rounded
        _this.rafID = window.requestAnimationFrame(function () {
          var _ref$getBoundingClien = ref.getBoundingClientRect(),
              width = _ref$getBoundingClien.width;

          _this.setState({
            width: width
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStyle", function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTransition", function (state) {
      return _this.transition[state];
    });

    return _this;
  }

  _createClass(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.rafID) {
        window.cancelAnimationFrame(this.rafID);
      }
    } // width must be calculated; cannot transition from `undefined` to `number`

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          inProp = _this$props.in;
      var width = this.state.width;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"], {
        enter: false,
        mountOnEnter: true,
        unmountOnExit: true,
        in: inProp,
        timeout: this.duration
      }, function (state) {
        var style = _objectSpread({}, _this2.getStyle(width), _this2.getTransition(state));

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          ref: _this2.getWidth,
          style: style
        }, children);
      });
    }
  }]);

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = _objectWithoutProperties(_ref, ["in", "onExited"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Collapse, {
      in: inProp,
      onExited: onExited
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({
      cropWithEllipsis: inProp
    }, props)));
  };
};

var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent
    }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({
      component: WrappedComponent
    }, props));
  };
};

var makeAnimated = function makeAnimated() {
  var externalComponents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components$$1 = defaultComponents({
    components: externalComponents
  });

  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = _objectWithoutProperties(components$$1, ["Input", "MultiValue", "Placeholder", "SingleValue", "ValueContainer"]);

  return _objectSpread({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();
var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;
var index = Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["a"] = (index$1);



/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(481)();
}


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(154)('wks');
var uid = __webpack_require__(118);
var Symbol = __webpack_require__(12).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilesTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export reset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({filesUploadRequest:['data'],filesUploadSuccess:['data'],filesUploadFailure:['err'],filesUploadReset:null}),Types=_createActions.Types,Creators=_createActions.Creators;var FilesTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,err:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null,data:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var reset=function reset(state){return state.merge({fetching:false,data:null,err:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.FILES_UPLOAD_SUCCESS,success),_defineProperty(_createReducer,Types.FILES_UPLOAD_REQUEST,request),_defineProperty(_createReducer,Types.FILES_UPLOAD_FAILURE,failure),_defineProperty(_createReducer,Types.FILES_UPLOAD_RESET,reset),_createReducer));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(15)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(70);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var IE8_DOM_DEFINE = __webpack_require__(410);
var toPrimitive = __webpack_require__(78);
var dP = Object.defineProperty;

exports.f = __webpack_require__(23) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export init */
/* unused harmony export logout */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* unused harmony export isLoggedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({authCheckRequest:['data'],authCheckSuccess:null,authCheckFailure:['err'],authRequest:['data'],authSuccess:['user'],authFailure:['err'],authLogout:null,authInit:null}),Types=_createActions.Types,Creators=_createActions.Creators;var AuthTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,user:null,err:null,profileChanged:false,passwordChanged:false});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var user=_ref.user;return state.merge({fetching:false,err:null,user:user});};// we've had a problem logging in
// Possible errors:
// * user pass doesnt match
// * user not registered ?
// * user account not activated ?
// err is string
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};// Set state initial value when user open sign in modal
var init=function init(state){return state.merge({fetching:false,err:null,passwordChanged:false});};var logout=function logout(state){return state.merge({user:null,fetching:false,err:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.AUTH_CHECK_SUCCESS,success),_defineProperty(_createReducer,Types.AUTH_CHECK_REQUEST,request),_defineProperty(_createReducer,Types.AUTH_CHECK_FAILURE,failure),_defineProperty(_createReducer,Types.AUTH_SUCCESS,success),_defineProperty(_createReducer,Types.AUTH_REQUEST,request),_defineProperty(_createReducer,Types.AUTH_FAILURE,failure),_defineProperty(_createReducer,Types.AUTH_LOGOUT,logout),_defineProperty(_createReducer,Types.AUTH_INIT,init),_createReducer));var isLoggedIn=function isLoggedIn(state){return state.user!==null;};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileUploader=function(_React$Component){_inherits(FileUploader,_React$Component);function FileUploader(props){_classCallCheck(this,FileUploader);var _this=_possibleConstructorReturn(this,(FileUploader.__proto__||Object.getPrototypeOf(FileUploader)).call(this,props));_this.componentWillReceiveProps=function(newProps){if(newProps.files.data&&!_this.state.passed&&_this.state.active){_this._passResult(newProps.files.data.upload[0].filename);_this.setState({passed:true,url:newProps.files.data.upload[0].url,uploading:false,active:false});}if(newProps.files.err&&!_this.state.passed){_this.setState({passed:true,err:newProps.files.err,file:null});}};_this._passResult=function(filename){_this.props.onUploaded(filename);};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});_this._upload(event);};_this._upload=function(event){_this.setState({passed:false,uploading:true,active:true});var data=new FormData();var files=event.target.files[0]||_this.state.file.files[0];data.append('files',files);var setting=_this.props.setting;Object.keys(setting).map(function(key){return data.append(key,setting[key]);});_this.props.upload(data);_this.setState({uploaded:true});};_this.state={file:null,// selected file before upload
uploaded:false,// to state that the file is uploaded
passed:false,// to make sure it pass the data once, cause UNSAFE_componentWillReceiveProps would trigger several times
url:'',// grab url from successfully uploaded file
uploading:false,// side effect: 'uploading ...' text
err:null,// side effect: to contain error
active:false// active flag for the component (uploadable = TRUE)
};return _this;}_createClass(FileUploader,[{key:'render',value:function render(){var _this2=this;var date=Date.now();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'files',required:this.props.required,className:'custom-file-input',onChange:function onChange(event){return _this2._fileSelect(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'custom-file-label'},this.state.file?'File selected':'Choose files'))),this.state.uploading&&'Uploading ...',this.state.uploaded&&!this.state.uploading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.url&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.state.url,className:'img img-responsive',src:this.state.url+'?v='+date,style:{maxWidth:'100%'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Files Uploaded'),this.state.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.state.err));}}]);return FileUploader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FileUploader));

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successDetail */
/* unused harmony export successItem */
/* unused harmony export successAffiliates */
/* unused harmony export successSpreadsheet */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({couponRequest:['data'],couponSuccess:['data'],couponFailure:['err'],couponDetailRequest:['data'],couponDetailSuccess:['data'],couponDetailFailure:['err'],couponTagRequest:['data'],couponTagSuccess:['data'],couponTagFailure:['err'],couponCreateRequest:['data'],couponCreateSuccess:['data'],couponCreateFailure:['err'],couponGenerateRequest:['data'],couponGenerateSuccess:['data'],couponGenerateFailure:['err'],couponUpdateRequest:['data'],couponUpdateSuccess:['data'],couponUpdateFailure:['err'],businessUpdateRequest:['data'],businessUpdateSuccess:['data'],businessUpdateFailure:['err'],couponDeleteRequest:['id'],couponDeleteSuccess:['data'],couponDeleteFailure:['err'],businessDeleteRequest:['id'],businessDeleteSuccess:['data'],businessDeleteFailure:['err'],couponSpreadsheetRequest:['data'],couponSpreadsheetSuccess:['data'],couponSpreadsheetFailure:['err'],historySpreadsheetRequest:['data'],historySpreadsheetSuccess:['data'],historySpreadsheetFailure:['err'],getCouponItemRequest:['data'],getCouponItemSuccess:['data'],getCouponItemFailure:['err'],postCouponItemRequest:['data'],postCouponItemSuccess:['data'],postCouponItemFailure:['err'],postCouponItemTagRequest:['data'],postCouponItemTagSuccess:['data'],postCouponItemTagFailure:['err'],deleteCouponItemRequest:['data'],deleteCouponItemSuccess:['data'],deleteCouponItemFailure:['err'],deleteCouponItemTagRequest:['data'],deleteCouponItemTagSuccess:['data'],deleteCouponItemTagFailure:['err'],getAffiliatesRequest:['data'],getAffiliatesSuccess:['data'],getAffiliatesFailure:['data'],affiliateTransferRequest:['data'],affiliateTransferSuccess:['data'],affiliateTransferFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var CouponTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,spreadsheet:null,detail:{},couponitem:[],affiliates:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null,success:null,spreadsheet:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successDetail=function successDetail(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,detail:data,err:null});};var successItem=function successItem(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,couponitem:data,err:null});};var successAffiliates=function successAffiliates(state,_ref4){var data=_ref4.data;return state.merge({fetching:false,affiliates:data,err:null});};var successSpreadsheet=function successSpreadsheet(state,_ref5){var data=_ref5.data;return state.merge({fetching:false,spreadsheet:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref6){var err=_ref6.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref7){var data=_ref7.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref8){var err=_ref8.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.COUPON_SUCCESS,success),_defineProperty(_createReducer,Types.COUPON_REQUEST,request),_defineProperty(_createReducer,Types.COUPON_FAILURE,failure),_defineProperty(_createReducer,Types.COUPON_DETAIL_SUCCESS,successDetail),_defineProperty(_createReducer,Types.COUPON_DETAIL_REQUEST,request),_defineProperty(_createReducer,Types.COUPON_DETAIL_FAILURE,failure),_defineProperty(_createReducer,Types.COUPON_TAG_SUCCESS,success),_defineProperty(_createReducer,Types.COUPON_TAG_REQUEST,request),_defineProperty(_createReducer,Types.COUPON_TAG_FAILURE,failure),_defineProperty(_createReducer,Types.COUPON_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.COUPON_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.COUPON_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.COUPON_GENERATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.COUPON_GENERATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.COUPON_GENERATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.COUPON_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.COUPON_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.COUPON_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.BUSINESS_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.BUSINESS_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.BUSINESS_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.COUPON_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.COUPON_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.COUPON_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.BUSINESS_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.BUSINESS_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.BUSINESS_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.COUPON_SPREADSHEET_SUCCESS,successSpreadsheet),_defineProperty(_createReducer,Types.COUPON_SPREADSHEET_REQUEST,request),_defineProperty(_createReducer,Types.COUPON_SPREADSHEET_FAILURE,failure),_defineProperty(_createReducer,Types.HISTORY_SPREADSHEET_SUCCESS,successSpreadsheet),_defineProperty(_createReducer,Types.HISTORY_SPREADSHEET_REQUEST,request),_defineProperty(_createReducer,Types.HISTORY_SPREADSHEET_FAILURE,failure),_defineProperty(_createReducer,Types.GET_COUPON_ITEM_SUCCESS,successItem),_defineProperty(_createReducer,Types.GET_COUPON_ITEM_REQUEST,request),_defineProperty(_createReducer,Types.GET_COUPON_ITEM_FAILURE,failure),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_TAG_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_TAG_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_COUPON_ITEM_TAG_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_TAG_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_TAG_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_COUPON_ITEM_TAG_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_AFFILIATES_SUCCESS,successAffiliates),_defineProperty(_createReducer,Types.GET_AFFILIATES_REQUEST,request),_defineProperty(_createReducer,Types.GET_AFFILIATES_FAILURE,failure),_defineProperty(_createReducer,Types.AFFILIATE_TRANSFER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.AFFILIATE_TRANSFER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.AFFILIATE_TRANSFER_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttractionTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export searchSuccess */
/* unused harmony export detailSuccess */
/* unused harmony export failure */
/* unused harmony export changeRequest */
/* unused harmony export changeSuccess */
/* unused harmony export clearSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({attractionRequest:['data'],attractionSuccess:['data'],attractionFailure:['err'],placeRequest:['data'],placeSuccess:['data'],placeFailure:['err'],getPlacesV2Request:['data'],getPlacesV2Success:['data'],getPlacesV2Failure:['err'],attractionDetailRequest:['data'],attractionDetailSuccess:['data'],attractionDetailFailure:['err'],placeDetailRequest:['data'],placeDetailSuccess:['data'],placeDetailFailure:['err'],attractionUpdateRequest:['data'],attractionUpdateSuccess:['data'],attractionUpdateFailure:['err'],attractionClearCacheRequest:null,attractionClearCacheSuccess:null,attractionClearCacheFailure:['err'],attractionSearchRequest:['data'],attractionSearchSuccess:['data'],attractionSearchFailure:['err'],placeSearchRequest:['data'],placeSearchSuccess:['data'],placeSearchFailure:['err'],downloadAttractionDataRequest:['filter'],downloadAttractionDataSuccess:null,downloadAttractionDataFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var AttractionTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,processing:false,data:[],dataSearch:[],err:null,success:false,detail:{}});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,success:false});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,processing:false,data:data,err:null});};var searchSuccess=function searchSuccess(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,processing:false,dataSearch:data,err:null});};var detailSuccess=function detailSuccess(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,processing:false,detail:data,err:null});};var failure=function failure(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err});};var changeRequest=function changeRequest(state){return state.merge({processing:true,err:null,success:false});};var changeSuccess=function changeSuccess(state,_ref5){var data=_ref5.data;return state.merge({fetching:false,processing:false,err:null,success:true});};var clearSuccess=function clearSuccess(state){return state.merge({fetching:false,err:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.ATTRACTION_REQUEST,request),_defineProperty(_createReducer,Types.ATTRACTION_SUCCESS,success),_defineProperty(_createReducer,Types.ATTRACTION_FAILURE,failure),_defineProperty(_createReducer,Types.GET_PLACES_V2_REQUEST,request),_defineProperty(_createReducer,Types.GET_PLACES_V2_SUCCESS,success),_defineProperty(_createReducer,Types.GET_PLACES_V2_FAILURE,failure),_defineProperty(_createReducer,Types.PLACE_REQUEST,request),_defineProperty(_createReducer,Types.PLACE_SUCCESS,success),_defineProperty(_createReducer,Types.PLACE_FAILURE,failure),_defineProperty(_createReducer,Types.ATTRACTION_DETAIL_REQUEST,request),_defineProperty(_createReducer,Types.ATTRACTION_DETAIL_SUCCESS,detailSuccess),_defineProperty(_createReducer,Types.ATTRACTION_DETAIL_FAILURE,failure),_defineProperty(_createReducer,Types.PLACE_DETAIL_REQUEST,request),_defineProperty(_createReducer,Types.PLACE_DETAIL_SUCCESS,detailSuccess),_defineProperty(_createReducer,Types.PLACE_DETAIL_FAILURE,failure),_defineProperty(_createReducer,Types.ATTRACTION_UPDATE_REQUEST,changeRequest),_defineProperty(_createReducer,Types.ATTRACTION_UPDATE_SUCCESS,changeSuccess),_defineProperty(_createReducer,Types.ATTRACTION_UPDATE_FAILURE,failure),_defineProperty(_createReducer,Types.ATTRACTION_CLEAR_CACHE_REQUEST,request),_defineProperty(_createReducer,Types.ATTRACTION_CLEAR_CACHE_SUCCESS,clearSuccess),_defineProperty(_createReducer,Types.ATTRACTION_CLEAR_CACHE_FAILURE,failure),_defineProperty(_createReducer,Types.ATTRACTION_SEARCH_REQUEST,request),_defineProperty(_createReducer,Types.ATTRACTION_SEARCH_SUCCESS,searchSuccess),_defineProperty(_createReducer,Types.ATTRACTION_SEARCH_FAILURE,failure),_defineProperty(_createReducer,Types.PLACE_SEARCH_REQUEST,request),_defineProperty(_createReducer,Types.PLACE_SEARCH_SUCCESS,searchSuccess),_defineProperty(_createReducer,Types.PLACE_SEARCH_FAILURE,failure),_defineProperty(_createReducer,Types.DOWNLOAD_ATTRACTION_DATA_REQUEST,request),_defineProperty(_createReducer,Types.DOWNLOAD_ATTRACTION_DATA_SUCCESS,success),_defineProperty(_createReducer,Types.DOWNLOAD_ATTRACTION_DATA_FAILURE,failure),_createReducer));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* unused harmony reexport takeEvery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport throttle */


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(93);
var _isTransformer = __webpack_require__(233);


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer [xf] to return a new transformer (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} xf transducer to initialize if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */
module.exports = function _dispatchable(methodNames, xf, fn) {
  return function() {
    if (arguments.length === 0) {
      return fn();
    }
    var args = Array.prototype.slice.call(arguments, 0);
    var obj = args.pop();
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, args);
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = xf.apply(null, args);
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(79);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {
  init: function() {
    return this.xf['@@transducer/init']();
  },
  result: function(result) {
    return this.xf['@@transducer/result'](result);
  }
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrderTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successDetailList */
/* unused harmony export successSingle */
/* unused harmony export successReport */
/* unused harmony export successChatbot */
/* unused harmony export failureSingle */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({orderRequest:['filter'],orderSuccess:['data'],orderFailure:['err'],orderCheckoutRequest:['data'],orderCheckoutSuccess:null,orderCheckoutFailure:['err'],orderConfirmRequest:['data'],orderConfirmSuccess:null,orderConfirmFailure:['err'],orderSingleRequest:['id'],orderSingleSuccess:['data'],orderSingleFailure:['err'],orderDetailListRequest:['filter'],orderDetailListSuccess:['data'],orderDetailListFailure:['err'],orderUpdateRequest:['data'],orderUpdateSuccess:null,orderUpdateFailure:['err'],orderUpdateAmountRequest:['data'],orderUpdateAmountSuccess:null,orderUpdateAmountFailure:['err'],orderListDownloadRequest:['filter'],orderListDownloadSuccess:null,orderListDownloadFailure:['err'],orderDetailListDownloadRequest:['filter'],orderDetailListDownloadSuccess:null,orderDetailListDownloadFailure:['err'],orderInvoiceRequest:['data'],orderInvoiceSuccess:['data'],orderInvoiceFailure:['err'],resendOrderVoucherRequest:['data'],resendOrderVoucherSuccess:['data'],resendOrderVoucherFailure:['err'],getOrderReportRequest:['filter'],getOrderReportSuccess:['data'],getOrderReportFailure:['err'],getOrderReportSpreadsheetRequest:['filter'],getOrderReportSpreadsheetSuccess:[null],getOrderReportSpreadsheetFailure:['err'],getChatbotOrderRequest:['filter'],getChatbotOrderSuccess:['data'],getChatbotOrderFailure:['err'],postChatbotOrderRequest:['data'],postChatbotOrderSuccess:[null],postChatbotOrderFailure:['err'],refundDanaRequest:['data'],refundDanaSuccess:['data'],refundDanaFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var OrderTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,data_detail:{data:[]},DATA_REPORT:{data:[]},DATA_CHATBOT:{data:[]},data_single:{},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successDetailList=function successDetailList(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_detail:data,err:null});};var successSingle=function successSingle(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,data_single:data,err:null});};var successReport=function successReport(state,_ref4){var data=_ref4.data;return state.merge({fetching:false,DATA_REPORT:data,err:null});};var successChatbot=function successChatbot(state,_ref5){var data=_ref5.data;return state.merge({fetching:false,DATA_CHATBOT:data,err:null});};var failureSingle=function failureSingle(state,_ref6){var err=_ref6.err;return state.merge({fetching:false,err:err,data_single:{}});};// we've had a problem logging in
var failure=function failure(state,_ref7){var err=_ref7.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref8){var data=_ref8.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref9){var err=_ref9.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.ORDER_SUCCESS,success),_defineProperty(_createReducer,Types.ORDER_REQUEST,request),_defineProperty(_createReducer,Types.ORDER_FAILURE,failure),_defineProperty(_createReducer,Types.ORDER_CHECKOUT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_CHECKOUT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_CHECKOUT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ORDER_CONFIRM_SUCCESS,success),_defineProperty(_createReducer,Types.ORDER_CONFIRM_REQUEST,request),_defineProperty(_createReducer,Types.ORDER_CONFIRM_FAILURE,failure),_defineProperty(_createReducer,Types.ORDER_SINGLE_SUCCESS,successSingle),_defineProperty(_createReducer,Types.ORDER_SINGLE_REQUEST,request),_defineProperty(_createReducer,Types.ORDER_SINGLE_FAILURE,failureSingle),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_SUCCESS,successDetailList),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_REQUEST,request),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_FAILURE,failure),_defineProperty(_createReducer,Types.ORDER_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ORDER_UPDATE_AMOUNT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_UPDATE_AMOUNT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_UPDATE_AMOUNT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ORDER_LIST_DOWNLOAD_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_LIST_DOWNLOAD_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_LIST_DOWNLOAD_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_DOWNLOAD_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_DOWNLOAD_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_DETAIL_LIST_DOWNLOAD_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ORDER_INVOICE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ORDER_INVOICE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ORDER_INVOICE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.RESEND_ORDER_VOUCHER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.RESEND_ORDER_VOUCHER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.RESEND_ORDER_VOUCHER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_SUCCESS,successReport),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_REQUEST,request),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_FAILURE,failure),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_SPREADSHEET_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_SPREADSHEET_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.GET_ORDER_REPORT_SPREADSHEET_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_CHATBOT_ORDER_SUCCESS,successChatbot),_defineProperty(_createReducer,Types.GET_CHATBOT_ORDER_REQUEST,request),_defineProperty(_createReducer,Types.GET_CHATBOT_ORDER_FAILURE,failure),_defineProperty(_createReducer,Types.POST_CHATBOT_ORDER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_CHATBOT_ORDER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_CHATBOT_ORDER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.REFUND_DANA_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.REFUND_DANA_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.REFUND_DANA_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isDecimal__ = __webpack_require__(909);
var FormatMoney=function FormatMoney(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var thousand=arguments.length>1&&arguments[1]!==undefined?arguments[1]:',';var decimal=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'.';var precision=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;var formatted=__WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatMoney(value,{format:'%v',thousand:thousand,decimal:decimal,precision:Object(__WEBPACK_IMPORTED_MODULE_1__isDecimal__["a" /* default */])(value)?precision:0});return formatted;};/* harmony default export */ __webpack_exports__["a"] = (FormatMoney);

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(407),
	PropTypes = __webpack_require__(20),
	createClass = __webpack_require__(137),
	moment = __webpack_require__(18),
	React = __webpack_require__(0),
	CalendarContainer = __webpack_require__(865),
	onClickOutside = __webpack_require__(870).default
	;

var viewModes = Object.freeze({
	YEARS: 'years',
	MONTHS: 'months',
	DAYS: 'days',
	TIME: 'time',
});

var TYPES = PropTypes;
var Datetime = createClass({
	displayName: 'DateTime',
	propTypes: {
		// value: TYPES.object | TYPES.string,
		// defaultValue: TYPES.object | TYPES.string,
		// viewDate: TYPES.object | TYPES.string,
		onFocus: TYPES.func,
		onBlur: TYPES.func,
		onChange: TYPES.func,
		onViewModeChange: TYPES.func,
		onNavigateBack: TYPES.func,
		onNavigateForward: TYPES.func,
		locale: TYPES.string,
		utc: TYPES.bool,
		displayTimeZone: TYPES.string,
		input: TYPES.bool,
		// dateFormat: TYPES.string | TYPES.bool,
		// timeFormat: TYPES.string | TYPES.bool,
		inputProps: TYPES.object,
		timeConstraints: TYPES.object,
		viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
		isValidDate: TYPES.func,
		open: TYPES.bool,
		strictParsing: TYPES.bool,
		closeOnSelect: TYPES.bool,
		closeOnTab: TYPES.bool
	},

	getInitialState: function() {
		this.checkTZ( this.props );
		
		var state = this.getStateFromProps( this.props );

		if ( state.open === undefined )
			state.open = !this.props.input;

		state.currentView = this.props.dateFormat ?
			(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;

		return state;
	},

	parseDate: function (date, formats) {
		var parsedDate;

		if (date && typeof date === 'string')
			parsedDate = this.localMoment(date, formats.datetime);
		else if (date)
			parsedDate = this.localMoment(date);

		if (parsedDate && !parsedDate.isValid())
			parsedDate = null;

		return parsedDate;
	},

	getStateFromProps: function( props ) {
		var formats = this.getFormats( props ),
			date = props.value || props.defaultValue,
			selectedDate, viewDate, updateOn, inputValue
			;

		selectedDate = this.parseDate(date, formats);

		viewDate = this.parseDate(props.viewDate, formats);

		viewDate = selectedDate ?
			selectedDate.clone().startOf('month') :
			viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');

		updateOn = this.getUpdateOn(formats);

		if ( selectedDate )
			inputValue = selectedDate.format(formats.datetime);
		else if ( date.isValid && !date.isValid() )
			inputValue = '';
		else
			inputValue = date || '';

		return {
			updateOn: updateOn,
			inputFormat: formats.datetime,
			viewDate: viewDate,
			selectedDate: selectedDate,
			inputValue: inputValue,
			open: props.open
		};
	},

	getUpdateOn: function( formats ) {
		if ( formats.date.match(/[lLD]/) ) {
			return viewModes.DAYS;
		} else if ( formats.date.indexOf('M') !== -1 ) {
			return viewModes.MONTHS;
		} else if ( formats.date.indexOf('Y') !== -1 ) {
			return viewModes.YEARS;
		}

		return viewModes.DAYS;
	},

	getFormats: function( props ) {
		var formats = {
				date: props.dateFormat || '',
				time: props.timeFormat || ''
			},
			locale = this.localMoment( props.date, null, props ).localeData()
			;

		if ( formats.date === true ) {
			formats.date = locale.longDateFormat('L');
		}
		else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
			formats.time = '';
		}

		if ( formats.time === true ) {
			formats.time = locale.longDateFormat('LT');
		}

		formats.datetime = formats.date && formats.time ?
			formats.date + ' ' + formats.time :
			formats.date || formats.time
		;

		return formats;
	},

	componentWillReceiveProps: function( nextProps ) {
		var formats = this.getFormats( nextProps ),
			updatedState = {}
		;

		if ( nextProps.value !== this.props.value ||
			formats.datetime !== this.getFormats( this.props ).datetime ) {
			updatedState = this.getStateFromProps( nextProps );
		}

		if ( updatedState.open === undefined ) {
			if ( typeof nextProps.open !== 'undefined' ) {
				updatedState.open = nextProps.open;
			} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
				updatedState.open = false;
			} else {
				updatedState.open = this.state.open;
			}
		}

		if ( nextProps.viewMode !== this.props.viewMode ) {
			updatedState.currentView = nextProps.viewMode;
		}

		if ( nextProps.locale !== this.props.locale ) {
			if ( this.state.viewDate ) {
				var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
				updatedState.viewDate = updatedViewDate;
			}
			if ( this.state.selectedDate ) {
				var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
				updatedState.selectedDate = updatedSelectedDate;
				updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
			}
		}

		if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
			if ( nextProps.utc ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().utc();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().utc();
					updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
				}
			} else if ( nextProps.displayTimeZone ) {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
					updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
				}
			} else {
				if ( this.state.viewDate )
					updatedState.viewDate = this.state.viewDate.clone().local();
				if ( this.state.selectedDate ) {
					updatedState.selectedDate = this.state.selectedDate.clone().local();
					updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
				}
			}
		}

		if ( nextProps.viewDate !== this.props.viewDate ) {
			updatedState.viewDate = moment(nextProps.viewDate);
		}

		this.checkTZ( nextProps );

		this.setState( updatedState );
	},

	onInputChange: function( e ) {
		var value = e.target === null ? e : e.target.value,
			localMoment = this.localMoment( value, this.state.inputFormat ),
			update = { inputValue: value }
			;

		if ( localMoment.isValid() && !this.props.value ) {
			update.selectedDate = localMoment;
			update.viewDate = localMoment.clone().startOf('month');
		} else {
			update.selectedDate = null;
		}

		return this.setState( update, function() {
			return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
		});
	},

	onInputKey: function( e ) {
		if ( e.which === 9 && this.props.closeOnTab ) {
			this.closeCalendar();
		}
	},

	showView: function( view ) {
		var me = this;
		return function() {
			me.state.currentView !== view && me.props.onViewModeChange( view );
			me.setState({ currentView: view });
		};
	},

	setDate: function( type ) {
		var me = this,
			nextViews = {
				month: viewModes.DAYS,
				year: viewModes.MONTHS,
			}
		;
		return function( e ) {
			me.setState({
				viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
				currentView: nextViews[ type ]
			});
			me.props.onViewModeChange( nextViews[ type ] );
		};
	},

	subtractTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateBack( amount, type );
			me.updateTime( 'subtract', amount, type, toSelected );
		};
	},

	addTime: function( amount, type, toSelected ) {
		var me = this;
		return function() {
			me.props.onNavigateForward( amount, type );
			me.updateTime( 'add', amount, type, toSelected );
		};
	},

	updateTime: function( op, amount, type, toSelected ) {
		var update = {},
			date = toSelected ? 'selectedDate' : 'viewDate';

		update[ date ] = this.state[ date ].clone()[ op ]( amount, type );

		this.setState( update );
	},

	allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
	setTime: function( type, value ) {
		var index = this.allowedSetTime.indexOf( type ) + 1,
			state = this.state,
			date = (state.selectedDate || state.viewDate).clone(),
			nextType
			;

		// It is needed to set all the time properties
		// to not to reset the time
		date[ type ]( value );
		for (; index < this.allowedSetTime.length; index++) {
			nextType = this.allowedSetTime[index];
			date[ nextType ]( date[nextType]() );
		}

		if ( !this.props.value ) {
			this.setState({
				selectedDate: date,
				inputValue: date.format( state.inputFormat )
			});
		}
		this.props.onChange( date );
	},

	updateSelectedDate: function( e, close ) {
		var target = e.currentTarget,
			modifier = 0,
			viewDate = this.state.viewDate,
			currentDate = this.state.selectedDate || viewDate,
			date
			;

		if (target.className.indexOf('rdtDay') !== -1) {
			if (target.className.indexOf('rdtNew') !== -1)
				modifier = 1;
			else if (target.className.indexOf('rdtOld') !== -1)
				modifier = -1;

			date = viewDate.clone()
				.month( viewDate.month() + modifier )
				.date( parseInt( target.getAttribute('data-value'), 10 ) );
		} else if (target.className.indexOf('rdtMonth') !== -1) {
			date = viewDate.clone()
				.month( parseInt( target.getAttribute('data-value'), 10 ) )
				.date( currentDate.date() );
		} else if (target.className.indexOf('rdtYear') !== -1) {
			date = viewDate.clone()
				.month( currentDate.month() )
				.date( currentDate.date() )
				.year( parseInt( target.getAttribute('data-value'), 10 ) );
		}

		date.hours( currentDate.hours() )
			.minutes( currentDate.minutes() )
			.seconds( currentDate.seconds() )
			.milliseconds( currentDate.milliseconds() );

		if ( !this.props.value ) {
			var open = !( this.props.closeOnSelect && close );
			if ( !open ) {
				this.props.onBlur( date );
			}

			this.setState({
				selectedDate: date,
				viewDate: date.clone().startOf('month'),
				inputValue: date.format( this.state.inputFormat ),
				open: open
			});
		} else {
			if ( this.props.closeOnSelect && close ) {
				this.closeCalendar();
			}
		}

		this.props.onChange( date );
	},

	openCalendar: function( e ) {
		if ( !this.state.open ) {
			this.setState({ open: true }, function() {
				this.props.onFocus( e );
			});
		}
	},

	closeCalendar: function() {
		this.setState({ open: false }, function () {
			this.props.onBlur( this.state.selectedDate || this.state.inputValue );
		});
	},

	handleClickOutside: function() {
		if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
			this.setState({ open: false }, function() {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		}
	},

	localMoment: function( date, format, props ) {
		props = props || this.props;
		var m = null;

		if (props.utc) {
			m = moment.utc(date, format, props.strictParsing);
		} else if (props.displayTimeZone) {
			m = moment.tz(date, format, props.displayTimeZone);
		} else {
			m = moment(date, format, props.strictParsing);
		}

		if ( props.locale )
			m.locale( props.locale );
		return m;
	},

	checkTZ: function( props ) {
		var con = console;

		if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
			this.tzWarning = true;
			con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
		}
	},

	componentProps: {
		fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
		fromState: ['viewDate', 'selectedDate', 'updateOn'],
		fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
	},

	getComponentProps: function() {
		var me = this,
			formats = this.getFormats( this.props ),
			props = {dateFormat: formats.date, timeFormat: formats.time}
			;

		this.componentProps.fromProps.forEach( function( name ) {
			props[ name ] = me.props[ name ];
		});
		this.componentProps.fromState.forEach( function( name ) {
			props[ name ] = me.state[ name ];
		});
		this.componentProps.fromThis.forEach( function( name ) {
			props[ name ] = me[ name ];
		});

		return props;
	},

	overrideEvent: function( handler, action ) {
		if ( !this.overridenEvents ) {
			this.overridenEvents = {};
		}

		if ( !this.overridenEvents[handler] ) {
			var me = this;
			this.overridenEvents[handler] = function( e ) {
				var result;
				if ( me.props.inputProps && me.props.inputProps[handler] ) {
					result = me.props.inputProps[handler]( e );
				}
				if ( result !== false ) {
					action( e );
				}
			};
		}

		return this.overridenEvents[handler];
	},

	render: function() {
		// TODO: Make a function or clean up this code,
		// logic right now is really hard to follow
		var className = 'rdt' + (this.props.className ?
									( Array.isArray( this.props.className ) ?
									' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
			children = [];

		if ( this.props.input ) {
			var finalInputProps = assign(
				{ type: 'text', className: 'form-control', value: this.state.inputValue },
				this.props.inputProps,
				{
					onClick: this.overrideEvent( 'onClick', this.openCalendar ),
					onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
					onChange: this.overrideEvent( 'onChange', this.onInputChange ),
					onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
				}
			);

			if ( this.props.renderInput ) {
				children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
			} else {
				children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
			}
		} else {
			className += ' rdtStatic';
		}

		if ( this.props.open || (this.props.open === undefined && this.state.open ) )
			className += ' rdtOpen';

		return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
			React.createElement( 'div',
				{ key: 'dt', className: 'rdtPicker' },
				React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
			)
		));
	}
});

var ClickableWrapper = onClickOutside( createClass({
	render: function() {
		return React.createElement( 'div', { className: this.props.className }, this.props.children );
	},
	handleClickOutside: function( e ) {
		this.props.onClickOut( e );
	}
}));

Datetime.defaultProps = {
	className: '',
	defaultValue: '',
	inputProps: {},
	input: true,
	onFocus: function() {},
	onBlur: function() {},
	onChange: function() {},
	onViewModeChange: function() {},
	onNavigateBack: function() {},
	onNavigateForward: function() {},
	timeFormat: true,
	timeConstraints: {},
	dateFormat: true,
	strictParsing: true,
	closeOnSelect: false,
	closeOnTab: true,
	utc: false
};

// Make moment accessible through the Datetime class
Datetime.moment = moment;

module.exports = Datetime;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*
AdvancedTable - Helper for rendering table
Now with object support instead of standalone array elements
This component was made to replace MagicTable.js
@author Arsena 'senndbx', 2019

Props Format:
  <AdvancedTable
    colSpan={}
    colSpanText=''
    header={[{ className, field, colSpan }]}
    body={[{ className, field }]}
    style={}
    className={}
  />
*/var AdvancedTable=function AdvancedTable(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped '+props.className,style:props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,props.header.map(function(column,COLUMN_ITERATOR){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{colSpan:column.colSpan||1,className:column.className||'text-center',key:COLUMN_ITERATOR},column.field);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,props.body&&props.body.length>0?props.body.map(function(row,ROW_ITERATOR){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:ROW_ITERATOR},row.map(function(column,COLUMN_ITERATOR){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:column.className||'text-center',key:COLUMN_ITERATOR},column.field||'-');}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:props.colSpan},props.colSpanText||'- No Data -')))));};/* harmony default export */ __webpack_exports__["a"] = (AdvancedTable);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry1 = __webpack_require__(5);
var _curry2 = __webpack_require__(3);
var _curryN = __webpack_require__(172);


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DestinationTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export continentSuccess */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({destinationRequest:null,destinationSuccess:['data'],destinationFailure:['err'],destinationCreateRequest:['data'],destinationCreateSuccess:['data'],destinationCreateFailure:['err'],destinationDeleteRequest:['data'],destinationDeleteSuccess:['data'],destinationDeleteFailure:['err'],destinationUpdateRequest:['data'],destinationUpdateSuccess:['data'],destinationUpdateFailure:['err'],addAttractionToDestinationRequest:['data'],addAttractionToDestinationSuccess:['data'],addAttractionToDestinationFailure:['err'],deleteAttractionFromDestinationRequest:['data'],deleteAttractionFromDestinationSuccess:['data'],deleteAttractionFromDestinationFailure:['err'],addPlaceToDestinationRequest:['data'],addPlaceToDestinationSuccess:['data'],addPlaceToDestinationFailure:['err'],deletePlaceFromDestinationRequest:['data'],deletePlaceFromDestinationSuccess:['data'],deletePlaceFromDestinationFailure:['err'],continentRequest:null,continentSuccess:['data'],continentFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var DestinationTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],continent:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var continentSuccess=function continentSuccess(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,continent:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.DESTINATION_SUCCESS,success),_defineProperty(_createReducer,Types.DESTINATION_REQUEST,request),_defineProperty(_createReducer,Types.DESTINATION_FAILURE,failure),_defineProperty(_createReducer,Types.DESTINATION_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DESTINATION_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DESTINATION_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DESTINATION_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DESTINATION_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DESTINATION_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DESTINATION_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DESTINATION_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DESTINATION_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ADD_ATTRACTION_TO_DESTINATION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ADD_ATTRACTION_TO_DESTINATION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ADD_ATTRACTION_TO_DESTINATION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_FROM_DESTINATION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_FROM_DESTINATION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_FROM_DESTINATION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ADD_PLACE_TO_DESTINATION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ADD_PLACE_TO_DESTINATION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ADD_PLACE_TO_DESTINATION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_PLACE_FROM_DESTINATION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_PLACE_FROM_DESTINATION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_PLACE_FROM_DESTINATION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.CONTINENT_SUCCESS,continentSuccess),_defineProperty(_createReducer,Types.CONTINENT_REQUEST,request),_defineProperty(_createReducer,Types.CONTINENT_FAILURE,failure),_createReducer));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(196);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(20);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _check = __webpack_require__(848);

var _check2 = _interopRequireDefault(_check);

var _x = __webpack_require__(849);

var _x2 = _interopRequireDefault(_x);

var _util = __webpack_require__(850);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        // Disable linting rule here since this usage of setState inside
        // componentDidUpdate is OK; see
        // https://reactjs.org/docs/react-component.html#componentdidupdate
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ checked: !!this.props.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      if (this.props.disabled) {
        return;
      }
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;

      this.setState({ checked: checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      if (this.props.disabled) {
        return;
      }
      this.startX = (0, _util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, _util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, _util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.default = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(155);
var defined = __webpack_require__(79);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _map = __webpack_require__(173);
var _reduce = __webpack_require__(56);
var _xmap = __webpack_require__(563);
var curryN = __webpack_require__(40);
var keys = __webpack_require__(66);


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */
module.exports = _curry2(_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function() {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function(acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successSingle */
/* unused harmony export failure */
/* unused harmony export failureSingle */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getCategoryRequest:['data'],getCategorySuccess:['data'],getCategoryFailure:['err'],getSingleCategoryRequest:['data'],getSingleCategorySuccess:['data'],getSingleCategoryFailure:['err'],createCategoryRequest:['data'],createCategorySuccess:['data'],createCategoryFailure:['err'],updateCategoryRequest:['data'],updateCategorySuccess:['data'],updateCategoryFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var CategoryTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],category_single:{},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var successSingle=function successSingle(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,category_single:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var failureSingle=function failureSingle(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err,data_single:{}});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref5){var data=_ref5.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref6){var err=_ref6.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_CATEGORY_SUCCESS,success),_defineProperty(_createReducer,Types.GET_CATEGORY_REQUEST,request),_defineProperty(_createReducer,Types.GET_CATEGORY_FAILURE,failure),_defineProperty(_createReducer,Types.GET_SINGLE_CATEGORY_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SINGLE_CATEGORY_REQUEST,request),_defineProperty(_createReducer,Types.GET_SINGLE_CATEGORY_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_CATEGORY_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_CATEGORY_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_CATEGORY_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successCustom */
/* unused harmony export successCampaign */
/* unused harmony export successVariant */
/* unused harmony export successVariantItem */
/* unused harmony export successCountry */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({productRequest:['data'],productSuccess:['data'],productFailure:['err'],getProductCustomRequest:['data'],getProductCustomSuccess:['data'],getProductCustomFailure:['err'],productCreateRequest:['data'],productCreateSuccess:['data'],productCreateFailure:['err'],productDeleteRequest:['data'],productDeleteSuccess:['data'],productDeleteFailure:['err'],productUpdateRequest:['data'],productUpdateSuccess:['data'],productUpdateFailure:['err'],getProductCountryRequest:['data'],getProductCountrySuccess:['data'],getProductCountryFailure:['err'],postProductCountryRequest:['data'],postProductCountrySuccess:['data'],postProductCountryFailure:['err'],deleteProductCountryRequest:['data'],deleteProductCountrySuccess:['data'],deleteProductCountryFailure:['err'],getProductCampaignRequest:['data'],getProductCampaignSuccess:['data'],getProductCampaignFailure:['err'],postProductCampaignRequest:['data'],postProductCampaignSuccess:['data'],postProductCampaignFailure:['err'],putProductCampaignRequest:['data'],putProductCampaignSuccess:['data'],putProductCampaignFailure:['err'],deleteProductCampaignRequest:['data'],deleteProductCampaignSuccess:['data'],deleteProductCampaignFailure:['err'],getProductVariantRequest:['data'],getProductVariantSuccess:['data'],getProductVariantFailure:['err'],postProductVariantRequest:['data'],postProductVariantSuccess:['data'],postProductVariantFailure:['err'],putProductVariantRequest:['data'],putProductVariantSuccess:['data'],putProductVariantFailure:['err'],deleteProductVariantRequest:['data'],deleteProductVariantSuccess:['data'],deleteProductVariantFailure:['err'],getProductVariantItemRequest:['data'],getProductVariantItemSuccess:['data'],getProductVariantItemFailure:['err'],postProductVariantItemRequest:['data'],postProductVariantItemSuccess:['data'],postProductVariantItemFailure:['err'],deleteProductVariantItemRequest:['data'],deleteProductVariantItemSuccess:['data'],deleteProductVariantItemFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var ProductTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,custom:[],campaign:[],variant:[],variant_item:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successCustom=function successCustom(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,custom:data,err:null});};var successCampaign=function successCampaign(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,campaign:data,err:null});};var successVariant=function successVariant(state,_ref4){var data=_ref4.data;return state.merge({fetching:false,variant:data,err:null});};var successVariantItem=function successVariantItem(state,_ref5){var data=_ref5.data;return state.merge({fetching:false,variant_item:data,err:null});};var successCountry=function successCountry(state,_ref6){var data=_ref6.data;return state.merge({fetching:false,country:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref7){var err=_ref7.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref8){var data=_ref8.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref9){var err=_ref9.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.PRODUCT_SUCCESS,success),_defineProperty(_createReducer,Types.PRODUCT_REQUEST,request),_defineProperty(_createReducer,Types.PRODUCT_FAILURE,failure),_defineProperty(_createReducer,Types.GET_PRODUCT_CUSTOM_SUCCESS,successCustom),_defineProperty(_createReducer,Types.GET_PRODUCT_CUSTOM_REQUEST,request),_defineProperty(_createReducer,Types.GET_PRODUCT_CUSTOM_FAILURE,failure),_defineProperty(_createReducer,Types.PRODUCT_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PRODUCT_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PRODUCT_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PRODUCT_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PRODUCT_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PRODUCT_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PRODUCT_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PRODUCT_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PRODUCT_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_PRODUCT_COUNTRY_SUCCESS,successCountry),_defineProperty(_createReducer,Types.GET_PRODUCT_COUNTRY_REQUEST,request),_defineProperty(_createReducer,Types.GET_PRODUCT_COUNTRY_FAILURE,failure),_defineProperty(_createReducer,Types.POST_PRODUCT_COUNTRY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_PRODUCT_COUNTRY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_PRODUCT_COUNTRY_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_PRODUCT_COUNTRY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_PRODUCT_COUNTRY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_PRODUCT_COUNTRY_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_PRODUCT_CAMPAIGN_SUCCESS,successCampaign),_defineProperty(_createReducer,Types.GET_PRODUCT_CAMPAIGN_REQUEST,request),_defineProperty(_createReducer,Types.GET_PRODUCT_CAMPAIGN_FAILURE,failure),_defineProperty(_createReducer,Types.POST_PRODUCT_CAMPAIGN_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_PRODUCT_CAMPAIGN_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_PRODUCT_CAMPAIGN_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_PRODUCT_CAMPAIGN_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_PRODUCT_CAMPAIGN_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_PRODUCT_CAMPAIGN_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_PRODUCT_CAMPAIGN_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_PRODUCT_CAMPAIGN_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_PRODUCT_CAMPAIGN_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_SUCCESS,successVariant),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_REQUEST,request),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_FAILURE,failure),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_PRODUCT_VARIANT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_PRODUCT_VARIANT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_PRODUCT_VARIANT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_ITEM_SUCCESS,successVariantItem),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_ITEM_REQUEST,request),_defineProperty(_createReducer,Types.GET_PRODUCT_VARIANT_ITEM_FAILURE,failure),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_ITEM_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_ITEM_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_PRODUCT_VARIANT_ITEM_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_ITEM_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_ITEM_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_PRODUCT_VARIANT_ITEM_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 49 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var createDesc = __webpack_require__(99);
module.exports = __webpack_require__(23) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var hide = __webpack_require__(50);
var has = __webpack_require__(49);
var SRC = __webpack_require__(118)('src');
var $toString = __webpack_require__(948);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(43).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(156);
var createDesc = __webpack_require__(99);
var toIObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(78);
var has = __webpack_require__(49);
var IE8_DOM_DEFINE = __webpack_require__(410);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(23) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(49);
var toObject = __webpack_require__(32);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(15);
var defined = __webpack_require__(79);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getSectionRequest:['data'],getSectionSuccess:['data'],getSectionFailure:['err'],postSectionRequest:['data'],postSectionSuccess:['data'],postSectionFailure:['err'],putSectionRequest:['data'],putSectionSuccess:['data'],putSectionFailure:['err'],deleteSectionRequest:['data'],deleteSectionSuccess:['data'],deleteSectionFailure:['err'],// getSectionRequest: ['data'],
// getSectionSuccess: ['data'],
// getSectionFailure: ['err'],
postSubSectionRequest:['data'],postSubSectionSuccess:['data'],postSubSectionFailure:['err'],putSubSectionRequest:['data'],putSubSectionSuccess:['data'],putSubSectionFailure:['err'],deleteSubSectionRequest:['data'],deleteSubSectionSuccess:['data'],deleteSubSectionFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var SectionTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_SECTION_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SECTION_REQUEST,request),_defineProperty(_createReducer,Types.GET_SECTION_FAILURE,failure),_defineProperty(_createReducer,Types.POST_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_SECTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_SECTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_SECTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.POST_SUB_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_SUB_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_SUB_SECTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_SUB_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_SUB_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_SUB_SECTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_SUB_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_SUB_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_SUB_SECTION_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(174);
var _xwrap = __webpack_require__(320);
var bind = __webpack_require__(321);


module.exports = (function() {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  };
}());


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _equals = __webpack_require__(583);


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
module.exports = _curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InsuranceTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successView */
/* unused harmony export failure */
/* unused harmony export failureView */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({// Travel package
getTravelPackageRequest:['data'],getTravelPackageSuccess:['data'],getTravelPackageFailure:['err'],postTravelPackageRequest:['data'],postTravelPackageSuccess:['data'],postTravelPackageFailure:['err'],putTravelPackageRequest:['data'],putTravelPackageSuccess:['data'],putTravelPackageFailure:['err'],deleteTravelPackageRequest:['data'],deleteTravelPackageSuccess:['data'],deleteTravelPackageFailure:['err'],viewTravelPackageRequest:['data'],viewTravelPackageSuccess:['data'],viewTravelPackageFailure:['err'],postTravelPackagePriceRequest:['data'],postTravelPackagePriceSuccess:['data'],postTravelPackagePriceFailure:['err'],putTravelPackagePriceRequest:['data'],putTravelPackagePriceSuccess:['data'],putTravelPackagePriceFailure:['err'],switchTravelPackagePriceRequest:['data'],switchTravelPackagePriceSuccess:['data'],switchTravelPackagePriceFailure:['err'],getTicketPackageRequest:['data'],getTicketPackageSuccess:['data'],getTicketPackageFailure:['err'],postTicketPackageRequest:['data'],postTicketPackageSuccess:['data'],postTicketPackageFailure:['err'],putTicketPackageRequest:['data'],putTicketPackageSuccess:['data'],putTicketPackageFailure:['err'],deleteTicketPackageRequest:['data'],deleteTicketPackageSuccess:['data'],deleteTicketPackageFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var InsuranceTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],data_view:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null// success: null
});};var successView=function successView(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_view:data,err:null// success: null
});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var failureView=function failureView(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err,data_view:{}});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref5){var data=_ref5.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref6){var err=_ref6.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_TRAVEL_PACKAGE_SUCCESS,success),_defineProperty(_createReducer,Types.GET_TRAVEL_PACKAGE_REQUEST,request),_defineProperty(_createReducer,Types.GET_TRAVEL_PACKAGE_FAILURE,failure),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_SUCCESS,success),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_REQUEST,request),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_FAILURE,failure),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_TRAVEL_PACKAGE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_TRAVEL_PACKAGE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_TRAVEL_PACKAGE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.VIEW_TRAVEL_PACKAGE_SUCCESS,successView),_defineProperty(_createReducer,Types.VIEW_TRAVEL_PACKAGE_REQUEST,request),_defineProperty(_createReducer,Types.VIEW_TRAVEL_PACKAGE_FAILURE,failureView),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_PRICE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_PRICE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_TRAVEL_PACKAGE_PRICE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_PRICE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_PRICE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_TRAVEL_PACKAGE_PRICE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.SWITCH_TRAVEL_PACKAGE_PRICE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.SWITCH_TRAVEL_PACKAGE_PRICE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.SWITCH_TRAVEL_PACKAGE_PRICE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_TICKET_PACKAGE_SUCCESS,success),_defineProperty(_createReducer,Types.GET_TICKET_PACKAGE_REQUEST,request),_defineProperty(_createReducer,Types.GET_TICKET_PACKAGE_FAILURE,failure),_defineProperty(_createReducer,Types.POST_TICKET_PACKAGE_SUCCESS,success),_defineProperty(_createReducer,Types.POST_TICKET_PACKAGE_REQUEST,request),_defineProperty(_createReducer,Types.POST_TICKET_PACKAGE_FAILURE,failure),_defineProperty(_createReducer,Types.PUT_TICKET_PACKAGE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_TICKET_PACKAGE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_TICKET_PACKAGE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_TICKET_PACKAGE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_TICKET_PACKAGE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_TICKET_PACKAGE_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(37);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successCustom */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({bannerRequest:['data'],bannerSuccess:['data'],bannerFailure:['err'],bannerCustomRequest:['data'],bannerCustomSuccess:['data'],bannerCustomFailure:['err'],bannerCreateRequest:['data'],bannerCreateSuccess:['data'],bannerCreateFailure:['err'],bannerDeleteRequest:['data'],bannerDeleteSuccess:['data'],bannerDeleteFailure:['err'],bannerUpdateRequest:['data'],bannerUpdateSuccess:['data'],bannerUpdateFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var BannerTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,custom:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successCustom=function successCustom(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,custom:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.BANNER_SUCCESS,success),_defineProperty(_createReducer,Types.BANNER_REQUEST,request),_defineProperty(_createReducer,Types.BANNER_FAILURE,failure),_defineProperty(_createReducer,Types.BANNER_CUSTOM_SUCCESS,successCustom),_defineProperty(_createReducer,Types.BANNER_CUSTOM_REQUEST,request),_defineProperty(_createReducer,Types.BANNER_CUSTOM_FAILURE,failure),_defineProperty(_createReducer,Types.BANNER_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.BANNER_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.BANNER_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.BANNER_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.BANNER_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.BANNER_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.BANNER_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.BANNER_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.BANNER_UPDATE_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = sym('TASK');
var HELPER = sym('HELPER');
var MATCH = sym('MATCH');
var CANCEL = sym('CANCEL_PROMISE');
var SAGA_ACTION = sym('SAGA_ACTION');
var SELF_CANCELLATION = sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = konst(true);
var kFalse = konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(463);
var isBuffer = __webpack_require__(1324);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(534),
    isArrayLike = __webpack_require__(228),
    isString = __webpack_require__(539),
    toInteger = __webpack_require__(314),
    values = __webpack_require__(544);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
module.exports = function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];

  idx = 0;
  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }
  idx = 0;
  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }
  return result;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _has = __webpack_require__(46);
var _isArguments = __webpack_require__(322);


/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
module.exports = (function() {
  // cover IE < 9 keys issues
  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = (function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
  }());

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
}());


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(112);
var NotFound=function NotFound(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app blank sidebar-opened'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-card global'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'error-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'error-title'},'404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'error-sub-title'},' Sorry, page not found ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mt-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'btn btn-primary',to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-angle-left'}),' Back to Dashboard')))));};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.18.1';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution:
      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      while (++index < length) {
        var key = toKey(path[index]);

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        baseAssignValue(result, pair[0], pair[1]);
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      arrayEach(importsKeys, function(key) {
        if (reForbiddenIdentifierChars.test(key)) {
          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
        }
      });

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(144)(module)))

/***/ }),
/* 69 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(15);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0: return function() { return fn.apply(this, arguments); };
    case 1: return function(a0) { return fn.apply(this, arguments); };
    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var _reduce = __webpack_require__(56);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *                -               -10
 *               / \              / \
 *              -   4           -6   4
 *             / \              / \
 *            -   3   ==>     -3   3
 *           / \              / \
 *          -   2           -1   2
 *         / \              / \
 *        0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
module.exports = _curry3(_reduce);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(738),
    hasPath = __webpack_require__(389);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(764);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export countSuccess */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({userRequest:['filter'],userSuccess:['data'],userFailure:['err'],userCountRequest:['filter'],userCountSuccess:['data'],userCountFailure:['err'],userCreateRequest:['data'],userCreateSuccess:null,userCreateFailure:['err'],userUpdateRequest:['data'],userUpdateSuccess:null,userUpdateFailure:['err'],userDeleteRequest:['id'],userDeleteSuccess:null,userDeleteFailure:['err'],userListRequest:['data'],userListSuccess:null,userListFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var UserTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,user_count:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var countSuccess=function countSuccess(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,user_count:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.USER_SUCCESS,success),_defineProperty(_createReducer,Types.USER_REQUEST,request),_defineProperty(_createReducer,Types.USER_FAILURE,failure),_defineProperty(_createReducer,Types.USER_COUNT_SUCCESS,countSuccess),_defineProperty(_createReducer,Types.USER_COUNT_REQUEST,request),_defineProperty(_createReducer,Types.USER_COUNT_FAILURE,failure),_defineProperty(_createReducer,Types.USER_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.USER_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.USER_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.USER_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.USER_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.USER_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.USER_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.USER_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.USER_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.USER_LIST_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.USER_LIST_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.USER_LIST_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(43);
var fails = __webpack_require__(15);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(59);
var IObject = __webpack_require__(155);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(24);
var asc = __webpack_require__(281);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrandTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getBrandRequest:['data'],getBrandSuccess:['data'],getBrandFailure:['err'],createBrandRequest:['data'],createBrandSuccess:['data'],createBrandFailure:['err'],updateBrandRequest:['data'],updateBrandSuccess:['data'],updateBrandFailure:['err'],deleteBrandRequest:['data'],deleteBrandSuccess:['data'],deleteBrandFailure:['err'],getSingleBrandRequest:['data'],getSingleBrandSuccess:['data'],getSingleBrandFailure:['err'],createCategoryBrandRequest:['data'],createCategoryBrandSuccess:['data'],createCategoryBrandFailure:['err'],updateCategoryBrandRequest:['data'],updateCategoryBrandSuccess:['data'],updateCategoryBrandFailure:['err'],deleteCategoryBrandRequest:['data'],deleteCategoryBrandSuccess:['data'],deleteCategoryBrandFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var BrandTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_BRAND_SUCCESS,success),_defineProperty(_createReducer,Types.GET_BRAND_REQUEST,request),_defineProperty(_createReducer,Types.GET_BRAND_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_BRAND_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_BRAND_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_BRAND_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_BRAND_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_BRAND_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_BRAND_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_BRAND_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_BRAND_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_BRAND_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_SINGLE_BRAND_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SINGLE_BRAND_REQUEST,request),_defineProperty(_createReducer,Types.GET_SINGLE_BRAND_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_CATEGORY_BRAND_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_CATEGORY_BRAND_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_CATEGORY_BRAND_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_BRAND_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_BRAND_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_CATEGORY_BRAND_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_CATEGORY_BRAND_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_CATEGORY_BRAND_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_CATEGORY_BRAND_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SupplierTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getSupplierRequest:['data'],getSupplierSuccess:['data'],getSupplierFailure:['err'],createSupplierRequest:['data'],createSupplierSuccess:['data'],createSupplierFailure:['err'],updateSupplierRequest:['data'],updateSupplierSuccess:['data'],updateSupplierFailure:['err'],deleteSupplierRequest:['data'],deleteSupplierSuccess:['data'],deleteSupplierFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var SupplierTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_SUPPLIER_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SUPPLIER_REQUEST,request),_defineProperty(_createReducer,Types.GET_SUPPLIER_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_SUPPLIER_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_SUPPLIER_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_SUPPLIER_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_SUPPLIER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_SUPPLIER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_SUPPLIER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_SUPPLIER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_SUPPLIER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_SUPPLIER_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(313);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresetTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export currencyRequest */
/* unused harmony export currencySuccess */
/* unused harmony export currencyFailure */
/* unused harmony export languageRequest */
/* unused harmony export languageSuccess */
/* unused harmony export languageFailure */
/* unused harmony export countriesRequest */
/* unused harmony export countriesSuccess */
/* unused harmony export countriesFailure */
/* unused harmony export presetOrderRequest */
/* unused harmony export presetOrderUpdateSuccess */
/* unused harmony export presetOrderSuccess */
/* unused harmony export presetOrderFailure */
/* unused harmony export change */
/* unused harmony export getBranchRequest */
/* unused harmony export getBranchSuccess */
/* unused harmony export getBranchFailure */
/* unused harmony export updateBranchRequest */
/* unused harmony export updateBranchSuccess */
/* unused harmony export updateBranchFailure */
/* unused harmony export getShipping */
/* unused harmony export getShippingSuccess */
/* unused harmony export getShippingFailure */
/* unused harmony export updateShipping */
/* unused harmony export updateShippingSuccess */
/* unused harmony export updateShippingFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({presetChange:['data'],currencyRequest:null,currencySuccess:['data'],currencyFailure:['err'],languageRequest:null,languageSuccess:['data'],languageFailure:['err'],countriesRequest:null,countriesSuccess:['data'],countriesFailure:['err'],presetOrderRequest:null,presetOrderSuccess:['data'],presetOrderFailure:['err'],presetOrderUpdateRequest:['data'],presetOrderUpdateSuccess:['data'],presetOrderUpdateFailure:['err'],getBranchRequest:null,getBranchSuccess:['data'],getBranchFailure:['err'],updateBranchRequest:['data'],updateBranchSuccess:['data'],updateBranchFailure:['err'],getShipping:null,getShippingSuccess:['data'],getShippingFailure:['err'],updateShipping:['data'],updateShippingSuccess:['data'],updateShippingFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var PresetTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_2_seamless_immutable___default()({fetchingCurrency:false,errCurrency:null,dataCurrency:[],fetchingLanguage:false,errLanguage:null,dataLanguage:[],fetchingCountries:false,errCountries:null,dataCountries:[],fetchingPresetOrder:false,errPresetOrder:null,dataPresetOrder:{},fetchingBranch:false,errBranch:null,dataBranch:{},fetchingShipping:false,errShipping:null,dataShipping:{},setting:{currency_code:Object(__WEBPACK_IMPORTED_MODULE_1__src_Utils_PrivilegeUtils__["b" /* currentCurrency */])(),language_code:'EN',provider:'BMG'}});/* ------------- Reducers ------------- */// Currency
var currencyRequest=function currencyRequest(state){return state.merge({fetchingCurrency:true,errCurrency:null});};var currencySuccess=function currencySuccess(state,_ref){var data=_ref.data;return state.merge({fetchingCurrency:false,errCurrency:null,dataCurrency:data});};var currencyFailure=function currencyFailure(state,_ref2){var err=_ref2.err;return state.merge({fetchingCurrency:false,errCurrency:err});};// Language
var languageRequest=function languageRequest(state){return state.merge({fetchingLanguage:true,errLanguage:null});};var languageSuccess=function languageSuccess(state,_ref3){var data=_ref3.data;return state.merge({fetchingLanguage:false,errLanguage:null,dataLanguage:data});};var languageFailure=function languageFailure(state,_ref4){var err=_ref4.err;return state.merge({fetchingLanguage:false,errLanguage:err});};// Countries
var countriesRequest=function countriesRequest(state){return state.merge({fetchingCountries:true,errCountries:null});};var countriesSuccess=function countriesSuccess(state,_ref5){var data=_ref5.data;return state.merge({fetchingCountries:false,errCountries:null,dataCountries:data});};var countriesFailure=function countriesFailure(state,_ref6){var err=_ref6.err;return state.merge({fetchingCountries:false,errCountries:err});};// Preset Order
var presetOrderRequest=function presetOrderRequest(state){return state.merge({fetchingPresetOrder:true,errPresetOrder:null});};var presetOrderUpdateSuccess=function presetOrderUpdateSuccess(state,_ref7){var data=_ref7.data;return state.merge({fetchingPresetOrder:false,errPresetOrder:null});};var presetOrderSuccess=function presetOrderSuccess(state,_ref8){var data=_ref8.data;return state.merge({fetchingPresetOrder:false,errPresetOrder:null,dataPresetOrder:data});};var presetOrderFailure=function presetOrderFailure(state,_ref9){var err=_ref9.err;return state.merge({fetchingPresetOrder:false,errPresetOrder:err});};var change=function change(state,_ref10){var data=_ref10.data;return state.merge({setting:data});};// Branch
var getBranchRequest=function getBranchRequest(state){return state.merge({fetchingBranch:true,errBranch:null});};var getBranchSuccess=function getBranchSuccess(state,_ref11){var data=_ref11.data;return state.merge({fetchingBranch:false,errBranch:null,dataBranch:data});};var getBranchFailure=function getBranchFailure(state,_ref12){var err=_ref12.err;return state.merge({fetchingBranch:false,errBranch:err});};var updateBranchRequest=function updateBranchRequest(state){return state.merge({fetchingBranch:true,errBranch:null});};var updateBranchSuccess=function updateBranchSuccess(state,_ref13){var data=_ref13.data;return state.merge({fetchingBranch:false,errBranch:null,dataBranch:data});};var updateBranchFailure=function updateBranchFailure(state,_ref14){var err=_ref14.err;return state.merge({fetchingBranch:false,errBranch:err});};// Shipping
var getShipping=function getShipping(state){return state.merge({fetchingShipping:true,errShipping:null});};var getShippingSuccess=function getShippingSuccess(state,_ref15){var data=_ref15.data;return state.merge({fetchingShipping:false,errShipping:null,dataShipping:data});};var getShippingFailure=function getShippingFailure(state,_ref16){var err=_ref16.err;return state.merge({fetchingShipping:false,errShipping:err});};var updateShipping=function updateShipping(state){return state.merge({fetchingShipping:true,errShipping:null});};var updateShippingSuccess=function updateShippingSuccess(state,_ref17){var data=_ref17.data;return state.merge({fetchingShipping:false,errShipping:null,dataShipping:data});};var updateShippingFailure=function updateShippingFailure(state,_ref18){var err=_ref18.err;return state.merge({fetchingShipping:false,errShipping:err});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.PRESET_CHANGE,change),_defineProperty(_createReducer,Types.CURRENCY_REQUEST,currencyRequest),_defineProperty(_createReducer,Types.CURRENCY_SUCCESS,currencySuccess),_defineProperty(_createReducer,Types.CURRENCY_FAILURE,currencyFailure),_defineProperty(_createReducer,Types.LANGUAGE_REQUEST,languageRequest),_defineProperty(_createReducer,Types.LANGUAGE_SUCCESS,languageSuccess),_defineProperty(_createReducer,Types.LANGUAGE_FAILURE,languageFailure),_defineProperty(_createReducer,Types.COUNTRIES_REQUEST,countriesRequest),_defineProperty(_createReducer,Types.COUNTRIES_SUCCESS,countriesSuccess),_defineProperty(_createReducer,Types.COUNTRIES_FAILURE,countriesFailure),_defineProperty(_createReducer,Types.PRESET_ORDER_REQUEST,presetOrderRequest),_defineProperty(_createReducer,Types.PRESET_ORDER_SUCCESS,presetOrderSuccess),_defineProperty(_createReducer,Types.PRESET_ORDER_FAILURE,presetOrderFailure),_defineProperty(_createReducer,Types.PRESET_ORDER_UPDATE_REQUEST,presetOrderRequest),_defineProperty(_createReducer,Types.PRESET_ORDER_UPDATE_SUCCESS,presetOrderUpdateSuccess),_defineProperty(_createReducer,Types.PRESET_ORDER_UPDATE_FAILURE,presetOrderFailure),_defineProperty(_createReducer,Types.GET_BRANCH_REQUEST,getBranchRequest),_defineProperty(_createReducer,Types.GET_BRANCH_SUCCESS,getBranchSuccess),_defineProperty(_createReducer,Types.GET_BRANCH_FAILURE,getBranchFailure),_defineProperty(_createReducer,Types.UPDATE_BRANCH_REQUEST,updateBranchRequest),_defineProperty(_createReducer,Types.UPDATE_BRANCH_SUCCESS,updateBranchSuccess),_defineProperty(_createReducer,Types.UPDATE_BRANCH_FAILURE,updateBranchFailure),_defineProperty(_createReducer,Types.GET_SHIPPING,getShipping),_defineProperty(_createReducer,Types.GET_SHIPPING_SUCCESS,getShippingSuccess),_defineProperty(_createReducer,Types.GET_SHIPPING_FAILURE,getShippingFailure),_defineProperty(_createReducer,Types.UPDATE_SHIPPING,updateShipping),_defineProperty(_createReducer,Types.UPDATE_SHIPPING_SUCCESS,updateShippingSuccess),_defineProperty(_createReducer,Types.UPDATE_SHIPPING_FAILURE,updateShippingFailure),_createReducer));

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(412);
var enumBugKeys = __webpack_require__(267);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(7);
var dPs = __webpack_require__(413);
var enumBugKeys = __webpack_require__(267);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(264)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(268).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(23)) {
  var LIBRARY = __webpack_require__(100);
  var global = __webpack_require__(12);
  var fails = __webpack_require__(15);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(213);
  var $buffer = __webpack_require__(290);
  var ctx = __webpack_require__(59);
  var anInstance = __webpack_require__(123);
  var propertyDesc = __webpack_require__(99);
  var hide = __webpack_require__(50);
  var redefineAll = __webpack_require__(124);
  var toInteger = __webpack_require__(70);
  var toLength = __webpack_require__(24);
  var toIndex = __webpack_require__(435);
  var toAbsoluteIndex = __webpack_require__(119);
  var toPrimitive = __webpack_require__(78);
  var has = __webpack_require__(49);
  var classof = __webpack_require__(102);
  var isObject = __webpack_require__(16);
  var toObject = __webpack_require__(32);
  var isArrayIter = __webpack_require__(279);
  var create = __webpack_require__(87);
  var getPrototypeOf = __webpack_require__(53);
  var gOPN = __webpack_require__(120).f;
  var getIterFn = __webpack_require__(157);
  var uid = __webpack_require__(118);
  var wks = __webpack_require__(21);
  var createArrayMethod = __webpack_require__(81);
  var createArrayIncludes = __webpack_require__(201);
  var speciesConstructor = __webpack_require__(159);
  var ArrayIterators = __webpack_require__(283);
  var Iterators = __webpack_require__(121);
  var $iterDetect = __webpack_require__(208);
  var setSpecies = __webpack_require__(122);
  var arrayFill = __webpack_require__(282);
  var arrayCopyWithin = __webpack_require__(425);
  var $DP = __webpack_require__(25);
  var $GOPD = __webpack_require__(52);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(430);
var $export = __webpack_require__(2);
var shared = __webpack_require__(154)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(433))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarkupTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successItem */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({markupRequest:['filter'],markupSuccess:['data'],markupFailure:['err'],markupCreateRequest:['data'],markupCreateSuccess:['data'],markupCreateFailure:['err'],markupUpdateRequest:['data'],markupUpdateSuccess:['data'],markupUpdateFailure:['err'],markupDeleteRequest:['data'],markupDeleteSuccess:['data'],markupDeleteFailure:['err'],markupItemCreateRequest:['data'],markupItemCreateSuccess:['data'],markupItemCreateFailure:['err'],markupItemUpdateRequest:['data'],markupItemUpdateSuccess:['data'],markupItemUpdateFailure:['err'],markupItemDeleteRequest:['data'],markupItemDeleteSuccess:['data'],markupItemDeleteFailure:['err'],markupItemGetRequest:['data'],markupItemGetSuccess:['data'],markupItemGetFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var MarkupTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,data_item:{value:0,test_value:0,id:'',attraction_id:'',created_at:'',updated_at:'',attraction:{type_name:''},locations:[],final_price:'',is_expired:false,is_disabled:false,provider:'',attraction_packages:[],title:'',current_price:0,preview_price:0,currency_code:''},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successItem=function successItem(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_item:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.MARKUP_SUCCESS,success),_defineProperty(_createReducer,Types.MARKUP_REQUEST,request),_defineProperty(_createReducer,Types.MARKUP_FAILURE,failure),_defineProperty(_createReducer,Types.MARKUP_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_ITEM_CREATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_ITEM_CREATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_ITEM_CREATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_ITEM_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_ITEM_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_ITEM_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_ITEM_DELETE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.MARKUP_ITEM_DELETE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.MARKUP_ITEM_DELETE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.MARKUP_ITEM_GET_SUCCESS,successItem),_defineProperty(_createReducer,Types.MARKUP_ITEM_GET_REQUEST,request),_defineProperty(_createReducer,Types.MARKUP_ITEM_GET_FAILURE,failure),_createReducer));

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
module.exports = Array.isArray || function _isArray(val) {
  return (val != null &&
          val.length >= 0 &&
          Object.prototype.toString.call(val) === '[object Array]');
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x :
    {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
};


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toggle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SwitchButton=function(_React$Component){_inherits(SwitchButton,_React$Component);function SwitchButton(props){_classCallCheck(this,SwitchButton);var _this=_possibleConstructorReturn(this,(SwitchButton.__proto__||Object.getPrototypeOf(SwitchButton)).call(this,props));_this.componentWillReceiveProps=function(newProps){_this.setState({isChecked:newProps.isChecked});};_this.componentWillMount=function(){_this.setState({isChecked:_this.props.isChecked});};_this._handleChange=function(){_this.setState({isChecked:!_this.state.isChecked});var event={target:{value:!_this.state.isChecked}};_this.props.onChange(event);};_this.state={isChecked:props.isChecked};return _this;}_createClass(SwitchButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_toggle___default.a,{checked:this.state.isChecked,value:this.props.label,onChange:this._handleChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.label));}}]);return SwitchButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SwitchButton);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
AdvancedFilter - Customizable and expandable inline forms
@author Arsena 'senndbx', 2019

Format:
  <AdvancedFilter filters={[{}]} callback={} manipulateState={} />

How to use:
  filters={[{type, name, placeholder, field, selectors:[{label, value}]}]}
    - type: ['selector', 'number', 'text']. Subject to change in the future
    - name: label assigned to form
    - placeholder: placeholder assigned to form (if type is not selector)
    - field: property name that will sent as a filte to API
    - selector properties:
      - label: label assigned to option
      - value: value assigned to option
      - restriction: (NEW) restriction to filter out options inside said filter, if any

  manipulateState={(props) => this._manipulateState(props)}
    - This component will try to manipulate otherwise fixed state on its parent component
    - Send local state to parent state as a (typically) parameter

  callback={(event) => this._function(event)}
    - This component will try to trigger any function available in parent component

Best practices:
  - Refer all available filter props inside external JSON file(s)

@todo
  - Make object-based styling to apply inside JSX
  - Make date-based filter. Type is 'dateTime'
  - Make local only filter (RESTless) (type assigned is 'advancedText')
  - Integrate toggle as a filter, or react-toggle as a filter
  - Integrate react-select (even more scalable selector)
  - Make passing props into this component be able to refer to some local JSON file => DONE
  - Rework interface: instead of inline forms, make this a vertically expandable form
*/var AdvancedFilter=function(_React$Component){_inherits(AdvancedFilter,_React$Component);function AdvancedFilter(props){_classCallCheck(this,AdvancedFilter);var _this=_possibleConstructorReturn(this,(AdvancedFilter.__proto__||Object.getPrototypeOf(AdvancedFilter)).call(this,props));_this._handleChange=function(event,type,field){var params=Object.assign({},_this.state.params);var value=null;if(type==='dateTime'){value=event;}else{value=event.target.value;}params[field]=value;_this.setState({params:params});_this.props.manipulateState(params);};_this._renderGeneric=function(type,placeholder,field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:type,className:'form-control',placeholder:placeholder,onChange:function onChange(event){return _this._handleChange(event,type,field);}});};_this._renderSelector=function(type,field,selectors){var options=[];selectors.map(function(item,i){if(!Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"])(item.restriction,Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])())){options.push(item);}return options;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:function onChange(event){return _this._handleChange(event,type,field);}},options.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}));};_this._renderDateTime=function(type,field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime___default.a,{value:_this.state.params.field,closeOnSelect:true,onChange:function onChange(event){return _this._handleChange(event,type,field);},dateFormat:'DD/MM/YYYY',timeFormat:false});};_this._renderInput=function(type,placeholder,field,selectors){switch(type){case'text':case'number':return _this._renderGeneric(type,placeholder,field);case'selector':return _this._renderSelector(type,field,selectors);case'dateTime':return _this._renderDateTime(type,field);default:return null;}};_this.state={params:{}};_this.filters=props.filters;return _this;}_createClass(AdvancedFilter,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter by:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2.props.callback(event);}},this.filters.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},item.name),_this2._renderInput(item.type,item.placeholder,item.field,item.selectors));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'}),' Search'))));}}]);return AdvancedFilter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AdvancedFilter);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponProviderTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getCouponProviderRequest:['data'],getCouponProviderSuccess:['data'],getCouponProviderFailure:['err'],postCouponProviderRequest:['data'],postCouponProviderSuccess:['data'],postCouponProviderFailure:['err'],putCouponProviderRequest:['data'],putCouponProviderSuccess:['data'],putCouponProviderFailure:['err'],deleteCouponProviderRequest:['data'],deleteCouponProviderSuccess:['data'],deleteCouponProviderFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var CouponProviderTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null,success:null,spreadsheet:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_COUPON_PROVIDER_REQUEST,request),_defineProperty(_createReducer,Types.GET_COUPON_PROVIDER_SUCCESS,success),_defineProperty(_createReducer,Types.GET_COUPON_PROVIDER_FAILURE,failure),_defineProperty(_createReducer,Types.POST_COUPON_PROVIDER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_COUPON_PROVIDER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_COUPON_PROVIDER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_COUPON_PROVIDER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_COUPON_PROVIDER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_COUPON_PROVIDER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_COUPON_PROVIDER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_COUPON_PROVIDER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_COUPON_PROVIDER_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InventoryTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successCustom */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getInventoryRequest:['data'],getInventorySuccess:['data'],getInventoryFailure:['err'],getInventoryCustomRequest:['data'],getInventoryCustomSuccess:['data'],getInventoryCustomFailure:['err'],createInventoryRequest:['data'],createInventorySuccess:['data'],createInventoryFailure:['err'],updateInventoryRequest:['data'],updateInventorySuccess:['data'],updateInventoryFailure:['err'],updateInventoryImageRequest:['data'],updateInventoryImageSuccess:['data'],updateInventoryImageFailure:['err'],deleteInventoryRequest:['data'],deleteInventorySuccess:['data'],deleteInventoryFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var InventoryTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],custom:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var successCustom=function successCustom(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,custom:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_INVENTORY_SUCCESS,success),_defineProperty(_createReducer,Types.GET_INVENTORY_REQUEST,request),_defineProperty(_createReducer,Types.GET_INVENTORY_FAILURE,failure),_defineProperty(_createReducer,Types.GET_INVENTORY_CUSTOM_SUCCESS,successCustom),_defineProperty(_createReducer,Types.GET_INVENTORY_CUSTOM_REQUEST,request),_defineProperty(_createReducer,Types.GET_INVENTORY_CUSTOM_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_INVENTORY_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_INVENTORY_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_INVENTORY_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_IMAGE_SUCCESS,success),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_IMAGE_REQUEST,request),_defineProperty(_createReducer,Types.UPDATE_INVENTORY_IMAGE_FAILURE,failure),_defineProperty(_createReducer,Types.DELETE_INVENTORY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_INVENTORY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_INVENTORY_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(118)('meta');
var isObject = __webpack_require__(16);
var has = __webpack_require__(49);
var setDesc = __webpack_require__(25).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(15)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(69);
var TAG = __webpack_require__(21)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(21)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(50)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(59);
var call = __webpack_require__(423);
var isArrayIter = __webpack_require__(279);
var anObject = __webpack_require__(7);
var toLength = __webpack_require__(24);
var getIterFn = __webpack_require__(157);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successCategory */
/* unused harmony export successPopular */
/* unused harmony export failure */
/* unused harmony export failureCategory */
/* unused harmony export failurePopular */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getAllEventsRequest:['data'],getAllEventsSuccess:['data'],getAllEventsFailure:['err'],getEventsRequest:['data'],getEventsSuccess:['data'],getEventsFailure:['err'],getEventsCategoriesRequest:['data'],getEventsCategoriesSuccess:['data'],getEventsCategoriesFailure:['err'],getAllPopularEventsRequest:['data'],getAllPopularEventsSuccess:['data'],getAllPopularEventsFailure:['err'],setPopularEventRequest:['data'],setPopularEventSuccess:['data'],setPopularEventFailure:['err'],resetEventDescriptionRequest:['data'],resetEventDescriptionSuccess:['data'],resetEventDescriptionFailure:['err'],updateEventDescriptionRequest:['data'],updateEventDescriptionSuccess:['data'],updateEventDescriptionFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var EventsTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],data_category:[],data_popular:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successCategory=function successCategory(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_category:data,err:null});};var successPopular=function successPopular(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,data_popular:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err});};var failureCategory=function failureCategory(state,_ref5){var err=_ref5.err;return state.merge({fetching:false,err:err,data_category:[]});};var failurePopular=function failurePopular(state,_ref6){var err=_ref6.err;return state.merge({fetching:false,err:err,data_popular:[]});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref7){var data=_ref7.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref8){var err=_ref8.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_ALL_EVENTS_SUCCESS,success),_defineProperty(_createReducer,Types.GET_ALL_EVENTS_REQUEST,request),_defineProperty(_createReducer,Types.GET_ALL_EVENTS_FAILURE,failure),_defineProperty(_createReducer,Types.GET_EVENTS_SUCCESS,success),_defineProperty(_createReducer,Types.GET_EVENTS_REQUEST,request),_defineProperty(_createReducer,Types.GET_EVENTS_FAILURE,failure),_defineProperty(_createReducer,Types.GET_EVENTS_CATEGORIES_SUCCESS,successCategory),_defineProperty(_createReducer,Types.GET_EVENTS_CATEGORIES_REQUEST,request),_defineProperty(_createReducer,Types.GET_EVENTS_CATEGORIES_FAILURE,failureCategory),_defineProperty(_createReducer,Types.GET_ALL_POPULAR_EVENTS_SUCCESS,successPopular),_defineProperty(_createReducer,Types.GET_ALL_POPULAR_EVENTS_REQUEST,request),_defineProperty(_createReducer,Types.GET_ALL_POPULAR_EVENTS_FAILURE,failurePopular),_defineProperty(_createReducer,Types.SET_POPULAR_EVENT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.SET_POPULAR_EVENT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.SET_POPULAR_EVENT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.RESET_EVENT_DESCRIPTION_SUCCESS,success),_defineProperty(_createReducer,Types.RESET_EVENT_DESCRIPTION_REQUEST,request),_defineProperty(_createReducer,Types.RESET_EVENT_DESCRIPTION_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_EVENT_DESCRIPTION_SUCCESS,success),_defineProperty(_createReducer,Types.UPDATE_EVENT_DESCRIPTION_REQUEST,request),_defineProperty(_createReducer,Types.UPDATE_EVENT_DESCRIPTION_FAILURE,failure),_createReducer));

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColourTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successAll */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getColourRequest:['data'],getColourSuccess:['data'],getColourFailure:['err'],getAllColourRequest:['data'],getAllColourSuccess:['data'],getAllColourFailure:['err'],createColourRequest:['data'],createColourSuccess:['data'],createColourFailure:['err'],updateColourRequest:['data'],updateColourSuccess:['data'],updateColourFailure:['err'],deleteColourRequest:['data'],deleteColourSuccess:['data'],deleteColourFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var ColourTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],dataAll:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var successAll=function successAll(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,dataAll:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_COLOUR_SUCCESS,success),_defineProperty(_createReducer,Types.GET_COLOUR_REQUEST,request),_defineProperty(_createReducer,Types.GET_COLOUR_FAILURE,failure),_defineProperty(_createReducer,Types.GET_ALL_COLOUR_SUCCESS,successAll),_defineProperty(_createReducer,Types.GET_ALL_COLOUR_REQUEST,request),_defineProperty(_createReducer,Types.GET_ALL_COLOUR_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_COLOUR_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_COLOUR_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_COLOUR_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_COLOUR_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_COLOUR_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_COLOUR_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_COLOUR_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_COLOUR_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_COLOUR_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SizeTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successAll */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getSizeRequest:['data'],getSizeSuccess:['data'],getSizeFailure:['err'],getAllSizeRequest:['data'],getAllSizeSuccess:['data'],getAllSizeFailure:['err'],createSizeRequest:['data'],createSizeSuccess:['data'],createSizeFailure:['err'],updateSizeRequest:['data'],updateSizeSuccess:['data'],updateSizeFailure:['err'],deleteSizeRequest:['data'],deleteSizeSuccess:['data'],deleteSizeFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var SizeTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],dataAll:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var successAll=function successAll(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,dataAll:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_SIZE_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SIZE_REQUEST,request),_defineProperty(_createReducer,Types.GET_SIZE_FAILURE,failure),_defineProperty(_createReducer,Types.GET_ALL_SIZE_SUCCESS,successAll),_defineProperty(_createReducer,Types.GET_ALL_SIZE_REQUEST,request),_defineProperty(_createReducer,Types.GET_ALL_SIZE_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_SIZE_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_SIZE_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_SIZE_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_SIZE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_SIZE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_SIZE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_SIZE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_SIZE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_SIZE_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WarehouseTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getWarehouseRequest:['data'],getWarehouseSuccess:['data'],getWarehouseFailure:['err'],createWarehouseRequest:['data'],createWarehouseSuccess:['data'],createWarehouseFailure:['err'],updateWarehouseRequest:['data'],updateWarehouseSuccess:['data'],updateWarehouseFailure:['err'],deleteWarehouseRequest:['data'],deleteWarehouseSuccess:['data'],deleteWarehouseFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var WarehouseTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_WAREHOUSE_SUCCESS,success),_defineProperty(_createReducer,Types.GET_WAREHOUSE_REQUEST,request),_defineProperty(_createReducer,Types.GET_WAREHOUSE_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_WAREHOUSE_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_WAREHOUSE_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_WAREHOUSE_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_WAREHOUSE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_WAREHOUSE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_WAREHOUSE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_WAREHOUSE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_WAREHOUSE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_WAREHOUSE_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttractionPromoTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({attractionPromoRequest:['data'],attractionPromoSuccess:['data'],attractionPromoFailure:['err'],postAttractionPromoRequest:['data'],postAttractionPromoSuccess:['data'],postAttractionPromoFailure:['err'],putAttractionPromoRequest:['data'],putAttractionPromoSuccess:['data'],putAttractionPromoFailure:['err'],deleteAttractionPromoRequest:['data'],deleteAttractionPromoSuccess:['data'],deleteAttractionPromoFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var AttractionPromoTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,processing:false,data:[],err:null,success:false});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,success:false});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,processing:false,data:data,err:null});};var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.ATTRACTION_PROMO_REQUEST,request),_defineProperty(_createReducer,Types.ATTRACTION_PROMO_SUCCESS,success),_defineProperty(_createReducer,Types.ATTRACTION_PROMO_FAILURE,failure),_defineProperty(_createReducer,Types.POST_ATTRACTION_PROMO_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_ATTRACTION_PROMO_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_ATTRACTION_PROMO_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_ATTRACTION_PROMO_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_ATTRACTION_PROMO_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_ATTRACTION_PROMO_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_PROMO_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_PROMO_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_ATTRACTION_PROMO_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchedulerTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successDetail */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getSchedulerRequest:['data'],getSchedulerSuccess:['data'],getSchedulerFailure:['err'],getSchedulerDetailRequest:['data'],getSchedulerDetailSuccess:['data'],getSchedulerDetailFailure:['err'],postSchedulerRequest:['data'],postSchedulerSuccess:['data'],postSchedulerFailure:['err'],putSchedulerRequest:['data'],putSchedulerSuccess:['data'],putSchedulerFailure:['err'],deleteSchedulerRequest:['data'],deleteSchedulerSuccess:['data'],deleteSchedulerFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var SchedulerTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null,detail:{}});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:true// important: initial value is null
});};var successDetail=function successDetail(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,detail:data,err:null,success:true});};var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_SCHEDULER_SUCCESS,success),_defineProperty(_createReducer,Types.GET_SCHEDULER_REQUEST,request),_defineProperty(_createReducer,Types.GET_SCHEDULER_FAILURE,failure),_defineProperty(_createReducer,Types.GET_SCHEDULER_DETAIL_SUCCESS,successDetail),_defineProperty(_createReducer,Types.GET_SCHEDULER_DETAIL_REQUEST,request),_defineProperty(_createReducer,Types.GET_SCHEDULER_DETAIL_FAILURE,failure),_defineProperty(_createReducer,Types.POST_SCHEDULER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_SCHEDULER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_SCHEDULER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_SCHEDULER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_SCHEDULER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_SCHEDULER_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_SCHEDULER_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_SCHEDULER_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_SCHEDULER_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EsimsTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getAllEsimsRequest:['data'],getAllEsimsSuccess:['data'],getAllEsimsFailure:['err'],esimUpdateRequest:['data'],esimUpdateSuccess:['data'],esimUpdateFailure:['err'],esimUpdateCountryRequest:['data'],esimUpdateCountrySuccess:['data'],esimUpdateCountryFailure:['err'],esimUpdateVariantRequest:['data'],esimUpdateVariantSuccess:['data'],esimUpdateVariantFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var EsimsTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};// Manipulate data
var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_ALL_ESIMS_SUCCESS,success),_defineProperty(_createReducer,Types.GET_ALL_ESIMS_REQUEST,request),_defineProperty(_createReducer,Types.GET_ALL_ESIMS_FAILURE,failure),_defineProperty(_createReducer,Types.ESIM_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ESIM_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ESIM_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ESIM_UPDATE_COUNTRY_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ESIM_UPDATE_COUNTRY_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ESIM_UPDATE_COUNTRY_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ESIM_UPDATE_VARIANT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ESIM_UPDATE_VARIANT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ESIM_UPDATE_VARIANT_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(515);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(516);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(518);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(520);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(307);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(225);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(524);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(528);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(529);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(530);
/* unused harmony reexport withRouter */





























/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */
module.exports = _curry1(function always(val) {
  return function() {
    return val;
  };
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(147);
var _curry3 = __webpack_require__(6);


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
module.exports = _curry3(_checkForMethod('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var _indexOf = __webpack_require__(336);


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CouponPresetTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getCouponPresetRequest:['data'],getCouponPresetSuccess:['data'],getCouponPresetFailure:['err'],postCouponPresetRequest:['data'],postCouponPresetSuccess:['data'],postCouponPresetFailure:['err'],putCouponPresetRequest:['data'],putCouponPresetSuccess:['data'],putCouponPresetFailure:['err'],deleteCouponPresetRequest:['data'],deleteCouponPresetSuccess:['data'],deleteCouponPresetFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var CouponPresetTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null,success:null,spreadsheet:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_COUPON_PRESET_REQUEST,request),_defineProperty(_createReducer,Types.GET_COUPON_PRESET_SUCCESS,success),_defineProperty(_createReducer,Types.GET_COUPON_PRESET_FAILURE,failure),_defineProperty(_createReducer,Types.POST_COUPON_PRESET_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_COUPON_PRESET_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_COUPON_PRESET_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_COUPON_PRESET_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_COUPON_PRESET_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_COUPON_PRESET_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_COUPON_PRESET_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_COUPON_PRESET_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_COUPON_PRESET_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransferHistoryTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successMatches */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({transferHistoryRequest:['filter'],transferHistorySuccess:['data'],transferHistoryFailure:['err'],transferHistoryMatchesRequest:null,transferHistoryMatchesSuccess:['data'],transferHistoryMatchesFailure:['err'],transferHistoryUpdateRequest:['data'],transferHistoryUpdateSuccess:['data'],transferHistoryUpdateFailure:['err'],transferHistoryListDownloadRequest:['filter'],transferHistoryListDownloadSuccess:null,transferHistoryListDownloadFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var TransferHistoryTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,err:null,data_matches:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,success:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successMatches=function successMatches(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_matches:data,err:null});};var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.TRANSFER_HISTORY_SUCCESS,success),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_REQUEST,request),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_FAILURE,failure),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_MATCHES_SUCCESS,successMatches),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_MATCHES_REQUEST,request),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_MATCHES_FAILURE,failure),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_UPDATE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_UPDATE_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_LIST_DOWNLOAD_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_LIST_DOWNLOAD_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.TRANSFER_HISTORY_LIST_DOWNLOAD_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 118 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(70);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(412);
var hiddenKeys = __webpack_require__(267).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var dP = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(23);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(51);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EcommerceProductTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successView */
/* unused harmony export failureView */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getEcommerceProductRequest:['data'],getEcommerceProductSuccess:['data'],getEcommerceProductFailure:['err'],viewEcommerceProductRequest:['data'],viewEcommerceProductSuccess:['data'],viewEcommerceProductFailure:['err'],createEcommerceProductRequest:['data'],createEcommerceProductSuccess:['data'],createEcommerceProductFailure:['err'],createEcommerceProductStockRequest:['data'],createEcommerceProductStockSuccess:['data'],createEcommerceProductStockFailure:['err'],updateEcommerceProductRequest:['data'],updateEcommerceProductSuccess:['data'],updateEcommerceProductFailure:['err'],deleteEcommerceProductRequest:['data'],deleteEcommerceProductSuccess:['data'],deleteEcommerceProductFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var EcommerceProductTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],data_view:{},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};var successView=function successView(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_view:data,err:null});};var failureView=function failureView(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err,data_view:{}});};// we've had a problem logging in
var failure=function failure(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref5){var data=_ref5.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref6){var err=_ref6.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_ECOMMERCE_PRODUCT_SUCCESS,success),_defineProperty(_createReducer,Types.GET_ECOMMERCE_PRODUCT_REQUEST,request),_defineProperty(_createReducer,Types.GET_ECOMMERCE_PRODUCT_FAILURE,failure),_defineProperty(_createReducer,Types.VIEW_ECOMMERCE_PRODUCT_SUCCESS,successView),_defineProperty(_createReducer,Types.VIEW_ECOMMERCE_PRODUCT_REQUEST,request),_defineProperty(_createReducer,Types.VIEW_ECOMMERCE_PRODUCT_FAILURE,failureView),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_FAILURE,failure),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_STOCK_SUCCESS,success),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_STOCK_REQUEST,request),_defineProperty(_createReducer,Types.CREATE_ECOMMERCE_PRODUCT_STOCK_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_ECOMMERCE_PRODUCT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_ECOMMERCE_PRODUCT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_ECOMMERCE_PRODUCT_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_PRODUCT_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_PRODUCT_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_PRODUCT_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(476);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(514);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    getRawTag = __webpack_require__(537),
    objectToString = __webpack_require__(538);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */
module.exports = _curry2(function max(a, b) { return b > a ? b : a; });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var curryN = __webpack_require__(40);


/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */
module.exports = _curry1(function curry(fn) {
  return curryN(fn.length, fn);
});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */
module.exports = _curry2(function path(paths, obj) {
  var val = obj;
  var idx = 0;
  while (idx < paths.length) {
    if (val == null) {
      return;
    }
    val = val[paths[idx]];
    idx += 1;
  }
  return val;
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(745),
    getValue = __webpack_require__(748);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(260);

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopularAttractionTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export changeRequest */
/* unused harmony export changeSuccess */
/* unused harmony export failure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({popularAttractionRequest:['data'],popularAttractionSuccess:['data'],popularAttractionFailure:['err'],popularAttractionSaveRequest:['data'],popularAttractionSaveSuccess:['data'],popularAttractionSaveFailure:['err'],popularAttractionDeleteRequest:['data'],popularAttractionDeleteSuccess:['data'],popularAttractionDeleteFailure:['err'],popularAttractionEditRequest:['data'],popularAttractionEditSuccess:['data'],popularAttractionEditFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var PopularAttractionTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,processing:false,data:[],err:null,success:false});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null,success:false});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,processing:false,data:data,err:null});};var changeRequest=function changeRequest(state){return state.merge({processing:true,err:null,success:false});};var changeSuccess=function changeSuccess(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,processing:false,err:null,success:true});};var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_REQUEST,request),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_SUCCESS,success),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_FAILURE,failure),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_SAVE_REQUEST,changeRequest),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_SAVE_SUCCESS,changeSuccess),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_SAVE_FAILURE,failure),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_DELETE_REQUEST,changeRequest),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_DELETE_SUCCESS,changeSuccess),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_DELETE_FAILURE,failure),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_EDIT_REQUEST,changeRequest),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_EDIT_SUCCESS,changeSuccess),_defineProperty(_createReducer,Types.POPULAR_ATTRACTION_EDIT_FAILURE,failure),_createReducer));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(864);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tooltip__ = __webpack_require__(199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
EllipsisModal - Modal based text viewer
@author Arsena 'senndbx', 2019

Format:
  <EllipsisModal type={} descriptor={} name={} description={} />

Props used:
  - type: 'string', 'html', 'array'. Will be used to determine how description will be rendered.
  - descriptor: string, will be used as button name (if any)
  - name: string, will be used as a modal title (if any)
  - description: data type varies. Will be used to render data inside modal.
  - for array description will be rendered as an unordered list, with properties as follows:
    - label: descriptive, on top of description box
    - content: placed inside the description box

@todo:
  - deprecate button, and replace integrate with ellipsis
  - expand Types, so it can handle more datatype
  - make passing props into this component be able to refer to some local JSON file
  - make style object
*/var EllipsisModal=function(_React$Component){_inherits(EllipsisModal,_React$Component);function EllipsisModal(props){_classCallCheck(this,EllipsisModal);var _this=_possibleConstructorReturn(this,(EllipsisModal.__proto__||Object.getPrototypeOf(EllipsisModal)).call(this,props));_initialiseProps.call(_this);_this.state={showModal:false,style:{width:'40vw'}};return _this;}_createClass(EllipsisModal,[{key:'render',value:function render(){var _props=this.props,description=_props.description,type=_props.type,descriptor=_props.descriptor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,this._renderField(description,type,descriptor),this._renderModal(this.state.showModal));}}]);return EllipsisModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this2=this;this._toggleModal=function(showModal){_this2.setState({showModal:showModal});};this._renderField=function(description,type,descriptor){if(description===null||description===''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye-slash'});}else{switch(type){case'array':case'HTML':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary',onClick:function onClick(){return _this2._toggleModal(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'text-center','data-tip':'Click to view '+descriptor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tooltip__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}),' ',descriptor);case'string':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(){return _this2._toggleModal(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'text-center','data-tip':'Click to view '+descriptor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tooltip__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis___default.a,{text:description,maxLine:'1',ellipsis:'...',trimRight:true,basedOn:'letters'})));default:return null;}}};this._renderModal=function(props){var _props2=_this2.props,type=_props2.type,name=_props2.name,description=_props2.description,descriptor=_props2.descriptor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:props,onClose:function onClose(){return _this2._toggleModal(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:_this2.state.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},descriptor)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},name),_this2._renderContent(type,description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2 mt-2',onClick:function onClick(){return _this2._toggleModal(false);}},'Close'))));};this._renderContent=function(type,description){switch(type){case'string':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{readOnly:true,style:{minHeight:'40vh'},className:'form-control',value:description});case'HTML':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:description}});case'array':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,description.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,item.label||'',' ',item.content||''));}));default:return null;}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(EllipsisModal));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(25).f;
var has = __webpack_require__(49);
var TAG = __webpack_require__(21)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(79);
var fails = __webpack_require__(15);
var spaces = __webpack_require__(272);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(449);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* unused harmony export takeEvery */
/* harmony export (immutable) */ __webpack_exports__["i"] = takeLatest;
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(452);



var IO = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var eff = fork.apply(undefined, [fn].concat(args));
  eff[FORK].detached = true;
  return eff;
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: createAsEffectType(TAKE),
  put: createAsEffectType(PUT),
  all: createAsEffectType(ALL),
  race: createAsEffectType(RACE),
  call: createAsEffectType(CALL),
  cps: createAsEffectType(CPS),
  fork: createAsEffectType(FORK),
  join: createAsEffectType(JOIN),
  cancel: createAsEffectType(CANCEL),
  select: createAsEffectType(SELECT),
  actionChannel: createAsEffectType(ACTION_CHANNEL),
  cancelled: createAsEffectType(CANCELLED),
  flush: createAsEffectType(FLUSH),
  getContext: createAsEffectType(GET_CONTEXT),
  setContext: createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(546),
    baseKeys = __webpack_require__(553),
    isArrayLike = __webpack_require__(228);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var map = __webpack_require__(45);
var prop = __webpack_require__(175);


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */
module.exports = _curry2(function pluck(p, list) {
  return map(prop(p), list);
});


/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var _isArray = __webpack_require__(93);


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
module.exports = function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
      fn.apply(this, arguments) :
      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _toString = __webpack_require__(582);


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
module.exports = _curry1(function toString(val) { return _toString(val, []); });


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isString = __webpack_require__(146);


/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */
module.exports = _curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _identity = __webpack_require__(251);


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */
module.exports = _curry1(_identity);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isFunction = __webpack_require__(179);
var curryN = __webpack_require__(40);
var toString = __webpack_require__(148);


/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */
module.exports = _curry2(function invoker(arity, method) {
  return curryN(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString(target) + ' does not have a method named "' + method + '"');
  });
});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function(root, undefined) {

	/* --- Setup --- */

	// Create the local library object, to be exported or referenced globally later
	var lib = {};

	// Current version
	lib.version = '0.4.1';


	/* --- Exposed settings --- */

	// The library's settings configuration object. Contains default parameters for
	// currency and number formatting
	lib.settings = {
		currency: {
			symbol : "$",		// default currency symbol is '$'
			format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
			decimal : ".",		// decimal point separator
			thousand : ",",		// thousands separator
			precision : 2,		// decimal places
			grouping : 3		// digit grouping (not implemented yet)
		},
		number: {
			precision : 0,		// default precision on numbers is 0
			grouping : 3,		// digit grouping (not implemented yet)
			thousand : ",",
			decimal : "."
		}
	};


	/* --- Internal Helper Methods --- */

	// Store reference to possibly-available ECMAScript 5 methods for later
	var nativeMap = Array.prototype.map,
		nativeIsArray = Array.isArray,
		toString = Object.prototype.toString;

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js
	 */
	function isString(obj) {
		return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
	}

	/**
	 * Tests whether supplied parameter is a string
	 * from underscore.js, delegates to ECMA5's native Array.isArray
	 */
	function isArray(obj) {
		return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
	}

	/**
	 * Tests whether supplied parameter is a true object
	 */
	function isObject(obj) {
		return obj && toString.call(obj) === '[object Object]';
	}

	/**
	 * Extends an object with a defaults object, similar to underscore's _.defaults
	 *
	 * Used for abstracting parameter handling from API methods
	 */
	function defaults(object, defs) {
		var key;
		object = object || {};
		defs = defs || {};
		// Iterate over object non-prototype properties:
		for (key in defs) {
			if (defs.hasOwnProperty(key)) {
				// Replace values with defaults only if undefined (allow empty/zero values):
				if (object[key] == null) object[key] = defs[key];
			}
		}
		return object;
	}

	/**
	 * Implementation of `Array.map()` for iteration loops
	 *
	 * Returns a new Array as a result of calling `iterator` on each array value.
	 * Defers to native Array.map if available
	 */
	function map(obj, iterator, context) {
		var results = [], i, j;

		if (!obj) return results;

		// Use native .map method if it exists:
		if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

		// Fallback for native .map:
		for (i = 0, j = obj.length; i < j; i++ ) {
			results[i] = iterator.call(context, obj[i], i, obj);
		}
		return results;
	}

	/**
	 * Check and normalise the value of precision (must be positive integer)
	 */
	function checkPrecision(val, base) {
		val = Math.round(Math.abs(val));
		return isNaN(val)? base : val;
	}


	/**
	 * Parses a format string or object and returns format obj for use in rendering
	 *
	 * `format` is either a string with the default (positive) format, or object
	 * containing `pos` (required), `neg` and `zero` values (or a function returning
	 * either a string or object)
	 *
	 * Either string or format.pos must contain "%v" (value) to be valid
	 */
	function checkCurrencyFormat(format) {
		var defaults = lib.settings.currency.format;

		// Allow function as format parameter (should return string or object):
		if ( typeof format === "function" ) format = format();

		// Format can be a string, in which case `value` ("%v") must be present:
		if ( isString( format ) && format.match("%v") ) {

			// Create and return positive, negative and zero formats:
			return {
				pos : format,
				neg : format.replace("-", "").replace("%v", "-%v"),
				zero : format
			};

		// If no format, or object is missing valid positive value, use defaults:
		} else if ( !format || !format.pos || !format.pos.match("%v") ) {

			// If defaults is a string, casts it to an object for faster checking next time:
			return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
				pos : defaults,
				neg : defaults.replace("%v", "-%v"),
				zero : defaults
			};

		}
		// Otherwise, assume format was fine:
		return format;
	}


	/* --- API Methods --- */

	/**
	 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
	 * Alias: `accounting.parse(string)`
	 *
	 * Decimal must be included in the regular expression to match floats (defaults to
	 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
	 * separator, provide it as the second argument.
	 *
	 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
	 *
	 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
	 */
	var unformat = lib.unformat = lib.parse = function(value, decimal) {
		// Recursively unformat arrays:
		if (isArray(value)) {
			return map(value, function(val) {
				return unformat(val, decimal);
			});
		}

		// Fails silently (need decent errors):
		value = value || 0;

		// Return the value as-is if it's already a number:
		if (typeof value === "number") return value;

		// Default decimal point comes from settings, but could be set to eg. "," in opts:
		decimal = decimal || lib.settings.number.decimal;

		 // Build regex to strip out everything except digits, decimal point and minus sign:
		var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
			unformatted = parseFloat(
				("" + value)
				.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
				.replace(regex, '')         // strip out any cruft
				.replace(decimal, '.')      // make sure decimal point is standard
			);

		// This will fail silently which may cause trouble, let's wait and see:
		return !isNaN(unformatted) ? unformatted : 0;
	};


	/**
	 * Implementation of toFixed() that treats floats more like decimals
	 *
	 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
	 * problems for accounting- and finance-related software.
	 */
	var toFixed = lib.toFixed = function(value, precision) {
		precision = checkPrecision(precision, lib.settings.number.precision);
		var power = Math.pow(10, precision);

		// Multiply up by precision, round accurately, then divide and use native toFixed():
		return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
	};


	/**
	 * Format a number, with comma-separated thousands and custom precision/decimal places
	 * Alias: `accounting.format()`
	 *
	 * Localise by overriding the precision and thousand / decimal separators
	 * 2nd parameter `precision` can be an object matching `settings.number`
	 */
	var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val) {
				return formatNumber(val, precision, thousand, decimal);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(precision) ? precision : {
					precision : precision,
					thousand : thousand,
					decimal : decimal
				}),
				lib.settings.number
			),

			// Clean up precision
			usePrecision = checkPrecision(opts.precision),

			// Do some calc:
			negative = number < 0 ? "-" : "",
			base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
			mod = base.length > 3 ? base.length % 3 : 0;

		// Format the number:
		return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
	};


	/**
	 * Format a number into currency
	 *
	 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
	 * defaults: (0, "$", 2, ",", ".", "%s%v")
	 *
	 * Localise by overriding the symbol, precision, thousand / decimal separators and format
	 * Second param can be an object matching `settings.currency` which is the easiest way.
	 *
	 * To do: tidy up the parameters
	 */
	var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
		// Resursively format arrays:
		if (isArray(number)) {
			return map(number, function(val){
				return formatMoney(val, symbol, precision, thousand, decimal, format);
			});
		}

		// Clean up number:
		number = unformat(number);

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero):
			formats = checkCurrencyFormat(opts.format),

			// Choose which format to use for this value:
			useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

		// Return with currency symbol added:
		return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	};


	/**
	 * Format a list of numbers into an accounting column, padding with whitespace
	 * to line up currency symbols, thousand separators and decimals places
	 *
	 * List should be an array of numbers
	 * Second parameter can be an object containing keys that match the params
	 *
	 * Returns array of accouting-formatted number strings of same length
	 *
	 * NB: `white-space:pre` CSS rule is required on the list container to prevent
	 * browsers from collapsing the whitespace in the output strings.
	 */
	lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
		if (!list) return [];

		// Build options object from second param (if object) or all params, extending defaults:
		var opts = defaults(
				(isObject(symbol) ? symbol : {
					symbol : symbol,
					precision : precision,
					thousand : thousand,
					decimal : decimal,
					format : format
				}),
				lib.settings.currency
			),

			// Check format (returns object with pos, neg and zero), only need pos for now:
			formats = checkCurrencyFormat(opts.format),

			// Whether to pad at start of string or after currency symbol:
			padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

			// Store value for the length of the longest string in the column:
			maxLength = 0,

			// Format the list according to options, store the length of the longest string:
			formatted = map(list, function(val, i) {
				if (isArray(val)) {
					// Recursively format columns if list is a multi-dimensional array:
					return lib.formatColumn(val, opts);
				} else {
					// Clean up the value
					val = unformat(val);

					// Choose which format to use for this value (pos, neg or zero):
					var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

						// Format this value, push into formatted list and save the length:
						fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

					if (fVal.length > maxLength) maxLength = fVal.length;
					return fVal;
				}
			});

		// Pad each number in the list and send back the column of numbers:
		return map(formatted, function(val, i) {
			// Only if this is a string (not a nested array, which would have already been padded):
			if (isString(val) && val.length < maxLength) {
				// Depending on symbol position, pad after symbol or at index 0:
				return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
			}
			return val;
		});
	};


	/* --- Module Definition --- */

	// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
	// Otherwise, just add `accounting` to the global object
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			exports = module.exports = lib;
		}
		exports.accounting = lib;
	} else if (typeof define === 'function' && define.amd) {
		// Return the library as an AMD module:
		define([], function() {
			return lib;
		});
	} else {
		// Use accounting.noConflict to restore `accounting` back to its original value.
		// Returns a reference to the library's `accounting` object;
		// e.g. `var numbers = accounting.noConflict();`
		lib.noConflict = (function(oldAccounting) {
			return function() {
				// Reset the value of the root's `accounting` variable:
				root.accounting = oldAccounting;
				// Delete the noConflict method:
				lib.noConflict = undefined;
				// Return reference to the library to re-assign it:
				return lib;
			};
		})(root.accounting);

		// Declare `fx` on the root (global/window) object:
		root['accounting'] = lib;
	}

	// Root will be `window` in browser or `global` on the server:
}(this));


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({reviewListRequest:['filter'],reviewListSuccess:['data'],reviewListFailure:['err'],reviewApproveRequest:['id'],reviewApproveSuccess:null,reviewApproveFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var ReviewTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:{list:[]},err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,success:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.REVIEW_LIST_SUCCESS,success),_defineProperty(_createReducer,Types.REVIEW_LIST_REQUEST,request),_defineProperty(_createReducer,Types.REVIEW_LIST_FAILURE,failure),_defineProperty(_createReducer,Types.REVIEW_APPROVE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.REVIEW_APPROVE_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.REVIEW_APPROVE_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(43);
var global = __webpack_require__(12);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(100) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(69);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(102);
var ITERATOR = __webpack_require__(21)('iterator');
var Iterators = __webpack_require__(121);
module.exports = __webpack_require__(43).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(7);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(37);
var SPECIES = __webpack_require__(21)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocationTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateProvinceSuccess */
/* unused harmony export manipulateCitySuccess */
/* unused harmony export manipulateDistrictSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getProvinceRequest:['data'],getProvinceSuccess:['data'],getProvinceFailure:['err'],getCityRequest:['data'],getCitySuccess:['data'],getCityFailure:['err'],getDistrictRequest:['data'],getDistrictSuccess:['data'],getDistrictFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var LocationTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,province:[],city:[],district:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateProvinceSuccess=function manipulateProvinceSuccess(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,processing:false,province:data,success:true,err:null});};var manipulateCitySuccess=function manipulateCitySuccess(state,_ref4){var data=_ref4.data;return state.merge({fetching:false,processing:false,city:data,success:true,err:null});};var manipulateDistrictSuccess=function manipulateDistrictSuccess(state,_ref5){var data=_ref5.data;return state.merge({fetching:false,processing:false,district:data,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref6){var err=_ref6.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_PROVINCE_SUCCESS,manipulateProvinceSuccess),_defineProperty(_createReducer,Types.GET_PROVINCE_REQUEST,request),_defineProperty(_createReducer,Types.GET_PROVINCE_FAILURE,failure),_defineProperty(_createReducer,Types.GET_CITY_SUCCESS,manipulateCitySuccess),_defineProperty(_createReducer,Types.GET_CITY_REQUEST,request),_defineProperty(_createReducer,Types.GET_CITY_FAILURE,failure),_defineProperty(_createReducer,Types.GET_DISTRICT_SUCCESS,manipulateDistrictSuccess),_defineProperty(_createReducer,Types.GET_DISTRICT_REQUEST,request),_defineProperty(_createReducer,Types.GET_DISTRICT_FAILURE,failure),_createReducer));

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EcommerceOrderTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successShipping */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getEcommerceOrderRequest:['filter'],getEcommerceOrderSuccess:['data'],getEcommerceOrderFailure:['err'],getEcommerceOrderShippingRequest:['data'],getEcommerceOrderShippingSuccess:['data'],getEcommerceOrderShippingFailure:['err'],postEcommerceOrderShippingRequest:['data'],postEcommerceOrderShippingSuccess:['data'],postEcommerceOrderShippingFailure:['err'],putEcommerceOrderShippingRequest:['data'],putEcommerceOrderShippingSuccess:['data'],putEcommerceOrderShippingFailure:['err'],deleteEcommerceOrderShippingRequest:['data'],deleteEcommerceOrderShippingSuccess:['data'],deleteEcommerceOrderShippingFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var EcommerceOrderTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,DATA_DETAIL:{},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,err:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var successShipping=function successShipping(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,DATA_DETAIL:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref3){var err=_ref3.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref5){var err=_ref5.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_SUCCESS,success),_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_REQUEST,request),_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_FAILURE,failure),_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_SHIPPING_SUCCESS,successShipping),_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_SHIPPING_REQUEST,request),_defineProperty(_createReducer,Types.GET_ECOMMERCE_ORDER_SHIPPING_FAILURE,failure),_defineProperty(_createReducer,Types.POST_ECOMMERCE_ORDER_SHIPPING_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.POST_ECOMMERCE_ORDER_SHIPPING_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.POST_ECOMMERCE_ORDER_SHIPPING_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.PUT_ECOMMERCE_ORDER_SHIPPING_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_ECOMMERCE_ORDER_SHIPPING_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_ECOMMERCE_ORDER_SHIPPING_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_ORDER_SHIPPING_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_ORDER_SHIPPING_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_ECOMMERCE_ORDER_SHIPPING_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PrecisionRound=function PrecisionRound(number){var precision=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var factor=Math.pow(10,precision);return Math.round(number*factor)/factor;};/* harmony default export */ __webpack_exports__["a"] = (PrecisionRound);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromoSectionTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getPromoSectionRequest:['data'],getPromoSectionSuccess:['data'],getPromoSectionFailure:['err'],updatePromoSectionRequest:['data'],updatePromoSectionSuccess:['data'],updatePromoSectionFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var PromoSectionTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:{},err:null,processing:false,success:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true,success:null});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref3){var data=_ref3.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref4){var err=_ref4.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_PROMO_SECTION_SUCCESS,success),_defineProperty(_createReducer,Types.GET_PROMO_SECTION_REQUEST,request),_defineProperty(_createReducer,Types.GET_PROMO_SECTION_FAILURE,failure),_defineProperty(_createReducer,Types.UPDATE_PROMO_SECTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.UPDATE_PROMO_SECTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.UPDATE_PROMO_SECTION_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REHYDRATE; });
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var require;var require;/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.localforage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw (f.code="MODULE_NOT_FOUND", f)}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
'use strict';
var immediate = _dereq_(1);

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && (typeof obj === 'object' || typeof obj === 'function') && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"1":1}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';
if (typeof global.Promise !== 'function') {
  global.Promise = _dereq_(2);
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"2":2}],4:[function(_dereq_,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function getIDB() {
    /* global indexedDB,webkitIndexedDB,mozIndexedDB,OIndexedDB,msIndexedDB */
    try {
        if (typeof indexedDB !== 'undefined') {
            return indexedDB;
        }
        if (typeof webkitIndexedDB !== 'undefined') {
            return webkitIndexedDB;
        }
        if (typeof mozIndexedDB !== 'undefined') {
            return mozIndexedDB;
        }
        if (typeof OIndexedDB !== 'undefined') {
            return OIndexedDB;
        }
        if (typeof msIndexedDB !== 'undefined') {
            return msIndexedDB;
        }
    } catch (e) {
        return;
    }
}

var idb = getIDB();

function isIndexedDBValid() {
    try {
        // Initialize IndexedDB; fall back to vendor-prefixed versions
        // if needed.
        if (!idb || !idb.open) {
            return false;
        }
        // We mimic PouchDB here;
        //
        // We test for openDatabase because IE Mobile identifies itself
        // as Safari. Oh the lulz...
        var isSafari = typeof openDatabase !== 'undefined' && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);

        var hasFetch = typeof fetch === 'function' && fetch.toString().indexOf('[native code') !== -1;

        // Safari <10.1 does not meet our requirements for IDB support
        // (see: https://github.com/pouchdb/pouchdb/issues/5572).
        // Safari 10.1 shipped with fetch, we can use that to detect it.
        // Note: this creates issues with `window.fetch` polyfills and
        // overrides; see:
        // https://github.com/localForage/localForage/issues/856
        return (!isSafari || hasFetch) && typeof indexedDB !== 'undefined' &&
        // some outdated implementations of IDB that appear on Samsung
        // and HTC Android devices <4.4 are missing IDBKeyRange
        // See: https://github.com/mozilla/localForage/issues/128
        // See: https://github.com/mozilla/localForage/issues/272
        typeof IDBKeyRange !== 'undefined';
    } catch (e) {
        return false;
    }
}

// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor. (i.e.
// old QtWebKit versions, at least).
function createBlob(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== 'TypeError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
}

// This is CommonJS because lie is an external dependency, so Rollup
// can just ignore it.
if (typeof Promise === 'undefined') {
    // In the "nopromises" build this will just throw if you don't have
    // a global promise object, but it would throw anyway later.
    _dereq_(3);
}
var Promise$1 = Promise;

function executeCallback(promise, callback) {
    if (callback) {
        promise.then(function (result) {
            callback(null, result);
        }, function (error) {
            callback(error);
        });
    }
}

function executeTwoCallbacks(promise, callback, errorCallback) {
    if (typeof callback === 'function') {
        promise.then(callback);
    }

    if (typeof errorCallback === 'function') {
        promise["catch"](errorCallback);
    }
}

function normalizeKey(key) {
    // Cast the key to a string, as that's all we can set as a key.
    if (typeof key !== 'string') {
        console.warn(key + ' used as a key, but it is not a string.');
        key = String(key);
    }

    return key;
}

function getCallback() {
    if (arguments.length && typeof arguments[arguments.length - 1] === 'function') {
        return arguments[arguments.length - 1];
    }
}

// Some code originally from async_storage.js in
// [Gaia](https://github.com/mozilla-b2g/gaia).

var DETECT_BLOB_SUPPORT_STORE = 'local-forage-detect-blob-support';
var supportsBlobs = void 0;
var dbContexts = {};
var toString = Object.prototype.toString;

// Transaction Modes
var READ_ONLY = 'readonly';
var READ_WRITE = 'readwrite';

// Transform a binary string to an array buffer, because otherwise
// weird stuff happens when you try to work with the binary string directly.
// It is known.
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function _binStringToArrayBuffer(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
    }
    return buf;
}

//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37 and Android <5. In those versions, storing a blob will throw.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
// Code borrowed from PouchDB. See:
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-adapter-idb/src/blobSupport.js
//
function _checkBlobSupportWithoutCaching(idb) {
    return new Promise$1(function (resolve) {
        var txn = idb.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
        var blob = createBlob(['']);
        txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, 'key');

        txn.onabort = function (e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };

        txn.oncomplete = function () {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
    })["catch"](function () {
        return false; // error, so assume unsupported
    });
}

function _checkBlobSupport(idb) {
    if (typeof supportsBlobs === 'boolean') {
        return Promise$1.resolve(supportsBlobs);
    }
    return _checkBlobSupportWithoutCaching(idb).then(function (value) {
        supportsBlobs = value;
        return supportsBlobs;
    });
}

function _deferReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Create a deferred object representing the current database operation.
    var deferredOperation = {};

    deferredOperation.promise = new Promise$1(function (resolve, reject) {
        deferredOperation.resolve = resolve;
        deferredOperation.reject = reject;
    });

    // Enqueue the deferred operation.
    dbContext.deferredOperations.push(deferredOperation);

    // Chain its promise to the database readiness.
    if (!dbContext.dbReady) {
        dbContext.dbReady = deferredOperation.promise;
    } else {
        dbContext.dbReady = dbContext.dbReady.then(function () {
            return deferredOperation.promise;
        });
    }
}

function _advanceReadiness(dbInfo) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Resolve its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.resolve();
        return deferredOperation.promise;
    }
}

function _rejectReadiness(dbInfo, err) {
    var dbContext = dbContexts[dbInfo.name];

    // Dequeue a deferred operation.
    var deferredOperation = dbContext.deferredOperations.pop();

    // Reject its promise (which is part of the database readiness
    // chain of promises).
    if (deferredOperation) {
        deferredOperation.reject(err);
        return deferredOperation.promise;
    }
}

function _getConnection(dbInfo, upgradeNeeded) {
    return new Promise$1(function (resolve, reject) {
        dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();

        if (dbInfo.db) {
            if (upgradeNeeded) {
                _deferReadiness(dbInfo);
                dbInfo.db.close();
            } else {
                return resolve(dbInfo.db);
            }
        }

        var dbArgs = [dbInfo.name];

        if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
        }

        var openreq = idb.open.apply(idb, dbArgs);

        if (upgradeNeeded) {
            openreq.onupgradeneeded = function (e) {
                var db = openreq.result;
                try {
                    db.createObjectStore(dbInfo.storeName);
                    if (e.oldVersion <= 1) {
                        // Added when support for blob shims was added
                        db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                    }
                } catch (ex) {
                    if (ex.name === 'ConstraintError') {
                        console.warn('The database "' + dbInfo.name + '"' + ' has been upgraded from version ' + e.oldVersion + ' to version ' + e.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                    } else {
                        throw ex;
                    }
                }
            };
        }

        openreq.onerror = function (e) {
            e.preventDefault();
            reject(openreq.error);
        };

        openreq.onsuccess = function () {
            var db = openreq.result;
            db.onversionchange = function (e) {
                // Triggered when the database is modified (e.g. adding an objectStore) or
                // deleted (even when initiated by other sessions in different tabs).
                // Closing the connection here prevents those operations from being blocked.
                // If the database is accessed again later by this instance, the connection
                // will be reopened or the database recreated as needed.
                e.target.close();
            };
            resolve(db);
            _advanceReadiness(dbInfo);
        };
    });
}

function _getOriginalConnection(dbInfo) {
    return _getConnection(dbInfo, false);
}

function _getUpgradedConnection(dbInfo) {
    return _getConnection(dbInfo, true);
}

function _isUpgradeNeeded(dbInfo, defaultVersion) {
    if (!dbInfo.db) {
        return true;
    }

    var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
    var isDowngrade = dbInfo.version < dbInfo.db.version;
    var isUpgrade = dbInfo.version > dbInfo.db.version;

    if (isDowngrade) {
        // If the version is not the default one
        // then warn for impossible downgrade.
        if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + '"' + " can't be downgraded from version " + dbInfo.db.version + ' to version ' + dbInfo.version + '.');
        }
        // Align the versions to prevent errors.
        dbInfo.version = dbInfo.db.version;
    }

    if (isUpgrade || isNewStore) {
        // If the store is new then increment the version (if needed).
        // This will trigger an "upgradeneeded" event which is required
        // for creating a store.
        if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
                dbInfo.version = incVersion;
            }
        }

        return true;
    }

    return false;
}

// encode a blob for indexeddb engines that don't support blobs
function _encodeBlob(blob) {
    return new Promise$1(function (resolve, reject) {
        var reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = function (e) {
            var base64 = btoa(e.target.result || '');
            resolve({
                __local_forage_encoded_blob: true,
                data: base64,
                type: blob.type
            });
        };
        reader.readAsBinaryString(blob);
    });
}

// decode an encoded blob
function _decodeBlob(encodedBlob) {
    var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
    return createBlob([arrayBuff], { type: encodedBlob.type });
}

// is this one of our fancy encoded blobs?
function _isEncodedBlob(value) {
    return value && value.__local_forage_encoded_blob;
}

// Specialize the default `ready()` function by making it dependent
// on the current database operations. Thus, the driver will be actually
// ready when it's been initialized (default) *and* there are no pending
// operations on the database (initiated by some other instances).
function _fullyReady(callback) {
    var self = this;

    var promise = self._initReady().then(function () {
        var dbContext = dbContexts[self._dbInfo.name];

        if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
        }
    });

    executeTwoCallbacks(promise, callback, callback);
    return promise;
}

// Try to establish a new db connection to replace the
// current one which is broken (i.e. experiencing
// InvalidStateError while creating a transaction).
function _tryReconnect(dbInfo) {
    _deferReadiness(dbInfo);

    var dbContext = dbContexts[dbInfo.name];
    var forages = dbContext.forages;

    for (var i = 0; i < forages.length; i++) {
        var forage = forages[i];
        if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
        }
    }
    dbInfo.db = null;

    return _getOriginalConnection(dbInfo).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        // store the latest db reference
        // in case the db was upgraded
        dbInfo.db = dbContext.db = db;
        for (var i = 0; i < forages.length; i++) {
            forages[i]._dbInfo.db = db;
        }
    })["catch"](function (err) {
        _rejectReadiness(dbInfo, err);
        throw err;
    });
}

// FF doesn't like Promises (micro-tasks) and IDDB store operations,
// so we have to do it with callbacks
function createTransaction(dbInfo, mode, callback, retries) {
    if (retries === undefined) {
        retries = 1;
    }

    try {
        var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
        callback(null, tx);
    } catch (err) {
        if (retries > 0 && (!dbInfo.db || err.name === 'InvalidStateError' || err.name === 'NotFoundError')) {
            return Promise$1.resolve().then(function () {
                if (!dbInfo.db || err.name === 'NotFoundError' && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                    // increase the db version, to create the new ObjectStore
                    if (dbInfo.db) {
                        dbInfo.version = dbInfo.db.version + 1;
                    }
                    // Reopen the database for upgrading.
                    return _getUpgradedConnection(dbInfo);
                }
            }).then(function () {
                return _tryReconnect(dbInfo).then(function () {
                    createTransaction(dbInfo, mode, callback, retries - 1);
                });
            })["catch"](callback);
        }

        callback(err);
    }
}

function createDbContext() {
    return {
        // Running localForages sharing a database.
        forages: [],
        // Shared database.
        db: null,
        // Database readiness (promise).
        dbReady: null,
        // Deferred operations on the database.
        deferredOperations: []
    };
}

// Open the IndexedDB database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    // Get the current context of the database;
    var dbContext = dbContexts[dbInfo.name];

    // ...or create a new context.
    if (!dbContext) {
        dbContext = createDbContext();
        // Register the new context in the global container.
        dbContexts[dbInfo.name] = dbContext;
    }

    // Register itself as a running localForage in the current context.
    dbContext.forages.push(self);

    // Replace the default `ready()` function with the specialized one.
    if (!self._initReady) {
        self._initReady = self.ready;
        self.ready = _fullyReady;
    }

    // Create an array of initialization states of the related localForages.
    var initPromises = [];

    function ignoreErrors() {
        // Don't handle errors here,
        // just makes sure related localForages aren't pending.
        return Promise$1.resolve();
    }

    for (var j = 0; j < dbContext.forages.length; j++) {
        var forage = dbContext.forages[j];
        if (forage !== self) {
            // Don't wait for itself...
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
        }
    }

    // Take a snapshot of the related localForages.
    var forages = dbContext.forages.slice(0);

    // Initialize the connection process only when
    // all the related localForages aren't pending.
    return Promise$1.all(initPromises).then(function () {
        dbInfo.db = dbContext.db;
        // Get the connection or open a new one without upgrade.
        return _getOriginalConnection(dbInfo);
    }).then(function (db) {
        dbInfo.db = db;
        if (_isUpgradeNeeded(dbInfo, self._defaultConfig.version)) {
            // Reopen the database for upgrading.
            return _getUpgradedConnection(dbInfo);
        }
        return db;
    }).then(function (db) {
        dbInfo.db = dbContext.db = db;
        self._dbInfo = dbInfo;
        // Share the final connection amongst related localForages.
        for (var k = 0; k < forages.length; k++) {
            var forage = forages[k];
            if (forage !== self) {
                // Self is already up-to-date.
                forage._dbInfo.db = dbInfo.db;
                forage._dbInfo.version = dbInfo.version;
            }
        }
    });
}

function getItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.get(key);

                    req.onsuccess = function () {
                        var value = req.result;
                        if (value === undefined) {
                            value = null;
                        }
                        if (_isEncodedBlob(value)) {
                            value = _decodeBlob(value);
                        }
                        resolve(value);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items stored in database.
function iterate(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openCursor();
                    var iterationNumber = 1;

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (cursor) {
                            var value = cursor.value;
                            if (_isEncodedBlob(value)) {
                                value = _decodeBlob(value);
                            }
                            var result = iterator(value, cursor.key, iterationNumber++);

                            // when the iterator callback returns any
                            // (non-`undefined`) value, then we stop
                            // the iteration immediately
                            if (result !== void 0) {
                                resolve(result);
                            } else {
                                cursor["continue"]();
                            }
                        } else {
                            resolve();
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);

    return promise;
}

function setItem(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        var dbInfo;
        self.ready().then(function () {
            dbInfo = self._dbInfo;
            if (toString.call(value) === '[object Blob]') {
                return _checkBlobSupport(dbInfo.db).then(function (blobSupport) {
                    if (blobSupport) {
                        return value;
                    }
                    return _encodeBlob(value);
                });
            }
            return value;
        }).then(function (value) {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);

                    // The reason we don't _save_ null is because IE 10 does
                    // not support saving the `null` type in IndexedDB. How
                    // ironic, given the bug below!
                    // See: https://github.com/mozilla/localForage/issues/161
                    if (value === null) {
                        value = undefined;
                    }

                    var req = store.put(value, key);

                    transaction.oncomplete = function () {
                        // Cast to undefined so the value passed to
                        // callback/promise is the same as what one would get out
                        // of `getItem()` later. This leads to some weirdness
                        // (setItem('foo', undefined) will return `null`), but
                        // it's not my fault localStorage is our baseline and that
                        // it's weird.
                        if (value === undefined) {
                            value = null;
                        }

                        resolve(value);
                    };
                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function removeItem(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    // We use a Grunt task to make this safe for IE and some
                    // versions of Android (including those used by Cordova).
                    // Normally IE won't like `.delete()` and will insist on
                    // using `['delete']()`, but we have a build step that
                    // fixes this for us now.
                    var req = store["delete"](key);
                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onerror = function () {
                        reject(req.error);
                    };

                    // The request will be also be aborted if we've exceeded our storage
                    // space.
                    transaction.onabort = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function clear(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_WRITE, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.clear();

                    transaction.oncomplete = function () {
                        resolve();
                    };

                    transaction.onabort = transaction.onerror = function () {
                        var err = req.error ? req.error : req.transaction.error;
                        reject(err);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function length(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.count();

                    req.onsuccess = function () {
                        resolve(req.result);
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function key(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        if (n < 0) {
            resolve(null);

            return;
        }

        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var advanced = false;
                    var req = store.openKeyCursor();

                    req.onsuccess = function () {
                        var cursor = req.result;
                        if (!cursor) {
                            // this means there weren't enough keys
                            resolve(null);

                            return;
                        }

                        if (n === 0) {
                            // We have the first key, return it if that's what they
                            // wanted.
                            resolve(cursor.key);
                        } else {
                            if (!advanced) {
                                // Otherwise, ask the cursor to skip ahead n
                                // records.
                                advanced = true;
                                cursor.advance(n);
                            } else {
                                // When we get here, we've got the nth key.
                                resolve(cursor.key);
                            }
                        }
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            createTransaction(self._dbInfo, READ_ONLY, function (err, transaction) {
                if (err) {
                    return reject(err);
                }

                try {
                    var store = transaction.objectStore(self._dbInfo.storeName);
                    var req = store.openKeyCursor();
                    var keys = [];

                    req.onsuccess = function () {
                        var cursor = req.result;

                        if (!cursor) {
                            resolve(keys);
                            return;
                        }

                        keys.push(cursor.key);
                        cursor["continue"]();
                    };

                    req.onerror = function () {
                        reject(req.error);
                    };
                } catch (e) {
                    reject(e);
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        var isCurrentDb = options.name === currentConfig.name && self._dbInfo.db;

        var dbPromise = isCurrentDb ? Promise$1.resolve(self._dbInfo.db) : _getOriginalConnection(options).then(function (db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
                forages[i]._dbInfo.db = db;
            }
            return db;
        });

        if (!options.storeName) {
            promise = dbPromise.then(function (db) {
                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                }

                var dropDBPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.deleteDatabase(options.name);

                    req.onerror = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        reject(req.error);
                    };

                    req.onblocked = function () {
                        // Closing all open connections in onversionchange handler should prevent this situation, but if
                        // we do get here, it just means the request remains pending - eventually it will succeed or error
                        console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        if (db) {
                            db.close();
                        }
                        resolve(db);
                    };
                });

                return dropDBPromise.then(function (db) {
                    dbContext.db = db;
                    for (var i = 0; i < forages.length; i++) {
                        var _forage = forages[i];
                        _advanceReadiness(_forage._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        } else {
            promise = dbPromise.then(function (db) {
                if (!db.objectStoreNames.contains(options.storeName)) {
                    return;
                }

                var newVersion = db.version + 1;

                _deferReadiness(options);

                var dbContext = dbContexts[options.name];
                var forages = dbContext.forages;

                db.close();
                for (var i = 0; i < forages.length; i++) {
                    var forage = forages[i];
                    forage._dbInfo.db = null;
                    forage._dbInfo.version = newVersion;
                }

                var dropObjectPromise = new Promise$1(function (resolve, reject) {
                    var req = idb.open(options.name, newVersion);

                    req.onerror = function (err) {
                        var db = req.result;
                        db.close();
                        reject(err);
                    };

                    req.onupgradeneeded = function () {
                        var db = req.result;
                        db.deleteObjectStore(options.storeName);
                    };

                    req.onsuccess = function () {
                        var db = req.result;
                        db.close();
                        resolve(db);
                    };
                });

                return dropObjectPromise.then(function (db) {
                    dbContext.db = db;
                    for (var j = 0; j < forages.length; j++) {
                        var _forage2 = forages[j];
                        _forage2._dbInfo.db = db;
                        _advanceReadiness(_forage2._dbInfo);
                    }
                })["catch"](function (err) {
                    (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function () {});
                    throw err;
                });
            });
        }
    }

    executeCallback(promise, callback);
    return promise;
}

var asyncStorage = {
    _driver: 'asyncStorage',
    _initStorage: _initStorage,
    _support: isIndexedDBValid(),
    iterate: iterate,
    getItem: getItem,
    setItem: setItem,
    removeItem: removeItem,
    clear: clear,
    length: length,
    key: key,
    keys: keys,
    dropInstance: dropInstance
};

function isWebSQLValid() {
    return typeof openDatabase === 'function';
}

// Sadly, the best way to save binary data in WebSQL/localStorage is serializing
// it to Base64, so this is how we store it to prevent very strange errors with less
// verbose ways of binary <-> string data storage.
var BASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

var BLOB_TYPE_PREFIX = '~~local_forage_type~';
var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;

var SERIALIZED_MARKER = '__lfsc__:';
var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;

// OMG the serializations!
var TYPE_ARRAYBUFFER = 'arbf';
var TYPE_BLOB = 'blob';
var TYPE_INT8ARRAY = 'si08';
var TYPE_UINT8ARRAY = 'ui08';
var TYPE_UINT8CLAMPEDARRAY = 'uic8';
var TYPE_INT16ARRAY = 'si16';
var TYPE_INT32ARRAY = 'si32';
var TYPE_UINT16ARRAY = 'ur16';
var TYPE_UINT32ARRAY = 'ui32';
var TYPE_FLOAT32ARRAY = 'fl32';
var TYPE_FLOAT64ARRAY = 'fl64';
var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;

var toString$1 = Object.prototype.toString;

function stringToBuffer(serializedString) {
    // Fill the string into a ArrayBuffer.
    var bufferLength = serializedString.length * 0.75;
    var len = serializedString.length;
    var i;
    var p = 0;
    var encoded1, encoded2, encoded3, encoded4;

    if (serializedString[serializedString.length - 1] === '=') {
        bufferLength--;
        if (serializedString[serializedString.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = new ArrayBuffer(bufferLength);
    var bytes = new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = BASE_CHARS.indexOf(serializedString[i]);
        encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
        encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
        encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);

        /*jslint bitwise: true */
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return buffer;
}

// Converts a buffer to a string to store, serialized, in the backend
// storage library.
function bufferToString(buffer) {
    // base64-arraybuffer
    var bytes = new Uint8Array(buffer);
    var base64String = '';
    var i;

    for (i = 0; i < bytes.length; i += 3) {
        /*jslint bitwise: true */
        base64String += BASE_CHARS[bytes[i] >> 2];
        base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64String += BASE_CHARS[bytes[i + 2] & 63];
    }

    if (bytes.length % 3 === 2) {
        base64String = base64String.substring(0, base64String.length - 1) + '=';
    } else if (bytes.length % 3 === 1) {
        base64String = base64String.substring(0, base64String.length - 2) + '==';
    }

    return base64String;
}

// Serialize a value, afterwards executing a callback (which usually
// instructs the `setItem()` callback/promise to be executed). This is how
// we store binary data with localStorage.
function serialize(value, callback) {
    var valueType = '';
    if (value) {
        valueType = toString$1.call(value);
    }

    // Cannot use `value instanceof ArrayBuffer` or such here, as these
    // checks fail when running the tests using casper.js...
    //
    // TODO: See why those tests fail and use a better solution.
    if (value && (valueType === '[object ArrayBuffer]' || value.buffer && toString$1.call(value.buffer) === '[object ArrayBuffer]')) {
        // Convert binary arrays to a string and prefix the string with
        // a special marker.
        var buffer;
        var marker = SERIALIZED_MARKER;

        if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
        } else {
            buffer = value.buffer;

            if (valueType === '[object Int8Array]') {
                marker += TYPE_INT8ARRAY;
            } else if (valueType === '[object Uint8Array]') {
                marker += TYPE_UINT8ARRAY;
            } else if (valueType === '[object Uint8ClampedArray]') {
                marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === '[object Int16Array]') {
                marker += TYPE_INT16ARRAY;
            } else if (valueType === '[object Uint16Array]') {
                marker += TYPE_UINT16ARRAY;
            } else if (valueType === '[object Int32Array]') {
                marker += TYPE_INT32ARRAY;
            } else if (valueType === '[object Uint32Array]') {
                marker += TYPE_UINT32ARRAY;
            } else if (valueType === '[object Float32Array]') {
                marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === '[object Float64Array]') {
                marker += TYPE_FLOAT64ARRAY;
            } else {
                callback(new Error('Failed to get type for BinaryArray'));
            }
        }

        callback(marker + bufferToString(buffer));
    } else if (valueType === '[object Blob]') {
        // Conver the blob to a binaryArray and then to a string.
        var fileReader = new FileReader();

        fileReader.onload = function () {
            // Backwards-compatible prefix for the blob type.
            var str = BLOB_TYPE_PREFIX + value.type + '~' + bufferToString(this.result);

            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
        };

        fileReader.readAsArrayBuffer(value);
    } else {
        try {
            callback(JSON.stringify(value));
        } catch (e) {
            console.error("Couldn't convert value into a JSON string: ", value);

            callback(null, e);
        }
    }
}

// Deserialize data we've inserted into a value column/field. We place
// special markers into our strings to mark them as encoded; this isn't
// as nice as a meta field, but it's the only sane thing we can do whilst
// keeping localStorage support intact.
//
// Oftentimes this will just deserialize JSON content, but if we have a
// special marker (SERIALIZED_MARKER, defined above), we will extract
// some kind of arraybuffer/binary data/typed array out of the string.
function deserialize(value) {
    // If we haven't marked this string as being specially serialized (i.e.
    // something other than serialized JSON), we can just return it and be
    // done with it.
    if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
        return JSON.parse(value);
    }

    // The following code deals with deserializing some kind of Blob or
    // TypedArray. First we separate out the type of data we're dealing
    // with from the data itself.
    var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
    var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);

    var blobType;
    // Backwards-compatible blob type serialization strategy.
    // DBs created with older versions of localForage will simply not have the blob type.
    if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
        var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
        blobType = matcher[1];
        serializedString = serializedString.substring(matcher[0].length);
    }
    var buffer = stringToBuffer(serializedString);

    // Return the right type based on the code/type set during
    // serialization.
    switch (type) {
        case TYPE_ARRAYBUFFER:
            return buffer;
        case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
        case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
        case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
        case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
        case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
        case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
        case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
        case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
        case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
        case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
        default:
            throw new Error('Unkown type: ' + type);
    }
}

var localforageSerializer = {
    serialize: serialize,
    deserialize: deserialize,
    stringToBuffer: stringToBuffer,
    bufferToString: bufferToString
};

/*
 * Includes code from:
 *
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */

function createDbTable(t, dbInfo, callback, errorCallback) {
    t.executeSql('CREATE TABLE IF NOT EXISTS ' + dbInfo.storeName + ' ' + '(id INTEGER PRIMARY KEY, key unique, value)', [], callback, errorCallback);
}

// Open the WebSQL database (automatically creates one if one didn't
// previously exist), using any options set in the config.
function _initStorage$1(options) {
    var self = this;
    var dbInfo = {
        db: null
    };

    if (options) {
        for (var i in options) {
            dbInfo[i] = typeof options[i] !== 'string' ? options[i].toString() : options[i];
        }
    }

    var dbInfoPromise = new Promise$1(function (resolve, reject) {
        // Open the database; the openDatabase API will automatically
        // create it for us if it doesn't exist.
        try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
        } catch (e) {
            return reject(e);
        }

        // Create our key/value table if it doesn't exist.
        dbInfo.db.transaction(function (t) {
            createDbTable(t, dbInfo, function () {
                self._dbInfo = dbInfo;
                resolve();
            }, function (t, error) {
                reject(error);
            });
        }, reject);
    });

    dbInfo.serializer = localforageSerializer;
    return dbInfoPromise;
}

function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
    t.executeSql(sqlStatement, args, callback, function (t, error) {
        if (error.code === error.SYNTAX_ERR) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name = ?", [dbInfo.storeName], function (t, results) {
                if (!results.rows.length) {
                    // if the table is missing (was deleted)
                    // re-create it table and retry
                    createDbTable(t, dbInfo, function () {
                        t.executeSql(sqlStatement, args, callback, errorCallback);
                    }, errorCallback);
                } else {
                    errorCallback(t, error);
                }
            }, errorCallback);
        } else {
            errorCallback(t, error);
        }
    }, errorCallback);
}

function getItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName + ' WHERE key = ? LIMIT 1', [key], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).value : null;

                    // Check to see if this is serialized content we need to
                    // unpack.
                    if (result) {
                        result = dbInfo.serializer.deserialize(result);
                    }

                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function iterate$1(iterator, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;

            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT * FROM ' + dbInfo.storeName, [], function (t, results) {
                    var rows = results.rows;
                    var length = rows.length;

                    for (var i = 0; i < length; i++) {
                        var item = rows.item(i);
                        var result = item.value;

                        // Check to see if this is serialized content
                        // we need to unpack.
                        if (result) {
                            result = dbInfo.serializer.deserialize(result);
                        }

                        result = iterator(result, item.key, i + 1);

                        // void(0) prevents problems with redefinition
                        // of `undefined`.
                        if (result !== void 0) {
                            resolve(result);
                            return;
                        }
                    }

                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function _setItem(key, value, callback, retriesLeft) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            // The localStorage API doesn't return undefined values in an
            // "expected" way, so undefined is always cast to null in all
            // drivers. See: https://github.com/mozilla/localForage/pull/42
            if (value === undefined) {
                value = null;
            }

            // Save the original value to pass to the callback.
            var originalValue = value;

            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    dbInfo.db.transaction(function (t) {
                        tryExecuteSql(t, dbInfo, 'INSERT OR REPLACE INTO ' + dbInfo.storeName + ' ' + '(key, value) VALUES (?, ?)', [key, value], function () {
                            resolve(originalValue);
                        }, function (t, error) {
                            reject(error);
                        });
                    }, function (sqlError) {
                        // The transaction failed; check
                        // to see if it's a quota error.
                        if (sqlError.code === sqlError.QUOTA_ERR) {
                            // We reject the callback outright for now, but
                            // it's worth trying to re-run the transaction.
                            // Even if the user accepts the prompt to use
                            // more storage on Safari, this error will
                            // be called.
                            //
                            // Try to re-run the transaction.
                            if (retriesLeft > 0) {
                                resolve(_setItem.apply(self, [key, originalValue, callback, retriesLeft - 1]));
                                return;
                            }
                            reject(sqlError);
                        }
                    });
                }
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function setItem$1(key, value, callback) {
    return _setItem.apply(this, [key, value, callback, 1]);
}

function removeItem$1(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName + ' WHERE key = ?', [key], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Deletes every item in the table.
// TODO: Find out if this resets the AUTO_INCREMENT number.
function clear$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'DELETE FROM ' + dbInfo.storeName, [], function () {
                    resolve();
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Does a simple `COUNT(key)` to get the number of items stored in
// localForage.
function length$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                // Ahhh, SQL makes this one soooooo easy.
                tryExecuteSql(t, dbInfo, 'SELECT COUNT(key) as c FROM ' + dbInfo.storeName, [], function (t, results) {
                    var result = results.rows.item(0).c;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// Return the key located at key index X; essentially gets the key from a
// `WHERE id = ?`. This is the most efficient way I can think to implement
// this rarely-used (in my experience) part of the API, but it can seem
// inconsistent, because we do `INSERT OR REPLACE INTO` on `setItem()`, so
// the ID of each key will change every time it's updated. Perhaps a stored
// procedure for the `setItem()` SQL would solve this problem?
// TODO: Don't change ID on `setItem()`.
function key$1(n, callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName + ' WHERE id = ? LIMIT 1', [n + 1], function (t, results) {
                    var result = results.rows.length ? results.rows.item(0).key : null;
                    resolve(result);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$1(callback) {
    var self = this;

    var promise = new Promise$1(function (resolve, reject) {
        self.ready().then(function () {
            var dbInfo = self._dbInfo;
            dbInfo.db.transaction(function (t) {
                tryExecuteSql(t, dbInfo, 'SELECT key FROM ' + dbInfo.storeName, [], function (t, results) {
                    var keys = [];

                    for (var i = 0; i < results.rows.length; i++) {
                        keys.push(results.rows.item(i).key);
                    }

                    resolve(keys);
                }, function (t, error) {
                    reject(error);
                });
            });
        })["catch"](reject);
    });

    executeCallback(promise, callback);
    return promise;
}

// https://www.w3.org/TR/webdatabase/#databases
// > There is no way to enumerate or delete the databases available for an origin from this API.
function getAllStoreNames(db) {
    return new Promise$1(function (resolve, reject) {
        db.transaction(function (t) {
            t.executeSql('SELECT name FROM sqlite_master ' + "WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function (t, results) {
                var storeNames = [];

                for (var i = 0; i < results.rows.length; i++) {
                    storeNames.push(results.rows.item(i).name);
                }

                resolve({
                    db: db,
                    storeNames: storeNames
                });
            }, function (t, error) {
                reject(error);
            });
        }, function (sqlError) {
            reject(sqlError);
        });
    });
}

function dropInstance$1(options, callback) {
    callback = getCallback.apply(this, arguments);

    var currentConfig = this.config();
    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            var db;
            if (options.name === currentConfig.name) {
                // use the db reference of the current instance
                db = self._dbInfo.db;
            } else {
                db = openDatabase(options.name, '', '', 0);
            }

            if (!options.storeName) {
                // drop all database tables
                resolve(getAllStoreNames(db));
            } else {
                resolve({
                    db: db,
                    storeNames: [options.storeName]
                });
            }
        }).then(function (operationInfo) {
            return new Promise$1(function (resolve, reject) {
                operationInfo.db.transaction(function (t) {
                    function dropTable(storeName) {
                        return new Promise$1(function (resolve, reject) {
                            t.executeSql('DROP TABLE IF EXISTS ' + storeName, [], function () {
                                resolve();
                            }, function (t, error) {
                                reject(error);
                            });
                        });
                    }

                    var operations = [];
                    for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                        operations.push(dropTable(operationInfo.storeNames[i]));
                    }

                    Promise$1.all(operations).then(function () {
                        resolve();
                    })["catch"](function (e) {
                        reject(e);
                    });
                }, function (sqlError) {
                    reject(sqlError);
                });
            });
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var webSQLStorage = {
    _driver: 'webSQLStorage',
    _initStorage: _initStorage$1,
    _support: isWebSQLValid(),
    iterate: iterate$1,
    getItem: getItem$1,
    setItem: setItem$1,
    removeItem: removeItem$1,
    clear: clear$1,
    length: length$1,
    key: key$1,
    keys: keys$1,
    dropInstance: dropInstance$1
};

function isLocalStorageValid() {
    try {
        return typeof localStorage !== 'undefined' && 'setItem' in localStorage &&
        // in IE8 typeof localStorage.setItem === 'object'
        !!localStorage.setItem;
    } catch (e) {
        return false;
    }
}

function _getKeyPrefix(options, defaultConfig) {
    var keyPrefix = options.name + '/';

    if (options.storeName !== defaultConfig.storeName) {
        keyPrefix += options.storeName + '/';
    }
    return keyPrefix;
}

// Check if localStorage throws when saving an item
function checkIfLocalStorageThrows() {
    var localStorageTestKey = '_localforage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return false;
    } catch (e) {
        return true;
    }
}

// Check if localStorage is usable and allows to save an item
// This method checks if localStorage is usable in Safari Private Browsing
// mode, or in any other case where the available quota for localStorage
// is 0 and there wasn't any saved items yet.
function _isLocalStorageUsable() {
    return !checkIfLocalStorageThrows() || localStorage.length > 0;
}

// Config the localStorage backend, using options set in the config.
function _initStorage$2(options) {
    var self = this;
    var dbInfo = {};
    if (options) {
        for (var i in options) {
            dbInfo[i] = options[i];
        }
    }

    dbInfo.keyPrefix = _getKeyPrefix(options, self._defaultConfig);

    if (!_isLocalStorageUsable()) {
        return Promise$1.reject();
    }

    self._dbInfo = dbInfo;
    dbInfo.serializer = localforageSerializer;

    return Promise$1.resolve();
}

// Remove all keys from the datastore, effectively destroying all data in
// the app's key/value store!
function clear$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var keyPrefix = self._dbInfo.keyPrefix;

        for (var i = localStorage.length - 1; i >= 0; i--) {
            var key = localStorage.key(i);

            if (key.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key);
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Retrieve an item from the store. Unlike the original async_storage
// library in Gaia, we don't modify return values at all. If a key's value
// is `undefined`, we pass that value to the callback function.
function getItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result = localStorage.getItem(dbInfo.keyPrefix + key);

        // If a result was found, parse it from the serialized
        // string into a JS object. If result isn't truthy, the key
        // is likely undefined and we'll pass it straight to the
        // callback.
        if (result) {
            result = dbInfo.serializer.deserialize(result);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

// Iterate over all items in the store.
function iterate$2(iterator, callback) {
    var self = this;

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var keyPrefix = dbInfo.keyPrefix;
        var keyPrefixLength = keyPrefix.length;
        var length = localStorage.length;

        // We use a dedicated iterator instead of the `i` variable below
        // so other keys we fetch in localStorage aren't counted in
        // the `iterationNumber` argument passed to the `iterate()`
        // callback.
        //
        // See: github.com/mozilla/localForage/pull/435#discussion_r38061530
        var iterationNumber = 1;

        for (var i = 0; i < length; i++) {
            var key = localStorage.key(i);
            if (key.indexOf(keyPrefix) !== 0) {
                continue;
            }
            var value = localStorage.getItem(key);

            // If a result was found, parse it from the serialized
            // string into a JS object. If result isn't truthy, the
            // key is likely undefined and we'll pass it straight
            // to the iterator.
            if (value) {
                value = dbInfo.serializer.deserialize(value);
            }

            value = iterator(value, key.substring(keyPrefixLength), iterationNumber++);

            if (value !== void 0) {
                return value;
            }
        }
    });

    executeCallback(promise, callback);
    return promise;
}

// Same as localStorage's key() method, except takes a callback.
function key$2(n, callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var result;
        try {
            result = localStorage.key(n);
        } catch (error) {
            result = null;
        }

        // Remove the prefix from the key, if a key is found.
        if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
        }

        return result;
    });

    executeCallback(promise, callback);
    return promise;
}

function keys$2(callback) {
    var self = this;
    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        var length = localStorage.length;
        var keys = [];

        for (var i = 0; i < length; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
                keys.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
        }

        return keys;
    });

    executeCallback(promise, callback);
    return promise;
}

// Supply the number of keys in the datastore to the callback function.
function length$2(callback) {
    var self = this;
    var promise = self.keys().then(function (keys) {
        return keys.length;
    });

    executeCallback(promise, callback);
    return promise;
}

// Remove an item from the store, nice and simple.
function removeItem$2(key, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        var dbInfo = self._dbInfo;
        localStorage.removeItem(dbInfo.keyPrefix + key);
    });

    executeCallback(promise, callback);
    return promise;
}

// Set a key's value and run an optional callback once the value is set.
// Unlike Gaia's implementation, the callback function is passed the value,
// in case you want to operate on that value only after you're sure it
// saved, or something like that.
function setItem$2(key, value, callback) {
    var self = this;

    key = normalizeKey(key);

    var promise = self.ready().then(function () {
        // Convert undefined values to null.
        // https://github.com/mozilla/localForage/pull/42
        if (value === undefined) {
            value = null;
        }

        // Save the original value to pass to the callback.
        var originalValue = value;

        return new Promise$1(function (resolve, reject) {
            var dbInfo = self._dbInfo;
            dbInfo.serializer.serialize(value, function (value, error) {
                if (error) {
                    reject(error);
                } else {
                    try {
                        localStorage.setItem(dbInfo.keyPrefix + key, value);
                        resolve(originalValue);
                    } catch (e) {
                        // localStorage capacity exceeded.
                        // TODO: Make this a specific error/event.
                        if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                            reject(e);
                        }
                        reject(e);
                    }
                }
            });
        });
    });

    executeCallback(promise, callback);
    return promise;
}

function dropInstance$2(options, callback) {
    callback = getCallback.apply(this, arguments);

    options = typeof options !== 'function' && options || {};
    if (!options.name) {
        var currentConfig = this.config();
        options.name = options.name || currentConfig.name;
        options.storeName = options.storeName || currentConfig.storeName;
    }

    var self = this;
    var promise;
    if (!options.name) {
        promise = Promise$1.reject('Invalid arguments');
    } else {
        promise = new Promise$1(function (resolve) {
            if (!options.storeName) {
                resolve(options.name + '/');
            } else {
                resolve(_getKeyPrefix(options, self._defaultConfig));
            }
        }).then(function (keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);

                if (key.indexOf(keyPrefix) === 0) {
                    localStorage.removeItem(key);
                }
            }
        });
    }

    executeCallback(promise, callback);
    return promise;
}

var localStorageWrapper = {
    _driver: 'localStorageWrapper',
    _initStorage: _initStorage$2,
    _support: isLocalStorageValid(),
    iterate: iterate$2,
    getItem: getItem$2,
    setItem: setItem$2,
    removeItem: removeItem$2,
    clear: clear$2,
    length: length$2,
    key: key$2,
    keys: keys$2,
    dropInstance: dropInstance$2
};

var sameValue = function sameValue(x, y) {
    return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
};

var includes = function includes(array, searchElement) {
    var len = array.length;
    var i = 0;
    while (i < len) {
        if (sameValue(array[i], searchElement)) {
            return true;
        }
        i++;
    }

    return false;
};

var isArray = Array.isArray || function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};

// Drivers are stored here when `defineDriver()` is called.
// They are shared across all instances of localForage.
var DefinedDrivers = {};

var DriverSupport = {};

var DefaultDrivers = {
    INDEXEDDB: asyncStorage,
    WEBSQL: webSQLStorage,
    LOCALSTORAGE: localStorageWrapper
};

var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];

var OptionalDriverMethods = ['dropInstance'];

var LibraryMethods = ['clear', 'getItem', 'iterate', 'key', 'keys', 'length', 'removeItem', 'setItem'].concat(OptionalDriverMethods);

var DefaultConfig = {
    description: '',
    driver: DefaultDriverOrder.slice(),
    name: 'localforage',
    // Default DB size is _JUST UNDER_ 5MB, as it's the highest size
    // we can use without a prompt.
    size: 4980736,
    storeName: 'keyvaluepairs',
    version: 1.0
};

function callWhenReady(localForageInstance, libraryMethod) {
    localForageInstance[libraryMethod] = function () {
        var _args = arguments;
        return localForageInstance.ready().then(function () {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
        });
    };
}

function extend() {
    for (var i = 1; i < arguments.length; i++) {
        var arg = arguments[i];

        if (arg) {
            for (var _key in arg) {
                if (arg.hasOwnProperty(_key)) {
                    if (isArray(arg[_key])) {
                        arguments[0][_key] = arg[_key].slice();
                    } else {
                        arguments[0][_key] = arg[_key];
                    }
                }
            }
        }
    }

    return arguments[0];
}

var LocalForage = function () {
    function LocalForage(options) {
        _classCallCheck(this, LocalForage);

        for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
                var driver = DefaultDrivers[driverTypeKey];
                var driverName = driver._driver;
                this[driverTypeKey] = driverName;

                if (!DefinedDrivers[driverName]) {
                    // we don't need to wait for the promise,
                    // since the default drivers can be defined
                    // in a blocking manner
                    this.defineDriver(driver);
                }
            }
        }

        this._defaultConfig = extend({}, DefaultConfig);
        this._config = extend({}, this._defaultConfig, options);
        this._driverSet = null;
        this._initDriver = null;
        this._ready = false;
        this._dbInfo = null;

        this._wrapLibraryMethodsWithReady();
        this.setDriver(this._config.driver)["catch"](function () {});
    }

    // Set any config values for localForage; can be called anytime before
    // the first API call (e.g. `getItem`, `setItem`).
    // We loop through options so we don't overwrite existing config
    // values.


    LocalForage.prototype.config = function config(options) {
        // If the options argument is an object, we use it to set values.
        // Otherwise, we return either a specified config value or all
        // config values.
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            // If localforage is ready and fully initialized, we can't set
            // any new configuration values. Instead, we return an error.
            if (this._ready) {
                return new Error("Can't call config() after localforage " + 'has been used.');
            }

            for (var i in options) {
                if (i === 'storeName') {
                    options[i] = options[i].replace(/\W/g, '_');
                }

                if (i === 'version' && typeof options[i] !== 'number') {
                    return new Error('Database version must be a number.');
                }

                this._config[i] = options[i];
            }

            // after all config options are set and
            // the driver option is used, try setting it
            if ('driver' in options && options.driver) {
                return this.setDriver(this._config.driver);
            }

            return true;
        } else if (typeof options === 'string') {
            return this._config[options];
        } else {
            return this._config;
        }
    };

    // Used to define a custom driver, shared across all instances of
    // localForage.


    LocalForage.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
        var promise = new Promise$1(function (resolve, reject) {
            try {
                var driverName = driverObject._driver;
                var complianceError = new Error('Custom driver not compliant; see ' + 'https://mozilla.github.io/localForage/#definedriver');

                // A driver name should be defined and not overlap with the
                // library-defined, default drivers.
                if (!driverObject._driver) {
                    reject(complianceError);
                    return;
                }

                var driverMethods = LibraryMethods.concat('_initStorage');
                for (var i = 0, len = driverMethods.length; i < len; i++) {
                    var driverMethodName = driverMethods[i];

                    // when the property is there,
                    // it should be a method even when optional
                    var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                    if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== 'function') {
                        reject(complianceError);
                        return;
                    }
                }

                var configureMissingMethods = function configureMissingMethods() {
                    var methodNotImplementedFactory = function methodNotImplementedFactory(methodName) {
                        return function () {
                            var error = new Error('Method ' + methodName + ' is not implemented by the current driver');
                            var promise = Promise$1.reject(error);
                            executeCallback(promise, arguments[arguments.length - 1]);
                            return promise;
                        };
                    };

                    for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                        var optionalDriverMethod = OptionalDriverMethods[_i];
                        if (!driverObject[optionalDriverMethod]) {
                            driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                        }
                    }
                };

                configureMissingMethods();

                var setDriverSupport = function setDriverSupport(support) {
                    if (DefinedDrivers[driverName]) {
                        console.info('Redefining LocalForage driver: ' + driverName);
                    }
                    DefinedDrivers[driverName] = driverObject;
                    DriverSupport[driverName] = support;
                    // don't use a then, so that we can define
                    // drivers that have simple _support methods
                    // in a blocking manner
                    resolve();
                };

                if ('_support' in driverObject) {
                    if (driverObject._support && typeof driverObject._support === 'function') {
                        driverObject._support().then(setDriverSupport, reject);
                    } else {
                        setDriverSupport(!!driverObject._support);
                    }
                } else {
                    setDriverSupport(true);
                }
            } catch (e) {
                reject(e);
            }
        });

        executeTwoCallbacks(promise, callback, errorCallback);
        return promise;
    };

    LocalForage.prototype.driver = function driver() {
        return this._driver || null;
    };

    LocalForage.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
        var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error('Driver not found.'));

        executeTwoCallbacks(getDriverPromise, callback, errorCallback);
        return getDriverPromise;
    };

    LocalForage.prototype.getSerializer = function getSerializer(callback) {
        var serializerPromise = Promise$1.resolve(localforageSerializer);
        executeTwoCallbacks(serializerPromise, callback);
        return serializerPromise;
    };

    LocalForage.prototype.ready = function ready(callback) {
        var self = this;

        var promise = self._driverSet.then(function () {
            if (self._ready === null) {
                self._ready = self._initDriver();
            }

            return self._ready;
        });

        executeTwoCallbacks(promise, callback, callback);
        return promise;
    };

    LocalForage.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
        var self = this;

        if (!isArray(drivers)) {
            drivers = [drivers];
        }

        var supportedDrivers = this._getSupportedDrivers(drivers);

        function setDriverToConfig() {
            self._config.driver = self.driver();
        }

        function extendSelfWithDriver(driver) {
            self._extend(driver);
            setDriverToConfig();

            self._ready = self._initStorage(self._config);
            return self._ready;
        }

        function initDriver(supportedDrivers) {
            return function () {
                var currentDriverIndex = 0;

                function driverPromiseLoop() {
                    while (currentDriverIndex < supportedDrivers.length) {
                        var driverName = supportedDrivers[currentDriverIndex];
                        currentDriverIndex++;

                        self._dbInfo = null;
                        self._ready = null;

                        return self.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                    }

                    setDriverToConfig();
                    var error = new Error('No available storage method found.');
                    self._driverSet = Promise$1.reject(error);
                    return self._driverSet;
                }

                return driverPromiseLoop();
            };
        }

        // There might be a driver initialization in progress
        // so wait for it to finish in order to avoid a possible
        // race condition to set _dbInfo
        var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function () {
            return Promise$1.resolve();
        }) : Promise$1.resolve();

        this._driverSet = oldDriverSetDone.then(function () {
            var driverName = supportedDrivers[0];
            self._dbInfo = null;
            self._ready = null;

            return self.getDriver(driverName).then(function (driver) {
                self._driver = driver._driver;
                setDriverToConfig();
                self._wrapLibraryMethodsWithReady();
                self._initDriver = initDriver(supportedDrivers);
            });
        })["catch"](function () {
            setDriverToConfig();
            var error = new Error('No available storage method found.');
            self._driverSet = Promise$1.reject(error);
            return self._driverSet;
        });

        executeTwoCallbacks(this._driverSet, callback, errorCallback);
        return this._driverSet;
    };

    LocalForage.prototype.supports = function supports(driverName) {
        return !!DriverSupport[driverName];
    };

    LocalForage.prototype._extend = function _extend(libraryMethodsAndProperties) {
        extend(this, libraryMethodsAndProperties);
    };

    LocalForage.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
        var supportedDrivers = [];
        for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
                supportedDrivers.push(driverName);
            }
        }
        return supportedDrivers;
    };

    LocalForage.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
        // Add a stub for each driver API method that delays the call to the
        // corresponding driver method until localForage is ready. These stubs
        // will be replaced by the driver methods as soon as the driver is
        // loaded, so there is no performance impact.
        for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
        }
    };

    LocalForage.prototype.createInstance = function createInstance(options) {
        return new LocalForage(options);
    };

    return LocalForage;
}();

// The actual localForage object that we expose as a module or via a
// global. It's extended by pulling in one of our other libraries.


var localforage_js = new LocalForage();

module.exports = localforage_js;

},{"3":3}]},{},[4])(4)
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isObjectLike = __webpack_require__(130);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */
module.exports = _curry2(function add(a, b) {
  return Number(a) + Number(b);
});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _isPlaceholder = __webpack_require__(170);


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
module.exports = function _curryN(length, received, fn) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length &&
          (!_isPlaceholder(received[combinedIdx]) ||
           argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined)
                     : _arity(left, _curryN(length, combined, fn));
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _isArray = __webpack_require__(93);
var _isString = __webpack_require__(146);


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
module.exports = _curry1(function isArrayLike(x) {
  if (_isArray(x)) { return true; }
  if (!x) { return false; }
  if (typeof x !== 'object') { return false; }
  if (_isString(x)) { return false; }
  if (x.nodeType === 1) { return !!x.length; }
  if (x.length === 0) { return true; }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */
module.exports = _curry2(function prop(p, obj) { return obj[p]; });


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry3(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */
module.exports = _curry1(function isNil(x) { return x == null; });


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      var takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */
module.exports = _curry2(function nAry(n, fn) {
  switch (n) {
    case 0: return function() {return fn.call(this);};
    case 1: return function(a0) {return fn.call(this, a0);};
    case 2: return function(a0, a1) {return fn.call(this, a0, a1);};
    case 3: return function(a0, a1, a2) {return fn.call(this, a0, a1, a2);};
    case 4: return function(a0, a1, a2, a3) {return fn.call(this, a0, a1, a2, a3);};
    case 5: return function(a0, a1, a2, a3, a4) {return fn.call(this, a0, a1, a2, a3, a4);};
    case 6: return function(a0, a1, a2, a3, a4, a5) {return fn.call(this, a0, a1, a2, a3, a4, a5);};
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6);};
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);};
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);};
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);};
    default: throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
  }
});


/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var liftN = __webpack_require__(329);


/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */
module.exports = _curry1(function lift(fn) {
  return liftN(fn.length, fn);
});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _pipe = __webpack_require__(579);
var reduce = __webpack_require__(74);
var tail = __webpack_require__(241);


/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
module.exports = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipe, arguments[0], tail(arguments)));
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _isString = __webpack_require__(146);


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
module.exports = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
                           Array.prototype.slice.call(list, 0).reverse();
});


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(338);
var _curry2 = __webpack_require__(3);
var filter = __webpack_require__(243);


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(172);
var _dispatchable = __webpack_require__(31);
var _has = __webpack_require__(46);
var _reduce = __webpack_require__(56);
var _xreduceBy = __webpack_require__(591);


/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */
module.exports = _curryN(4, [], _dispatchable([], _xreduceBy,
  function reduceBy(valueFn, valueAcc, keyFn, list) {
    return _reduce(function(acc, elt) {
      var key = keyFn(elt);
      acc[key] = valueFn(_has(key, acc) ? acc[key] : valueAcc, elt);
      return acc;
    }, {}, list);
  }));


/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var curry = __webpack_require__(132);


/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */
module.exports = _curry1(function flip(fn) {
  return curry(function(a, b) {
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = b;
    args[1] = a;
    return fn.apply(this, args);
  });
});


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */
module.exports = _curry2(function is(Ctor, val) {
  return val != null && val.constructor === Ctor || val instanceof Ctor;
});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var map = __webpack_require__(45);


/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry2(function lens(getter, setter) {
  return function(toFunctorFn) {
    return function(target) {
      return map(
        function(focus) {
          return setter(focus, target);
        },
        toFunctorFn(getter(target))
      );
    };
  };
});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var _isObject = __webpack_require__(245);
var mergeWithKey = __webpack_require__(256);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWithKey(fn, lObj, rObj) {
  return mergeWithKey(function(k, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey(fn, lVal, rVal);
    } else {
      return fn(k, lVal, rVal);
    }
  }, lObj, rObj);
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DbTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({dbDumpRequest:null,dbDumpSuccess:null,dbDumpFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var DbTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,err:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null});};var success=function success(state){return state.merge({fetching:false,err:null});};var failure=function failure(state,_ref){var err=_ref.err;return state.merge({fetching:false,err:err});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.DB_DUMP_SUCCESS,success),_defineProperty(_createReducer,Types.DB_DUMP_REQUEST,request),_defineProperty(_createReducer,Types.DB_DUMP_FAILURE,failure),_createReducer));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(753),
    listCacheDelete = __webpack_require__(754),
    listCacheGet = __webpack_require__(755),
    listCacheHas = __webpack_require__(756),
    listCacheSet = __webpack_require__(757);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(392);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(759);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(169);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ObjectCleaner=function ObjectCleaner(obj){for(var propName in obj){if(!obj[propName]){delete obj[propName];}}return obj;};/* harmony default export */ __webpack_exports__["a"] = (ObjectCleaner);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}



function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var CONSTANT = {
  GLOBAL: {
    HIDE: "__react_tooltip_hide_event",
    REBUILD: "__react_tooltip_rebuild_event",
    SHOW: "__react_tooltip_show_event"
  }
};

/**
 * Static methods for react-tooltip
 */

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event;

  if (typeof window.CustomEvent === "function") {
    event = new window.CustomEvent(eventName, {
      detail: opts
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
};

function staticMethods (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.HIDE, {
      target: target
    });
  };
  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */


  target.rebuild = function () {
    dispatchGlobalEvent(CONSTANT.GLOBAL.REBUILD);
  };
  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */


  target.show = function (target) {
    dispatchGlobalEvent(CONSTANT.GLOBAL.SHOW, {
      target: target
    });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = {
        currentTarget: event.detail.target
      };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({
        currentTarget: hasTarget && event.detail.target
      }, hasTarget);
    }
  };
}

/**
 * Events that should be bound to the window
 */
function windowListener (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild

    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show

    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize

    if (resizeHide) {
      window.removeEventListener("resize", this.onWindowResize);
      window.addEventListener("resize", this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener("resize", this.onWindowResize);
  };
  /**
   * invoked by resize event of window
   */


  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
}

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */
var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;
  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute("currentItem");
  if (!isCapture) e.stopPropagation();

  if (show && currentItem === "true") {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute("currentItem", "true");
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute("currentItem", "false");
    } else {
      targetArray[i].setAttribute("currentItem", "true");
    }
  }
};

var customListeners = {
  id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];

    if (map !== undefined) {
      return map[event];
    }
  }
};
function customEvent (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;
    return event || !!ele.getAttribute("data-event");
  };
  /* Bind listener for custom event */


  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff;
    var dataEvent = ele.getAttribute("data-event") || event;
    var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
    dataEvent.split(" ").forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });

    if (dataEventOff) {
      dataEventOff.split(" ").forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };
  /* Unbind listener for custom event */


  target.prototype.customUnbindListener = function (ele) {
    var _this$state2 = this.state,
        event = _this$state2.event,
        eventOff = _this$state2.eventOff;
    var dataEvent = event || ele.getAttribute("data-event");
    var dataEventOff = eventOff || ele.getAttribute("data-event-off");
    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
}

/**
 * Util method to judge if it should follow capture model
 */
function isCapture (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
  };
}

/**
 * Util method to get effect
 */
function getEffect (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute("data-effect");
    return dataEffect || this.props.effect || "float";
  };
}

/**
 * Util method to get effect
 */

var makeProxy = function makeProxy(e) {
  var proxy = {};

  for (var key in e) {
    if (typeof e[key] === "function") {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }

  return proxy;
};

var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
  var id = this.props.id;
  var tip = e.target.getAttribute("data-tip") || null;
  var forId = e.target.getAttribute("data-for") || null;
  var target = e.target;

  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(" ").forEach(function (event) {
      return events[event] = true;
    });
  });
  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName("body")[0];
};

function bodyMode (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _this$state = this.state,
        event = _this$state.event,
        eventOff = _this$state.eventOff,
        possibleCustomEvents = _this$state.possibleCustomEvents,
        possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
    var body = getBody();
    var customEvents = findCustomEvents(targetArray, "data-event");
    var customEventsOff = findCustomEvents(targetArray, "data-event-off");
    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(" ").forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(" ").forEach(function (event) {
      return customEventsOff[event] = true;
    });
    this.unbindBodyListener(body);
    var listeners = this.bodyModeListeners = {};

    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, {
        respectEffect: true
      });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
        checkStatus.call(_this, targetEventOff, e);
      }, {
        customEvent: true
      });
    }

    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, {
        customEvent: true
      });
    }

    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();
    var listeners = this.bodyModeListeners;

    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
}

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */
// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

function trackRemoval (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;
    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];

        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];

          if (element === _this.state.currentTarget) {
            _this.hideTooltip();

            return;
          }
        }
      }
    });
    observer.observe(window.document, {
      childList: true,
      subtree: true
    });
    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
}

/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
function getPosition (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };

  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };

  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };

  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  }; //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //


  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };

  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };

  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };

  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  }; // Check whether the tooltip with orientation p is completely inside the client window


  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };

  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ["top", "bottom", "left", "right"];
  var insideList = [];

  for (var i = 0; i < 4; i++) {
    var p = placesList[i];

    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace;
  var shouldUpdatePlace = desiredPlace !== place;

  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: {
        place: newPlace
      }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
}

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
}; // Get current mouse offset


var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === "float") {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }

  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window


var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top;
  var right;
  var bottom;
  var left;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === "float") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === "solid") {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return {
    top: top,
    bottom: bottom,
    left: left,
    right: right
  };
}; // Consider additional offset into position calculation


var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === "[object String]") {
    offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
  }

  for (var key in offset) {
    if (key === "top") {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === "bottom") {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === "left") {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === "right") {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return {
    extraOffset_X: extraOffset_X,
    extraOffset_Y: extraOffset_Y
  };
}; // Get the offset of the parent elements


var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;

  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
  return {
    parentTop: parentTop,
    parentLeft: parentLeft
  };
};

/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */
function getTipContent (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.

  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;

  if (!multiline || multiline === "false" || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  } // Multiline tooltip content


  return tip.split(regexp).map(function (d, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      key: i,
      className: "multi-line"
    }, d);
  });
}

/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return /(^aria-\w+$|^role$)/.test(prop);
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });
  return ariaObj;
}

/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */
function nodeListToArray (nodeList) {
  var length = nodeList.length;

  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }

  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
}

___$insertStyle(".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip:before, .__react_component_tooltip:after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0px;\n  margin-left: 0px;\n  visibility: visible;\n}\n.__react_component_tooltip.type-dark {\n  color: #fff;\n  background-color: #222;\n}\n.__react_component_tooltip.type-dark.place-top:after {\n  border-top-color: #222;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-bottom:after {\n  border-bottom-color: #222;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-left:after {\n  border-left-color: #222;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-dark.place-right:after {\n  border-right-color: #222;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-dark.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-dark.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-success {\n  color: #fff;\n  background-color: #8DC572;\n}\n.__react_component_tooltip.type-success.place-top:after {\n  border-top-color: #8DC572;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-success.place-bottom:after {\n  border-bottom-color: #8DC572;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-success.place-left:after {\n  border-left-color: #8DC572;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-success.place-right:after {\n  border-right-color: #8DC572;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-success.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-success.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning {\n  color: #fff;\n  background-color: #F0AD4E;\n}\n.__react_component_tooltip.type-warning.place-top:after {\n  border-top-color: #F0AD4E;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-bottom:after {\n  border-bottom-color: #F0AD4E;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-left:after {\n  border-left-color: #F0AD4E;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-warning.place-right:after {\n  border-right-color: #F0AD4E;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-warning.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-warning.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-error {\n  color: #fff;\n  background-color: #BE6464;\n}\n.__react_component_tooltip.type-error.place-top:after {\n  border-top-color: #BE6464;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-error.place-bottom:after {\n  border-bottom-color: #BE6464;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-error.place-left:after {\n  border-left-color: #BE6464;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-error.place-right:after {\n  border-right-color: #BE6464;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-error.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-error.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-info {\n  color: #fff;\n  background-color: #337AB7;\n}\n.__react_component_tooltip.type-info.place-top:after {\n  border-top-color: #337AB7;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-info.place-bottom:after {\n  border-bottom-color: #337AB7;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-info.place-left:after {\n  border-left-color: #337AB7;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-info.place-right:after {\n  border-right-color: #337AB7;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-info.border {\n  border: 1px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-top:before {\n  border-top: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-bottom:before {\n  border-bottom: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-left:before {\n  border-left: 8px solid #fff;\n}\n.__react_component_tooltip.type-info.border.place-right:before {\n  border-right: 8px solid #fff;\n}\n.__react_component_tooltip.type-light {\n  color: #222;\n  background-color: #fff;\n}\n.__react_component_tooltip.type-light.place-top:after {\n  border-top-color: #fff;\n  border-top-style: solid;\n  border-top-width: 6px;\n}\n.__react_component_tooltip.type-light.place-bottom:after {\n  border-bottom-color: #fff;\n  border-bottom-style: solid;\n  border-bottom-width: 6px;\n}\n.__react_component_tooltip.type-light.place-left:after {\n  border-left-color: #fff;\n  border-left-style: solid;\n  border-left-width: 6px;\n}\n.__react_component_tooltip.type-light.place-right:after {\n  border-right-color: #fff;\n  border-right-style: solid;\n  border-right-width: 6px;\n}\n.__react_component_tooltip.type-light.border {\n  border: 1px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-top:before {\n  border-top: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-bottom:before {\n  border-bottom: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-left:before {\n  border-left: 8px solid #222;\n}\n.__react_component_tooltip.type-light.border.place-right:before {\n  border-right: 8px solid #222;\n}\n.__react_component_tooltip.place-top {\n  margin-top: -10px;\n}\n.__react_component_tooltip.place-top:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-top:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  bottom: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-bottom {\n  margin-top: 10px;\n}\n.__react_component_tooltip.place-bottom:before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom:after {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  top: -6px;\n  left: 50%;\n  margin-left: -8px;\n}\n.__react_component_tooltip.place-left {\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-left:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  right: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip.place-right {\n  margin-left: 10px;\n}\n.__react_component_tooltip.place-right:before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right:after {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  left: -6px;\n  top: 50%;\n  margin-top: -4px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0px;\n  text-align: center;\n}");

var _class, _class2, _temp;

var ReactTooltip = staticMethods(_class = windowListener(_class = customEvent(_class = isCapture(_class = getEffect(_class = bodyMode(_class = trackRemoval(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    var _this;

    _classCallCheck(this, ReactTooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactTooltip).call(this, props));
    _this.state = {
      place: props.place || "top",
      // Direction of tooltip
      desiredPlace: props.place || "top",
      type: "dark",
      // Color theme of tooltip
      effect: "float",
      // float or fixed
      show: false,
      border: false,
      offset: {},
      extraClass: "",
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null,
      // Current mouse event
      currentTarget: null,
      // Current target of mouse event
      ariaProps: parseAria(props),
      // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || "",
      possibleCustomEventsOff: props.possibleCustomEventsOff || "",
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(["showTooltip", "updateTooltip", "hideTooltip", "hideTooltipOnScroll", "getTooltipContent", "globalRebuild", "globalShow", "globalHide", "onWindowResize", "mouseOnToolTip"]);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }
  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: "bind",
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          insecure = _this$props.insecure,
          resizeHide = _this$props.resizeHide;

      this.bindListener(); // Bind listener for tooltip

      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;
      this.clearTimer();
      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }
    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: "mouseOnToolTip",
    value: function mouseOnToolTip() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }

        return this.tooltipRef.matches(":hover");
      }

      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: "getTargetArray",
    value: function getTargetArray(id) {
      var targetArray;

      if (!id) {
        targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
      } else {
        var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        targetArray = document.querySelectorAll("[data-tip][data-for=\"".concat(escaped, "\"]"));
      } // targetArray is a NodeList, convert it to a real array


      return nodeListToArray(targetArray);
    }
    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: "bindListener",
    value: function bindListener() {
      var _this3 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          globalEventOff = _this$props2.globalEventOff,
          isCapture = _this$props2.isCapture;
      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        if (target.getAttribute("currentItem") === null) {
          target.setAttribute("currentItem", "false");
        }

        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);

          var effect = _this3.getEffect(target);

          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);

            return;
          }

          target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);

          if (effect === "float") {
            target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
          }

          target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
        });
      } // Global event to hide tooltip


      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      } // Track removal of targetArray elements from DOM


      this.bindRemovalTracker();
    }
    /**
     * Unbind listeners on target elements
     */

  }, {
    key: "unbindListener",
    value: function unbindListener() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          globalEventOff = _this$props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);

          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }
    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: "unbindBasicListener",
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
      target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
      target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
    }
  }, {
    key: "getTooltipContent",
    value: function getTooltipContent() {
      var _this$props4 = this.props,
          getContent = _this$props4.getContent,
          children = _this$props4.children; // Generate tooltip content

      var content;

      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: "isEmptyTip",
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === "string" && placeholder === "" || placeholder === null;
    }
    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: "showTooltip",
    value: function showTooltip(e, isGlobalCall) {
      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      } // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected


      var _this$props5 = this.props,
          multiline = _this$props5.multiline,
          getContent = _this$props5.getContent;
      var originTooltip = e.currentTarget.getAttribute("data-tip");
      var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect

      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll

      var scrollHide = true;

      if (e.currentTarget.getAttribute("data-scroll-hide")) {
        scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      } // Make sure the correct place is set


      var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
      var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
      var result = getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering

      this.clearTimer();
      var target = e.currentTarget;
      var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute("data-type") || self.props.type || "dark",
          effect: effect,
          offset: offset,
          html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
          delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
          delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
          delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
          border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
          extraClass: target.getAttribute("data-class") || self.props["class"] || self.props.className || "",
          disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
          currentTarget: target
        }, function () {
          if (scrollHide) self.addScrollListener(self.state.currentTarget);
          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;
                var placeholder = getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      }; // If there is no delay call immediately, don't allow events to get in first.


      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }
    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: "updateTooltip",
    value: function updateTooltip(e) {
      var _this5 = this;

      var _this$state = this.state,
          delayShow = _this$state.delayShow,
          disable = _this$state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

      if (this.mouseOnToolTip()) {
        return;
      }

      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;

          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();

            if (isInvisible && afterShow) afterShow(e);
          });
        }
      };

      clearTimeout(this.delayShowLoop);

      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }
    /*
     * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: "listenForTooltipExit",
    value: function listenForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
      }
    }
  }, {
    key: "removeListenerForTooltipExit",
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;

      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
      }
    }
    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: "hideTooltip",
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        isScroll: false
      };
      var disable = this.state.disable;
      var isScroll = options.isScroll;
      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;
      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip

      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip

        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();

          return;
        }

        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener();

          if (isVisible && afterHide) afterHide(e);
        });
      };

      this.clearTimer();

      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }
    /**
     * When scroll, hide tooltip
     */

  }, {
    key: "hideTooltipOnScroll",
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, {
        isScroll: true
      });
    }
    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: "addScrollListener",
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: "removeScrollListener",
    value: function removeScrollListener() {
      window.removeEventListener("scroll", this.hideTooltipOnScroll);
    } // Calculation the position

  }, {
    key: "updatePosition",
    value: function updatePosition() {
      var _this7 = this;

      var _this$state2 = this.state,
          currentEvent = _this$state2.currentEvent,
          currentTarget = _this$state2.currentTarget,
          place = _this$state2.place,
          desiredPlace = _this$state2.desiredPlace,
          effect = _this$state2.effect,
          offset = _this$state2.offset;
      var node = this.tooltipRef;
      var result = getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);

      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      } // Set tooltip position


      node.style.left = result.position.left + "px";
      node.style.top = result.position.top + "px";
    }
    /**
     * Set style tag in header
     * in this way we can insert default css
     */

    /* setStyleHeader() {
      const head = document.getElementsByTagName("head")[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        const tag = document.createElement("style");
        tag.id = "react-tooltip";
        tag.innerHTML = cssStyle; */

    /* eslint-disable */

    /*      if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
            tag.setAttribute('nonce', __webpack_nonce__)
          }*/

    /* eslint-enable */

    /*    head.insertBefore(tag, head.firstChild);
      }
    } */

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: "clearTimer",
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$state3 = this.state,
          extraClass = _this$state3.extraClass,
          html = _this$state3.html,
          ariaProps = _this$state3.ariaProps,
          disable = _this$state3.disable;
      var placeholder = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(placeholder);
      var tooltipClass = "__react_component_tooltip" + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
      " type-".concat(this.state.type) + ( // dark, success, warning, error, info, light
      this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
      var Wrapper = this.props.wrapper;

      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(" ");

      if (html) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: wrapperClassName,
          id: this.props.id,
          ref: function ref(_ref) {
            return _this8.tooltipRef = _ref;
          }
        }, ariaProps, {
          "data-id": "tooltip",
          dangerouslySetInnerHTML: {
            __html: placeholder
          }
        }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, _extends({
          className: wrapperClassName,
          id: this.props.id
        }, ariaProps, {
          ref: function ref(_ref2) {
            return _this8.tooltipRef = _ref2;
          },
          "data-id": "tooltip"
        }), placeholder);
      }
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;
      var newAriaProps = parseAria(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });

      if (!isChanged) {
        return null;
      }

      return _objectSpread2({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _defineProperty(_class2, "propTypes", {
  children: propTypes.any,
  place: propTypes.string,
  type: propTypes.string,
  effect: propTypes.string,
  offset: propTypes.object,
  multiline: propTypes.bool,
  border: propTypes.bool,
  insecure: propTypes.bool,
  "class": propTypes.string,
  className: propTypes.string,
  id: propTypes.string,
  html: propTypes.bool,
  delayHide: propTypes.number,
  delayUpdate: propTypes.number,
  delayShow: propTypes.number,
  event: propTypes.string,
  eventOff: propTypes.string,
  watchWindow: propTypes.bool,
  isCapture: propTypes.bool,
  globalEventOff: propTypes.string,
  getContent: propTypes.any,
  afterShow: propTypes.func,
  afterHide: propTypes.func,
  overridePosition: propTypes.func,
  disable: propTypes.bool,
  scrollHide: propTypes.bool,
  resizeHide: propTypes.bool,
  wrapper: propTypes.string,
  bodyMode: propTypes.bool,
  possibleCustomEvents: propTypes.string,
  possibleCustomEventsOff: propTypes.string,
  clickable: propTypes.bool
}), _defineProperty(_class2, "defaultProps", {
  insecure: true,
  resizeHide: true,
  wrapper: "div",
  clickable: false
}), _defineProperty(_class2, "supportedWrappers", ["div", "span"]), _defineProperty(_class2, "displayName", "ReactTooltip"), _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

/* harmony default export */ __webpack_exports__["a"] = (ReactTooltip);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CronReportTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export successItem */
/* unused harmony export successWhitelist */
/* unused harmony export failure */
/* unused harmony export manipulateRequest */
/* unused harmony export manipulateSuccess */
/* unused harmony export manipulateFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getCronReportRequest:['data'],getCronReportSuccess:['data'],getCronReportFailure:['err'],getCronReportItemRequest:['data'],getCronReportItemSuccess:['data'],getCronReportItemFailure:['err'],disableAttractionRequest:['data'],disableAttractionSuccess:['data'],disableAttractionFailure:['err'],enableAttractionRequest:['data'],enableAttractionSuccess:['data'],enableAttractionFailure:['err'],getWhitelistRequest:['data'],getWhitelistSuccess:['data'],getWhitelistFailure:['err'],putWhitelistRequest:['data'],putWhitelistSuccess:['data'],putWhitelistFailure:['err'],deleteWhitelistRequest:['data'],deleteWhitelistSuccess:['data'],deleteWhitelistFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var CronReportTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],data_item:{},data_whitelist:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null,success:true});};var successItem=function successItem(state,_ref2){var data=_ref2.data;return state.merge({fetching:false,data_item:data,err:null,success:true});};var successWhitelist=function successWhitelist(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,data_whitelist:data,err:null,success:true});};var failure=function failure(state,_ref4){var err=_ref4.err;return state.merge({fetching:false,err:err});};var manipulateRequest=function manipulateRequest(state){return state.merge({processing:true,success:null});};var manipulateSuccess=function manipulateSuccess(state,_ref5){var data=_ref5.data;return state.merge({processing:false,success:true,err:null});};var manipulateFailure=function manipulateFailure(state,_ref6){var err=_ref6.err;return state.merge({processing:false,err:err,success:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_CRON_REPORT_SUCCESS,success),_defineProperty(_createReducer,Types.GET_CRON_REPORT_REQUEST,request),_defineProperty(_createReducer,Types.GET_CRON_REPORT_FAILURE,failure),_defineProperty(_createReducer,Types.GET_CRON_REPORT_ITEM_SUCCESS,successItem),_defineProperty(_createReducer,Types.GET_CRON_REPORT_ITEM_REQUEST,request),_defineProperty(_createReducer,Types.GET_CRON_REPORT_ITEM_FAILURE,failure),_defineProperty(_createReducer,Types.DISABLE_ATTRACTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DISABLE_ATTRACTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DISABLE_ATTRACTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.ENABLE_ATTRACTION_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.ENABLE_ATTRACTION_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.ENABLE_ATTRACTION_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.GET_WHITELIST_SUCCESS,successWhitelist),_defineProperty(_createReducer,Types.GET_WHITELIST_REQUEST,request),_defineProperty(_createReducer,Types.GET_WHITELIST_FAILURE,failure),_defineProperty(_createReducer,Types.PUT_WHITELIST_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.PUT_WHITELIST_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.PUT_WHITELIST_FAILURE,manipulateFailure),_defineProperty(_createReducer,Types.DELETE_WHITELIST_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.DELETE_WHITELIST_REQUEST,manipulateRequest),_defineProperty(_createReducer,Types.DELETE_WHITELIST_FAILURE,manipulateFailure),_createReducer));

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(44);
var toLength = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(119);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(69);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(70);
var defined = __webpack_require__(79);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(100);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(51);
var hide = __webpack_require__(50);
var Iterators = __webpack_require__(121);
var $iterCreate = __webpack_require__(206);
var setToStringTag = __webpack_require__(139);
var getPrototypeOf = __webpack_require__(53);
var ITERATOR = __webpack_require__(21)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(87);
var descriptor = __webpack_require__(99);
var setToStringTag = __webpack_require__(139);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(50)(IteratorPrototype, __webpack_require__(21)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(16);
var cof = __webpack_require__(69);
var MATCH = __webpack_require__(21)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(21)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(102);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(426);
var redefine = __webpack_require__(51);
var hide = __webpack_require__(50);
var fails = __webpack_require__(15);
var defined = __webpack_require__(79);
var wks = __webpack_require__(21);
var regexpExec = __webpack_require__(285);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(51);
var redefineAll = __webpack_require__(124);
var meta = __webpack_require__(101);
var forOf = __webpack_require__(104);
var anInstance = __webpack_require__(123);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(15);
var $iterDetect = __webpack_require__(208);
var setToStringTag = __webpack_require__(139);
var inheritIfRequired = __webpack_require__(273);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var hide = __webpack_require__(50);
var uid = __webpack_require__(118);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(100) || !__webpack_require__(15)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(12)[K];
});


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(37);
var ctx = __webpack_require__(59);
var forOf = __webpack_require__(104);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Editor__ = __webpack_require__(1167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Editor__["a"]; });
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */




/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExchangeRateTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* unused harmony export successSingle */
/* unused harmony export manipulateSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({exchangeRateRequest:['data'],exchangeRateSuccess:['data'],exchangeRateFailure:['err'],exchangeRateSingleRequest:['data'],exchangeRateSingleSuccess:['data'],exchangeRateSingleFailure:['err'],exchangeRateUpdateRequest:['data'],exchangeRateUpdateSuccess:['data'],exchangeRateUpdateFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var ExchangeRateTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:null,detail:{},err:null});/* ------------- Reducers ------------- */// we're attempting to login
var request=function request(state){return state.merge({fetching:true});};// we've successfully logged in
var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};// we've had a problem logging in
var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};var successSingle=function successSingle(state,_ref3){var data=_ref3.data;return state.merge({fetching:false,detail:data,err:null});};var manipulateSuccess=function manipulateSuccess(state,_ref4){var data=_ref4.data;return state.merge({fetching:false,err:null});};/* ------------- Hookup Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.EXCHANGE_RATE_SUCCESS,success),_defineProperty(_createReducer,Types.EXCHANGE_RATE_REQUEST,request),_defineProperty(_createReducer,Types.EXCHANGE_RATE_FAILURE,failure),_defineProperty(_createReducer,Types.EXCHANGE_RATE_SINGLE_SUCCESS,successSingle),_defineProperty(_createReducer,Types.EXCHANGE_RATE_SINGLE_REQUEST,request),_defineProperty(_createReducer,Types.EXCHANGE_RATE_SINGLE_FAILURE,failure),_defineProperty(_createReducer,Types.EXCHANGE_RATE_UPDATE_SUCCESS,manipulateSuccess),_defineProperty(_createReducer,Types.EXCHANGE_RATE_UPDATE_REQUEST,request),_defineProperty(_createReducer,Types.EXCHANGE_RATE_UPDATE_FAILURE,failure),_createReducer));

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FailedTransactionTypes; });
/* unused harmony export INITIAL_STATE */
/* unused harmony export request */
/* unused harmony export success */
/* unused harmony export failure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return reducer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
var _createReducer;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({getFailedTransactionRequest:['data'],getFailedTransactionSuccess:['data'],getFailedTransactionFailure:['err'],triggerFailedTransactionRequest:['data'],triggerFailedTransactionSuccess:['data'],triggerFailedTransactionFailure:['err']}),Types=_createActions.Types,Creators=_createActions.Creators;var FailedTransactionTypes=Types;/* harmony default export */ __webpack_exports__["b"] = (Creators);/* ------------- Initial State ------------- */var INITIAL_STATE=__WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()({fetching:false,data:[],err:null,processing:false,success:null});/* ------------- Reducers ------------- */var request=function request(state){return state.merge({fetching:true,err:null,success:null});};var success=function success(state,_ref){var data=_ref.data;return state.merge({fetching:false,data:data,err:null});};var failure=function failure(state,_ref2){var err=_ref2.err;return state.merge({fetching:false,err:err});};/* ------------- Hook Reducers To Types ------------- */var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createReducer"])(INITIAL_STATE,(_createReducer={},_defineProperty(_createReducer,Types.GET_FAILED_TRANSACTION_SUCCESS,success),_defineProperty(_createReducer,Types.GET_FAILED_TRANSACTION_REQUEST,request),_defineProperty(_createReducer,Types.GET_FAILED_TRANSACTION_FAILURE,failure),_defineProperty(_createReducer,Types.TRIGGER_FAILED_TRANSACTION_SUCCESS,success),_defineProperty(_createReducer,Types.TRIGGER_FAILED_TRANSACTION_REQUEST,request),_defineProperty(_createReducer,Types.TRIGGER_FAILED_TRANSACTION_FAILURE,failure),_createReducer));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(497);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(226);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(312),
    isLength = __webpack_require__(229);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  F: __webpack_require__(557),
  T: __webpack_require__(231),
  __: __webpack_require__(558),
  add: __webpack_require__(171),
  addIndex: __webpack_require__(559),
  adjust: __webpack_require__(232),
  all: __webpack_require__(560),
  allPass: __webpack_require__(562),
  always: __webpack_require__(113),
  and: __webpack_require__(323),
  any: __webpack_require__(324),
  anyPass: __webpack_require__(234),
  ap: __webpack_require__(235),
  aperture: __webpack_require__(564),
  append: __webpack_require__(567),
  apply: __webpack_require__(326),
  applySpec: __webpack_require__(568),
  ascend: __webpack_require__(569),
  assoc: __webpack_require__(176),
  assocPath: __webpack_require__(328),
  binary: __webpack_require__(570),
  bind: __webpack_require__(321),
  both: __webpack_require__(571),
  call: __webpack_require__(572),
  chain: __webpack_require__(237),
  clamp: __webpack_require__(576),
  clone: __webpack_require__(577),
  comparator: __webpack_require__(578),
  complement: __webpack_require__(239),
  compose: __webpack_require__(240),
  composeK: __webpack_require__(334),
  composeP: __webpack_require__(580),
  concat: __webpack_require__(242),
  cond: __webpack_require__(246),
  construct: __webpack_require__(589),
  constructN: __webpack_require__(339),
  contains: __webpack_require__(340),
  converge: __webpack_require__(341),
  countBy: __webpack_require__(590),
  curry: __webpack_require__(132),
  curryN: __webpack_require__(40),
  dec: __webpack_require__(592),
  defaultTo: __webpack_require__(342),
  descend: __webpack_require__(593),
  difference: __webpack_require__(343),
  differenceWith: __webpack_require__(344),
  dissoc: __webpack_require__(247),
  dissocPath: __webpack_require__(594),
  divide: __webpack_require__(595),
  drop: __webpack_require__(346),
  dropLast: __webpack_require__(597),
  dropLastWhile: __webpack_require__(601),
  dropRepeats: __webpack_require__(604),
  dropRepeatsWith: __webpack_require__(348),
  dropWhile: __webpack_require__(605),
  either: __webpack_require__(607),
  empty: __webpack_require__(351),
  endsWith: __webpack_require__(352),
  eqBy: __webpack_require__(608),
  eqProps: __webpack_require__(354),
  equals: __webpack_require__(57),
  evolve: __webpack_require__(609),
  filter: __webpack_require__(243),
  find: __webpack_require__(355),
  findIndex: __webpack_require__(356),
  findLast: __webpack_require__(612),
  findLastIndex: __webpack_require__(614),
  flatten: __webpack_require__(616),
  flip: __webpack_require__(186),
  forEach: __webpack_require__(357),
  forEachObjIndexed: __webpack_require__(617),
  fromPairs: __webpack_require__(358),
  groupBy: __webpack_require__(618),
  groupWith: __webpack_require__(619),
  gt: __webpack_require__(620),
  gte: __webpack_require__(250),
  has: __webpack_require__(359),
  hasIn: __webpack_require__(621),
  head: __webpack_require__(622),
  identical: __webpack_require__(337),
  identity: __webpack_require__(150),
  ifElse: __webpack_require__(360),
  inc: __webpack_require__(623),
  indexBy: __webpack_require__(624),
  indexOf: __webpack_require__(625),
  init: __webpack_require__(626),
  innerJoin: __webpack_require__(627),
  insert: __webpack_require__(628),
  insertAll: __webpack_require__(629),
  intersection: __webpack_require__(630),
  intersectionWith: __webpack_require__(632),
  intersperse: __webpack_require__(633),
  into: __webpack_require__(634),
  invert: __webpack_require__(637),
  invertObj: __webpack_require__(638),
  invoker: __webpack_require__(151),
  is: __webpack_require__(187),
  isEmpty: __webpack_require__(255),
  isNil: __webpack_require__(177),
  join: __webpack_require__(639),
  juxt: __webpack_require__(363),
  keys: __webpack_require__(66),
  keysIn: __webpack_require__(640),
  last: __webpack_require__(349),
  lastIndexOf: __webpack_require__(641),
  length: __webpack_require__(364),
  lens: __webpack_require__(188),
  lensIndex: __webpack_require__(642),
  lensPath: __webpack_require__(643),
  lensProp: __webpack_require__(644),
  lift: __webpack_require__(180),
  liftN: __webpack_require__(329),
  lt: __webpack_require__(645),
  lte: __webpack_require__(646),
  map: __webpack_require__(45),
  mapAccum: __webpack_require__(647),
  mapAccumRight: __webpack_require__(648),
  mapObjIndexed: __webpack_require__(649),
  match: __webpack_require__(650),
  mathMod: __webpack_require__(651),
  max: __webpack_require__(131),
  maxBy: __webpack_require__(652),
  mean: __webpack_require__(366),
  median: __webpack_require__(653),
  memoize: __webpack_require__(654),
  memoizeWith: __webpack_require__(368),
  merge: __webpack_require__(369),
  mergeAll: __webpack_require__(655),
  mergeDeepLeft: __webpack_require__(656),
  mergeDeepRight: __webpack_require__(657),
  mergeDeepWith: __webpack_require__(658),
  mergeDeepWithKey: __webpack_require__(189),
  mergeWith: __webpack_require__(659),
  mergeWithKey: __webpack_require__(256),
  min: __webpack_require__(660),
  minBy: __webpack_require__(661),
  modulo: __webpack_require__(662),
  multiply: __webpack_require__(370),
  nAry: __webpack_require__(178),
  negate: __webpack_require__(663),
  none: __webpack_require__(664),
  not: __webpack_require__(333),
  nth: __webpack_require__(149),
  nthArg: __webpack_require__(665),
  o: __webpack_require__(666),
  objOf: __webpack_require__(362),
  of: __webpack_require__(667),
  omit: __webpack_require__(669),
  once: __webpack_require__(670),
  or: __webpack_require__(350),
  over: __webpack_require__(371),
  pair: __webpack_require__(671),
  partial: __webpack_require__(372),
  partialRight: __webpack_require__(672),
  partition: __webpack_require__(673),
  path: __webpack_require__(133),
  pathEq: __webpack_require__(674),
  pathOr: __webpack_require__(675),
  pathSatisfies: __webpack_require__(676),
  pick: __webpack_require__(677),
  pickAll: __webpack_require__(374),
  pickBy: __webpack_require__(678),
  pipe: __webpack_require__(181),
  pipeK: __webpack_require__(679),
  pipeP: __webpack_require__(335),
  pluck: __webpack_require__(145),
  prepend: __webpack_require__(375),
  product: __webpack_require__(680),
  project: __webpack_require__(681),
  prop: __webpack_require__(175),
  propEq: __webpack_require__(377),
  propIs: __webpack_require__(378),
  propOr: __webpack_require__(682),
  propSatisfies: __webpack_require__(379),
  props: __webpack_require__(683),
  range: __webpack_require__(380),
  reduce: __webpack_require__(74),
  reduceBy: __webpack_require__(184),
  reduceRight: __webpack_require__(381),
  reduceWhile: __webpack_require__(684),
  reduced: __webpack_require__(685),
  reject: __webpack_require__(183),
  remove: __webpack_require__(345),
  repeat: __webpack_require__(686),
  replace: __webpack_require__(687),
  reverse: __webpack_require__(182),
  scan: __webpack_require__(688),
  sequence: __webpack_require__(383),
  set: __webpack_require__(689),
  slice: __webpack_require__(114),
  sort: __webpack_require__(690),
  sortBy: __webpack_require__(691),
  sortWith: __webpack_require__(692),
  split: __webpack_require__(384),
  splitAt: __webpack_require__(693),
  splitEvery: __webpack_require__(694),
  splitWhen: __webpack_require__(695),
  startsWith: __webpack_require__(385),
  subtract: __webpack_require__(696),
  sum: __webpack_require__(367),
  symmetricDifference: __webpack_require__(697),
  symmetricDifferenceWith: __webpack_require__(698),
  tail: __webpack_require__(241),
  take: __webpack_require__(249),
  takeLast: __webpack_require__(353),
  takeLastWhile: __webpack_require__(699),
  takeWhile: __webpack_require__(700),
  tap: __webpack_require__(702),
  test: __webpack_require__(703),
  times: __webpack_require__(382),
  toLower: __webpack_require__(705),
  toPairs: __webpack_require__(386),
  toPairsIn: __webpack_require__(706),
  toString: __webpack_require__(148),
  toUpper: __webpack_require__(707),
  transduce: __webpack_require__(708),
  transpose: __webpack_require__(709),
  traverse: __webpack_require__(710),
  trim: __webpack_require__(711),
  tryCatch: __webpack_require__(712),
  type: __webpack_require__(238),
  unapply: __webpack_require__(713),
  unary: __webpack_require__(714),
  uncurryN: __webpack_require__(715),
  unfold: __webpack_require__(716),
  union: __webpack_require__(717),
  unionWith: __webpack_require__(718),
  uniq: __webpack_require__(252),
  uniqBy: __webpack_require__(361),
  uniqWith: __webpack_require__(253),
  unless: __webpack_require__(719),
  unnest: __webpack_require__(720),
  until: __webpack_require__(721),
  update: __webpack_require__(248),
  useWith: __webpack_require__(376),
  values: __webpack_require__(327),
  valuesIn: __webpack_require__(722),
  view: __webpack_require__(723),
  when: __webpack_require__(724),
  where: __webpack_require__(387),
  whereEq: __webpack_require__(725),
  without: __webpack_require__(726),
  xprod: __webpack_require__(727),
  zip: __webpack_require__(728),
  zipObj: __webpack_require__(729),
  zipWith: __webpack_require__(730)
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(113);


/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */
module.exports = always(true);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry3 = __webpack_require__(6);


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */
module.exports = _curry3(function adjust(fn, idx, list) {
  if (idx >= list.length || idx < -list.length) {
    return list;
  }
  var start = idx < 0 ? list.length : 0;
  var _idx = start + idx;
  var _list = _concat(list);
  _list[_idx] = fn(list[_idx]);
  return _list;
});


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function _isTransformer(obj) {
  return typeof obj['@@transducer/step'] === 'function';
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var curryN = __webpack_require__(40);
var max = __webpack_require__(131);
var pluck = __webpack_require__(145);
var reduce = __webpack_require__(74);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      var isClub = R.propEq('suit', '♣');
 *      var isSpade = R.propEq('suit', '♠');
 *      var isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */
module.exports = _curry1(function anyPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (preds[idx].apply(this, arguments)) {
        return true;
      }
      idx += 1;
    }
    return false;
  });
});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);
var _reduce = __webpack_require__(56);
var map = __webpack_require__(45);


/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */
module.exports = _curry2(function ap(applyF, applyX) {
  return (
    typeof applyX['fantasy-land/ap'] === 'function' ?
      applyX['fantasy-land/ap'](applyF) :
    typeof applyF.ap === 'function' ?
      applyF.ap(applyX) :
    typeof applyF === 'function' ?
      function(x) { return applyF(x)(applyX(x)); } :
    // else
      _reduce(function(acc, f) { return _concat(acc, map(f, applyX)); }, [], applyF)
  );
});


/***/ }),
/* 236 */
/***/ (function(module, exports) {

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
module.exports = Number.isInteger || function _isInteger(n) {
  return (n << 0) === n;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _makeFlat = __webpack_require__(330);
var _xchain = __webpack_require__(573);
var map = __webpack_require__(45);


/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */
module.exports = _curry2(_dispatchable(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
  if (typeof monad === 'function') {
    return function(x) { return fn(monad(x))(x); };
  }
  return _makeFlat(false)(map(fn, monad));
}));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 */
module.exports = _curry1(function type(val) {
  return val === null      ? 'Null'      :
         val === undefined ? 'Undefined' :
         Object.prototype.toString.call(val).slice(8, -1);
});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var lift = __webpack_require__(180);
var not = __webpack_require__(333);


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */
module.exports = lift(not);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var pipe = __webpack_require__(181);
var reverse = __webpack_require__(182);


/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
module.exports = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(147);
var _curry1 = __webpack_require__(5);
var slice = __webpack_require__(114);


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
module.exports = _curry1(_checkForMethod('tail', slice(1, Infinity)));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isArray = __webpack_require__(93);
var _isFunction = __webpack_require__(179);
var _isString = __webpack_require__(146);
var toString = __webpack_require__(148);


/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */
module.exports = _curry2(function concat(a, b) {
  if (_isArray(a)) {
    if (_isArray(b)) {
      return a.concat(b);
    }
    throw new TypeError(toString(b) + ' is not an array');
  }
  if (_isString(a)) {
    if (_isString(b)) {
      return a + b;
    }
    throw new TypeError(toString(b) + ' is not a string');
  }
  if (a != null && _isFunction(a['fantasy-land/concat'])) {
    return a['fantasy-land/concat'](b);
  }
  if (a != null && _isFunction(a.concat)) {
    return a.concat(b);
  }
  throw new TypeError(toString(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _filter = __webpack_require__(244);
var _isObject = __webpack_require__(245);
var _reduce = __webpack_require__(56);
var _xfilter = __webpack_require__(588);
var keys = __webpack_require__(66);


/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */
module.exports = _curry2(_dispatchable(['filter'], _xfilter, function(pred, filterable) {
  return (
    _isObject(filterable) ?
      _reduce(function(acc, key) {
        if (pred(filterable[key])) {
          acc[key] = filterable[key];
        }
        return acc;
      }, {}, keys(filterable)) :
    // else
      _filter(pred, filterable)
  );
}));


/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
};


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry1 = __webpack_require__(5);
var map = __webpack_require__(45);
var max = __webpack_require__(131);
var reduce = __webpack_require__(74);


/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @example
 *
 *      var fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */
module.exports = _curry1(function cond(pairs) {
  var arity = reduce(max,
                     0,
                     map(function(pair) { return pair[0].length; }, pairs));
  return _arity(arity, function() {
    var idx = 0;
    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }
      idx += 1;
    }
  });
});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
module.exports = _curry2(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var adjust = __webpack_require__(232);
var always = __webpack_require__(113);


/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */
module.exports = _curry3(function update(idx, x, list) {
  return adjust(always(x), idx, list);
});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xtake = __webpack_require__(599);
var slice = __webpack_require__(114);


/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      var personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      var takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */
module.exports = _curry2(_dispatchable(['take'], _xtake, function take(n, xs) {
  return slice(0, n < 0 ? Infinity : n, xs);
}));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */
module.exports = _curry2(function gte(a, b) { return a >= b; });


/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = function _identity(x) { return x; };


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(150);
var uniqBy = __webpack_require__(361);


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */
module.exports = uniqBy(identity);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(185);
var _curry2 = __webpack_require__(3);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      var strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */
module.exports = _curry2(function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;
  while (idx < len) {
    item = list[idx];
    if (!_containsWith(pred, item, result)) {
      result[result.length] = item;
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var _objectAssign = __webpack_require__(636);

module.exports =
  typeof Object.assign === 'function' ? Object.assign : _objectAssign;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var empty = __webpack_require__(351);
var equals = __webpack_require__(57);


/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */
module.exports = _curry1(function isEmpty(x) {
  return x != null && equals(x, empty(x));
});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var _has = __webpack_require__(46);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (String -> a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */
module.exports = _curry3(function mergeWithKey(fn, l, r) {
  var result = {};
  var k;

  for (k in l) {
    if (_has(k, l)) {
      result[k] = _has(k, r) ? fn(k, l[k], r[k]) : l[k];
    }
  }

  for (k in r) {
    if (_has(k, r) && !(_has(k, result))) {
      result[k] = r[k];
    }
  }

  return result;
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(33),
    isSymbol = __webpack_require__(169);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(742),
    mapCacheDelete = __webpack_require__(758),
    mapCacheGet = __webpack_require__(760),
    mapCacheHas = __webpack_require__(761),
    mapCacheSet = __webpack_require__(762);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(763);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(803),
    baseMatchesProperty = __webpack_require__(833),
    identity = __webpack_require__(837),
    isArray = __webpack_require__(33),
    property = __webpack_require__(838);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var _require = __webpack_require__(873),
    canvasStyle = _require.canvasStyle,
    mirrorProps = _require.mirrorProps;

var _require2 = __webpack_require__(874),
    omit = _require2.omit;

function prevSibling(node, count) {
  while (node && count--) {
    node = node.previousElementSibling;
  }
  return node;
}

var defaultProps = {
  basedOn: undefined,
  className: '',
  component: 'div',
  ellipsis: '…', // &hellip;
  maxLine: 1,
  onReflow: function onReflow() {},

  text: '',
  trimRight: true,
  winWidth: undefined // for the HOC
};
var usedProps = Object.keys(defaultProps);
/**
 * props.text {String} the text you want to clamp
 * props.maxLine {Number|String} max lines allowed
 * props.ellipsis {String} the ellipsis indicator
 * props.trimRight {Boolean} should we trimRight the clamped text?
 * props.basedOn {String} letters|words
 * props.className {String}
 */

var LinesEllipsis = function (_React$PureComponent) {
  _inherits(LinesEllipsis, _React$PureComponent);

  function LinesEllipsis(props) {
    _classCallCheck(this, LinesEllipsis);

    var _this = _possibleConstructorReturn(this, (LinesEllipsis.__proto__ || Object.getPrototypeOf(LinesEllipsis)).call(this, props));

    _this.state = {
      text: props.text,
      clamped: false
    };
    _this.units = [];
    _this.maxLine = 0;
    _this.canvas = null;
    return _this;
  }

  _createClass(LinesEllipsis, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initCanvas();
      this.reflow(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.winWidth !== this.props.winWidth) {
        this.copyStyleToCanvas();
      }
      this.reflow(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.canvas.parentNode.removeChild(this.canvas);
    }
  }, {
    key: 'setState',
    value: function setState(state, callback) {
      if (typeof state.clamped !== 'undefined') {
        this.clamped = state.clamped;
      }
      return _get(LinesEllipsis.prototype.__proto__ || Object.getPrototypeOf(LinesEllipsis.prototype), 'setState', this).call(this, state, callback);
    }
  }, {
    key: 'initCanvas',
    value: function initCanvas() {
      if (this.canvas) return;
      var canvas = this.canvas = document.createElement('div');
      canvas.className = 'LinesEllipsis-canvas ' + this.props.className;
      canvas.setAttribute('aria-hidden', 'true');
      this.copyStyleToCanvas();
      Object.keys(canvasStyle).forEach(function (key) {
        canvas.style[key] = canvasStyle[key];
      });
      document.body.appendChild(canvas);
    }
  }, {
    key: 'copyStyleToCanvas',
    value: function copyStyleToCanvas() {
      var _this2 = this;

      var targetStyle = window.getComputedStyle(this.target);
      mirrorProps.forEach(function (key) {
        _this2.canvas.style[key] = targetStyle[key];
      });
    }
  }, {
    key: 'reflow',
    value: function reflow(props) {
      /* eslint-disable no-control-regex */
      var basedOn = props.basedOn || (/^[\x00-\x7F]+$/.test(props.text) ? 'words' : 'letters');
      switch (basedOn) {
        case 'words':
          this.units = props.text.split(/\b|(?=\W)/);
          break;
        case 'letters':
          this.units = Array.from(props.text);
          break;
        default:
          throw new Error('Unsupported options basedOn: ' + basedOn);
      }
      this.maxLine = +props.maxLine || 1;
      this.canvas.innerHTML = this.units.map(function (c) {
        return '<span class=\'LinesEllipsis-unit\'>' + c + '</span>';
      }).join('');
      var ellipsisIndex = this.putEllipsis(this.calcIndexes());
      var clamped = ellipsisIndex > -1;
      var newState = {
        clamped: clamped,
        text: clamped ? this.units.slice(0, ellipsisIndex).join('') : props.text
      };
      this.setState(newState, props.onReflow.bind(this, newState));
    }
  }, {
    key: 'calcIndexes',
    value: function calcIndexes() {
      var indexes = [0];
      var elt = this.canvas.firstElementChild;
      if (!elt) return indexes;

      var index = 0;
      var line = 1;
      var offsetTop = elt.offsetTop;
      while (elt = elt.nextElementSibling) {
        if (elt.offsetTop > offsetTop) {
          line++;
          indexes.push(index);
          offsetTop = elt.offsetTop;
        }
        index++;
        if (line > this.maxLine) {
          break;
        }
      }
      return indexes;
    }
  }, {
    key: 'putEllipsis',
    value: function putEllipsis(indexes) {
      if (indexes.length <= this.maxLine) return -1;
      var lastIndex = indexes[this.maxLine];
      var units = this.units.slice(0, lastIndex);
      var maxOffsetTop = this.canvas.children[lastIndex].offsetTop;
      this.canvas.innerHTML = units.map(function (c, i) {
        return '<span class=\'LinesEllipsis-unit\'>' + c + '</span>';
      }).join('') + ('<wbr><span class=\'LinesEllipsis-ellipsis\'>' + this.props.ellipsis + '</span>');
      var ndEllipsis = this.canvas.lastElementChild;
      var ndPrevUnit = prevSibling(ndEllipsis, 2);
      while (ndPrevUnit && (ndEllipsis.offsetTop > maxOffsetTop || // IE & Edge: doesn't support <wbr>
      ndEllipsis.offsetHeight > ndPrevUnit.offsetHeight || ndEllipsis.offsetTop > ndPrevUnit.offsetTop)) {
        this.canvas.removeChild(ndPrevUnit);
        ndPrevUnit = prevSibling(ndEllipsis, 2);
        units.pop();
      }
      return units.length;
    }

    // expose

  }, {
    key: 'isClamped',
    value: function isClamped() {
      return this.clamped; // do not use state.clamped. #27
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          text = _state.text,
          clamped = _state.clamped;

      var _props = this.props,
          Component = _props.component,
          ellipsis = _props.ellipsis,
          trimRight = _props.trimRight,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['component', 'ellipsis', 'trimRight', 'className']);

      return React.createElement(
        Component,
        _extends({
          className: 'LinesEllipsis ' + (clamped ? 'LinesEllipsis--clamped' : '') + ' ' + className,
          ref: function ref(node) {
            return _this3.target = node;
          }
        }, omit(rest, usedProps)),
        clamped && trimRight ? text.replace(/[\s\uFEFF\xA0]+$/, '') : text,
        React.createElement('wbr', null),
        clamped && React.createElement(
          'span',
          { className: 'LinesEllipsis-ellipsis' },
          ellipsis
        )
      );
    }
  }]);

  return LinesEllipsis;
}(React.PureComponent);

LinesEllipsis.defaultProps = defaultProps;

module.exports = LinesEllipsis;



/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var document = __webpack_require__(12).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(43);
var LIBRARY = __webpack_require__(100);
var wksExt = __webpack_require__(411);
var defineProperty = __webpack_require__(25).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(154)('keys');
var uid = __webpack_require__(118);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 267 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(12).document;
module.exports = document && document.documentElement;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(202);
var pIE = __webpack_require__(156);
var toObject = __webpack_require__(32);
var IObject = __webpack_require__(155);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(15)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(7);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(59)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var setPrototypeOf = __webpack_require__(270).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(70);
var defined = __webpack_require__(79);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(207);
var defined = __webpack_require__(79);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(21)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(121);
var ITERATOR = __webpack_require__(21)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(25);
var createDesc = __webpack_require__(99);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1037);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(24);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(103);
var step = __webpack_require__(284);
var Iterators = __webpack_require__(121);
var toIObject = __webpack_require__(44);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(205)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(158);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(204)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(59);
var invoke = __webpack_require__(271);
var html = __webpack_require__(268);
var cel = __webpack_require__(264);
var global = __webpack_require__(12);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(69)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var macrotask = __webpack_require__(287).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(69)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(37);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var DESCRIPTORS = __webpack_require__(23);
var LIBRARY = __webpack_require__(100);
var $typed = __webpack_require__(213);
var hide = __webpack_require__(50);
var redefineAll = __webpack_require__(124);
var fails = __webpack_require__(15);
var anInstance = __webpack_require__(123);
var toInteger = __webpack_require__(70);
var toLength = __webpack_require__(24);
var toIndex = __webpack_require__(435);
var gOPN = __webpack_require__(120).f;
var dP = __webpack_require__(25).f;
var arrayFill = __webpack_require__(282);
var setToStringTag = __webpack_require__(139);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(120);
var gOPS = __webpack_require__(202);
var anObject = __webpack_require__(7);
var Reflect = __webpack_require__(12).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(62);
var normalizeHeaderName = __webpack_require__(1326);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(464);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(464);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)))

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(471);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(480);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(297);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(485);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(498);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(491);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(305);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(221);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(308);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(227);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(519)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isObject = __webpack_require__(72);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(540);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(548),
    isObjectLike = __webpack_require__(130);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(84),
    stubFalse = __webpack_require__(549);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144)(module)))

/***/ }),
/* 318 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(550),
    baseUnary = __webpack_require__(551),
    nodeUtil = __webpack_require__(552);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = (function() {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function() {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
  XWrap.prototype['@@transducer/step'] = function(acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) { return new XWrap(fn); };
}());


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry2 = __webpack_require__(3);


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
module.exports = _curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(46);


module.exports = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has('callee', x); };
}());


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */
module.exports = _curry2(function and(a, b) {
  return a && b;
});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xany = __webpack_require__(325);


/**
 * Returns `true` if at least one of elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      var lessThan0 = R.flip(R.lt)(0);
 *      var lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */
module.exports = _curry2(_dispatchable(['any'], _xany, function any(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (fn(list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XAny(f, xf) {
    this.xf = xf;
    this.f = f;
    this.any = false;
  }
  XAny.prototype['@@transducer/init'] = _xfBase.init;
  XAny.prototype['@@transducer/result'] = function(result) {
    if (!this.any) {
      result = this.xf['@@transducer/step'](result, false);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAny.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.any = true;
      result = _reduced(this.xf['@@transducer/step'](result, true));
    }
    return result;
  };

  return _curry2(function _xany(f, xf) { return new XAny(f, xf); });
}());


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      var nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */
module.exports = _curry2(function apply(fn, args) {
  return fn.apply(this, args);
});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var keys = __webpack_require__(66);


/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */
module.exports = _curry1(function values(obj) {
  var props = keys(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var _has = __webpack_require__(46);
var _isArray = __webpack_require__(93);
var _isInteger = __webpack_require__(236);
var assoc = __webpack_require__(176);
var isNil = __webpack_require__(177);


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */
module.exports = _curry3(function assocPath(path, val, obj) {
  if (path.length === 0) {
    return val;
  }
  var idx = path[0];
  if (path.length > 1) {
    var nextObj = (!isNil(obj) && _has(idx, obj)) ? obj[idx] : _isInteger(path[1]) ? [] : {};
    val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
  }
  if (_isInteger(idx) && _isArray(obj)) {
    var arr = [].concat(obj);
    arr[idx] = val;
    return arr;
  } else {
    return assoc(idx, val, obj);
  }
});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduce = __webpack_require__(56);
var ap = __webpack_require__(235);
var curryN = __webpack_require__(40);
var map = __webpack_require__(45);


/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */
module.exports = _curry2(function liftN(arity, fn) {
  var lifted = curryN(arity, fn);
  return curryN(arity, function() {
    return _reduce(ap, map(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var _isArrayLike = __webpack_require__(174);


/**
 * `_makeFlat` is a helper function that returns a one-level or fully recursive
 * function based on the flag passed in.
 *
 * @private
 */
module.exports = function _makeFlat(recursive) {
  return function flatt(list) {
    var value, jlen, j;
    var result = [];
    var idx = 0;
    var ilen = list.length;

    while (idx < ilen) {
      if (_isArrayLike(list[idx])) {
        value = recursive ? flatt(list[idx]) : list[idx];
        j = 0;
        jlen = value.length;
        while (j < jlen) {
          result[result.length] = value[j];
          j += 1;
        }
      } else {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
    return result;
  };
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(332);
var type = __webpack_require__(238);


/**
 * Copies an object.
 *
 * @private
 * @param {*} value The value to be copied
 * @param {Array} refFrom Array containing the source references
 * @param {Array} refTo Array containing the copied source references
 * @param {Boolean} deep Whether or not to perform deep cloning.
 * @return {*} The copied value.
 */
module.exports = function _clone(value, refFrom, refTo, deep) {
  var copy = function copy(copiedValue) {
    var len = refFrom.length;
    var idx = 0;
    while (idx < len) {
      if (value === refFrom[idx]) {
        return refTo[idx];
      }
      idx += 1;
    }
    refFrom[idx + 1] = value;
    refTo[idx + 1] = copiedValue;
    for (var key in value) {
      copiedValue[key] = deep ?
        _clone(value[key], refFrom, refTo, true) : value[key];
    }
    return copiedValue;
  };
  switch (type(value)) {
    case 'Object':  return copy({});
    case 'Array':   return copy([]);
    case 'Date':    return new Date(value.valueOf());
    case 'RegExp':  return _cloneRegExp(value);
    default:        return value;
  }
};


/***/ }),
/* 332 */
/***/ (function(module, exports) {

module.exports = function _cloneRegExp(pattern) {
  return new RegExp(pattern.source, (pattern.global     ? 'g' : '') +
                                    (pattern.ignoreCase ? 'i' : '') +
                                    (pattern.multiline  ? 'm' : '') +
                                    (pattern.sticky     ? 'y' : '') +
                                    (pattern.unicode    ? 'u' : ''));
};


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */
module.exports = _curry1(function not(a) {
  return !a;
});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var chain = __webpack_require__(237);
var compose = __webpack_require__(240);
var map = __webpack_require__(45);


/**
 * Returns the right-to-left Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.composeK(h, g, f)` is equivalent to `R.compose(R.chain(h), R.chain(g), R.chain(f))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((y -> m z), (x -> m y), ..., (a -> m b)) -> (a -> m z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipeK
 * @example
 *
 *       //  get :: String -> Object -> Maybe *
 *       var get = R.curry((propName, obj) => Maybe(obj[propName]))
 *
 *       //  getStateCode :: Maybe String -> Maybe String
 *       var getStateCode = R.composeK(
 *         R.compose(Maybe.of, R.toUpper),
 *         get('state'),
 *         get('address'),
 *         get('user'),
 *       );
 *       getStateCode({"user":{"address":{"state":"ny"}}}); //=> Maybe.Just("NY")
 *       getStateCode({}); //=> Maybe.Nothing()
 * @symb R.composeK(f, g, h)(a) = R.chain(f, R.chain(g, h(a)))
 */
module.exports = function composeK() {
  if (arguments.length === 0) {
    throw new Error('composeK requires at least one argument');
  }
  var init = Array.prototype.slice.call(arguments);
  var last = init.pop();
  return compose(compose.apply(this, map(chain, init)), last);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _pipeP = __webpack_require__(581);
var reduce = __webpack_require__(74);
var tail = __webpack_require__(241);


/**
 * Performs left-to-right composition of one or more Promise-returning
 * functions. The leftmost function may have any arity; the remaining functions
 * must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a -> Promise b), (b -> Promise c), ..., (y -> Promise z)) -> (a -> Promise z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeP
 * @example
 *
 *      //  followersForUser :: String -> Promise [User]
 *      var followersForUser = R.pipeP(db.getUserById, db.getFollowers);
 */
module.exports = function pipeP() {
  if (arguments.length === 0) {
    throw new Error('pipeP requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipeP, arguments[0], tail(arguments)));
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var equals = __webpack_require__(57);


module.exports = function _indexOf(list, a, idx) {
  var inf, item;
  // Array.prototype.indexOf doesn't exist below IE9
  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === 'number' && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        // non-zero numbers can utilise Set
        return list.indexOf(a, idx);

      // all these types can utilise Set
      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }
    }
  }
  // anything else not covered above, defer to R.equals
  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */
module.exports = _curry2(function identical(a, b) {
  // SameValue algorithm
  if (a === b) { // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
});


/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var curry = __webpack_require__(132);
var nAry = __webpack_require__(178);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      };
 *      Salad.prototype.recipe = function() {
 *        var instructions = R.map((ingredient) => (
 *          'Add a whollop of ' + ingredient, this.ingredients)
 *        )
 *        return R.join('\n', instructions)
 *      }
 *
 *      var ThreeLayerSalad = R.constructN(3, Salad)
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup')
 *      console.log(salad.recipe());
 *      // Add a whollop of Mayonnaise
 *      // Add a whollop of Potato Chips
 *      // Add a whollop of Potato Ketchup
 */
module.exports = _curry2(function constructN(n, Fn) {
  if (n > 10) {
    throw new Error('Constructor with greater than ten arguments');
  }
  if (n === 0) {
    return function() { return new Fn(); };
  }
  return curry(nAry(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
    switch (arguments.length) {
      case  1: return new Fn($0);
      case  2: return new Fn($0, $1);
      case  3: return new Fn($0, $1, $2);
      case  4: return new Fn($0, $1, $2, $3);
      case  5: return new Fn($0, $1, $2, $3, $4);
      case  6: return new Fn($0, $1, $2, $3, $4, $5);
      case  7: return new Fn($0, $1, $2, $3, $4, $5, $6);
      case  8: return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
      case  9: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
      case 10: return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
    }
  }));
});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */
module.exports = _curry2(_contains);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _map = __webpack_require__(173);
var curryN = __webpack_require__(40);
var max = __webpack_require__(131);
var pluck = __webpack_require__(145);
var reduce = __webpack_require__(74);


/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> b -> ... -> x1), (a -> b -> ... -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */
module.exports = _curry2(function converge(after, fns) {
  return curryN(reduce(max, 0, pluck('length', fns)), function() {
    var args = arguments;
    var context = this;
    return after.apply(context, _map(function(fn) {
      return fn.apply(context, args);
    }, fns));
  });
});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      var defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */
module.exports = _curry2(function defaultTo(d, v) {
  return v == null || v !== v ? d : v;
});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _curry2 = __webpack_require__(3);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */
module.exports = _curry2(function difference(first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_contains(first[idx], second) && !_contains(first[idx], out)) {
      out[out.length] = first[idx];
    }
    idx += 1;
  }
  return out;
});


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(185);
var _curry3 = __webpack_require__(6);


/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      var cmp = (x, y) => x.a === y.a;
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      var l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */
module.exports = _curry3(function differenceWith(pred, first, second) {
  var out = [];
  var idx = 0;
  var firstLen = first.length;
  while (idx < firstLen) {
    if (!_containsWith(pred, first[idx], second) &&
        !_containsWith(pred, first[idx], out)) {
      out.push(first[idx]);
    }
    idx += 1;
  }
  return out;
});


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */
module.exports = _curry3(function remove(start, count, list) {
  var result = Array.prototype.slice.call(list, 0);
  result.splice(start, count);
  return result;
});


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xdrop = __webpack_require__(596);
var slice = __webpack_require__(114);


/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */
module.exports = _curry2(_dispatchable(['drop'], _xdrop, function drop(n, xs) {
  return slice(Math.max(0, n), Infinity, xs);
}));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XDropRepeatsWith(pred, xf) {
    this.xf = xf;
    this.pred = pred;
    this.lastValue = undefined;
    this.seenFirstValue = false;
  }

  XDropRepeatsWith.prototype['@@transducer/init'] = _xfBase.init;
  XDropRepeatsWith.prototype['@@transducer/result'] = _xfBase.result;
  XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
    var sameAsLast = false;
    if (!this.seenFirstValue) {
      this.seenFirstValue = true;
    } else if (this.pred(this.lastValue, input)) {
      sameAsLast = true;
    }
    this.lastValue = input;
    return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropRepeatsWith(pred, xf) { return new XDropRepeatsWith(pred, xf); });
}());


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xdropRepeatsWith = __webpack_require__(347);
var last = __webpack_require__(349);


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a, a -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */
module.exports = _curry2(_dispatchable([], _xdropRepeatsWith, function dropRepeatsWith(pred, list) {
  var result = [];
  var idx = 1;
  var len = list.length;
  if (len !== 0) {
    result[0] = list[0];
    while (idx < len) {
      if (!pred(last(result), list[idx])) {
        result[result.length] = list[idx];
      }
      idx += 1;
    }
  }
  return result;
}));



/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(149);


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */
module.exports = nth(-1);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */
module.exports = _curry2(function or(a, b) {
  return a || b;
});


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _isArguments = __webpack_require__(322);
var _isArray = __webpack_require__(93);
var _isObject = __webpack_require__(245);
var _isString = __webpack_require__(146);


/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty` and/or
 * `<Type>.prototype.empty`.
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */
module.exports = _curry1(function empty(x) {
  return (
    (x != null && typeof x['fantasy-land/empty'] === 'function') ?
      x['fantasy-land/empty']() :
    (x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function') ?
      x.constructor['fantasy-land/empty']() :
    (x != null && typeof x.empty === 'function') ?
      x.empty() :
    (x != null && x.constructor != null && typeof x.constructor.empty === 'function') ?
      x.constructor.empty() :
    _isArray(x) ?
      [] :
    _isString(x) ?
      '' :
    _isObject(x) ?
      {} :
    _isArguments(x) ?
      (function() { return arguments; }()) :
    // else
      void 0
  );
});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var equals = __webpack_require__(57);
var takeLast = __webpack_require__(353);

/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(suffix, list) {
  return equals(takeLast(suffix.length, list), suffix);
});


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var drop = __webpack_require__(346);


/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */
module.exports = _curry2(function takeLast(n, xs) {
  return drop(n >= 0 ? xs.length - n : 0, xs);
});


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var equals = __webpack_require__(57);


/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */
module.exports = _curry3(function eqProps(prop, obj1, obj2) {
  return equals(obj1[prop], obj2[prop]);
});


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xfind = __webpack_require__(610);


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable(['find'], _xfind, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xfindIndex = __webpack_require__(611);


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindIndex, function findIndex(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(147);
var _curry2 = __webpack_require__(3);


/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      var printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */
module.exports = _curry2(_checkForMethod('forEach', function forEach(fn, list) {
  var len = list.length;
  var idx = 0;
  while (idx < len) {
    fn(list[idx]);
    idx += 1;
  }
  return list;
}));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry1(function fromPairs(pairs) {
  var result = {};
  var idx = 0;
  while (idx < pairs.length) {
    result[pairs[idx][0]] = pairs[idx][1];
    idx += 1;
  }
  return result;
});


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _has = __webpack_require__(46);


/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      var hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      var point = {x: 0, y: 0};
 *      var pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */
module.exports = _curry2(_has);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var curryN = __webpack_require__(40);


/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when
 * @example
 *
 *      var incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */
module.exports = _curry3(function ifElse(condition, onTrue, onFalse) {
  return curryN(Math.max(condition.length, onTrue.length, onFalse.length),
    function _ifElse() {
      return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    }
  );
});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var _Set = __webpack_require__(631);
var _curry2 = __webpack_require__(3);


/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */
module.exports = _curry2(function uniqBy(fn, list) {
  var set = new _Set();
  var result = [];
  var idx = 0;
  var appliedItem, item;

  while (idx < list.length) {
    item = list[idx];
    appliedItem = fn(item);
    if (set.add(appliedItem)) {
      result.push(item);
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      var matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */
module.exports = _curry2(function objOf(key, val) {
  var obj = {};
  obj[key] = val;
  return obj;
});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var converge = __webpack_require__(341);


/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */
module.exports = _curry1(function juxt(fns) {
  return converge(function() { return Array.prototype.slice.call(arguments, 0); }, fns);
});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _isNumber = __webpack_require__(365);


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */
module.exports = _curry1(function length(list) {
  return list != null && _isNumber(list.length) ? list.length : NaN;
});


/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = function _isNumber(x) {
  return Object.prototype.toString.call(x) === '[object Number]';
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var sum = __webpack_require__(367);


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */
module.exports = _curry1(function mean(list) {
  return sum(list) / list.length;
});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(171);
var reduce = __webpack_require__(74);


/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */
module.exports = reduce(add, 0);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry2 = __webpack_require__(3);
var _has = __webpack_require__(46);


/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = _curry2(function memoizeWith(mFn, fn) {
  var cache = {};
  return _arity(fn.length, function() {
    var key = mFn.apply(this, arguments);
    if (!_has(key, cache)) {
      cache[key] = fn.apply(this, arguments);
    }
    return cache[key];
  });
});


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(254);
var _curry2 = __webpack_require__(3);


/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      var resetToDefault = R.merge(R.__, {x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
 */
module.exports = _curry2(function merge(l, r) {
  return _assign({}, l, r);
});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */
module.exports = _curry2(function multiply(a, b) { return a * b; });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */
module.exports = (function() {
  // `Identity` is a functor that holds a single value, where `map` simply
  // transforms the held value with the provided function.
  var Identity = function(x) {
    return {value: x, map: function(f) { return Identity(f(x)); }};
  };

  return _curry3(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) { return Identity(f(y)); })(x).value;
  });
}());


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _createPartialApplicator = __webpack_require__(373);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */
module.exports = _createPartialApplicator(_concat);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry2 = __webpack_require__(3);


module.exports = function _createPartialApplicator(concat) {
  return _curry2(function(fn, args) {
    return _arity(Math.max(0, fn.length - args.length), function() {
      return fn.apply(this, concat(args, arguments));
    });
  });
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */
module.exports = _curry2(function pickAll(names, obj) {
  var result = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    var name = names[idx];
    result[name] = obj[name];
    idx += 1;
  }
  return result;
});


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);


/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */
module.exports = _curry2(function prepend(el, list) {
  return _concat([el], list);
});


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var curryN = __webpack_require__(40);


/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (x1 -> x2 -> ... -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */
module.exports = _curry2(function useWith(fn, transformers) {
  return curryN(transformers.length, function() {
    var args = [];
    var idx = 0;
    while (idx < transformers.length) {
      args.push(transformers[idx].call(this, arguments[idx]));
      idx += 1;
    }
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
  });
});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var equals = __webpack_require__(57);


/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.equals, R.propSatisfies
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      var kids = [abby, fred, rusty, alois];
 *      var hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */
module.exports = _curry3(function propEq(name, val, obj) {
  return equals(val, obj[name]);
});


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var is = __webpack_require__(187);


/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */
module.exports = _curry3(function propIs(type, name, obj) {
  return is(type, obj[name]);
});


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */
module.exports = _curry3(function propSatisfies(pred, name, obj) {
  return pred(obj[name]);
});


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isNumber = __webpack_require__(365);


/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in tthe set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */
module.exports = _curry2(function range(from, to) {
  if (!(_isNumber(from) && _isNumber(to))) {
    throw new TypeError('Both arguments to range must be numbers');
  }
  var result = [];
  var n = from;
  while (n < to) {
    result.push(n);
    n += 1;
  }
  return result;
});


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a, b -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *          -               -2
 *         / \              / \
 *        1   -            1   3
 *           / \              / \
 *          2   -     ==>    2  -1
 *             / \              / \
 *            3   -            3   4
 *               / \              / \
 *              4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */
module.exports = _curry3(function reduceRight(fn, acc, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    acc = fn(list[idx], acc);
    idx -= 1;
  }
  return acc;
});


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */
module.exports = _curry2(function times(fn, n) {
  var len = Number(n);
  var idx = 0;
  var list;

  if (len < 0 || isNaN(len)) {
    throw new RangeError('n must be a non-negative number');
  }
  list = new Array(len);
  while (idx < len) {
    list[idx] = fn(idx);
    idx += 1;
  }
  return list;
});


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var ap = __webpack_require__(235);
var map = __webpack_require__(45);
var prepend = __webpack_require__(375);
var reduceRight = __webpack_require__(381);


/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */
module.exports = _curry2(function sequence(of, traversable) {
  return typeof traversable.sequence === 'function' ?
    traversable.sequence(of) :
    reduceRight(function(x, acc) { return ap(map(prepend, x), acc); },
                of([]),
                traversable);
});


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(151);


/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */
module.exports = invoker(1, 'split');


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var equals = __webpack_require__(57);
var take = __webpack_require__(249);

/**
 * Checks if a list starts with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */
module.exports = _curry2(function(prefix, list) {
  return equals(take(prefix.length, list), prefix);
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _has = __webpack_require__(46);


/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
module.exports = _curry1(function toPairs(obj) {
  var pairs = [];
  for (var prop in obj) {
    if (_has(prop, obj)) {
      pairs[pairs.length] = [prop, obj[prop]];
    }
  }
  return pairs;
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _has = __webpack_require__(46);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */
module.exports = _curry2(function where(spec, testObj) {
  for (var prop in spec) {
    if (_has(prop, spec) && !spec[prop](testObj[prop])) {
      return false;
    }
  }
  return true;
});


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
var MenuItem=function MenuItem(_ref){var menu=_ref.menu,location=_ref.location,role=_ref.role,branch=_ref.branch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{display:menu.hidden?'none':'inherit'},className:'/'+(location.pathname.split('/')[1]===menu.url?'active':'')+' '+(menu.subs?'open':'')},menu.subs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{role:'button'},menu.title,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa arrow'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:menu.url||'/#'},' ',menu.title,' '),menu.subs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sidebar-nav'},menu.subs.map(function(child,i){if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(child.role,role)&&__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(child.branch,branch)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,className:location.pathname===child.url?'active':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:child.url},' ',child.title,' '));}else{return null;}})));};/* harmony default export */ __webpack_exports__["a"] = (MenuItem);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(390),
    isArguments = __webpack_require__(316),
    isArray = __webpack_require__(33),
    isIndex = __webpack_require__(318),
    isLength = __webpack_require__(229),
    toKey = __webpack_require__(195);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(33),
    isKey = __webpack_require__(257),
    stringToPath = __webpack_require__(739),
    toString = __webpack_require__(260);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(20));

var _addClass = _interopRequireDefault(__webpack_require__(772));

var _removeClass = _interopRequireDefault(__webpack_require__(775));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(395));

var _PropTypes = __webpack_require__(396);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(127));

var _reactLifecyclesCompat = __webpack_require__(261);

var _PropTypes = __webpack_require__(396);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(20));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(261);

var _ChildMapping = __webpack_require__(795);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(192),
    stackClear = __webpack_require__(805),
    stackDelete = __webpack_require__(806),
    stackGet = __webpack_require__(807),
    stackHas = __webpack_require__(808),
    stackSet = __webpack_require__(809);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(810),
    isObjectLike = __webpack_require__(130);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(811),
    arraySome = __webpack_require__(814),
    cacheHas = __webpack_require__(815);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(72);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(390),
    toKey = __webpack_require__(195);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormChangeImage=function(_React$Component){_inherits(FormChangeImage,_React$Component);/**
   * NOTE : IMAGE UPLOAD IN THIS COMPONENT IS DIFFERENT / NOT USING 'FILEUPLOADER' COMPONENT LIKE THE OTHERS
   * BECAUSE ON BACKEND, TO UPDATE ATTRACTION IMAGE IS ONLY NEED TO UPLOAD IT AND THEN AUTOMATICALLY CHANGED
   */function FormChangeImage(props){_classCallCheck(this,FormChangeImage);var _this=_possibleConstructorReturn(this,(FormChangeImage.__proto__||Object.getPrototypeOf(FormChangeImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data&&!_this.state.passed){_this.setState({uploading:false,passed:true});_this.props.closeModal();}if(newProps.files.err){_this.setState({err:newProps.files.err,file:null});}};_this._fileUploaded=function(file){_this.setState({file:file});};_this._fileSelect=function(event){var file=event.target;var reader=new FileReader();reader.onloadend=function(){_this.setState({preview:reader.result});};reader.readAsDataURL(event.target.files[0]);_this.setState({file:file});};_this._upload=function(event){_this.setState({uploading:true,passed:false});if(event)event.preventDefault();var data=new FormData();var files=event.target.files[0]||_this.state.file.files[0];data.append('files',files);var item=_this.props.item;var filename='';if(item){filename=item.split('/');filename=filename[filename.length-1];filename=filename.substring(0,filename.indexOf('?'));}var setting={type:'attraction-picture',attraction_id:_this.props.attractionId,filename:filename};Object.keys(setting).map(function(key){return data.append(key,setting[key]);});_this.props.upload(data);};_this.state={file:null,passed:false,// to make sure it pass the data once, cause sometimes componentWillReceiveProps would trigger several times
uploading:false,// trgigger 'uploading ...' text
err:null,// to contain error,
preview:null};return _this;}_createClass(FormChangeImage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,closeModal=_props.closeModal,dimension=_props.dimension;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._upload(event);},className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Attraction Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},dimension),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',name:'files',required:this.props.required,className:'custom-file-input',onChange:function onChange(event){return _this2._fileSelect(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'custom-file-label'},this.state.file?'File selected':'Choose files'))),this.state.uploading&&'Uploading ...',this.state.preview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.preview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.state.preview,className:'img img-responsive',src:this.state.preview,style:{maxWidth:'100%'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Image To Preview'),this.state.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.state.err)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary mr-2'},'Save')));}}]);return FormChangeImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));},clearCache:function clearCache(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionRedux__["b" /* default */].attractionClearCacheRequest());},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormChangeImage));

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormChangeBanner=function(_React$Component){_inherits(FormChangeBanner,_React$Component);function FormChangeBanner(props){_classCallCheck(this,FormChangeBanner);var _this=_possibleConstructorReturn(this,(FormChangeBanner.__proto__||Object.getPrototypeOf(FormChangeBanner)).call(this,props));_this._fileUploaded=function(file){_this.setState({file:file});};_this._submit=function(event){event.preventDefault();var parsed={wide:null,wide_mobile:null};if(_this.props.banners){parsed=Object.assign({},parsed,_this.props.banners);}var banner_file=Object.assign({},parsed);banner_file[_this.props.bannerType]=_this.state.file;var form={banner_file:banner_file};var data={id:_this.props.attractionId,form:form};_this.props.updateAttractionDetail(data);_this.props.closeModal();};_this.state={file:null,uploaded:false};return _this;}_createClass(FormChangeBanner,[{key:'render',value:function render(){var _this2=this;var _props=this.props,bannerType=_props.bannerType,closeModal=_props.closeModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Change Banner (',bannerType,')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Banner File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},bannerType==='wide'?'1049x433':'375x269'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FileUploader__["a" /* default */],{setting:{type:'attraction-banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename);}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary',onClick:function onClick(){return closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.file,className:'btn btn-lg btn-primary ml-2'},'Save'))));}}]);return FormChangeBanner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{uploadFiles:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},reset:function reset(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormChangeBanner));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(311),
    baseIteratee = __webpack_require__(262),
    toInteger = __webpack_require__(314);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(934),
    findIndex = __webpack_require__(408);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(23) && !__webpack_require__(15)(function () {
  return Object.defineProperty(__webpack_require__(264)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(21);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(49);
var toIObject = __webpack_require__(44);
var arrayIndexOf = __webpack_require__(201)(false);
var IE_PROTO = __webpack_require__(266)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var anObject = __webpack_require__(7);
var getKeys = __webpack_require__(86);

module.exports = __webpack_require__(23) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(44);
var gOPN = __webpack_require__(120).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 415 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(37);
var isObject = __webpack_require__(16);
var invoke = __webpack_require__(271);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(12).parseInt;
var $trim = __webpack_require__(140).trim;
var ws = __webpack_require__(272);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(12).parseFloat;
var $trim = __webpack_require__(140).trim;

module.exports = 1 / $parseFloat(__webpack_require__(272) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(69);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(16);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 421 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(275);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(32);
var IObject = __webpack_require__(155);
var toLength = __webpack_require__(24);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(32);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(24);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(285);
__webpack_require__(2)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(23) && /./g.flags != 'g') __webpack_require__(25).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(158)
});


/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var isObject = __webpack_require__(16);
var newPromiseCapability = __webpack_require__(289);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(431);
var validate = __webpack_require__(125);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(212)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(25).f;
var create = __webpack_require__(87);
var redefineAll = __webpack_require__(124);
var ctx = __webpack_require__(59);
var anInstance = __webpack_require__(123);
var forOf = __webpack_require__(104);
var $iterDefine = __webpack_require__(205);
var step = __webpack_require__(284);
var setSpecies = __webpack_require__(122);
var DESCRIPTORS = __webpack_require__(23);
var fastKey = __webpack_require__(101).fastKey;
var validate = __webpack_require__(125);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(431);
var validate = __webpack_require__(125);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(212)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var each = __webpack_require__(81)(0);
var redefine = __webpack_require__(51);
var meta = __webpack_require__(101);
var assign = __webpack_require__(269);
var weak = __webpack_require__(434);
var isObject = __webpack_require__(16);
var validate = __webpack_require__(125);
var NATIVE_WEAK_MAP = __webpack_require__(125);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(212)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(124);
var getWeak = __webpack_require__(101).getWeak;
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(16);
var anInstance = __webpack_require__(123);
var forOf = __webpack_require__(104);
var createArrayMethod = __webpack_require__(81);
var $has = __webpack_require__(49);
var validate = __webpack_require__(125);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(70);
var toLength = __webpack_require__(24);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(203);
var isObject = __webpack_require__(16);
var toLength = __webpack_require__(24);
var ctx = __webpack_require__(59);
var IS_CONCAT_SPREADABLE = __webpack_require__(21)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(24);
var repeat = __webpack_require__(274);
var defined = __webpack_require__(79);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(23);
var getKeys = __webpack_require__(86);
var toIObject = __webpack_require__(44);
var isEnum = __webpack_require__(156).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(102);
var from = __webpack_require__(440);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(104);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(102);
var ITERATOR = __webpack_require__(21)('iterator');
var Iterators = __webpack_require__(121);
module.exports = __webpack_require__(43).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(444);
var invoke = __webpack_require__(271);
var aFunction = __webpack_require__(37);
module.exports = function (/* ...pargs */) {
  var fn = aFunction(this);
  var length = arguments.length;
  var pargs = new Array(length);
  var i = 0;
  var _ = path._;
  var holder = false;
  while (length > i) if ((pargs[i] = arguments[i++]) === _) holder = true;
  return function (/* ...args */) {
    var that = this;
    var aLen = arguments.length;
    var j = 0;
    var k = 0;
    var args;
    if (!holder && !aLen) return invoke(fn, pargs, that);
    args = pargs.slice();
    if (holder) for (;length > j; j++) if (args[j] === _) args[j] = arguments[k++];
    while (aLen > k) args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25);
var gOPD = __webpack_require__(52);
var ownKeys = __webpack_require__(291);
var toIObject = __webpack_require__(44);

module.exports = function define(target, mixin) {
  var keys = ownKeys(toIObject(mixin));
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) dP.f(target, key = keys[i++], gOPD.f(mixin, key));
  return target;
};


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isTextarea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergePlugins; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_EditorPropTypes__ = __webpack_require__(447);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var isValidKey = function (keys) { return function (key) { return keys.indexOf(key) !== -1; }; };
// tslint:disable-next-line:ban-types
var isFunction = function (x) { return typeof x === 'function'; };
var bindHandlers = function (props, editor, initEvent) {
    Object.keys(props)
        .filter(isValidKey(Object.keys(__WEBPACK_IMPORTED_MODULE_0__components_EditorPropTypes__["b" /* eventPropTypes */])))
        .forEach(function (key) {
        var handler = props[key];
        if (isFunction(handler)) {
            if (key === 'onInit') {
                handler(initEvent, editor);
            }
            else {
                editor.on(key.substring(2), function (e) { return handler(e, editor); });
            }
        }
    });
};
var unique = 0;
var uuid = function (prefix) {
    var date = new Date();
    var time = date.getTime();
    var random = Math.floor(Math.random() * 1000000000);
    unique++;
    return prefix + '_' + random + unique + String(time);
};
var isTextarea = function (element) {
    return element !== null && element.tagName.toLowerCase() === 'textarea';
};
var normalizePluginArray = function (plugins) {
    if (typeof plugins === 'undefined' || plugins === '') {
        return [];
    }
    return Array.isArray(plugins) ? plugins : plugins.split(' ');
};
var mergePlugins = function (initPlugins, inputPlugins) {
    return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins));
};


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var eventPropTypes = {
    onActivate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onAddUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeAddUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeExecCommand: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeGetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeRenderUI: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforeSetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBeforePaste: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onBlur: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onClearUndos: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onContextMenu: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onCopy: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onCut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDblclick: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDeactivate: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDirty: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDrag: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragDrop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragGesture: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDragOver: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onDrop: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onExecCommand: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocus: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocusIn: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onFocusOut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onGetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onHide: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onInit: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyPress: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onKeyUp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onLoadContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseDown: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseMove: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onMouseUp: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onNodeChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectResizeStart: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectResized: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onObjectSelected: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPaste: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPostProcess: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPostRender: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onPreProcess: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onProgressState: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onRedo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onRemove: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onReset: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSaveContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSelectionChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSetAttrib: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSetContent: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onShow: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onSubmit: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onUndo: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"],
    onVisualAid: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"]
};
var EditorPropTypes = __assign({ apiKey: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], id: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], inline: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"], init: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], initialValue: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], onEditorChange: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], value: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], tagName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], cloudChannel: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], plugins: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"]]), toolbar: __WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"]([__WEBPACK_IMPORTED_MODULE_0_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["array"]]), disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types__["bool"], textareaName: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"] }, eventPropTypes);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(450);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__internal_channel__["a"]; });
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(220);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(452);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(61);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1269);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);












/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(451);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        log('error', 'uncaught at ' + name, error.message);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      if (false) {
        log('info', name + ' has been cancelled', '');
      }
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
      }
      if (!task.cont) {
        log('error', 'uncaught', result.sagaStack || result.stack);
        if (result instanceof Error && onError) {
          onError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        log('error', 'uncaught at ' + name, err.message);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        log('error', 'uncaught at ' + name, error.stack || error.message || error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _cb;

          cb.cancel();
          completed = true;
          cb((_cb = {}, _cb[key] = res, _cb));
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(61);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export storages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createPersistor__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTransform__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__persistStore__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__ = __webpack_require__(457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__["a"]; });
/* unused harmony reexport createPersistor */
/* unused harmony reexport createTransform */
/* unused harmony reexport getStoredState */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__persistStore__["a"]; });
/* unused harmony reexport purgeStoredState */







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};



/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__purgeStoredState__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__);





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__purgeStoredState__["a" /* default */])({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__ = __webpack_require__(456);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(164);


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(455);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* KEY_PREFIX */];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Services_ImmutablePersistenceTransform__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
var REDUX_PERSIST={active:true,reducerVersion:'4',storeConfig:{storage:__WEBPACK_IMPORTED_MODULE_1_localforage___default.a,// blacklist: [], // reducer keys that you do NOT want stored to persistence here
whitelist:['auth'],// Optionally, just specify the keys you DO want stored to
// persistence. An empty array means 'don't store any reducers' -> infinitered/ignite#409
transforms:[__WEBPACK_IMPORTED_MODULE_0__Services_ImmutablePersistenceTransform__["a" /* default */]]}};/* harmony default export */ __webpack_exports__["a"] = (REDUX_PERSIST);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var AppConfig={DEBUG:"false",apiURL:"https://api.passpod.com",NODE_ENV:"production"};/* harmony default export */ __webpack_exports__["a"] = (AppConfig);

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1323);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var settle = __webpack_require__(1327);
var buildURL = __webpack_require__(1329);
var parseHeaders = __webpack_require__(1330);
var isURLSameOrigin = __webpack_require__(1331);
var createError = __webpack_require__(465);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1332);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1333);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1328);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(469);
module.exports = __webpack_require__(474);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(470).enable();
  window.Promise = __webpack_require__(472);
}

// fetch() polyfill for making API calls.
__webpack_require__(473);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(165);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(295);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(295);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 473 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Routes_App__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(1342);
var store=Object(__WEBPACK_IMPORTED_MODULE_4__Redux__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Routes_App__["a" /* default */],null)),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(165),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(165),r=__webpack_require__(477);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(478);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(221);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(482);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(299);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(507);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(304);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(494);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(492);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(301);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(496);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(500);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63), __webpack_require__(499)(module)))

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(302);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(303);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(304);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(305);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(508);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(221);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Services_GetToken__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_AppNavigation__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_HomePage__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_LoginPage__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_DestinationPage__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_AttractionPage__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_CouponPage__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_ProductPage__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_UserPage__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_OrderPage__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_EventsPage__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_InsurancePage__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pages_ManageAdminPage__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Pages_TravypassPage__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Pages_ReviewPage__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Pages_EcommercePage__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Pages_MiscPage__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Pages_EsimPage__ = __webpack_require__(1257);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var App=function App(_ref){var auth=_ref.auth,location=_ref.location;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{exact:true,path:'/',component:__WEBPACK_IMPORTED_MODULE_5__Pages_HomePage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/destination/:sub?',component:__WEBPACK_IMPORTED_MODULE_7__Pages_DestinationPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/attractions/:sub?',component:__WEBPACK_IMPORTED_MODULE_8__Pages_AttractionPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/coupon/:sub?',component:__WEBPACK_IMPORTED_MODULE_9__Pages_CouponPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/product',component:__WEBPACK_IMPORTED_MODULE_11__Pages_ProductPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/esim',component:__WEBPACK_IMPORTED_MODULE_21__Pages_EsimPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/user/:sub?',component:__WEBPACK_IMPORTED_MODULE_12__Pages_UserPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/order/:sub?',component:__WEBPACK_IMPORTED_MODULE_13__Pages_OrderPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/e-commerce/:sub?',component:__WEBPACK_IMPORTED_MODULE_19__Pages_EcommercePage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/events/:sub?',component:__WEBPACK_IMPORTED_MODULE_14__Pages_EventsPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/insurance/:sub?',component:__WEBPACK_IMPORTED_MODULE_15__Pages_InsurancePage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/manage-admin',component:__WEBPACK_IMPORTED_MODULE_16__Pages_ManageAdminPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/reviews',component:__WEBPACK_IMPORTED_MODULE_18__Pages_ReviewPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/travypass/:sub?',component:__WEBPACK_IMPORTED_MODULE_17__Pages_TravypassPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{path:'/misc/:sub?',component:__WEBPACK_IMPORTED_MODULE_20__Pages_MiscPage__["a" /* default */],auth:auth,location:location}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/login',component:__WEBPACK_IMPORTED_MODULE_6__Pages_LoginPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_10__Pages_NotFound__["a" /* default */]}))));};var isAuthenticated=true;var checkAuth=function checkAuth(){var token=Object(__WEBPACK_IMPORTED_MODULE_2__Services_GetToken__["a" /* getToken */])();token.then(function(res){isAuthenticated=true;}).catch(function(err){isAuthenticated=false;console.log('ERR_AUTH:',err);});};checkAuth();var PrivateRoute=function PrivateRoute(_ref2){var Component=_ref2.component,rest=_objectWithoutProperties(_ref2,['component']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_AppNavigation__["a" /* default */],{location:rest.location},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:function render(props){return isAuthenticated?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:{pathname:'/login',state:{from:props.location}}});}})));};var stateToProps=function stateToProps(state){return{auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(App));

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(225);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(225);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(517);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(226);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(306);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(521);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(523);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(310);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(525);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(226);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(527);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(227);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(310);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(227);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(531);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(308);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_DbRedux__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Nav__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Routes_menus__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Cookie from 'js-cookie'
var AppNavigation=function(_React$Component){_inherits(AppNavigation,_React$Component);function AppNavigation(props){_classCallCheck(this,AppNavigation);var _this=_possibleConstructorReturn(this,(AppNavigation.__proto__||Object.getPrototypeOf(AppNavigation)).call(this,props));_this.componentDidMount=function(){_this.props.checkLogin();};_this._inputChange=function(event){var val=event.target.value;var name=event.target.name;var newState=Object.assign({},_this.state);newState[name]=val;_this.setState(newState);var _this$state=_this.state,currency_code=_this$state.currency_code,language_code=_this$state.language_code;var data={currency_code:currency_code,language_code:language_code};_this.props.changePreset(data);_this.setState({refresh:true});};_this._logout=function(e){if(e)e.preventDefault();_this.props.logout();_this.setState({redirect:true});};_this._dbDump=function(event){if(event)event.preventDefault();_this.props.dbDump();};_this._clearCache=function(event){event.preventDefault();_this.props.clearCache();};_this.state={redirect:false,refresh:false,currency_code:props.preset.setting.currency_code,language_code:props.preset.setting.language_code};_this.menus=__WEBPACK_IMPORTED_MODULE_8__Routes_menus__["a" /* default */];return _this;}_createClass(AppNavigation,[{key:'render',value:function render(){var _this2=this;// let currentRole = this.props.auth.user ? this.props.auth.user.role : (Cookie.get('user_role') ? Cookie.get('user_role') : '')
// let currentBranch = this.props.auth.user ? this.props.auth.user.branch_code : (Cookie.get('branch') ? Cookie.get('branch') : '')
if(!this.props.auth.user&&this.state.redirect||this.state.redirect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/login'});}var grantedAccess=[];this.menus.map(function(menu,i){if(__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(menu.role,Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["c" /* currentRole */])())){grantedAccess.push(menu.url);if(menu.subs){menu.subs.map(function(sub,i){return grantedAccess.push(sub.url);});}}return grantedAccess;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:'app',id:'app'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block header-block-collapse d-lg-none d-xl-none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'collapse-btn',id:'sidebar-collapse-btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-bars'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block header-block-search'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin'&&Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/manage-admin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-users-cog'}),' Manage Admin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block header-block-nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'nav-profile'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'nav-link',href:'/#',onClick:function onClick(e){return _this2._dbDump(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-database icon'}),' Export Database',this.props.database.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info ml-2'},'Processing...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'nav-link',href:'/#',onClick:function onClick(event){return _this2._clearCache(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eraser icon'}),' Clear Cache')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'profile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'nav-link',href:'/#',onClick:function onClick(e){return _this2._logout(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-power-off icon'}),' Logout'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Nav__["a" /* Sidebar */],{location:this.props.location,role:Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["c" /* currentRole */])(),menus:this.menus,branch:Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["a" /* currentBranch */])()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('article',{className:'content'},this.props.children));}}]);return AppNavigation;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{preset:state.preset,auth:state.auth,database:state.database};};var dispatchToProps=function dispatchToProps(dispatch){return{checkLogin:function checkLogin(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authCheckRequest());},logout:function logout(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());},clearCache:function clearCache(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].attractionClearCacheRequest());},dbDump:function dbDump(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DbRedux__["b" /* default */].dbDumpRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AppNavigation));

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(311),
    baseIsNaN = __webpack_require__(535),
    strictIndexOf = __webpack_require__(536);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 535 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 536 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 538 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isArray = __webpack_require__(33),
    isObjectLike = __webpack_require__(130);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(541);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(542),
    isObject = __webpack_require__(72),
    isSymbol = __webpack_require__(169);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(543);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(545),
    keys = __webpack_require__(143);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(315);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(547),
    isArguments = __webpack_require__(316),
    isArray = __webpack_require__(33),
    isBuffer = __webpack_require__(317),
    isIndex = __webpack_require__(318),
    isTypedArray = __webpack_require__(319);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isObjectLike = __webpack_require__(130);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isLength = __webpack_require__(229),
    isObjectLike = __webpack_require__(130);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(313);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144)(module)))

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(554),
    nativeKeys = __webpack_require__(555);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(556);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var always = __webpack_require__(113);


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
module.exports = always(false);


/***/ }),
/* 558 */
/***/ (function(module, exports) {

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
module.exports = {'@@functional/placeholder': true};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry1 = __webpack_require__(5);
var curryN = __webpack_require__(40);


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */
module.exports = _curry1(function addIndex(fn) {
  return curryN(fn.length, function() {
    var idx = 0;
    var origFn = arguments[0];
    var list = arguments[arguments.length - 1];
    var args = Array.prototype.slice.call(arguments, 0);
    args[0] = function() {
      var result = origFn.apply(this, _concat(arguments, [idx, list]));
      idx += 1;
      return result;
    };
    return fn.apply(this, args);
  });
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xall = __webpack_require__(561);


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      var equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */
module.exports = _curry2(_dispatchable(['all'], _xall, function all(fn, list) {
  var idx = 0;
  while (idx < list.length) {
    if (!fn(list[idx])) {
      return false;
    }
    idx += 1;
  }
  return true;
}));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XAll(f, xf) {
    this.xf = xf;
    this.f = f;
    this.all = true;
  }
  XAll.prototype['@@transducer/init'] = _xfBase.init;
  XAll.prototype['@@transducer/result'] = function(result) {
    if (this.all) {
      result = this.xf['@@transducer/step'](result, true);
    }
    return this.xf['@@transducer/result'](result);
  };
  XAll.prototype['@@transducer/step'] = function(result, input) {
    if (!this.f(input)) {
      this.all = false;
      result = _reduced(this.xf['@@transducer/step'](result, false));
    }
    return result;
  };

  return _curry2(function _xall(f, xf) { return new XAll(f, xf); });
}());


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var curryN = __webpack_require__(40);
var max = __webpack_require__(131);
var pluck = __webpack_require__(145);
var reduce = __webpack_require__(74);


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      var isQueen = R.propEq('rank', 'Q');
 *      var isSpade = R.propEq('suit', '♠︎');
 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */
module.exports = _curry1(function allPass(preds) {
  return curryN(reduce(max, 0, pluck('length', preds)), function() {
    var idx = 0;
    var len = preds.length;
    while (idx < len) {
      if (!preds[idx].apply(this, arguments)) {
        return false;
      }
      idx += 1;
    }
    return true;
  });
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function(result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return _curry2(function _xmap(f, xf) { return new XMap(f, xf); });
}());


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var _aperture = __webpack_require__(565);
var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xaperture = __webpack_require__(566);


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */
module.exports = _curry2(_dispatchable([], _xaperture, _aperture));


/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = function _aperture(n, list) {
  var idx = 0;
  var limit = list.length - (n - 1);
  var acc = new Array(limit >= 0 ? limit : 0);
  while (idx < limit) {
    acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
    idx += 1;
  }
  return acc;
};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XAperture(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XAperture.prototype['@@transducer/init'] = _xfBase.init;
  XAperture.prototype['@@transducer/result'] = function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XAperture.prototype['@@transducer/step'] = function(result, input) {
    this.store(input);
    return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
  };
  XAperture.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };
  XAperture.prototype.getCopy = function() {
    return _concat(Array.prototype.slice.call(this.acc, this.pos),
                   Array.prototype.slice.call(this.acc, 0, this.pos));
  };

  return _curry2(function _xaperture(n, xf) { return new XAperture(n, xf); });
}());


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);


/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */
module.exports = _curry2(function append(el, list) {
  return _concat(list, [el]);
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var apply = __webpack_require__(326);
var curryN = __webpack_require__(40);
var map = __webpack_require__(45);
var max = __webpack_require__(131);
var pluck = __webpack_require__(145);
var reduce = __webpack_require__(74);
var values = __webpack_require__(327);


/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      var getMetrics = R.applySpec({
 *                                      sum: R.add,
 *                                      nested: { mul: R.multiply }
 *                                   });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */
module.exports = _curry1(function applySpec(spec) {
  spec = map(function(v) { return typeof v == 'function' ? v : applySpec(v); },
             spec);
  return curryN(reduce(max, 0, pluck('length', values(spec))),
                function() {
                  var args = arguments;
                  return map(function(f) { return apply(f, args); }, spec);
                });
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      var byAge = R.ascend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByYoungestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function ascend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa < bb ? -1 : aa > bb ? 1 : 0;
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var nAry = __webpack_require__(178);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      var takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      var takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */
module.exports = _curry1(function binary(fn) {
  return nAry(2, fn);
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isFunction = __webpack_require__(179);
var and = __webpack_require__(323);
var lift = __webpack_require__(180);


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      var gt10 = R.gt(R.__, 10)
 *      var lt20 = R.lt(R.__, 20)
 *      var f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 */
module.exports = _curry2(function both(f, g) {
  return _isFunction(f) ?
    function _both() {
      return f.apply(this, arguments) && g.apply(this, arguments);
    } :
    lift(and)(f, g);
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var curry = __webpack_require__(132);


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.times(R.always(' ')),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */
module.exports = curry(function call(fn) {
  return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _flatCat = __webpack_require__(574);
var map = __webpack_require__(45);


module.exports = _curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var _forceReduced = __webpack_require__(575);
var _isArrayLike = __webpack_require__(174);
var _reduce = __webpack_require__(56);
var _xfBase = __webpack_require__(34);

module.exports = (function() {
  var preservingReduced = function(xf) {
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return xf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        var ret = xf['@@transducer/step'](result, input);
        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
      }
    };
  };

  return function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
      '@@transducer/init': _xfBase.init,
      '@@transducer/result': function(result) {
        return rxf['@@transducer/result'](result);
      },
      '@@transducer/step': function(result, input) {
        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
      }
    };
  };
}());


/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);

/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */
module.exports = _curry3(function clamp(min, max, value) {
  if (min > max) {
    throw new Error('min must not be greater than max in clamp(min, max, value)');
  }
  return value < min ? min :
         value > max ? max :
         value;
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(331);
var _curry1 = __webpack_require__(5);


/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */
module.exports = _curry1(function clone(value) {
  return value != null && typeof value.clone === 'function' ?
    value.clone() :
    _clone(value, [], [], true);
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a, b -> Boolean) -> (a, b -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      var byAge = R.comparator((a, b) => a.age < b.age);
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByIncreasingAge = R.sort(byAge, people);
 */
module.exports = _curry1(function comparator(pred) {
  return function(a, b) {
    return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
  };
});


/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var pipeP = __webpack_require__(335);
var reverse = __webpack_require__(182);


/**
 * Performs right-to-left composition of one or more Promise-returning
 * functions. The rightmost function may have any arity; the remaining
 * functions must be unary.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((y -> Promise z), (x -> Promise y), ..., (a -> Promise b)) -> (a -> Promise z)
 * @param {...Function} functions The functions to compose
 * @return {Function}
 * @see R.pipeP
 * @example
 *
 *      var db = {
 *        users: {
 *          JOE: {
 *            name: 'Joe',
 *            followers: ['STEVE', 'SUZY']
 *          }
 *        }
 *      }
 *
 *      // We'll pretend to do a db lookup which returns a promise
 *      var lookupUser = (userId) => Promise.resolve(db.users[userId])
 *      var lookupFollowers = (user) => Promise.resolve(user.followers)
 *      lookupUser('JOE').then(lookupFollowers)
 *
 *      //  followersForUser :: String -> Promise [UserId]
 *      var followersForUser = R.composeP(lookupFollowers, lookupUser);
 *      followersForUser('JOE').then(followers => console.log('Followers:', followers))
 *      // Followers: ["STEVE","SUZY"]
 */
module.exports = function composeP() {
  if (arguments.length === 0) {
    throw new Error('composeP requires at least one argument');
  }
  return pipeP.apply(this, reverse(arguments));
};


/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = function _pipeP(f, g) {
  return function() {
    var ctx = this;
    return f.apply(ctx, arguments).then(function(x) {
      return g.call(ctx, x);
    });
  };
};


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _map = __webpack_require__(173);
var _quote = __webpack_require__(586);
var _toISOString = __webpack_require__(587);
var keys = __webpack_require__(66);
var reject = __webpack_require__(183);


module.exports = function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _contains(y, xs) ? '<Circular>' : _toString(y, xs);
  };

  //  mapPairs :: (Object, [String]) -> [String]
  var mapPairs = function(obj, keys) {
    return _map(function(k) { return _quote(k) + ': ' + recur(obj[k]); }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';
    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function(k) { return /^\d+$/.test(k); }, keys(x)))).join(', ') + ']';
    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';
    case '[object Null]':
      return 'null';
    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);
    case '[object Undefined]':
      return 'undefined';
    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();
        if (repr !== '[object Object]') {
          return repr;
        }
      }
      return '{' + mapPairs(x, keys(x)).join(', ') + '}';
  }
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var _arrayFromIterator = __webpack_require__(584);
var _functionName = __webpack_require__(585);
var _has = __webpack_require__(46);
var identical = __webpack_require__(337);
var keys = __webpack_require__(66);
var type = __webpack_require__(238);


module.exports = function _equals(a, b, stackA, stackB) {
  if (identical(a, b)) {
    return true;
  }

  if (type(a) !== type(b)) {
    return false;
  }

  if (a == null || b == null) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) &&
           typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) &&
           typeof b.equals === 'function' && b.equals(a);
  }

  switch (type(a)) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' &&
          _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && identical(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!identical(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source &&
            a.global === b.global &&
            a.ignoreCase === b.ignoreCase &&
            a.multiline === b.multiline &&
            a.sticky === b.sticky &&
            a.unicode === b.unicode)) {
        return false;
      }
      break;
    case 'Map':
    case 'Set':
      if (!_equals(_arrayFromIterator(a.entries()), _arrayFromIterator(b.entries()), stackA, stackB)) {
        return false;
      }
      break;
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
      break;
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }

  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }

  stackA.push(a);
  stackB.push(b);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], stackA, stackB))) {
      return false;
    }
    idx -= 1;
  }
  stackA.pop();
  stackB.pop();
  return true;
};


/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
};


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
};


/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = function _quote(s) {
  var escaped = s
    .replace(/\\/g, '\\\\')
    .replace(/[\b]/g, '\\b')  // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r')
    .replace(/\t/g, '\\t')
    .replace(/\v/g, '\\v')
    .replace(/\0/g, '\\0');

  return '"' + escaped.replace(/"/g, '\\"') + '"';
};


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
module.exports = (function() {
  var pad = function pad(n) { return (n < 10 ? '0' : '') + n; };

  return typeof Date.prototype.toISOString === 'function' ?
    function _toISOString(d) {
      return d.toISOString();
    } :
    function _toISOString(d) {
      return (
        d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds()) + '.' +
        (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z'
      );
    };
}());


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;
  XFilter.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return _curry2(function _xfilter(f, xf) { return new XFilter(f, xf); });
}());


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var constructN = __webpack_require__(339);


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      var AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      var animalTypes = ["Lion", "Tiger", "Bear"];
 *      var animalSighting = R.invoker(0, 'sighting');
 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */
module.exports = _curry1(function construct(Fn) {
  return constructN(Fn.length, Fn);
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(184);


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */
module.exports = reduceBy(function(acc, elem) { return acc + 1; }, 0);


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(172);
var _has = __webpack_require__(46);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XReduceBy(valueFn, valueAcc, keyFn, xf) {
    this.valueFn = valueFn;
    this.valueAcc = valueAcc;
    this.keyFn = keyFn;
    this.xf = xf;
    this.inputs = {};
  }
  XReduceBy.prototype['@@transducer/init'] = _xfBase.init;
  XReduceBy.prototype['@@transducer/result'] = function(result) {
    var key;
    for (key in this.inputs) {
      if (_has(key, this.inputs)) {
        result = this.xf['@@transducer/step'](result, this.inputs[key]);
        if (result['@@transducer/reduced']) {
          result = result['@@transducer/value'];
          break;
        }
      }
    }
    this.inputs = null;
    return this.xf['@@transducer/result'](result);
  };
  XReduceBy.prototype['@@transducer/step'] = function(result, input) {
    var key = this.keyFn(input);
    this.inputs[key] = this.inputs[key] || [key, this.valueAcc];
    this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
    return result;
  };

  return _curryN(4, [],
                 function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
                   return new XReduceBy(valueFn, valueAcc, keyFn, xf);
                 });
}());


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(171);


/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */
module.exports = add(-1);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      var byAge = R.descend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByOldestFirst = R.sort(byAge, people);
 */
module.exports = _curry3(function descend(fn, a, b) {
  var aa = fn(a);
  var bb = fn(b);
  return aa > bb ? -1 : aa < bb ? 1 : 0;
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isInteger = __webpack_require__(236);
var assoc = __webpack_require__(176);
var dissoc = __webpack_require__(247);
var remove = __webpack_require__(345);
var update = __webpack_require__(248);


/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */
module.exports = _curry2(function dissocPath(path, obj) {
  switch (path.length) {
    case 0:
      return obj;
    case 1:
      return _isInteger(path[0]) ? remove(path[0], 1, obj) : dissoc(path[0], obj);
    default:
      var head = path[0];
      var tail = Array.prototype.slice.call(path, 1);
      if (obj[head] == null) {
        return obj;
      } else if (_isInteger(path[0])) {
        return update(head, dissocPath(tail, obj[head]), obj);
      } else {
        return assoc(head, dissocPath(tail, obj[head]), obj);
      }
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      var half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      var reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */
module.exports = _curry2(function divide(a, b) { return a / b; });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XDrop(n, xf) {
    this.xf = xf;
    this.n = n;
  }
  XDrop.prototype['@@transducer/init'] = _xfBase.init;
  XDrop.prototype['@@transducer/result'] = _xfBase.result;
  XDrop.prototype['@@transducer/step'] = function(result, input) {
    if (this.n > 0) {
      this.n -= 1;
      return result;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdrop(n, xf) { return new XDrop(n, xf); });
}());


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _dropLast = __webpack_require__(598);
var _xdropLast = __webpack_require__(600);


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */
module.exports = _curry2(_dispatchable([], _xdropLast, _dropLast));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var take = __webpack_require__(249);

module.exports = function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);

module.exports = (function() {
  function XTake(n, xf) {
    this.xf = xf;
    this.n = n;
    this.i = 0;
  }
  XTake.prototype['@@transducer/init'] = _xfBase.init;
  XTake.prototype['@@transducer/result'] = _xfBase.result;
  XTake.prototype['@@transducer/step'] = function(result, input) {
    this.i += 1;
    var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
    return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
  };

  return _curry2(function _xtake(n, xf) { return new XTake(n, xf); });
}());


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XDropLast(n, xf) {
    this.xf = xf;
    this.pos = 0;
    this.full = false;
    this.acc = new Array(n);
  }
  XDropLast.prototype['@@transducer/init'] = _xfBase.init;
  XDropLast.prototype['@@transducer/result'] =  function(result) {
    this.acc = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.full) {
      result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
    }
    this.store(input);
    return result;
  };
  XDropLast.prototype.store = function(input) {
    this.acc[this.pos] = input;
    this.pos += 1;
    if (this.pos === this.acc.length) {
      this.pos = 0;
      this.full = true;
    }
  };

  return _curry2(function _xdropLast(n, xf) { return new XDropLast(n, xf); });
}());


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _dropLastWhile = __webpack_require__(602);
var _xdropLastWhile = __webpack_require__(603);


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} predicate The function to be called on each element
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      var lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(_dispatchable([], _xdropLastWhile, _dropLastWhile));


/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = function dropLastWhile(pred, list) {
  var idx = list.length - 1;
  while (idx >= 0 && pred(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, 0, idx + 1);
};


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduce = __webpack_require__(56);
var _xfBase = __webpack_require__(34);

module.exports = (function() {
  function XDropLastWhile(fn, xf) {
    this.f = fn;
    this.retained = [];
    this.xf = xf;
  }
  XDropLastWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropLastWhile.prototype['@@transducer/result'] = function(result) {
    this.retained = null;
    return this.xf['@@transducer/result'](result);
  };
  XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.retain(result, input)
                         : this.flush(result, input);
  };
  XDropLastWhile.prototype.flush = function(result, input) {
    result = _reduce(
      this.xf['@@transducer/step'],
      result,
      this.retained
    );
    this.retained = [];
    return this.xf['@@transducer/step'](result, input);
  };
  XDropLastWhile.prototype.retain = function(result, input) {
    this.retained.push(input);
    return result;
  };

  return _curry2(function _xdropLastWhile(fn, xf) { return new XDropLastWhile(fn, xf); });
}());


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _dispatchable = __webpack_require__(31);
var _xdropRepeatsWith = __webpack_require__(347);
var dropRepeatsWith = __webpack_require__(348);
var equals = __webpack_require__(57);


/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */
module.exports = _curry1(_dispatchable([], _xdropRepeatsWith(equals), dropRepeatsWith(equals)));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xdropWhile = __webpack_require__(606);


/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      var lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 */
module.exports = _curry2(_dispatchable(['dropWhile'], _xdropWhile, function dropWhile(pred, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && pred(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, idx);
}));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XDropWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XDropWhile.prototype['@@transducer/init'] = _xfBase.init;
  XDropWhile.prototype['@@transducer/result'] = _xfBase.result;
  XDropWhile.prototype['@@transducer/step'] = function(result, input) {
    if (this.f) {
      if (this.f(input)) {
        return result;
      }
      this.f = null;
    }
    return this.xf['@@transducer/step'](result, input);
  };

  return _curry2(function _xdropWhile(f, xf) { return new XDropWhile(f, xf); });
}());


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isFunction = __webpack_require__(179);
var lift = __webpack_require__(180);
var or = __webpack_require__(350);


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      var gt10 = x => x > 10;
 *      var even = x => x % 2 === 0;
 *      var f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 */
module.exports = _curry2(function either(f, g) {
  return _isFunction(f) ?
    function _either() {
      return f.apply(this, arguments) || g.apply(this, arguments);
    } :
    lift(or)(f, g);
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var equals = __webpack_require__(57);


/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */
module.exports = _curry3(function eqBy(f, x, y) {
  return equals(f(x), f(y));
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      var transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */
module.exports = _curry2(function evolve(transformations, object) {
  var result = {};
  var transformation, key, type;
  for (key in object) {
    transformation = transformations[key];
    type = typeof transformation;
    result[key] = type === 'function'                 ? transformation(object[key])
                : transformation && type === 'object' ? evolve(transformation, object[key])
                                                      : object[key];
  }
  return result;
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };

  return _curry2(function _xfind(f, xf) { return new XFind(f, xf); });
}());


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XFindIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.found = false;
  }
  XFindIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindIndex.prototype['@@transducer/result'] = function(result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, -1);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFindIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, this.idx));
    }
    return result;
  };

  return _curry2(function _xfindIndex(f, xf) { return new XFindIndex(f, xf); });
}());


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xfindLast = __webpack_require__(613);


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */
module.exports = _curry2(_dispatchable([], _xfindLast, function findLast(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx -= 1;
  }
}));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XFindLast(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFindLast.prototype['@@transducer/init'] = _xfBase.init;
  XFindLast.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
  };
  XFindLast.prototype['@@transducer/step'] = function(result, input) {
    if (this.f(input)) {
      this.last = input;
    }
    return result;
  };

  return _curry2(function _xfindLast(f, xf) { return new XFindLast(f, xf); });
}());


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xfindLastIndex = __webpack_require__(615);


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */
module.exports = _curry2(_dispatchable([], _xfindLastIndex, function findLastIndex(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0) {
    if (fn(list[idx])) {
      return idx;
    }
    idx -= 1;
  }
  return -1;
}));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XFindLastIndex(f, xf) {
    this.xf = xf;
    this.f = f;
    this.idx = -1;
    this.lastIdx = -1;
  }
  XFindLastIndex.prototype['@@transducer/init'] = _xfBase.init;
  XFindLastIndex.prototype['@@transducer/result'] = function(result) {
    return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
  };
  XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
    this.idx += 1;
    if (this.f(input)) {
      this.lastIdx = this.idx;
    }
    return result;
  };

  return _curry2(function _xfindLastIndex(f, xf) { return new XFindLastIndex(f, xf); });
}());


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _makeFlat = __webpack_require__(330);


/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */
module.exports = _curry1(_makeFlat(true));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var keys = __webpack_require__(66);


/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */
module.exports = _curry2(function forEachObjIndexed(fn, obj) {
  var keyList = keys(obj);
  var idx = 0;
  while (idx < keyList.length) {
    var key = keyList[idx];
    fn(obj[key], key, obj);
    idx += 1;
  }
  return obj;
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(147);
var _curry2 = __webpack_require__(3);
var reduceBy = __webpack_require__(184);

/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */
module.exports = _curry2(_checkForMethod('groupBy', reduceBy(function(acc, item) {
  if (acc == null) {
    acc = [];
  }
  acc.push(item);
  return acc;
}, null)));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);

/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */
module.exports = _curry2(function(fn, list) {
  var res = [];
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    var nextidx = idx + 1;
    while (nextidx < len && fn(list[nextidx - 1], list[nextidx])) {
      nextidx += 1;
    }
    res.push(list.slice(idx, nextidx));
    idx = nextidx;
  }
  return res;
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */
module.exports = _curry2(function gt(a, b) { return a > b; });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      var square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */
module.exports = _curry2(function hasIn(prop, obj) {
  return prop in obj;
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var nth = __webpack_require__(149);


/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */
module.exports = nth(0);


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var add = __webpack_require__(171);


/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */
module.exports = add(1);


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var reduceBy = __webpack_require__(184);


/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */
module.exports = reduceBy(function(acc, elem) { return elem; }, null);


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _indexOf = __webpack_require__(336);
var _isArray = __webpack_require__(93);


/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function indexOf(target, xs) {
  return typeof xs.indexOf === 'function' && !_isArray(xs) ?
    xs.indexOf(target) :
    _indexOf(xs, target, 0);
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var slice = __webpack_require__(114);


/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */
module.exports = slice(0, -1);


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(185);
var _curry3 = __webpack_require__(6);
var _filter = __webpack_require__(244);


/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig (a -> b -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function innerJoin(pred, xs, ys) {
  return _filter(function(x) { return _containsWith(pred, x, ys); }, xs);
});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */
module.exports = _curry3(function insert(idx, elt, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  var result = Array.prototype.slice.call(list, 0);
  result.splice(idx, 0, elt);
  return result;
});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */
module.exports = _curry3(function insertAll(idx, elts, list) {
  idx = idx < list.length && idx >= 0 ? idx : list.length;
  return [].concat(Array.prototype.slice.call(list, 0, idx),
                   elts,
                   Array.prototype.slice.call(list, idx));
});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _curry2 = __webpack_require__(3);
var _filter = __webpack_require__(244);
var flip = __webpack_require__(186);
var uniq = __webpack_require__(252);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */
module.exports = _curry2(function intersection(list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  return uniq(_filter(flip(_contains)(lookupList), filteredList));
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);


// A simple Set type that honours R.equals semantics
module.exports = (function() {
  function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
  }

  // until we figure out why jsdoc chokes on this
  // @param item The item to add to the Set
  // @returns {boolean} true if the item did not exist prior, otherwise false
  //
  _Set.prototype.add = function(item) {
    return !hasOrAdd(item, true, this);
  };

  //
  // @param item The item to check for existence in the Set
  // @returns {boolean} true if the item exists in the Set, otherwise false
  //
  _Set.prototype.has = function(item) {
    return hasOrAdd(item, false, this);
  };

  //
  // Combines the logic for checking whether an item is a member of the set and
  // for adding a new item to the set.
  //
  // @param item       The item to check or add to the Set instance.
  // @param shouldAdd  If true, the item will be added to the set if it doesn't
  //                   already exist.
  // @param set        The set instance to check or add to.
  // @return {boolean} true if the item already existed, otherwise false.
  //
  function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch (type) {
      case 'string':
      case 'number':
        // distinguish between +0 and -0
        if (item === 0 && 1 / item === -Infinity) {
          if (set._items['-0']) {
            return true;
          } else {
            if (shouldAdd) {
              set._items['-0'] = true;
            }
            return false;
          }
        }
        // these types can all utilise the native Set
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = {};
              set._items[type][item] = true;
            }
            return false;
          } else if (item in set._items[type]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][item] = true;
            }
            return false;
          }
        }

      case 'boolean':
        // set._items['boolean'] holds a two element array
        // representing [ falseExists, trueExists ]
        if (type in set._items) {
          var bIdx = item ? 1 : 0;
          if (set._items[type][bIdx]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][bIdx] = true;
            }
            return false;
          }
        } else {
          if (shouldAdd) {
            set._items[type] = item ? [false, true] : [true, false];
          }
          return false;
        }

      case 'function':
        // compare functions for reference equality
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;
            set._nativeSet.add(item);
            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = [item];
            }
            return false;
          }
          if (!_contains(item, set._items[type])) {
            if (shouldAdd) {
              set._items[type].push(item);
            }
            return false;
          }
          return true;
        }

      case 'undefined':
        if (set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type] = true;
          }
          return false;
        }

      case 'object':
        if (item === null) {
          if (!set._items['null']) {
            if (shouldAdd) {
              set._items['null'] = true;
            }
            return false;
          }
          return true;
        }
      /* falls through */
      default:
        // reduce the search size of heterogeneous sets by creating buckets
        // for each type.
        type = Object.prototype.toString.call(item);
        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }
          return false;
        }
        // scan through all previously applied items
        if (!_contains(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }
          return false;
        }
        return true;
    }
  }
  return _Set;
}());


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var _containsWith = __webpack_require__(185);
var _curry3 = __webpack_require__(6);
var uniqWith = __webpack_require__(253);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate function that determines whether
 *        the two supplied elements are equal.
 * @param {Array} list1 One list of items to compare
 * @param {Array} list2 A second list of items to compare
 * @return {Array} A new list containing those elements common to both lists.
 * @see R.innerJoin
 * @deprecated since v0.24.0
 * @example
 *
 *      var buffaloSpringfield = [
 *        {id: 824, name: 'Richie Furay'},
 *        {id: 956, name: 'Dewey Martin'},
 *        {id: 313, name: 'Bruce Palmer'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *      var csny = [
 *        {id: 204, name: 'David Crosby'},
 *        {id: 456, name: 'Stephen Stills'},
 *        {id: 539, name: 'Graham Nash'},
 *        {id: 177, name: 'Neil Young'}
 *      ];
 *
 *      R.intersectionWith(R.eqBy(R.prop('id')), buffaloSpringfield, csny);
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */
module.exports = _curry3(function intersectionWith(pred, list1, list2) {
  var lookupList, filteredList;
  if (list1.length > list2.length) {
    lookupList = list1;
    filteredList = list2;
  } else {
    lookupList = list2;
    filteredList = list1;
  }
  var results = [];
  var idx = 0;
  while (idx < filteredList.length) {
    if (_containsWith(pred, filteredList[idx], lookupList)) {
      results[results.length] = filteredList[idx];
    }
    idx += 1;
  }
  return uniqWith(pred, results);
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var _checkForMethod = __webpack_require__(147);
var _curry2 = __webpack_require__(3);


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
 */
module.exports = _curry2(_checkForMethod('intersperse', function intersperse(separator, list) {
  var out = [];
  var idx = 0;
  var length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], separator);
    }
    idx += 1;
  }
  return out;
}));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var _clone = __webpack_require__(331);
var _curry3 = __webpack_require__(6);
var _isTransformer = __webpack_require__(233);
var _reduce = __webpack_require__(56);
var _stepCat = __webpack_require__(635);


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      var intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */
module.exports = _curry3(function into(acc, xf, list) {
  return _isTransformer(acc) ?
    _reduce(xf(acc), acc['@@transducer/init'](), list) :
    _reduce(xf(_stepCat(acc)), _clone(acc, [], [], false), list);
});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(254);
var _identity = __webpack_require__(251);
var _isArrayLike = __webpack_require__(174);
var _isTransformer = __webpack_require__(233);
var objOf = __webpack_require__(362);


module.exports = (function() {
  var _stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
      xs.push(x);
      return xs;
    },
    '@@transducer/result': _identity
  };
  var _stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) { return a + b; },
    '@@transducer/result': _identity
  };
  var _stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
      return _assign(
        result,
        _isArrayLike(input) ? objOf(input[0], input[1]) : input
      );
    },
    '@@transducer/result': _identity
  };

  return function _stepCat(obj) {
    if (_isTransformer(obj)) {
      return obj;
    }
    if (_isArrayLike(obj)) {
      return _stepCatArray;
    }
    if (typeof obj === 'string') {
      return _stepCatString;
    }
    if (typeof obj === 'object') {
      return _stepCatObject;
    }
    throw new Error('Cannot create transformer for ' + obj);
  };
}());


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var _has = __webpack_require__(46);

// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
module.exports = function _objectAssign(target) {
  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var output = Object(target);
  var idx = 1;
  var length = arguments.length;
  while (idx < length) {
    var source = arguments[idx];
    if (source != null) {
      for (var nextKey in source) {
        if (_has(nextKey, source)) {
          output[nextKey] = source[nextKey];
        }
      }
    }
    idx += 1;
  }
  return output;
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _has = __webpack_require__(46);
var keys = __webpack_require__(66);


/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      var raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */
module.exports = _curry1(function invert(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    var val = obj[key];
    var list = _has(val, out) ? out[val] : (out[val] = []);
    list[list.length] = key;
    idx += 1;
  }
  return out;
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var keys = __webpack_require__(66);


/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      var raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      var raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */
module.exports = _curry1(function invertObj(obj) {
  var props = keys(obj);
  var len = props.length;
  var idx = 0;
  var out = {};

  while (idx < len) {
    var key = props[idx];
    out[obj[key]] = key;
    idx += 1;
  }
  return out;
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(151);


/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */
module.exports = invoker(1, 'join');


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */
module.exports = _curry1(function keysIn(obj) {
  var prop;
  var ks = [];
  for (prop in obj) {
    ks[ks.length] = prop;
  }
  return ks;
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isArray = __webpack_require__(93);
var equals = __webpack_require__(57);


/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */
module.exports = _curry2(function lastIndexOf(target, xs) {
  if (typeof xs.lastIndexOf === 'function' && !_isArray(xs)) {
    return xs.lastIndexOf(target);
  } else {
    var idx = xs.length - 1;
    while (idx >= 0) {
      if (equals(xs[idx], target)) {
        return idx;
      }
      idx -= 1;
    }
    return -1;
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var lens = __webpack_require__(188);
var nth = __webpack_require__(149);
var update = __webpack_require__(248);


/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */
module.exports = _curry1(function lensIndex(n) {
  return lens(nth(n), update(n));
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var assocPath = __webpack_require__(328);
var lens = __webpack_require__(188);
var path = __webpack_require__(133);


/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */
module.exports = _curry1(function lensPath(p) {
  return lens(path(p), assocPath(p));
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var assoc = __webpack_require__(176);
var lens = __webpack_require__(188);
var prop = __webpack_require__(175);


/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */
module.exports = _curry1(function lensProp(k) {
  return lens(prop(k), assoc(k));
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */
module.exports = _curry2(function lt(a, b) { return a < b; });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */
module.exports = _curry2(function lte(a, b) { return a <= b; });


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (acc -> x -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccumRight
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */
module.exports = _curry3(function mapAccum(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var tuple = [acc];
  while (idx < len) {
    tuple = fn(tuple[0], list[idx]);
    result[idx] = tuple[1];
    idx += 1;
  }
  return [tuple[0], result];
});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *value* and *acc*, and should
 * return a tuple *[value, acc]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (x-> acc -> (y, acc)) -> acc -> [x] -> ([y], acc)
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var append = (a, b) => [a + b, a + b];
 *
 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   [
 *     f(b, f(c, f(d, a)[0])[0])[1],
 *     f(c, f(d, a)[0])[1],
 *     f(d, a)[1],
 *   ]
 *   f(b, f(c, f(d, a)[0])[0])[0],
 * ]
 */
module.exports = _curry3(function mapAccumRight(fn, acc, list) {
  var idx = list.length - 1;
  var result = [];
  var tuple = [acc];
  while (idx >= 0) {
    tuple = fn(list[idx], tuple[0]);
    result[idx] = tuple[1];
    idx -= 1;
  }
  return [result, tuple[0]];
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduce = __webpack_require__(56);
var keys = __webpack_require__(66);


/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */
module.exports = _curry2(function mapObjIndexed(fn, obj) {
  return _reduce(function(acc, key) {
    acc[key] = fn(obj[key], key, obj);
    return acc;
  }, {}, keys(obj));
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */
module.exports = _curry2(function match(rx, str) {
  return str.match(rx) || [];
});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _isInteger = __webpack_require__(236);


/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      var clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      var seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */
module.exports = _curry2(function mathMod(m, p) {
  if (!_isInteger(m)) { return NaN; }
  if (!_isInteger(p) || p < 1) { return NaN; }
  return ((m % p) + p) % p;
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */
module.exports = _curry3(function maxBy(f, a, b) {
  return f(b) > f(a) ? b : a;
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var mean = __webpack_require__(366);


/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */
module.exports = _curry1(function median(list) {
  var len = list.length;
  if (len === 0) {
    return NaN;
  }
  var width = 2 - len % 2;
  var idx = (len - width) / 2;
  return mean(Array.prototype.slice.call(list, 0).sort(function(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }).slice(idx, idx + width));
});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeWith = __webpack_require__(368);
var toString = __webpack_require__(148);


/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */
module.exports = memoizeWith(function() {
  return toString(arguments);
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var _assign = __webpack_require__(254);
var _curry1 = __webpack_require__(5);


/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */
module.exports = _curry1(function mergeAll(list) {
  return _assign.apply(null, [{}].concat(list));
});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var mergeDeepWithKey = __webpack_require__(189);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */
module.exports = _curry2(function mergeDeepLeft(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var mergeDeepWithKey = __webpack_require__(189);


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */
module.exports = _curry2(function mergeDeepRight(lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return rVal;
  }, lObj, rObj);
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var mergeDeepWithKey = __webpack_require__(189);


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */
module.exports = _curry3(function mergeDeepWith(fn, lObj, rObj) {
  return mergeDeepWithKey(function(k, lVal, rVal) {
    return fn(lVal, rVal);
  }, lObj, rObj);
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var mergeWithKey = __webpack_require__(256);


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig (a -> a -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */
module.exports = _curry3(function mergeWith(fn, l, r) {
  return mergeWithKey(function(_, _l, _r) {
    return fn(_l, _r);
  }, l, r);
});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */
module.exports = _curry2(function min(a, b) { return b < a ? b : a; });


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */
module.exports = _curry3(function minBy(f, a, b) {
  return f(b) < f(a) ? b : a;
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      var isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */
module.exports = _curry2(function modulo(a, b) { return a % b; });


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */
module.exports = _curry1(function negate(n) { return -n; });


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var _complement = __webpack_require__(338);
var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xany = __webpack_require__(325);
var any = __webpack_require__(324);


/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isEven, [1, 3, 5, 7, 8, 11]); //=> false
 */
module.exports = _curry2(_complement(_dispatchable(['any'], _xany, any)));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var curryN = __webpack_require__(40);
var nth = __webpack_require__(149);


/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */
module.exports = _curry1(function nthArg(n) {
  var arity = n < 0 ? 1 : n + 1;
  return curryN(arity, function() {
    return nth(n, arguments);
  });
});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + lastName
 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */
module.exports = _curry3(function o(f, g, x) {
  return f(g(x));
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _of = __webpack_require__(668);


/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */
module.exports = _curry1(_of);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = function _of(x) { return [x]; };


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _curry2 = __webpack_require__(3);


/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */
module.exports = _curry2(function omit(names, obj) {
  var result = {};
  for (var prop in obj) {
    if (!_contains(prop, names)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _curry1 = __webpack_require__(5);


/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      var addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */
module.exports = _curry1(function once(fn) {
  var called = false;
  var result;
  return _arity(fn.length, function() {
    if (called) {
      return result;
    }
    called = true;
    result = fn.apply(this, arguments);
    return result;
  });
});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */
module.exports = _curry2(function pair(fst, snd) { return [fst, snd]; });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _createPartialApplicator = __webpack_require__(373);
var flip = __webpack_require__(186);


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */
module.exports = _createPartialApplicator(flip(_concat));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var filter = __webpack_require__(243);
var juxt = __webpack_require__(363);
var reject = __webpack_require__(183);


/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */
module.exports = juxt([filter, reject]);


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var equals = __webpack_require__(57);
var path = __webpack_require__(133);


/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      var user1 = { address: { zipCode: 90210 } };
 *      var user2 = { address: { zipCode: 55555 } };
 *      var user3 = { name: 'Bob' };
 *      var users = [ user1, user2, user3 ];
 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */
module.exports = _curry3(function pathEq(_path, val, obj) {
  return equals(path(_path, obj), val);
});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var defaultTo = __webpack_require__(342);
var path = __webpack_require__(133);


/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */
module.exports = _curry3(function pathOr(d, p, obj) {
  return defaultTo(d, path(p, obj));
});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var path = __webpack_require__(133);


/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */
module.exports = _curry3(function pathSatisfies(pred, propPath, obj) {
  return propPath.length > 0 && pred(path(propPath, obj));
});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */
module.exports = _curry2(function pick(names, obj) {
  var result = {};
  var idx = 0;
  while (idx < names.length) {
    if (names[idx] in obj) {
      result[names[idx]] = obj[names[idx]];
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
module.exports = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var composeK = __webpack_require__(334);
var reverse = __webpack_require__(182);

/**
 * Returns the left-to-right Kleisli composition of the provided functions,
 * each of which must return a value of a type supported by [`chain`](#chain).
 *
 * `R.pipeK(f, g, h)` is equivalent to `R.pipe(R.chain(f), R.chain(g), R.chain(h))`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Function
 * @sig Chain m => ((a -> m b), (b -> m c), ..., (y -> m z)) -> (a -> m z)
 * @param {...Function}
 * @return {Function}
 * @see R.composeK
 * @example
 *
 *      //  parseJson :: String -> Maybe *
 *      //  get :: String -> Object -> Maybe *
 *
 *      //  getStateCode :: Maybe String -> Maybe String
 *      var getStateCode = R.pipeK(
 *        parseJson,
 *        get('user'),
 *        get('address'),
 *        get('state'),
 *        R.compose(Maybe.of, R.toUpper)
 *      );
 *
 *      getStateCode('{"user":{"address":{"state":"ny"}}}');
 *      //=> Just('NY')
 *      getStateCode('[Invalid JSON]');
 *      //=> Nothing()
 * @symb R.pipeK(f, g, h)(a) = R.chain(h, R.chain(g, f(a)))
 */
module.exports = function pipeK() {
  if (arguments.length === 0) {
    throw new Error('pipeK requires at least one argument');
  }
  return composeK.apply(this, reverse(arguments));
};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var multiply = __webpack_require__(370);
var reduce = __webpack_require__(74);


/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */
module.exports = reduce(multiply, 1);


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var _map = __webpack_require__(173);
var identity = __webpack_require__(150);
var pickAll = __webpack_require__(374);
var useWith = __webpack_require__(376);


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */
module.exports = useWith(_map, [pickAll, identity]); // passing `identity` gives correct arity


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var _has = __webpack_require__(46);


/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var favorite = R.prop('favoriteLibrary');
 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */
module.exports = _curry3(function propOr(val, p, obj) {
  return (obj != null && _has(p, obj)) ? obj[p] : val;
});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */
module.exports = _curry2(function props(ps, obj) {
  var len = ps.length;
  var out = [];
  var idx = 0;

  while (idx < len) {
    out[idx] = obj[ps[idx]];
    idx += 1;
  }

  return out;
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var _curryN = __webpack_require__(172);
var _reduce = __webpack_require__(56);
var _reduced = __webpack_require__(94);


/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */
module.exports = _curryN(4, [], function _reduceWhile(pred, fn, a, list) {
  return _reduce(function(acc, x) {
    return pred(acc, x) ? fn(acc, x) : _reduced(acc);
  }, a, list);
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var _reduced = __webpack_require__(94);

/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is unavailable to functions not explicitly listed
 * above. For instance, it is not currently supported by
 * [`reduceRight`](#reduceRight).
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */

module.exports = _curry1(_reduced);


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var always = __webpack_require__(113);
var times = __webpack_require__(382);


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */
module.exports = _curry2(function repeat(value, n) {
  return times(always(value), n);
});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */
module.exports = _curry3(function replace(regex, replacement, str) {
  return str.replace(regex, replacement);
});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a,b -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */
module.exports = _curry3(function scan(fn, acc, list) {
  var idx = 0;
  var len = list.length;
  var result = [acc];
  while (idx < len) {
    acc = fn(acc, list[idx]);
    result[idx + 1] = acc;
    idx += 1;
  }
  return result;
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var always = __webpack_require__(113);
var over = __webpack_require__(371);


/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */
module.exports = _curry3(function set(lens, v, x) {
  return over(lens, always(v), x);
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,a -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      var diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */
module.exports = _curry2(function sort(comparator, list) {
  return Array.prototype.slice.call(list, 0).sort(comparator);
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      var sortByFirstItem = R.sortBy(R.prop(0));
 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      var people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */
module.exports = _curry2(function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [a -> a -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      var alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      var bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      var people = [clara, bob, alice];
 *      var ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */
module.exports = _curry2(function sortWith(fns, list) {
  return Array.prototype.slice.call(list, 0).sort(function(a, b) {
    var result = 0;
    var i = 0;
    while (result === 0 && i < fns.length) {
      result = fns[i](a, b);
      i += 1;
    }
    return result;
  });
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var length = __webpack_require__(364);
var slice = __webpack_require__(114);


/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */
module.exports = _curry2(function splitAt(index, array) {
  return [slice(0, index, array), slice(index, length(array), array)];
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var slice = __webpack_require__(114);


/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */
module.exports = _curry2(function splitEvery(n, list) {
  if (n <= 0) {
    throw new Error('First argument to splitEvery must be a positive integer');
  }
  var result = [];
  var idx = 0;
  while (idx < list.length) {
    result.push(slice(idx, idx += n, list));
  }
  return result;
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */
module.exports = _curry2(function splitWhen(pred, list) {
  var idx = 0;
  var len = list.length;
  var prefix = [];

  while (idx < len && !pred(list[idx])) {
    prefix.push(list[idx]);
    idx += 1;
  }

  return [prefix, Array.prototype.slice.call(list, idx)];
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      var minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      var complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */
module.exports = _curry2(function subtract(a, b) {
  return Number(a) - Number(b);
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var concat = __webpack_require__(242);
var difference = __webpack_require__(343);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */
module.exports = _curry2(function symmetricDifference(list1, list2) {
  return concat(difference(list1, list2), difference(list2, list1));
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var concat = __webpack_require__(242);
var differenceWith = __webpack_require__(344);


/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      var eqA = R.eqBy(R.prop('a'));
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */
module.exports = _curry3(function symmetricDifferenceWith(pred, list1, list2) {
  return concat(differenceWith(pred, list1, list2), differenceWith(pred, list2, list1));
});


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      var isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 */
module.exports = _curry2(function takeLastWhile(fn, list) {
  var idx = list.length - 1;
  while (idx >= 0 && fn(list[idx])) {
    idx -= 1;
  }
  return Array.prototype.slice.call(list, idx + 1);
});


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _dispatchable = __webpack_require__(31);
var _xtakeWhile = __webpack_require__(701);


/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @param {Function} fn The function called per iteration.
 * @param {Array} list The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      var isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 */
module.exports = _curry2(_dispatchable(['takeWhile'], _xtakeWhile, function takeWhile(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len && fn(list[idx])) {
    idx += 1;
  }
  return Array.prototype.slice.call(list, 0, idx);
}));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var _reduced = __webpack_require__(94);
var _xfBase = __webpack_require__(34);


module.exports = (function() {
  function XTakeWhile(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XTakeWhile.prototype['@@transducer/init'] = _xfBase.init;
  XTakeWhile.prototype['@@transducer/result'] = _xfBase.result;
  XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : _reduced(result);
  };

  return _curry2(function _xtakeWhile(f, xf) { return new XTakeWhile(f, xf); });
}());


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      var sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */
module.exports = _curry2(function tap(fn, x) {
  fn(x);
  return x;
});


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var _cloneRegExp = __webpack_require__(332);
var _curry2 = __webpack_require__(3);
var _isRegExp = __webpack_require__(704);
var toString = __webpack_require__(148);


/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */
module.exports = _curry2(function test(pattern, str) {
  if (!_isRegExp(pattern)) {
    throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
  }
  return _cloneRegExp(pattern).test(str);
});


/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = function _isRegExp(x) {
  return Object.prototype.toString.call(x) === '[object RegExp]';
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(151);


/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */
module.exports = invoker(0, 'toLowerCase');


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */
module.exports = _curry1(function toPairsIn(obj) {
  var pairs = [];
  for (var prop in obj) {
    pairs[pairs.length] = [prop, obj[prop]];
  }
  return pairs;
});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var invoker = __webpack_require__(151);


/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */
module.exports = invoker(0, 'toUpperCase');


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var _reduce = __webpack_require__(56);
var _xwrap = __webpack_require__(320);
var curryN = __webpack_require__(40);


/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */
module.exports = curryN(4, function transduce(xf, fn, acc, list) {
  return _reduce(xf(typeof fn === 'function' ? _xwrap(fn) : fn), acc, list);
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */
module.exports = _curry1(function transpose(outerlist) {
  var i = 0;
  var result = [];
  while (i < outerlist.length) {
    var innerlist = outerlist[i];
    var j = 0;
    while (j < innerlist.length) {
      if (typeof result[j] === 'undefined') {
        result[j] = [];
      }
      result[j].push(innerlist[j]);
      j += 1;
    }
    i += 1;
  }
  return result;
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);
var map = __webpack_require__(45);
var sequence = __webpack_require__(383);


/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Nothing` if the given divisor is `0`
 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
 */
module.exports = _curry3(function traverse(of, f, traversable) {
  return typeof traversable['fantasy-land/traverse'] === 'function' ?
    traversable['fantasy-land/traverse'](f, of) :
    sequence(of, map(f, traversable));
});


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */
module.exports = (function() {
  var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
           '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028' +
           '\u2029\uFEFF';
  var zeroWidth = '\u200b';
  var hasProtoTrim = (typeof String.prototype.trim === 'function');
  if (!hasProtoTrim || (ws.trim() || !zeroWidth.trim())) {
    return _curry1(function trim(str) {
      var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
      var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
      return str.replace(beginRx, '').replace(endRx, '');
    });
  } else {
    return _curry1(function trim(str) {
      return str.trim();
    });
  }
}());


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var _arity = __webpack_require__(73);
var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);


/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
 */
module.exports = _curry2(function _tryCatch(tryer, catcher) {
  return _arity(tryer.length, function() {
    try {
      return tryer.apply(this, arguments);
    } catch (e) {
      return catcher.apply(this, _concat([e], arguments));
    }
  });
});


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */
module.exports = _curry1(function unapply(fn) {
  return function() {
    return fn(Array.prototype.slice.call(arguments, 0));
  };
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);
var nAry = __webpack_require__(178);


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      var takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */
module.exports = _curry1(function unary(fn) {
  return nAry(1, fn);
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var curryN = __webpack_require__(40);


/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      var addFour = a => b => c => d => a + b + c + d;
 *
 *      var uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */
module.exports = _curry2(function uncurryN(depth, fn) {
  return curryN(depth, function() {
    var currentDepth = 1;
    var value = fn;
    var idx = 0;
    var endIdx;
    while (currentDepth <= depth && typeof value === 'function') {
      endIdx = currentDepth === depth ? arguments.length : idx + value.length;
      value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
      currentDepth += 1;
      idx = endIdx;
    }
    return value;
  });
});


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      var f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */
module.exports = _curry2(function unfold(fn, seed) {
  var pair = fn(seed);
  var result = [];
  while (pair && pair.length) {
    result[result.length] = pair[0];
    pair = fn(pair[1]);
  }
  return result;
});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry2 = __webpack_require__(3);
var compose = __webpack_require__(240);
var uniq = __webpack_require__(252);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */
module.exports = _curry2(compose(uniq, _concat));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var _concat = __webpack_require__(65);
var _curry3 = __webpack_require__(6);
var uniqWith = __webpack_require__(253);


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> a -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      var l1 = [{a: 1}, {a: 2}];
 *      var l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */
module.exports = _curry3(function unionWith(pred, list1, list2) {
  return uniqWith(pred, _concat(list1, list2));
});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */
module.exports = _curry3(function unless(pred, whenFalseFn, x) {
  return pred(x) ? x : whenFalseFn(x);
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var _identity = __webpack_require__(251);
var chain = __webpack_require__(237);


/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */
module.exports = chain(_identity);


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */
module.exports = _curry3(function until(pred, fn, init) {
  var val = init;
  while (!pred(val)) {
    val = fn(val);
  }
  return val;
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var _curry1 = __webpack_require__(5);


/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */
module.exports = _curry1(function valuesIn(obj) {
  var prop;
  var vs = [];
  for (prop in obj) {
    vs[vs.length] = obj[prop];
  }
  return vs;
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */
module.exports = (function() {
  // `Const` is a functor that effectively ignores the function given to `map`.
  var Const = function(x) {
    return {value: x, 'fantasy-land/map': function() { return this; }};
  };

  return _curry2(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
  });
}());


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless
 * @example
 *
 *      // truncate :: String -> String
 *      var truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */
module.exports = _curry3(function when(pred, whenTrueFn, x) {
  return pred(x) ? whenTrueFn(x) : x;
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);
var equals = __webpack_require__(57);
var map = __webpack_require__(45);
var where = __webpack_require__(387);


/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */
module.exports = _curry2(function whereEq(spec, testObj) {
  return where(map(equals, spec), testObj);
});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var _contains = __webpack_require__(115);
var _curry2 = __webpack_require__(3);
var flip = __webpack_require__(186);
var reject = __webpack_require__(183);


/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */
module.exports = _curry2(function(xs, list) {
  return reject(flip(_contains)(xs), list);
});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */
module.exports = _curry2(function xprod(a, b) { // = xprodWith(prepend); (takes about 3 times as long...)
  var idx = 0;
  var ilen = a.length;
  var j;
  var jlen = b.length;
  var result = [];
  while (idx < ilen) {
    j = 0;
    while (j < jlen) {
      result[result.length] = [a[idx], b[j]];
      j += 1;
    }
    idx += 1;
  }
  return result;
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */
module.exports = _curry2(function zip(a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = [a[idx], b[idx]];
    idx += 1;
  }
  return rv;
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var _curry2 = __webpack_require__(3);


/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zipWith(pair), fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */
module.exports = _curry2(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var _curry3 = __webpack_require__(6);


/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a,b -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      var f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */
module.exports = _curry3(function zipWith(fn, a, b) {
  var rv = [];
  var idx = 0;
  var len = Math.min(a.length, b.length);
  while (idx < len) {
    rv[idx] = fn(a[idx], b[idx]);
    idx += 1;
  }
  return rv;
});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(r){return r&&"object"==typeof r&&"default"in r?r.default:r}var curry=_interopDefault(__webpack_require__(132)),cond=_interopDefault(__webpack_require__(246)),isNil=_interopDefault(__webpack_require__(177)),identity=_interopDefault(__webpack_require__(150)),is=_interopDefault(__webpack_require__(187)),T=_interopDefault(__webpack_require__(231)),gte=_interopDefault(__webpack_require__(250)),complement=_interopDefault(__webpack_require__(239)),eqProps=_interopDefault(__webpack_require__(354)),isEmpty=_interopDefault(__webpack_require__(255)),anyPass=_interopDefault(__webpack_require__(234)),pipe=_interopDefault(__webpack_require__(181)),toPairs=_interopDefault(__webpack_require__(386)),map=_interopDefault(__webpack_require__(45)),adjust=_interopDefault(__webpack_require__(232)),fromPairs=_interopDefault(__webpack_require__(358)),range=_interopDefault(__webpack_require__(380)),split=_interopDefault(__webpack_require__(384)),path=_interopDefault(__webpack_require__(133)),newStartsWith=_interopDefault(__webpack_require__(385)),newEndsWith=_interopDefault(__webpack_require__(352)),find=_interopDefault(__webpack_require__(355)),propEq=_interopDefault(__webpack_require__(377)),findIndex=_interopDefault(__webpack_require__(356)),log=function(r){return console.log(r),r},trace=curry(function(r,e){return console.log(r),e}),toNumber=cond([[isNil,identity],[is(Number),identity],[T,function(r){return Number(r)}]]),toDate=function(r){return cond([[isNil,identity],[is(Object),identity],[T,function(r){return new Date(r)}]])(r)},isWithin=curry(function(r,e,t){var i=is(Number);return i(r)&&i(e)&&i(t)&&gte(t,r)&&gte(e,t)}),isNotWithin=complement(isWithin),eqLength=eqProps("length"),random=function(r,e){return Math.floor(Math.random()*(e-r+1))+r},sample=function(r){if(isNil(r)||isEmpty(r))return null;var e=r.length-1;return r[random(0,e)]},isNilOrEmpty=anyPass([isNil,isEmpty]),isNotNil=complement(isNil),isUndefined=function(r){return void 0===r},mapKeys=curry(function(r,e){return pipe(toPairs,map(adjust(r,0)),fromPairs)(e)}),rangeStep=curry(function(e,t,r){return 0===e?null:0<e&&r<t?null:e<0&&t<r?null:map(function(r){return t+e*r},range(0,1+(r-t)/e>>>0))}),dotPath=curry(function(r,e){return path(split(".",r),e)}),startsWith=curry(function(r,e){return newStartsWith(r,e)}),endsWith=curry(function(r,e){return newEndsWith(r,e)}),findByProp=curry(function(r,e,t){return find(propEq(r,e))(t)}),findIndexByProp=curry(function(r,e,t){return findIndex(propEq(r,e))(t)}),Ramdasauce={log:log,trace:trace,toNumber:toNumber,toDate:toDate,isWithin:isWithin,isNotWithin:isNotWithin,eqLength:eqLength,random:random,sample:sample,isNilOrEmpty:isNilOrEmpty,isNotNil:isNotNil,isUndefined:isUndefined,mapKeys:mapKeys,rangeStep:rangeStep,dotPath:dotPath,startsWith:startsWith,endsWith:endsWith,findByProp:findByProp,findIndexByProp:findIndexByProp};module.exports=Ramdasauce,module.exports=Ramdasauce;


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuItem__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });
/* unused harmony reexport MenuItem */


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuItem__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
var Sidebar=function Sidebar(_ref){var location=_ref.location,role=_ref.role,menus=_ref.menus,branch=_ref.branch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand'},role==='admin_travy'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Travelinpod ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Admin')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Passpod ',branch==='PH'&&'PH',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Admin')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'sidebar-menu metismenu',id:'sidebar-menu'},menus.map(function(menu,i){if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(menu.role,role)&&__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(menu.branch,branch)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__MenuItem__["a" /* default */],{key:i,menu:menu,location:location,role:role,branch:branch});}else{return null;}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-overlay',id:'sidebar-overlay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar-mobile-menu-handle',id:'sidebar-mobile-menu-handle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mobile-menu-handle'}));};/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var menus=[{title:'Destinations',url:'/destination',role:['admin'],branch:['ID','PH'],subs:[{title:'Manage Destination',url:'/destination/manage',role:['admin'],branch:['ID','PH']},{title:'Continent Mapping',url:'/destination/mapping',role:['admin'],branch:['ID','PH']}]},{title:'Attractions',url:'/attractions',role:['admin'],branch:['ID','PH'],subs:[{title:'Manage Attractions',url:'/attractions',role:['admin'],branch:['ID','PH']},{title:'Manage Popular Attractions',url:'/attractions/popular',role:['admin'],branch:['ID','PH']},{title:'Attraction Mapping',url:'/attractions/new-attraction-mapping',role:['admin'],branch:['ID']},{title:'Reviews',url:'/attractions/reviews',role:['admin'],branch:['ID','PH']},{title:'Cron Report Tools',url:'/attractions/cron-report',role:'admin',branch:['ID']}]},{title:'Wifi Product',url:'/product',role:['admin'],branch:['ID','PH']},{title:'eSIM',url:'/esim',role:['admin'],branch:['ID']},{title:'Coupon',url:'/coupon',role:['admin','finance'],branch:['ID','PH'],subs:[{title:'Manage Coupon',url:'/coupon/manage-coupon',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Provider',url:'/coupon/manage-provider',role:['admin','finance'],branch:['ID']},{title:'Manage Sobat Affiliate',url:'/coupon/manage-affiliate',role:['admin','finance'],branch:['ID']}]},{title:'Events',url:'/events',role:['admin','cs','finance'],branch:['ID'],subs:[{title:'Events List',url:'/events/events-list',role:['admin','cs','finance'],branch:['ID']},{title:'Popular Events',url:'/events/popular-events',role:['admin','cs','finance'],branch:['ID']},{title:'Events Categories',url:'/events/events-categories',role:['admin','cs','finance'],branch:['ID']}]},{title:'Insurance',url:'/insurance',role:['admin','cs','finance'],branch:['ID'],subs:[{title:'Travel Package',url:'/insurance/travel-package-list',role:['admin','cs','finance'],branch:['ID']},{title:'Ticket Package',url:'/insurance/ticket-package-list',role:['admin','cs','finance'],branch:['ID']}]},{title:'E-commerce',url:'/e-commerce',role:['admin','finance'],branch:['ID','PH'],subs:[{title:'Manage Category',url:'/e-commerce/manage-category',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Variant',url:'/e-commerce/manage-variant',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Brand',url:'/e-commerce/manage-brand',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Warehouse',url:'/e-commerce/manage-warehouse',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Inventory',url:'/e-commerce/manage-inventory',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Product',url:'/e-commerce/manage-ecommerce-product',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Supplier',url:'/e-commerce/manage-supplier',role:['admin','finance'],branch:['ID','PH']},{title:'Manage Order',url:'/e-commerce/manage-ecommerce-order',role:['admin','finance'],branch:['ID']}]},{title:'Order',url:'/order',role:['admin','cs','finance','admin_travy'],branch:['ID','PH'],subs:[{title:'Order List',url:'/order/list',role:['admin','cs','finance','admin_travy'],branch:['ID','PH']},{title:'Order Detail List',url:'/order/detail-list',role:['admin','cs','finance'],branch:['ID','PH']},{title:'Auto Transfer List',url:'/order/auto-transfer',role:['admin','cs','finance'],branch:['ID']},{title:'Chatbot Order List',url:'/order/chatbot-list',role:['admin','cs','finance'],branch:['ID']},{title:'Change Status',url:'/order/change-status',role:['admin','cs','finance'],branch:['ID']}]},{title:'User',url:'/user',role:['admin'],branch:['ID','PH'],subs:[{title:'User list',url:'/user/list',role:['admin'],branch:['ID','PH']},{title:'User count by date',url:'/user/count',role:['admin'],branch:['ID','PH']}]},{title:'Misc.',url:'/misc',role:'admin',branch:['ID','PH'],subs:[{title:'Banners',url:'/misc/banners',role:'admin',branch:['ID','PH']},{title:'Markup',url:'/misc/markup',role:'admin',branch:['ID','PH']},{title:'Exchange Rate',url:'/misc/exchange-rate',role:'admin',branch:['ID']},{title:'Sections',url:'/misc/section-page',role:'admin',branch:['ID']},{title:'Shipping Preset',url:'/misc/shipping-preset',role:'admin',branch:['ID']},{title:'Attraction Promo',url:'/misc/attraction-promo',role:'admin',branch:['ID']},{title:'Promo Section',url:'/misc/promo-section',role:'admin',branch:['ID']},{title:'Failed Transaction',url:'/misc/failed-transaction',role:'admin',branch:['ID']},{title:'Scheduler',url:'/misc/scheduler',role:'admin',branch:['ID']}]},{title:'Travelinpod',url:'/travypass',role:['admin','admin_travy'],branch:['ID'],subs:[{title:'Manage Travelinpod',url:'/travypass/manage-travypass',role:['admin'],branch:['ID']},{title:'Order Report',url:'/travypass/order-report',role:['admin','admin_travy'],branch:['ID']}]},{title:'Manage Admin',url:'/manage-admin',role:['admin'],branch:['ID'],hidden:true}];/* harmony default export */ __webpack_exports__["a"] = (menus);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_React$Component){_inherits(HomePage,_React$Component);function HomePage(props){_classCallCheck(this,HomePage);var _this=_possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).call(this,props));_this.state={// DO NOT remove the legacy state below
// role: null
};return _this;}// DO NOT remove the legacy props checking below
// componentWillReceiveProps = (nextProps) => {
//   if (nextProps.auth.user) {
//     this.setState({ role: nextProps.auth.user.role })
//   }
// }
_createClass(HomePage,[{key:'render',value:function render(){var auth=this.props.auth;if(auth.user&&auth.user.role==='admin'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/destination/manage'});}else if(auth.user&&auth.user.role!=='admin'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/order'});}else if(!auth.user){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/login'});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Attraction Dashboard'))));}}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{preset:state.preset,auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(HomePage));

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginPage=function(_React$Component){_inherits(LoginPage,_React$Component);function LoginPage(props){_classCallCheck(this,LoginPage);var _this=_possibleConstructorReturn(this,(LoginPage.__proto__||Object.getPrototypeOf(LoginPage)).call(this,props));_this.componentDidMount=function(){_this.props.checkAuth();};_this.componentWillReceiveProps=function(nextProps){if(nextProps.auth.user&&!nextProps.auth.err){_this.setState({redirect:true,error:null});}};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState[field]=val;_this.setState(newState);};_this._formSubmit=function(event){event.preventDefault();var _this$state=_this.state,email=_this$state.email,password=_this$state.password;var data={email:email,password:password};_this.props.login(data);};_this.state={email:'',password:'',redirect:false,error:null};return _this;}_createClass(LoginPage,[{key:'render',value:function render(){var _this2=this;if(this.state.redirect){var redirect='/';if(this.props.auth.user.role==='admin'){redirect='/destination/manage';}else{redirect='/order/list';}var history=this.props.history.location;if(history.state&&history.state.from&&history.state.from.pathname){redirect=history.state.from.pathname;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:redirect});}var _props$auth=this.props.auth,fetching=_props$auth.fetching,err=_props$auth.err;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'auth'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'auth-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'auth-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'auth-title'},'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'auth-content'},err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.state.error),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._formSubmit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'email'},'E-Mail'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',className:'form-control underlined',name:'email',id:'email',placeholder:'Your email address',required:true,onChange:function onChange(event){return _this2._inputChange(event,'email');},disabled:fetching})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'password'},'Password'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',className:'form-control underlined',name:'password',id:'password',placeholder:'Your password',required:true,onChange:function onChange(event){return _this2._inputChange(event,'password');},disabled:fetching})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-block btn-primary',disabled:fetching},!fetching?'Login':'Logging in ...')))))));}}]);return LoginPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{login:function login(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authRequest(data));},logout:function logout(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authLogout());},init:function init(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authInit());},checkAuth:function checkAuth(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authCheckRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(LoginPage));

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Destination_ManageDestination__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Destination_Mapping__ = __webpack_require__(841);
var subList={Manage:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Destination_ManageDestination__["a" /* default */],null),Mapping:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Destination_Mapping__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'manage':_ref$subname,location=_ref.location;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var UserPage=function UserPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (UserPage);

/***/ }),
/* 738 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(740);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(741);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(258);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(743),
    ListCache = __webpack_require__(192),
    Map = __webpack_require__(259);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(744),
    hashDelete = __webpack_require__(749),
    hashGet = __webpack_require__(750),
    hashHas = __webpack_require__(751),
    hashSet = __webpack_require__(752);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(191);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(312),
    isMasked = __webpack_require__(746),
    isObject = __webpack_require__(72),
    toSource = __webpack_require__(391);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(747);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(191);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(191);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 753 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(193);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(193);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(193);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(193);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(194);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(194);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(194);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(194);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    arrayMap = __webpack_require__(315),
    isArray = __webpack_require__(33),
    isSymbol = __webpack_require__(169);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(765),
    hasUnicode = __webpack_require__(393),
    stringToArray = __webpack_require__(767),
    toString = __webpack_require__(260);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(766);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(768),
    hasUnicode = __webpack_require__(393),
    unicodeToArray = __webpack_require__(769);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 768 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Destination_FormCreate__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Destination_FormDelete__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Destination_FormEdit__ = __webpack_require__(797);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DestinationPage=function(_React$Component){_inherits(DestinationPage,_React$Component);function DestinationPage(props){_classCallCheck(this,DestinationPage);var _this=_possibleConstructorReturn(this,(DestinationPage.__proto__||Object.getPrototypeOf(DestinationPage)).call(this,props));_this._filterChange=function(event,field){var newState=Object.assign({},_this.state.filter);var val=event.target.value;newState[field]=val;_this.setState({filter:newState});if(field==='name'){__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_3_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="name"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="name"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()("tr:hidden").show();}}};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._select=function(obj,action){_this.setState({selected:obj});_this._toggleModal(action);};_this.componentDidMount=function(){_this.props.getDestination();};_this._reverseOrder=function(){_this.setState({reverse:!_this.state.reverse});__WEBPACK_IMPORTED_MODULE_3_jquery___default()("tbody").each(function(elem,index){var arr=__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.makeArray(__WEBPACK_IMPORTED_MODULE_3_jquery___default()("tr",this).detach());arr.reverse();__WEBPACK_IMPORTED_MODULE_3_jquery___default()(this).append(arr);});};_this.state={showModal:null,selected:null,filter:{name:''},reverse:false};return _this;}_createClass(DestinationPage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,fetching=_props.fetching,err=_props.err;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Destination List',fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create');}},'Create Destination')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'control-label mr-2'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',placeholder:'Destination Name',value:this.state.filter.name,onChange:function onChange(event){return _this2._filterChange(event,'name');}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Narrow Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Wide Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Wide Mobile Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{role:'button',onClick:function onClick(){return _this2._reverseOrder();}},'Priority ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-'+(this.state.reverse?'sort-numeric-down':'sort-numeric-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Experience Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Update Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'9',className:'text-center'},'- No Data -')):data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'name'},item.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url?item.image_url.narrow:'',alt:'',style:{height:'75px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url?item.image_url.wide:'',alt:'',style:{height:'75px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url?item.image_url.wide_mobile:'',alt:'',style:{height:'75px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.priority||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.experience_count||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._select(item,'edit-content');},className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._select(item,'edit-image');},className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._select(item,'delete');},className:'btn btn-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Destination_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Destination_FormDelete__["a" /* default */],{data:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-content'||this.state.showModal==='edit-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Destination_FormEdit__["a" /* default */],{data:this.state.selected,editType:this.state.showModal,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return DestinationPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return Object.assign({},state.destination);};var dispatchToProps=function dispatchToProps(dispatch){return{getDestination:function getDestination(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_DestinationRedux__["b" /* default */].destinationRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DestinationPage));

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(20);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(127);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
var isBrowser = typeof window !== 'undefined';

var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (isBrowser) {
        if (!this.props.container) {
          this.container = document.createElement('div');
          document.body.appendChild(this.container);
        } else {
          this.container = this.props.container;
        }
        this.renderLayer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!useCreatePortal) {
        _reactDom2.default.unmountComponentAtNode(this.container);
      }
      if (!this.props.container) {
        document.body.removeChild(this.container);
      }
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      if (!useCreatePortal) {
        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (useCreatePortal) {
        return _reactDom2.default.createPortal(this.props.children, this.container);
      }
      return null;
    }
  }]);

  return Portal;
}(_react.Component);

Portal.propTypes = {
  children: _propTypes2.default.node, // eslint-disable-line
  container: _propTypes2.default.object // eslint-disable-line
};

exports.default = Portal;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(773);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(774));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 773 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 776 */
/***/ (function(module, exports) {

(function(root) {
  var isOn = false;
  var scrollbarSize;
  var scrollTop;

  function getScrollbarSize() {
    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;

    var doc = document.documentElement;
    var dummyScroller = document.createElement('div');
    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
    doc.appendChild(dummyScroller);
    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
    doc.removeChild(dummyScroller);
    return scrollbarSize;
  }

  function hasScrollbar() {
    return document.documentElement.scrollHeight > window.innerHeight;
  }

  function on(options) {
    if (typeof document === 'undefined' || isOn) return;
    var doc = document.documentElement;
    scrollTop = window.pageYOffset;
    if (hasScrollbar()) {
      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
    } else {
      doc.style.width = '100%';
    }
    doc.style.position = 'fixed';
    doc.style.top = -scrollTop + 'px';
    doc.style.overflow = 'hidden';
    isOn = true;
  }

  function off() {
    if (typeof document === 'undefined' || !isOn) return;
    var doc = document.documentElement;
    doc.style.width = '';
    doc.style.position = '';
    doc.style.top = '';
    doc.style.overflow = '';
    window.scroll(0, scrollTop);
    isOn = false;
  }

  function toggle() {
    if (isOn) {
      off();
      return;
    }
    on();
  }

  var noScroll = {
    on: on,
    off: off,
    toggle: toggle,
  };

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = noScroll;
  } else {
    root.noScroll = noScroll;
  }
})(this);


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var createFocusTrap = __webpack_require__(778);

var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap(props) {
    _classCallCheck(this, FocusTrap);

    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));

    _this.setNode = function (el) {
      _this.node = el;
    };

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }
    return _this;
  }

  _createClass(FocusTrap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
      var tailoredFocusTrapOptions = {
        returnFocusOnDeactivate: false
      };
      for (var optionName in specifiedFocusTrapOptions) {
        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
        if (optionName === 'returnFocusOnDeactivate') continue;
        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
      }

      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
      if (this.props.active) {
        this.focusTrap.activate();
      }
      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;

        var returnFocus = returnFocusOnDeactivate || false;
        var config = { returnFocus: returnFocus };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();
      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var elementProps = {
        ref: this.setNode
      };

      // This will get id, className, style, etc. -- arbitrary element props
      for (var prop in this.props) {
        if (!this.props.hasOwnProperty(prop)) continue;
        if (checkedProps.indexOf(prop) !== -1) continue;
        elementProps[prop] = this.props[prop];
      }

      return React.createElement(this.props.tag, elementProps, this.props.children);
    }
  }]);

  return FocusTrap;
}(React.Component);

FocusTrap.defaultProps = {
  active: true,
  tag: 'div',
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};

module.exports = FocusTrap;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var tabbable = __webpack_require__(779);
var xtend = __webpack_require__(780);

var listeningFocusTrap = null;

function focusTrap(element, userOptions) {
  var doc = document;
  var container =
    typeof element === 'string' ? doc.querySelector(element) : element;

  var config = xtend(
    {
      returnFocusOnDeactivate: true,
      escapeDeactivates: true
    },
    userOptions
  );

  var state = {
    firstTabbableNode: null,
    lastTabbableNode: null,
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false
  };

  var trap = {
    activate: activate,
    deactivate: deactivate,
    pause: pause,
    unpause: unpause
  };

  return trap;

  function activate(activateOptions) {
    if (state.active) return;

    updateTabbableNodes();

    state.active = true;
    state.paused = false;
    state.nodeFocusedBeforeActivation = doc.activeElement;

    var onActivate =
      activateOptions && activateOptions.onActivate
        ? activateOptions.onActivate
        : config.onActivate;
    if (onActivate) {
      onActivate();
    }

    addListeners();
    return trap;
  }

  function deactivate(deactivateOptions) {
    if (!state.active) return;

    removeListeners();
    state.active = false;
    state.paused = false;

    var onDeactivate =
      deactivateOptions && deactivateOptions.onDeactivate !== undefined
        ? deactivateOptions.onDeactivate
        : config.onDeactivate;
    if (onDeactivate) {
      onDeactivate();
    }

    var returnFocus =
      deactivateOptions && deactivateOptions.returnFocus !== undefined
        ? deactivateOptions.returnFocus
        : config.returnFocusOnDeactivate;
    if (returnFocus) {
      delay(function() {
        tryFocus(state.nodeFocusedBeforeActivation);
      });
    }

    return trap;
  }

  function pause() {
    if (state.paused || !state.active) return;
    state.paused = true;
    removeListeners();
  }

  function unpause() {
    if (!state.paused || !state.active) return;
    state.paused = false;
    addListeners();
  }

  function addListeners() {
    if (!state.active) return;

    // There can be only one listening focus trap at a time
    if (listeningFocusTrap) {
      listeningFocusTrap.pause();
    }
    listeningFocusTrap = trap;

    updateTabbableNodes();

    // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.
    delay(function() {
      tryFocus(getInitialFocusNode());
    });
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, true);
    doc.addEventListener('touchstart', checkPointerDown, true);
    doc.addEventListener('click', checkClick, true);
    doc.addEventListener('keydown', checkKey, true);

    return trap;
  }

  function removeListeners() {
    if (!state.active || listeningFocusTrap !== trap) return;

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);

    listeningFocusTrap = null;

    return trap;
  }

  function getNodeForOption(optionName) {
    var optionValue = config[optionName];
    var node = optionValue;
    if (!optionValue) {
      return null;
    }
    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue);
      if (!node) {
        throw new Error('`' + optionName + '` refers to no known node');
      }
    }
    if (typeof optionValue === 'function') {
      node = optionValue();
      if (!node) {
        throw new Error('`' + optionName + '` did not return a node');
      }
    }
    return node;
  }

  function getInitialFocusNode() {
    var node;
    if (getNodeForOption('initialFocus') !== null) {
      node = getNodeForOption('initialFocus');
    } else if (container.contains(doc.activeElement)) {
      node = doc.activeElement;
    } else {
      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
    }

    if (!node) {
      throw new Error(
        "You can't have a focus-trap without at least one focusable element"
      );
    }

    return node;
  }

  // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.
  function checkPointerDown(e) {
    if (container.contains(e.target)) return;
    if (config.clickOutsideDeactivates) {
      deactivate({
        returnFocus: !tabbable.isFocusable(e.target)
      });
    } else {
      e.preventDefault();
    }
  }

  // In case focus escapes the trap for some strange reason, pull it back in.
  function checkFocusIn(e) {
    // In Firefox when you Tab out of an iframe the Document is briefly focused.
    if (container.contains(e.target) || e.target instanceof Document) {
      return;
    }
    e.stopImmediatePropagation();
    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
  }

  function checkKey(e) {
    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
      e.preventDefault();
      deactivate();
      return;
    }
    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  }

  // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.
  function checkTab(e) {
    updateTabbableNodes();
    if (e.shiftKey && e.target === state.firstTabbableNode) {
      e.preventDefault();
      tryFocus(state.lastTabbableNode);
      return;
    }
    if (!e.shiftKey && e.target === state.lastTabbableNode) {
      e.preventDefault();
      tryFocus(state.firstTabbableNode);
      return;
    }
  }

  function checkClick(e) {
    if (config.clickOutsideDeactivates) return;
    if (container.contains(e.target)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  function updateTabbableNodes() {
    var tabbableNodes = tabbable(container);
    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
    state.lastTabbableNode =
      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
  }

  function tryFocus(node) {
    if (node === doc.activeElement) return;
    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus();
    state.mostRecentlyFocusedNode = node;
    if (isSelectableInput(node)) {
      node.select();
    }
  }
}

function isSelectableInput(node) {
  return (
    node.tagName &&
    node.tagName.toLowerCase() === 'input' &&
    typeof node.select === 'function'
  );
}

function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}

function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
}

function delay(fn) {
  return setTimeout(fn, 0);
}

module.exports = focusTrap;


/***/ }),
/* 779 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var elementDocument = el.ownerDocument || el;
  var regularTabbables = [];
  var orderedTabbables = [];

  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
  if (
    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}

function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
  if (
    node.disabled
    || isHiddenInput(node)
    || untouchabilityChecker.isUntouchable(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node, untouchabilityChecker) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

// Array.prototype.find not available in IE.
function find(list, predicate) {
  for (var i = 0, length = list.length; i < length; i++) {
    if (predicate(list[i])) return list[i];
  }
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function UntouchabilityChecker(elementDocument) {
  this.doc = elementDocument;
  // Node cache must be refreshed on every check, in case
  // the content of the element has changed. The cache contains tuples
  // mapping nodes to their boolean result.
  this.cache = [];
}

// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
  if (node.nodeType !== Node.ELEMENT_NODE) return false;

    // Search for a cached result.
    var cached = find(this.cache, function(item) {
      return item === node;
    });
    if (cached) return cached[1];

    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);

    var result = false;

    if (nodeComputedStyle.display === 'none') {
      result = true;
    } else if (node.parentNode) {
      result = this.hasDisplayNone(node.parentNode);
    }

    this.cache.push([node, result]);

    return result;
}

UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
  if (node === this.doc.documentElement) return false;
  var computedStyle = this.doc.defaultView.getComputedStyle(node);
  if (this.hasDisplayNone(node, computedStyle)) return true;
  return computedStyle.visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_ObjectCleaner__ = __webpack_require__(198);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this._fileSelect=function(event){var files=[];var raw=event.target.files;for(var i=0;i<raw.length;i++){files.push(raw[i]);}_this.setState({files:files});};_this._upload=function(event){event.preventDefault();var data=new FormData(event.target);data.append('type','destination-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var selected=Object.assign({},_this.state.selected);selected[field]=filename;_this.setState({selected:selected});};_this._inputChange=function(event,field){var newState=Object.assign({},_this.state);newState[field]=event.target.value.replace(/[^\x20-\x7E]/g,'');_this.setState(newState);};_this._submit=function(event){event.preventDefault();var image_file={wide:_this.state.selected.wide,narrow:_this.state.selected.narrow,wide_mobile:_this.state.selected.wide_mobile};image_file=Object(__WEBPACK_IMPORTED_MODULE_6__Utils_ObjectCleaner__["a" /* default */])(image_file);var data={name:_this.state.name,image_file:image_file,experience_count:_this.state.experience_count,priority:_this.state.priority,country_id:_this.state.country.value,about:_this.state.about};_this.props.submit(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}var newState=Object.assign({},_this.state);newState.priority=val;_this.setState(newState);};_this._addItem=function(field){var about=Object.assign({},_this.state.about);about[_this.state.lang_tab][field].push({title:'',content:''});_this.setState({about:about});};_this._removeItem=function(field,index){var about=Object.assign({},_this.state.about);about[_this.state.lang_tab][field].splice(index,1);_this.setState({about:about});};_this._aboutChange=function(event,parentField,index,field){var val=event.target.value;var about=Object.assign({},_this.state.about);about[_this.state.lang_tab][parentField][index][field]=val;_this.setState({about:about});};_this.lang=['en','id'];var aboutValues={};_this.lang.forEach(function(lang){aboutValues[lang]={getting_around:[],weather:[],currency:[],health:[]};});_this.state={files:[],uploaded:false,selected:{wide:'',narrow:'',wide_mobile:''},lang_tab:_this.lang[0],name:'',experience_count:0,priority:1,country:'',about:aboutValues};return _this;}// _imgSelect = (event, field) => {
//   let newState = {...this.state.selected}
//   newState[field] = event.target.value
//   this.setState({selected: newState})
// }
_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;var country_list=this.props.country_list;var countries=[];country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});var aboutList=[{id:'getting_around',label:'Getting Around'},{id:'weather',label:'Weather'},{id:'currency',label:'Currency and Tipping'},{id:'health',label:'Health'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'90vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Destination')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'name',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'name');},value:this.state.name,placeholder:'Destination Name',required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'experience_count',className:'control-label'},'Experience Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'experience_count',min:0,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'experience_count');},value:this.state.experience_count,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'priority',className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'priority',min:1,className:'form-control',onChange:function onChange(event){return _this2._valueChange(event,'priority');},value:this.state.priority,required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'country',className:'control-label'},'Country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:countries,value:this.state.country,required:true,onChange:function onChange(country){return _this2.setState({country:country});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.country,required:true,style:{position:'absolute',zIndex:'-1',top:0,left:'30%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Narrow (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'270x200'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUploader__["a" /* default */],{required:true,setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'narrow');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Wide (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1440x277'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUploader__["a" /* default */],{required:true,setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'wide');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Wide Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'375x269'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUploader__["a" /* default */],{required:true,setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'wide_mobile');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-4',role:'group'},this.lang.map(function(lang,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:i,type:'button',className:'btn btn-primary '+(_this2.state.lang_tab===lang&&'active'),onClick:function onClick(){return _this2.setState({lang_tab:lang});}},lang.toUpperCase());})),aboutList.map(function(about){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:about.id,className:'about-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control-label d-flex justify-content-between',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'title'},about.label||'-',' [ ',_this2.state.lang_tab.toUpperCase(),' ]'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary',onClick:function onClick(){return _this2._addItem(about.id);}},'Add Item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'15%',className:'text-center'},'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this2.state.about[_this2.state.lang_tab][about.id].length?_this2.state.about[_this2.state.lang_tab][about.id].map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'text',value:item.title,className:'form-control',onChange:function onChange(e){return _this2._aboutChange(e,about.id,i,'title');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,value:item.content,className:'form-control',onChange:function onChange(e){return _this2._aboutChange(e,about.id,i,'content');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:function onClick(){return _this2._removeItem(about.id,i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'- No Data -')))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return Object.assign({},state.files,{processing:state.destination.processing,success:state.destination.success,error:state.destination.err,country_list:state.preset.dataCountries});};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_DestinationRedux__["b" /* default */].destinationCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(784);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(791)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)))

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(20);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(394));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(794));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(398));

var _Transition = _interopRequireDefault(__webpack_require__(395));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(20));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(127);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(398));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormDelete=function(_React$Component){_inherits(FormDelete,_React$Component);function FormDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FormDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FormDelete.__proto__||Object.getPrototypeOf(FormDelete)).call.apply(_ref,[this].concat(args))),_this),_this._delete=function(event){if(event)event.preventDefault();_this.props.deleteDestination(_this.props.data.id);_this.props.closeModal();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FormDelete,[{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,closeModal=_props.closeModal;// const Delete = () => {
//   return <div className="alert alert-info">Deleting ...</div>
// }
// const Success = () => {
//   setTimeout(() => this.props.closeModal(), 10)
//   return <div className="alert alert-success">Deleted successfuly!</div>
// }
// const Error = () => {
//   return <div className="alert alert-danger">{ this.props.error }</div>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Delete Destination ?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this2._delete(e);},className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title'},data.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img img-responsive m-2',src:data.image_url?data.image_url.narrow:'',alt:'',style:{height:'75px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img img-responsive m-2',src:data.image_url?data.image_url.wide:'',alt:'',style:{height:'75px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img img-responsive m-2',src:data.image_url?data.image_url.wide_mobile:'',alt:'',style:{height:'75px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-danger'},'Delete'))));}}]);return FormDelete;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{processing:state.destination.processing,success:state.destination.success,error:state.destination.err};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteDestination:function deleteDestination(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_DestinationRedux__["b" /* default */].destinationDeleteRequest({id:id}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormDelete));

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findKey__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_findKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_findKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_seamless_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_ObjectCleaner__ = __webpack_require__(198);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormEdit=function(_React$Component){_inherits(FormEdit,_React$Component);function FormEdit(props){_classCallCheck(this,FormEdit);var _this=_possibleConstructorReturn(this,(FormEdit.__proto__||Object.getPrototypeOf(FormEdit)).call(this,props));_initialiseProps.call(_this);_this.lang=['en','id'];var country_list=props.country_list;var countries=[];country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});_this.countries=countries;var key=__WEBPACK_IMPORTED_MODULE_5_lodash_findKey___default()(countries,['value',props.data.country_id]);var about=props.data.about;var aboutValues={};_this.lang.forEach(function(lang){var getting_around=[];var weather=[];var currency=[];var health=[];if(about[lang]&&about[lang].getting_around){about[lang].getting_around.forEach(function(data){return getting_around.push(__WEBPACK_IMPORTED_MODULE_7_seamless_immutable___default()(data).asMutable());});}if(about[lang]&&about[lang].weather){about[lang].weather.forEach(function(data){return weather.push(__WEBPACK_IMPORTED_MODULE_7_seamless_immutable___default()(data).asMutable());});}if(about[lang]&&about[lang].currency){about[lang].currency.forEach(function(data){return currency.push(__WEBPACK_IMPORTED_MODULE_7_seamless_immutable___default()(data).asMutable());});}if(about[lang]&&about[lang].health){about[lang].health.forEach(function(data){return health.push(__WEBPACK_IMPORTED_MODULE_7_seamless_immutable___default()(data).asMutable());});}aboutValues[lang]={getting_around:getting_around,weather:weather,currency:currency,health:health};});_this.state={name:props.data.name||'',experience_count:props.data.experience_count||0,priority:props.data.priority||1,country:countries[key]||'',selected:{wide:props.data.image_file.wide||'',narrow:props.data.image_file.narrow||'',wide_mobile:props.data.image_file.wide_mobile||''},files:[],uploaded:false,lang_tab:_this.lang[0],about:aboutValues};return _this;}// _fileSelect = (event) => {
//   let files = []
//   const raw = event.target.files
//   for(let i = 0; i < raw.length; i++) {
//     files.push(raw[i])
//   }
//   this.setState({ files })
// }
// _upload = (event) => {
//   event.preventDefault()
//   let data = new FormData(event.target)
//   data.append('type', 'destination-image')
//   this.props.upload(data)
//   this.setState({ uploaded: true })
// }
// _imgSelect = (event, field) => {
//   let newState = {...this.state.selected}
//   newState[field] = event.target.value
//   this.setState({selected: newState})
// }
_createClass(FormEdit,[{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,editType=_props.editType,closeModal=_props.closeModal;var aboutList=[{id:'getting_around',label:'Getting Around'},{id:'weather',label:'Weather'},{id:'currency',label:'Currency and Tipping'},{id:'health',label:'Health'}];// const Update = () => {
//   return <div className="alert alert-info">Updating ...</div>
// }
// const Success = () => {
//   setTimeout(() => this.props.closeModal(), 10)
//   return <div className="alert alert-success">Updated successfuly!</div>
// }
// const Error = () => {
//   return <div className="alert alert-danger">{ this.props.error }</div>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'45vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Destination')),editType==='edit-content'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'name',className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'name',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'name');},value:this.state.name,placeholder:'Destination Name'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'experience_count',className:'control-label'},'Experience Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'experience_count',min:0,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'experience_count');},value:this.state.experience_count}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'priority',className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'priority',min:1,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'priority');},value:this.state.priority}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'country',className:'control-label'},'Country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:this.countries,value:this.state.country,onChange:function onChange(country){return _this2.setState({country:country});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'about-list-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-4',role:'group'},this.lang.map(function(lang,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:i,type:'button',className:'btn btn-primary '+(_this2.state.lang_tab===lang&&'active'),onClick:function onClick(){return _this2.setState({lang_tab:lang});}},lang.toUpperCase());})),aboutList.map(function(about){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:about.id,className:'about-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'control-label d-flex justify-content-between',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'title'},about.label||'-','  [ ',_this2.state.lang_tab.toUpperCase(),' ]'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary',onClick:function onClick(){return _this2._addItem(about.id);}},'Add Item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'15%',className:'text-center'},'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this2.state.about[_this2.state.lang_tab][about.id].length?_this2.state.about[_this2.state.lang_tab][about.id].map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'text',value:item.title,className:'form-control',onChange:function onChange(e){return _this2._aboutChange(e,about.id,i,'title');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,value:item.content,className:'form-control',onChange:function onChange(e){return _this2._aboutChange(e,about.id,i,'content');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:function onClick(){return _this2._removeItem(about.id,i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'- No Data -')))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))):// EDIT IMAGE
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,data.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Narrow (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'270x200'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FileUploader__["a" /* default */],{setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'narrow');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Wide (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1440x277'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FileUploader__["a" /* default */],{setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'wide');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image Wide Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'375x269'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FileUploader__["a" /* default */],{setting:{type:'destination-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'wide_mobile');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return FormEdit;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this._fileUploaded=function(filename,field){var selected=Object.assign({},_this3.state.selected);selected[field]=filename;_this3.setState({selected:selected});};this._inputChange=function(event,field){var newState=Object.assign({},_this3.state);newState[field]=event.target.value;_this3.setState(newState);};this._submit=function(event){event.preventDefault();var image_file={wide:_this3.state.selected.wide,narrow:_this3.state.selected.narrow,wide_mobile:_this3.state.selected.wide_mobile};image_file=Object(__WEBPACK_IMPORTED_MODULE_8__Utils_ObjectCleaner__["a" /* default */])(image_file);var content={name:_this3.state.name,experience_count:_this3.state.experience_count,priority:_this3.state.priority,country_id:_this3.state.country.value,image_file:image_file,about:_this3.state.about};_this3.props.submit(_this3.props.data.id,content);_this3.props.closeModal();};this._addItem=function(field){var about=Object.assign({},_this3.state.about);about[_this3.state.lang_tab][field].push({title:'',content:''});_this3.setState({about:about});};this._removeItem=function(field,index){var about=Object.assign({},_this3.state.about);about[_this3.state.lang_tab][field].splice(index,1);_this3.setState({about:about});};this._aboutChange=function(event,parentField,index,field){var val=event.target.value;var about=Object.assign({},_this3.state.about);about[_this3.state.lang_tab][parentField][index][field]=val;_this3.setState({about:about});};};var stateToProps=function stateToProps(state){return{uploadFiles:state.files,processing:state.destination.processing,success:state.destination.success,error:state.destination.err,country_list:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(id,content){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationUpdateRequest({id:id,content:content}));},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormEdit));

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(799),
    baseForOwn = __webpack_require__(800),
    baseIteratee = __webpack_require__(262);

/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
}

module.exports = findKey;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

module.exports = baseFindKey;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(801),
    keys = __webpack_require__(143);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(802);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 802 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(804),
    getMatchData = __webpack_require__(832),
    matchesStrictComparable = __webpack_require__(403);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(399),
    baseIsEqual = __webpack_require__(400);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(192);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 806 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 807 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(192),
    Map = __webpack_require__(259),
    MapCache = __webpack_require__(258);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(399),
    equalArrays = __webpack_require__(401),
    equalByTag = __webpack_require__(816),
    equalObjects = __webpack_require__(820),
    getTag = __webpack_require__(827),
    isArray = __webpack_require__(33),
    isBuffer = __webpack_require__(317),
    isTypedArray = __webpack_require__(319);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(258),
    setCacheAdd = __webpack_require__(812),
    setCacheHas = __webpack_require__(813);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 812 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 813 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 814 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(168),
    Uint8Array = __webpack_require__(817),
    eq = __webpack_require__(392),
    equalArrays = __webpack_require__(401),
    mapToArray = __webpack_require__(818),
    setToArray = __webpack_require__(819);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(84);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(821);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(822),
    getSymbols = __webpack_require__(824),
    keys = __webpack_require__(143);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(823),
    isArray = __webpack_require__(33);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 823 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(825),
    stubArray = __webpack_require__(826);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(828),
    Map = __webpack_require__(259),
    Promise = __webpack_require__(829),
    Set = __webpack_require__(830),
    WeakMap = __webpack_require__(831),
    baseGetTag = __webpack_require__(129),
    toSource = __webpack_require__(391);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(84);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(402),
    keys = __webpack_require__(143);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(400),
    get = __webpack_require__(834),
    hasIn = __webpack_require__(835),
    isKey = __webpack_require__(257),
    isStrictComparable = __webpack_require__(402),
    matchesStrictComparable = __webpack_require__(403),
    toKey = __webpack_require__(195);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(404);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(836),
    hasPath = __webpack_require__(389);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 836 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 837 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(839),
    basePropertyDeep = __webpack_require__(840),
    isKey = __webpack_require__(257),
    toKey = __webpack_require__(195);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(404);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Destination_CreateMapping__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Destination_ViewMapping__ = __webpack_require__(843);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import $ from 'jquery'
var Mapping=function(_React$Component){_inherits(Mapping,_React$Component);function Mapping(props){_classCallCheck(this,Mapping);var _this=_possibleConstructorReturn(this,(Mapping.__proto__||Object.getPrototypeOf(Mapping)).call(this,props));_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var item=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];_this.setState({showModal:modalId,detail:item});};_this.componentDidMount=function(){_this.props.getContinent();};var countries=[];props.country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});_this.country_list=countries;_this.state={showModal:null,continent:'0',detail:[]};return _this;}_createClass(Mapping,[{key:'render',value:function render(){var _this2=this;var destination=this.props.destination;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Continent Mapping',destination.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create');}},'Create Mapping')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Continent'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.continent,onChange:function onChange(event){return _this2.setState({continent:event.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- Select Continent -'),destination.continent&&destination.continent.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:i},item.name||'-');})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(destination.fetching||destination.processing)&&destination.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},destination.err),this.state.continent&&destination.continent.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{width:'60%'},'Destinations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,destination.continent[this.state.continent].countries.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.destinations.map(function(dest,i){if(i===0){return dest.name;}else{return", "+dest.name;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('view',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}))));})))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Destination_CreateMapping__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='view',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Destination_ViewMapping__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return Mapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{destination:state.destination,country_list:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{getContinent:function getContinent(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].continentRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Mapping));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateMapping=function(_React$Component){_inherits(CreateMapping,_React$Component);function CreateMapping(props){_classCallCheck(this,CreateMapping);var _this=_possibleConstructorReturn(this,(CreateMapping.__proto__||Object.getPrototypeOf(CreateMapping)).call(this,props));_this.componentDidMount=function(){_this.props.getDestination();};_this._inputChange=function(event,field){var newState=Object.assign({},_this.state);newState[field]=event.target.value.replace(/[^\x20-\x7E]/g,'');_this.setState(newState);};_this._submit=function(event){event.preventDefault();var content={country_id:_this.state.country.value};_this.props.submit(_this.state.destination.value,content);_this.props.closeModal();};_this.state={country:'',destination:''};return _this;}_createClass(CreateMapping,[{key:'render',value:function render(){var _this2=this;// const { files } = this.state
var _props=this.props,country_list=_props.country_list,data=_props.data;var countries=[];country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});var destinations=[];data.map(function(item,i){destinations[i]={value:item.id,label:item.name};return destinations;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Map Destination to Continent')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'country',className:'control-label'},'Country')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:countries,value:this.state.country,required:true,onChange:function onChange(country){return _this2.setState({country:country});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.country,required:true,style:{position:'absolute',zIndex:'-1',top:0,left:'30%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'destinations',className:'control-label'},'Destinations')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:destinations,value:this.state.destination,required:true,onChange:function onChange(destination){return _this2.setState({destination:destination});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.destination,required:true,style:{position:'absolute',zIndex:'-1',top:0,left:'30%'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return CreateMapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{data:state.destination.data,processing:state.destination.processing,success:state.destination.success,error:state.destination.err,country_list:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{getDestination:function getDestination(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationRequest());},submit:function submit(id,content){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationUpdateRequest({id:id,content:content}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateMapping));

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewMapping=function(_React$Component){_inherits(ViewMapping,_React$Component);function ViewMapping(props){_classCallCheck(this,ViewMapping);var _this=_possibleConstructorReturn(this,(ViewMapping.__proto__||Object.getPrototypeOf(ViewMapping)).call(this,props));_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var destination=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';_this.setState({showModal:modalId,destination:destination});};_this._submit=function(event){event.preventDefault();var content={country_id:null};_this.props.submit(_this.state.destination.id,content);_this._toggleModal();};_this.state={showModal:null,destination:''};return _this;}_createClass(ViewMapping,[{key:'render',value:function render(){var _this2=this;var detail=this.props.detail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Destination List in ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete Mapping'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,detail.destinations&&detail.destinations.map(function(dest,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dest.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._toggleModal('delete',dest);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-trash'}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Delete Mapping ?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title'},this.state.destination.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-danger'},'Delete'))))));}}]);return ViewMapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(id,content){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationUpdateRequest({id:id,content:content}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewMapping));

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Attraction_Default__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Attraction_Popular__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Attraction_AttractionMapping__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Attraction_NewAttractionMapping__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Attraction_Reviews__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Attraction_CronReport__ = __webpack_require__(875);
var subList={Default:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Attraction_Default__["a" /* default */],null),Popular:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Attraction_Popular__["a" /* default */],null),AttractionMapping:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Attraction_AttractionMapping__["a" /* default */],null),NewAttractionMapping:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Attraction_NewAttractionMapping__["a" /* default */],null),Reviews:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Attraction_Reviews__["a" /* default */],null),CronReport:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Attraction_CronReport__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'default':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var AttractionPage=function AttractionPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (AttractionPage);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Attraction_AttractionDetail__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Attraction_PlaceDetail__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Attraction_AttractionResetUpdate__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Attraction_FormUpdateDetail__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Attraction_FormUpdateBanner__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Containers_Attraction_FormUpdateImage__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Containers_Attraction_DownloadAttractionData__ = __webpack_require__(857);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionDefaultPage=function(_React$Component){_inherits(AttractionDefaultPage,_React$Component);function AttractionDefaultPage(props){_classCallCheck(this,AttractionDefaultPage);var _this=_possibleConstructorReturn(this,(AttractionDefaultPage.__proto__||Object.getPrototypeOf(AttractionDefaultPage)).call(this,props));_this.componentDidUpdate=function(prevProps){if(_this.props.destination!==prevProps.destination){var id=null;if(_this.props.destination.data.length){id=_this.props.destination.data[0].id;}if(_this.props.destination.data.length&&!_this.state.destination){_this.setState({destination:id});_this._fetchData(_this.state.setting,id);}}};_this._fetchData=function(){var setting=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.state.setting;var destination=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this.state.destination;var tab=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var data={destination:destination,filter:Object.assign({},_this.state.setting,setting,_this.state.filter)};var activeTab=_this.state.tab;if(tab){activeTab=tab;}if(destination){if(activeTab==='attraction'){_this.props.getAttraction(data);}else{data.filter.type='landmark';_this.props.getPlace(data);}}};_this._destinationSelect=function(event){var val=event.target.value;_this.setState({destination:val});_this._fetchData(null,val);};_this._presetChange=function(event){var val=event.target.value;var name=event.target.name;var newState=Object.assign({},_this.state.setting);newState[name]=val;_this.setState({setting:newState});_this._fetchData(newState,_this.state.destination);};_this._changePage=function(page){_this.setState({page:page});var _this$state=_this.state,setting=_this$state.setting,destination=_this$state.destination,filter=_this$state.filter;var data=Object.assign({},setting,{page:page},filter);_this._fetchData(data,destination);};_this._filterChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state.filter);newState[field]=val;_this.setState({filter:newState});};_this._applyFilter=function(event){event.preventDefault();_this._fetchData();};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._selectAttraction=function(data,action){_this.setState({selected:data});_this._toggleModal(action);};_this._toggleDisable=function(event,id){var isDisabled=!event.target.value;var data={id:id,form:{is_disabled:isDisabled}};_this.props.updateAttractionDetail(data);setTimeout(function(){_this._fetchData();},500);};_this._changeTab=function(){var tab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'attraction';_this.setState({tab:tab,page:1});var _this$state2=_this.state,setting=_this$state2.setting,destination=_this$state2.destination,filter=_this$state2.filter;var data=Object.assign({},setting,filter);_this._fetchData(data,destination,tab);};_this.state={showModal:null,filter:{q:''},setting:Object.assign({},props.setting),destination:'',selected:null,reverse:false,tab:'attraction'};return _this;}_createClass(AttractionDefaultPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getDestination();}// Lifecycle method below (for grabbing initial destination id) causes a
// very hard to reproduce yet somewhat frequent timing glitch, so it's hidden.
// componentWillReceiveProps = (newProps) => {
//   let id = null
//   if (newProps.destination.data.length) {
//     id = newProps.destination.data[0].id
//   }
//   if (newProps.destination.data.length && !this.state.destination) {
//     this.setState({ destination: id })
//     this._fetchData(this.state.setting, id)
//   }
// }
// This lifecycle method is useful to replace function above
},{key:'render',value:function render(){var _this2=this;var _props=this.props,destination=_props.destination,attraction=_props.attraction;var setting=this.state.setting;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Attractions',(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},attraction.fetching?'Loading':'Processing',' ...')),this.state.tab==='attraction'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._toggleModal('download-attraction-data');},className:'btn btn-primary'},'Download Attraction Data')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-1'},'Language'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',name:'language_code',value:setting.language_code,onChange:function onChange(event){return _this2._presetChange(event);}},this.props.preset.dataLanguage.map(function(lang,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:lang.code==='ind'?'ID':lang.code==='eng'?'EN':lang.code},lang.code==='ind'?'ID':lang.code==='eng'?'EN':lang.code);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-1'},'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',name:'provider',value:setting.provider,onChange:function onChange(event){return _this2._presetChange(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'BMG'},'BMG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'KLOOK'},'Klook')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.destination,onChange:function onChange(event){return _this2._destinationSelect(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'- Select Destination -'),destination.data&&destination.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);}))),this.state.destination&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._applyFilter(event);},className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search by title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'title',className:'form-control',onChange:function onChange(event){return _this2._filterChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-1 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'110%'}},attraction.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},attraction.err),this.state.destination&&this.state.tab==='attraction'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Is Active?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Expiration Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Action'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Reset'))),attraction.data!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!attraction.data.data||!attraction.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'8'},'-- No Data --')):attraction.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'title'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.city?item.city.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_accounting___default.a.formatMoney(item.final_price,{symbol:setting.currency_code,format:'%s %v',thousand:',',precision:0})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__["a" /* default */],{isChecked:!item.is_disabled,onChange:function onChange(event){return _this2._toggleDisable(event,item.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.is_expired?'Expired':'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'view');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'update-detail');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'update-banner');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),' Banner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'update-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),' Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!item.is_ignored_on_update,className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'reset');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-redo'}),' Reset Update')));}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'View'))),attraction.data!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,attraction.data.data&&attraction.data.data.length?attraction.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'title'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectAttraction(item,'view');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'2',className:'text-center'},'- No Data -')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view',onClose:this._toggleModal,closeOnOverlayClick:true},this.state.tab==='attraction'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Attraction_AttractionDetail__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Attraction_PlaceDetail__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-detail',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Attraction_FormUpdateDetail__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-banner',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Attraction_FormUpdateBanner__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Containers_Attraction_FormUpdateImage__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='reset',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Attraction_AttractionResetUpdate__["a" /* default */],{detailId:this.state.selected&&this.state.selected.id,setting:this.state.setting,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download-attraction-data',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Containers_Attraction_DownloadAttractionData__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},this.state.destination&&attraction.data&&attraction.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:attraction.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return AttractionDefaultPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{destination:state.destination,attraction:state.attraction,preset:state.preset,setting:state.preset.setting};};var dispatchToProps=function dispatchToProps(dispatch){return{getDestination:function getDestination(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].destinationRequest());},getPlace:function getPlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_AttractionRedux__["b" /* default */].placeRequest(data));},getAttraction:function getAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_AttractionRedux__["b" /* default */].attractionRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));},clearCache:function clearCache(){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_AttractionRedux__["b" /* default */].attractionClearCacheRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionDefaultPage));

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = Paginator;

// Paginator constructor
//
// `per_page` is the number of results per page, `length` is the number of
// pages to display. They default to `25` and `10` respectively.
function Paginator(per_page, length) {
  // You really should be calling this with `new Paginator`, but WHATEVER.
  if (!(this instanceof Paginator)) {
    return new Paginator(per_page, length);
  }

  // Woo, defaults!
  this.per_page = per_page || 25;
  this.length = length || 10;
}

// Build an object with all the necessary information for outputting pagination
// controls.
//
// (new Paginator(paginator.build(100, 2)
Paginator.prototype.build = function(total_results, current_page) {
  // We want the number of pages, rounded up to the nearest page.
  var total_pages = Math.ceil(total_results / this.per_page);

  // Ensure both total_results and current_page are treated as Numbers
  total_results = parseInt(total_results, 10);
  current_page  = parseInt(current_page, 10) || 1;

  // Obviously we can't be on a negative or 0 page.
  if (current_page < 1) { current_page = 1; }
  // If the user has done something like /page/99999 we want to clamp that back
  // down.
  if (current_page > total_pages) { current_page = total_pages; }

  // This is the first page to be displayed as a numbered link.
  var first_page = Math.max(1, current_page - Math.floor(this.length / 2));

  // And here's the last page to be displayed specifically.
  var last_page = Math.min(total_pages, current_page + Math.floor(this.length / 2));

  // This is triggered if we're at or near one of the extremes; we won't have
  // enough page links. We need to adjust our bounds accordingly.
  if (last_page - first_page + 1 < this.length) {
    if (current_page < (total_pages / 2)) {
      last_page = Math.min(total_pages, last_page + (this.length - (last_page - first_page)));
    } else {
      first_page = Math.max(1, first_page - (this.length - (last_page - first_page)));
    }
  }

  // This can be triggered if the user wants an odd number of pages.
  if (last_page - first_page + 1 > this.length) {
    // We want to move towards whatever extreme we're closest to at the time.
    if (current_page > (total_pages / 2)) {
      first_page++;
    } else {
      last_page--;
    }
  }

  // First result on the page. This, along with the field below, can be used to
  // do "showing x to y of z results" style things.
  var first_result = this.per_page * (current_page - 1);
  if (first_result < 0) { first_result = 0; }

  // Last result on the page.
  var last_result = (this.per_page * current_page) - 1;
  if (last_result < 0) { last_result = 0; }
  if (last_result > Math.max(total_results - 1, 0)) { last_result = Math.max(total_results - 1, 0); }

  // GIMME THAT OBJECT
  return {
    total_pages: total_pages,
    pages: Math.min(last_page - first_page + 1, total_pages),
    current_page: current_page,
    first_page: first_page,
    last_page: last_page,
    previous_page: current_page - 1,
    next_page: current_page + 1,
    has_previous_page: current_page > 1,
    has_next_page: current_page < total_pages,
    total_results: total_results,
    results: Math.min(last_result - first_result + 1, total_results),
    first_result: first_result,
    last_result: last_result,
  };
};


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(20));

var _classnames = _interopRequireDefault(__webpack_require__(196));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Page =
/*#__PURE__*/
function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    _classCallCheck(this, Page);

    return _possibleConstructorReturn(this, _getPrototypeOf(Page).apply(this, arguments));
  }

  _createClass(Page, [{
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props = this.props,
          isDisabled = _this$props.isDisabled,
          pageNumber = _this$props.pageNumber;
      e.preventDefault();

      if (isDisabled) {
        return;
      }

      this.props.onClick(pageNumber);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props2 = this.props,
          pageText = _this$props2.pageText,
          pageNumber = _this$props2.pageNumber,
          activeClass = _this$props2.activeClass,
          itemClass = _this$props2.itemClass,
          linkClass = _this$props2.linkClass,
          activeLinkClass = _this$props2.activeLinkClass,
          disabledClass = _this$props2.disabledClass,
          isActive = _this$props2.isActive,
          isDisabled = _this$props2.isDisabled,
          href = _this$props2.href,
          ariaLabel = _this$props2.ariaLabel;
      var css = (0, _classnames["default"])(itemClass, (_cx = {}, _defineProperty(_cx, activeClass, isActive), _defineProperty(_cx, disabledClass, isDisabled), _cx));
      var linkCss = (0, _classnames["default"])(linkClass, _defineProperty({}, activeLinkClass, isActive));
      return _react["default"].createElement("li", {
        className: css,
        onClick: this.handleClick.bind(this)
      }, _react["default"].createElement("a", {
        className: linkCss,
        href: href,
        "aria-label": ariaLabel
      }, pageText));
    }
  }]);

  return Page;
}(_react.Component);

exports["default"] = Page;

_defineProperty(Page, "propTypes", {
  pageText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  pageNumber: _propTypes["default"].number.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  isDisabled: _propTypes["default"].bool,
  activeClass: _propTypes["default"].string,
  activeLinkClass: _propTypes["default"].string,
  itemClass: _propTypes["default"].string,
  linkClass: _propTypes["default"].string,
  disabledClass: _propTypes["default"].string,
  href: _propTypes["default"].string
});

_defineProperty(Page, "defaultProps", {
  activeClass: "active",
  disabledClass: "disabled",
  itemClass: undefined,
  linkClass: undefined,
  activeLinkCLass: undefined,
  isActive: false,
  isDisabled: false,
  href: "#"
});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Attraction_FormChangeImage__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Attraction_FormChangeBanner__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionDetail=function(_React$Component){_inherits(AttractionDetail,_React$Component);function AttractionDetail(props){_classCallCheck(this,AttractionDetail);var _this=_possibleConstructorReturn(this,(AttractionDetail.__proto__||Object.getPrototypeOf(AttractionDetail)).call(this,props));_this.componentWillReceiveProps=function(nextProps){_this.setState({form:Object.assign({},_this.state.form,{language_code:__WEBPACK_IMPORTED_MODULE_4_lodash_toLower___default()(nextProps.setting.language_code),currency_code:nextProps.setting.currency_code,highlights:nextProps.attraction.detail.highlights,additional_info:nextProps.attraction.detail.additional_info,description:nextProps.attraction.detail.description})});};_this.componentDidMount=function(){var filter={language_code:_this.props.setting.language_code,currency_code:_this.props.setting.currency_code};var data={id:_this.props.detailId,filter:filter};_this.props.getAttractionDetail(data);_this.props.reset();};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var item=arguments[1];var dimension=arguments[2];_this.setState({showModal:modalId,selected:Object.assign({},_this.state.selected,{item:item,dimension:dimension})});if(!modalId){_this.props.clearCache();_this.props.getAttractionDetail({id:_this.props.detailId});}};_this._toggleTab=function(){var tabName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({tab:tabName});};_this._toggleEdit=function(){_this.setState({edit:!_this.state.edit});};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState['form'][field]=val;_this.setState({newState:newState});};_this._fileSelect=function(event,item,dimension){var reader=new FileReader();var file=event.target.files[0];var newImage=Object.assign({},_this.state.files);reader.onloadend=function(){newImage[item.uuid+dimension]=reader.result;_this.setState({files:newImage});};reader.readAsDataURL(file);};_this._submit=function(){var form=_this.state.form;var data={id:_this.props.attraction.detail.id,form:form};_this.props.updateAttractionDetail(data);_this.props.closeModal();};_this._toggleChangeBanner=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var bannerType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'wide';_this.setState({showModal:modalId,selected:Object.assign({},_this.state.selected,{banner:bannerType})});};_this.state={tab:null,edit:false,form:{language_code:__WEBPACK_IMPORTED_MODULE_4_lodash_toLower___default()(props.setting.language_code),currency_code:'',highlights:'',additional_info:'',description:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(AttractionDetail,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,detail=_props$attraction.detail,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;// const { files } = this.state
var ImageTab=function ImageTab(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.local_photos&&detail.local_photos.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'mb-3',style:{borderBottom:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Caption'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Dimension'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Image'),_this2.state.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit Image'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Object.keys(item.paths).map(function(dimension,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},key===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:Object.keys(item.paths).length},item.caption||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dimension),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.paths[dimension],alt:'',height:'175px',className:'img img-responsive'})),_this2.state.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('change-image',item,dimension);}},'Change Image')));})))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{open:_this2.state.showModal==='change-image',onClose:_this2._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Attraction_FormChangeImage__["a" /* default */],{attractionId:_this2.props.detailId,item:_this2.state.selected.item,dimension:_this2.state.selected.dimension,closeModal:function closeModal(){return _this2._toggleModal();}})));};var BannerTab=function BannerTab(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-6 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Web'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.banner_url&&detail.banner_url.wide?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:detail.banner_url.wide,alt:'',className:'img img-responsive mb-2',style:{width:'100%'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'- NO IMAGE -')),_this2.state.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleChangeBanner('change-banner','wide');}},'Change Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-6 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Mobile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.banner_url&&detail.banner_url.wide_mobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:detail.banner_url.wide_mobile,alt:'',className:'img img-responsive mb-2',style:{width:'100%'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'- NO IMAGE -')),_this2.state.edit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleChangeBanner('change-banner','wide_mobile');}},'Change Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{open:_this2.state.showModal==='change-banner',onClose:_this2._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Attraction_FormChangeBanner__["a" /* default */],{attractionId:_this2.props.detailId,banners:detail.banner_file,bannerType:_this2.state.selected.banner,closeModal:function closeModal(){return _this2._toggleModal();}})));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Attraction Detail',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),detail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title'},detail.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Images')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageTab,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BannerTab,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.description||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Base Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.provider==='BMG'?__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(detail.normal_price,{symbol:this.props.setting.currency_code,format:'%s %v'}):__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(detail.final_price,{symbol:this.props.setting.currency_code,format:'%s %v'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'City')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.city&&detail.city.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Geolocation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},'Lat: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.latitude),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Lon: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.longitude))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Business Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.business_hours_from,' - ',detail.business_hours_to)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Highlights')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.highlights)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Additional Info')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.additional_info)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Packages')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10 table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Prices'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Description'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,detail.attraction_packages&&detail.attraction_packages.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title),item.provider==='BMG'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'30%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},Object.keys(item.prices).map(function(key,index){if(__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(key,'normal')||!item.prices[key]){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},'(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,key),') ',__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(item.prices[key],{symbol:_this2.props.setting.currency_code,format:'%s %v'}));}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'30%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'list-unstyled'},item.prices.map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},'(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,key.name),') ',__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(key.price,{symbol:_this2.props.setting.currency_code,format:'%s %v'}));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{width:'40%'},item.description));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Instant Confirmation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'badge badge-pill badge-'+(detail.is_instant?'success':'danger')},detail.is_instant?'Yes':'No'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.meta_title||'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.meta_description||''))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close')));}}]);return AttractionDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{getAttractionDetail:function getAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_AttractionRedux__["b" /* default */].attractionDetailRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));},clearCache:function clearCache(){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_AttractionRedux__["b" /* default */].attractionClearCacheRequest());},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},reset:function reset(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__["b" /* default */].filesUploadReset());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionDetail));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactJson from 'react-json-view'
var PlaceDetail=function(_React$Component){_inherits(PlaceDetail,_React$Component);function PlaceDetail(props){_classCallCheck(this,PlaceDetail);var _this=_possibleConstructorReturn(this,(PlaceDetail.__proto__||Object.getPrototypeOf(PlaceDetail)).call(this,props));_this.componentWillReceiveProps=function(nextProps){_this.setState({form:Object.assign({},_this.state.form,{description:nextProps.attraction.detail.description})});};_this.componentDidMount=function(){var _this$props=_this.props,getPlaceDetail=_this$props.getPlaceDetail,detailId=_this$props.detailId,reset=_this$props.reset;var data={id:detailId};getPlaceDetail(data);reset();};_this.state={tab:null,edit:false,form:{language_code:__WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default()(props.setting.language_code),highlights:'',additional_info:'',description:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(PlaceDetail,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,detail=_props$attraction.detail,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;// const { files } = this.state
var ImageTab=function ImageTab(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb-3',style:{borderBottom:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Caption'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Dimension'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Image'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,detail.local_photo&&Object.keys(detail.local_photo.paths).map(function(dimension,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},key===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:Object.keys(detail.local_photo.paths).length},detail.local_photo.caption||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dimension),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:detail.local_photo.paths[dimension],alt:'',height:'175px',className:'img img-responsive'})));}))))));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Landmark Detail',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),detail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mb-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title'},detail.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Images')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageTab,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.address||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Admission')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.admission||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.email||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Phone')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.phone||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.description||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Geolocation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},'Lat: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.latitude),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Lon: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,detail.longitude))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Opening Hours')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.opening_hours||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xs-12 col-sm-10'},detail.duration||'-'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close')));}}]);return PlaceDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{getPlaceDetail:function getPlaceDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeDetailRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));},clearCache:function clearCache(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionClearCacheRequest());},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},reset:function reset(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadReset());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(PlaceDetail));

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionResetUpdate=function(_React$Component){_inherits(AttractionResetUpdate,_React$Component);function AttractionResetUpdate(props){_classCallCheck(this,AttractionResetUpdate);var _this=_possibleConstructorReturn(this,(AttractionResetUpdate.__proto__||Object.getPrototypeOf(AttractionResetUpdate)).call(this,props));_this.componentWillReceiveProps=function(nextProps){_this.setState({form:Object.assign({},_this.state.form,{highlights:nextProps.attraction.detail.highlights,additional_info:nextProps.attraction.detail.additional_info,description:nextProps.attraction.detail.description})});};_this.componentDidMount=function(){var filter={language_code:_this.props.setting.language_code,currency_code:_this.props.setting.currency_code};var data={id:_this.props.detailId,filter:filter};_this.props.getAttractionDetail(data);};_this._submit=function(){var form={is_ignored_on_update:false};var data={id:_this.props.attraction.detail.id,form:form};_this.props.updateAttractionDetail(data);_this.props.closeModal();};_this.state={tab:null,form:{language_code:__WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default()(props.setting.language_code),highlights:'',additional_info:'',description:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(AttractionResetUpdate,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Reset Attraction ?',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'*The reset will take time, need to wait the CRON to process')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary ml-2',onClick:function onClick(){return _this2._submit();}},'Reset')));}}]);return AttractionResetUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{getAttractionDetail:function getAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionResetUpdate));

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionUpdate=function(_React$Component){_inherits(AttractionUpdate,_React$Component);function AttractionUpdate(props){_classCallCheck(this,AttractionUpdate);var _this=_possibleConstructorReturn(this,(AttractionUpdate.__proto__||Object.getPrototypeOf(AttractionUpdate)).call(this,props));_this.componentWillReceiveProps=function(nextProps){_this.setState({form:Object.assign({},_this.state.form,{highlights:nextProps.attraction.detail.highlights,additional_info:nextProps.attraction.detail.additional_info,description:nextProps.attraction.detail.description,meta_description:nextProps.attraction.detail.meta_description||'',meta_title:nextProps.attraction.detail.meta_title||''})});};_this.componentDidMount=function(){var filter={language_code:_this.props.setting.language_code,currency_code:_this.props.setting.currency_code};var data={id:_this.props.detailId,filter:filter};_this.props.getAttractionDetail(data);};_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(){var form=_this.state.form;var data={id:_this.props.attraction.detail.id,form:form};_this.props.updateAttractionDetail(data);_this.props.closeModal();};_this.state={tab:null,form:{language_code:__WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default()(props.setting.language_code),highlights:'',additional_info:'',description:'',meta_description:'',meta_title:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(AttractionUpdate,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Attraction Detail',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'highlights',className:'control-label'},'Highlights'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'highlights',rows:'5',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'highlights');},value:this.state.form.highlights})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'additional_info',className:'control-label'},'Additional Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'additional_info',rows:'10',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'additional_info');},value:this.state.form.additional_info})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'description',className:'control-label'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'description',rows:'15',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'description');},value:this.state.form.description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'meta_description',className:'control-label'},'Meta-description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'meta_description',rows:'3',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'meta_description');},value:this.state.form.meta_description})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'meta_title',className:'control-label'},'Meta-title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{name:'meta_title',rows:'3',className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'meta_title');},value:this.state.form.meta_title}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary ml-2',onClick:function onClick(){return _this2._submit();}},'Save')));}}]);return AttractionUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{getAttractionDetail:function getAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionUpdate));

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Attraction_FormChangeBanner__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionUpdate=function(_React$Component){_inherits(AttractionUpdate,_React$Component);function AttractionUpdate(props){_classCallCheck(this,AttractionUpdate);var _this=_possibleConstructorReturn(this,(AttractionUpdate.__proto__||Object.getPrototypeOf(AttractionUpdate)).call(this,props));_this.componentWillReceiveProps=function(nextProps){_this.setState({form:Object.assign({},_this.state.form,{highlights:nextProps.attraction.detail.highlights,additional_info:nextProps.attraction.detail.additional_info,description:nextProps.attraction.detail.description})});};_this.componentDidMount=function(){var filter={language_code:_this.props.setting.language_code,currency_code:_this.props.setting.currency_code};var data={id:_this.props.detailId,filter:filter};_this.props.getAttractionDetail(data);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var item=arguments[1];var dimension=arguments[2];_this.setState({showModal:modalId,selected:Object.assign({},_this.state.selected,{item:item,dimension:dimension})});_this.props.closeModal();};_this._toggleTab=function(){var tabName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({tab:tabName});};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState['form'][field]=val;_this.setState({newState:newState});};_this._fileSelect=function(event,item,dimension){var reader=new FileReader();var file=event.target.files[0];var newImage=Object.assign({},_this.state.files);reader.onloadend=function(){newImage[item.uuid+dimension]=reader.result;_this.setState({files:newImage});};reader.readAsDataURL(file);};_this._submit=function(){var form=_this.state.form;var data={id:_this.props.attraction.detail.id,form:form};_this.props.updateAttractionDetail(data);_this.props.closeModal();};_this._toggleChangeBanner=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var bannerType=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'wide';_this.setState({showModal:modalId,selected:Object.assign({},_this.state.selected,{banner:bannerType})});};_this.state={tab:null,form:{language_code:__WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default()(props.setting.language_code),highlights:'',additional_info:'',description:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(AttractionUpdate,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,detail=_props$attraction.detail,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;// const { files } = this.state
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Attraction Banner',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-6 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Web (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1049x433'),')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.banner_url&&detail.banner_url.wide?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:detail.banner_url.wide,alt:'',className:'img img-responsive mb-2',style:{width:'100%'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'- NO IMAGE -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleChangeBanner('change-banner','wide');}},'Change Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group col-6 text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'375x269'),')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.banner_url&&detail.banner_url.wide_mobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:detail.banner_url.wide_mobile,alt:'',className:'img img-responsive mb-2',style:{width:'100%'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'- NO IMAGE -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'* Image for mobile banner will take from web banner image')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleChangeBanner('change-banner','wide_mobile');}},'Change Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='change-banner',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Attraction_FormChangeBanner__["a" /* default */],{attractionId:this.props.detailId,banners:detail.banner_file,bannerType:this.state.selected.banner,closeModal:function closeModal(){return _this2._toggleModal();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close')));}}]);return AttractionUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{getAttractionDetail:function getAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].attractionDetailRequest(data));},updateAttractionDetail:function updateAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].attractionUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionUpdate));

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Attraction_FormChangeImage__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_AttractionRedux__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormUpdateImage=function(_React$Component){_inherits(FormUpdateImage,_React$Component);function FormUpdateImage(props){_classCallCheck(this,FormUpdateImage);var _this=_possibleConstructorReturn(this,(FormUpdateImage.__proto__||Object.getPrototypeOf(FormUpdateImage)).call(this,props));_this.componentDidMount=function(){var filter={language_code:_this.props.setting.language_code,currency_code:_this.props.setting.currency_code};var data={id:_this.props.detailId,filter:filter};_this.props.getAttractionDetail(data);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var item=arguments[1];var dimension=arguments[2];_this.setState({showModal:modalId,selected:Object.assign({},_this.state.selected,{item:item,dimension:dimension})});};_this._toggleTab=function(){var tabName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({tab:tabName});};_this.state={tab:null,form:{language_code:__WEBPACK_IMPORTED_MODULE_2_lodash_toLower___default()(props.setting.language_code),highlights:'',additional_info:'',description:''},files:{},showModal:null,selected:{item:{},dimension:null,banner:null}};return _this;}_createClass(FormUpdateImage,[{key:'render',value:function render(){var _this2=this;var _props$attraction=this.props.attraction,detail=_props$attraction.detail,fetching=_props$attraction.fetching,err=_props$attraction.err,processing=_props$attraction.processing;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Attraction Update',(fetching||processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},fetching?'Loading':'Processing',' ...'))),err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,detail.local_photos&&detail.local_photos.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'mb-3',style:{borderBottom:'1px solid #ddd'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Caption'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Dimension'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit Image'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,Object.keys(item.paths).map(function(dimension,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:key},key===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{rowSpan:Object.keys(item.paths).length},item.caption||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dimension),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.paths[dimension]+'&v='+__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.updated_at).unix(),alt:'',height:'175px',className:'img img-responsive'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('change-image',item.paths[dimension],dimension);}},'Change Image')));})))));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='change-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Attraction_FormChangeImage__["a" /* default */],{attractionId:this.props.detailId,item:this.state.selected.item,dimension:this.state.selected.dimension,closeModal:function closeModal(){return _this2._toggleModal();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary ml-2',onClick:function onClick(){return _this2._submit();}},'Save')));}}]);return FormUpdateImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{getAttractionDetail:function getAttractionDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_AttractionRedux__["b" /* default */].attractionDetailRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormUpdateImage));

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadAttractionData=function(_React$Component){_inherits(DownloadAttractionData,_React$Component);function DownloadAttractionData(props){_classCallCheck(this,DownloadAttractionData);var _this=_possibleConstructorReturn(this,(DownloadAttractionData.__proto__||Object.getPrototypeOf(DownloadAttractionData)).call(this,props));_this._inputChange=function(event,field){var filter=Object.assign({},_this.state.filter);if(field==='destinationId'){filter.destinationId=event.value;_this.setState({selected:event,filter:filter});}else{var value=event.target.value;filter[field]=value;_this.setState({filter:filter});}};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.filter);_this.props.download(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={selected:'',filter:{destinationId:''}};return _this;}_createClass(DownloadAttractionData,[{key:'render',value:function render(){var _this2=this;var destination=this.props.destination;// populate destination selector
var destinationPicker=[];destination.data&&destination.data.length&&destination.data.map(function(item,i){destinationPicker[i]={value:item.id,label:item.name};return destinationPicker;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download Attraction Data',(destination.fetching||destination.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},destination.fetching?'Loading':'Processing','...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Pick a Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:destinationPicker,name:'attraction-picker',placeholder:'All Destination',value:this.state.selected,onChange:function onChange(selected){return _this2._inputChange(selected,'destinationId');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),'Download')))));}}]);return DownloadAttractionData;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{destination:state.destination};};var dispatchToProps=function dispatchToProps(dispatch){return{download:function download(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionRedux__["b" /* default */].downloadAttractionDataRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadAttractionData));

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_PopularAttractionRedux__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_PopularAttraction_FormCreate__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_PopularAttraction_FormEdit__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Popular=function(_React$Component){_inherits(Popular,_React$Component);function Popular(props){_classCallCheck(this,Popular);var _this=_possibleConstructorReturn(this,(Popular.__proto__||Object.getPrototypeOf(Popular)).call(this,props));_this.componentDidMount=function(){_this._getList();};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState[field]=val;_this.setState(newState);if(field==='modifier_value'){setTimeout(function(){_this._getList();},250);}};_this._getList=function(){var _this$state=_this.state,modifier=_this$state.modifier,modifier_value=_this$state.modifier_value;var data={modifier:modifier,modifier_value:modifier_value};_this.props.getPopularAttraction(data);};_this._reverseOrder=function(){_this.setState({reverse:!_this.state.reverse});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tbody').each(function(elem,index){var arr=__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.makeArray(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tr',this).detach());arr.reverse();__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).append(arr);});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var detail=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this.setState({showModal:modalId,detail:detail});if(!modalId){setTimeout(function(){_this._getList();},250);}};_this._delete=function(){var id=_this.state.detail.popularity_id;_this.props.deletePopularAttraction(id);setTimeout(function(){_this._toggleModal();},250);};_this._filterChange=function(event,field){var newState=Object.assign({},_this.state.filter);var val=event.target.value;newState[field]=val;_this.setState({filter:newState});if(field==='title'){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_2_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('td[data-filter="title"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_2_jquery___default()('td[data-filter="title"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tr:hidden').show();}}};_this.options=[{value:'id',label:'Passpod ID',restriction:['PH']},{value:'sg',label:'Passpod SG',restriction:['PH']},{value:'ph',label:'Passpod PH'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_8__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={modifier:'origin',modifier_value:Object(__WEBPACK_IMPORTED_MODULE_8__Utils_PrivilegeUtils__["a" /* currentBranch */])(),reverse:false,showModal:null,detail:{},filter:{title:''}};return _this;}_createClass(Popular,[{key:'render',value:function render(){var _this2=this;var popularAttraction=this.props.popularAttraction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Popular Attraction',(popularAttraction.fetching||popularAttraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},popularAttraction.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add New')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Origin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'modifier_value',className:'form-control',value:this.state.modifier_value,onChange:function onChange(event){return _this2._inputChange(event,'modifier_value');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'- Select Origin -'),this.options.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search by title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'title',className:'form-control',onChange:function onChange(event){return _this2._filterChange(event,'title');}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(popularAttraction.fetching||popularAttraction.processing)&&popularAttraction.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},popularAttraction.err),this.state.modifier_value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{role:'button',onClick:function onClick(){return _this2._reverseOrder();}},'Priority ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-'+(this.state.reverse?'sort-numeric-down':'sort-numeric-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!popularAttraction.data||!popularAttraction.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},' - NO DATA - ')):popularAttraction.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'title'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.priority),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._toggleModal('edit',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._toggleModal('delete',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_PopularAttraction_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='edit',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_PopularAttraction_FormEdit__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Popular Attraction?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.detail.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete'))))));}}]);return Popular;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{popularAttraction:state.popularAttraction};};var dispatchToProps=function dispatchToProps(dispatch){return{getPopularAttraction:function getPopularAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionRequest(data));},deletePopularAttraction:function deletePopularAttraction(id){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionDeleteRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Popular));

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_PopularAttractionRedux__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this.componentDidMount=function(){var data={q:_this.state.search,page:_this.state.page};_this.props.search(data);};_this._toggleAttractionModal=function(){_this.setState({showModal:!_this.state.showModal});if(_this.state.showModal){_this.setState({page:1,search:''});var data={q:'',page:1};_this.props.search(data);}};_this._inputSearchChange=function(event){var val=event.target.value;_this.setState({search:val});};_this._search=function(event){event.preventDefault();var data={q:_this.state.search,page:_this.state.page};_this.props.search(data);};_this._changePage=function(page){_this.setState({page:page});var data={q:_this.state.search,page:page};_this.props.search(data);};_this._selectAttraction=function(data){_this.setState({selectedAttraction:data,form:Object.assign({},_this.state.form,{attraction_id:data.id})});_this._toggleAttractionModal();};_this._save=function(event){event.preventDefault();var data=_this.state.form;_this.props.save(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseInt(val,10)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}_this.setState({form:Object.assign({},_this.state.form,{priority:val})});};_this.origin=[{value:'ID',label:'INDONESIA',restriction:['PH']},{value:'SG',label:'SINGAPORE',restriction:['PH']},{value:'PH',label:'PHILIPPINES'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={showModal:false,selectedAttraction:{title:''},form:{attraction_id:'',modifier_type:'origin',modifier_value:Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])(),priority:1},page:1,search:''};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;var attraction=this.props.attraction;var _state$form=this.state.form,attraction_id=_state$form.attraction_id,modifier_value=_state$form.modifier_value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Popular Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{role:'button',type:'text',className:'form-control',readOnly:true,value:this.state.selectedAttraction.title||'Click to select',onClick:function onClick(){return _this2._toggleAttractionModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Origin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'modifier_value',required:true,className:'form-control',value:this.state.form.modifier_value,onChange:function onChange(event){return _this2.setState({form:Object.assign({},_this2.state.form,{modifier_value:event.target.value})});}},this.origin.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!attraction_id||!modifier_value,className:'btn btn-primary ml-2'},'Save'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal,closeOnOverlayClick:true,onClose:function onClose(){return _this2._toggleAttractionModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titile-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Select Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'row mb-2',onSubmit:function onSubmit(event){return _this2._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',name:'search',className:'form-control',placeholder:'Search Attraction',onChange:function onChange(event){return _this2._inputSearchChange(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!attraction.dataSearch.data||!attraction.dataSearch.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'- No Data -')):attraction.dataSearch.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i+1+(_this2.state.page-1)*10),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._selectAttraction(item);},className:'btn btn-info'},'Select')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},attraction.dataSearch.page&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.dataSearch.page||this.state.page,itemsCountPerPage:10,totalItemsCount:attraction.dataSearch.total,pageRangeDisplayed:5,onChange:this._changePage})))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{search:function search(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSearchRequest(data));},save:function save(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionSaveRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__ = __webpack_require__(136);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormEdit=function(_React$Component){_inherits(FormEdit,_React$Component);function FormEdit(props){_classCallCheck(this,FormEdit);var _this=_possibleConstructorReturn(this,(FormEdit.__proto__||Object.getPrototypeOf(FormEdit)).call(this,props));_this._save=function(event){event.preventDefault();var data={id:_this.props.detail.popularity_id,form:_this.state.form};_this.props.save(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseInt(val,10)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}_this.setState({form:Object.assign({},_this.state.form,{priority:val})});};_this.state={form:{attraction_id:props.detail.id,origin:props.detail.modifier_value,priority:props.detail.priority}};return _this;}_createClass(FormEdit,[{key:'render',value:function render(){var _this2=this;var _state$form=this.state.form,attraction_id=_state$form.attraction_id,origin=_state$form.origin,priority=_state$form.priority;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Popular Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',readOnly:true,value:this.props.detail.title||'-'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!attraction_id||!origin||!priority,className:'btn btn-primary ml-2'},'Save'))));}}]);return FormEdit;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{save:function save(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionEditRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormEdit));

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Attraction_AttractionCreateMapping__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionMapping=function(_React$Component){_inherits(AttractionMapping,_React$Component);function AttractionMapping(props){_classCallCheck(this,AttractionMapping);var _this=_possibleConstructorReturn(this,(AttractionMapping.__proto__||Object.getPrototypeOf(AttractionMapping)).call(this,props));_this.componentWillReceiveProps=function(newProps){var id=null;if(newProps.destination.data.length){id=newProps.destination.data[0].id;}if(newProps.destination.data.length&&!_this.state.destination){_this.setState({destination:id});_this._fetchAttraction({destination:id});}if(!_this.state.showModal&&!newProps.destination.err)_this.setState({attractions:newProps.attraction});};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState[field]=val;_this.setState(newState);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._changeTab=function(){var tab=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'attractions';_this.setState({tab:tab,page:1});_this._fetchAttraction({tab:tab,destination:_this.state.destination});};_this._fetchAttraction=function(_ref,event){var setting=_ref.setting,destination=_ref.destination,page=_ref.page,tab=_ref.tab;if(event)event.preventDefault();var data={destination:destination,filter:Object.assign({},setting,{page:page})};_this.props.getPlace(data);};_this._destinationSelect=function(event){var val=event.target.value;_this.setState({destination:val});_this._fetchAttraction({destination:val,tab:_this.state.tab});};_this._selectAttraction=function(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';_this._toggleModal(action);_this.setState({detail:item});};_this._delete=function(){var data={place_id:_this.state.detail.id,destination_id:_this.state.destination,type:_this.state.detail.place_type};_this.props.deletePlace(data);setTimeout(function(){_this._toggleModal();},250);};_this._changePage=function(page){_this.setState({page:page});var _this$state=_this.state,setting=_this$state.setting,destination=_this$state.destination;var data={destination:destination,filter:Object.assign({},setting,{page:page})};_this.props.getPlace(data);};_this._filterChange=function(event,field){var newState=Object.assign({},_this.state.setting);var val=event.target.value;newState[field]=val;_this.setState({setting:newState});var data={destination:_this.state.destination,filter:Object.assign({},newState,{page:1})};_this.props.getPlace(data);};_this.state={showModal:null,setting:Object.assign({q:''},props.setting,{type:'attraction',provider:'BMG'}),destination:'',detail:{},page:1,attractions:{},tab:'places'};return _this;}_createClass(AttractionMapping,[{key:'componentDidMount',value:function componentDidMount(){this.props.getDestination();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,destination=_props.destination,attraction=_props.attraction;var attractions=this.state.attractions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Attractions & Places Mapping',(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},attraction.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('mapping-place');}},'Create Mapping')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Destination')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.destination,onChange:function onChange(event){return _this2._destinationSelect(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'- Select Destination -'),destination.data&&destination.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.setting.provider,onChange:function onChange(event){return _this2._filterChange(event,'provider');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'BMG'},'BMG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'KLOOK'},'KLOOK')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(e){return _this2._fetchAttraction({destination:_this2.state.destination,setting:_this2.state.setting},e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search by title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',name:'title',className:'form-control',onChange:function onChange(event){return _this2._filterChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-1 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},attraction.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Attraction : '),' ',attraction.err),destination.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Destination : '),' ',destination.err),this.state.destination&&attractions.data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,attractions.data.data&&attractions.data.data.length?attractions.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'title'},_this2.state.tab==='places'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'[ ',item.place_type,' ]'),' ',item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectAttraction(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'- No Data -')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='mapping-place',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Attraction_AttractionCreateMapping__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},type:'place'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete ',this.state.tab,' from Destination?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},this.state.destination&&attractions.data&&attractions.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:attractions.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return AttractionMapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{destination:state.destination,attraction:state.attraction,preset:state.preset,setting:state.preset.setting};};var dispatchToProps=function dispatchToProps(dispatch){return{getDestination:function getDestination(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].destinationRequest());},getAttraction:function getAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].attractionRequest(data));},getPlace:function getPlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].placeRequest(data));},deleteAttraction:function deleteAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].deleteAttractionFromDestinationRequest(data));},deletePlace:function deletePlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].deletePlaceFromDestinationRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionMapping));

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this.componentDidMount=function(){var data={q:_this.state.searchByQuery,c:_this.state.searchByCity,page:_this.state.page};if(_this.props.type==='attraction'){_this.props.searchAttraction(data);}else{_this.props.searchPlace(data);}};_this._toggleAttractionModal=function(){_this.setState({showModal:!_this.state.showModal});if(_this.state.showModal){_this.setState({page:1,searchByQuery:'',searchByCity:'',searchByProvider:''});var data={q:'',c:'',provider:'',page:1};if(_this.props.type==='attraction'){_this.props.searchAttraction(data);}else{_this.props.searchPlace(data);}}};_this._inputChange=function(event,field){var val=event.target.value;field==='q'&&_this.setState({searchByQuery:val});field==='c'&&_this.setState({searchByCity:val});field==='provider'&&_this.setState({searchByProvider:val});};_this._search=function(event){event.preventDefault();var data={q:_this.state.searchByQuery,c:_this.state.searchByCity,provider:_this.state.searchByProvider,page:1};_this.props.type==='attraction'?_this.props.searchAttraction(data):_this.props.searchPlace(data);};_this._changePage=function(page){_this.setState({page:page});var data={q:_this.state.searchByQuery,c:_this.state.searchByCity,provider:_this.state.searchByProvider,page:page};if(_this.props.type==='attraction'){_this.props.searchAttraction(data);}else{_this.props.searchPlace(data);}};_this._selectAttraction=function(data){var attraction_id=[].concat(_toConsumableArray(_this.state.form.attraction_id));var places=[].concat(_toConsumableArray(_this.state.form.places));attraction_id.push(data.id);places.push({id:data.id,type:data.place_type});var attraction=[].concat(_toConsumableArray(_this.state.selectedItems));attraction.push(data);_this.setState({selectedItems:attraction,form:Object.assign({},_this.state.form,{attraction_id:attraction_id,places:places})});};_this._removeAttraction=function(id){var attraction_id=[];var places=[];var attraction=[];_this.state.selectedItems.forEach(function(data){if(data.id!==id){if(_this.props.type==='attraction'){attraction_id.push(data.id);}else{places.push({id:data.id,type:data.place_type});}attraction.push(data);}});_this.setState({selectedItems:attraction,form:Object.assign({},_this.state.form,{attraction_id:attraction_id,places:places})});};_this._save=function(event){event.preventDefault();var data=_this.state.form;if(_this.props.type==='attraction'){_this.props.saveAttraction(data);}else{_this.props.savePlace(data);}_this.props.closeModal();};_this.state={showModal:false,selectedItems:[],form:{attraction_id:[],places:[],destination_id:''},page:1,searchByQuery:'',searchByCity:'',searchByProvider:''};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,attraction=_props.attraction,destination=_props.destination,type=_props.type;var destination_id=this.state.form.destination_id;var selectedItems=this.state.selectedItems;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto',style:{textTransform:'capitalize'}},'Create ',type,' Destination Mapping',(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},attraction.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Origin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',name:'destination_id',required:true,value:this.state.form.destination_id,onChange:function onChange(event){return _this2.setState({form:Object.assign({},_this2.state.form,{destination_id:event.target.value})});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'- Select Destination -'),destination.data&&destination.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-between',style:{textTransform:'capitalize'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary',onClick:function onClick(){return _this2._toggleAttractionModal();}},'Select List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'hidden',name:'attraction_id',value:this.state.form.attraction_id[0]||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!this.state.selectedItems||!this.state.selectedItems.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- No Data -')):this.state.selectedItems.map(function(item,i){var city='-';if(item.place_type==='landmark'){if(item.city){city=item.city;}}else{if(item.city&&item.city.name){city=item.city.name;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,city),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._removeAttraction(item.id);},className:'btn btn-danger'},'Remove')));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!selectedItems.length||!destination_id,className:'btn btn-primary ml-2'},'Save'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal,closeOnOverlayClick:true,onClose:function onClose(){return _this2._toggleAttractionModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto',style:{textTransform:'capitalize'}},'Select ',type,(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},attraction.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'col-xs-12 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Selected'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!this.state.selectedItems||!this.state.selectedItems.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- No Data -')):this.state.selectedItems.map(function(item,i){var city='-';if(item.place_type==='landmark'){if(item.city){city=item.city;}}else{if(item.city&&item.city.name){city=item.city.name;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,city),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._removeAttraction(item.id);},className:'btn btn-danger'},'Remove')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary btn-lg',onClick:function onClick(){return _this2._toggleAttractionModal();}},'OK'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'col-xs-12 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{style:{textTransform:'capitalize'}},type,' List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'row mb-2',onSubmit:function onSubmit(event){return _this2._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',name:'search',className:'form-control',placeholder:'Search by Title',onChange:function onChange(event){return _this2._inputChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'row mb-2',onSubmit:function onSubmit(event){return _this2._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',name:'search',className:'form-control',placeholder:'Search by City',onChange:function onChange(event){return _this2._inputChange(event,'c');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'row mb-2',onSubmit:function onSubmit(event){return _this2._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'provider',className:'form-control',placeholder:'Search by Provider',onChange:function onChange(event){return _this2._inputChange(event,'provider');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'BMG'},'BMG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'KLOOK'},'KLOOK'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,// !attraction.data.data || !attraction.data.data.length
!attraction.dataSearch.data||!attraction.dataSearch.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- No Data -'))// : attraction.data.data.map((item, i) => {
:attraction.dataSearch.data.map(function(item,i){var city='-';if(item.place_type==='landmark'){if(item.city){city=item.city;}}else{if(item.city&&item.city.name){city=item.city.name;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,type==='place'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'[ ',item.place_type,' ]'),' ',item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,String(city)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,!__WEBPACK_IMPORTED_MODULE_4_lodash_includes___default()(_this2.state.form.attraction_id,item.id)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._selectAttraction(item);},className:'btn btn-info'},'Select')));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},// attraction.data.total &&
attraction.dataSearch.total&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link'// activePage={attraction.data.page || this.state.page}
,activePage:attraction.dataSearch.page||this.state.page,itemsCountPerPage:10// totalItemsCount={attraction.data.total}
,totalItemsCount:attraction.dataSearch.total,pageRangeDisplayed:5,onChange:this._changePage})))))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,destination:state.destination};};var dispatchToProps=function dispatchToProps(dispatch){return{searchAttraction:function searchAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].attractionSearchRequest(data));},saveAttraction:function saveAttraction(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].addAttractionToDestinationRequest(data));},searchPlace:function searchPlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_AttractionRedux__["b" /* default */].placeSearchRequest(data));},savePlace:function savePlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_DestinationRedux__["b" /* default */].addPlaceToDestinationRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Attraction_NewAttractionCreateMapping__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_js_pagination__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewAttractionMapping=function(_React$Component){_inherits(NewAttractionMapping,_React$Component);function NewAttractionMapping(props){_classCallCheck(this,NewAttractionMapping);var _this=_possibleConstructorReturn(this,(NewAttractionMapping.__proto__||Object.getPrototypeOf(NewAttractionMapping)).call(this,props));_initialiseProps.call(_this);_this.state={selectedDestinationID:null,filter:{page:1,provider:'',q:''},activeModal:null,destinationArray:[],detail:{}};_this.providerSelector=[{label:'ALL',value:''},{label:'BMG',value:'BMG'},{label:'KLOOK',value:'KLOOK'},{label:'LOKET',value:'LOKET'}];return _this;}_createClass(NewAttractionMapping,[{key:'componentDidMount',value:function componentDidMount(){this.props.getDestination();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(this.props.destination.data!==prevProps.destination.data){this._populateDestination(this.props.destination.data);}if(this.state.selectedDestinationID!==prevState.selectedDestinationID){this._fetchPlaceWithDestination(this.state.filter);}}},{key:'render',value:function render(){var _this2=this;var attraction=this.props.attraction;var data=attraction.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{attraction:attraction,title:'Attraction Mapping',_modal:function _modal(args){return _this2._triggerModal(args);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DestinationSelector,{destinationArray:this.state.destinationArray,_uponSelect:function _uponSelect(args){return _this2._uponSelect(args);}}),this.state.selectedDestinationID!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_AdvancedFilter__["a" /* default */],{filters:[{type:'text',name:'Search by Title',placeholder:'Insert title ...',field:'q'},{type:'selector',name:'Provider',field:'provider',selectors:this.providerSelector}],manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._callback(event);}}),this.state.selectedDestinationID!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__["a" /* default */],{colSpan:3,header:[{field:'Title'},{field:'Provider'},{field:'Delete'}],body:data.data&&data.data.length>0&&data.data.map(function(item){return[{field:item.title},{field:item.provider},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'deleteMapping');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})}),data.meta!==undefined&&this.state.selectedDestinationID!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:data.meta.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:data.meta.count,pageRangeDisplayed:5,onChange:this._handleChangePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.activeModal==='create-mapping',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Attraction_NewAttractionCreateMapping__["a" /* default */],{_close:function _close(){return _this2._triggerModal(null,true);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.activeModal==='deleteMapping',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DeleteMapping,{detail:this.state.detail,_delete:function _delete(args){return _this2._deletePlace(args);},_close:function _close(){return _this2._triggerModal(null);}})));}}]);return NewAttractionMapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this._fetchPlaceWithDestination=function(filter){var data=Object.assign({destination:_this3.state.selectedDestinationID},filter);_this3.props.getPlacesV2Request(data);};this._handleChangePage=function(page){var filter=_this3.state.filter;filter.page=page;_this3.setState({filter:filter});_this3._fetchPlaceWithDestination(filter);};this._populateDestination=function(data){var destinationArray=_this3.state.destinationArray;if(data){data.map(function(item,i){return destinationArray[i]={label:item.name,value:item.id};});}_this3.setState({destinationArray:destinationArray});};this._callback=function(event){event&&event.preventDefault();_this3._fetchPlaceWithDestination(_this3.state.filter);};this._manipulateState=function(props){_this3.setState({filter:props});};this._selectItem=function(detail,activeModal){_this3.setState({detail:detail});_this3._triggerModal(activeModal);};this._triggerModal=function(activeModal,actionType){_this3.setState({activeModal:activeModal});if(actionType){setTimeout(function(){_this3._fetchPlaceWithDestination(_this3.state.filter);},500);}};this._uponSelect=function(event){event&&event.preventDefault();var selectedDestinationID=event.target.value;_this3.setState({selectedDestinationID:selectedDestinationID});};this._deletePlace=function(args){var data={destination_id:_this3.state.selectedDestinationID,place_id:args.id,type:args.place_type};_this3.props.deletePlace(data);setTimeout(function(){_this3._triggerModal(null,true);},250);};};var Header=function Header(_ref){var attraction=_ref.attraction,title=_ref.title,_modal=_ref._modal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},title,(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-2',onClick:function onClick(){return _modal('create-mapping');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-map'}),' Create Mapping'))));};var DestinationSelector=function DestinationSelector(_ref2){var destinationArray=_ref2.destinationArray,_uponSelect=_ref2._uponSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Destination')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{defaultValue:'DEFAULT',className:'form-control',onChange:function onChange(event){return _uponSelect(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:'DEFAULT'},'- Please select a destination -'),destinationArray.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))));};var DeleteMapping=function DeleteMapping(_ref3){var detail=_ref3.detail,_close=_ref3._close,_delete=_ref3._delete;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete Mapping')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Remove ',detail.title,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'(',detail.provider,')'),' from Destination?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:_close},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _delete(detail);}},'Delete')));};var stateToProps=function stateToProps(state){return{destination:state.destination,attraction:state.attraction,preset:state.preset,setting:state.preset.setting};};var dispatchToProps=function dispatchToProps(dispatch){return{getDestination:function getDestination(){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_DestinationRedux__["b" /* default */].destinationRequest());},getPlacesV2Request:function getPlacesV2Request(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_AttractionRedux__["b" /* default */].getPlacesV2Request(data));},deletePlace:function deletePlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_DestinationRedux__["b" /* default */].deletePlaceFromDestinationRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(NewAttractionMapping));

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(165);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(137),
	DaysView = __webpack_require__(866),
	MonthsView = __webpack_require__(867),
	YearsView = __webpack_require__(868),
	TimeView = __webpack_require__(869)
	;

var CalendarContainer = createClass({
	viewComponents: {
		days: DaysView,
		months: MonthsView,
		years: YearsView,
		time: TimeView
	},

	render: function() {
		return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
	}
});

module.exports = CalendarContainer;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(137),
	moment = __webpack_require__(18)
	;

var DateTimePickerDays = createClass({
	render: function() {
		var footer = this.renderFooter(),
			date = this.props.viewDate,
			locale = date.localeData(),
			tableChildren
			;

		tableChildren = [
			React.createElement('thead', { key: 'th' }, [
				React.createElement('tr', { key: 'h' }, [
					React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
					React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
				]),
				React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
			]),
			React.createElement('tbody', { key: 'tb' }, this.renderDays())
		];

		if ( footer )
			tableChildren.push( footer );

		return React.createElement('div', { className: 'rdtDays' },
			React.createElement('table', {}, tableChildren )
		);
	},

	/**
	 * Get a list of the days of the week
	 * depending on the current locale
	 * @return {array} A list with the shortname of the days
	 */
	getDaysOfWeek: function( locale ) {
		var days = locale._weekdaysMin,
			first = locale.firstDayOfWeek(),
			dow = [],
			i = 0
			;

		days.forEach( function( day ) {
			dow[ (7 + ( i++ ) - first) % 7 ] = day;
		});

		return dow;
	},

	renderDays: function() {
		var date = this.props.viewDate,
			selected = this.props.selectedDate && this.props.selectedDate.clone(),
			prevMonth = date.clone().subtract( 1, 'months' ),
			currentYear = date.year(),
			currentMonth = date.month(),
			weeks = [],
			days = [],
			renderer = this.props.renderDay || this.renderDay,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, isDisabled, dayProps, currentDate
			;

		// Go to the last week of the previous month
		prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
		var lastDay = prevMonth.clone().add( 42, 'd' );

		while ( prevMonth.isBefore( lastDay ) ) {
			classes = 'rdtDay';
			currentDate = prevMonth.clone();

			if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
				classes += ' rdtOld';
			else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
				classes += ' rdtNew';

			if ( selected && prevMonth.isSame( selected, 'day' ) )
				classes += ' rdtActive';

			if ( prevMonth.isSame( moment(), 'day' ) )
				classes += ' rdtToday';

			isDisabled = !isValid( currentDate, selected );
			if ( isDisabled )
				classes += ' rdtDisabled';

			dayProps = {
				key: prevMonth.format( 'M_D' ),
				'data-value': prevMonth.date(),
				className: classes
			};

			if ( !isDisabled )
				dayProps.onClick = this.updateSelectedDate;

			days.push( renderer( dayProps, currentDate, selected ) );

			if ( days.length === 7 ) {
				weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
				days = [];
			}

			prevMonth.add( 1, 'd' );
		}

		return weeks;
	},

	updateSelectedDate: function( event ) {
		this.props.updateSelectedDate( event, true );
	},

	renderDay: function( props, currentDate ) {
		return React.createElement('td',  props, currentDate.date() );
	},

	renderFooter: function() {
		if ( !this.props.timeFormat )
			return '';

		var date = this.props.selectedDate || this.props.viewDate;

		return React.createElement('tfoot', { key: 'tf'},
			React.createElement('tr', {},
				React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
			)
		);
	},

	alwaysValidDate: function() {
		return 1;
	}
});

module.exports = DateTimePickerDays;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(137)
;

var DateTimePickerMonths = createClass({
	render: function() {
		return React.createElement('div', { className: 'rdtMonths' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
		]);
	},

	renderMonths: function() {
		var date = this.props.selectedDate,
			month = this.props.viewDate.month(),
			year = this.props.viewDate.year(),
			rows = [],
			i = 0,
			months = [],
			renderer = this.props.renderMonth || this.renderMonth,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
			// Date is irrelevant because we're only interested in month
			irrelevantDate = 1
			;

		while (i < 12) {
			classes = 'rdtMonth';
			currentMonth =
				this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });

			noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
			daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInMonth.find(function( d ) {
				var day = currentMonth.clone().set( 'date', d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( date && i === date.month() && year === date.year() )
				classes += ' rdtActive';

			props = {
				key: i,
				'data-value': i,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'months' ?
					this.updateSelectedMonth : this.props.setDate( 'month' ) );

			months.push( renderer( props, i, year, date && date.clone() ) );

			if ( months.length === 4 ) {
				rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
				months = [];
			}

			i++;
		}

		return rows;
	},

	updateSelectedMonth: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderMonth: function( props, month ) {
		var localMoment = this.props.viewDate;
		var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
		var strLength = 3;
		// Because some months are up to 5 characters long, we want to
		// use a fixed string length for consistency
		var monthStrFixedLength = monthStr.substring( 0, strLength );
		return React.createElement('td', props, capitalize( monthStrFixedLength ) );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

function capitalize( str ) {
	return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
}

module.exports = DateTimePickerMonths;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(137)
;

var DateTimePickerYears = createClass({
	render: function() {
		var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;

		return React.createElement('div', { className: 'rdtYears' }, [
			React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
				React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
				React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
				React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
			]))),
			React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
		]);
	},

	renderYears: function( year ) {
		var years = [],
			i = -1,
			rows = [],
			renderer = this.props.renderYear || this.renderYear,
			selectedDate = this.props.selectedDate,
			isValid = this.props.isValidDate || this.alwaysValidDate,
			classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
			// Month and date are irrelevant here because
			// we're only interested in the year
			irrelevantMonth = 0,
			irrelevantDate = 1
			;

		year--;
		while (i < 11) {
			classes = 'rdtYear';
			currentYear = this.props.viewDate.clone().set(
				{ year: year, month: irrelevantMonth, date: irrelevantDate } );

			// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
			// if ( i === -1 | i === 10 )
				// classes += ' rdtOld';

			noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
			daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
				return i + 1;
			});

			validDay = daysInYear.find(function( d ) {
				var day = currentYear.clone().dayOfYear( d );
				return isValid( day );
			});

			isDisabled = ( validDay === undefined );

			if ( isDisabled )
				classes += ' rdtDisabled';

			if ( selectedDate && selectedDate.year() === year )
				classes += ' rdtActive';

			props = {
				key: year,
				'data-value': year,
				className: classes
			};

			if ( !isDisabled )
				props.onClick = ( this.props.updateOn === 'years' ?
					this.updateSelectedYear : this.props.setDate('year') );

			years.push( renderer( props, year, selectedDate && selectedDate.clone() ));

			if ( years.length === 4 ) {
				rows.push( React.createElement('tr', { key: i }, years ) );
				years = [];
			}

			year++;
			i++;
		}

		return rows;
	},

	updateSelectedYear: function( event ) {
		this.props.updateSelectedDate( event );
	},

	renderYear: function( props, year ) {
		return React.createElement('td',  props, year );
	},

	alwaysValidDate: function() {
		return 1;
	},
});

module.exports = DateTimePickerYears;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(0),
	createClass = __webpack_require__(137),
	assign = __webpack_require__(407)
	;

var DateTimePickerTime = createClass({
	getInitialState: function() {
		return this.calculateState( this.props );
	},

	calculateState: function( props ) {
		var date = props.selectedDate || props.viewDate,
			format = props.timeFormat,
			counters = []
			;

		if ( format.toLowerCase().indexOf('h') !== -1 ) {
			counters.push('hours');
			if ( format.indexOf('m') !== -1 ) {
				counters.push('minutes');
				if ( format.indexOf('s') !== -1 ) {
					counters.push('seconds');
				}
			}
		}

		var hours = date.format( 'H' );

		var daypart = false;
		if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
			if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
				daypart = ( hours >= 12 ) ? 'PM' : 'AM';
			} else {
				daypart = ( hours >= 12 ) ? 'pm' : 'am';
			}
		}

		return {
			hours: hours,
			minutes: date.format( 'mm' ),
			seconds: date.format( 'ss' ),
			milliseconds: date.format( 'SSS' ),
			daypart: daypart,
			counters: counters
		};
	},

	renderCounter: function( type ) {
		if ( type !== 'daypart' ) {
			var value = this.state[ type ];
			if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				value = ( value - 1 ) % 12 + 1;

				if ( value === 0 ) {
					value = 12;
				}
			}
			return React.createElement('div', { key: type, className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		}
		return '';
	},

	renderDayPart: function() {
		return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
			React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
			React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
			React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
		]);
	},

	render: function() {
		var me = this,
			counters = []
		;

		this.state.counters.forEach( function( c ) {
			if ( counters.length )
				counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
			counters.push( me.renderCounter( c ) );
		});

		if ( this.state.daypart !== false ) {
			counters.push( me.renderDayPart() );
		}

		if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
			counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
			counters.push(
				React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
					React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
					)
				);
		}

		return React.createElement('div', { className: 'rdtTime' },
			React.createElement('table', {}, [
				this.renderHeader(),
				React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
					React.createElement('div', { className: 'rdtCounters' }, counters )
				)))
			])
		);
	},

	componentWillMount: function() {
		var me = this;
		me.timeConstraints = {
			hours: {
				min: 0,
				max: 23,
				step: 1
			},
			minutes: {
				min: 0,
				max: 59,
				step: 1
			},
			seconds: {
				min: 0,
				max: 59,
				step: 1
			},
			milliseconds: {
				min: 0,
				max: 999,
				step: 1
			}
		};
		['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
			assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
		});
		this.setState( this.calculateState( this.props ) );
	},

	componentWillReceiveProps: function( nextProps ) {
		this.setState( this.calculateState( nextProps ) );
	},

	updateMilli: function( e ) {
		var milli = parseInt( e.target.value, 10 );
		if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
			this.props.setTime( 'milliseconds', milli );
			this.setState( { milliseconds: milli } );
		}
	},

	renderHeader: function() {
		if ( !this.props.dateFormat )
			return null;

		var date = this.props.selectedDate || this.props.viewDate;
		return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
			React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
		));
	},

	onStartClicking: function( action, type ) {
		var me = this;

		return function() {
			var update = {};
			update[ type ] = me[ action ]( type );
			me.setState( update );

			me.timer = setTimeout( function() {
				me.increaseTimer = setInterval( function() {
					update[ type ] = me[ action ]( type );
					me.setState( update );
				}, 70);
			}, 500);

			me.mouseUpListener = function() {
				clearTimeout( me.timer );
				clearInterval( me.increaseTimer );
				me.props.setTime( type, me.state[ type ] );
				document.body.removeEventListener( 'mouseup', me.mouseUpListener );
				document.body.removeEventListener( 'touchend', me.mouseUpListener );
			};

			document.body.addEventListener( 'mouseup', me.mouseUpListener );
			document.body.addEventListener( 'touchend', me.mouseUpListener );
		};
	},

	disableContextMenu: function( event ) {
		event.preventDefault();
		return false;
	},

	padValues: {
		hours: 1,
		minutes: 2,
		seconds: 2,
		milliseconds: 3
	},

	toggleDayPart: function( type ) { // type is always 'hours'
		var value = parseInt( this.state[ type ], 10) + 12;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	increase: function( type ) {
		var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
		if ( value > this.timeConstraints[ type ].max )
			value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
		return this.pad( type, value );
	},

	decrease: function( type ) {
		var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
		if ( value < this.timeConstraints[ type ].min )
			value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
		return this.pad( type, value );
	},

	pad: function( type, value ) {
		var str = value + '';
		while ( str.length < this.padValues[ type ] )
			str = '0' + str;
		return str;
	},
});

module.exports = DateTimePickerTime;


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_DestinationRedux__ = __webpack_require__(41);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewAttractionCreateMapping=function(_React$Component){_inherits(NewAttractionCreateMapping,_React$Component);function NewAttractionCreateMapping(props){_classCallCheck(this,NewAttractionCreateMapping);var _this=_possibleConstructorReturn(this,(NewAttractionCreateMapping.__proto__||Object.getPrototypeOf(NewAttractionCreateMapping)).call(this,props));_this._manipulateSearchData=function(event,field){event&&event.preventDefault();};_this._setAttraction=function(item,context){var set=new Set(_this.state.selectedArray);switch(context){case'select':set.add(item);break;case'deselect':set.delete(item);break;default:return null;}var selectedArray=[].concat(_toConsumableArray(set));_this.setState({selectedArray:selectedArray});};_this._contextButton=function(item,context){switch(context){case'select':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this._setAttraction(item,'select');}},'Select');case'deselect':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._setAttraction(item,'deselect');}},'Remove');default:return null;}};_this._handleChangePage=function(page){var searchData=_this.state.searchData;searchData.page=page;_this.setState({searchData:searchData});_this.props.searchPlace(searchData);};_this._handleSearchSubmit=function(e){e.preventDefault();var data=Object.assign({},_this.state.searchData);data.page=1;_this.props.searchPlace(data);};_this._handleChange=function(e,field){var value=e.target.value;var searchData=Object.assign({},_this.state.searchData);searchData[field]=value;_this.setState({searchData:searchData});};_this._applyTo=function(e){var targetDestination=e.target.value;_this.setState({targetDestination:targetDestination});};_this._handleSubmit=function(e){e.preventDefault();var selectedArray=_this.state.selectedArray;var places=[];selectedArray.map(function(item,i){return places[i]={type:item.place_type,id:item.id};});var data={destination_id:_this.state.targetDestination,places:places};_this.props.savePlace(data);_this.props._close();};_this.state={searchData:{limit:10,q:'',c:'',provider:'',page:1},targetDestination:'',selectedArray:[]};_this.providerSelector=[{label:'ALL',value:''},{label:'BMG',value:'BMG'},{label:'KLOOK',value:'KLOOK'},{label:'LOKET',value:'LOKET'}];return _this;}_createClass(NewAttractionCreateMapping,[{key:'render',value:function render(){var _this2=this;var _props=this.props,attraction=_props.attraction,destination=_props.destination;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'90vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Create Mapping',(attraction.fetching||attraction.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'col-xs-12 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-left'},'Search Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(x){return _this2._handleSearchSubmit(x);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Search by Title',className:'form-control',type:'text',onChange:function onChange(e){return _this2._handleChange(e,'q');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'City')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Search by City',className:'form-control',type:'text',onChange:function onChange(e){return _this2._handleChange(e,'c');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:function onChange(e){return _this2._handleChange(e,'provider');}},this.providerSelector.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:option.value},option.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'}),' Search'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_AdvancedTable__["a" /* default */],{colSpan:4,header:[{field:'Title'},{field:'City'},{field:'Provider'},{field:'Action'}],body:attraction.dataSearch.data&&attraction.dataSearch.data.length>0&&attraction.dataSearch.data.map(function(item){return[{field:item.title},{field:item.city.name},{field:item.provider},{field:_this2._contextButton(item,'select')}];})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.dataSearch.page,itemsCountPerPage:10,totalItemsCount:attraction.dataSearch.total,pageRangeDisplayed:5,onChange:this._handleChangePage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'col-xs-12 col-sm-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-left'},'Selected Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'selected-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_AdvancedTable__["a" /* default */],{colSpan:4,header:[{field:'Title'},{field:'City'},{field:'Provider'},{field:'Action'}],body:this.state.selectedArray.map(function(item){return[{field:item.title},{field:item.city.name},{field:item.provider},{field:_this2._contextButton(item,'deselect')}];})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Apply to:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',defaultValue:'DEFAULT',onChange:function onChange(e){return _this2._applyTo(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:'DEFAULT'},'- Please select a destination -'),destination.data&&destination.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:this.props._close},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary mr-2',onClick:function onClick(e){return _this2._handleSubmit(e);}},'Save')));}}]);return NewAttractionCreateMapping;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,destination:state.destination};};var dispatchToProps=function dispatchToProps(dispatch){return{searchPlace:function searchPlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__["b" /* default */].placeSearchRequest(data));},savePlace:function savePlace(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_DestinationRedux__["b" /* default */].addPlaceToDestinationRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(NewAttractionCreateMapping));

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lines_ellipsis__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lines_ellipsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lines_ellipsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_ReviewRedux__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Reviews=function(_React$Component){_inherits(Reviews,_React$Component);function Reviews(props){_classCallCheck(this,Reviews);var _this=_possibleConstructorReturn(this,(Reviews.__proto__||Object.getPrototypeOf(Reviews)).call(this,props));_this._fetchReviewList=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object.assign({},_this.state.filter);_this.props.getReviewList(params);};_this._filterChange=function(event,field){var val=event.target.value;var filter=Object.assign({},_this.state.filter);filter[field]=val;_this.setState({filter:filter});_this._fetchReviewList(filter);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchReviewList(filter);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._approve=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.props.approveReview(id);_this._toggleModal();};_this.statusList=[{label:'- ALL STATUS -',value:''},{label:'APPROVED',value:true},{label:'UNAPPROVED',value:false}];_this.state={showModal:null,detail:{title:'',content:''},filter:{page:1,limit:10,status:''}};return _this;}_createClass(Reviews,[{key:'componentDidMount',value:function componentDidMount(){this._fetchReviewList();}},{key:'render',value:function render(){var _this2=this;var review=this.props.review;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Reviews',(review.fetching||review.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},review.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-1'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',name:'status',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},this.statusList.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(review.fetching||review.processing)&&review.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},review.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reviewer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Review Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Review Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Place'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',width:'15%'},'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,review.data&&review.data.list?review.data.list.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.first_name,' ',item.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_lines_ellipsis___default.a,{text:item.content||'',maxLine:'1',ellipsis:'...',trimRight:true,basedOn:'letters'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.place.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(item.status?'success':'danger')},item.status?'APPROVED':'UNAPPROVED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',title:'View',onClick:function onClick(){return _this2._selectItem(item,'view');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-eye'})),!item.status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',title:'Approve',onClick:function onClick(){return _this2._approve(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-check'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'8',className:'text-center'},'- NO DATA -')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='view',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Review')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Review for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,this.state.detail.place?this.state.detail.place.title:'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:this.state.detail.title})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{readOnly:true,style:{minHeight:'25vh'},className:'form-control',value:this.state.detail.content})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2._toggleModal();}},'Close'),!this.state.detail.status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._approve(_this2.state.detail.id);},className:'btn btn-lg btn-primary ml-2'},'Approve'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},review.data&&review.data.total>this.state.filter.limit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:review.data.page||this.state.filter.page,itemsCountPerPage:this.state.filter.limit,totalItemsCount:review.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return Reviews;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{review:state.review};};var dispatchToProps=function dispatchToProps(dispatch){return{getReviewList:function getReviewList(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_ReviewRedux__["b" /* default */].reviewListRequest(filter));},approveReview:function approveReview(id){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_ReviewRedux__["b" /* default */].reviewApproveRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Reviews));

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  canvasStyle: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 0,
    overflow: 'hidden',
    'padding-top': 0,
    'padding-bottom': 0,
    border: 'none'
  },

  mirrorProps: ['box-sizing', 'width', 'font-size', 'font-weight', 'font-family', 'font-style', 'letter-spacing', 'text-indent', 'white-space', 'word-break', 'padding-left', 'padding-right']
};



/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function omit(obj, omittedKeys) {
  if (!obj || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }
  var ret = {};
  Object.keys(obj).forEach(function (key) {
    if (omittedKeys.indexOf(key) > -1) {
      return;
    }
    ret[key] = obj[key];
  });
  return ret;
}

module.exports = {
  omit: omit
};



/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_CronReport_Expired__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_CronReport_ManageAttractions__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_CronReport_Whitelist__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__ = __webpack_require__(200);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CronReport=function(_React$Component){_inherits(CronReport,_React$Component);function CronReport(props){_classCallCheck(this,CronReport);var _this=_possibleConstructorReturn(this,(CronReport.__proto__||Object.getPrototypeOf(CronReport)).call(this,props));_this.componentDidMount=function(){_this.props.get(_this.state.filter);};_this._changeDate=function(date){var filter=Object.assign({},_this.state.filter);filter.date=date.format(_this.dateFormat);_this.setState({filter:filter});setTimeout(function(){_this.props.get(filter);},250);};_this._toggleModal=function(id){if(!id){_this.setState({showModal:null,detail:[]});}else{_this.setState({showModal:id});}};_this._selectItem=function(item,modalID,id){_this.setState({detail:item,selectedID:id});_this._toggleModal(modalID);};_this._viewModalButton=function(buttonStyle,faStyle,name,item,modalID,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn '+buttonStyle,onClick:function onClick(){return _this._selectItem(item,modalID,id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa '+faStyle+' mr-2'}),name);};_this.dateFormat='YYYY-MM-DD';_this.now=__WEBPACK_IMPORTED_MODULE_0_moment___default()().format(_this.dateFormat);_this.state={showModal:null,filter:{include_status:true,page:1,limit:10,item_page:1,item_limit:10,date:_this.now},detail:[],selectedID:''};return _this;}_createClass(CronReport,[{key:'render',value:function render(){var _this2=this;var cronReport=this.props.cronReport;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'title'},'Cron Report Tools',(cronReport.fetching||cronReport.processing)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),this._viewModalButton('btn btn-primary','fa-cogs','Manage Whitelist',null,'WHITELIST',null)),!(cronReport.processing||cronReport.fetching)&&cronReport.err&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert alert-danger'},cronReport.err)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},'Change Date')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.filter.date,dateFormat:this.dateFormat,timeFormat:false,isValidDate:function isValidDate(current){return current.isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()());},onChange:function onChange(date){return _this2._changeDate(date);},closeOnSelect:true})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__["a" /* default */],{colSpan:6,header:[{field:'Provider'},{field:'Created At'},{field:'Date'},{field:'Manage Attractions'},{field:'Expired Attractions'}],body:cronReport.data.data&&cronReport.data.data.length>0&&cronReport.data.data.map(function(item,i){return[{field:item.provider},{field:__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(item.created_at).format('h:mm:ss a')},{field:item.date},{field:_this2._viewModalButton('btn btn-primary','fa-wrench','Manage',item.list_ids,'MANAGE_ATTRACTION',item.id)},{field:_this2._viewModalButton('btn btn-info','fa-eye','View',item.expired_ids,'EXPIRED_LIST',item.id)}];})}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='MANAGE_ATTRACTION',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_CronReport_ManageAttractions__["a" /* default */],Object.assign({closeModal:function closeModal(){return _this2._toggleModal(null);}},this.props,{id:this.state.selectedID,filter:this.state.filter}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='WHITELIST',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_CronReport_Whitelist__["a" /* default */],Object.assign({closeModal:function closeModal(){return _this2._toggleModal(null);}},this.props))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='EXPIRED_LIST',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_CronReport_Expired__["a" /* default */],Object.assign({closeModal:function closeModal(){return _this2._toggleModal(null);}},this.props,{detail:this.state.detail}))));}}]);return CronReport;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var stateToProps=function stateToProps(state){return{cronReport:state.cronReport};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].getCronReportRequest(data));},getItem:function getItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].getCronReportItemRequest(data));},disable:function disable(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].disableAttractionRequest(data));},enable:function enable(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].enableAttractionRequest(data));},getWhitelist:function getWhitelist(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].getWhitelistRequest(data));},putWhitelist:function putWhitelist(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].putWhitelistRequest(data));},deleteWhitelist:function deleteWhitelist(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CronReportRedux__["b" /* default */].deleteWhitelistRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CronReport));

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Expired=function(_React$Component){_inherits(Expired,_React$Component);function Expired(props){_classCallCheck(this,Expired);var _this=_possibleConstructorReturn(this,(Expired.__proto__||Object.getPrototypeOf(Expired)).call(this,props));_this.state={detail:props.detail};return _this;}_createClass(Expired,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Expired Attractions List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Expired ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},this.props.detail.length>0?this.props.detail.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info mr-2',key:i},item.id);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-danger'},'- No Expired ID -'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'))));}}]);return Expired;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Expired);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AttractionList__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AttractionSelector__ = __webpack_require__(879);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageAttractions=function(_React$Component){_inherits(ManageAttractions,_React$Component);function ManageAttractions(props){_classCallCheck(this,ManageAttractions);var _this=_possibleConstructorReturn(this,(ManageAttractions.__proto__||Object.getPrototypeOf(ManageAttractions)).call(this,props));_this.componentDidMount=function(){var data={id:_this.props.id,filter:_this.state.filter};_this.props.getItem(data);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter);filter.item_page=page;_this.setState({filter:filter});var data={id:_this.props.id,filter:filter};_this.props.getItem(data);};_this._arrayAdd=function(id,title,is_disabled){var array=_this.state.array;array.push({id:id,title:title,is_disabled:is_disabled});_this.setState({array:array});};_this._arrayDecrease=function(id){var array=_this.state.array;var targetIndex=array.map(function(item){return item.id;}).indexOf(id);array.splice(targetIndex,1);_this.setState({array:array});};_this._functionStateChange=function(event){if(event)event.preventDefault();var value=event.target.value;_this.setState({functionState:value});};_this._executeToggle=function(method){var converter=_this.state.array.map(function(item){return item.id;});var data={attraction_ids:converter};if(method==='enable'){_this.props.enable(data);}else if(method==='disable'){_this.props.disable(data);}_this._forceReload();};_this._forceReload=function(){var data={id:_this.props.id,filter:_this.state.filter};setTimeout(function(){_this.setState({array:[],functionState:''});setTimeout(function(){_this.props.getItem(data);},300);},300);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter);filter.item_page=page;_this.setState({page:page,filter:filter});var data={id:_this.props.id,filter:filter};_this.props.getItem(data);};_this.state={array:[],filter:props.filter,functionState:''};return _this;}_createClass(ManageAttractions,[{key:'render',value:function render(){var _this2=this;var cronReport=this.props.cronReport;var data_item=cronReport.data_item;var data=data_item.data,meta=data_item.meta;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Enable / Disable Whitelisted Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AttractionList__["a" /* default */],{data:data,meta:meta,arrayAdd:function arrayAdd(id,title,is_disabled){return _this2._arrayAdd(id,title,is_disabled);},changePage:this._changePage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AttractionSelector__["a" /* default */],{array:this.state.array,functionState:this.state.functionState,arrayDecrease:function arrayDecrease(id){return _this2._arrayDecrease(id);},functionStateChange:function functionStateChange(event){return _this2._functionStateChange(event);},executeToggle:function executeToggle(functionState){return _this2._executeToggle(functionState);},closeModal:function closeModal(){return _this2.props.closeModal();}}));}}]);return ManageAttractions;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ManageAttractions);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionList=function(_React$Component){_inherits(AttractionList,_React$Component);function AttractionList(props){_classCallCheck(this,AttractionList);var _this=_possibleConstructorReturn(this,(AttractionList.__proto__||Object.getPrototypeOf(AttractionList)).call(this,props));_this._smartButton=function(id,title,is_disabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this.props.arrayAdd(id,title,is_disabled);},className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-down'}));};_this._simpleBoolView=function(bool){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(bool?'danger':'success')},bool?'Disabled':'Enabled');};_this._changePage=function(page){_this.setState({page:page});_this.props.changePage(page);};_this.state={page:1};return _this;}_createClass(AttractionList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,data=_props.data,meta=_props.meta;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Attractions List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_AdvancedTable__["a" /* default */],{className:'table-bordered',colSpan:4,header:[{field:'ID'},{field:'Title'},{field:'Status'},{field:'Select'}],body:data&&data.list_ids.length>0&&data.list_ids.map(function(x,i){return[{field:x.id},{field:x.title},{field:_this2._simpleBoolView(x.is_disabled)},{field:_this2._smartButton(x.id,x.title,x.is_disabled)}];})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section text-center mt-3'},meta&&meta.item_total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:this.state.page,itemsCountPerPage:meta.item_limit,totalItemsCount:meta.item_total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return AttractionList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AttractionList);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FunctionSelector__ = __webpack_require__(880);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionSelector=function(_React$Component){_inherits(AttractionSelector,_React$Component);function AttractionSelector(props){_classCallCheck(this,AttractionSelector);var _this=_possibleConstructorReturn(this,(AttractionSelector.__proto__||Object.getPrototypeOf(AttractionSelector)).call(this,props));_this._simpleBoolView=function(bool){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(bool?'danger':'success')},bool?'Disabled':'Enabled');};_this.state={};return _this;}_createClass(AttractionSelector,[{key:'render',value:function render(){var _this2=this;var array=this.props.array;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Selected Attractions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal-content mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_AdvancedTable__["a" /* default */],{colSpan:4,header:[{field:'ID'},{field:'Title'},{field:'Status'},{field:'Remove'}],body:array.length>0&&array.map(function(item,i){return[{field:item.id},{field:item.title},{field:_this2._simpleBoolView(item.is_disabled)},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.arrayDecrease(item.id);},key:i,className:'btn btn-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-arrow-up'}))}];})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FunctionSelector__["a" /* default */],Object.assign({},this.props,{options:[{value:'',description:'-Please Select Action-',disabled:true},{value:'disable',description:'Disable Attraction',disabled:false},{value:'enable',description:'Enable Attraction',disabled:false}]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2.props.executeToggle(_this2.props.functionState);}},'Apply'))));}}]);return AttractionSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AttractionSelector);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FunctionSelector=function(_React$Component){_inherits(FunctionSelector,_React$Component);function FunctionSelector(props){_classCallCheck(this,FunctionSelector);var _this=_possibleConstructorReturn(this,(FunctionSelector.__proto__||Object.getPrototypeOf(FunctionSelector)).call(this,props));_this.state={};_this.options=props.options;return _this;}_createClass(FunctionSelector,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Choose Action')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.props.functionState,onChange:function onChange(event){return _this2.props.functionStateChange(event);},className:'form-control'},this.options.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,disabled:option.disabled,value:option.value},option.description);}))));}}]);return FunctionSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (FunctionSelector);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__(199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Whitelist=function(_React$Component){_inherits(Whitelist,_React$Component);function Whitelist(props){_classCallCheck(this,Whitelist);var _this=_possibleConstructorReturn(this,(Whitelist.__proto__||Object.getPrototypeOf(Whitelist)).call(this,props));_this.componentDidMount=function(){_this.props.getWhitelist();};_this._forceReload=function(){_this._clearAllArray();_this.setState({method:''});_this.props.getWhitelist();};_this._clearAllArray=function(){_this.setState({idCollection:''});};_this._inputAllArray=function(array){var idCollection=array.join(';');_this.setState({idCollection:idCollection});};_this._onTextareaChange=function(event){if(event){event.preventDefault();}var idCollection=_this.state.idCollection;var value=event.target.value;idCollection=value;_this.setState({idCollection:idCollection});};_this._arrayConvertNow=function(string){var array=string.split(';').map(Number);return array;};_this._handleMethod=function(args){var value=args.target.value;_this.setState({method:value});};_this._whitelistApiCall=function(method){var data={ids:_this._arrayConvertNow(_this.state.idCollection)};if(method==='update'){_this.props.putWhitelist(data);}else if(method==='delete'){_this.props.deleteWhitelist(data);}setTimeout(function(){_this._forceReload();},300);};_this.state={idCollection:'',method:''};return _this;}_createClass(Whitelist,[{key:'render',value:function render(){var _this2=this;var cronReport=this.props.cronReport;var data_whitelist=cronReport.data_whitelist;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'55vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Manage Whitelist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Whitelisted ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},data_whitelist.length>0?data_whitelist.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info mr-2',key:i},item);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-danger'},'- No Whitelisted ID Yet -'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'data-tip':'Input multiple ID in this format: "ID;ID;ID;...". Please do not add space between ID and semicolons.',className:'control-label'},'Input ID',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'ml-2 fa fa-exclamation-circle'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:5,value:this.state.idCollection,onChange:function onChange(event){return _this2._onTextareaChange(event);},type:'number',className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger mr-2',onClick:function onClick(){return _this2._clearAllArray();}},'Clear All'),data_whitelist.length!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._inputAllArray(data_whitelist.length>0&&data_whitelist);}},'Input All'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Select Action')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{required:true,value:this.state.method,onChange:function onChange(event){return _this2._handleMethod(event);},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'- Please Select Action -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'update'},'Add Selected ID to Whitelist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'delete'},'Remove Selected ID from Whitelist')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._whitelistApiCall(_this2.state.method);},className:'btn btn-primary'},'Apply'))));}}]);return Whitelist;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Whitelist);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Coupon_ManageCoupon__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Coupon_ManageProvider__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Coupon_ManageAffiliate__ = __webpack_require__(907);
var subList={ManageCoupon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Coupon_ManageCoupon__["a" /* default */],null),ManageProvider:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Coupon_ManageProvider__["a" /* default */],null),ManageAffiliate:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Coupon_ManageAffiliate__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var CouponPage=function CouponPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (CouponPage);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_CouponProviderRedux__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Coupon_CreateCoupon__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Coupon_GenerateCoupon__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Containers_Coupon_ViewCoupon__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Containers_Coupon_UpdateContent__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Containers_Coupon_UpdateImage__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Containers_Coupon_ViewBusinessCoupon__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Containers_Coupon_UpdateBusinessContent__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Containers_Coupon_UpdateBusinessImage__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Containers_Coupon_DownloadSpreadsheet__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Containers_Coupon_DownloadHistory__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Containers_Coupon_IndividualCoupon__ = __webpack_require__(894);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CouponPage=function(_React$Component){_inherits(CouponPage,_React$Component);function CouponPage(props){_classCallCheck(this,CouponPage);var _this=_possibleConstructorReturn(this,(CouponPage.__proto__||Object.getPrototypeOf(CouponPage)).call(this,props));_this.componentDidMount=function(){_this._fetchCoupon();_this.props.getCouponProvider();_this.props.getCategory();};_this._fetchCoupon=function(event){if(event){event.preventDefault();}var filter={page:_this.state.page,q:_this.state.q,type:_this.state.type,status:_this.state.status,discount_type:_this.state.discount_type,product_type:_this.state.product_type,only_private:_this.state.only_private};if(_this.state.start_at!==null&&_this.state.end_at!==null){filter['start_at']=_this.state.start_at.format(_this.dateformat);filter['end_at']=_this.state.end_at.format(_this.dateformat);}if(_this.state.sortCreated!=='desc'){filter['sort']='created_at';}if(_this.state.tab==='coupon-user'){if(!filter.type){filter.type='GENERIC';}_this.props.getAllCoupon(filter);}else{if(!filter.type){filter.type='BUSINESS';}_this.props.getAllCouponTag(filter);}};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchCoupon();}};_this._resetSelector=function(item){item.coupon_providers===null?_this.setState({selectedProvider:null}):_this.setState({selectedProvider:{value:item.provider_id,label:item.coupon_providers.name}});};_this._selectItem=function(item,action){if(action==='edit-content'||action==='edit-business-content'){_this._resetSelector(item);}_this.setState({detail:item});_this._toggleModal(action);};_this._delete=function(){_this.props.deleteCoupon(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this._deleteTag=function(){var body={status:'unavailable',is_deleted:1};var data={tag:_this.state.detail.tag,body:body};_this.props.deleteBusiness(data);setTimeout(function(){_this._toggleModal();},250);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){_this._fetchCoupon();},250);};_this._changeTab=function(tab){_this.setState({tab:tab,page:1,q:'',status:'',product_type:'',discount_type:'',start_at:null,end_at:null,filterDate:false,only_private:false,sortCreated:'desc'});setTimeout(function(){_this._fetchCoupon();},250);};_this._dateChange=function(date,field){var newdate=null;if(__WEBPACK_IMPORTED_MODULE_6_lodash_isObject___default()(date)){newdate=date;}var newState=Object.assign({},_this.state);newState[field]=newdate;_this.setState(newState);};_this._sortCoupon=function(){if(_this.state.sortCreated==='desc'){_this.setState({sortCreated:'asc'});}else{_this.setState({sortCreated:'desc'});}setTimeout(function(){_this._fetchCoupon();},250);};_this._toggleStatus=function(item){var form=Object.assign({},item);if(form.status==='available'){form['status']='unavailable';}else{form['status']='available';}var data={id:item.id,form:form};_this.props.updateCoupon(data);setTimeout(function(){_this._fetchCoupon();},250);};_this.dateformat='YYYY-MM-DD';_this.state={showModal:null,selectedProvider:null,detail:{},page:1,q:'',type:'GENERIC',status:'',discount_type:'',product_type:'',rent_type:'',start_at:null,end_at:null,filterDate:false,only_private:false,tab:'coupon-user',sortCreated:'desc',sortValue:''};return _this;}_createClass(CouponPage,[{key:'render',value:function render(){var _this2=this;var coupon=this.props.coupon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Coupon',!this.state.showModal&&(this.props.coupon.fetching||this.props.coupon.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},this.props.coupon.fetching?'Loading':'Processing',' ...')),this.state.tab==='coupon-tag'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('generate');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus mr-2'}),'Generate Business Coupon'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus mr-2'}),'Create User Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-4',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='coupon-user'&&'active'),onClick:function onClick(){return _this2._changeTab('coupon-user');}},'Coupon User'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='coupon-tag'&&'active'),onClick:function onClick(){return _this2._changeTab('coupon-tag');}},'Coupon Business')),this.state.tab==='coupon-user'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._fetchCoupon(event);},className:'form-inline d-flex justify-content-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Code / Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Coupon Code / Title',className:'form-control',onChange:function onChange(event){return _this2.setState({q:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({product_type:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Product Type -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'modem'},'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'attraction'},'Attraction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'insurance'},'Insurance'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Discount Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({discount_type:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Discount Type -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({status:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Status -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'available'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unavailable'},'Unavailable'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Specific User'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_SwitchButton__["a" /* default */],{isChecked:this.state.only_private,onChange:function onChange(){return _this2.setState({only_private:!_this2.state.only_private});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.start_at,closeOnSelect:true,onChange:function onChange(date){return _this2._dateChange(date,'start_at');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.end_at,closeOnSelect:true,onChange:function onChange(date){return _this2._dateChange(date,'end_at');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mt-1'},'Apply Filter')))),this.state.tab==='coupon-tag'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline d-flex justify-content-right',onSubmit:function onSubmit(event){return _this2._fetchCoupon(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Tag / Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Coupon Tag / Title',className:'form-control',onChange:function onChange(event){return _this2.setState({q:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({product_type:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Product Type -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'modem'},'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'attraction'},'Attraction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'insurance'},'Insurance'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Discount Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({discount_type:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Discount Type -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this2.setState({status:event.target.value});},className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- All Status -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'available'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unavailable'},'Unavailable'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.start_at,closeOnSelect:true,onChange:function onChange(date){return _this2._dateChange(date,'start_at');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.end_at,closeOnSelect:true,onChange:function onChange(date){return _this2._dateChange(date,'end_at');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mt-1'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(this.props.coupon.fetching||this.props.coupon.processing)&&this.props.coupon.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.props.coupon.err),this.state.tab==='coupon-user'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',role:'button',onClick:function onClick(){return _this2._sortCoupon();}},'Created',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(this.state.sortCreated==='desc'?'sort-amount-down':'sort-amount-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Platform'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Usage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'# Per user'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Disc type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Disc Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Disc'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Min Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'End'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Individual Coupon'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!coupon.data||!coupon.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'20',className:'text-center'},'- NO DATA -')):coupon.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},i+1+(_this2.state.page-1)*10),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.created_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.platform||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.product_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_usage||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_usage_per_user||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.discount_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.discount_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_discount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.min_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.start_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.end_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_SwitchButton__["a" /* default */],{isChecked:item.status==='available',onChange:function onChange(){return _this2._toggleStatus(item);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'view');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._selectItem(item,'individual-coupon');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-content');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'edit-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),'Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.claimers&&!item.claimers.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))),this.state.tab==='coupon-tag'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Tag'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{role:'button',onClick:function onClick(){return _this2._sortCoupon();}},'Created',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(this.state.sortCreated==='desc'?'sort-amount-down':'sort-amount-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Platform'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Usage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'# Per user'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Disc type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Disc amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Disc'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Min Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Max Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Start'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'End'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'View'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Individual Coupon'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Spreadsheet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'History'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!coupon.data||!coupon.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'19',className:'text-center'},'- NO DATA -')):coupon.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},i+1+(_this2.state.page-1)*10),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.tag||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.created_at).format(_this2.dateformat)||'----'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.platform||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.product_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_usage||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_usage_per_user||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.discount_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.discount_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_discount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.min_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.max_amount||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.start_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.end_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_SwitchButton__["a" /* default */],{isChecked:item.status==='available',onChange:function onChange(){return _this2._toggleStatus(item);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'view-business');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._selectItem(item,'individual-coupon');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-business-content');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-business-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),'Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.stats&&item.stats.order_count===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-business');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'download');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'downloadHistory');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS')));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Coupon_CreateCoupon__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='generate',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Coupon_GenerateCoupon__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-content',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Containers_Coupon_UpdateContent__["a" /* default */],{selectedProvider:this.state.selectedProvider,detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-business-content',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Containers_Coupon_UpdateBusinessContent__["a" /* default */],{selectedProvider:this.state.selectedProvider,detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='edit-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Containers_Coupon_UpdateImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-business-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Containers_Coupon_UpdateBusinessImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Containers_Coupon_ViewCoupon__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-business',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Containers_Coupon_ViewBusinessCoupon__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='individual-coupon',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Containers_Coupon_IndividualCoupon__["a" /* default */],{title:this.state.detail.title,uuid:this.state.detail.id,tag:this.state.detail.tag,source_type:this.state.tab,product_type:this.state.detail.product_type,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Coupon?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Title: ',this.state.detail.title||'-',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Coupon: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},this.state.detail.code||'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-business',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Coupon?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Title: ',this.state.detail.title||'-',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Tag: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},this.state.detail.tag||'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteTag();}},'Delete')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Containers_Coupon_DownloadSpreadsheet__["a" /* default */],{tag:this.state.detail.tag,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='downloadHistory',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Containers_Coupon_DownloadHistory__["a" /* default */],{tag:this.state.detail.tag,closeModal:function closeModal(){return _this2._toggleModal();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},this.props.coupon.data&&this.props.coupon.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:this.props.coupon.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:this.props.coupon.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return CouponPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllCoupon:function getAllCoupon(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].couponRequest(filter));},getAllCouponTag:function getAllCouponTag(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].couponTagRequest(filter));},getCouponProvider:function getCouponProvider(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CouponProviderRedux__["b" /* default */].getCouponProviderRequest());},getCategory:function getCategory(){return dispatch(__WEBPACK_IMPORTED_MODULE_10__Redux_CategoryRedux__["b" /* default */].getCategoryRequest());},getCouponItem:function getCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].getCouponItemRequest(data));},deleteCoupon:function deleteCoupon(id){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].couponDeleteRequest(id));},deleteBusiness:function deleteBusiness(tag){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].businessDeleteRequest(tag));},updateCoupon:function updateCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].couponUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CouponPage));

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateCoupon=function(_React$Component){_inherits(CreateCoupon,_React$Component);function CreateCoupon(props){_classCallCheck(this,CreateCoupon);var _this=_possibleConstructorReturn(this,(CreateCoupon.__proto__||Object.getPrototypeOf(CreateCoupon)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var coupon=Object.assign({},_this.state.coupon);coupon['image_file']=newProps.files.data.upload[0].filename;_this.setState({coupon:coupon});}};_this._selectChange=function(selectedProvider){var coupon=Object.assign({},_this.state.coupon);coupon.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,coupon:coupon});};_this._fileUploaded=function(filename,field){var coupon=Object.assign({},_this.state.coupon);coupon[field]=filename;_this.setState({coupon:coupon});};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','coupon-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._couponChange=function(event,field){var isNumber=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var val=event.target.value;if(isNumber){val=parseInt(val,10);}var coupon=Object.assign({},_this.state.coupon);coupon[field]=val;if(field==='code'){if(val.match(_this.couponCodeRegex)===null){return null;}coupon[field]=val.substr(0,14);}_this.setState({coupon:coupon});};_this._dateChange=function(date,field){var coupon=Object.assign({},_this.state.coupon);if(field==='start_at'){if(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.coupon.end_at)){coupon.end_at=__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(1,'day');}}if(field==='travel_date_start'){if(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.coupon.travel_date_end)){coupon.travel_date_end=__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(1,'day');}}coupon[field]=date;_this.setState({coupon:coupon});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.coupon);_this.props.createCoupon(data);setTimeout(function(){_this.props.closeModal();},250);};_this.dateFormat='YYYY-MM-DD';_this.couponCodeRegex=/^[a-zA-Z0-9]*$/;_this.platforms=[{value:'all',label:'ALL'},{value:'web',label:'WEB'},{value:'all-mobile',label:'ALL-MOBILE'},{value:'android',label:'ANDROID'},{value:'ios',label:'IOS'}];_this.rentType=[{value:'all',label:'ALL'},{value:'new',label:'NEW'},{value:'topup',label:'TOP-UP'}];_this.productTypes=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'insurance',label:'INSURANCE',restriction:['PH']},{value:'inventory',label:'ECOMMERCE'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.iso_code=[{value:'ID',label:'INDONESIA',restriction:['PH']},{value:'PH',label:'PHILIPPINES'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_8_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.state={selectedProvider:null,coupon:{type:'GENERIC',title:'',code:'',status:'available',max_usage:1,max_usage_per_user:1,image_file:'',product_type:'all',rent_type:'all',travel_date_start:null,travel_date_end:null,min_duration:0,discount_type:'PRICE_CUT',discount_amount:0,max_discount:0,start_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(),end_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(),description:'',min_amount:0,max_amount:0,platform:'all',first_order_only:false,first_user_only:false,provider_id:null,iso_code:Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])()},file:null,uploaded:false};return _this;}_createClass(CreateCoupon,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;var providerPicker=[];couponProvider.data&&couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'85vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Create Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Title',className:'form-control',value:this.state.coupon.title,onChange:function onChange(event){return _this2._couponChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Code (max: 14 character)',className:'form-control',value:this.state.coupon.code,onChange:function onChange(event){return _this2._couponChange(event,'code');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'GENERIC'},'Generic'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'BUSINESS'},'Business')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.status,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'available'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unavailable'},'Unavailable')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.platform,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'platform');}},this.platforms.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.product_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'product_type');}},this.productTypes.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rent Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.rent_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'rent_type');}},this.rentType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.min_duration,onChange:function onChange(event){return _this2._couponChange(event,'min_duration',true);}}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel Start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1,'day'));},value:this.state.coupon.travel_date_start,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_start');},closeOnSelect:true}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel End')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.travel_date_start);},value:this.state.coupon.travel_date_end,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_end');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage,onChange:function onChange(event){return _this2._couponChange(event,'max_usage',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage Per User')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage_per_user,onChange:function onChange(event){return _this2._couponChange(event,'max_usage_per_user',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.discount_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'discount_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'DURATION_CUT'},'FULL CUT (DURATION BASED)'),this.state.coupon.product_type==='modem'&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT_WITH_DEPOSIT'},'FULL CUT (WITH DEPOSIT)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.discount_amount,onChange:function onChange(event){return _this2._couponChange(event,'discount_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Discount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_discount,onChange:function onChange(event){return _this2._couponChange(event,'max_discount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.min_amount,onChange:function onChange(event){return _this2._couponChange(event,'min_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_amount,onChange:function onChange(event){return _this2._couponChange(event,'max_amount',true);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_order_only,onChange:function onChange(event){return _this2._couponChange(event,'first_order_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_user_only,onChange:function onChange(event){return _this2._couponChange(event,'first_user_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.start_at,onChange:function onChange(date){return _this2._dateChange(date,'start_at');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.end_at,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.start_at);},onChange:function onChange(date){return _this2._dateChange(date,'end_at');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Coupon Description',rows:'3',value:this.state.coupon.description,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'description');}}))),Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))),Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'ISO Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.iso_code,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'iso_code');}},this.iso_code.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'433x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'coupon-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files,couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_FilesRedux__["b" /* default */].filesUploadReset());},createCoupon:function createCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_10__Redux_CouponRedux__["b" /* default */].couponCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateCoupon));

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GenerateCoupon=function(_React$Component){_inherits(GenerateCoupon,_React$Component);function GenerateCoupon(props){_classCallCheck(this,GenerateCoupon);var _this=_possibleConstructorReturn(this,(GenerateCoupon.__proto__||Object.getPrototypeOf(GenerateCoupon)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this._selectChange=function(selectedProvider){var coupon=Object.assign({},_this.state.coupon);coupon.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,coupon:coupon});};_this._fileUploaded=function(filename,field){var coupon=Object.assign({},_this.state.coupon);coupon[field]=filename;_this.setState({coupon:coupon});};_this._couponChange=function(event,field){var isNumber=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var val=event.target.value;if(isNumber){val=parseInt(val,10);}var coupon=Object.assign({},_this.state.coupon);coupon[field]=val;if(field==='tag'){if(val.match(_this.couponCodeRegex)===null){return null;}coupon[field]=val.substr(0,14);coupon['code']=coupon[field]+'-';}_this.setState({coupon:coupon});};_this._dateChange=function(date,field){var coupon=Object.assign({},_this.state.coupon);coupon[field]=date;_this.setState({coupon:coupon});};_this._submit=function(event){event.preventDefault();var preset='GENERATE_DUPLICATES_WITH_APPENDED_CODE';var baseCoupon=Object.assign({},_this.state.coupon);baseCoupon['start_at']=_this.state.coupon.start_at.format();baseCoupon['end_at']=_this.state.coupon.end_at.format();var options={appendedCodeLength:6};var data={preset:preset,count:_this.state.count,baseCoupon:baseCoupon,options:options};_this.props.createCoupon(data);setTimeout(function(){_this.props.closeModal();},250);};_this.couponCodeRegex=/^[a-zA-Z0-9]*$/;_this.platforms=[{value:'all',label:'ALL'},{value:'web',label:'WEB'},{value:'all-mobile',label:'ALL-MOBILE'},{value:'android',label:'ANDROID'},{value:'ios',label:'IOS'}];_this.rentType=[{value:'all',label:'ALL'},{value:'new',label:'NEW'},{value:'topup',label:'TOP-UP'}];_this.productTypes=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'insurance',label:'INSURANCE'},{value:'inventory',label:'ECOMMERCE'}];_this.state={selectedProvider:null,coupon:{type:'BUSINESS',title:'',code:'',tag:'',status:'available',max_usage:1,max_usage_per_user:1,image_file:'',product_type:'all',rent_type:'all',travel_date_start:null,travel_date_end:null,min_duration:0,discount_type:'PRICE_CUT',discount_amount:0,max_discount:0,start_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(),end_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(),description:'',min_amount:0,max_amount:0,platform:'all',first_order_only:false,first_user_only:false},count:5};return _this;}_createClass(GenerateCoupon,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;var providerPicker=[];couponProvider.data&&couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'85vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Generate Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:1,className:'form-control',value:this.state.count,onChange:function onChange(event){return _this2.setState({count:parseInt(event.target.value,10)});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Title',className:'form-control',value:this.state.coupon.title,onChange:function onChange(event){return _this2._couponChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tag')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Code (max: 14 char)',className:'form-control',value:this.state.coupon.tag,onChange:function onChange(event){return _this2._couponChange(event,'tag');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.status,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'available'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unavailable'},'Unavailable')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.platform,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'platform');}},this.platforms.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.product_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'product_type');}},this.productTypes.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rent Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.rent_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'rent_type');}},this.rentType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.min_duration,onChange:function onChange(event){return _this2._couponChange(event,'min_duration',true);}}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel Start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1,'day'));},value:this.state.coupon.travel_date_start,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_start');},closeOnSelect:true}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel End')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.travel_date_start);},value:this.state.coupon.travel_date_end,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_end');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage,onChange:function onChange(event){return _this2._couponChange(event,'max_usage',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage Per User')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage_per_user,onChange:function onChange(event){return _this2._couponChange(event,'max_usage_per_user',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.discount_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'discount_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'DURATION_CUT'},'FULL CUT (DURATION BASED)'),this.state.coupon.product_type==='modem'&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT_WITH_DEPOSIT'},'FULL CUT (WITH DEPOSIT)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.discount_amount,onChange:function onChange(event){return _this2._couponChange(event,'discount_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Discount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_discount,onChange:function onChange(event){return _this2._couponChange(event,'max_discount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.min_amount,onChange:function onChange(event){return _this2._couponChange(event,'min_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_amount,onChange:function onChange(event){return _this2._couponChange(event,'max_amount',true);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_order_only,onChange:function onChange(event){return _this2._couponChange(event,'first_order_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_user_only,onChange:function onChange(event){return _this2._couponChange(event,'first_user_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.start_at,viewDate:this.state.coupon.start_at,onChange:function onChange(date){return _this2._dateChange(date,'start_at');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.end_at,viewDate:this.state.coupon.end_at,onChange:function onChange(date){return _this2._dateChange(date,'end_at');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Coupon Description',rows:'3',value:this.state.coupon.description,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'433x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FileUploader__["a" /* default */],{setting:{type:'coupon-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return GenerateCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files,couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_FilesRedux__["b" /* default */].filesUploadReset());},createCoupon:function createCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_CouponRedux__["b" /* default */].couponGenerateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(GenerateCoupon));

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewCoupon=function(_React$Component){_inherits(ViewCoupon,_React$Component);function ViewCoupon(props){_classCallCheck(this,ViewCoupon);var _this=_possibleConstructorReturn(this,(ViewCoupon.__proto__||Object.getPrototypeOf(ViewCoupon)).call(this,props));_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(modalId==='view-user'){_this._fetchClaimers();}};_this._fetchClaimers=function(){_this.props.getDetail({id:_this.props.detail.id});};_this.state={showModal:null,data:[]};return _this;}_createClass(ViewCoupon,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'View Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.code||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.type||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.status||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.platform||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.product_type||'-')),this.props.detail.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rent Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.rent_type||'-')),this.props.detail.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel Start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.travel_date_start||'-')),this.props.detail.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel End')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.travel_date_end||'-')),this.props.detail.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.min_duration||'- No Restriction -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_usage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage Per User')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_usage_per_user)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.discount_type.replace('_',' ')||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.discount_amount||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.min_amount||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_amount||0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},String(this.props.detail.first_order_only))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},String(this.props.detail.first_user_only))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.detail.start_at).format('DD/MM/Y hh:mm A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_2_moment___default()(this.props.detail.end_at).format('DD/MM/Y hh:mm A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.detail.description||'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.image_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img-responsive',src:this.props.detail.image_url,style:{maxWidth:'100%'}}):'No Image'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('view-user');}},'View Users'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-user',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'List User',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._fetchClaimers();},className:'ml-2 btn btn-primary'},'Reload'),(this.props.coupon.fetching||this.props.coupon.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},this.props.coupon.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Phone number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Order ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Discount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.coupon.detail&&!this.props.coupon.detail.coupon_history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'9',className:'text-center'},'- No Data -')):this.props.coupon.detail.coupon_history.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.first_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.last_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.country_code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.country_calling_code+item.user.phone_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order_id||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order.final_amount||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order.discount_amount||'-'));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close')))))));}}]);return ViewCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{getDetail:function getDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_CouponRedux__["b" /* default */].couponDetailRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewCoupon));

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateContent=function(_React$Component){_inherits(UpdateContent,_React$Component);function UpdateContent(props){_classCallCheck(this,UpdateContent);var _this=_possibleConstructorReturn(this,(UpdateContent.__proto__||Object.getPrototypeOf(UpdateContent)).call(this,props));_this._selectChange=function(selectedProvider){var coupon=Object.assign({},_this.state.coupon);coupon.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,coupon:coupon});};_this._couponChange=function(event,field){var isNumber=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var val=event.target.value;if(isNumber){val=parseInt(val,10);}var coupon=Object.assign({},_this.state.coupon);coupon[field]=val;if(field==='code'){coupon[field]=val.substr(0,7);}_this.setState({coupon:coupon});};_this._dateChange=function(date,field){var coupon=Object.assign({},_this.state.coupon);if(field==='start_at'){if(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.coupon.end_at)){coupon.end_at=__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(1,'day');}}if(field==='travel_date_start'){if(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.coupon.travel_date_end)){coupon.travel_date_end=__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).add(1,'day');}}coupon[field]=date;_this.setState({coupon:coupon});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.coupon);var data={id:_this.props.detail.id,form:form};_this.props.updateCoupon(data);setTimeout(function(){_this.props.closeModal();},250);};_this.dateFormat='YYYY-MM-DD';_this.platforms=[{value:'all',label:'ALL'},{value:'web',label:'WEB'},{value:'all-mobile',label:'ALL-MOBILE'},{value:'android',label:'ANDROID'},{value:'ios',label:'IOS'}];_this.rentType=[{value:'all',label:'ALL'},{value:'new',label:'NEW'},{value:'topup',label:'TOP-UP'}];_this.productTypes=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'insurance',label:'INSURANCE',restriction:['PH']},{value:'inventory',label:'ECOMMERCE'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={selectedProvider:props.selectedProvider||null,coupon:{title:props.detail.title||'',code:props.detail.code||'',status:props.detail.status||'available',max_usage:props.detail.max_usage||1,max_usage_per_user:props.detail.max_usage_per_user||1,image_file:props.detail.image_file||'',product_type:props.detail.product_type||'all',rent_type:props.detail.rent_type||'all',travel_date_start:props.detail.travel_date_start||null,travel_date_end:props.detail.travel_date_end||null,min_duration:props.detail.min_duration||0,type:props.detail.type||'GENERIC',discount_type:props.detail.discount_type||'PRICE_CUT',discount_amount:props.detail.discount_amount||0,max_discount:props.detail.max_discount||0,start_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.detail.start_at),end_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.detail.end_at),description:props.detail.description||'',min_amount:props.detail.min_amount||0,max_amount:props.detail.max_amount||0,platform:props.detail.platform||'all',first_order_only:props.detail.first_order_only||false,first_user_only:props.detail.first_user_only||false,provider_id:props.detail.provider_id||null,iso_code:props.detail.iso_code||Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()}};return _this;}_createClass(UpdateContent,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;var providerPicker=[];couponProvider.data&&couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Edit Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Title',className:'form-control',value:this.state.coupon.title,onChange:function onChange(event){return _this2._couponChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,className:'form-control',value:this.state.coupon.code}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'GENERIC'},'Generic'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'BUSINESS'},'Business')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.status,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'available'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'unavailable'},'Unavailable')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.platform,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'platform');}},this.platforms.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.product_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'product_type');}},this.productTypes.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rent Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.rent_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'rent_type');}},this.rentType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.min_duration,onChange:function onChange(event){return _this2._couponChange(event,'min_duration',true);}}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel Start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1,'day'));},value:this.state.coupon.travel_date_start,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_start');},closeOnSelect:true}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel End')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.travel_date_start);},value:this.state.coupon.travel_date_end,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_end');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage,onChange:function onChange(event){return _this2._couponChange(event,'max_usage',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage Per User')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage_per_user,onChange:function onChange(event){return _this2._couponChange(event,'max_usage_per_user',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.discount_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'discount_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'DURATION_CUT'},'FULL CUT (DURATION BASED)'),this.state.coupon.product_type==='modem'&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT_WITH_DEPOSIT'},'FULL CUT (WITH DEPOSIT)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.discount_amount,onChange:function onChange(event){return _this2._couponChange(event,'discount_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Discount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_discount,onChange:function onChange(event){return _this2._couponChange(event,'max_discount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.min_amount,onChange:function onChange(event){return _this2._couponChange(event,'min_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_amount,onChange:function onChange(event){return _this2._couponChange(event,'max_amount',true);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_order_only,onChange:function onChange(event){return _this2._couponChange(event,'first_order_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_user_only,onChange:function onChange(event){return _this2._couponChange(event,'first_user_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.start_at,onChange:function onChange(date){return _this2._dateChange(date,'start_at');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.end_at,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.start_at);},onChange:function onChange(date){return _this2._dateChange(date,'end_at');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Coupon Description',rows:'3',value:this.state.coupon.description,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'description');}}))),Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateContent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{updateCoupon:function updateCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_CouponRedux__["b" /* default */].couponUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateContent));

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateImage=function(_React$Component){_inherits(UpdateImage,_React$Component);function UpdateImage(props){_classCallCheck(this,UpdateImage);// this.formatDate = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
var _this=_possibleConstructorReturn(this,(UpdateImage.__proto__||Object.getPrototypeOf(UpdateImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var coupon=Object.assign({},_this.state.coupon);coupon['image_file']=newProps.files.data.upload[0].filename;_this.setState({coupon:coupon});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','coupon-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.coupon);var data={id:_this.props.detail.id,form:form};_this.props.updateCoupon(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={coupon:{title:props.detail.title||'',code:props.detail.code||'',// max 7
status:props.detail.status||'available',// available, unavailable
max_usage:props.detail.max_usage||1,max_usage_per_user:props.detail.max_usage_per_user||1,image_file:'',discount_type:props.detail.discount_type||'PRICE_CUT',// PRICE_CUT, FULL_CUT, PERCENTAGE_CUT
discount_amount:props.detail.discount_amount||0,start_at:props.detail.start_at,end_at:props.detail.end_at,description:props.detail.description||'',min_amount:props.detail.min_amount||0},file:null,uploaded:false};return _this;}_createClass(UpdateImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Update Coupon Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img-responsive',style:{maxWidth:'100%'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'New Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'433x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',className:'custom-file-input',onChange:function onChange(event){return _this2._fileSelect(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'custom-file-label'},this.state.file?'File selected':'Choose files')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(event){return _this2._upload(event);},disabled:!this.state.file,className:'input-group-text'},'Upload'))),this.props.files.fetching&&'Uploading ...',this.state.uploaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.files.data&&this.props.files.data.upload.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,alt:item.filename,title:item.filename,className:'img img-responsive',src:item.url,style:{maxWidth:'100%'}});})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Files Uploaded'),this.props.files.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.props.files.err)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.coupon.image_file,className:'btn btn-primary'},'Save'))));}}]);return UpdateImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__["b" /* default */].filesUploadReset());},updateCoupon:function updateCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateImage));

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Modal from 'react-responsive-modal'
var ViewBusinessCoupon=function(_React$Component){_inherits(ViewBusinessCoupon,_React$Component);function ViewBusinessCoupon(props){_classCallCheck(this,ViewBusinessCoupon);var _this=_possibleConstructorReturn(this,(ViewBusinessCoupon.__proto__||Object.getPrototypeOf(ViewBusinessCoupon)).call(this,props));_this.state={data:[]};return _this;}_createClass(ViewBusinessCoupon,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'View Business Tags')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tag')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.tag||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.type||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.status||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.platform||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.product_type||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_usage||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Max Usage Per user')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_usage_per_user||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.discount_type||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.discount_amount||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.min_amount||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.max_amount||'-')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.first_order_only||'No first order limitation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.first_user_only||'No first user limitation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.props.detail.start_at).format('DD/MM/Y hh:mm A')||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.props.detail.end_at).format('DD/MM/Y hh:mm A')||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.description||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Updated at')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.updated_at||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.stats.count||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.stats.order_count||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Claimer Count')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.stats.claimer_count||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},this.props.detail.image_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img-responsive',src:this.props.detail.image_url,style:{maxWidth:'100%'}}):'No Image'))))));}}]);return ViewBusinessCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllCouponTag:function getAllCouponTag(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__["b" /* default */].couponTagRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewBusinessCoupon));

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateBusinessContent=function(_React$Component){_inherits(UpdateBusinessContent,_React$Component);function UpdateBusinessContent(props){_classCallCheck(this,UpdateBusinessContent);var _this=_possibleConstructorReturn(this,(UpdateBusinessContent.__proto__||Object.getPrototypeOf(UpdateBusinessContent)).call(this,props));_this._selectChange=function(selectedProvider){var coupon=Object.assign({},_this.state.coupon);coupon.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,coupon:coupon});};_this._couponChange=function(event,field){var isNumber=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var val=event.target.value;var coupon=Object.assign({},_this.state.coupon);if(isNumber){val=parseInt(val,10);}coupon[field]=val;if(field==='tag'){coupon[field]=val.substr(0,7);}_this.setState({coupon:coupon});};_this._dateChange=function(date,field){var coupon=Object.assign({},_this.state.coupon);coupon[field]=date;_this.setState({coupon:coupon});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.coupon);form['start_at']=_this.state.coupon.start_at.format();form['end_at']=_this.state.coupon.end_at.format();var data={tag:_this.props.detail.tag,form:form};_this.props.updateBusiness(data);setTimeout(function(){_this.props.closeModal();},250);};_this.platforms=[{value:'all',label:'ALL'},{value:'web',label:'WEB'},{value:'all-mobile',label:'ALL-MOBILE'},{value:'android',label:'ANDROID'},{value:'ios',label:'IOS'}];_this.rentType=[{value:'all',label:'ALL'},{value:'new',label:'NEW'},{value:'topup',label:'TOP-UP'}];_this.productTypes=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'insurance',label:'INSURANCE'},{value:'inventory',label:'ECOMMERCE'}];_this.state={selectedProvider:props.selectedProvider||null,coupon:{title:props.detail.title||'',tag:props.detail.tag,max_usage:props.detail.max_usage||1,max_usage_per_user:props.detail.max_usage_per_user||1,product_type:props.detail.product_type||'all',rent_type:props.detail.rent_type||'all',travel_date_start:props.detail.travel_date_start||null,travel_date_end:props.detail.travel_date_end||null,min_duration:props.detail.min_duration||0,discount_type:props.detail.discount_type||'PRICE_CUT',discount_amount:props.detail.discount_amount||0,max_discount:props.detail.max_discount||0,start_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.detail.start_at),end_at:__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.detail.end_at),description:props.detail.description||'',min_amount:props.detail.min_amount||0,max_amount:props.detail.max_amount||0,platform:props.detail.platform||'all',first_order_only:props.detail.first_order_only||false,first_user_only:props.detail.first_user_only||false,provider_id:props.detail.provider_id||null}};return _this;}_createClass(UpdateBusinessContent,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;var providerPicker=[];couponProvider.data&&couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'85vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Update Coupon Business')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Coupon Title',className:'form-control',value:this.state.coupon.title,onChange:function onChange(event){return _this2._couponChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Tag')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,className:'form-control',value:this.state.coupon.tag}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Platform')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.platform,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'platform');}},this.platforms.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.product_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'product_type');}},this.productTypes.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rent Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.rent_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'rent_type');}},this.rentType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Duration')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.min_duration,onChange:function onChange(event){return _this2._couponChange(event,'min_duration',true);}}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel Start')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1,'day'));},value:this.state.coupon.travel_date_start,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_start');},closeOnSelect:true}))),this.state.coupon.product_type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Travel End')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{dateFormat:this.dateFormat,timeFormat:false,utc:true,isValidDate:function isValidDate(current){return current.isAfter(_this2.state.coupon.travel_date_start);},value:this.state.coupon.travel_date_end,onChange:function onChange(date){return _this2._dateChange(date,'travel_date_end');},closeOnSelect:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage,onChange:function onChange(event){return _this2._couponChange(event,'max_usage',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Usage Per User')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.coupon.max_usage_per_user,onChange:function onChange(event){return _this2._couponChange(event,'max_usage_per_user',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.coupon.discount_type,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'discount_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PRICE_CUT'},'PRICE CUT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT'},'FULL CUT'),(this.state.coupon.product_type==='modem'||this.state.coupon.product_type==='all')&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'DURATION_CUT'},'FULL CUT (DURATION BASED)'),this.state.coupon.product_type==='modem'&&this.state.coupon.min_duration>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'FULL_CUT_WITH_DEPOSIT'},'FULL CUT (WITH DEPOSIT)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PERCENTAGE_CUT'},'PERCENTAGE CUT')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.discount_amount,onChange:function onChange(event){return _this2._couponChange(event,'discount_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Discount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_discount,onChange:function onChange(event){return _this2._couponChange(event,'max_discount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Min Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.min_amount,onChange:function onChange(event){return _this2._couponChange(event,'min_amount',true);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Max Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.coupon.max_amount,onChange:function onChange(event){return _this2._couponChange(event,'max_amount',true);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Order Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_order_only,onChange:function onChange(event){return _this2._couponChange(event,'first_order_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First User Only')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_SwitchButton__["a" /* default */],{isChecked:this.state.coupon.first_user_only,onChange:function onChange(event){return _this2._couponChange(event,'first_user_only');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.start_at,viewDate:this.state.coupon.start_at,onChange:function onChange(date){return _this2._dateChange(date,'start_at');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End At')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:this.state.coupon.end_at,viewDate:this.state.coupon.end_at,onChange:function onChange(date){return _this2._dateChange(date,'end_at');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Coupon Description',rows:'3',value:this.state.coupon.description,className:'form-control',onChange:function onChange(event){return _this2._couponChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateBusinessContent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBusiness:function updateBusiness(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_CouponRedux__["b" /* default */].businessUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateBusinessContent));

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateBusinessImage=function(_React$Component){_inherits(UpdateBusinessImage,_React$Component);function UpdateBusinessImage(props){_classCallCheck(this,UpdateBusinessImage);var _this=_possibleConstructorReturn(this,(UpdateBusinessImage.__proto__||Object.getPrototypeOf(UpdateBusinessImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var coupon=Object.assign({},_this.state.coupon);coupon['image_file']=newProps.files.data.upload[0].filename;_this.setState({coupon:coupon});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','coupon-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.coupon);var data={tag:_this.props.detail.tag,form:form};_this.props.updateCoupon(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={coupon:{tag:props.detail.tag||'',image_file:''},file:null,uploaded:false};return _this;}_createClass(UpdateBusinessImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Update Coupon Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img-responsive',style:{maxWidth:'100%'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'New Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'433x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'custom-file'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',className:'custom-file-input',onChange:function onChange(event){return _this2._fileSelect(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'custom-file-label'},this.state.file?'File selected':'Choose files')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(event){return _this2._upload(event);},disabled:!this.state.file,className:'input-group-text'},'Upload'))),this.props.files.fetching&&'Uploading ...',this.state.uploaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.files.data&&this.props.files.data.upload.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,alt:item.filename,title:item.filename,className:'img img-responsive',src:item.url,style:{maxWidth:'100%'}});})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No Files Uploaded'),this.props.files.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.props.files.err)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.coupon.image_file,className:'btn btn-primary'},'Save'))));}}]);return UpdateBusinessImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_FilesRedux__["b" /* default */].filesUploadReset());},updateCoupon:function updateCoupon(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].businessUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateBusinessImage));

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadSpreadsheet=function(_React$Component){_inherits(DownloadSpreadsheet,_React$Component);function DownloadSpreadsheet(props){_classCallCheck(this,DownloadSpreadsheet);var _this=_possibleConstructorReturn(this,(DownloadSpreadsheet.__proto__||Object.getPrototypeOf(DownloadSpreadsheet)).call(this,props));_this.componentWillReceiveProps=function(newProps){if(_this.state.isSubmitted&&newProps.coupon.spreadsheet){_this._downloadLink(newProps.coupon.spreadsheet);}};_this.componentDidMount=function(){_this._submit();};_this._downloadLink=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var downloadLink=data;_this.setState({downloadLink:downloadLink});if(data){_this.props.closeModal();}};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState[field]=val;_this.setState(newState);};_this._submit=function(event){if(event)event.preventDefault();var _this$state=_this.state,type=_this$state.type,tag=_this$state.tag;var data={type:type,tag:tag};_this.setState({isSubmitted:true});_this.props.generateSpreadsheet(data);};_this.types=[{value:'BUSINESS',label:'Business'},{value:'GENERIC',label:'Generic'}];_this.state={type:'BUSINESS',tag:props.tag||'-',isSubmitted:false,downloadLink:null};return _this;}_createClass(DownloadSpreadsheet,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Download Spreadsheet')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},this.state.downloadLink?'The file is being downloaded':'Generating ...'));}}]);return DownloadSpreadsheet;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{generateSpreadsheet:function generateSpreadsheet(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__["b" /* default */].couponSpreadsheetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadSpreadsheet));

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadHistory=function(_React$Component){_inherits(DownloadHistory,_React$Component);function DownloadHistory(props){_classCallCheck(this,DownloadHistory);var _this=_possibleConstructorReturn(this,(DownloadHistory.__proto__||Object.getPrototypeOf(DownloadHistory)).call(this,props));_this.componentWillReceiveProps=function(newProps){if(_this.state.isSubmitted&&newProps.coupon.spreadsheet){_this._downloadLink(newProps.coupon.spreadsheet);}};_this.componentDidMount=function(){_this._submit();};_this._downloadLink=function(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var downloadLink=data;_this.setState({downloadLink:downloadLink});if(data){_this.props.closeModal();}};_this._inputChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);newState[field]=val;_this.setState(newState);};_this._submit=function(event){if(event)event.preventDefault();var _this$state=_this.state,type=_this$state.type,tag=_this$state.tag;var data={type:type,tag:tag};_this.setState({isSubmitted:true});_this.props.generateSpreadsheet(data);};_this.types=[{value:'BUSINESS',label:'Business'},{value:'GENERIC',label:'Generic'}];_this.state={type:'BUSINESS',tag:props.tag||'-',isSubmitted:false,downloadLink:null};return _this;}_createClass(DownloadHistory,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Download History')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},this.state.downloadLink?'The file is being downloaded':'Generating ...'));}}]);return DownloadHistory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{generateSpreadsheet:function generateSpreadsheet(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__["b" /* default */].historySpreadsheetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadHistory));

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IndividualModem__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IndividualAttraction__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IndividualInsurance__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IndividualEcommerce__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RenderTable__ = __webpack_require__(899);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndividualCoupon=function(_React$Component){_inherits(IndividualCoupon,_React$Component);function IndividualCoupon(props){_classCallCheck(this,IndividualCoupon);var _this=_possibleConstructorReturn(this,(IndividualCoupon.__proto__||Object.getPrototypeOf(IndividualCoupon)).call(this,props));_this.componentDidMount=function(){_this._fetchSelectors();};_this._fetchSelectors=function(){_this.props.getProductCustom();_this.props.getTravelPackage();_this.props.getInventoryCustom();};_this._fetchCouponItem=function(){_this.props.getCouponItemRequest({uuid:_this.props.uuid});};_this._toggleTab=function(tab){_this.setState({tab:tab});};_this._renderInterface=function(PRODUCT_TYPE){switch(PRODUCT_TYPE){case'modem':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IndividualModem__["a" /* default */],{fetchCouponItem:_this._fetchCouponItem,tag:_this.props.tag,uuid:_this.props.uuid,source_type:_this.props.source_type});case'attraction':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IndividualAttraction__["a" /* default */],{fetchCouponItem:_this._fetchCouponItem,tag:_this.props.tag,uuid:_this.props.uuid,source_type:_this.props.source_type});case'insurance':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IndividualInsurance__["a" /* default */],{fetchCouponItem:_this._fetchCouponItem,tag:_this.props.tag,uuid:_this.props.uuid,source_type:_this.props.source_type});case'inventory':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__IndividualEcommerce__["a" /* default */],{fetchCouponItem:_this._fetchCouponItem,tag:_this.props.tag,uuid:_this.props.uuid,source_type:_this.props.source_type});case'all':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this._selectTab(),_this._renderInterface(_this.state.tab));default:return null;}};_this._selectTab=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group ml-auto mb-4',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._toggleTab('modem');},className:'btn btn-primary '+(_this.state.tab==='modem'?'active':'')},'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._toggleTab('attraction');},className:'btn btn-primary '+(_this.state.tab==='attraction'?'active':'')},'Attraction'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._toggleTab('insurance');},className:'btn btn-primary '+(_this.state.tab==='insurance'?'active':'')},'Insurance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._toggleTab('inventory');},className:'btn btn-primary '+(_this.state.tab==='inventory'?'active':'')},'Ecommerce'));};_this.state={showModal:null,tab:'modem',selectedModem:'',selectedDestination:'',selectedAttraction:'',form:{discountable_id:'',discountable_type:''}};return _this;}_createClass(IndividualCoupon,[{key:'render',value:function render(){var _this2=this;var coupon=this.props.coupon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'75vw',height:'90vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Apply Individual Coupon for ',this.props.title,(coupon.fetching||coupon.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},coupon.fetching?'Loading ...':'Processing ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this._renderInterface(this.props.product_type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RenderTable__["a" /* default */],{closeModal:function closeModal(){return _this2.props.closeModal();},fetchCouponItem:this._fetchCouponItem}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.closeModal();},className:'btn btn-secondary mr-2'},'Close')))));}}]);return IndividualCoupon;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{getProductCustom:function getProductCustom(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCustomRequest());},getTravelPackage:function getTravelPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_InsuranceRedux__["b" /* default */].getTravelPackageRequest(data));},getInventoryCustom:function getInventoryCustom(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_InventoryRedux__["b" /* default */].getInventoryCustomRequest());},getCouponItemRequest:function getCouponItemRequest(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__["b" /* default */].getCouponItemRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(IndividualCoupon));

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import RenderTable from './RenderTable'
var IndividualModem=function(_React$Component){_inherits(IndividualModem,_React$Component);function IndividualModem(props){_classCallCheck(this,IndividualModem);var _this=_possibleConstructorReturn(this,(IndividualModem.__proto__||Object.getPrototypeOf(IndividualModem)).call(this,props));_this._selectChange=function(selectedModem){var form=Object.assign({},_this.state.form);form.discountable_id=selectedModem.value;_this.setState({selectedModem:selectedModem,form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);if(_this.props.source_type==='coupon-user'){var uuid=_this.props.uuid;var data={uuid:uuid,form:form};_this.props.postCouponItem(data);}else{var tag=_this.props.tag;var _data={tag:tag,form:form};_this.props.postCouponItemTag(_data);}setTimeout(function(){_this.props.fetchCouponItem();},500);};_this.state={selectedModem:null,form:{discountable_type:'product',discountable_id:''}};return _this;}_createClass(IndividualModem,[{key:'render',value:function render(){var _this2=this;var product=this.props.product;var modemPicker=[];product.custom.map(function(item,i){return modemPicker[i]={value:item.id,label:item.title};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:modemPicker,value:this.state.selectedModem,onChange:function onChange(selectedModem){return _this2._selectChange(selectedModem);},placeholder:'Select Wifi Product to add ...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Add')))));}}]);return IndividualModem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon,product:state.product};};var dispatchToProps=function dispatchToProps(dispatch){return{postCouponItem:function postCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemRequest(data));},postCouponItemTag:function postCouponItemTag(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemTagRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(IndividualModem));

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndividualAttraction=function(_React$Component){_inherits(IndividualAttraction,_React$Component);function IndividualAttraction(props){_classCallCheck(this,IndividualAttraction);var _this=_possibleConstructorReturn(this,(IndividualAttraction.__proto__||Object.getPrototypeOf(IndividualAttraction)).call(this,props));_this.componentDidMount=function(){_this.props.attractionSearch({q:_this.state.q,page:_this.state.page});};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalID});};_this._selectItem=function(item,modalID){_this.setState({detail:item});_this._toggleModal(modalID);};_this._changePage=function(page){_this.setState({page:page});var data={q:_this.state.q,page:page};_this.props.attractionSearch(data);};_this._inputChange=function(event){var val=event.target.value;_this.setState({q:val});};_this._search=function(event){event.preventDefault();var data={q:_this.state.q,page:1};_this.props.attractionSearch(data);};_this._submit=function(){var form=Object.assign({},_this.state.form);form.discountable_id=_this.state.detail.id;if(_this.props.source_type==='coupon-user'){var uuid=_this.props.uuid;var data={uuid:uuid,form:form};_this.props.postCouponItem(data);}else{var tag=_this.props.tag;var _data={tag:tag,form:form};_this.props.postCouponItemTag(_data);}setTimeout(function(){_this._toggleModal();_this.props.fetchCouponItem();},100);};_this._renderAttractionSelector=function(){var attraction=_this.props.attraction;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-group row mb-3',onSubmit:function onSubmit(event){return _this._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',name:'search',placeholder:'Search by Attraction name ...',className:'form-control',onChange:function onChange(event){return _this._inputChange(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Add'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!attraction.dataSearch.data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'3'},'No data')):attraction.dataSearch.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.provider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this._selectItem(item,'add-attraction');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},attraction.dataSearch.page&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.dataSearch.page||_this.state.page,itemsCountPerPage:10,totalItemsCount:attraction.dataSearch.total,pageRangeDisplayed:5,onChange:_this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:_this.state.showModal==='add-attraction',onClose:_this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Confirm Add Item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'For attraction: ',_this.state.detail.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',onClick:function onClick(){return _this._submit();}},'Confirm'))));};_this.state={showModal:null,detail:{},form:{discountable_type:'attraction',discountable_id:''},page:1,q:''};return _this;}_createClass(IndividualAttraction,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this._renderAttractionSelector()));}}]);return IndividualAttraction;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction,coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{attractionSearch:function attractionSearch(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__["b" /* default */].attractionSearchRequest(data));},postCouponItem:function postCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_CouponRedux__["b" /* default */].postCouponItemRequest(data));},postCouponItemTag:function postCouponItemTag(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_CouponRedux__["b" /* default */].postCouponItemTagRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(IndividualAttraction));

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndividualInsurance=function(_React$Component){_inherits(IndividualInsurance,_React$Component);function IndividualInsurance(props){_classCallCheck(this,IndividualInsurance);var _this=_possibleConstructorReturn(this,(IndividualInsurance.__proto__||Object.getPrototypeOf(IndividualInsurance)).call(this,props));_this._selectChange=function(selectedInsurance){var form=Object.assign({},_this.state.form);form.discountable_id=selectedInsurance.value;_this.setState({selectedInsurance:selectedInsurance,form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);if(_this.props.source_type==='coupon-user'){var uuid=_this.props.uuid;var data={uuid:uuid,form:form};_this.props.postCouponItem(data);}else{var tag=_this.props.tag;var _data={tag:tag,form:form};_this.props.postCouponItemTag(_data);}setTimeout(function(){_this.props.fetchCouponItem();},500);};_this.state={selectedInsurance:null,form:{discountable_type:'insurance',discountable_id:''}};return _this;}_createClass(IndividualInsurance,[{key:'render',value:function render(){var _this2=this;var insurance=this.props.insurance;var insurancePicker=[];insurance.data.map(function(item,i){return insurancePicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:insurancePicker,value:this.state.selectedInsurance,onChange:function onChange(selectedInsurance){return _this2._selectChange(selectedInsurance);},placeholder:'Select Insurance to add...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Add')))));}}]);return IndividualInsurance;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon,insurance:state.insurance};};var dispatchToProps=function dispatchToProps(dispatch){return{postCouponItem:function postCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemRequest(data));},postCouponItemTag:function postCouponItemTag(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemTagRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(IndividualInsurance));

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IndividualEcommerce=function(_React$Component){_inherits(IndividualEcommerce,_React$Component);function IndividualEcommerce(props){_classCallCheck(this,IndividualEcommerce);var _this=_possibleConstructorReturn(this,(IndividualEcommerce.__proto__||Object.getPrototypeOf(IndividualEcommerce)).call(this,props));_this._changeTab=function(tab){_this.setState({tab:tab});};_this._selectChange=function(e,field){var form=Object.assign({},_this.state.form);if(field==='inventory'){form.discountable_id=e.value;form.discountable_type='inventory';_this.setState({selectedInventory:e,form:form});}else if(field==='category'){form.discountable_id=e.value;form.discountable_type='category';_this.setState({selectedCategory:e,form:form});}};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);if(_this.props.source_type==='coupon-user'){var uuid=_this.props.uuid;var data={uuid:uuid,form:form};_this.props.postCouponItem(data);}else{var tag=_this.props.tag;var _data={tag:tag,form:form};_this.props.postCouponItemTag(_data);}setTimeout(function(){_this.props.fetchCouponItem();},500);};_this.state={tab:'inventory',selectedInventory:null,selectedCategory:null,form:{discountable_type:'',discountable_id:''}};return _this;}_createClass(IndividualEcommerce,[{key:'render',value:function render(){var _this2=this;var _props=this.props,inventory=_props.inventory,category=_props.category;var inventoryPicker=[];inventory.custom.map(function(item,i){return inventoryPicker[i]={value:item.id,label:item.name};});var categoryPicker=[];category.data.map(function(item,i){return categoryPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-3',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._changeTab('inventory');},className:'btn btn-primary '+(this.state.tab==='inventory'?'active':'')},'Inventory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._changeTab('category');},className:'btn btn-primary '+(this.state.tab==='category'?'active':'')},'Category')),this.state.tab==='inventory'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:inventoryPicker,value:this.state.selectedInventory,onChange:function onChange(e){return _this2._selectChange(e,'inventory');},placeholder:'Select Ecommerce Product to add ...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Add')))),this.state.tab==='category'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:categoryPicker,value:this.state.selectedCategory,onChange:function onChange(e){return _this2._selectChange(e,'category');},placeholder:'Select Ecommerce Category to add ...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Add')))));}}]);return IndividualEcommerce;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon,category:state.category,inventory:state.inventory};};var dispatchToProps=function dispatchToProps(dispatch){return{postCouponItem:function postCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemRequest(data));},postCouponItemTag:function postCouponItemTag(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemTagRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(IndividualEcommerce));

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RenderTable=function(_React$Component){_inherits(RenderTable,_React$Component);function RenderTable(props){_classCallCheck(this,RenderTable);var _this=_possibleConstructorReturn(this,(RenderTable.__proto__||Object.getPrototypeOf(RenderTable)).call(this,props));_this.componentDidMount=function(){_this.props.fetchCouponItem();};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalID});if(!modalID){_this.props.fetchCouponItem();}};_this._selectItem=function(item,modalID){_this.setState({detail:item});_this._toggleModal(modalID);};_this._deleteCouponItem=function(couponUUID,couponItemId){var data={couponUUID:couponUUID,couponItemId:couponItemId};_this.props.deleteCouponItem(data);setTimeout(function(){_this._toggleModal();},500);};_this._catchDiscountableType=function(input){return input==='product'?'modem':input;};_this._renderTableBody=function(data){return data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{textTransform:'capitalize'}},_this._catchDiscountableType(item.discountable_type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this._renderTableRow(item.discountable_type,i)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._selectItem(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));});};_this._renderTableRow=function(type,i){var coupon=_this.props.coupon;switch(type){case'product':return coupon.couponitem[i].product.title;case'attraction':return coupon.couponitem[i].attraction.title;case'insurance':return coupon.couponitem[i].travel_package.name;case'inventory':return coupon.couponitem[i].inventory.name;case'category':return coupon.couponitem[i].category.name;default:return null;}};_this.state={showModal:null,detail:{}};return _this;}_createClass(RenderTable,[{key:'render',value:function render(){var _this2=this;var coupon=this.props.coupon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,(!coupon.fetching||!coupon.processing)&&coupon.couponitem&&coupon.couponitem.length>0?this._renderTableBody(coupon.couponitem):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'--No Data--'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='delete',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Confirm deletion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._toggleModal();},className:'btn btn-lg btn-secondary mr-2'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._deleteCouponItem(_this2.state.detail.coupon_id,_this2.state.detail.id);},className:'btn btn-lg btn-danger'},'Delete')))));}}]);return RenderTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteCouponItem:function deleteCouponItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].deleteCouponItemRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(RenderTable));

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponProviderRedux__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Coupon_CreateProvider__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Coupon_UpdateProvider__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Coupon_DeleteProvider__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Coupon_CreatePreset__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Coupon_UpdatePreset__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Coupon_DeletePreset__ = __webpack_require__(906);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageProvider=function(_React$Component){_inherits(ManageProvider,_React$Component);function ManageProvider(props){_classCallCheck(this,ManageProvider);var _this=_possibleConstructorReturn(this,(ManageProvider.__proto__||Object.getPrototypeOf(ManageProvider)).call(this,props));_this.componentDidMount=function(){_this._customFetch();};_this._customFetch=function(){if(_this.state.tab==='Provider'){_this.props.getCouponProvider();}else if(_this.state.tab==='Preset'){_this.props.getCouponPreset();}};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalID});if(!modalID){setTimeout(function(){_this._customFetch();},100);}};_this._resetSelector=function(item){item.provider_id===null?_this.setState({selectedProvider:null}):_this.setState({selectedProvider:{value:item.coupon_providers?item.coupon_providers.id:'',label:item.coupon_providers?item.coupon_providers.name:''}});};_this._selectItem=function(item,action){if(action==='update-preset'){_this._resetSelector(item);}_this.setState({detail:item});_this._toggleModal(action);};_this._changeTab=function(tab){_this.setState({tab:tab});setTimeout(function(){_this._customFetch();},100);};_this.state={selectedProvider:null,tab:'Provider',showModal:null,detail:{}};return _this;}_createClass(ManageProvider,[{key:'render',value:function render(){var _this2=this;var _props=this.props,couponProvider=_props.couponProvider,couponPreset=_props.couponPreset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title mr-auto'},'Manage ',this.state.tab,(couponProvider.fetching||couponProvider.processing||couponPreset.fetching||couponPreset.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),this.state.tab==='Provider'?!(couponProvider.fetching||couponProvider.processing)&&couponProvider.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},couponProvider.err):!(couponPreset.fetching||couponPreset.processing)&&couponPreset.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},couponProvider.err),this.state.tab==='Provider'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-provider');}},'Create Provider'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-preset');}},'Create Preset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-3',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='Provider'&&'active'),onClick:function onClick(){return _this2._changeTab('Provider');}},'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='Preset'&&'active'),onClick:function onClick(){return _this2._changeTab('Preset');}},'Preset')),this.state.tab==='Provider'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,couponProvider.data?couponProvider.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-provider');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-provider');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'3'},'-- No Data --'))))),this.state.tab==='Preset'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Card Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Provider Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Prefix'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,couponPreset.data?couponPreset.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.card_type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.coupon_providers?item.coupon_providers.name:'-- No Data --'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.prefix),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-preset');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-preset');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'5'},'-- No Data --'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-provider',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Coupon_CreateProvider__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-provider',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Coupon_UpdateProvider__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='delete-provider',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Coupon_DeleteProvider__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-preset',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Coupon_CreatePreset__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-preset',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Coupon_UpdatePreset__["a" /* default */],{selectedProvider:this.state.selectedProvider,detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='delete-preset',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Coupon_DeletePreset__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return ManageProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{couponProvider:state.couponProvider,couponPreset:state.couponPreset};};var dispatchToProps=function dispatchToProps(dispatch){return{getCouponProvider:function getCouponProvider(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponProviderRedux__["b" /* default */].getCouponProviderRequest(data));},getCouponPreset:function getCouponPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_CouponPresetRedux__["b" /* default */].getCouponPresetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageProvider));

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__ = __webpack_require__(97);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateProvider=function(_React$Component){_inherits(CreateProvider,_React$Component);function CreateProvider(props){_classCallCheck(this,CreateProvider);var _this=_possibleConstructorReturn(this,(CreateProvider.__proto__||Object.getPrototypeOf(CreateProvider)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.props.postCouponProvider(form);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:''}};return _this;}_createClass(CreateProvider,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title '},'Create Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:'text',placeholder:'Provider Name',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save')))));}}]);return CreateProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{postCouponProvider:function postCouponProvider(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].postCouponProviderRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateProvider));

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__ = __webpack_require__(97);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateProvider=function(_React$Component){_inherits(UpdateProvider,_React$Component);function UpdateProvider(props){_classCallCheck(this,UpdateProvider);var _this=_possibleConstructorReturn(this,(UpdateProvider.__proto__||Object.getPrototypeOf(UpdateProvider)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var id=_this.state.id;var data={form:form,id:id};_this.props.putCouponProvider(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={id:props.detail.id||'',form:{name:props.detail.name||''}};return _this;}_createClass(UpdateProvider,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Update Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:'text',placeholder:'Provider Name',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save')))));}}]);return UpdateProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{putCouponProvider:function putCouponProvider(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].putCouponProviderRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateProvider));

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__ = __webpack_require__(97);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteProvider=function(_React$Component){_inherits(DeleteProvider,_React$Component);function DeleteProvider(props){_classCallCheck(this,DeleteProvider);var _this=_possibleConstructorReturn(this,(DeleteProvider.__proto__||Object.getPrototypeOf(DeleteProvider)).call(this,props));_this._delete=function(event){event.preventDefault();var id=_this.props.detail.id;_this.props.deleteCouponProvider(id);setTimeout(function(){_this.props.closeModal();},250);};_this.state={};return _this;}_createClass(DeleteProvider,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Confirm deletion for:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Provider Name: ',this.props.detail.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._delete(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',type:'submit'},'Delete')))));}}]);return DeleteProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteCouponProvider:function deleteCouponProvider(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].deleteCouponProviderRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeleteProvider));

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreatePreset=function(_React$Component){_inherits(CreatePreset,_React$Component);function CreatePreset(props){_classCallCheck(this,CreatePreset);var _this=_possibleConstructorReturn(this,(CreatePreset.__proto__||Object.getPrototypeOf(CreatePreset)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._selectChange=function(selectedProvider){var form=Object.assign({},_this.state.form);form.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,form:form});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);_this.props.postCouponPreset(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={selectedProvider:null,form:{provider_id:'',card_type:'',prefix:''}};return _this;}_createClass(CreatePreset,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;// populate provider selector
var providerPicker=[];couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Create Preset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Card Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'',className:'form-control',value:this.state.form.card_type,required:true,onChange:function onChange(event){return _this2._inputChange(event,'card_type');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Prefix')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'',className:'form-control',value:this.state.form.prefix,required:true,onChange:function onChange(event){return _this2._inputChange(event,'prefix');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save')))));}}]);return CreatePreset;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{postCouponPreset:function postCouponPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].postCouponPresetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreatePreset));

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdatePreset=function(_React$Component){_inherits(UpdatePreset,_React$Component);function UpdatePreset(props){_classCallCheck(this,UpdatePreset);var _this=_possibleConstructorReturn(this,(UpdatePreset.__proto__||Object.getPrototypeOf(UpdatePreset)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._selectChange=function(selectedProvider){var form=Object.assign({},_this.state.form);form.provider_id=selectedProvider.value;_this.setState({selectedProvider:selectedProvider,form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var id=_this.props.detail.id;var data={id:id,form:form};_this.props.putCouponPreset(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={selectedProvider:props.selectedProvider||null,form:{provider_id:props.detail.provider_id||'',card_type:props.detail.card_type||'',prefix:props.detail.prefix||''}};return _this;}_createClass(UpdatePreset,[{key:'render',value:function render(){var _this2=this;var couponProvider=this.props.couponProvider;// populate provider selector
var providerPicker=[];couponProvider.data.map(function(item,i){return providerPicker[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Update Preset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.detail.coupon_providers?this.props.detail.coupon_providers.name:'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Coupon Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:providerPicker,value:this.state.selectedProvider,onChange:function onChange(selectedProvider){return _this2._selectChange(selectedProvider);},required:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Card Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'',className:'form-control',value:this.state.form.card_type,required:true,onChange:function onChange(event){return _this2._inputChange(event,'card_type');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Prefix')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'',className:'form-control',value:this.state.form.prefix,required:true,onChange:function onChange(event){return _this2._inputChange(event,'prefix');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save')))));}}]);return UpdatePreset;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{couponProvider:state.couponProvider};};var dispatchToProps=function dispatchToProps(dispatch){return{putCouponPreset:function putCouponPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].putCouponPresetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdatePreset));

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__ = __webpack_require__(116);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeletePreset=function(_React$Component){_inherits(DeletePreset,_React$Component);function DeletePreset(props){_classCallCheck(this,DeletePreset);var _this=_possibleConstructorReturn(this,(DeletePreset.__proto__||Object.getPrototypeOf(DeletePreset)).call(this,props));_this._delete=function(event){event.preventDefault();var id=_this.props.detail.id;_this.props.deleteCouponPreset(id);setTimeout(function(){_this.props.closeModal();},250);};_this.state={};return _this;}_createClass(DeletePreset,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete Preset')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Confirm deletion for:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Provider Name: ',this.props.detail.coupon_providers?this.props.detail.coupon_providers.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Card Type: ',this.props.detail.card_type||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Prefix: ',this.props.detail.prefix||'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._delete(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',type:'submit'},'Delete')))));}}]);return DeletePreset;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteCouponPreset:function deleteCouponPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].deleteCouponPresetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeletePreset));

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Coupon_ViewAffiliateHistory__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_AdvancedFilter__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Affiliate=function(_React$Component){_inherits(Affiliate,_React$Component);function Affiliate(props){_classCallCheck(this,Affiliate);var _this=_possibleConstructorReturn(this,(Affiliate.__proto__||Object.getPrototypeOf(Affiliate)).call(this,props));_initialiseProps.call(_this);_this.filters=[{type:'text',name:'User Name',placeholder:'User Name',field:'name'},{type:'selector',name:'Status',placeholder:'Status',field:'status',selectors:[{label:'All',value:''},{label:'Transfer Request',value:'process'},{label:'No Request',value:'non-process'}]}];_this.productType=[{label:'All',value:'all'},{label:'E-Commerce',value:'inventory'},{label:'Attraction',value:'attraction'},{label:'Wifi Product',value:'modem'},{label:'Insurance',value:'insurance'}];_this.state={tab:'affiliates-list',page:1,filter:{page:1},showModal:null,editMode:null,forceEditMode:false,detail:{},form:{general_affiliate_pisces_point:0,general_affiliate_pisces_recharger:0,general_affiliate_pisces_min_amount:0,general_affiliate_pisces_discount_type:'',general_affiliate_pisces_discount_value:0,general_affiliate_pisces_product_type:''// 'inventory', 'attraction', 'modem', 'all', 'insurance'
}};_this.discountType=[{label:'Price Cut',value:'PRICE_CUT'},{label:'Percentage Cut',value:'PERCENTAGE_CUT'}];return _this;}_createClass(Affiliate,[{key:'render',value:function render(){var _this2=this;var _props=this.props,coupon=_props.coupon,preset=_props.preset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'affiliate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},this.state.tab==='preset'?'Manage Sobat Affiliate Presets':'Sobat Affiliate User List',(coupon.fetching||coupon.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='affiliates-list'&&'active'),onClick:function onClick(){return _this2._changeTab('affiliates-list');}},'User List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='preset'&&'active'),onClick:function onClick(){return _this2._changeTab('preset');}},'Presets')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,this.state.tab==='affiliates-list'&&this._renderViewAffiliate(coupon),this.state.tab==='preset'&&this._renderAffiliatePreset(preset)));}}]);return Affiliate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3.props.getAffiliates();};this.componentDidUpdate=function(prevProps){if(_this3.props.dataPresetOrder!==prevProps.dataPresetOrder){_this3.props.getPreset();}};this._selectItem=function(modalID,item){_this3.setState({detail:item});_this3._toggleModal(modalID);};this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this3.state.form);form[field]=value;_this3.setState({form:form});};this._changeTab=function(args){_this3.setState({tab:args});};this._changePage=function(page){var filter=Object.assign({},_this3.state.filter,{page:page});_this3.setState({filter:filter});_this3._customFetch({page:page});};this._customFetch=function(filter,event){if(event)event.preventDefault();var params=Object.assign({},_this3.state.filter,filter);_this3.props.getAffiliates(params);};this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this3.setState({showModal:modalID});if(!modalID){_this3._customFetch();}};this._editMode=function(){var editModeID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var field=arguments[1];var preset=_this3.props.preset;if(editModeID!==null){var form=Object.assign({},_this3.state.form);form[field]=preset.dataPresetOrder[field];_this3.setState({form:form});}_this3.setState({editMode:editModeID,forceEditMode:!_this3.state.forceEditMode});};this._submit=function(field,value){var data=_defineProperty({},field,value);_this3.props.putPreset(data);setTimeout(function(){_this3._editMode();},500);};this._convertLabel=function(label){switch(label){case'all':return'All';case'inventory':return'E-Commerce';case'attraction':return'Attraction';case'modem':return'Wifi Product';case'insurance':return'Insurance';default:return null;}};this._renderAffiliatePreset=function(preset){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Preset Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Preset Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Points earned per sobat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_point'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control my-0',value:_this3.state.form.general_affiliate_pisces_point,onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_point');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_point',_this3.state.form.general_affiliate_pisces_point);}},'Submit'))):preset.dataPresetOrder.general_affiliate_pisces_point||'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.editMode==='pisces_point'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_point','general_affiliate_pisces_point');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Minimum sobat amount to redeem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_recharger'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control my-0',value:_this3.state.form.general_affiliate_pisces_recharger,onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_recharger');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_recharger',_this3.state.form.general_affiliate_pisces_recharger);}},'Submit'))):preset.dataPresetOrder.general_affiliate_pisces_recharger||'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this3.state.editMode==='pisces_recharger'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_recharger','general_affiliate_pisces_recharger');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Minimum transaction amount to redeem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_min_amount'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control my-0',value:_this3.state.form.general_affiliate_pisces_min_amount,onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_min_amount');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_min_amount',_this3.state.form.general_affiliate_pisces_min_amount);}},'Submit'))):Object(__WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__["a" /* default */])(preset.dataPresetOrder.general_affiliate_pisces_min_amount)||'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this3.state.editMode==='pisces_min_amount'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_min_amount','general_affiliate_pisces_min_amount');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Discount Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_discount_type'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:_this3.state.form.general_affiliate_pisces_discount_type,className:'form-control my-0',onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_discount_type',_this3.state.form.general_affiliate_pisces_discount_type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Discount Type'),_this3.discountType.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_discount_type',_this3.state.form.general_affiliate_pisces_discount_type);}},'Submit'))):preset.dataPresetOrder.general_affiliate_pisces_discount_type==='PRICE_CUT'?'Price Cut':preset.dataPresetOrder.general_affiliate_pisces_discount_type==='PERCENTAGE_CUT'?'Percentage Cut':'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this3.state.editMode==='pisces_discount_type'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_discount_type','general_affiliate_pisces_discount_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Discount Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_discount_value'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control my-0',value:_this3.state.form.general_affiliate_pisces_discount_value,onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_discount_value');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_discount_value',_this3.state.form.general_affiliate_pisces_discount_value);}},'Submit'))):Object(__WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__["a" /* default */])(preset.dataPresetOrder.general_affiliate_pisces_discount_value)||'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.editMode==='pisces_discount_value'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_discount_value','general_affiliate_pisces_discount_value');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'Discount Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{maxWidth:'100px'}},_this3.state.editMode==='pisces_product_type'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:_this3.state.form.general_affiliate_pisces_product_type,onChange:function onChange(event){return _this3._inputChange(event,'general_affiliate_pisces_product_type');}},_this3.productType.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:option.value},option.label);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this3._submit('general_affiliate_pisces_product_type',_this3.state.form.general_affiliate_pisces_product_type);}},'Submit'))):_this3._convertLabel(preset.dataPresetOrder.general_affiliate_pisces_product_type)||'Loading ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.editMode==='pisces_product_type'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._editMode();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times-circle'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this3.state.forceEditMode,className:'btn btn-primary',onClick:function onClick(){return _this3._editMode('pisces_product_type','general_affiliate_pisces_product_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))))))))));};this._renderAffiliateData=function(data){if(!data){return'- No Data -';}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,data.bank_name,' ',data.rekening);}};this._manipulateState=function(props){var obj=Object.assign({},_this3.state.filter);var filter=Object.assign({},obj,props);_this3.setState({filter:filter});};this._callback=function(event){if(event){event.preventDefault();}_this3.props.getAffiliates(_this3.state.filter);};this._renderViewAffiliate=function(coupon){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_AdvancedFilter__["a" /* default */],{filters:_this3.filters,callback:function callback(event){return _this3._callback(event);},manipulateState:function manipulateState(props){return _this3._manipulateState(props);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Bank Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Point'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Available Point'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Redemption Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,coupon.affiliates.data&&coupon.affiliates.data.length>0?coupon.affiliates.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.first_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this3._renderAffiliateData(item.coupon_affiliates)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.user_affiliates.is_request?'Transfer Request':'No Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.point),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.available_point),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info '+(item.user_affiliates.is_request?'boolean-red-badge':''),'data-badge':true,onClick:function onClick(){return _this3._selectItem('modal-view-HISTORY',item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}),' View')));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'8'},'- No Data -'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},coupon.affiliates&&coupon.affiliates.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:coupon.affiliates.page||_this3.state.filter.page,itemsCountPerPage:10,totalItemsCount:coupon.affiliates.total,pageRangeDisplayed:5,onChange:_this3._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:_this3.state.showModal==='modal-view-HISTORY',onClose:_this3._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Coupon_ViewAffiliateHistory__["a" /* default */],{detail:_this3.state.detail,closeModal:function closeModal(){return _this3._toggleModal();}})));};};var stateToProps=function stateToProps(state){return{preset:state.preset,coupon:state.coupon};};var dispatchToProps=function dispatchToProps(dispatch){return{getPreset:function getPreset(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_PresetRedux__["b" /* default */].presetOrderRequest());},getAffiliates:function getAffiliates(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_CouponRedux__["b" /* default */].getAffiliatesRequest(filter));},putPreset:function putPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_PresetRedux__["b" /* default */].presetOrderUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Affiliate));

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewAffiliateHistory=function(_React$Component){_inherits(ViewAffiliateHistory,_React$Component);function ViewAffiliateHistory(props){_classCallCheck(this,ViewAffiliateHistory);var _this=_possibleConstructorReturn(this,(ViewAffiliateHistory.__proto__||Object.getPrototypeOf(ViewAffiliateHistory)).call(this,props));_this._selectItem=function(modalID,item){if(modalID==='modal-input-transfer-amount'){_this.setState({detail:item,form:{transfer_amount:item.point}});}else{_this.setState({detail:item});}_this._toggleModal(modalID);};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(!modalID){_this.setState({detail:{}});}_this.setState({showModal:modalID});};_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event,UUID,USER_ID){event.preventDefault();var form=Object.assign({},_this.state.form);var uuid=UUID;form.user_id=USER_ID;var data={form:form,uuid:uuid};setTimeout(function(){_this.props.affiliateTransfer(data);},500);_this.props.closeModal();};_this.state={showModal:null,detail:{},form:{user_id:props.detail.user_redeem_histories.user_id,transfer_amount:undefined}};return _this;}_createClass(ViewAffiliateHistory,[{key:'render',value:function render(){var _this2=this;var detail=this.props.detail;var user_redeem_histories=detail.user_redeem_histories,coupon_affiliates=detail.coupon_affiliates;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'55vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Redemption Details')),coupon_affiliates!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Affiliate Details')),coupon_affiliates!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'User Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,coupon_affiliates.name||'- No Data -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Bank Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,coupon_affiliates.bank_name||'- No Data -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Bank Account Number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,coupon_affiliates.rekening||'- No Data -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Taxpayer Number (NPWP)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,coupon_affiliates.npwp||'- No Data -')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'View Coupon Usage History')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,coupon_affiliates.coupon_histories&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._selectItem('modal-coupon-histories',coupon_affiliates.coupon_histories);},className:'btn btn-primary'},'Click to View'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Redemption History')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Point'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Create Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Transfer'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,user_redeem_histories&&user_redeem_histories.length>0?user_redeem_histories.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.point),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.status==='redeem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Redeemed ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-circle'})),item.status==='paid'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Paid ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-circle'})),item.status==='process'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Processing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.created_at).format('DD MMM YYYY, h:mm:ss a')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.status==='process'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem('modal-input-transfer-amount',item);}},'Input Transfer Amount')):null));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'4'},'- No Data -')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-coupon-histories',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'90vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Coupon Usage History')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Order ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'User Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Use Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Final Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'User Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Transfer Request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Transfer Date'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.detail&&this.state.detail.length>0?this.state.detail.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order.order_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.user.first_name,' ',item.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_4_moment___default.a.unix(item.order.created_at).format('DD/MM/YYYY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_5__Utils_FormatMoney__["a" /* default */])(item.order.final_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order.user_destination&&item.order.user_destination.length>0?item.order.user_destination.toString():'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order.user_redeem_order_history.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order.user_redeem_order_history.length>0?item.order.user_redeem_order_history[0].transfer_status&&item.order.user_redeem_order_history[0].transfer_date:'- No transfer request yet -'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'6'},'- No Usage Data -')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:this._toggleModal,className:'btn btn-primary'},'Close'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-input-transfer-amount',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Submit transfer amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event,_this2.state.detail.id,_this2.state.detail.user_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Transfer Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:1,className:'form-control',value:this.state.form.transfer_amount,onChange:function onChange(event){return _this2._inputChange(event,'transfer_amount');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:this._toggleModal},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Submit')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',onClick:function onClick(){return _this2.props.closeModal();}},'Close')));}}]);return ViewAffiliateHistory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{affiliateTransfer:function affiliateTransfer(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CouponRedux__["b" /* default */].affiliateTransferRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewAffiliateHistory));

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isDecimal=function isDecimal(num){return num%1!==0;};/* harmony default export */ __webpack_exports__["a"] = (isDecimal);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_EllipsisModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Product_CountryList__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Product_FormCreate__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Product_ProductPreset__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Product_ProductVariants__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Product_UpdateContent__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Product_UpdateImage__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Utils_ConversionUtils__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filterData_json__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__filterData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__filterData_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ProductCampaign from '../Containers/Product/ProductCampaign'
var ProductPage=function(_React$Component){_inherits(ProductPage,_React$Component);function ProductPage(props){_classCallCheck(this,ProductPage);var _this=_possibleConstructorReturn(this,(ProductPage.__proto__||Object.getPrototypeOf(ProductPage)).call(this,props));_initialiseProps.call(_this);_this.branch=Object(__WEBPACK_IMPORTED_MODULE_17__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.currency=Object(__WEBPACK_IMPORTED_MODULE_17__Utils_PrivilegeUtils__["b" /* currentCurrency */])();_this.state={tab:'WifiProductList',showModal:null,filter:{sort:'title',page:1,q:'',iso_code:_this.branch,currency_code:_this.currency,status:''},detail:{}};return _this;}_createClass(ProductPage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,product=_props.product,preset=_props.preset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Wifi Product ',this.state.tab==='WifiProductList'?'List':'Preset',(product.fetching||product.processing||preset.fetchingPresetOrder)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},product.fetching?'Loading':'Processing',' ...')),this.state.tab==='WifiProductList'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._toggleModal('create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create New'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='WifiProductList'?'active':''),onClick:function onClick(){return _this2._changeTab('WifiProductList');}},'Product List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='WifiProductPreset'?'active':''),onClick:function onClick(){return _this2._changeTab('WifiProductPreset');}},'Preset')),this.state.tab==='WifiProductList'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__["a" /* default */],{filters:__WEBPACK_IMPORTED_MODULE_18__filterData_json___default.a.productFilters,manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._fetchProduct(event);}}))),this.state.tab==='WifiProductPreset'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Product_ProductPreset__["a" /* default */],null),this.state.tab==='WifiProductList'&&this._renderTable(product),this.state.tab==='WifiProductList'&&this._renderPagination(product),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Product_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='countryList',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Product_CountryList__["a" /* default */],{title:this.state.detail.title,uuid:this.state.detail.id,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='edit-content',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Product_UpdateContent__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='edit-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Product_UpdateImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='variants',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Product_ProductVariants__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Delete Product?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.state.detail.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete'))))));}}]);return ProductPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3.props.getProduct(_this3.state.filter);_this3.branch==='PH'&&_this3.props.getBranch();};this.componentDidUpdate=function(prevProps){if(_this3.props.dataPresetOrder!==prevProps.dataPresetOrder){_this3.props.getPreset();}};this._changeTab=function(tab){_this3.setState({tab:tab});};this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(!modalId)_this3._fetchProduct();_this3.setState({showModal:modalId});};this._fetchProduct=function(event){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this3.state.filter;if(event)event.preventDefault();_this3.props.getProduct(filter);};this._toggleSort=function(){var sort=_this3.state.filter.sort;if(sort==='title'){sort='-title';}else{sort='title';}var filter=Object.assign({},_this3.state.filter,{sort:sort});_this3.setState({filter:filter});_this3._fetchProduct(null,{sort:sort});};this._selectItem=function(item,action){_this3.setState({detail:item});_this3._toggleModal(action);};this._toggleField=function(item,field){var form={};var id=item.id;switch(field){case'status':item.status==='active'?form.status='inactive':form.status='active';break;case'use_dynamic_price':item.use_dynamic_price===1?form.use_dynamic_price=0:form.use_dynamic_price=1;break;default:break;}form.iso_code=item.iso_code;var data={id:id,form:form};_this3.props.updateProduct(data);setTimeout(function(){_this3._fetchProduct();},250);};this._changePage=function(page){var filter=Object.assign({},_this3.state.filter,{page:page});_this3.setState({filter:filter});_this3.props.getProduct(filter);};this._delete=function(){var id=_this3.state.detail.id;_this3.props.deleteProduct({id:id});setTimeout(function(){_this3._toggleModal();},250);};this._manipulateState=function(props){var filter=Object.assign({},_this3.state.filter,props);filter.page=1;// PAGINATION SAFETY RULE
if(props.iso_code){filter.currency_code=Object(__WEBPACK_IMPORTED_MODULE_15__Utils_ConversionUtils__["a" /* isoCodeConversion */])(props.iso_code);}_this3.setState({filter:filter});};this._renderTable=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(product.fetching||product.processing)&&product.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},product.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',role:'button',onClick:function onClick(){return _this3._toggleSort();}},'Title ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-'+(_this3.state.filter.sort==='-title'?'sort-amount-down':'sort-amount-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Normal Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Final Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Currency Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Allow Coupon?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',colSpan:'2'},'Dynamic Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!product.data||!product.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'13',className:'text-center'},'- NO DATA -')):product.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_EllipsisModal__["a" /* default */],{type:'string',descriptor:'Product Description',name:item.title,description:item.description||''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_16__Utils_FormatMoney__["a" /* default */])(item.normal_price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_16__Utils_FormatMoney__["a" /* default */])(item.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.currency_code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a,{checked:item.status==='active',onChange:function onChange(){return _this3._toggleField(item,'status');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.use_coupon===0?'Not Allowed':'Allow'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url,alt:'',className:'img img-responsive',height:'75px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a,{checked:item.use_dynamic_price===1,onChange:function onChange(){return _this3._toggleField(item,'use_dynamic_price');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this3._selectItem(item,'variants');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-list'}),' View')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this3._selectItem(item,'countryList');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-globe'}),' Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this3._selectItem(item,'edit-content');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this3._selectItem(item,'edit-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),' Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this3._selectItem(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}))))));};this._renderPagination=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},product.data&&product.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:product.data.page||_this3.state.filter.page,itemsCountPerPage:10,totalItemsCount:product.data.total,pageRangeDisplayed:5,onChange:_this3._changePage}));};};var stateToProps=function stateToProps(state){return{product:state.product,preset:state.preset};};var dispatchToProps=function dispatchToProps(dispatch){return{getProduct:function getProduct(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_14__Redux_ProductRedux__["b" /* default */].productRequest(filter));},deleteProduct:function deleteProduct(data){return dispatch(__WEBPACK_IMPORTED_MODULE_14__Redux_ProductRedux__["b" /* default */].productDeleteRequest(data));},getPreset:function getPreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_13__Redux_PresetRedux__["b" /* default */].presetOrderRequest(data));},updateProduct:function updateProduct(data){return dispatch(__WEBPACK_IMPORTED_MODULE_14__Redux_ProductRedux__["b" /* default */].productUpdateRequest(data));},getBranch:function getBranch(){return dispatch(__WEBPACK_IMPORTED_MODULE_13__Redux_PresetRedux__["b" /* default */].getBranchRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ProductPage));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CountryList=function(_React$Component){_inherits(CountryList,_React$Component);function CountryList(props){_classCallCheck(this,CountryList);var _this=_possibleConstructorReturn(this,(CountryList.__proto__||Object.getPrototypeOf(CountryList)).call(this,props));_this.componentDidMount=function(){_this._getProductCountry();};_this._getProductCountry=function(){var data={uuid:_this.props.uuid};_this.props.get(data);};_this._inputChange=function(event,field){var val=event.target.value;if(event.target.type==='number'){val=parseFloat(val);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._selectChange=function(selectedCountry){var form=Object.assign({},_this.state.form);form.country_id=selectedCountry.value;_this.setState({selectedCountry:selectedCountry,form:form});};_this._delete=function(uuid){var data={uuid:uuid};_this.props.delete(data);setTimeout(function(){_this._getProductCountry();},500);};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.props.submit(form);setTimeout(function(){_this._getProductCountry();},500);};var countries=[];props.country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});_this.countries=countries;_this.state={selectedCountry:null,form:{product_id:props.uuid,country_id:''}};return _this;}_createClass(CountryList,[{key:'render',value:function render(){var _this2=this;var product=this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},this.props.title,' Country List',(product.fetching||product.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},product.fetching?'Loading ...':'Processing ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:this.countries,value:this.state.selectedCountry,onChange:function onChange(selectedCountry){return _this2._selectChange(selectedCountry);},placeholder:'Select country to assign ...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Assign')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!product.country||product.country.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'2'},'-- No Data --')):product.country.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.country.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._delete(item.id);},className:'btn btn-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.closeModal();},className:'btn btn-secondary mr-2'},'Close'))));}}]);return CountryList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{country_list:state.preset.dataCountries,product:state.product// country: state.product.country
};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCountryRequest(data));},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductCountryRequest(data));},delete:function _delete(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductCountryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CountryList));

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','product');data.append('product_type',_this.state.form.product_type);_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);var val=event.target.value;// 'deprecate' the validation below
// if (event.target.type === 'number') {
//   val = parseFloat(val)
// }
form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);if(Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()==='PH'){form.description_ind=form.description_eng;}_this.props.submit(form);setTimeout(function(){_this.props.closeModal();},250);};var currencyCode=function currencyCode(){var branch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])();switch(branch){case'ID':return'IDR';case'PH':return'PHP';default:return null;}};_this.CCSelector=[{value:'IDR',label:'IDR',restriction:['PH']},// { value: 'SGD', label: 'SGD', restriction: ['PH'] },
{value:'USD',label:'USD',restriction:['PH']},{value:'PHP',label:'PHP'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={form:{title:'',description:'',description_ind:'',description_eng:'',short_desc_id:'',short_desc_en:'',meta_description:'',meta_title:'',normal_price:0,price:0,currency_code:currencyCode(),image_file:'',product_type:'modem',status:'active',use_dynamic_price:0,divisor:1,use_coupon:'1',quota:'',short_code:'',iso_code:Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])(),details:{country_id:''}},file:null,uploaded:false};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Product')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Product Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Key Passpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Key Passpod',required:true,className:'form-control',value:this.state.form.description,onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'ID Product Description',className:'form-control',value:this.state.form.description_ind,onChange:function onChange(event){return _this2._inputChange(event,'description_ind');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'EN Product Description',className:'form-control',value:this.state.form.description_eng,onChange:function onChange(event){return _this2._inputChange(event,'description_eng');}}))),Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Description (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'',className:'form-control',value:this.state.form.short_desc_id,onChange:function onChange(event){return _this2._inputChange(event,'short_desc_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Description (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'',className:'form-control',value:this.state.form.short_desc_en,onChange:function onChange(event){return _this2._inputChange(event,'short_desc_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Meta-title',className:'form-control',value:this.state.form.meta_title,onChange:function onChange(event){return _this2._inputChange(event,'meta_title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Meta-description',className:'form-control',value:this.state.form.meta_description,onChange:function onChange(event){return _this2._inputChange(event,'meta_description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Currency Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.currency_code,onChange:function onChange(event){return _this2._inputChange(event,'currency_code');}},this.CCSelector.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Normal Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',required:true,value:this.state.form.normal_price,onChange:function onChange(event){return _this2._inputChange(event,'normal_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Final Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',required:true,value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.product_type,onChange:function onChange(event){return _this2._inputChange(event,'product_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'modem'},'Modem')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.status,onChange:function onChange(event){return _this2._inputChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'active'},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'inactive'},'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Dynamic Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.use_dynamic_price,onChange:function onChange(event){return _this2._inputChange(event,'use_dynamic_price');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:1},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Divisor')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',min:'1',required:true,value:this.state.form.divisor,onChange:function onChange(event){return _this2._inputChange(event,'divisor');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Allow Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.use_coupon,onChange:function onChange(event){return _this2._inputChange(event,'use_coupon');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Allowed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'Not Allowed')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Quota')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Product quota',type:'text',className:'form-control',value:this.state.form.quota,onChange:function onChange(event){return _this2._inputChange(event,'quota');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Short product code (3 to 4 letters)',type:'text',minLength:3,maxLength:4,className:'form-control',value:this.state.form.short_code,onChange:function onChange(event){return _this2._inputChange(event,'short_code');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'270x160'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'product',product_type:this.state.form.product_type},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.image_file,className:'btn btn-primary'},'Save')))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].productCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// deprecate after merge with PH
var ProductPreset=function(_React$Component){_inherits(ProductPreset,_React$Component);function ProductPreset(props){_classCallCheck(this,ProductPreset);var _this=_possibleConstructorReturn(this,(ProductPreset.__proto__||Object.getPrototypeOf(ProductPreset)).call(this,props));_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);var value=event.target.value;form[field]=value;_this.setState({form:form});};_this._editMode=function(forceEditMode,field,value){var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({editMode:field,forceEditMode:forceEditMode,form:form});};_this._submit=function(field){var data={};if(field==='deposit'){data={country:_this.state.form.country,deposit_country:_this.state.form.deposit,currency_code:_this.state.form.currency_code};}else if(field==='general_discount_extend_wifi'){data={general_discount_extend_wifi:_this.state.form.general_discount_extend_wifi};}else if(field==='COD'){data={country:_this.state.form.country,product:field,value:_this.state.form.COD};}if(field==='COD'){_this.props.updateBranch(data);}else{_this.props.submit(data);}setTimeout(function(){_this._editMode(false);},500);};_this._renderRow=function(data,field,title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},title),_this.state.editMode===field?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control my-0',type:field==='COD'?'text':'number',min:field==='general_discount_extend_wifi'?0:null,max:field==='general_discount_extend_wifi'?100:null,value:_this.state.form[field],onChange:function onChange(event){return _this._inputChange(event,field);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mb-0',onClick:function onClick(){return _this._submit(field);}},'Submit')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},field==='deposit'?''+Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(data[field]):field==='general_discount_extend_wifi'?data[field]+' %':data[field]),_this.state.editMode===field?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._editMode(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this.state.forceEditMode,className:'btn btn-primary '+(_this.state.forceEditMode?'btn-disabled':''),onClick:function onClick(){return _this._editMode(true,field,data[field]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))));};_this.componentDidMount=function(){_this.props.get();};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.currency=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["b" /* currentCurrency */])();_this.state={form:{COD:_this.branch==='PH'?props.preset.dataBranch[_this.branch].COD:'',general_discount_extend_wifi:props.preset.dataPresetOrder.general_discount_extend_wifi,deposit:'',// still needed for placeholder
country:_this.branch,deposit_country:props.preset.dataPresetOrder.deposit_country[_this.branch].deposit,currency_code:Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["b" /* currentCurrency */])()},editMode:null,forceEditMode:false};return _this;}_createClass(ProductPreset,[{key:'render',value:function render(){var preset=this.props.preset;var dataPresetOrder=preset.dataPresetOrder,dataBranch=preset.dataBranch;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Preset Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Preset Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Preset Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.branch==='ID'&&this._renderRow(dataPresetOrder,'general_discount_extend_wifi','Extend Wifi Discount'),this._renderRow(dataPresetOrder.deposit_country[this.branch],'deposit','Deposit'),this.branch==='PH'&&this._renderRow(dataBranch[this.branch],'COD','COD Payment Text')))));}}]);return ProductPreset;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{preset:state.preset};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_PresetRedux__["b" /* default */].presetOrderRequest());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_PresetRedux__["b" /* default */].presetOrderUpdateRequest(data));},updateBranch:function updateBranch(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_PresetRedux__["b" /* default */].updateBranchRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ProductPreset));

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ProductVariantStocks__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductVariantDelete__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_toggle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductVariants=function(_React$Component){_inherits(ProductVariants,_React$Component);function ProductVariants(props){_classCallCheck(this,ProductVariants);var _this=_possibleConstructorReturn(this,(ProductVariants.__proto__||Object.getPrototypeOf(ProductVariants)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var data={product_id:_this.product_id};_this.props.getProductVariant(data);};_this._resetForm=function(){var form=Object.assign({},_this.state.form);var bookingToggle=false;form.start_date=null;form.end_date=null;form.use_booking_period=0;form.platform='all';form.date_period_start=null;form.date_period_end=null;_this.setState({form:form,bookingToggle:bookingToggle});if(_this.state.editMode!==null){_this._forceEditMode(null,null);}};_this._handleDateTime=function(date,field){var form=Object.assign({},_this.state.form);if(field==='start_date'){if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.state.form.end_date)){form.end_date=__WEBPACK_IMPORTED_MODULE_0_moment___default()(date).add(1,'day');}}if(field==='date_period_start'){if(__WEBPACK_IMPORTED_MODULE_0_moment___default()(date)>=__WEBPACK_IMPORTED_MODULE_0_moment___default()(_this.state.form.date_period_end)){form.date_period_end=date;}}form[field]=date;_this.setState({form:form});};_this._handleToggle=function(event){var form=Object.assign({},_this.state.form);var bookingToggle=event.target.checked;if(bookingToggle){form.use_booking_period=1;}else if(!bookingToggle){form.use_booking_period=0;form.date_period_start=null;form.date_period_end=null;}_this.setState({form:form,bookingToggle:bookingToggle});};_this._handleSelectChange=function(event,field){var form=Object.assign({},_this.state.form);var value=event.target.value;form[field]=value;_this.setState({form:form});};_this._onSubmit=function(event){if(event)event.preventDefault();var form=Object.assign({},_this.state.form);form.start_date=__WEBPACK_IMPORTED_MODULE_0_moment___default()(form.start_date).format(_this.dateFormat);form.end_date=__WEBPACK_IMPORTED_MODULE_0_moment___default()(form.end_date).format(_this.dateFormat);form.date_period_start!==null?form.date_period_start=__WEBPACK_IMPORTED_MODULE_0_moment___default()(form.date_period_start).format(_this.dateFormat):form.date_period_start=null;form.date_period_end!==null?form.date_period_end=__WEBPACK_IMPORTED_MODULE_0_moment___default()(form.date_period_end).format(_this.dateFormat):form.date_period_end=null;if(_this.state.editMode===null){var data={form:form};_this.props.postProductVariant(data);}else if(_this.state.editMode!==null){var _data={form:form,id:_this.state.detail.id};_this.props.putProductVariant(_data);}setTimeout(function(){_this._resetForm();},300);};_this._selectItem=function(item,modalID,editID){_this.setState({detail:item});if(modalID!==null){_this._toggleModal(modalID);}else if(editID!==null){_this._forceEditMode(item,editID);}};_this._forceEditMode=function(item,editID){_this.setState({editMode:editID});var form=Object.assign({},_this.state.form);if(editID){form.start_date=item.start_date;form.end_date=item.end_date;form.use_booking_period=item.use_booking_period;item.use_booking_period===1&&item.date_period_start?form.date_period_start=item.date_period_start:form.date_period_start=null;item.use_booking_period===1&&item.date_period_end?form.date_period_end=item.date_period_end:form.date_period_end=null;form.platform=item.platform;_this.setState({form:form,bookingToggle:item.use_booking_period===1});}if(!editID){form.start_date=null;form.end_date=null;form.use_booking_period=0;form.platform='all';form.date_period_start=null;form.date_period_end=null;_this.setState({form:form,bookingToggle:false});}};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalID});};_this._renderHeader=function(data,title,small){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'title'},title,(data.fetching||data.processing)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'badge badge-info ml-2'},data.fetching?'Loading ...':data.processing?'Processing ...':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,small)),data.err&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'alert alert-danger'},data.err));};_this._renderTable=function(variant){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__["a" /* default */],{colSpan:8,header:[{field:'Platform'},{field:'Travel Start Date'},{field:'Travel End Date'},{field:'Booking Period Start'},{field:'Booking Period End'},{field:'Stock'},{field:'Edit'},{field:'Delete'}],body:variant&&variant.length>0&&variant.map(function(item){return[{field:item.platform},{field:item.start_date},{field:item.end_date},{field:item.date_period_start||'-'},{field:item.date_period_end||'-'},{field:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-info '+(item.product_variant_stocks.length>0?'':'boolean-red-badge'),'data-badge':true,disabled:_this.state.editMode!==null,onClick:function onClick(){return _this._selectItem(item,'product-variant-stocks-modal',null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-list mr-2'}),'Manage')},{field:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',disabled:_this.state.editMode!==null,onClick:function onClick(){return _this._selectItem(item,null,item.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-danger',disabled:_this.state.editMode!==null,onClick:function onClick(){return _this._selectItem(item,'delete-modal',null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})});};_this._renderSubTable=function(PRODUCT_VARIANT_STOCKS){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul',null,PRODUCT_VARIANT_STOCKS.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li',{key:i},'qty: ',item.qty,' price: ',item.price);}));};_this._renderForm=function(formLines){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:'mb-3',onSubmit:function onSubmit(event){return _this._onSubmit(event);}},formLines.map(function(lines,i){return _this._renderFormLine(i,lines.field,lines.label,lines.type);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-9 text-right'},_this.state.editMode!==null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this._forceEditMode(null,null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-times'}),' Cancel'),_this.state.editMode!==null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-save'}),' Save'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add'))));};_this._renderFormLine=function(i,field,label,type){var beforeDate=null;var today=__WEBPACK_IMPORTED_MODULE_0_moment___default()();var yesterday=__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1,'day');if(field==='end_date'){beforeDate=_this.state.form.start_date;}else if(field==='date_period_end'){beforeDate=_this.state.form.date_period_start;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:i,className:'form-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{className:'control-label'},label)),type==='datetime'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datetime___default.a,{value:_this.state.form[field],inputProps:{placeholder:'Select '+label+' ...',disabled:(field==='date_period_start'||field==='date_period_end')&&!_this.state.bookingToggle},closeOnSelect:true,dateFormat:_this.dateFormat,isValidDate:field==='start_date'?function(current){return current.isAfter(today);}:field==='date_period_start'?function(current){return current.isAfter(yesterday);}:field==='date_period_end'?function(current){return current.isSameOrAfter(beforeDate);}:function(current){return current.isAfter(beforeDate);},timeFormat:false,onChange:function onChange(date){return _this._handleDateTime(date,field);}})),type==='toggle'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_toggle___default.a,{checked:_this.state.bookingToggle,onChange:function onChange(event){return _this._handleToggle(event);}})),type==='select'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:_this.state.form[field],onChange:function onChange(event){return _this._handleSelectChange(event,field);},className:'form-control'},_this.platforms.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))));};_this.product_id=props.detail.id;_this.title=props.detail.title;_this.dateFormat='YYYY-MM-DD';_this.formLines=[{type:'select',label:'Platform',field:'platform'},{type:'datetime',label:'Travel Start Date',field:'start_date'},{type:'datetime',label:'Travel End Date',field:'end_date'},{type:'toggle',label:'Use Booking Period?',field:'use_booking_period'},{type:'datetime',label:'Booking Period Start',field:'date_period_start'},{type:'datetime',label:'Booking Period End',field:'date_period_end'}];_this.platforms=[{value:'all',label:'ALL'},{value:'web',label:'WEB'},{value:'all-mobile',label:'ALL-MOBILE'},{value:'android',label:'ANDROID'},{value:'ios',label:'IOS'}];_this.state={form:{product_id:_this.product_id,start_date:null,end_date:null,use_booking_period:0,platform:'all',date_period_start:null,date_period_end:null},bookingToggle:false,showModal:null,editMode:null,detail:{}};return _this;}_createClass(ProductVariants,[{key:'render',value:function render(){var _this2=this;var product=this.props.product;var variant=product.variant;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'section',style:{width:'70vw',height:'80vh'}},this._renderHeader(product,'Manage Dynamic Price',this.title),this._renderForm(this.formLines),this._renderTable(variant),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ModalBase,Object.assign({},this.props,{detail:this.state.detail,showModal:this.state.showModal,closeModal:function closeModal(){return _this2._toggleModal(null);}})));}}]);return ProductVariants;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var ModalBase=function(_React$Component2){_inherits(ModalBase,_React$Component2);function ModalBase(props){_classCallCheck(this,ModalBase);var _this3=_possibleConstructorReturn(this,(ModalBase.__proto__||Object.getPrototypeOf(ModalBase)).call(this,props));_this3.state={};return _this3;}_createClass(ModalBase,[{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,onClose:function onClose(){return _this4.props.closeModal();},open:this.props.showModal==='delete-modal',classNames:{modal:'modal-large'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ProductVariantDelete__["a" /* default */],Object.assign({},this.props,{detail:this.props.detail}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,onClose:function onClose(){return _this4.props.closeModal();},open:this.props.showModal==='product-variant-stocks-modal',classNames:{modal:'modal-large'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ProductVariantStocks__["a" /* default */],Object.assign({},this.props,{detail:this.props.detail}))));}}]);return ModalBase;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var stateToProps=function stateToProps(state){return{product:state.product};};var dispatchToProps=function dispatchToProps(dispatch){return{getProductVariant:function getProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].getProductVariantRequest(data));},postProductVariant:function postProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].postProductVariantRequest(data));},putProductVariant:function putProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].putProductVariantRequest(data));},deleteProductVariant:function deleteProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].deleteProductVariantRequest(data));},getProductVariantItem:function getProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].getProductVariantItemRequest(data));},postProductVariantItem:function postProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].postProductVariantItemRequest(data));},deleteProductVariantItem:function deleteProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_ProductRedux__["b" /* default */].deleteProductVariantItemRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ProductVariants));

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductVariantStocks=function(_React$Component){_inherits(ProductVariantStocks,_React$Component);function ProductVariantStocks(props){_classCallCheck(this,ProductVariantStocks);var _this=_possibleConstructorReturn(this,(ProductVariantStocks.__proto__||Object.getPrototypeOf(ProductVariantStocks)).call(this,props));_this.componentDidMount=function(){_this._fetchProductVariantItem();};_this._fetchProductVariantItem=function(){_this.props.getProductVariantItem({variant_id:_this.variant_id});};_this._handleInputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._onSubmit=function(event){if(event){event.preventDefault();}var form=Object.assign({},_this.state.form);var data={variant_id:_this.variant_id,form:form};_this.props.postProductVariantItem(data);setTimeout(function(){_this._resetForm();},300);};_this._resetForm=function(){var form=Object.assign({},_this.state.form);form.qty='';form.price='';_this.setState({form:form});};_this._onDelete=function(id){var data={productvariantitemuuid:id};_this.props.deleteProductVariantItem(data);setTimeout(function(){_this._toggleModal(null);},300);};_this._selectItem=function(item,modalID){_this.setState({detail:item});_this._toggleModal(modalID);};_this._toggleModal=function(modalID){_this.setState({showModal:modalID});};_this._renderHeader=function(data,title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},title,(data.fetching||data.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},data.fetching?'Loading ...':data.processing?'Processing ...':''))),data.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},data.err));};_this._renderForm=function(formLines){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'mb-3',onSubmit:function onSubmit(event){return _this._onSubmit(event);}},formLines.map(function(lines,i){return _this._renderFormLine(i,lines.field,lines.label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add Stock'))));};_this._renderFormLine=function(i,field,label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:_this.state.form[field],type:'number',min:0,required:true,placeholder:'Insert '+label+' ...',className:'form-control',onChange:function onChange(event){return _this._handleInputChange(event,field);}}))));};_this._renderTable=function(product){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_AdvancedTable__["a" /* default */],{colSpan:3,header:[{field:'Quantity'},{field:'Price'},{field:'Delete'}],body:product.variant_item&&product.variant_item.length>0&&product.variant_item.map(function(item,i){return[{field:item.qty},{field:Object(__WEBPACK_IMPORTED_MODULE_5__Utils_FormatMoney__["a" /* default */])(item.price)},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',type:'button',onClick:function onClick(){return _this._selectItem(item,'delete-product-variant-stocks');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})});};_this.variant_id=_this.props.detail.id;_this.formLines=[{field:'price',label:'Price'},{field:'qty',label:'Quantity'}];_this.state={detail:{},form:{price:'',qty:''},showModal:null};return _this;}_createClass(ProductVariantStocks,[{key:'render',value:function render(){var _this2=this;var product=this.props.product;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'60vw'}},this._renderHeader(product,'Manage Dynamic Price Stock'),this._renderForm(this.formLines),this._renderTable(product),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{onClose:function onClose(){return _this2._toggleModal(null);},classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='delete-product-variant-stocks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Delete Dynamic Price Stock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Quantity Left: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.detail.qty)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Price: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.state.detail.price))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._onDelete(_this2.state.detail.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),' Delete')))))));}}]);return ProductVariantStocks;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{product:state.product};};var dispatchToProps=function dispatchToProps(dispatch){return{getProductVariant:function getProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].getProductVariantRequest(data));},postProductVariant:function postProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].postProductVariantRequest(data));},putProductVariant:function putProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].putProductVariantRequest(data));},deleteProductVariant:function deleteProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].deleteProductVariantRequest(data));},getProductVariantItem:function getProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].getProductVariantItemRequest(data));},postProductVariantItem:function postProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].postProductVariantItemRequest(data));},deleteProductVariantItem:function deleteProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].deleteProductVariantItemRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ProductVariantStocks));

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductVariantDelete=function(_React$Component){_inherits(ProductVariantDelete,_React$Component);function ProductVariantDelete(props){_classCallCheck(this,ProductVariantDelete);var _this=_possibleConstructorReturn(this,(ProductVariantDelete.__proto__||Object.getPrototypeOf(ProductVariantDelete)).call(this,props));_this._onDelete=function(){var data={id:_this.props.detail.id,product_id:_this.props.detail.product_id};_this.props.deleteProductVariant(data);setTimeout(function(){_this.props.closeModal();},350);};_this.state={};return _this;}_createClass(ProductVariantDelete,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Delete Dynamic Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Start Date: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.detail.start_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'End Date: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.detail.end_date))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._onDelete();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),' Delete'))));}}]);return ProductVariantDelete;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{product:state.product};};var dispatchToProps=function dispatchToProps(dispatch){return{getProductVariant:function getProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].getProductVariantRequest(data));},postProductVariant:function postProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].postProductVariantRequest(data));},putProductVariant:function putProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].putProductVariantRequest(data));},deleteProductVariant:function deleteProductVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].deleteProductVariantRequest(data));},getProductVariantItem:function getProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].getProductVariantItemRequest(data));},postProductVariantItem:function postProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].postProductVariantItemRequest(data));},deleteProductVariantItem:function deleteProductVariantItem(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].deleteProductVariantItemRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ProductVariantDelete));

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 *  DO NOT REMOVE ANYTHING RELATED TO COUNTRY BELOW.
 *  Country as a single data is now deprecated, but may be reverted anytime.
 */// import CountryList from './CountryList'
// import Select from 'react-select'
// import findKey from 'lodash/findKey'
var UpdateContent=function(_React$Component){_inherits(UpdateContent,_React$Component);function UpdateContent(props){_classCallCheck(this,UpdateContent);// let countries = []
// props.country_list.map((item, i) => {
//   countries[i] = {
//     value: item.id,
//     label: item.name
//   }
//   return countries
// })
// this.countries = countries
// let country_id = props.detail.details ? props.detail.details.country_id : ''
// const key = findKey(countries, ['value', country_id])
var _this=_possibleConstructorReturn(this,(UpdateContent.__proto__||Object.getPrototypeOf(UpdateContent)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value;// 'deprecate' the validation below
// if (event.target.type === 'number') {
//   val = parseInt(val, 10)
// }
var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);if(Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])()==='PH'){form.description_ind=form.description_eng;}var data={id:_this.props.detail.id,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};var currencyCode=function currencyCode(){var branch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])();switch(branch){case'ID':return'IDR';case'PH':return'PHP';default:return null;}};_this.CCSelector=[{value:'IDR',label:'IDR',restriction:['PH']},// { value: 'SGD', label: 'SGD', restriction: ['PH'] },
{value:'USD',label:'USD',restriction:['PH']},{value:'PHP',label:'PHP'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={showModal:null,form:{title:props.detail.title||'',description:props.detail.description||'',description_ind:props.detail.description_ind||'',description_eng:props.detail.description_eng||'',short_desc_id:props.detail.short_desc_id||'',short_desc_en:props.detail.short_desc_en||'',meta_description:props.detail.meta_description||'',meta_title:props.detail.meta_title||'',normal_price:props.detail.normal_price||0,price:props.detail.price||0,currency_code:props.detail.currency_code||currencyCode(),image_file:props.detail.image_file||'',product_type:props.detail.product_type||'modem',status:props.detail.status||'active',divisor:props.detail.divisor||1,use_coupon:props.detail.use_coupon||'1',quota:props.detail.quota||'',short_code:props.detail.short_code||'',iso_code:props.detail.iso_code||Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])(),details:{country_id:props.detail.details?props.detail.details.country_id:''}},// country: countries[key] || '',
file:null,uploaded:false};return _this;}// _countryChange = (country) => {
//   let form = { ...this.state.form }
//   form.details.country_id = country.value
//   this.setState({ country, form })
// }
_createClass(UpdateContent,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Product Content')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Product Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Key Passpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Key Passpod',className:'form-control',value:this.state.form.description,onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Indonesian Product Description',className:'form-control',value:this.state.form.description_ind,onChange:function onChange(event){return _this2._inputChange(event,'description_ind');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'English Product Description',className:'form-control',value:this.state.form.description_eng,onChange:function onChange(event){return _this2._inputChange(event,'description_eng');}}))),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Description (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'',className:'form-control',value:this.state.form.short_desc_id,onChange:function onChange(event){return _this2._inputChange(event,'short_desc_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Description (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'',className:'form-control',value:this.state.form.short_desc_en,onChange:function onChange(event){return _this2._inputChange(event,'short_desc_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Meta-title',className:'form-control',value:this.state.form.meta_title,onChange:function onChange(event){return _this2._inputChange(event,'meta_title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Meta-description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Meta-description',className:'form-control',value:this.state.form.meta_description,onChange:function onChange(event){return _this2._inputChange(event,'meta_description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Currency Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.currency_code,onChange:function onChange(event){return _this2._inputChange(event,'currency_code');}},this.CCSelector.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Normal Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.form.normal_price,onChange:function onChange(event){return _this2._inputChange(event,'normal_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Final Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.product_type,onChange:function onChange(event){return _this2._inputChange(event,'product_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'modem'},'Modem')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.status,onChange:function onChange(event){return _this2._inputChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'active'},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'inactive'},'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Divisor')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',min:'1',required:true,value:this.state.form.divisor,onChange:function onChange(event){return _this2._inputChange(event,'divisor');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Allow Coupon')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',required:true,value:this.state.form.use_coupon,onChange:function onChange(event){return _this2._inputChange(event,'use_coupon');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'1'},'Allowed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'0'},'Not Allowed')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Quota')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Product quota',type:'text',className:'form-control',value:this.state.form.quota,onChange:function onChange(event){return _this2._inputChange(event,'quota');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Short Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Short product code (3 to 4 letters)',type:'text',minLength:3,maxLength:4,className:'form-control',value:this.state.form.short_code,onChange:function onChange(event){return _this2._inputChange(event,'short_code');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateContent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].productUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateContent));

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateImage=function(_React$Component){_inherits(UpdateImage,_React$Component);function UpdateImage(props){_classCallCheck(this,UpdateImage);var _this=_possibleConstructorReturn(this,(UpdateImage.__proto__||Object.getPrototypeOf(UpdateImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','product');data.append('product_type',_this.state.form.product_type);_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};var countries=[];props.country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});_this.countries=countries;_this.state={form:{title:props.detail.title||'',description:props.detail.description||'',price:props.detail.price||0,currency_code:props.detail.currency_code||'IDR',image_file:'',product_type:props.detail.product_type||'modem',status:props.detail.status||'active',iso_code:props.detail.iso_code||'',details:{country_id:props.detail.details.country_id||''}},country:'',file:null,uploaded:false};return _this;}_createClass(UpdateImage,[{key:'render',value:function render(){var _this2=this;// const { files } = this.props
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Product Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',style:{width:'100%'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'270x160'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'product',product_type:this.state.form.product_type},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.image_file,className:'btn btn-primary'},'Save')))));}}]);return UpdateImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files,country_list:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ProductRedux__["b" /* default */].productUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateImage));

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoCodeConversion; });
var currencyConverter=[{case:'',currencyCode:''},{case:'ID',currencyCode:'IDR'},{case:'PH',currencyCode:'PHP'}];var isoCodeConversion=function isoCodeConversion(target){var obj=currencyConverter.find(function(item){return item.case===target;});return obj.currencyCode;};

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = {"productFilters":[{"type":"text","name":"Product Name","placeholder":"Wifi Product Name","field":"q"},{"type":"selector","name":"Source","field":"iso_code","selectors":[{"label":"Passpod","value":"ID","restriction":"PH"},{"label":"Passpod PH","value":"PH"}]},{"type":"selector","name":"Status","field":"status","selectors":[{"label":"All","value":""},{"label":"Active","value":"active"},{"label":"Inactive","value":"inactive"}]}]}

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__User_List__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__User_Count__ = __webpack_require__(925);
var subList={List:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__User_List__["a" /* default */],null),Count:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__User_Count__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname,location=_ref.location;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var UserPage=function UserPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (UserPage);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_User_DownloadUserList__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filterData_json__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filterData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filterData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_initialiseProps.call(_this);_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.sourceType=[{value:'',label:'All'},{value:'passpod',label:'Passpod'},{value:'travypass',label:'Travypass'}];_this.state={showModal:null,filter:{page:1,q:'',type:'',filterDate:false,registration_from:null,registration_until:null,only_admins:false}};return _this;}_createClass(List,[{key:'render',value:function render(){var _this2=this;var user=this.props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'User List',(user.fetching||user.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},user.fetching?'Loading':'Processing',' ...')),Object(__WEBPACK_IMPORTED_MODULE_9__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('download-user-list');}},'Download User List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_AdvancedFilter__["a" /* default */],{filters:__WEBPACK_IMPORTED_MODULE_8__filterData_json___default.a.userListFilters,manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._fetchUser(null,event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'150%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(user.fetching||user.processing)&&user.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},user.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Profile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'First Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Country Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Phone number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Role'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Total Order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Create Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Last Login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Active'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,user.data&&user.data.total===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'12',className:'text-center'},'- No Data -')),user.data&&user.data.total!==0&&user.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.profile_picture,alt:'profile',width:'35px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.first_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.last_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.country_code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.phone_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.role||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.count_order||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default.a.unix(item.created_at).format(_this2.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default.a.unix(item.last_login).format(_this2.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-'+(item.active?'success':'danger')},String(item.active))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download-user-list',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_User_DownloadUserList__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},user.data&&user.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:user.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:user.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3._fetchUser();};this._fetchUser=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this3.state.filter,filter);if(_this3.state.filter.registration_from&&_this3.state.filter.registration_until){params.registration_from=_this3.state.filter.registration_from.format('Y-MM-DD');params.registration_until=_this3.state.filter.registration_until.format('Y-MM-DD');}else{params.registration_from=null;params.registration_until=null;}params.filterDate=null;_this3.props.getUser(params);};this._manipulateState=function(props){_this3.setState({filter:props});};this._changePage=function(page){var filter=Object.assign({},_this3.state.filter,{page:page});_this3.setState({filter:filter});_this3._fetchUser({page:page});};this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this3.setState({showModal:modalId});};};var stateToProps=function stateToProps(state){return{user:state.user};};var dispatchToProps=function dispatchToProps(dispatch){return{getUser:function getUser(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_UserRedux__["b" /* default */].userRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(List));

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadUserList=function(_React$Component){_inherits(DownloadUserList,_React$Component);function DownloadUserList(props){_classCallCheck(this,DownloadUserList);var _this=_possibleConstructorReturn(this,(DownloadUserList.__proto__||Object.getPrototypeOf(DownloadUserList)).call(this,props));_this._typeChange=function(args){var val=args.target.value;var filter=Object.assign({},_this.state.filter);filter.type=val;_this.setState({filter:filter});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.filter);_this.props.download(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY';_this.type=[{value:'',label:'All'},{value:'passpod',label:'Passpod'},{value:'travypass',label:'Travypass',restriction:'PH'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])());});_this.state={filter:{type:''}};return _this;}_createClass(DownloadUserList,[{key:'render',value:function render(){var _this2=this;var user=this.props.user;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download User List',(user.fetching||user.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},user.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.type,onChange:function onChange(event){return _this2._typeChange(event);}},this.type.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Download')));}}]);return DownloadUserList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{user:state.user};};var dispatchToProps=function dispatchToProps(dispatch){return{download:function download(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__["b" /* default */].userListRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadUserList));

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = {"userListFilters":[{"type":"text","name":"User Name","placeholder":"User Name","field":"q"},{"type":"selector","name":"Source","field":"type","selectors":[{"label":"ALL","value":""},{"label":"Passpod","value":"passpod","restriction":"PH"},{"label":"Travypass","value":"travypass","restriction":"PH"}]},{"type":"dateTime","name":"From","field":"registration_from"},{"type":"dateTime","name":"To","field":"registration_until"}]}

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_UserRedux__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import sumBy from 'lodash/sumBy'
// import $ from 'jquery'
// import Modal from 'react-responsive-modal'
var Count=function(_React$Component){_inherits(Count,_React$Component);function Count(props){_classCallCheck(this,Count);var _this=_possibleConstructorReturn(this,(Count.__proto__||Object.getPrototypeOf(Count)).call(this,props));_this.componentDidMount=function(){_this._fetchUserCount({});};_this._fetchUserCount=function(_ref){var _ref$month=_ref.month,month=_ref$month===undefined?_this.state.month.value:_ref$month,_ref$year=_ref.year,year=_ref$year===undefined?_this.state.year.value:_ref$year;var monthYear=__WEBPACK_IMPORTED_MODULE_2_moment___default()().set({year:year,month:month});var firstDate=monthYear.startOf('month').format('Y-MM-DD');var lastDate=monthYear.endOf('month').format('Y-MM-DD');var filter={from:firstDate,until:lastDate};_this.props.getUserCount(filter);};_this._dateChange=function(value,field){var newState=Object.assign({},_this.state);newState[field]=value;_this.setState(newState);var date={month:_this.state.month.value,year:_this.state.year.value};date[field]=value.value;_this._fetchUserCount(date);};var monthList=[];var yearList=[];__WEBPACK_IMPORTED_MODULE_2_moment___default.a.months().map(function(label,i){return monthList.push({value:i,label:label});});for(var index=2018;index<=__WEBPACK_IMPORTED_MODULE_2_moment___default()().year();index++){yearList.push({value:index,label:index});// this would add years, starting from 2018
}_this.month=monthList;_this.year=yearList;_this.state={showModal:null,month:_this.month[__WEBPACK_IMPORTED_MODULE_2_moment___default()().month()],year:_this.year[__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(_this.year,function(list){return list.value===__WEBPACK_IMPORTED_MODULE_2_moment___default()().year();})]};return _this;}_createClass(Count,[{key:'render',value:function render(){var _this2=this;var _props=this.props,user_count=_props.user_count,user=_props.user;var monthYear=__WEBPACK_IMPORTED_MODULE_2_moment___default()().set({year:this.state.year.value,month:this.state.month.value});var lastDate=monthYear.endOf('month').date();var dates=[];for(var index=0;index<lastDate;index++){dates.push(index);}var userTotal=0;user_count.map(function(item,i){return userTotal+=item.count;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'User Count',(user.fetching||user.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},user.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Month'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{minWidth:'120px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:this.month,value:this.state.month,onChange:function onChange(value){return _this2._dateChange(value,'month');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{minWidth:'120px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:this.year,value:this.state.year,onChange:function onChange(value){return _this2._dateChange(value,'year');}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(user.fetching||user.processing)&&user.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},user.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'title'},'Total User : ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,userTotal))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'User Count'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,dates.map(function(i){var date=__WEBPACK_IMPORTED_MODULE_2_moment___default()().set({year:_this2.state.year.value,month:_this2.state.month.value,date:i+1});var exist=__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(user_count,function(data){return data.date===date.format('Y-MM-DD');});var count=0;if(exist>=0){count=user_count[exist].count;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{verticalAlign:'middle'}},count));})))))));}}]);return Count;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{user_count:state.user.user_count,user:state.user};};var dispatchToProps=function dispatchToProps(dispatch){return{getUserCount:function getUserCount(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_UserRedux__["b" /* default */].userCountRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Count));

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Order_List__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Order_ChatbotList__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Order_DetailList__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Order_AutoTransferList__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Order_ChangeStatus__ = __webpack_require__(1156);
var subList={List:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Order_List__["a" /* default */],null),ChatbotList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Order_ChatbotList__["a" /* default */],null),DetailList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Order_DetailList__["a" /* default */],null),AutoTransfer:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Order_AutoTransferList__["a" /* default */],null),ChangeStatus:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Order_ChangeStatus__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var OrderPage=function OrderPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (OrderPage);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Utils_ArrayCleaner__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Order_ViewDetail__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Order_ConfirmOrder__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Containers_Order_ViewPayment__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Containers_Order_EditAmount__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Containers_Order_EditStatus__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Containers_Order_DownloadOrderList__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Containers_Order_OrderInvoice__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Containers_Order_ResendVoucher__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var List=function(_React$Component){_inherits(List,_React$Component);function List(props){_classCallCheck(this,List);var _this=_possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).call(this,props));_this.componentDidMount=function(){_this._fetchOrder();_this.props.getCategory();};_this._fetchOrder=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this.state.filter,filter);if(_this.state.filter.from&&_this.state.filter.until){params.from=_this.state.filter.from.format('Y-MM-DD');params.until=_this.state.filter.until.format('Y-MM-DD');}else{params.from=null;params.until=null;}params.filterDate=null;_this.props.getOrder(params);};_this._specialFilterChange=function(event,field){var filter=Object.assign({},_this.state.filter);var value=event.target.value;filter[field]=value;_this.setState({filter:filter});};_this._productTypeChange=function(event){var filter=Object.assign({},_this.state.filter);var value=event.target.value;filter.type=value;if(value!=='modem'){if(filter.embed!==''){filter.embed='';_this.setState({filter:filter});}else if(filter.inventory_type!==''){filter.inventory_type='';_this.setState({filter:filter});}}_this.setState({filter:filter});};_this._filterChange=function(data,field){var uniq=['page','filterDate','from','until','order_status'];var val=null;if(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(uniq,field)){if(field==='from'||field==='until'){if(Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["isObject"])(data)){val=data;}}else{val=data;}}else{val=data.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=val;if(field==='order_status'){filter['status']='';}_this.setState({filter:filter});};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchOrder({page:page});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._select=function(data,action){_this.setState({selected:data});_this._toggleModal(action);};_this.dateFormat='DD MMM YYYY';_this.orderStatus=[{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'},{value:'payment-failed',label:'FAILED'},{value:'canceled',label:'CANCELED'},{value:'confirmed',label:'CONFIRMED'},{value:'expired',label:'EXPIRED'},{value:'approved-cs',label:'APPROVED CS'}];_this.orderType=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'event',label:'EVENTS',restriction:['admin_travy','PH']},{value:'insurance',label:'INSURANCE',restriction:['admin_travy','PH']},{value:'inventory',label:'E-COMMERCE',restriction:['admin_travy']},{value:'esim',label:'ESIM',restriction:['admin_travy']}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.sourceType=[{value:'',label:'ALL'},{value:'ID',label:'PASSPOD',restriction:['admin_travy','PH']},{value:'AP',label:'TRAVYPASS',restriction:['PH']}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.order_status=[{value:'request-cancel',label:'REQUEST CANCEL'}];_this.payment_methods=[{value:'',label:'ALL'},{value:'bank-transfer',label:'BANK TRANSFER'},{value:'credit-card',label:'CREDIT CARD',restriction:['PH']},{value:'cod',label:'COD',restriction:['ID']},{value:'virtual-account',label:'VIRTUAL ACCOUNT',restriction:['PH']},{value:'DANA',label:'DANA',restriction:['PH']},{value:'gopay',label:'GOPAY',restriction:['PH']},{value:'ovo',label:'OVO',restriction:['PH']},{value:'kredivo',label:'KREDIVO',restriction:['PH']},{value:'shopeepay',label:'SHOPEEPAY',restriction:['PH']},{value:'qris',label:'QRIS',restriction:['PH']}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.state={showModal:null,selected:'',filter:{code:'',page:1,filterDate:false,from:__WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1,'months'),until:__WEBPACK_IMPORTED_MODULE_4_moment___default()(),status:'',type:'all',embed:'',inventory_type:'',order_status:null,q:'',transaction_amount_from:null,transaction_amount_to:null,payment_method:'',coupon_code:''}};return _this;}_createClass(List,[{key:'render',value:function render(){var _this2=this;var _props=this.props,order=_props.order,category=_props.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Order List',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...')),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('download-list');}},'Download List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchOrder({page:1},event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Order Number / Email / Name',className:'form-control',value:this.state.filter.q,onChange:function onChange(event){return _this2._filterChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Amount From:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'180px'},type:'number',placeholder:'Input amount',className:'form-control',value:this.state.filter.transaction_amount_from||'',onChange:function onChange(event){return _this2._filterChange(event,'transaction_amount_from');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'180px'},type:'number',placeholder:'Input amount',className:'form-control',value:this.state.filter.transaction_amount_to||'',onChange:function onChange(event){return _this2._filterChange(event,'transaction_amount_to');}})),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Coupon'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'200px'},type:'text',placeholder:'Insert Coupon Code',className:'form-control',value:this.state.filter.coupon_code||'',onChange:function onChange(event){return _this2._filterChange(event,'coupon_code');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:'DD/MM/YYYY',timeFormat:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label ml-2 mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:'DD/MM/YYYY',timeFormat:false})),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:this.state.filter.order_status,className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),this.orderStatus.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.type,onChange:function onChange(event){return _this2._productTypeChange(event);}},this.orderType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&this.state.filter.type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Insurance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.embed,onChange:function onChange(event){return _this2._specialFilterChange(event,'embed');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'yes'},'Included'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'no'},'Excluded'))),this.state.filter.type==='inventory'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.inventory_type,onChange:function onChange(event){return _this2._specialFilterChange(event,'inventory_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),category.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name.toUpperCase());}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.payment_method,onChange:function onChange(event){return _this2._filterChange(event,'payment_method');}},this.payment_methods.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.code,onChange:function onChange(event){return _this2._filterChange(event,'code');}},this.sourceType.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Show Request Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_SwitchButton__["a" /* default */],{isChecked:!!this.state.filter.order_status,onChange:function onChange(){return _this2._filterChange(!_this2.state.filter.order_status?'request-cancel':null,'order_status');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'225%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Confirmation Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Waiting Voucher'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Cancellation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'User Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'},width:'5%'},'Create Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Currency'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Total Deposit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Admin Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Total Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Coupon Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Discount Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'Final Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'125px'}},'User Access From'),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit Amount'),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'View Order Details'),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'View Payment and Other Details'),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Confirm Order'),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Download Invoice'),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Resend Voucher'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,order.data&&order.data.data&&order.data.data.length?order.data.data.map(function(item,i){var name=[];name.push(item.salutation);name.push(item.first_name);name.push(item.last_name);name=Object(__WEBPACK_IMPORTED_MODULE_10__Utils_ArrayCleaner__["a" /* default */])(name);var requestCancel=null;if(item.order_details&&item.order_details.length>0){item.order_details.map(function(detail,i){if(detail.order_detail_status){requestCancel=detail.order_detail_status;}return requestCancel;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.status||'-',['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&['payment-pending','payment-failed','expired'].indexOf(item.status)>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:function onClick(){return _this2._select(item,'edit-status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.confirm_date!==null?__WEBPACK_IMPORTED_MODULE_4_moment___default()(item.confirm_date).format(_this2.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center`'}},item.waiting_voucher||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},requestCancel||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user_destination&&item.user_destination.length>0?item.user_destination.toString():'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,name.join(' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.phone_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_4_moment___default.a.unix(item.created_at).format(_this2.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order_payments&&item.order_payments.length?item.order_payments[item.order_payments.length-1].payment_method:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.unique_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.currency_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},Object(__WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__["a" /* default */])(item.total_deposit_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},Object(__WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__["a" /* default */])(item.total_admin_fee)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},Object(__WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__["a" /* default */])(item.total_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},item.coupon_code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},Object(__WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__["a" /* default */])(item.discount_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},Object(__WEBPACK_IMPORTED_MODULE_19__Utils_FormatMoney__["a" /* default */])(item.final_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.userdevice),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(['payment-pending','confirmed','expired'],item.status)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'edit-amount');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'})):'-'),['admin','finance','cs'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'view-detail');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),['admin','finance','cs'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'view-payment');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-list-alt'}))),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(['payment-pending','expired'],item.status)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'confirm-order');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-square'}),' Confirm'):'-'),['admin','finance'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])())>=0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(['confirmed'],item.status)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'order-invoice');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'})):'-'),Object(__WEBPACK_IMPORTED_MODULE_20__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["includes"])(['confirmed'],item.status)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'resend-email');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-envelope'})):'-'));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'25',className:'text-center'},'- No Data -'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-detail',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Order_ViewDetail__["a" /* default */],{order_id:this.state.selected.id,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='view-payment',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Containers_Order_ViewPayment__["a" /* default */],{order_id:this.state.selected.id,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='confirm-order',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Order_ConfirmOrder__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-amount',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Containers_Order_EditAmount__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-status',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Containers_Order_EditStatus__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download-list',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Containers_Order_DownloadOrderList__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='order-invoice',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Containers_Order_OrderInvoice__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='resend-email',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Containers_Order_ResendVoucher__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},order.data&&order.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:order.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:order.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order,detail:state.detail,category:state.category};};var dispatchToProps=function dispatchToProps(dispatch){return{getOrder:function getOrder(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_OrderRedux__["b" /* default */].orderRequest(filter));},getCategory:function getCategory(){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_CategoryRedux__["b" /* default */].getCategoryRequest());},resendOrderVoucher:function resendOrderVoucher(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_OrderRedux__["b" /* default */].resendOrderVoucherRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(List));

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ArrayCleaner=function ArrayCleaner(array){var newArray=[];for(var i=0;i<array.length;i++){if(array[i]){newArray.push(array[i]);}}return newArray;};/* harmony default export */ __webpack_exports__["a"] = (ArrayCleaner);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewDetail=function(_React$Component){_inherits(ViewDetail,_React$Component);function ViewDetail(props){_classCallCheck(this,ViewDetail);var _this=_possibleConstructorReturn(this,(ViewDetail.__proto__||Object.getPrototypeOf(ViewDetail)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){_this.props.getData(_this.props.order_id);};_this._renderAttraction=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Attractions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Booking number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Product type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Attraction title '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Attraction package'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='attraction'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.booking_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.attraction.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.attraction_package.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.provider||'-'),item.orderable.provider==='BMG'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.adults>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.orderable.adults+' Adult'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),item.orderable.children>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.orderable.children+' Children'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),item.orderable.seniors>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.orderable.senior+' Senior')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,item.orderable.skus.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},item.quantity+' '+item.title);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.orderable.date).format(_this.dateFormat)||'-'));}else return null;}))));};_this._renderModem=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Booking number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Wifi plan'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='modem'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.booking_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.orderable.start_date).format(_this.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.orderable.end_date).format(_this.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.product.title||'-'));}else return null;}))));};_this._renderEvents=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Events'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Booking Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Event Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Location'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantity'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='event'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.booking_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.events.name||'-'),!item.orderable.events.schedules.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'No Location'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.events.schedules.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},item.location.location_name||'-');})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.orderable.events.start_date).format(_this.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.orderable.events.end_date).format(_this.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.qty||'-'));}else return null;}))));};_this._renderInsurance=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Insurance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Booking Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Package Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Destination'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Start Day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End Day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Price'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='insurance'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.booking_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.travel_package.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.travel_package.type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.travel_package.destination_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.inseption_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.finish_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.price_travel.currency_code||'-',' ',item.orderable.price_travel.price||'-'));}else return null;}))));};_this._renderEcommerce=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'E-Commerce'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Booking Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Product Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Subtype'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='inventory'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.booking_number||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.qty||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.inventory_item.inventory.name||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.inventory_item.varian_size.name||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.inventory_item.varian_colour.name||''));}else return null;}))));};_this._renderEsim=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'eSIM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Booking Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'eSIM Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Data Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Day(s)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details&&data.order_details.map(function(item,i){if(item.type==='esim'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.booking_number||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.qty||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.variant.esim.name||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.variant.data_size||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.orderable.variant.day||''));}else return null;}))));};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.state={showModal:null};_this.currentBranch=Object(__WEBPACK_IMPORTED_MODULE_5__Utils_PrivilegeUtils__["a" /* currentBranch */])();return _this;}_createClass(ViewDetail,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var data=order.data_single;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Order Detail',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-secondary',style:{fontSize:'100%'}},data.unique_number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-secondary',style:{fontSize:'100%'}},data.status)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},(data.salutation||'-')+' '+(data.first_name||'-')+' '+(data.last_name||'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},data.email||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Phone Number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},data.phone_number||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Create Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.created_at).format(this.dateFormat)||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Currency Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},data.currency_code||'-')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Admin Fee')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.total_admin_fee,{format:'%v',thousand:',',decimal:'.',precision:2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Deposit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.total_deposit_amount,{format:'%v',thousand:',',decimal:'.',precision:2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.total_amount,{format:'%v',thousand:',',decimal:'.',precision:2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.discount_amount,{format:'%v',thousand:',',decimal:'.',precision:2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Insurance Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.total_insurance,{format:'%v',thousand:',',decimal:'.',precision:2}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Final Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8 text-right'},__WEBPACK_IMPORTED_MODULE_4_accounting___default.a.formatMoney(data.final_amount,{format:'%v',thousand:',',decimal:'.',precision:2})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Order Items')),this._renderAttraction(data),this._renderModem(data),this.currentBranch!=='PH'&&this._renderEvents(data),this.currentBranch!=='PH'&&this._renderInsurance(data),this._renderEcommerce(data),this._renderEsim(data),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close')));}}]);return ViewDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{getData:function getData(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderSingleRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewDetail));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfirmOrder=function(_React$Component){_inherits(ConfirmOrder,_React$Component);function ConfirmOrder(props){_classCallCheck(this,ConfirmOrder);var _this=_possibleConstructorReturn(this,(ConfirmOrder.__proto__||Object.getPrototypeOf(ConfirmOrder)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.props.detail.id;_this.props.getData(id);};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state);var data={id:_this.props.detail.id,form:form};_this.props.submit(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.state={transfer_amount:0,payment_notes:''};return _this;}_createClass(ConfirmOrder,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var data=order.data_single;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Confirm Order',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:data.order_number}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Order')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:data.final_amount}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Full Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:data.salutation+' '+data.first_name+' '+data.last_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Phone Number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:data.phone_number}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Transfer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.transfer_amount,onChange:function onChange(event){return _this2.setState({transfer_amount:event.target.value});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Notes (Optional)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control',placeholder:'Notes (Optional)',value:this.state.payment_notes,onChange:function onChange(event){return _this2.setState({payment_notes:event.target.value});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Confirm')));}}]);return ConfirmOrder;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{getData:function getData(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderSingleRequest(id));},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderConfirmRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ConfirmOrder));

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewPayment=function(_React$Component){_inherits(ViewPayment,_React$Component);function ViewPayment(props){_classCallCheck(this,ViewPayment);var _this=_possibleConstructorReturn(this,(ViewPayment.__proto__||Object.getPrototypeOf(ViewPayment)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this.componentWillReceiveProps=function(_ref){var order=_ref.order;var data=order.data_single;var modem=0;var inventory=0;var receiveMethod=_this.state.receive_method;var returnMethod=_this.state.return_method;if(data.order_details){data.order_details.map(function(item,i){if(item.type==='modem'){receiveMethod=item.orderable.receive_method||'';returnMethod=item.orderable.return_method||'';modem++;}if(item.type==="inventory"){receiveMethod=item.orderable.receive_method||'';inventory++;}return true;});_this.setState({modem:modem,inventory:inventory,order_details:data.order_details,receive_method:receiveMethod,return_method:returnMethod,refund_value_limit:data.final_amount});}};_this._fetchData=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.props.order_id;_this.props.getData(id);};_this._selectItem=function(item,modalID){if(modalID){_this.setState({showModal:modalID,selectedID:item.id});}};_this._refundDana=function(event,uuid){if(event){event.preventDefault();}var form=Object.assign({},_this.state.refundForm);var data={uuid:uuid,form:form};_this.props.refundDana(data);setTimeout(function(){_this.props.closeModal();},250);};_this._toggleModal=function(modalID){_this.setState({showModal:modalID});};_this._handleChange=function(event,field){if(event){event.preventDefault();}var refundForm=Object.assign({},_this.state.refundForm);var value=event.target.value;refundForm[field]=value;_this.setState({refundForm:refundForm});};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.refundType=[{label:'Refund',value:'refund'},{label:'Cancellation',value:'refund'}];_this.state={selectedID:'',showModal:null,modem:0,inventory:0,receive_method:'',return_method:'',order_details:[],refund_value_limit:'',refundForm:{refund_type:'',refund_value:''}};return _this;}_createClass(ViewPayment,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var data=order.data_single;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'80vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Order Payment Detail',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-secondary',style:{fontSize:'100%'}},data.unique_number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-secondary',style:{fontSize:'100%'}},data.status)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Payment ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Payment method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Payment status '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Create date package'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_payment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_payment.payment_id||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_payment.payment_method||'-',data.order_payment.payment_method==='virtual-account'?data.order_payment.payment_response.bank_name?' ('+data.order_payment.payment_response.bank_name+')':'':'',data.order_payment.payment_method==='DANA'&&data.order_payment.payment_response!==null?'('+data.order_payment.payment_response.payMethod+')':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_payment.payment_status||'-',data.order_payment.payment_method==='DANA'&&(data.order_payment.payment_status==='request-cancel'||data.order_payment.payment_status==='success')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._selectItem(data,'refund');},className:'ml-2 btn btn-sm btn-danger'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'mr-2 fa fa-share-square'}),'Refund')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.order_payment.created_at).format(this.dateFormat))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- NO DATA -'))))),this.state.modem>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Bank Account Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Bank'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Holder name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Holder account number'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.order_details?data.order_details.map(function(item,i){if(item.type==='modem'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.order_detail_bank_account?item.orderable.order_detail_bank_account.bank:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.order_detail_bank_account?item.orderable.order_detail_bank_account.holder_name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.order_detail_bank_account?item.orderable.order_detail_bank_account.holder_account_number:'-'));}else{return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- NO DATA -'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Receive Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'mt-1'},this.state.receive_method||'-----')),this.state.receive_method==='airport'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estimate time from'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estimate time to'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.order_details.length?this.state.order_details.map(function(item,i){if(item.type==='modem'&&item.orderable.receive_order_detail_airport){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_order_detail_airport.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_order_detail_airport.date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_order_detail_airport.estimate_time_from||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_order_detail_airport.estimate_time_to||'-'));}else{return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- NO DATA -'))))),this.state.receive_method==='courier'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Province'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'District'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub District'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Postal Code'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.order_details.length?this.state.order_details.map(function(item,i){if(item.type==='modem'&&item.orderable.receive_courier){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.address||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.province?item.orderable.receive_courier.user_address.province.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.city?item.orderable.receive_courier.user_address.city.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.district?item.orderable.receive_courier.user_address.district.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.subdistrict?item.orderable.receive_courier.user_address.subdistrict.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.receive_courier.user_address.postal_code||'-'));}else{return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'- NO DATA -'))))),this.state.receive_method==='vending-machine'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},data.order_pickup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Kode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pickup At'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.pickup_at?__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.order_pickup.pickup_at).format(this.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.status?'Sudah Diambil':'Belum diambil'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Return Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'mt-1'},this.state.return_method||'-----')),this.state.return_method==='airport'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estimate time from'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Estimate time to'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.order_details.length?this.state.order_details.map(function(item,i){if(item.type==='modem'&&item.orderable.return_order_detail_airport){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_order_detail_airport.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_order_detail_airport.date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_order_detail_airport.estimate_time_from||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_order_detail_airport.estimate_time_to||'-'));}else{return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- NO DATA -'))))),this.state.return_method==='courier'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Province'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'District'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Sub District'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Postal Code'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.state.order_details.length?this.state.order_details.map(function(item,i){if(item.type==='modem'&&item.orderable.return_courier){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.address||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.province?item.orderable.return_courier.user_address.province.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.city?item.orderable.return_courier.user_address.city.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.district?item.orderable.return_courier.user_address.district.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.subdistrict?item.orderable.return_courier.user_address.subdistrict.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.orderable.return_courier.user_address.postal_code||'-'));}else{return null;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'- NO DATA -')))))),this.state.inventory>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Inventory Pickup Detail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'mt-1'},this.state.receive_method||'-----')),this.state.receive_method==='vending-machine'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section table-responsive'},data.order_pickup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Kode'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Pickup At'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.pickup_at?__WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(data.order_pickup.pickup_at).format(this.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data.order_pickup.status?'Sudah Diambil':'Belum diambil')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='refund',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'45vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Confirm Refund')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Please fill these details:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._refundDana(event,_this2.state.selectedID);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Refund Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{defaultValue:'',onChange:function onChange(event){return _this2._handleChange(event,'refund_type');},required:true,className:'form-control'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'- Select Refund Type -'),this.refundType.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:option.value},option.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Refund Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Fill refund amount',value:this.state.refundForm.refund_value,onChange:function onChange(event){return _this2._handleChange(event,'refund_value');},required:true,className:'form-control',type:'number',min:0,max:this.state.refund_value_limit,step:1}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._toggleModal(null);},className:'btn btn-secondary',type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times mr-2'}),'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check mr-2'}),'Confirm'))))));}}]);return ViewPayment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{getData:function getData(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderSingleRequest(id));},refundDana:function refundDana(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].refundDanaRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewPayment));

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditAmount=function(_React$Component){_inherits(EditAmount,_React$Component);function EditAmount(props){_classCallCheck(this,EditAmount);var _this=_possibleConstructorReturn(this,(EditAmount.__proto__||Object.getPrototypeOf(EditAmount)).call(this,props));_this._fieldChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);if(event.target.type==='number'){val=parseFloat(val);}newState[field]=val;_this.setState(newState);};_this._checkField=function(field){var val=_this.state[field];var newState=Object.assign({},_this.state);if(!val){val=0;newState[field]=val;_this.setState(newState);}};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state);var data={id:_this.props.detail.id,form:form};_this.props.submit(data);_this.props.closeModal();};var _props$detail=props.detail,unique_number=_props$detail.unique_number,discount_amount=_props$detail.discount_amount,total_deposit_amount=_props$detail.total_deposit_amount,total_admin_fee=_props$detail.total_admin_fee,total_additional_price=_props$detail.total_additional_price,total_amount=_props$detail.total_amount;_this.state={unique_number:unique_number,discount_amount:discount_amount,total_deposit_amount:total_deposit_amount,total_admin_fee:total_admin_fee,total_additional_price:total_additional_price,total_amount:total_amount};return _this;}_createClass(EditAmount,[{key:'render',value:function render(){var _this2=this;var _props=this.props,order=_props.order,detail=_props.detail;var fields=[{name:'unique_number',label:'Unique Number'},{name:'discount_amount',label:'Discount Amount'},{name:'total_deposit_amount',label:'Total Deposit Amount'},{name:'total_admin_fee',label:'Total Admin Fee'},{name:'total_additional_price',label:'Total Additional Price'},{name:'total_amount',label:'Total Amount'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Amount ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-secondary ml-2'},detail.order_number),(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),fields.map(function(field,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},field.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',readOnly:field.name==='total_amount',min:'0',step:'any',className:'form-control',value:_this2.state[field.name],onBlur:function onBlur(){return _this2._checkField(field.name);},onChange:function onChange(event){return _this2._fieldChange(event,field.name);}})));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save')));}}]);return EditAmount;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderUpdateAmountRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EditAmount));

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditStatus=function(_React$Component){_inherits(EditStatus,_React$Component);function EditStatus(props){_classCallCheck(this,EditStatus);var _this=_possibleConstructorReturn(this,(EditStatus.__proto__||Object.getPrototypeOf(EditStatus)).call(this,props));_this._fieldChange=function(event,field){var val=event.target.value;var newState=Object.assign({},_this.state);if(event.target.type==='number'){val=parseFloat(val);}newState[field]=val;_this.setState(newState);};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:{status:_this.state.status.value}};_this.props.submit(data);_this.props.closeModal();};_this.orderStatus=[{value:'checkout',label:'CHECKOUT',role:['admin']},{value:'payment-pending',label:'PENDING',role:['admin','finance','cs']},{value:'approved-cs',label:'APPROVED CS',role:['admin','cs']},{value:'payment-failed',label:'FAILED',role:['admin','finance']},{value:'canceled',label:'CANCELED',role:['admin','finance']},{value:'expired',label:'EXPIRED',role:['admin']}];var options=[];_this.orderStatus.map(function(status,i){if(__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(status.role,_this.props.role)){options.push(status);}return options;});_this.options=options;var status=props.detail.status;status=__WEBPACK_IMPORTED_MODULE_4_lodash_find___default()(_this.options,function(i){return i.value===status;});_this.state={status:status};return _this;}_createClass(EditStatus,[{key:'render',value:function render(){var _this2=this;var _props=this.props,order=_props.order,detail=_props.detail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Status ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-secondary ml-2'},detail.order_number),(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{options:this.options,value:this.state.status,required:true,onChange:function onChange(status){return _this2.setState({status:status});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.status,required:true,onChange:function onChange(){return null;},style:{position:'absolute',zIndex:'-1',top:'50%',left:'30%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save')));}}]);return EditStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order,role:state.auth.user.role};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EditStatus));

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(262),
    isArrayLike = __webpack_require__(228),
    keys = __webpack_require__(143);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_SwitchButton__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadOrderList=function(_React$Component){_inherits(DownloadOrderList,_React$Component);function DownloadOrderList(props){_classCallCheck(this,DownloadOrderList);var _this=_possibleConstructorReturn(this,(DownloadOrderList.__proto__||Object.getPrototypeOf(DownloadOrderList)).call(this,props));_this.componentDidMount=function(){if(Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin_travy'){_this.setState({filter:{code:'AP',status:'confirmed'}});}};_this._filterChange=function(data,field){var uniq=['page','filterDate','from','until','order_status'];var val=null;if(__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(uniq,field)){if(field==='from'||field==='until'){if(__WEBPACK_IMPORTED_MODULE_4_lodash_isObject___default()(data)){val=data;}}else{val=data;}}else{val=data.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=val;if(field==='order_status'){filter['status']='';}_this.setState({filter:filter});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.filter);if(_this.state.filter.from&&_this.state.filter.until){data.from=_this.state.filter.from.format('Y-MM-DD');data.until=_this.state.filter.until.format('Y-MM-DD');}else{data.from=null;data.until=null;}_this.props.download(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY';_this.orderStatus=[{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'},{value:'payment-failed',label:'FAILED'},{value:'canceled',label:'CANCELED'},{value:'confirmed',label:'CONFIRMED'},{value:'expired',label:'EXPIRED'},{value:'approved-cs',label:'APPROVED CS'}];_this.orderType=[{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'}];_this.sourceSelector=[{value:'',label:'ALL'},{value:'ID',label:'Passpod'},{value:'AP',label:'Travypass'}];_this.order_status=[{value:'request-cancel',label:'REQUEST CANCEL'}];_this.payment_methods=[{value:'',label:'- Select Payment Method -'},{value:'bank-transfer',label:'BANK TRANSFER'},{value:'credit-card',label:'CREDIT CARD',restriction:['PH']},{value:'cod',label:'COD',restriction:['ID']},{value:'virtual-account',label:'VIRTUAL ACCOUNT',restriction:['PH']},{value:'DANA',label:'DANA',restriction:['PH']},{value:'gopay',label:'GOPAY',restriction:['PH']},{value:'ovo',label:'OVO',restriction:['PH']},{value:'kredivo',label:'KREDIVO',restriction:['PH']},{value:'shopeepay',label:'SHOPEEPAY',restriction:['PH']},{value:'qris',label:'QRIS',restriction:['PH']}].filter(function(option){return!__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!__WEBPACK_IMPORTED_MODULE_3_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.state={filter:{from:null,until:null,code:'',status:'',order_status:null,payment_method:''}};return _this;}_createClass(DownloadOrderList,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var from=this.state.filter.from;var yesterday=from;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download Order List',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:'DD/MM/YYYY',timeFormat:false,isValidDate:function isValidDate(current){return current.isAfter(yesterday);}})),Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.code,onChange:function onChange(event){return _this2._filterChange(event,'code');},required:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'-Select Source-'),this.sourceSelector.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{disabled:this.state.filter.order_status,className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'All'),this.orderStatus.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Show Request Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SwitchButton__["a" /* default */],{isChecked:!!this.state.filter.order_status,onChange:function onChange(){return _this2._filterChange(!_this2.state.filter.order_status?'request-cancel':null,'order_status');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.payment_method,onChange:function onChange(event){return _this2._filterChange(event,'payment_method');}},this.payment_methods.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Download')));}}]);return DownloadOrderList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{download:function download(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderListDownloadRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadOrderList));

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderInvoice=function(_React$Component){_inherits(OrderInvoice,_React$Component);function OrderInvoice(props){_classCallCheck(this,OrderInvoice);var _this=_possibleConstructorReturn(this,(OrderInvoice.__proto__||Object.getPrototypeOf(OrderInvoice)).call(this,props));_this.componentWillReceiveProps=function(nextProps){var data_single=nextProps.order.data_single;if(data_single.order_details&&data_single.order_details.length){var attraction=0;data_single.order_details.forEach(function(data,i){if(data.type==='attraction'){attraction++;}});_this.setState({attraction:attraction});}};_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.props.detail.id;_this.props.getData(id);};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,order_number:_this.props.detail.order_number};_this.props.downloadInvoice(data);_this.props.closeModal();// if (this.state.attraction) {
//   const data = {
//     id: this.props.detail.id,
//     order_number: this.props.detail.order_number
//   }
//   this.props.downloadInvoice(data)
//   this.props.closeModal()
// }
};_this.state={attraction:0};return _this;}_createClass(OrderInvoice,[{key:'render',value:function render(){var _this2=this;var _props=this.props,detail=_props.detail,order=_props.order;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download Invoice',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',style:{textAlign:'center'},readOnly:true,className:'form-control',value:detail.order_number})),!this.state.attraction&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Warning'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Invoice cannot be downloaded! ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Invoice can only be downloaded if there is an ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'attraction'),' in the order detail list'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.attraction,className:'btn btn-lg btn-primary'},'Download')));}}]);return OrderInvoice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{downloadInvoice:function downloadInvoice(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderInvoiceRequest(data));},getData:function getData(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderSingleRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(OrderInvoice));

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResendVoucher=function(_React$Component){_inherits(ResendVoucher,_React$Component);function ResendVoucher(props){_classCallCheck(this,ResendVoucher);var _this=_possibleConstructorReturn(this,(ResendVoucher.__proto__||Object.getPrototypeOf(ResendVoucher)).call(this,props));_this.componentWillReceiveProps=function(nextProps){var data_single=nextProps.order.data_single;if(data_single.order_details&&data_single.order_details.length){var attraction=0;data_single.order_details.forEach(function(data,i){if(data.type==='attraction'){attraction++;}});_this.setState({attraction:attraction});}};_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this.props.detail.id;_this.props.getData(id);};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id};_this.props.resendVoucher(data);_this.props.closeModal();};_this.state={attraction:0};return _this;}_createClass(ResendVoucher,[{key:'render',value:function render(){var _this2=this;var _props=this.props,detail=_props.detail,order=_props.order;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Resend Voucher',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',style:{textAlign:'center'},readOnly:true,className:'form-control',value:detail.id})),!this.state.attraction&&!order.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-warning'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Warning!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'Cannot re-send voucher for this order. You can only re-send voucher for ATTRACTION related orders.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary',disabled:!this.state.attraction},'Resend')));}}]);return ResendVoucher;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{resendVoucher:function resendVoucher(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].resendOrderVoucherRequest(data));},getData:function getData(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderSingleRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ResendVoucher));

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatbotList=function(_React$Component){_inherits(ChatbotList,_React$Component);function ChatbotList(props){_classCallCheck(this,ChatbotList);var _this=_possibleConstructorReturn(this,(ChatbotList.__proto__||Object.getPrototypeOf(ChatbotList)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this.state.filter,filter);_this.props.get(params);};_this._filterChange=function(data,field){var filter=Object.assign({},_this.state.filter);filter[field]=data.target.value;_this.setState({filter:filter});};_this._changeTab=function(tab){var filter=Object.assign({},_this.state.filter);filter.page=1;filter.type=tab;_this.setState({filter:filter,tab:tab});setTimeout(function(){_this._fetchData();},250);};_this._toggleModal=function(){var modal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(!modal){_this._fetchData();}_this.setState({modal:modal});};_this._selectItem=function(item,modal){_this.setState({detail:item});_this._toggleModal(modal);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchData({page:page});};_this._confirm=function(uuid){var form={type:_this.state.tab};var data={uuid:uuid,form:form};_this.props.post(data);setTimeout(function(){_this._toggleModal();},250);};_this._renderTable=function(data,tab){switch(tab){case'wifi-rental':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Customer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Phone'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Account Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Account Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Bank Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Bank Branch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'250px'}},'Start - End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Admin Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Deposit Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Final Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Return Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Courier Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Airport Terminal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Airport Estimate Time'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Airport Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Confirm Order'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.customer_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.phone||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.account_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.account_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.bank_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.bank_branch||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.product_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.country||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.start_date?__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.start_date).format(_this.dateFormat):'-',' - ',item.start_date?__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.end_date).format(_this.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.total_qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.unique_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.total_admin_fee)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.total_deposit_amount)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.total_amount)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.final_amount)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.receive_method||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.return_method||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.receive_courier_address||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.receive_airport_terminal||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.receive_airport_estimate_time||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.receive_airport_date?__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.receive_airport_date).format(_this.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.current_step==='incoming-order'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(item,'confirm');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-square'}),' Confirm'):'-'));})));case'wifi-extend':case'add-quota':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Modem Series'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Quota'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Product Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'250px'}},'Start Date - End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Admin Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Final Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Confirm Order'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.order_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.modem_series||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.quota||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.product_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.country||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.start_date?__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.start_date).format(_this.dateFormat):'-',' - ',item.start_date?__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.end_date).format(_this.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.unique_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.total_admin_fee)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.total_amount)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.final_amount)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.current_step==='incoming-order'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(item,'confirm');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-check-square'}),' Confirm'):'-'));})));default:return null;}};_this.dateFormat='DD MMM YYYY';_this.state={tab:'wifi-rental',modal:null,detail:{},filter:{type:'wifi-rental',page:1,limit:10,status:'incoming-order'}};return _this;}_createClass(ChatbotList,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Chatbot Order List',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='wifi-rental'&&'active'),onClick:function onClick(){return _this2._changeTab('wifi-rental');}},'Wifi Rental'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='wifi-extend'&&'active'),onClick:function onClick(){return _this2._changeTab('wifi-extend');}},'Wifi Extend'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='add-quota'&&'active'),onClick:function onClick(){return _this2._changeTab('add-quota');}},'Add Quota'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchData({page:1},event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control mr-2',onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'incoming-order'},'Incoming Order'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'processed'},'Processed'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},!order.DATA_CHATBOT||order.DATA_CHATBOT.data.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title text-center align-middle'},!(order.fetching||order.processing)&&'-- No Data --')):this._renderTable(order.DATA_CHATBOT.data,this.state.tab))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__["a" /* default */],{center:true,open:this.state.modal==='confirm',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Confirm Order')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.tab==='wifi-rental'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Customer name:'),' ',this.state.detail.customer_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Product name:'),' ',this.state.detail.product_name)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Order number:'),' ',this.state.detail.order_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Modem series:'),' ',this.state.detail.modem_series)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._toggleModal();},className:'btn btn-secondary mr-2'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._confirm(_this2.state.detail.id);},className:'btn btn-primary'},'Confirm')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section text-center'},order.DATA_CHATBOT&&order.DATA_CHATBOT.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:order.DATA_CHATBOT.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:order.DATA_CHATBOT.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return ChatbotList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_OrderRedux__["b" /* default */].getChatbotOrderRequest(filter));},post:function post(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_OrderRedux__["b" /* default */].postChatbotOrderRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ChatbotList));

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Order_DownloadOrderDetailList__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DetailList=function(_React$Component){_inherits(DetailList,_React$Component);function DetailList(props){_classCallCheck(this,DetailList);var _this=_possibleConstructorReturn(this,(DetailList.__proto__||Object.getPrototypeOf(DetailList)).call(this,props));_this.componentDidMount=function(){_this._fetchOrder();_this.props.getCategory();};_this._fetchOrder=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this.state.filter,filter);if(_this.state.filter.from&&_this.state.filter.until){params.from=_this.state.filter.from.format('Y-MM-DD');params.until=_this.state.filter.until.format('Y-MM-DD');}else{params.from=null;params.until=null;}params.filterDate=null;_this.props.getOrderDetailList(params);};_this._specialFilterChange=function(event,field){var filter=Object.assign({},_this.state.filter);var value=event.target.value;filter[field]=value;_this.setState({filter:filter});};_this._productTypeChange=function(event){var filter=Object.assign({},_this.state.filter);var value=event.target.value;filter.type=value;if(value!=='modem'){if(filter.embed!==''){filter.embed='';_this.setState({filter:filter});}else if(filter.inventory_type!==''){filter.inventory_type='';_this.setState({filter:filter});}}_this.setState({filter:filter});};_this._filterChange=function(data,field){var uniq=['page','filterDate','from','until'];var filter=Object.assign({},_this.state.filter);var val=null;if(__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(uniq,field)){if(field==='from'||field==='until'){if(__WEBPACK_IMPORTED_MODULE_8_lodash_isObject___default()(data)){val=data;}}else{val=data;}}else{val=data.target.value;}filter[field]=val;_this.setState({filter:filter});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchOrder({page:page});};_this._renderOrderModem=function(modems){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Wifi Product'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,modems.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.qty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.start_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.end_date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.product.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount)));})));};_this._renderOrderAttraction=function(attractions){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Attraction Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Attraction Package Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Base Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Amount'))),attractions.map(function(item,i){switch(item.provider){case'KLOOK':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.attraction.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.attraction_package.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'KLOOK'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'SGD '+item.attraction.base_price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,item.skus.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},item.quantity+' '+item.title);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount))));case'BMG':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.date).format(_this.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.attraction.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.attraction_package.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'BMG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.booking_response!==null?'SGD '+item.booking_response.totalAmount:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',style:{width:'60px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.children+' Children'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.adults+' Adult'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.seniors+' Senior')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount))));default:return null;}}));};_this._renderOrderEvent=function(events){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Ticket Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Insurance Package'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Insurance Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,events.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.qty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.start_date).format(_this.dateFormat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.end_date).format(_this.dateFormat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.ticket_name),item.order_detail_product_event_insurance?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.order_detail_product_event_insurance.ticket_package.name):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},' - '),item.order_detail_product_event_insurance?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.order_detail_product_event_insurance.ticket_package.price)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},' - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount)));})));};_this._renderOrderInsurance=function(insurances){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Start Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'End Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Package Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Insured'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Beneficiary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,insurances.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inseption_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.finish_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.travel_package.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,item.insured.length!==0?item.insured.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.CustName||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.Status||''));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6'},'-No Data--'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Percentage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Relationship'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,item.beneficiary.length!==0?item.beneficiary.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.BeneficiaryName||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.BeneficiaryPercentage||''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.BeneficiaryRelationship||''));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'-- No Data --'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount)||'-'));})));};_this._renderOrderInventory=function(inventories){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'SKU'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Product Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Subtype'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,inventories.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.sku_v||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.inventory?item.inventory_item.inventory.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.varian_size.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.varian_colour.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.inventory?item.inventory_item.inventory.category.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.inventory_item.inventory?item.inventory_item.inventory.brand.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount)||'-'));})));};_this._renderOrderEsim=function(esims){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3 table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Qty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'eSIM Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Data Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Day(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Amount'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,esims.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.variant.esim.name?item.variant.esim.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.variant.data_size?item.variant.data_size:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.variant.day?item.variant.day:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.amount)||'-'));})));};_this.dateFormat='DD MMM YYYY';_this.orderStatus=[{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'},{value:'payment-failed',label:'FAILED'},{value:'canceled',label:'CANCELED'},{value:'confirmed',label:'CONFIRMED'},{value:'expired',label:'EXPIRED'}];_this.orderType=[{value:'all',label:'ALL'},{value:'modem',label:'MODEM'},{value:'attraction',label:'ATTRACTION'},{value:'event',label:'EVENTS',restriction:['admin_travy','PH']},{value:'insurance',label:'INSURANCE',restriction:['admin_travy','PH']},{value:'inventory',label:'E-COMMERCE',restriction:['admin_travy']},{value:'esim',label:'ESIM',restriction:['admin_travy']}].filter(function(option){return!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.sourceType=[{value:'',label:'ALL'},{value:'ID',label:'PASSPOD',restriction:['admin_travy','PH']},{value:'AP',label:'TRAVYPASS',restriction:['PH']}].filter(function(option){return!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.payment_methods=[{value:'',label:'ALL'},{value:'bank-transfer',label:'BANK TRANSFER'},{value:'credit-card',label:'CREDIT CARD',restriction:['PH']},{value:'cod',label:'COD',restriction:['ID']},{value:'virtual-account',label:'VIRTUAL ACCOUNT',restriction:['PH']},{value:'DANA',label:'DANA',restriction:['PH']},{value:'gopay',label:'GOPAY',restriction:['PH']},{value:'ovo',label:'OVO',restriction:['PH']},{value:'kredivo',label:'KREDIVO',restriction:['PH']},{value:'shopeepay',label:'SHOPEEPAY',restriction:['PH']},{value:'qris',label:'QRIS',restriction:['PH']}].filter(function(option){return!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!__WEBPACK_IMPORTED_MODULE_7_lodash_includes___default()(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.insuranceIncluded=[{value:'',label:'ALL'},{value:'yes',label:'YES'},{value:'no',label:'NO'}];_this.state={showModal:null,filter:{code:'',page:1,filterDate:false,from:__WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1,'months'),until:__WEBPACK_IMPORTED_MODULE_5_moment___default()(),status:'',type:'all',embed:'',inventory_type:'',q:'',transaction_amount_from:null,transaction_amount_to:null}};return _this;}_createClass(DetailList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,order=_props.order,category=_props.category;var data_detail=order.data_detail;if(Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin_travy'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/order'});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Order Detail List',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...')),Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('download-list');}},'Download Detail List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchOrder(null,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Order Number / Email /Name',className:'form-control',value:this.state.filter.q,onChange:function onChange(event){return _this2._filterChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Amount From:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'180px'},type:'number',placeholder:'Input Amount',className:'form-control',value:this.state.filter.transaction_amount_from||'',onChange:function onChange(event){return _this2._filterChange(event,'transaction_amount_from');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label ml-2 mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'180px'},type:'number',placeholder:'Input Amount',className:'form-control',value:this.state.filter.transaction_amount_to||'',onChange:function onChange(event){return _this2._filterChange(event,'transaction_amount_to');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:'DD/MM/YYYY',timeFormat:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label ml-2 mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),this.orderStatus.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.code,onChange:function onChange(event){return _this2._filterChange(event,'code');}},this.sourceType.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.type,onChange:function onChange(event){return _this2._productTypeChange(event);}},this.orderType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&this.state.filter.type==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Insurance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.embed,onChange:function onChange(event){return _this2._specialFilterChange(event,'embed');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'yes'},'Included'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'no'},'Excluded'))),this.state.filter.type==='inventory'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.inventory_type,onChange:function onChange(event){return _this2._specialFilterChange(event,'inventory_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'ALL'),category.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name.toUpperCase());}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.payment_method,onChange:function onChange(event){return _this2._filterChange(event,'payment_method');}},this.payment_methods.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Confirmation Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Create Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Payment Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Currency'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Deposit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Admin Fee'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Total Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Discount Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Final Amt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Detail'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!data_detail.data||!data_detail.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'15',className:'text-center'},'- No Data -')):data_detail.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.confirm_date!==null?__WEBPACK_IMPORTED_MODULE_5_moment___default()(item.confirm_date).format(_this2.dateFormat):'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.status||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.salutation+' '+item.first_name+' '+item.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.phone_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_5_moment___default.a.unix(item.created_at).format(_this2.dateFormat)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.order_payments&&item.order_payments.length>0?item.order_payments[0].payment_method:'--No Data--'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center align-middle'},item.currency_code||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.total_deposit_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.total_admin_fee)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.total_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.discount_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.final_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.modems.length!==0&&_this2._renderOrderModem(item.modems),item.attractions.length!==0&&_this2._renderOrderAttraction(item.attractions),item.events.length!==0&&_this2._renderOrderEvent(item.events),item.insurances.length!==0&&_this2._renderOrderInsurance(item.insurances),item.inventories.length!==0&&_this2._renderOrderInventory(item.inventories),item.esim.length!==0&&_this2._renderOrderEsim(item.esim)));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},data_detail&&data_detail.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:data_detail.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:data_detail.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download-list',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Order_DownloadOrderDetailList__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return DetailList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order,category:state.category};};var dispatchToProps=function dispatchToProps(dispatch){return{getOrderDetailList:function getOrderDetailList(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_10__Redux_OrderRedux__["b" /* default */].orderDetailListRequest(filter));},getCategory:function getCategory(){return dispatch(__WEBPACK_IMPORTED_MODULE_11__Redux_CategoryRedux__["b" /* default */].getCategoryRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DetailList));

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadOrderDetailList=function(_React$Component){_inherits(DownloadOrderDetailList,_React$Component);function DownloadOrderDetailList(props){_classCallCheck(this,DownloadOrderDetailList);var _this=_possibleConstructorReturn(this,(DownloadOrderDetailList.__proto__||Object.getPrototypeOf(DownloadOrderDetailList)).call(this,props));_this.componentDidMount=function(){if(Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["c" /* currentRole */])()==='admin_travy'){_this.setState({filter:{code:'AP'}});}};_this._filterChange=function(data,field){var uniq=['page','filterDate','created_from','created_until'];var val=null;if(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["includes"])(uniq,field)){if(field==='created_from'||field==='created_until'){if(Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["isObject"])(data)){val=data;}}else{val=data;}}else{val=data.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=val;_this.setState({filter:filter,apply:false});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.filter);if(_this.state.filter.created_from&&_this.state.filter.created_until){data.created_from=_this.state.filter.created_from.format('Y-MM-DD');data.created_until=_this.state.filter.created_until.format('Y-MM-DD');}else{data.created_from=null;data.created_until=null;}_this.props.download(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY';_this.orderStatus=[{value:'',label:'ALL'},{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'},{value:'payment-failed',label:'FAILED'},{value:'canceled',label:'CANCELED'},{value:'confirmed',label:'CONFIRMED'},{value:'expired',label:'EXPIRED'}];_this.productType=[{value:'',label:'ALL'},{value:'modems',label:'MODEM'},{value:'attractions',label:'ATTRACTION'},{value:'events',label:'EVENT',restriction:['PH']},{value:'insurances',label:'INSURANCE',restriction:['PH']},{value:'inventories',label:'E-COMMERCE'},{value:'esims',label:'ESIM'}].filter(function(option){return!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])())&&!Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["includes"])(option.restriction,Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["c" /* currentRole */])());});_this.sourceSelector=[{value:'ID',label:'Passpod'},{value:'AP',label:'Travypass'}];_this.state={filter:{created_from:null,created_until:null,code:'',status:'',type:''}};return _this;}_createClass(DownloadOrderDetailList,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var created_from=this.state.filter.created_from;var yesterday=created_from;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'25vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download Order Detail List',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.created_from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'created_from');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.created_until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'created_until');},dateFormat:'DD/MM/YYYY',timeFormat:false,isValidDate:function isValidDate(current){return current.isAfter(yesterday);}})),Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["c" /* currentRole */])()!=='admin_travy'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Source'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.code,onChange:function onChange(event){return _this2._filterChange(event,'code');},required:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'Select Source'),this.sourceSelector.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},this.orderStatus.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Product Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.type,onChange:function onChange(event){return _this2._filterChange(event,'type');}},this.productType.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Download')));}}]);return DownloadOrderDetailList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order,auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{download:function download(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderDetailListDownloadRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadOrderDetailList));

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_accounting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_TransferHistoryRedux__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Order_MatchPaymentForm__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Order_MatchManualForm__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Order_DownloadAutoTransferList__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AutoTransferList=function(_React$Component){_inherits(AutoTransferList,_React$Component);function AutoTransferList(props){_classCallCheck(this,AutoTransferList);var _this=_possibleConstructorReturn(this,(AutoTransferList.__proto__||Object.getPrototypeOf(AutoTransferList)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._select=function(){var item=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_this._toggleModal(action);_this.setState({selected:item});};_this._sort=function(){if(_this.state.sort==='seq_yes'){_this.setState({sort:'seq_no'});}else{_this.setState({sort:'seq_yes'});}Object(__WEBPACK_IMPORTED_MODULE_13_core_js__["setTimeout"])(function(){_this._fetchData();},250);};_this._fetchData=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object.assign({},_this.state.filter);var event=arguments[1];var params=Object.assign({},_this.state.filter,filter);if(_this.state.filter.from&&_this.state.filter.until){params.from=_this.state.filter.from.format('Y-MM-DD');params.until=_this.state.filter.until.format('Y-MM-DD');}else{params.from=null;params.until=null;}if(_this.state.sort!=='seq_yes'){params.sort=_this.state.sort;}if(event)event.preventDefault();_this.props.getTransferHistory(params);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchData(filter);};_this._filterChange=function(event,field){var uniq=['page','filterDate','from','until','order_status'];var val=null;if(__WEBPACK_IMPORTED_MODULE_11_lodash_includes___default()(uniq,field)){if(field==='from'||field==='until'){if(__WEBPACK_IMPORTED_MODULE_12_lodash_isObject___default()(event)){val=event;}}else{val=event;}}else{val=event.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=val;_this.setState({filter:filter});};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.processStatus=[{value:'auto-confirm',label:'AUTO CONFIRM'},{value:'manual-confirm',label:'MANUAL CONFIRM'},{value:'manual-match',label:'MANUAL MATCH'},{value:'null',label:'PENDING'}];_this.state={showModal:null,selected:'',sort:'seq_yes',filter:{page:1,from:null,until:null,limit:10,status:'',order_number:'',bank_name:'',amount:''}};return _this;}_createClass(AutoTransferList,[{key:'render',value:function render(){var _this2=this;var transfer_history=this.props.transfer_history;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Auto Transfer List',(transfer_history.fetching||transfer_history.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},transfer_history.fetching?'Loading':'Processing',' ...')),this.props.auth.user&&this.props.auth.user.role!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('download-list');}},'Download List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchData({},event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-group mr-2'},'Order Number: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Order Number',className:'form-control',value:this.state.filter.order_number,onChange:function onChange(event){return _this2._filterChange(event,'order_number');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-group mr-2'},'Customer Bank Name: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Customer Bank Name',className:'form-control',value:this.state.filter.bank_name,onChange:function onChange(event){return _this2._filterChange(event,'bank_name');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'form-group mr-2'},'Amount: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'number',placeholder:'Amount',className:'form-control',value:this.state.filter.amount,onChange:function onChange(event){return _this2._filterChange(event,'amount');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Process Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-Process Status-'),this.processStatus.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'150%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(transfer_history.fetching||transfer_history.processing)&&transfer_history.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},transfer_history.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.auth.user&&this.props.auth.user.role!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Action'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{role:'button',onClick:function onClick(){return _this2._sort();}},'Seq',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-'+(this.state.sort==='seq_yes'?'sort-amount-down':'sort-amount-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Retrieve Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Process Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Transfer Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'DB/CR'),this.props.auth.user&&this.props.auth.user.role!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End Balance'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Customer Bank Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Transfer Note'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!transfer_history.data||!transfer_history.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'10',className:'text-center'},'- NO DATA -')):transfer_history.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},_this2.props.auth.user&&_this2.props.auth.user.role!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.order_id&&item.account_name!=='IONPAY NETWORKS PT'&&item.process_status!=='manual-confirm'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-1',onClick:function onClick(){return _this2._select(item,'payment');}},'Payment'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'manual');}},'Manual')):'-----------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.seq_no),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_5_moment___default.a.unix(item.retrieve_date).format(_this2.dateFormat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.order&&item.order.order_number?item.order.order_number:item.order_id?item.order_id:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.process_status||'PENDING'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(item.amount,{format:'%v',thousand:',',decimal:'.',precision:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.debit_credit),_this2.props.auth.user&&_this2.props.auth.user.role!=='cs'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_2_accounting___default.a.formatMoney(item.end_balance,{format:'%v',thousand:',',decimal:'.',precision:2})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.account_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.note||'-'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='payment',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Order_MatchPaymentForm__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='manual',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Order_MatchManualForm__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='download-list',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Order_DownloadAutoTransferList__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},transfer_history.data&&transfer_history.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:transfer_history.data.page||this.state.filter.page,itemsCountPerPage:this.state.filter.limit,totalItemsCount:transfer_history.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return AutoTransferList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{transfer_history:state.transfer_history,auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{getTransferHistory:function getTransferHistory(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AutoTransferList));

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MatchPaymentForm=function(_React$Component){_inherits(MatchPaymentForm,_React$Component);function MatchPaymentForm(props){_classCallCheck(this,MatchPaymentForm);var _this=_possibleConstructorReturn(this,(MatchPaymentForm.__proto__||Object.getPrototypeOf(MatchPaymentForm)).call(this,props));_this._submit=function(event){if(event)event.preventDefault();var _this$state=_this.state,order_number=_this$state.order_number,process_status=_this$state.process_status,notes=_this$state.notes;var data={id:_this.props.detail.id,form:{order_number:order_number.value||'',process_status:process_status,notes:notes}};_this.props.update(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.state={total_transfer:props.detail.amount,order_number:'',process_status:'manual-match',notes:''};return _this;}_createClass(MatchPaymentForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,transfer_history=_props.transfer_history,detail=_props.detail;var order_list=[];if(detail.orders&&detail.orders.length){detail.orders.map(function(item,i){order_list.push({value:item.order_number,label:'[ '+item.order_number+' ] - '+item.final_amount});return order_list;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Payment Manual Match ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-dark ml-2'},detail.seq_no||'-'),(transfer_history.fetching||transfer_history.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},transfer_history.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Total Transfer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',readOnly:true,value:this.state.total_transfer})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order List'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:order_list,value:this.state.order_number,required:true,onChange:function onChange(order_number){return _this2.setState({order_number:order_number});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.order_number.value||'',required:true,style:{position:'absolute',zIndex:'-1',top:'50%',left:'30%'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save')));}}]);return MatchPaymentForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{transfer_history:state.transfer_history};};var dispatchToProps=function dispatchToProps(dispatch){return{update:function update(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(MatchPaymentForm));

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_TransferHistoryRedux__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MatchManualForm=function(_React$Component){_inherits(MatchManualForm,_React$Component);function MatchManualForm(props){_classCallCheck(this,MatchManualForm);var _this=_possibleConstructorReturn(this,(MatchManualForm.__proto__||Object.getPrototypeOf(MatchManualForm)).call(this,props));_this._submit=function(event){if(event)event.preventDefault();var _this$state=_this.state,order_number=_this$state.order_number,process_status=_this$state.process_status,transfer_amount=_this$state.transfer_amount,note=_this$state.note;var data={id:_this.props.detail.id,form:{order_number:order_number,process_status:process_status,transfer_amount:transfer_amount,note:note}};_this.props.update(data);_this.props.closeModal();};_this.dateFormat='DD MMM YYYY, h:mm:ss a';_this.state={full_name:props.detail.account_name,transfer_amount:props.detail.amount,order_number:'',process_status:'manual-confirm',note:''};return _this;}_createClass(MatchManualForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,transfer_history=_props.transfer_history,detail=_props.detail;// let order_list = []
// detail.orders.length && detail.orders.map((item, i) => {
//   order_list.push({
//     value: item.id,
//     label: `[ ${item.order_number} ] - ${item.amount}`
//   })
//   return order_list
// })
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Manual ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-dark ml-2'},detail.seq_no||'-'),(transfer_history.fetching||transfer_history.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},transfer_history.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Full Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',readOnly:true,value:this.state.full_name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Transfer Amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',readOnly:true,className:'form-control',placeholder:'Transfer Amount',value:this.state.transfer_amount,onChange:function onChange(event){return _this2.setState({transfer_amount:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',placeholder:'Order Number',value:this.state.order_number,onChange:function onChange(event){return _this2.setState({order_number:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Notes (Optional)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control',value:this.state.note,placeholder:'Notes',onChange:function onChange(event){return _this2.setState({note:event.target.value});}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save')));}}]);return MatchManualForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{transfer_history:state.transfer_history};};var dispatchToProps=function dispatchToProps(dispatch){return{update:function update(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(MatchManualForm));

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_TransferHistoryRedux__ = __webpack_require__(117);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DownloadAutoTransferList=function(_React$Component){_inherits(DownloadAutoTransferList,_React$Component);function DownloadAutoTransferList(props){_classCallCheck(this,DownloadAutoTransferList);var _this=_possibleConstructorReturn(this,(DownloadAutoTransferList.__proto__||Object.getPrototypeOf(DownloadAutoTransferList)).call(this,props));_this._filterChange=function(data,field){var uniq=['page','filterDate','from','until'];var val=null;if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(uniq,field)){if(field==='from'||field==='until'){if(__WEBPACK_IMPORTED_MODULE_3_lodash_isObject___default()(data)){val=data;}}else{val=data;}}else{val=data.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=val;_this.setState({filter:filter});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.filter);if(_this.state.filter.from&&_this.state.filter.until){data.from=_this.state.filter.from.format('Y-MM-DD');data.until=_this.state.filter.until.format('Y-MM-DD');}else{data.from=null;data.until=null;}_this.props.download(data);_this.props.closeModal();};_this.processStatus=[{value:'auto-confirm',label:'AUTO CONFIRM'},{value:'manual-confirm',label:'MANUAL CONFIRM'},{value:'manual-match',label:'MANUAL MATCH'}];_this.state={filter:{from:null,until:null,status:''}};return _this;}_createClass(DownloadAutoTransferList,[{key:'render',value:function render(){var _this2=this;var transfer_history=this.props.transfer_history;var from=this.state.filter.from;var yesterday=from;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Download Transfer History',(transfer_history.fetching||transfer_history.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},transfer_history.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:'DD/MM/YYYY',timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:'DD/MM/YYYY',timeFormat:false,isValidDate:function isValidDate(current){return current.isAfter(yesterday);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Process Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'-Select Process-'),this.processStatus.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Download')));}}]);return DownloadAutoTransferList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{transfer_history:state.transfer_history};};var dispatchToProps=function dispatchToProps(dispatch){return{download:function download(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryListDownloadRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DownloadAutoTransferList));

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(946);
__webpack_require__(1143);
__webpack_require__(157);
__webpack_require__(1145);
__webpack_require__(442);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
module.exports = __webpack_require__(43);


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(947);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(967);
__webpack_require__(968);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(971);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(979);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(992);
__webpack_require__(993);
__webpack_require__(994);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(999);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
__webpack_require__(1003);
__webpack_require__(1004);
__webpack_require__(1005);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1038);
__webpack_require__(1039);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(283);
__webpack_require__(1051);
__webpack_require__(426);
__webpack_require__(1052);
__webpack_require__(427);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
__webpack_require__(430);
__webpack_require__(432);
__webpack_require__(433);
__webpack_require__(1058);
__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
__webpack_require__(1071);
__webpack_require__(1072);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1079);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
__webpack_require__(1084);
__webpack_require__(1085);
__webpack_require__(1086);
__webpack_require__(1087);
__webpack_require__(1088);
__webpack_require__(1089);
__webpack_require__(1090);
__webpack_require__(1091);
__webpack_require__(1092);
__webpack_require__(1093);
__webpack_require__(1094);
__webpack_require__(1095);
__webpack_require__(1096);
__webpack_require__(1097);
__webpack_require__(1098);
__webpack_require__(1099);
__webpack_require__(1100);
__webpack_require__(1101);
__webpack_require__(1102);
__webpack_require__(1103);
__webpack_require__(1104);
__webpack_require__(1105);
__webpack_require__(1106);
__webpack_require__(1107);
__webpack_require__(1108);
__webpack_require__(1109);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
__webpack_require__(1115);
__webpack_require__(1116);
__webpack_require__(1117);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(1120);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
module.exports = __webpack_require__(43);


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(12);
var has = __webpack_require__(49);
var DESCRIPTORS = __webpack_require__(23);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(51);
var META = __webpack_require__(101).KEY;
var $fails = __webpack_require__(15);
var shared = __webpack_require__(154);
var setToStringTag = __webpack_require__(139);
var uid = __webpack_require__(118);
var wks = __webpack_require__(21);
var wksExt = __webpack_require__(411);
var wksDefine = __webpack_require__(265);
var enumKeys = __webpack_require__(949);
var isArray = __webpack_require__(203);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(16);
var toObject = __webpack_require__(32);
var toIObject = __webpack_require__(44);
var toPrimitive = __webpack_require__(78);
var createDesc = __webpack_require__(99);
var _create = __webpack_require__(87);
var gOPNExt = __webpack_require__(414);
var $GOPD = __webpack_require__(52);
var $GOPS = __webpack_require__(202);
var $DP = __webpack_require__(25);
var $keys = __webpack_require__(86);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(120).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(156).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(100)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(50)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(154)('native-function-to-string', Function.toString);


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(202);
var pIE = __webpack_require__(156);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(87) });


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperty: __webpack_require__(25).f });


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(23), 'Object', { defineProperties: __webpack_require__(413) });


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(44);
var $getOwnPropertyDescriptor = __webpack_require__(52).f;

__webpack_require__(80)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(32);
var $getPrototypeOf = __webpack_require__(53);

__webpack_require__(80)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(32);
var $keys = __webpack_require__(86);

__webpack_require__(80)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(80)('getOwnPropertyNames', function () {
  return __webpack_require__(414).f;
});


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(80)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(80)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(101).onFreeze;

__webpack_require__(80)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(16);

__webpack_require__(80)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(16);

__webpack_require__(80)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(16);

__webpack_require__(80)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(269) });


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(415) });


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(270).set });


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(102);
var test = {};
test[__webpack_require__(21)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(51)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(416) });


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(25).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(23) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(53);
var HAS_INSTANCE = __webpack_require__(21)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(25).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(417);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(418);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(12);
var has = __webpack_require__(49);
var cof = __webpack_require__(69);
var inheritIfRequired = __webpack_require__(273);
var toPrimitive = __webpack_require__(78);
var fails = __webpack_require__(15);
var gOPN = __webpack_require__(120).f;
var gOPD = __webpack_require__(52).f;
var dP = __webpack_require__(25).f;
var $trim = __webpack_require__(140).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(87)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(23) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(51)(global, NUMBER, $Number);
}


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(70);
var aNumberValue = __webpack_require__(419);
var repeat = __webpack_require__(274);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(15)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(15);
var aNumberValue = __webpack_require__(419);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(12).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(420) });


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(420);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(418);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(417);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(421);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(275);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(276);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(422) });


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(15)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(421) });


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(275) });


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(276);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(15)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(276);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(119);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var toLength = __webpack_require__(24);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(140)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(204)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(205)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(204)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(24);
var context = __webpack_require__(277);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(278)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(277);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(278)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(274)
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(24);
var context = __webpack_require__(277);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(278)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(54)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(54)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(54)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(54)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(54)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(54)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(54)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(54)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(54)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(54)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(54)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(54)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(54)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(78);

$export($export.P + $export.F * __webpack_require__(15)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(1026);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(15);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(51)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(21)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(50)(proto, TO_PRIMITIVE, __webpack_require__(1029));


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(78);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(203) });


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(59);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var call = __webpack_require__(423);
var isArrayIter = __webpack_require__(279);
var toLength = __webpack_require__(24);
var createProperty = __webpack_require__(280);
var getIterFn = __webpack_require__(157);

$export($export.S + $export.F * !__webpack_require__(208)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(280);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(15)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(155) != Object || !__webpack_require__(71)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(268);
var cof = __webpack_require__(69);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(24);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(15)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(37);
var toObject = __webpack_require__(32);
var fails = __webpack_require__(15);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(71)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(81)(0);
var STRICT = __webpack_require__(71)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var isArray = __webpack_require__(203);
var SPECIES = __webpack_require__(21)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(81)(1);

$export($export.P + $export.F * !__webpack_require__(71)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(81)(2);

$export($export.P + $export.F * !__webpack_require__(71)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(81)(3);

$export($export.P + $export.F * !__webpack_require__(71)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(81)(4);

$export($export.P + $export.F * !__webpack_require__(71)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(424);

$export($export.P + $export.F * !__webpack_require__(71)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(424);

$export($export.P + $export.F * !__webpack_require__(71)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(201)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(71)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(44);
var toInteger = __webpack_require__(70);
var toLength = __webpack_require__(24);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(71)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(425) });

__webpack_require__(103)('copyWithin');


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(282) });

__webpack_require__(103)('fill');


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(81)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(103)(KEY);


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(81)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(103)(KEY);


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(122)('Array');


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var inheritIfRequired = __webpack_require__(273);
var dP = __webpack_require__(25).f;
var gOPN = __webpack_require__(120).f;
var isRegExp = __webpack_require__(207);
var $flags = __webpack_require__(158);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(23) && (!CORRECT_NEW || __webpack_require__(15)(function () {
  re2[__webpack_require__(21)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(51)(global, 'RegExp', $RegExp);
}

__webpack_require__(122)('RegExp');


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(427);
var anObject = __webpack_require__(7);
var $flags = __webpack_require__(158);
var DESCRIPTORS = __webpack_require__(23);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(51)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(15)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toLength = __webpack_require__(24);
var advanceStringIndex = __webpack_require__(286);
var regExpExec = __webpack_require__(209);

// @@match logic
__webpack_require__(210)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(70);
var advanceStringIndex = __webpack_require__(286);
var regExpExec = __webpack_require__(209);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(210)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(7);
var sameValue = __webpack_require__(415);
var regExpExec = __webpack_require__(209);

// @@search logic
__webpack_require__(210)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(207);
var anObject = __webpack_require__(7);
var speciesConstructor = __webpack_require__(159);
var advanceStringIndex = __webpack_require__(286);
var toLength = __webpack_require__(24);
var callRegExpExec = __webpack_require__(209);
var regexpExec = __webpack_require__(285);
var fails = __webpack_require__(15);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(210)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(100);
var global = __webpack_require__(12);
var ctx = __webpack_require__(59);
var classof = __webpack_require__(102);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(16);
var aFunction = __webpack_require__(37);
var anInstance = __webpack_require__(123);
var forOf = __webpack_require__(104);
var speciesConstructor = __webpack_require__(159);
var task = __webpack_require__(287).set;
var microtask = __webpack_require__(288)();
var newPromiseCapabilityModule = __webpack_require__(289);
var perform = __webpack_require__(428);
var userAgent = __webpack_require__(211);
var promiseResolve = __webpack_require__(429);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(21)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(124)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(139)($Promise, PROMISE);
__webpack_require__(122)(PROMISE);
Wrapper = __webpack_require__(43)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(208)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(434);
var validate = __webpack_require__(125);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(212)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(213);
var buffer = __webpack_require__(290);
var anObject = __webpack_require__(7);
var toAbsoluteIndex = __webpack_require__(119);
var toLength = __webpack_require__(24);
var isObject = __webpack_require__(16);
var ArrayBuffer = __webpack_require__(12).ArrayBuffer;
var speciesConstructor = __webpack_require__(159);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(15)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(122)(ARRAY_BUFFER);


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(213).ABV, {
  DataView: __webpack_require__(290).DataView
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(88)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(7);
var rApply = (__webpack_require__(12).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(15)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(87);
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(15);
var bind = __webpack_require__(416);
var rConstruct = (__webpack_require__(12).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(25);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(7);
var toPrimitive = __webpack_require__(78);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(15)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(52).f;
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(7);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(206)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(53);
var has = __webpack_require__(49);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(7);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(52);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(53);
var anObject = __webpack_require__(7);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(7);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(291) });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(7);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(25);
var gOPD = __webpack_require__(52);
var getPrototypeOf = __webpack_require__(53);
var has = __webpack_require__(49);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(99);
var anObject = __webpack_require__(7);
var isObject = __webpack_require__(16);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(270);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(201)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(103)('includes');


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(436);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(24);
var aFunction = __webpack_require__(37);
var arraySpeciesCreate = __webpack_require__(281);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(103)('flatMap');


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(436);
var toObject = __webpack_require__(32);
var toLength = __webpack_require__(24);
var toInteger = __webpack_require__(70);
var arraySpeciesCreate = __webpack_require__(281);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(103)('flatten');


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(2);
var $at = __webpack_require__(204)(true);
var $fails = __webpack_require__(15);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(437);
var userAgent = __webpack_require__(211);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(437);
var userAgent = __webpack_require__(211);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(140)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(140)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(2);
var defined = __webpack_require__(79);
var toLength = __webpack_require__(24);
var isRegExp = __webpack_require__(207);
var getFlags = __webpack_require__(158);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(206)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(265)('asyncIterator');


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(265)('observable');


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(291);
var toIObject = __webpack_require__(44);
var gOPD = __webpack_require__(52);
var createProperty = __webpack_require__(280);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(438)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(438)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(25);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(23) && $export($export.P + __webpack_require__(214), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var aFunction = __webpack_require__(37);
var $defineProperty = __webpack_require__(25);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(23) && $export($export.P + __webpack_require__(214), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(53);
var getOwnPropertyDescriptor = __webpack_require__(52).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(214), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(32);
var toPrimitive = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(53);
var getOwnPropertyDescriptor = __webpack_require__(52).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(23) && $export($export.P + __webpack_require__(214), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(439)('Map') });


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(439)('Set') });


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(215)('Map');


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(215)('Set');


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(215)('WeakMap');


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(215)('WeakSet');


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(216)('Map');


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(216)('Set');


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(216)('WeakMap');


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(216)('WeakSet');


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.G, { global: __webpack_require__(12) });


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.S, 'System', { global: __webpack_require__(12) });


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(2);
var cof = __webpack_require__(69);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var scale = __webpack_require__(441);
var fround = __webpack_require__(422);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { scale: __webpack_require__(441) });


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(2);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(43);
var global = __webpack_require__(12);
var speciesConstructor = __webpack_require__(159);
var promiseResolve = __webpack_require__(429);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(289);
var perform = __webpack_require__(428);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(53);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(432);
var from = __webpack_require__(440);
var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(53);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(53);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(89);
var anObject = __webpack_require__(7);
var aFunction = __webpack_require__(37);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(2);
var microtask = __webpack_require__(288)();
var process = __webpack_require__(12).process;
var isNode = __webpack_require__(69)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(2);
var global = __webpack_require__(12);
var core = __webpack_require__(43);
var microtask = __webpack_require__(288)();
var OBSERVABLE = __webpack_require__(21)('observable');
var aFunction = __webpack_require__(37);
var anObject = __webpack_require__(7);
var anInstance = __webpack_require__(123);
var redefineAll = __webpack_require__(124);
var hide = __webpack_require__(50);
var forOf = __webpack_require__(104);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(122)('Observable');


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(12);
var $export = __webpack_require__(2);
var userAgent = __webpack_require__(211);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(287);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(283);
var getKeys = __webpack_require__(86);
var redefine = __webpack_require__(51);
var global = __webpack_require__(12);
var hide = __webpack_require__(50);
var Iterators = __webpack_require__(121);
var wks = __webpack_require__(21);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(59);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(99);
var assign = __webpack_require__(269);
var create = __webpack_require__(87);
var getPrototypeOf = __webpack_require__(53);
var getKeys = __webpack_require__(86);
var dP = __webpack_require__(25);
var keyOf = __webpack_require__(1144);
var aFunction = __webpack_require__(37);
var forOf = __webpack_require__(104);
var isIterable = __webpack_require__(442);
var $iterCreate = __webpack_require__(206);
var step = __webpack_require__(284);
var isObject = __webpack_require__(16);
var toIObject = __webpack_require__(44);
var DESCRIPTORS = __webpack_require__(23);
var has = __webpack_require__(49);

// 0 -> Dict.forEach
// 1 -> Dict.map
// 2 -> Dict.filter
// 3 -> Dict.some
// 4 -> Dict.every
// 5 -> Dict.find
// 6 -> Dict.findKey
// 7 -> Dict.mapPairs
var createDictMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_EVERY = TYPE == 4;
  return function (object, callbackfn, that /* = undefined */) {
    var f = ctx(callbackfn, that, 3);
    var O = toIObject(object);
    var result = IS_MAP || TYPE == 7 || TYPE == 2
          ? new (typeof this == 'function' ? this : Dict)() : undefined;
    var key, val, res;
    for (key in O) if (has(O, key)) {
      val = O[key];
      res = f(val, key, object);
      if (TYPE) {
        if (IS_MAP) result[key] = res;          // map
        else if (res) switch (TYPE) {
          case 2: result[key] = val; break;     // filter
          case 3: return true;                  // some
          case 5: return val;                   // find
          case 6: return key;                   // findKey
          case 7: result[res[0]] = res[1];      // mapPairs
        } else if (IS_EVERY) return false;      // every
      }
    }
    return TYPE == 3 || IS_EVERY ? IS_EVERY : result;
  };
};
var findKey = createDictMethod(6);

var createDictIter = function (kind) {
  return function (it) {
    return new DictIterator(it, kind);
  };
};
var DictIterator = function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._a = getKeys(iterated);   // keys
  this._i = 0;                   // next index
  this._k = kind;                // kind
};
$iterCreate(DictIterator, 'Dict', function () {
  var that = this;
  var O = that._t;
  var keys = that._a;
  var kind = that._k;
  var key;
  do {
    if (that._i >= keys.length) {
      that._t = undefined;
      return step(1);
    }
  } while (!has(O, key = keys[that._i++]));
  if (kind == 'keys') return step(0, key);
  if (kind == 'values') return step(0, O[key]);
  return step(0, [key, O[key]]);
});

function Dict(iterable) {
  var dict = create(null);
  if (iterable != undefined) {
    if (isIterable(iterable)) {
      forOf(iterable, true, function (key, value) {
        dict[key] = value;
      });
    } else assign(dict, iterable);
  }
  return dict;
}
Dict.prototype = null;

function reduce(object, mapfn, init) {
  aFunction(mapfn);
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var i = 0;
  var memo, key;
  if (arguments.length < 3) {
    if (!length) throw TypeError('Reduce of empty object with no initial value');
    memo = O[keys[i++]];
  } else memo = Object(init);
  while (length > i) if (has(O, key = keys[i++])) {
    memo = mapfn(memo, O[key], key, object);
  }
  return memo;
}

function includes(object, el) {
  // eslint-disable-next-line no-self-compare
  return (el == el ? keyOf(object, el) : findKey(object, function (it) {
    // eslint-disable-next-line no-self-compare
    return it != it;
  })) !== undefined;
}

function get(object, key) {
  if (has(object, key)) return object[key];
}
function set(object, key, value) {
  if (DESCRIPTORS && key in Object) dP.f(object, key, createDesc(0, value));
  else object[key] = value;
  return object;
}

function isDict(it) {
  return isObject(it) && getPrototypeOf(it) === Dict.prototype;
}

$export($export.G + $export.F, { Dict: Dict });

$export($export.S, 'Dict', {
  keys: createDictIter('keys'),
  values: createDictIter('values'),
  entries: createDictIter('entries'),
  forEach: createDictMethod(0),
  map: createDictMethod(1),
  filter: createDictMethod(2),
  some: createDictMethod(3),
  every: createDictMethod(4),
  find: createDictMethod(5),
  findKey: findKey,
  mapPairs: createDictMethod(7),
  reduce: reduce,
  keyOf: keyOf,
  includes: includes,
  has: has,
  get: get,
  set: set,
  isDict: isDict
});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(86);
var toIObject = __webpack_require__(44);
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7);
var get = __webpack_require__(157);
module.exports = __webpack_require__(43).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12);
var core = __webpack_require__(43);
var $export = __webpack_require__(2);
var partial = __webpack_require__(443);
// https://esdiscuss.org/topic/promise-returning-delay-function
$export($export.G + $export.F, {
  delay: function delay(time) {
    return new (core.Promise || global.Promise)(function (resolve) {
      setTimeout(partial.call(resolve, true), time);
    });
  }
});


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(444);
var $export = __webpack_require__(2);

// Placeholder
__webpack_require__(43)._ = path._ = path._ || {};

$export($export.P + $export.F, 'Function', { part: __webpack_require__(443) });


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { isObject: __webpack_require__(16) });


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { classof: __webpack_require__(102) });


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var define = __webpack_require__(445);

$export($export.S + $export.F, 'Object', { define: define });


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var define = __webpack_require__(445);
var create = __webpack_require__(87);

$export($export.S + $export.F, 'Object', {
  make: function (proto, mixin) {
    return define(create(proto), mixin);
  }
});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(205)(Number, 'Number', function (iterated) {
  this._l = +iterated;
  this._i = 0;
}, function () {
  var i = this._i++;
  var done = !(i < this._l);
  return { done: done, value: done ? undefined : i };
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(2);
var $re = __webpack_require__(292)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $re = __webpack_require__(292)(/[&<>"']/g, {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});

$export($export.P + $export.F, 'String', { escapeHTML: function escapeHTML() { return $re(this); } });


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $re = __webpack_require__(292)(/&(?:amp|lt|gt|quot|apos);/g, {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&apos;': "'"
});

$export($export.P + $export.F, 'String', { unescapeHTML: function unescapeHTML() { return $re(this); } });


/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Order_ChangeStatusModal__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatus=function(_React$Component){_inherits(ChangeStatus,_React$Component);function ChangeStatus(props){_classCallCheck(this,ChangeStatus);var _this=_possibleConstructorReturn(this,(ChangeStatus.__proto__||Object.getPrototypeOf(ChangeStatus)).call(this,props));_this.componentDidMount=function(){_this._fetchOrder();};_this._fetchOrder=function(filter,event){if(event){event.preventDefault();}var data=Object.assign({},_this.state.filter,filter);_this.props.getOrder(data);};_this._select=function(data,field){_this.setState({selected:data});_this._toggleModal(field);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchOrder({page:page});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._filterChange=function(event,field){var filter=Object.assign({},_this.state.filter);var val=event.target.value;filter[field]=val;_this.setState({filter:filter});};_this.orderStatus=[{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'}];_this.state={selected:'',showModal:null,filter:{q:'',page:1,status:'checkout'}};return _this;}_createClass(ChangeStatus,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block mb-3 d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Change Status',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchOrder(_this2.state.filter,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search by Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'280px'},type:'text',className:'form-control',value:this.state.order_number,onChange:function onChange(event){return _this2._filterChange(event,'q');},minLength:'15',maxLength:'15'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},this.orderStatus.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Apply filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,order.data&&order.data.data&&order.data.data.length?order.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.order_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.unique_number||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'change-status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' ',item.status||'-')));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'-- No Data --'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},order.data&&order.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:order.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:order.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{className:{modal:'modal-large'},open:this.state.showModal==='change-status',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Order_ChangeStatusModal__["a" /* default */],{detail:this.state.selected,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return ChangeStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{getOrder:function getOrder(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ChangeStatus));

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChangeStatusModal=function(_React$Component){_inherits(ChangeStatusModal,_React$Component);function ChangeStatusModal(props){_classCallCheck(this,ChangeStatusModal);var _this=_possibleConstructorReturn(this,(ChangeStatusModal.__proto__||Object.getPrototypeOf(ChangeStatusModal)).call(this,props));_this._uniqueChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state);form.unique_number=val;_this.setState(form);};_this._submit=function(event){event.preventDefault();var data={form:{order_number:_this.state.order_number,status:_this.state.status.value,unique_number:_this.state.unique_number}};_this.props.closeModal();_this.props.submit(data);};_this.orderStatus=[{value:'checkout',label:'CHECKOUT'},{value:'payment-pending',label:'PENDING'}];var _props$detail=props.detail,order_number=_props$detail.order_number,status=_props$detail.status,unique_number=_props$detail.unique_number;var options=[];_this.orderStatus.map(function(status,i){options.push(status);return options;});_this.options=options;status=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(_this.options,function(i){return i.value===status;});_this.state={order_number:order_number,status:status,unique_number:unique_number};return _this;}_createClass(ChangeStatusModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,order=_props.order,detail=_props.detail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);},className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Status ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-secondary ml-2'},detail.order_number),(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},order.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:this.options,value:this.state.status,required:true,onChange:function onChange(status){return _this2.setState({status:status});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.status,required:true,onChange:function onChange(){return null;},style:{position:'absolute',zIndex:'-1',top:'50%',left:'30%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Unique Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',step:'any',className:'form-control',value:this.state.unique_number,onChange:function onChange(event){return _this2._uniqueChange(event,'unique_number');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save')));}}]);return ChangeStatusModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].orderCheckoutRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ChangeStatusModal));

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Events_EventsList__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Events_PopularEvents__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Events_EventsCategories__ = __webpack_require__(1163);
var subList={EventsList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Events_EventsList__["a" /* default */],null),PopularEvents:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Events_PopularEvents__["a" /* default */],null),EventsCategories:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Events_EventsCategories__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotFound__["a" /* default */],null);}};var EventsPage=function EventsPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (EventsPage);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewDetail=function(_React$Component){_inherits(ViewDetail,_React$Component);function ViewDetail(props){_classCallCheck(this,ViewDetail);var _this=_possibleConstructorReturn(this,(ViewDetail.__proto__||Object.getPrototypeOf(ViewDetail)).call(this,props));_this._handleEditMode=function(ID,action){_this.setState({editMode:ID});if(action==='reset'){_this.setState({form:{description:_this.props.props.description}});}};_this._handleChange=function(event){var value=event.target.value;var form=_this.state.form;form.description=value;_this.setState({form:form});};_this._resetEventDescription=function(event_id){var data={event_id:event_id};_this.props.resetEventDescription(data);};_this._updateEventDescription=function(event_id){var data={event_id:event_id,description:_this.state.form.description};_this.props.updateEventDescription(data);setTimeout(function(){_this._handleEditMode('',null);},250);};_this.dateFormat='YYYY-MM-DD';_this.state={editMode:'',form:{description:props.props.description}};return _this;}_createClass(ViewDetail,[{key:'render',value:function render(){var _this2=this;var props=this.props.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'75vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Event Details for ',props.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:props.banner,alt:props.banner,width:'600px'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{readOnly:this.state.editMode==='',style:{minHeight:'25vh'},className:'form-control',value:this.state.form.description,onChange:function onChange(event){return _this2._handleChange(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right mt-3'},props.is_ignored_on_update===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:this.state.editMode==='editing',className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._resetEventDescription(props.event_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-sync'}),' Revert Description'),this.state.editMode===''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._handleEditMode('editing',null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit Description'),this.state.editMode==='editing'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger mr-2',onClick:function onClick(){return _this2._handleEditMode('','reset');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}),' Cancel Edit'),this.state.editMode==='editing'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._updateEventDescription(props.event_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-upload'}),' Save Changes')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Schedule Info')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Start Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.schedules&&__WEBPACK_IMPORTED_MODULE_7_moment___default()(props.schedules[0].start_date).format(this.dateFormat))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'End Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.schedules&&__WEBPACK_IMPORTED_MODULE_7_moment___default()(props.schedules[0].end_date).format(this.dateFormat))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.schedules&&props.schedules[0].location.location_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.schedules&&props.schedules[0].location.address)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Additional Info')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Privacy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Membership'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,props.categories&&props.categories.length>0?props.categories.map(function(li,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i},li.name,' (',li.status?'Active':'Inactive',')');}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'No assigned category'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.is_private_event?'Private':'Public'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,props.required_member?'Required':'Not required')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-primary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'))));}}]);return ViewDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var EventsList=function(_React$Component2){_inherits(EventsList,_React$Component2);function EventsList(props){_classCallCheck(this,EventsList);var _this3=_possibleConstructorReturn(this,(EventsList.__proto__||Object.getPrototypeOf(EventsList)).call(this,props));_initialiseProps.call(_this3);_this3.state={showModal:null,detail:{schedules:[]},q:'',page:1};return _this3;}_createClass(EventsList,[{key:'render',value:function render(){var _this4=this;var events=this.props.events;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Events List',(events.fetching||events.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},events.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__["a" /* default */],{filters:[{type:'text',name:'Name',placeholder:'Insert event name ...',field:'q'}],manipulateState:function manipulateState(props){return _this4._manipulateState(props);},callback:function callback(event){return _this4._fetchAllEvents(event);}})),!(events.fetching||events.processing)&&events.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},events.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__["a" /* default */],{colSpan:5,header:[{field:'Event Name',className:'text-left'},{field:'Organizer'},{field:'Capacity'},{field:'Price'},{field:'View Details'}],body:events.data.data&&events.data.data.length>0&&events.data.data.map(function(item){return[{field:item.name,className:'text-left'},{field:item.organization_name},{field:item.capacity},{field:Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.start_price)},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this4._toggleModal(item,'view-detail');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))}];})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-detail',onClose:function onClose(){return _this4._toggleModal({},null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ViewDetail,{props:this.state.detail,resetEventDescription:function resetEventDescription(data){return _this4._resetEventDescription(data);},updateEventDescription:function updateEventDescription(data){return _this4._updateEventDescription(data);},closeModal:function closeModal(){return _this4._toggleModal({},null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},events.data&&events.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:events.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:events.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return EventsList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this5=this;this.componentDidMount=function(){_this5._fetchAllEvents();};this._fetchAllEvents=function(event){if(event)event.preventDefault();var filter={};if(_this5.state.q){filter={page:1,q:_this5.state.q};}else{filter={page:_this5.state.page,q:''};}_this5.props.getAllEvents(filter);};this._manipulateState=function(props){_this5.setState({q:props.q});};this._selectItem=function(item,action){_this5.setState({detail:item});_this5._toggleModal(action);};this._toggleDetail=function(detail){_this5.setState({detail:detail});};this._toggleModal=function(detail){var modalId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_this5._toggleDetail(detail);_this5.setState({showModal:modalId});if(!modalId){_this5._fetchAllEvents();}};this._changePage=function(page){_this5.setState({page:page});setTimeout(function(){_this5._fetchAllEvents();},250);};this._resetEventDescription=function(data){_this5.props.resetEventDescription(data);};this._updateEventDescription=function(data){_this5.props.updateEventDescription(data);};};var stateToProps=function stateToProps(state){return{events:state.events};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllEvents:function getAllEvents(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllEventsRequest(filter));},updateEventDescription:function updateEventDescription(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].updateEventDescriptionRequest(data));},resetEventDescription:function resetEventDescription(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].resetEventDescriptionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EventsList));

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Events_CreateEventsPriority__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Events_UpdateEventsPriority__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_EventsRedux__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PopularEvents=function(_React$Component){_inherits(PopularEvents,_React$Component);function PopularEvents(props){_classCallCheck(this,PopularEvents);var _this=_possibleConstructorReturn(this,(PopularEvents.__proto__||Object.getPrototypeOf(PopularEvents)).call(this,props));_this.componentDidMount=function(){_this._fetchAllPopularEvents();};_this._fetchAllPopularEvents=function(event){if(event){event.preventDefault();}_this.props.getAllPopularEvents();};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._deletePriority=function(){var form={is_popular:false,priority:0};var data={event_id:_this.state.detail.event_id,form:form};_this.props.deletePriority(data);setTimeout(function(){_this._toggleModal();},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchAllPopularEvents();}};_this.dateformat='YYYY-MM-DD';_this.state={showModal:null,detail:{}};return _this;}_createClass(PopularEvents,[{key:'render',value:function render(){var _this2=this;var events=this.props.events;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Popular Events List',(events.fetching||events.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},events.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-priority');}},'Add Popular Event'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(events.fetching||events.processing)&&events.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},events.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Event Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Organizer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Schedule Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Priority'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!events.data_popular||events.data_popular.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'7',className:'text-center'},'--No Data--')):events.data_popular.length&&events.data_popular.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,item.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!item.categories.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-oval btn-danger'},'No Categories'):item.categories&&item.categories.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:i,className:'btn btn-oval btn-primary mr-1'},item.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},item.organization_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center',style:{width:'70%'}},item.schedules.length&&item.schedules.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{key:i,width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Location')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.location.location_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.location.address)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Start Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.start_date).format(_this2.dateformat))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'End Date')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.end_date).format(_this2.dateformat)))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,item.priority)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-priority');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-priority');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='create-priority',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Events_CreateEventsPriority__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='update-priority',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Events_UpdateEventsPriority__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-priority',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Delete Priority?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.detail.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deletePriority();}},'Delete'))))));}}]);return PopularEvents;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{events:state.events};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllPopularEvents:function getAllPopularEvents(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_EventsRedux__["b" /* default */].getAllPopularEventsRequest(filter));},deletePriority:function deletePriority(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_EventsRedux__["b" /* default */].setPopularEventRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(PopularEvents));

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateEventsPriority=function(_React$Component){_inherits(CreateEventsPriority,_React$Component);function CreateEventsPriority(props){_classCallCheck(this,CreateEventsPriority);var _this=_possibleConstructorReturn(this,(CreateEventsPriority.__proto__||Object.getPrototypeOf(CreateEventsPriority)).call(this,props));_this.componentDidMount=function(){_this._fetchAllEvents();};_this._fetchAllEvents=function(event){if(event){event.preventDefault();}var filter={page:1,limit:1000};_this.props.getAllEvents(filter);};_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);if(field==='event_id'){form.event_id=event.value;_this.setState({selectedEvent:event,form:form});}else{var value=event.target.value;form[field]=value;_this.setState({form:form});}};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={event_id:_this.state.form.event_id,form:form};_this.props.setPriority(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={selectedEvent:'',form:{event_id:'',is_popular:true,priority:''}};return _this;}_createClass(CreateEventsPriority,[{key:'render',value:function render(){var _this2=this;var events=this.props.events;// populate event selector
var eventPicker=[];events.data.data&&events.data.data.length&&events.data.data.map(function(item,i){eventPicker[i]={value:item.event_id,label:item.name};return eventPicker;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Add Popular Event')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Event')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:eventPicker,name:'event-picker',required:true,placeholder:'Pick Available Event',value:this.state.selectedEvent,onChange:function onChange(selectedEvent){return _this2._inputChange(selectedEvent,'event_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Set Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'priority-input',type:'number',min:'1',max:'12',className:'form-control',placeholder:'Set Priority',value:this.state.form.priority,onChange:function onChange(event){return _this2._inputChange(event,'priority');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save'))));}}]);return CreateEventsPriority;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{events:state.events};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllEvents:function getAllEvents(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__["b" /* default */].getAllEventsRequest(filter));},setPriority:function setPriority(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__["b" /* default */].setPopularEventRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateEventsPriority));

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateEventsPriority=function(_React$Component){_inherits(UpdateEventsPriority,_React$Component);function UpdateEventsPriority(props){_classCallCheck(this,UpdateEventsPriority);var _this=_possibleConstructorReturn(this,(UpdateEventsPriority.__proto__||Object.getPrototypeOf(UpdateEventsPriority)).call(this,props));_this._inputChange=function(event,field){var target=event.target;var value=target.type==='checkbox'?target.checked:target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={event_id:_this.state.event_id,form:form};_this.props.setPriority(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={event_name:_this.props.detail.name,event_id:_this.props.detail.event_id,form:{is_popular:true,priority:props.detail.priority}};return _this;}_createClass(UpdateEventsPriority,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Events Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Event')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',disabled:true,value:this.state.event_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Set Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._inputChange(event,'priority');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save')))));}}]);return UpdateEventsPriority;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{setPriority:function setPriority(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__["b" /* default */].setPopularEventRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateEventsPriority));

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventsCategories=function(_React$Component){_inherits(EventsCategories,_React$Component);function EventsCategories(props){_classCallCheck(this,EventsCategories);var _this=_possibleConstructorReturn(this,(EventsCategories.__proto__||Object.getPrototypeOf(EventsCategories)).call(this,props));_this.componentDidMount=function(){_this._fetchEventsCategories();};_this._fetchEventsCategories=function(event){if(event){event.preventDefault();}_this.props.getEventsCategories();};_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(EventsCategories,[{key:'render',value:function render(){var events=this.props.events;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Events Categories',(events.fetching||events.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},events.fetching?'Loading':'Processing',' ...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(events.fetching||events.processing)&&events.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},events.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Category Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Category Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!events.data_category||events.data_category.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'--No Data--')):events.data_category.length&&events.data_category.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.status===true?'Active':'Inactive'));}))))));}}]);return EventsCategories;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{events:state.events};};var dispatchToProps=function dispatchToProps(dispatch){return{getEventsCategories:function getEventsCategories(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EventsRedux__["b" /* default */].getEventsCategoriesRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EventsCategories));

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Insurance_TravelPackageList__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Insurance_TicketPackageList__ = __webpack_require__(1173);
var subList={TravelPackageList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Insurance_TravelPackageList__["a" /* default */],null),TicketPackageList:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Insurance_TicketPackageList__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotFound__["a" /* default */],null);}};var InsurancePage=function InsurancePage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (InsurancePage);

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_CreateTravelPackage__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Insurance_UpdateTravelPackage__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Insurance_ViewTravelPrice__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_EllipsisModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_AdvancedTable__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TravelPackages=function(_React$Component){_inherits(TravelPackages,_React$Component);function TravelPackages(props){_classCallCheck(this,TravelPackages);var _this=_possibleConstructorReturn(this,(TravelPackages.__proto__||Object.getPrototypeOf(TravelPackages)).call(this,props));_this.componentDidMount=function(){_this._fetchTravelPackages();};_this._fetchTravelPackages=function(event){if(event){event.preventDefault();}_this.props.getTravelPackage();};_this._deleteTravelPackage=function(){var form={status:0};var data={id:_this.state.detail.id,form:form};_this.props.deleteTravelPackage(data);setTimeout(function(){_this._toggleModal();},250);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._toggleModal=function(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:action});if(!action){_this._fetchTravelPackages();}};_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(TravelPackages,[{key:'render',value:function render(){var _this2=this;var insurance=this.props.insurance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Travel Package List',(insurance.fetching||insurance.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},insurance.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-travel-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create Travel Package'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},!(insurance.fetching||insurance.processing)&&insurance.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},insurance.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_AdvancedTable__["a" /* default */],{colSpan:6,header:[{field:'Package Name',className:'text-left'},{field:'Type'},{field:'Destination'},{field:'View',colSpan:2},{field:'Edit'},{field:'Delete'}],body:insurance.data&&insurance.data.length>0&&insurance.data.map(function(item){return[{field:item.name,className:'text-left'},{field:item.type},{field:item.destination_type},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._selectItem(item,'view-travel-price');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}),' Price List')},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_EllipsisModal__["a" /* default */],{descriptor:'Description',name:item.name,description:item.description,type:'HTML'})},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-travel-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-travel-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-travel-price',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Insurance_ViewTravelPrice__["a" /* default */],{uuid:this.state.detail.id,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-travel-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_CreateTravelPackage__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-travel-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Insurance_UpdateTravelPackage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='delete-travel-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Delete Travel Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.detail.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteTravelPackage();}},'Delete')))));}}]);return TravelPackages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{insurance:state.insurance};};var dispatchToProps=function dispatchToProps(dispatch){return{getTravelPackage:function getTravelPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTravelPackageRequest(data));},deleteTravelPackage:function deleteTravelPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTravelPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(TravelPackages));

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateTravelPackage=function(_React$Component){_inherits(CreateTravelPackage,_React$Component);function CreateTravelPackage(props){_classCallCheck(this,CreateTravelPackage);var _this=_possibleConstructorReturn(this,(CreateTravelPackage.__proto__||Object.getPrototypeOf(CreateTravelPackage)).call(this,props));_this._inputChange=function(event,field){var val='';if(field==='description'){val=event.target.getContent();}else{val=event.target.value;}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.props.post(form);setTimeout(function(){_this.props.closeModal();},250);};_this.types=[{value:'individu',label:'Individu'},{value:'family',label:'Family'}];_this.destination_types=[{value:'overseas',label:'Overseas'},{value:'domestic',label:'Domestic'}];_this.state={form:{name:'',description:'',type:'',destination_type:''}};return _this;}_createClass(CreateTravelPackage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Travel Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__["a" /* Editor */],{initialValue:this.state.form.description,init:{plugins:'table lists textcolor colorpicker',menubar:false,branding:false,toolbar1:'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',toolbar2:'alignleft aligncenter alignright | indent outdent | numlist bullist | table',height:350},onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Insurance Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{required:true,className:'form-control',value:this.state.form.type,onChange:function onChange(event){return _this2._inputChange(event,'type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Pick a Type'),this.types.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Destination Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{required:true,className:'form-control',value:this.state.form.destination_type,onChange:function onChange(event){return _this2._inputChange(event,'destination_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Pick a Destination Type'),this.destination_types.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateTravelPackage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{post:function post(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__["b" /* default */].postTravelPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateTravelPackage));

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Editor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TinyMCE__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditorPropTypes__ = __webpack_require__(447);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};





var scriptState = __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__["a" /* create */]();
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.initialise = function () {
            var finalInit = __assign({}, _this.props.init, { target: _this.element, readonly: _this.props.disabled, inline: _this.inline, plugins: Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["d" /* mergePlugins */])(_this.props.init && _this.props.init.plugins, _this.props.plugins), toolbar: _this.props.toolbar || (_this.props.init && _this.props.init.toolbar), setup: function (editor) {
                    _this.editor = editor;
                    editor.on('init', function (e) {
                        _this.initEditor(e, editor);
                    });
                    if (_this.props.init && typeof _this.props.init.setup === 'function') {
                        _this.props.init.setup(editor);
                    }
                } });
            if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* isTextarea */])(_this.element)) {
                _this.element.style.visibility = '';
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])().init(finalInit);
        };
        return _this;
    }
    Editor.prototype.componentWillMount = function () {
        this.id = this.id || this.props.id || Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["e" /* uuid */])('tiny-react');
        this.inline = this.props.inline ? this.props.inline : this.props.init && this.props.init.inline;
    };
    Editor.prototype.componentDidMount = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])() !== null) {
            this.initialise();
        }
        else if (this.element && this.element.ownerDocument) {
            var doc = this.element.ownerDocument;
            var channel = this.props.cloudChannel ? this.props.cloudChannel : 'stable';
            var apiKey = this.props.apiKey ? this.props.apiKey : '';
            __WEBPACK_IMPORTED_MODULE_1__ScriptLoader__["b" /* load */](scriptState, doc, "https://cloud.tinymce.com/" + channel + "/tinymce.min.js?apiKey=" + apiKey, this.initialise);
        }
    };
    Editor.prototype.componentWillUnmount = function () {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])() !== null) {
            Object(__WEBPACK_IMPORTED_MODULE_2__TinyMCE__["a" /* getTinymce */])().remove(this.editor);
        }
    };
    Editor.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.editor && this.editor.initialized) {
            this.currentContent = this.currentContent || this.editor.getContent();
            if (typeof nextProps.value === 'string' && nextProps.value !== this.props.value && nextProps.value !== this.currentContent) {
                this.editor.setContent(nextProps.value);
            }
            if (typeof nextProps.disabled === 'boolean' && nextProps.disabled !== this.props.disabled) {
                this.editor.setMode(nextProps.disabled ? 'readonly' : 'design');
            }
        }
    };
    Editor.prototype.render = function () {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.initEditor = function (initEvent, editor) {
        var _this = this;
        var value = typeof this.props.value === 'string' ? this.props.value : typeof this.props.initialValue === 'string' ? this.props.initialValue : '';
        editor.setContent(value);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["b" /* isFunction */])(this.props.onEditorChange)) {
            editor.on('change keyup setcontent', function (e) {
                _this.currentContent = editor.getContent();
                if (Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["b" /* isFunction */])(_this.props.onEditorChange)) {
                    _this.props.onEditorChange(_this.currentContent);
                }
            });
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__Utils__["a" /* bindHandlers */])(this.props, editor, initEvent);
    };
    Editor.prototype.renderInline = function () {
        var _this = this;
        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](tagName, {
            ref: function (elm) { return (_this.element = elm); },
            id: this.id
        });
    };
    Editor.prototype.renderIframe = function () {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("textarea", { ref: function (elm) { return (_this.element = elm); }, style: { visibility: 'hidden' }, id: this.id, name: this.props.textareaName });
    };
    Editor.propTypes = __WEBPACK_IMPORTED_MODULE_4__EditorPropTypes__["a" /* EditorPropTypes */];
    return Editor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));



/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return load; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(446);
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var injectScriptTag = function (scriptId, doc, url, callback) {
    var scriptTag = doc.createElement('script');
    scriptTag.type = 'application/javascript';
    scriptTag.id = scriptId;
    scriptTag.addEventListener('load', callback);
    scriptTag.src = url;
    if (doc.head) {
        doc.head.appendChild(scriptTag);
    }
};
var create = function () {
    return {
        listeners: [],
        scriptId: Object(__WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* uuid */])('tiny-script'),
        scriptLoaded: false
    };
};
var load = function (state, doc, url, callback) {
    if (state.scriptLoaded) {
        callback();
    }
    else {
        state.listeners.push(callback);
        if (!doc.getElementById(state.scriptId)) {
            injectScriptTag(state.scriptId, doc, url, function () {
                state.listeners.forEach(function (fn) { return fn(); });
                state.scriptLoaded = true;
            });
        }
    }
};


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTinymce; });
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
var getTinymce = function () {
    var global = getGlobal();
    return global && global.tinymce ? global.tinymce : null;
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(63)))

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateTravelPackage=function(_React$Component){_inherits(UpdateTravelPackage,_React$Component);function UpdateTravelPackage(props){_classCallCheck(this,UpdateTravelPackage);var _this=_possibleConstructorReturn(this,(UpdateTravelPackage.__proto__||Object.getPrototypeOf(UpdateTravelPackage)).call(this,props));_this._inputChange=function(event,field){var val='';if(field==='description'){val=event.target.getContent();}else{val=event.target.value;}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.put(data);setTimeout(function(){_this.props.closeModal();},250);};_this.types=[{value:'individu',label:'Individu'},{value:'family',label:'Family'}];_this.destination_types=[{value:'overseas',label:'Overseas'},{value:'domestic',label:'Domestic'}];_this.state={form:{name:props.detail.name||'',description:props.detail.description||'',type:props.detail.type||'',destination_type:props.detail.destination_type||''}};return _this;}_createClass(UpdateTravelPackage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Travel Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert package name here',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__["a" /* Editor */],{initialValue:this.state.form.description,init:{plugins:'table lists textcolor colorpicker',menubar:false,branding:false,toolbar1:'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',toolbar2:'alignleft aligncenter alignright | indent outdent | numlist bullist | table',height:350},onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Insurance Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{required:true,className:'form-control',value:this.state.form.type,onChange:function onChange(event){return _this2._inputChange(event,'type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Pick a Type'),this.types.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Destination Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{required:true,className:'form-control',value:this.state.form.destination_type,onChange:function onChange(event){return _this2._inputChange(event,'destination_type');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Pick a Destination Type'),this.destination_types.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateTravelPackage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{put:function put(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__["b" /* default */].putTravelPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateTravelPackage));

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_UpdateTravelPackagePrice__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewTravelPrice=function(_React$Component){_inherits(ViewTravelPrice,_React$Component);function ViewTravelPrice(props){_classCallCheck(this,ViewTravelPrice);var _this=_possibleConstructorReturn(this,(ViewTravelPrice.__proto__||Object.getPrototypeOf(ViewTravelPrice)).call(this,props));_this.componentDidMount=function(){_this._fetchTravelPackageView();};_this._fetchTravelPackageView=function(event){if(event){event.preventDefault();}var data={id:_this.state.id};_this.props.viewTravelPackage(data);};_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._selectItem=function(item,action){_this.setState({details:item});_this._toggleModal(action);};_this._toggleStatus=function(item){var status=item.status;status===0?status=1:status=0;var data={parent_id:_this.state.id,child_id:item.id,form:{status:status}};_this.props.switchTravelPackagePrice(data);setTimeout(function(){_this._fetchTravelPackageView();},250);};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.state.id,form:form};_this.props.postTravelPackagePrice(data);setTimeout(function(){_this._fetchTravelPackageView();},250);};_this._toggleModal=function(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:action});if(!action){_this._fetchTravelPackageView();}};_this.state={details:{},showModal:null,switcher:false,id:props.uuid,form:{start_day:'',end_day:'',price:'',currency_code:'IDR'}};return _this;}_createClass(ViewTravelPrice,[{key:'render',value:function render(){var _this2=this;var insurance=this.props.insurance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Travel Package Price List',(insurance.fetching||insurance.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},insurance.fetching?'Fetching ...':'Processing ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start Day')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'Insert start day count here',value:this.state.form.start_day,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'start_day');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End Day')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'Insert end day count here',value:this.state.form.end_day,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'end_day');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'Insert day package price here',value:this.state.form.price,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-info mb-3'},'Add Package ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-square'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Start Day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'End Day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,insurance.data_view.map(function(item,i){return!item.travel_package_price||item.travel_package_price.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'5'},'No Data')):item.travel_package_price.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.start_day),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.end_day),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'edit-travel-package-price');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a,{checked:item.status===1,onChange:function onChange(){return _this2._toggleStatus(item);}})));});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-travel-package-price',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_UpdateTravelPackagePrice__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},parent_id:this.state.id,detail:this.state.details})));}}]);return ViewTravelPrice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{insurance:state.insurance};};var dispatchToProps=function dispatchToProps(dispatch){return{viewTravelPackage:function viewTravelPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].viewTravelPackageRequest(data));},postTravelPackagePrice:function postTravelPackagePrice(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTravelPackagePriceRequest(data));},switchTravelPackagePrice:function switchTravelPackagePrice(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].switchTravelPackagePriceRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewTravelPrice));

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateTravelPackagePrice=function(_React$Component){_inherits(UpdateTravelPackagePrice,_React$Component);function UpdateTravelPackagePrice(props){_classCallCheck(this,UpdateTravelPackagePrice);var _this=_possibleConstructorReturn(this,(UpdateTravelPackagePrice.__proto__||Object.getPrototypeOf(UpdateTravelPackagePrice)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={parent_id:_this.state.parent_id,child_id:_this.state.child_id,form:form};_this.props.putTravelPackagePriceRequest(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={parent_id:props.parent_id||'',child_id:props.detail.id||'',form:{start_day:props.detail.start_day||'',end_day:props.detail.end_day||'',price:props.detail.price||''}};return _this;}_createClass(UpdateTravelPackagePrice,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Update Travel Package Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start Day')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'placeholder',className:'form-control',value:this.state.form.start_day,onChange:function onChange(event){return _this2._inputChange(event,'start_day');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End Day')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'placeholder',className:'form-control',value:this.state.form.end_day,onChange:function onChange(event){return _this2._inputChange(event,'end_day');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',required:true,placeholder:'placeholder',className:'form-control',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateTravelPackagePrice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{putTravelPackagePriceRequest:function putTravelPackagePriceRequest(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTravelPackagePriceRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateTravelPackagePrice));

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_CreateTicketPackage__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Insurance_UpdateTicketPackage__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_EllipsisModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_AdvancedTable__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TicketPackages=function(_React$Component){_inherits(TicketPackages,_React$Component);function TicketPackages(props){_classCallCheck(this,TicketPackages);var _this=_possibleConstructorReturn(this,(TicketPackages.__proto__||Object.getPrototypeOf(TicketPackages)).call(this,props));_this.componentDidMount=function(){_this._fetchTicketPackages();};_this._fetchTicketPackages=function(event){if(event){event.preventDefault();}_this.props.getTicketPackage();};_this._deleteTicketPackage=function(){var form={status:0};var data={id:_this.state.detail.id,form:form};_this.props.deleteTicketPackage(data);setTimeout(function(){_this._toggleModal();},250);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._toggleModal=function(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:action});if(!action){_this._fetchTicketPackages();}};_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(TicketPackages,[{key:'render',value:function render(){var _this2=this;var insurance=this.props.insurance;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Ticket Package List',(insurance.fetching||insurance.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},insurance.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-ticket-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create Ticket Package'))),!(insurance.fetching||insurance.processing)&&insurance.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},insurance.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_AdvancedTable__["a" /* default */],{colSpan:7,header:[{field:'Package Name',className:'text-left'},{field:'Description'},{field:'Package Price'},{field:'Start Amount'},{field:'End Amount'},{field:'Edit'},{field:'Delete'}],body:insurance.data&&insurance.data.length>0&&insurance.data.map(function(item){return[{field:item.name,className:'text-left'},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_EllipsisModal__["a" /* default */],{descriptor:'View Description',name:item.name,description:item.description,type:'HTML'})},{field:Object(__WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__["a" /* default */])(item.price)},{field:Object(__WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__["a" /* default */])(item.start_amount)},{field:Object(__WEBPACK_IMPORTED_MODULE_7__Utils_FormatMoney__["a" /* default */])(item.end_amount)},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-ticket-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-ticket-package');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-ticket-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Insurance_CreateTicketPackage__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-ticket-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Insurance_UpdateTicketPackage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='delete-ticket-package',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Delete Ticket Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.detail.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteTicketPackage();}},'Delete')))));}}]);return TicketPackages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{insurance:state.insurance};};var dispatchToProps=function dispatchToProps(dispatch){return{getTicketPackage:function getTicketPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTicketPackageRequest(data));},deleteTicketPackage:function deleteTicketPackage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTicketPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(TicketPackages));

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateTicketPackage=function(_React$Component){_inherits(CreateTicketPackage,_React$Component);function CreateTicketPackage(props){_classCallCheck(this,CreateTicketPackage);var _this=_possibleConstructorReturn(this,(CreateTicketPackage.__proto__||Object.getPrototypeOf(CreateTicketPackage)).call(this,props));_this._inputChange=function(event,field){var val='';if(field==='description'){val=event.target.getContent();}else{val=event.target.value;}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.props.post(form);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:'',price:null,start_amount:null,end_amount:null,description:''}};return _this;}_createClass(CreateTicketPackage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Ticket Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'',className:'form-control',value:this.state.form.start_amount,onChange:function onChange(event){return _this2._inputChange(event,'start_amount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'',className:'form-control',value:this.state.form.end_amount,onChange:function onChange(event){return _this2._inputChange(event,'end_amount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'Insert package price here',className:'form-control',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__["a" /* Editor */],{initialValue:this.state.form.description,init:{plugins:'table lists textcolor colorpicker',menubar:false,branding:false,toolbar1:'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',toolbar2:'alignleft aligncenter alignright | indent outdent | numlist bullist | table',height:350},onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateTicketPackage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{post:function post(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__["b" /* default */].postTicketPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateTicketPackage));

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateTicketPackage=function(_React$Component){_inherits(UpdateTicketPackage,_React$Component);function UpdateTicketPackage(props){_classCallCheck(this,UpdateTicketPackage);var _this=_possibleConstructorReturn(this,(UpdateTicketPackage.__proto__||Object.getPrototypeOf(UpdateTicketPackage)).call(this,props));_this._inputChange=function(event,field){var val='';if(field==='description'){val=event.target.getContent();}else{val=event.target.value;}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.put(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:props.detail.name||'',price:props.detail.price||0,start_amount:props.detail.start_amount||0,end_amount:props.detail.end_amount||0,description:props.detail.description||''}};return _this;}_createClass(UpdateTicketPackage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'70vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Ticket Package')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert package name here',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'Insert package price here',className:'form-control',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Start Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'',className:'form-control',value:this.state.form.start_amount,onChange:function onChange(event){return _this2._inputChange(event,'start_amount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'End Amount')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',required:true,placeholder:'',className:'form-control',value:this.state.form.end_amount,onChange:function onChange(event){return _this2._inputChange(event,'end_amount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tinymce_tinymce_react__["a" /* Editor */],{initialValue:this.state.form.description,init:{plugins:'table lists textcolor colorpicker',menubar:false,branding:false,toolbar1:'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',toolbar2:'alignleft aligncenter alignright | indent outdent | numlist bullist | table',height:350},onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateTicketPackage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{put:function put(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_InsuranceRedux__["b" /* default */].putTicketPackageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateTicketPackage));

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_ManageAdmin_CreateAdmin__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_ManageAdmin_UpdateAdmin__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_ManageAdmin_DeleteAdmin__ = __webpack_require__(1179);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageAdminPage=function(_React$Component){_inherits(ManageAdminPage,_React$Component);function ManageAdminPage(props){_classCallCheck(this,ManageAdminPage);var _this=_possibleConstructorReturn(this,(ManageAdminPage.__proto__||Object.getPrototypeOf(ManageAdminPage)).call(this,props));_this.componentDidMount=function(){_this._fetchUser();};_this._fetchUser=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:_this.state.filter.page};var params=Object.assign({},filter,{only_admins:_this.only_admins});_this.props.getUser(params);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._select=function(data,action){_this.setState({detail:data});_this._toggleModal(action);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchUser({page:page});};_this.only_admins=true;_this.state={showModal:null,detail:{},filter:{page:1}};return _this;}_createClass(ManageAdminPage,[{key:'render',value:function render(){var _this2=this;var _props=this.props,user=_props.user,auth=_props.auth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Admin',(user.fetching||user.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},user.fetching?'Loading':'Processing',' ...')),auth.user&&auth.user.role==='admin'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create');}},'Create Admin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(user.fetching||user.processing)&&user.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},user.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'#')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Role'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!user.data||!user.data.data&&!user.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'11',className:'text-center'},'- No Data -')):user.data.data.map(function(item,i){var name='-';if(item.first_name||item.last_name){name=item.first_name+' '+item.last_name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i,className:'admin-tr '+(auth.user&&auth.user.id===item.id?'table-success':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,(user.data.page-1)*10+(i+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.email||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.role||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-'+(item.active?'success':'danger')},item.active?'Active':'Disabled')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._select(item,'update');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.role!=='admin'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._select(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})):'-----'));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_ManageAdmin_CreateAdmin__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='update',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_ManageAdmin_UpdateAdmin__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_ManageAdmin_DeleteAdmin__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},user.data&&user.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:user.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:user.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return ManageAdminPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{user:state.user,auth:state.auth};};var dispatchToProps=function dispatchToProps(dispatch){return{getUser:function getUser(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_UserRedux__["b" /* default */].userRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageAdminPage));

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateAdmin=function(_React$Component){_inherits(CreateAdmin,_React$Component);function CreateAdmin(props){_classCallCheck(this,CreateAdmin);var _this=_possibleConstructorReturn(this,(CreateAdmin.__proto__||Object.getPrototypeOf(CreateAdmin)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data=_this.state.form;_this.props.createUser(data);_this.props.closeModal();};_this.roles=[{value:'admin',label:'Admin'},{value:'finance',label:'Finance'},{value:'cs',label:'CS'}];_this.state={form:{first_name:'',last_name:'',role:_this.roles[0].value,email:'',password:''}};return _this;}_createClass(CreateAdmin,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Admin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'First Name',className:'form-control',value:this.state.form.first_name,onChange:function onChange(event){return _this2._inputChange(event,'first_name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Last Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Last Name',className:'form-control',value:this.state.form.last_name,onChange:function onChange(event){return _this2._inputChange(event,'last_name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Role')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.form.role,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'role');}},this.roles.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:item.value,key:i},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'email',required:true,placeholder:'Email',className:'form-control',value:this.state.form.email,onChange:function onChange(event){return _this2._inputChange(event,'email');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',required:true,placeholder:'password',className:'form-control',value:this.state.form.password,onChange:function onChange(event){return _this2._inputChange(event,'password');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return CreateAdmin;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createUser:function createUser(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__["b" /* default */].userCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateAdmin));

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_ObjectCleaner__ = __webpack_require__(198);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateAdmin=function(_React$Component){_inherits(UpdateAdmin,_React$Component);function UpdateAdmin(props){_classCallCheck(this,UpdateAdmin);var _this=_possibleConstructorReturn(this,(UpdateAdmin.__proto__||Object.getPrototypeOf(UpdateAdmin)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=_this.state.form;form=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_ObjectCleaner__["a" /* default */])(form);if(form.active==="active"){form.active=true;}else{form.active=false;}var data={id:_this.props.detail.id,form:form};_this.props.updateUser(data);_this.props.closeModal();};_this.roles=[{value:'admin',label:'Admin'},{value:'finance',label:'Finance'},{value:'cs',label:'CS'}];_this.state={form:{first_name:props.detail.first_name,last_name:props.detail.last_name,password:'',active:props.detail.active?'active':'disabled'}};return _this;}_createClass(UpdateAdmin,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Admin')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'First Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'First Name',className:'form-control',value:this.state.form.first_name,onChange:function onChange(event){return _this2._inputChange(event,'first_name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Last Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Last Name',className:'form-control',value:this.state.form.last_name,onChange:function onChange(event){return _this2._inputChange(event,'last_name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Password')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'password',placeholder:'password',className:'form-control',value:this.state.form.password,onChange:function onChange(event){return _this2._inputChange(event,'password');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.active,onChange:function onChange(event){return _this2._inputChange(event,'active');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'active'},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'disabled'},'Disabled')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return UpdateAdmin;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateUser:function updateUser(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__["b" /* default */].userUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateAdmin));

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteAdmin=function(_React$Component){_inherits(DeleteAdmin,_React$Component);function DeleteAdmin(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeleteAdmin);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeleteAdmin.__proto__||Object.getPrototypeOf(DeleteAdmin)).call.apply(_ref,[this].concat(args))),_this),_this._submit=function(event){event.preventDefault();_this.props.deleteUser(_this.props.detail.id);_this.props.closeModal();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeleteAdmin,[{key:'render',value:function render(){var _this2=this;var detail=this.props.detail;var name='-';if(detail.first_name||detail.last_name){name=detail.first_name+' '+detail.last_name;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Delete ',name,'?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',type:'submit'},'Delete'))));}}]);return DeleteAdmin;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteUser:function deleteUser(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_UserRedux__["b" /* default */].userDeleteRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeleteAdmin));

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Travypass_ManageTravypass__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Travypass_OrderReport__ = __webpack_require__(1185);
var subList={ManageTravypass:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Travypass_ManageTravypass__["a" /* default */],null),OrderReport:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Travypass_OrderReport__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotFound__["a" /* default */],null);}};var TravypassPage=function TravypassPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (TravypassPage);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Travypass_FormCreate__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Travypass_UpdateContent__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Travypass_UpdateImage__ = __webpack_require__(1184);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageTravypass=function(_React$Component){_inherits(ManageTravypass,_React$Component);function ManageTravypass(props){_classCallCheck(this,ManageTravypass);var _this=_possibleConstructorReturn(this,(ManageTravypass.__proto__||Object.getPrototypeOf(ManageTravypass)).call(this,props));_this.componentDidMount=function(){_this._fetchBanner();setTimeout(function(){_this.setState({general_markup_travypass:_this.props.preset.dataPresetOrder.general_markup_travypass});},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(_this.state.tab==='Banner'&&!modalId){_this._fetchBanner();}};_this._changeTab=function(tab){_this.setState({tab:tab});};_this._fetchBanner=function(){_this.props.getBanners(_this.state.filter);};_this._updatePreset=function(event){event.preventDefault();var data={general_markup_travypass:_this.state.general_markup_travypass};_this.props.updatePreset(data);setTimeout(function(){_this._toggleModal();},250);};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>100){val=100;}else if(parseFloat(val)<-100){val=-100;}_this.setState({general_markup_travypass:val});};_this._filterChange=function(event,field){var val=event.target.value;var filter=Object.assign({},_this.state.filter);filter[field]=val;_this.setState({filter:filter});if(field==='title'){__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_2_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_2_jquery___default()('td[data-filter="title"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_2_jquery___default()('td[data-filter="title"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tr:hidden').show();}}};_this._reverseOrder=function(){_this.setState({reverse:!_this.state.reverse});__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tbody').each(function(elem,index){var arr=__WEBPACK_IMPORTED_MODULE_2_jquery___default.a.makeArray(__WEBPACK_IMPORTED_MODULE_2_jquery___default()('tr',this).detach());arr.reverse();__WEBPACK_IMPORTED_MODULE_2_jquery___default()(this).append(arr);});};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._delete=function(){_this.props.deleteBanner(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this.state={showModal:null,general_markup_travypass:props.preset.dataPresetOrder.general_markup_travypass,tab:'Banner',filter:{type:'travypass',title:''},reverse:false,detail:{}};return _this;}_createClass(ManageTravypass,[{key:'render',value:function render(){var _this2=this;var banner=this.props.banner;var preset=this.props.preset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Travelinpod ',this.state.tab,banner.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),this.state.tab==='Banner'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create-travypass-banner');}},'Create New Banner'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:true,className:'btn btn-primary ml-auto'},'Create New Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-3',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='Banner'?'active':''),onClick:function onClick(){return _this2._changeTab('Banner');}},'Banner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='Markup'?'active':''),onClick:function onClick(){return _this2._changeTab('Markup');}},'Markup')),this.state.tab==='Banner'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'control-label mr-2'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',placeholder:'Banner Title',defaultValue:this.state.filter.title,onChange:function onChange(event){return _this2._filterChange(event,'title');}})))),this.state.tab==='Banner'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(banner.fetching||banner.processing)&&banner.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},banner.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{role:'button',onClick:function onClick(){return _this2._reverseOrder();}},'Priority ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-'+(this.state.reverse?'sort-numeric-down':'sort-numeric-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Web'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Mobile'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,banner.data&&banner.data.length?banner.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'title'},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.priority||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.image_url.web?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url.web,alt:'',className:'img img-responsive',height:'65px'}):'- No Image -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.image_url.mobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url.mobile,alt:'',className:'img img-responsive',height:'65px'}):'- No Image -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'update-travypass-content');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}),' Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update-travypass-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),' Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-travypass-banner');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'8',className:'text-center'},'- NO DATA -'))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2 mb-2'},'General Markup: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'mb-2'},preset.dataPresetOrder.general_markup_travypass,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-dark btn-sm btn-link mb-2',onClick:function onClick(){return _this2._toggleModal('edit-general-markup-travypass');}},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mb-2'},preset.fetchingPresetOrder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},'Processing...'),preset.errPresetOrder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-danger'},preset.errPresetOrder)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='create-travypass-banner',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Travypass_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='update-travypass-content',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Travypass_UpdateContent__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='update-travypass-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Travypass_UpdateImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-travypass-banner',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Banner?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.detail.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='edit-general-markup-travypass',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'General Markup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._updatePreset(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(event){return _this2._valueChange(event);},type:'number',name:'value',required:true,step:'any',max:100,className:'form-control',value:this.state.general_markup_travypass}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2._toggleModal();},className:'btn btn-secondary ml-auto'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Submit')))))));}}]);return ManageTravypass;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{banner:state.banner,preset:state.preset};};var dispatchToProps=function dispatchToProps(dispatch){return{getBanners:function getBanners(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_BannerRedux__["b" /* default */].bannerRequest(filter));},deleteBanner:function deleteBanner(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_BannerRedux__["b" /* default */].bannerDeleteRequest({id:id}));},updatePreset:function updatePreset(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_PresetRedux__["b" /* default */].presetOrderUpdateRequest(data));}// getPreset: () => dispatch(PresetActions.presetOrderRequest())
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageTravypass));

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form.image_file[field]=filename;if(field==='web'){form.image_file['original']=filename;}_this.setState({form:form});};_this._submit=function(event){event.preventDefault();_this.props.createBanner(_this.state.form);setTimeout(function(){_this.props.closeModal();},250);};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}var form=Object.assign({},_this.state.form);form.priority=val;_this.setState({form:form});};_this.state={form:{type:'travypass',title:'',priority:1,image_file:{web:'',mobile:'',original:''},link:''}};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Register New Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Banner Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Banner Link',className:'form-control',value:this.state.form.link,onChange:function onChange(event){return _this2._inputChange(event,'link');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},'URL must contain https://'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Web (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1049x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{required:true,setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'web');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'335x320'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{required:true,setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'mobile');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createBanner:function createBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__["b" /* default */].bannerCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateContent=function(_React$Component){_inherits(UpdateContent,_React$Component);function UpdateContent(props){_classCallCheck(this,UpdateContent);var _this=_possibleConstructorReturn(this,(UpdateContent.__proto__||Object.getPrototypeOf(UpdateContent)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}var form=Object.assign({},_this.state.form);form.priority=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:_this.state.form};_this.props.updateBanner(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{type:'travypass',title:props.detail.title||'',priority:props.detail.priority||'',image_file:{web:props.detail.image_file.web||'',mobile:props.detail.image_file.mobile||'',original:props.detail.image_file.original||''},link:props.detail.link||''}};return _this;}_createClass(UpdateContent,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Banner Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Link Banner',className:'form-control',value:this.state.form.link,onChange:function onChange(event){return _this2._inputChange(event,'link');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},'URL must contain https://'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return UpdateContent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBanner:function updateBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateContent));

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateImage=function(_React$Component){_inherits(UpdateImage,_React$Component);function UpdateImage(props){_classCallCheck(this,UpdateImage);var _this=_possibleConstructorReturn(this,(UpdateImage.__proto__||Object.getPrototypeOf(UpdateImage)).call(this,props));_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form.image_file[field]=filename;if(field==='web'){form.image_file['original']=filename;}_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:_this.state.form};_this.props.updateBanner(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{type:'travypass',title:props.detail.title||'',priority:props.detail.priority||'',image_file:{web:props.detail.image_file.web||'',mobile:props.detail.image_file.mobile||'',original:props.detail.image_file.original||''}}};return _this;}_createClass(UpdateImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Web (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1049x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'web');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'335x320'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'mobile');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return UpdateImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBanner:function updateBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__["b" /* default */].bannerUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateImage));

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderReport=function(_React$Component){_inherits(OrderReport,_React$Component);function OrderReport(props){_classCallCheck(this,OrderReport);var _this=_possibleConstructorReturn(this,(OrderReport.__proto__||Object.getPrototypeOf(OrderReport)).call(this,props));_this.componentDidMount=function(){_this._fetchData();};_this._fetchData=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this.state.filter,filter);if(_this.state.filter.from&&_this.state.filter.until){params.from=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.filter.from).format(_this.dateFormat);params.until=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.filter.until).format(_this.dateFormat);}else{params.from=null;params.until=null;}params.type=_this.state.tab;params.page=_this.state.filter.page;_this.props.getOrderReport(params);};_this._filterChange=function(data,field){var unique=['page','from','until'];var value=null;if(__WEBPACK_IMPORTED_MODULE_6_lodash_includes___default()(unique,field)){if(field==='from'||field==='until'){if(__WEBPACK_IMPORTED_MODULE_7_lodash_isObject___default()(data)){value=data;}}else{value=data;}}else{value=data.target.value;}var filter=Object.assign({},_this.state.filter);filter[field]=value;_this.setState({filter:filter});};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});setTimeout(function(){_this._fetchData({page:page});},80);};_this._changeTab=function(tab){var filter=Object.assign({},_this.state.filter);filter.page=1;_this.setState({filter:filter,tab:tab});setTimeout(function(){_this._fetchData();},80);};_this._downloadXLS=function(type){var data={from:__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.filter.from).format(_this.dateFormat),until:__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this.state.filter.until).format(_this.dateFormat),type:type};setTimeout(function(){_this.props.getOrderReportSpreadsheet(data);},500);};_this._renderMeta=function(data,dataStatModem,tab){switch(tab){case'modem':return!data||!dataStatModem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card card-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title mr-auto'},'Financial Report (Modem)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mr-2',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._downloadXLS('modem');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},'Order via Travypass')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Terminal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 2 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},data.total_qty_2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_revenue_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_commission_2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_gross_margin_2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 3 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},data.total_qty_3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_revenue_3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_commission_3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_gross_margin_3)))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},'Order via Passpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Terminal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Received on Airport'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Returned on Airport'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Commission (receive)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Commission (return)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 2 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 3 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn3))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived2+dataStatModem.qtyReceived3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn2+dataStatModem.qtyReturn3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived2+dataStatModem.commissiontyReceived3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn2+dataStatModem.commissionReturn3))))))))));case'attraction':return!data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card card-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title mr-auto'},'Financial Report (Attraction)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mr-2',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._downloadXLS('attraction');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Adults'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Children'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Seniors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},data.total_adults),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},data.total_children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},data.total_seniors),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_revenue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_commission)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_gross_margin))))))));case'modem-vending':return!data||!dataStatModem?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card card-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title mr-auto'},'Modem Travelinpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mr-2',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._downloadXLS('modem-vending');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},'Order via Travelinpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},data.total_qty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_revenue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_commission)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_gross_margin))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'title'},'Order via Passpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Terminal'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Received on Airport'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Returned on Airport'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Commission (receive)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Commission (return)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 2 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn2))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'Terminal 3 Bandara Soekarno Hatta'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn3))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Total')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReceived2+dataStatModem.qtyReceived3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},dataStatModem.qtyReturn2+dataStatModem.qtyReturn3),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissiontyReceived2+dataStatModem.commissiontyReceived3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(dataStatModem.commissionReturn2+dataStatModem.commissionReturn3)))))))));case'ecommerce':return!data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card card-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-header d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header-block mr-auto'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title mr-auto'},'Travel Smart Card in Travelinpod')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mr-2',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._downloadXLS('ecommerce');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-download'}),' Download XLS'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Total Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},data.total_qty),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_revenue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_commission)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(data.total_gross_margin))))))));default:return null;}};_this._renderData=function(data,tab){if(_this.props.order.err){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},_this.props.order.err);}switch(tab){case'modem':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'text-center align-middle table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Receive Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Terminal (receive)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Terminal (return) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Rent Duration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.terminal_received_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.terminal_received||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.terminal_return||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.rent_duration||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.revenue)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.commission)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.gross_margin)||'-'));})));case'attraction':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'text-center align-middle table-bordered',style:{width:'150%',backgroundColor:'#ffffff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Package Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Confirm Date'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Adults'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Children'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Seniors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.attraction_name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.country||'-','(',item.currency_code||'-',')'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.confirm_date||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_adults||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_children||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_seniors||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.revenue)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.commission)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.gross_margin)||'-'));})));case'ecommerce':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table text-center align-middle table-bordered',style:{backgroundColor:'#ffffff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Produk'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'SKU M'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'SKU V'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},item.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},item.sku_m||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},item.sku_v||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.revenue)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.commission)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.gross_margin)||'-'));})));case'modem-vending':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'text-center align-middle table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Revenue'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Commission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Gross Margin'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.total_qty||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.revenue)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.commission)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},'IDR ',Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FormatMoney__["a" /* default */])(item.gross_margin)||'-'));})));default:return null;}};_this.dateFormat='Y-MM-DD';_this.state={tab:'modem-vending',showModal:null,filter:{page:1,from:__WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1,'months').format(_this.dateFormat),until:__WEBPACK_IMPORTED_MODULE_3_moment___default()().format(_this.dateFormat)}};return _this;}_createClass(OrderReport,[{key:'render',value:function render(){var _this2=this;var order=this.props.order;var DATA_REPORT=order.DATA_REPORT;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Travelinpod Order Report',(order.fetching||order.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='modem-vending'&&'active'),onClick:function onClick(){return _this2._changeTab('modem-vending');}},'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+(this.state.tab==='ecommerce'&&'active'),onClick:function onClick(){return _this2._changeTab('ecommerce');}},'E Commerce'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchData(null,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Date Range:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.from,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'from');},dateFormat:this.dateFormat,timeFormat:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label ml-2 mr-2'},'To:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a,{value:this.state.filter.until,closeOnSelect:true,onChange:function onChange(date){return _this2._filterChange(date,'until');},dateFormat:this.dateFormat,timeFormat:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Change Date Range'))))),!(order.fetching||order.processing)&&order.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},order.err),this._renderMeta(DATA_REPORT.metaTravypass,DATA_REPORT.stat_modem_passpod,this.state.tab),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},this.state.tab==='modem'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!DATA_REPORT.data||!DATA_REPORT.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:2},'--No Data--')):DATA_REPORT.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,item.data[0].title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this2._renderData(item.data,_this2.state.tab)));}))),this.state.tab==='attraction'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!DATA_REPORT.data||!DATA_REPORT.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'--No Data--')):DATA_REPORT.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this2._renderData(item.data,_this2.state.tab)));}))),this.state.tab==='ecommerce'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!DATA_REPORT.data||!DATA_REPORT.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'--No Data--')):DATA_REPORT.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this2._renderData(item.data,_this2.state.tab)));}))),this.state.tab==='modem-vending'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Modem'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!DATA_REPORT.data||!DATA_REPORT.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:2},'--No Data--')):DATA_REPORT.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,item.data[0].title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},_this2._renderData(item.data,_this2.state.tab)));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},DATA_REPORT&&DATA_REPORT.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:DATA_REPORT.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:DATA_REPORT.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return OrderReport;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{order:state.order};};var dispatchToProps=function dispatchToProps(dispatch){return{getOrderReport:function getOrderReport(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].getOrderReportRequest(filter));},getOrderReportSpreadsheet:function getOrderReportSpreadsheet(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_OrderRedux__["b" /* default */].getOrderReportSpreadsheetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(OrderReport));

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ReviewRedux__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewPage=function(_React$Component){_inherits(ReviewPage,_React$Component);function ReviewPage(props){_classCallCheck(this,ReviewPage);var _this=_possibleConstructorReturn(this,(ReviewPage.__proto__||Object.getPrototypeOf(ReviewPage)).call(this,props));_this._fetchReviewList=function(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object.assign({},_this.state.filter);_this.props.getReviewList(params);};_this._filterChange=function(event,field){var value=event.target.value;var newState=Object.assign({},_this.state.filter);newState[field]=value;_this.setState({newState:newState});_this._fetchReviewList(newState);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._fetchReviewList(filter);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._approve=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.props.approveReview(id);_this._toggleModal();};_this.state={showModal:null,detail:{title:'',content:''},filter:{page:1,limit:10,status:null}};return _this;}_createClass(ReviewPage,[{key:'componentDidMount',value:function componentDidMount(){this._fetchReviewList();}},{key:'render',value:function render(){var _this2=this;var review=this.props.review;var statusList=[{label:'- ALL STATUS -',value:''},{label:'APPROVED',value:true},{label:'UNAPPROVED',value:false}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Reviews',(review.fetching||review.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},review.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-1'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',name:'status',value:this.state.filter.status,onChange:function onChange(event){return _this2._filterChange(event,'status');}},statusList.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(review.fetching||review.processing)&&review.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},review.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Reviewer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Review Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Review Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Place'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',width:'15%'},'Actions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,review.data&&review.data.list?review.data.list.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.user.first_name,' ',item.user.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lines_ellipsis___default.a,{text:item.content||'',maxLine:'1',ellipsis:'...',trimRight:true,basedOn:'letters'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.place.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(item.status?'success':'danger')},item.status?'APPROVED':'UNAPPROVED')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',title:'View',onClick:function onClick(){return _this2._selectItem(item,'view');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-eye'})),!item.status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',title:'Approve',onClick:function onClick(){return _this2._approve(item.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-check'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'8',className:'text-center'},'- NO DATA -')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='view',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Review')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('aside',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Review for ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,this.state.detail.place?this.state.detail.place.title:'-'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',readOnly:true,className:'form-control',value:this.state.detail.title})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{readOnly:true,style:{minHeight:'25vh'},className:'form-control',value:this.state.detail.content})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary',onClick:function onClick(){return _this2._toggleModal();}},'Close'),!this.state.detail.status&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._approve(_this2.state.detail.id);},className:'btn btn-lg btn-primary ml-2'},'Approve'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},review.data&&review.data.total>this.state.filter.limit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:review.data.page||this.state.filter.page,itemsCountPerPage:this.state.filter.limit,totalItemsCount:review.data.total,pageRangeDisplayed:5,onChange:this._changePage})));}}]);return ReviewPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{review:state.review};};var dispatchToProps=function dispatchToProps(dispatch){return{getReviewList:function getReviewList(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ReviewRedux__["b" /* default */].reviewListRequest(filter));},approveReview:function approveReview(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ReviewRedux__["b" /* default */].reviewApproveRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ReviewPage));

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Ecommerce_ManageCategory__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Ecommerce_ManageBrand__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Ecommerce_ManageVariant__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Ecommerce_ManageWarehouse__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Ecommerce_ManageInventory__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Ecommerce_ManageSupplier__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Ecommerce_ManageEcommerceProduct__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Ecommerce_ManageEcommerceOrder__ = __webpack_require__(1217);
var subList={ManageCategory:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Ecommerce_ManageCategory__["a" /* default */],null),ManageBrand:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Ecommerce_ManageBrand__["a" /* default */],null),ManageVariant:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Ecommerce_ManageVariant__["a" /* default */],null),ManageWarehouse:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Ecommerce_ManageWarehouse__["a" /* default */],null),ManageInventory:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Ecommerce_ManageInventory__["a" /* default */],null),ManageSupplier:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Ecommerce_ManageSupplier__["a" /* default */],null),ManageEcommerceProduct:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Ecommerce_ManageEcommerceProduct__["a" /* default */],null),ManageEcommerceOrder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Ecommerce_ManageEcommerceOrder__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Pages_NotFound__["a" /* default */],null);}};var EcommercePage=function EcommercePage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (EcommercePage);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateCategory__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateCategoryName__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_UpdateCategoryImage__ = __webpack_require__(1191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageCategory=function(_React$Component){_inherits(ManageCategory,_React$Component);function ManageCategory(props){_classCallCheck(this,ManageCategory);var _this=_possibleConstructorReturn(this,(ManageCategory.__proto__||Object.getPrototypeOf(ManageCategory)).call(this,props));_this._fetchCategory=function(event){if(event){event.preventDefault();}var filter='';_this.props.getCategory(filter);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){_this._fetchCategory();},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchCategory();}};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this.componentDidMount=function(){_this._fetchCategory();};_this.dateformat='Y-MM-DD';_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(ManageCategory,[{key:'render',value:function render(){var _this2=this;var category=this.props.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Category',(category.fetching||category.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},category.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-category');}},'Create Category'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(category.fetching||category.processing)&&category.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},category.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Category Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Icon'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit Category'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!category.data||!category.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'No data')):category.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.icon_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.icon_url,alt:'',style:{height:'75px'}}):'Empty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.image_url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url,alt:'',style:{height:'75px'}}):'Empty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center d-flex justify-content-around'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'update-category-name');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'update-category-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Image')));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,category.data&&category.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:category.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:category.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-category',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateCategory__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-category-name',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateCategoryName__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-category-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_UpdateCategoryImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return ManageCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{category:state.category};};var dispatchToProps=function dispatchToProps(dispatch){return{getCategory:function getCategory(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_CategoryRedux__["b" /* default */].getCategoryRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageCategory));

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateCategory=function(_React$Component){_inherits(CreateCategory,_React$Component);function CreateCategory(props){_classCallCheck(this,CreateCategory);var _this=_possibleConstructorReturn(this,(CreateCategory.__proto__||Object.getPrototypeOf(CreateCategory)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;form.icon_file=newProps.files.data.upload[0].filename;}};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','category');data.append('image_type',_this.state.image_type);_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);data.iso_code=_this.branch;_this.props.createCategory(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_5__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:'',icon_file:null,image_file:null},image_type:'',file:null,uploaded:false};return _this;}_createClass(CreateCategory,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Category Name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'518x344'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{required:true,setting:{type:'category',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Icon File(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'100x100'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{required:true,setting:{type:'category',image_type:'icon'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'icon_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadReset());},createCategory:function createCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].createCategoryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateCategory));

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateCategory=function(_React$Component){_inherits(UpdateCategory,_React$Component);function UpdateCategory(props){_classCallCheck(this,UpdateCategory);var _this=_possibleConstructorReturn(this,(UpdateCategory.__proto__||Object.getPrototypeOf(UpdateCategory)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateCategory(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:props.detail.name||'',id:props.detail.id||''}};return _this;}_createClass(UpdateCategory,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Category Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit Category Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Category name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateCategory:function updateCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].updateCategoryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateCategory));

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateCategory=function(_React$Component){_inherits(UpdateCategory,_React$Component);function UpdateCategory(props){_classCallCheck(this,UpdateCategory);var _this=_possibleConstructorReturn(this,(UpdateCategory.__proto__||Object.getPrototypeOf(UpdateCategory)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;form.icon_file=newProps.files.data.upload[0].filename;}};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','category');data.append('image_type',_this.state.image_type);_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateCategory(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:props.detail.name||'',id:props.detail.id||'',icon_file:props.detail.icon_file||'',image_file:props.detail.image_file||''},image_type:'',file:null,uploaded:false};return _this;}_createClass(UpdateCategory,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Category Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',style:{width:'100%'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Icon'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.icon_file,title:this.props.detail.icon_file,className:'img img-responsive img-border',style:{width:'100%'},src:this.props.detail.icon_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'518x344'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'category',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Icon File(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'100x100'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'category',image_type:'icon'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'icon_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadReset());},updateCategory:function updateCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].updateCategoryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateCategory));

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateBrand__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_AssignCategory__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_RemoveCategory__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateBrand__ = __webpack_require__(1196);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageBrand=function(_React$Component){_inherits(ManageBrand,_React$Component);function ManageBrand(props){_classCallCheck(this,ManageBrand);var _this=_possibleConstructorReturn(this,(ManageBrand.__proto__||Object.getPrototypeOf(ManageBrand)).call(this,props));_this.componentDidMount=function(){_this._fetchBrand();};_this._fetchBrand=function(event){if(event){event.preventDefault();}var filter='';_this.props.getBrand(filter);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){_this._fetchBrand();},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchBrand();}};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._deleteBrand=function(){_this.props.deleteBrand(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this.dateformat='Y-MM-DD';_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(ManageBrand,[{key:'render',value:function render(){var _this2=this;var brand=this.props.brand;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Brand',(brand.fetching||brand.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},brand.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-brand');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create Brand'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(brand.fetching||brand.processing)&&brand.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},brand.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Brand Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Assigned Categories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete Brand'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!brand.data||!brand.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'7',className:'text-center'},'No data')):brand.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),!item.categories||!item.categories.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},'- No Category -'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.categories.map(function(x){return x.name;}).join(', ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._selectItem(item,'assign-category');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus-circle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'remove-category');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-minus-circle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'edit-brand');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-brand');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),' Delete')));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,brand.data&&brand.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:brand.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:brand.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-brand',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateBrand__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='assign-category',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_AssignCategory__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='remove-category',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_RemoveCategory__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-brand',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateBrand__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-brand',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,'Confirm "',this.state.detail.name,'" brand deletion?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteBrand();}},'Delete')))));}}]);return ManageBrand;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{brand:state.brand};};var dispatchToProps=function dispatchToProps(dispatch){return{getBrand:function getBrand(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_BrandRedux__["b" /* default */].getBrandRequest(filter));},deleteBrand:function deleteBrand(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_BrandRedux__["b" /* default */].deleteBrandRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageBrand));

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateBrand=function(_React$Component){_inherits(CreateBrand,_React$Component);function CreateBrand(props){_classCallCheck(this,CreateBrand);var _this=_possibleConstructorReturn(this,(CreateBrand.__proto__||Object.getPrototypeOf(CreateBrand)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);data.iso_code=_this.branch;_this.props.createBrand(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:''}};return _this;}_createClass(CreateBrand,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Brand Name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateBrand;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createBrand:function createBrand(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createBrandRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateBrand));

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CategoryRedux__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AssignCategory=function(_React$Component){_inherits(AssignCategory,_React$Component);function AssignCategory(props){_classCallCheck(this,AssignCategory);var _this=_possibleConstructorReturn(this,(AssignCategory.__proto__||Object.getPrototypeOf(AssignCategory)).call(this,props));_this.componentDidMount=function(){_this.props.getCategory();};_this._inputChange=function(event,field){var value=event.target.value;var brand=Object.assign({},_this.state.brand);brand[field]=value;_this.setState({brand:brand});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.brand);_this.props.createCategoryBrand(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={brand_name:props.detail.name,brand:{brand_id:props.detail.id,category_id:props.detail.categories.id}};return _this;}_createClass(AssignCategory,[{key:'render',value:function render(){var _this2=this;var category=this.props.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Assign category to a brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'For brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',disabled:true,value:this.state.brand_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'category_id');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'--Pick a Category--'),category.data&&category.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return AssignCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{category:state.category};};var dispatchToProps=function dispatchToProps(dispatch){return{createCategoryBrand:function createCategoryBrand(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createCategoryBrandRequest(data));},getCategory:function getCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CategoryRedux__["b" /* default */].getCategoryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AssignCategory));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveCategory=function(_React$Component){_inherits(RemoveCategory,_React$Component);function RemoveCategory(props){_classCallCheck(this,RemoveCategory);var _this=_possibleConstructorReturn(this,(RemoveCategory.__proto__||Object.getPrototypeOf(RemoveCategory)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var category=Object.assign({},_this.state.category);category[field]=value;_this.setState({category:category});};_this._submit=function(event){event.preventDefault();var id=_this.state.category.id;_this.props.deleteCategoryBrand(id);setTimeout(function(){_this.props.closeModal();},250);};_this.state={category_name:props.detail.name,category:{id:''}};return _this;}_createClass(RemoveCategory,[{key:'render',value:function render(){var _this2=this;var detail=this.props.detail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Remove category from a brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'For Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',disabled:true,className:'form-control',value:this.state.category_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Pick category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'id');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'--Pick a category to be removed--'),detail.categories&&detail.categories.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.categoryBrand.id},item.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Delete')))));}}]);return RemoveCategory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteCategoryBrand:function deleteCategoryBrand(id){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].deleteCategoryBrandRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(RemoveCategory));

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateBrand=function(_React$Component){_inherits(UpdateBrand,_React$Component);function UpdateBrand(props){_classCallCheck(this,UpdateBrand);var _this=_possibleConstructorReturn(this,(UpdateBrand.__proto__||Object.getPrototypeOf(UpdateBrand)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateBrand(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{name:props.detail.name||'',id:props.detail.id||''}};return _this;}_createClass(UpdateBrand,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit Brand Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Brand name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateBrand;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBrand:function updateBrand(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].updateBrandRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateBrand));

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_CreateSize__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_CreateColour__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateSize__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Ecommerce_UpdateColour__ = __webpack_require__(1201);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageVariant=function(_React$Component){_inherits(ManageVariant,_React$Component);function ManageVariant(props){_classCallCheck(this,ManageVariant);var _this=_possibleConstructorReturn(this,(ManageVariant.__proto__||Object.getPrototypeOf(ManageVariant)).call(this,props));_this.componentDidMount=function(){_this._fetchVariant(_this.state.tab,_this.state.page);};_this._fetchVariant=function(tab,params){switch(tab){case'tab-colour':return _this.props.getColour(params);case'tab-size':return _this.props.getSize(params);default:return null;}};_this._changeTab=function(tab){_this.setState({tab:tab,page:1});setTimeout(function(){var params={page:_this.state.page};_this._fetchVariant(_this.state.tab,params);},250);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){var params={page:page};_this._fetchVariant(_this.state.tab,params);},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});var params={page:_this.state.page};if(!modalId){_this._fetchVariant(_this.state.tab,params);}};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._deleteSize=function(){_this.props.deleteSize(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this._deleteColour=function(){_this.props.deleteColour(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this.dateformat='Y-MM-DD';_this.state={tab:'tab-colour',page:1,showModal:null,detail:{}};return _this;}_createClass(ManageVariant,[{key:'render',value:function render(){var _this2=this;var _props=this.props,size=_props.size,colour=_props.colour;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Variant',this.state.tab==='tab-size'?(size.fetching||size.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},size.fetching?'Loading':'Processing',' ...'):(colour.fetching||colour.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},colour.fetching?'Loading':'Processing',' ...')),this.state.tab==='tab-colour'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-colour');}},'Create Type'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-size');}},'Create Subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn-group mb-4',role:'group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+((!this.state.tab||this.state.tab==='tab-colour')&&'active'),onClick:function onClick(){return _this2._changeTab('tab-colour');}},'Type Variant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary '+((!this.state.tab||this.state.tab==='tab-size')&&'active'),onClick:function onClick(){return _this2._changeTab('tab-size');}},'Subtype Variant'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},this.state.tab==='tab-size'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(size.fetching||size.processing)&&size.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},size.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'For Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Subtype'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit subtype'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete subtype'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!size.data.data||!size.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'No data')):size.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.category.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-size');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-size');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))),this.state.tab==='tab-colour'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(colour.fetching||colour.processing)&&colour.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},colour.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Type Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Type Color Code'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete Type'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!colour.data.data||!colour.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'No data')):colour.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btn mr-2',style:{backgroundColor:item.colour_code}}),item.colour_code),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-colour');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-colour');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}))))),this.state.tab==='tab-size'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},size.data&&size.data.total>100&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:size.data.page||this.state.page,itemsCountPerPage:100,totalItemsCount:size.data.total,pageRangeDisplayed:5,onChange:this._changePage})),this.state.tab==='tab-colour'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},colour.data&&colour.data.total>100&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:colour.data.page||this.state.page,itemsCountPerPage:100,totalItemsCount:colour.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-size',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_CreateSize__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-size',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateSize__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-size',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Confirm deletion for "',this.state.detail.name,'" type?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteSize();}},'Delete')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-colour',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_CreateColour__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-colour',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Ecommerce_UpdateColour__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-colour',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Confirm deletion for "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.detail.colour_code}},this.state.detail.name),'" type?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteColour();}},'Delete')))));}}]);return ManageVariant;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{size:state.size,colour:state.colour};};var dispatchToProps=function dispatchToProps(dispatch){return{getSize:function getSize(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_SizeRedux__["b" /* default */].getSizeRequest(filter));},getColour:function getColour(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ColourRedux__["b" /* default */].getColourRequest(filter));},deleteSize:function deleteSize(id){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_SizeRedux__["b" /* default */].deleteSizeRequest(id));},deleteColour:function deleteColour(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ColourRedux__["b" /* default */].deleteColourRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageVariant));

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateSize=function(_React$Component){_inherits(CreateSize,_React$Component);function CreateSize(props){_classCallCheck(this,CreateSize);var _this=_possibleConstructorReturn(this,(CreateSize.__proto__||Object.getPrototypeOf(CreateSize)).call(this,props));_this.componentDidMount=function(){_this.props.getCategory();};_this._inputChange=function(event,field){var value=event.target.value;var size=Object.assign({},_this.state.size);size[field]=value;_this.setState({size:size});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.size);data.iso_code=_this.branch;_this.props.createSize(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={size:{name:'',category_id:''}};return _this;}_createClass(CreateSize,[{key:'render',value:function render(){var _this2=this;var category=this.props.category;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Subtype Creation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'For Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'category_id');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'--Pick a Category--'),category.data&&category.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.id},item.name);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert subtype name',className:'form-control',value:this.state.size.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateSize;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{category:state.category};};var dispatchToProps=function dispatchToProps(dispatch){return{getCategory:function getCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_CategoryRedux__["b" /* default */].getCategoryRequest(data));},createSize:function createSize(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].createSizeRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateSize));

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateColour=function(_React$Component){_inherits(CreateColour,_React$Component);function CreateColour(props){_classCallCheck(this,CreateColour);var _this=_possibleConstructorReturn(this,(CreateColour.__proto__||Object.getPrototypeOf(CreateColour)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);data.iso_code=_this.branch;_this.props.createColour(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:'',colour_code:'#f89924'}};return _this;}_createClass(CreateColour,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Type Creation')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert type name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type Color Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'color',name:'colour-picker',style:{width:'100%',height:'38px'},value:this.state.form.colour_code,onChange:function onChange(event){return _this2._inputChange(event,'colour_code');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:'text',value:this.state.form.colour_code,readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateColour;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createColour:function createColour(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].createColourRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateColour));

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSize=function(_React$Component){_inherits(UpdateSize,_React$Component);function UpdateSize(props){_classCallCheck(this,UpdateSize);var _this=_possibleConstructorReturn(this,(UpdateSize.__proto__||Object.getPrototypeOf(UpdateSize)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateSize(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:props.detail.name||'',category_id:props.detail.category_id},id_name:props.detail.category.name||''};return _this;}_createClass(UpdateSize,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'For Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:'text',disabled:true,value:this.state.id_name}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert subtype name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateSize;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateSize:function updateSize(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].updateSizeRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSize));

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateColour=function(_React$Component){_inherits(UpdateColour,_React$Component);function UpdateColour(props){_classCallCheck(this,UpdateColour);var _this=_possibleConstructorReturn(this,(UpdateColour.__proto__||Object.getPrototypeOf(UpdateColour)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateColour(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:props.detail.name||'',colour_code:props.detail.colour_code||''}};return _this;}_createClass(UpdateColour,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Insert type name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type Color Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'color',name:'colour-picker',style:{width:'100%',height:'38px'},value:this.state.form.colour_code,onChange:function onChange(event){return _this2._inputChange(event,'colour_code');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:'text',value:this.state.form.colour_code,readOnly:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateColour;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateColour:function updateColour(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].updateColourRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateColour));

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateWarehouse__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateWarehouse__ = __webpack_require__(1204);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageWarehouse=function(_React$Component){_inherits(ManageWarehouse,_React$Component);function ManageWarehouse(props){_classCallCheck(this,ManageWarehouse);var _this=_possibleConstructorReturn(this,(ManageWarehouse.__proto__||Object.getPrototypeOf(ManageWarehouse)).call(this,props));_this._fetchWarehouse=function(event){if(event){event.preventDefault();}var filter='';_this.props.getWarehouse(filter);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){_this._fetchWarehouse();},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchWarehouse();}};_this._deleteWarehouse=function(){_this.props.deleteWarehouse(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this.componentDidMount=function(){_this._fetchWarehouse();};_this.dateformat='Y-MM-DD';_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(ManageWarehouse,[{key:'render',value:function render(){var _this2=this;var warehouse=this.props.warehouse;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Warehouse',(warehouse.fetching||warehouse.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},warehouse.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-warehouse');}},'Create Warehouse'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(warehouse.fetching||warehouse.processing)&&warehouse.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},warehouse.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!warehouse.data||!warehouse.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'No data')):warehouse.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.detail_info),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-warehouse');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-warehouse');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),'Delete')));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,warehouse.data&&warehouse.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:warehouse.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:warehouse.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-warehouse',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateWarehouse__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-warehouse',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateWarehouse__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-warehouse',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Warehouse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Confirm deletion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteWarehouse();}},'Delete')))));}}]);return ManageWarehouse;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{warehouse:state.warehouse};};var dispatchToProps=function dispatchToProps(dispatch){return{getWarehouse:function getWarehouse(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_WarehouseRedux__["b" /* default */].getWarehouseRequest(filter));},deleteWarehouse:function deleteWarehouse(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_WarehouseRedux__["b" /* default */].deleteWarehouseRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageWarehouse));

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateWarehouse=function(_React$Component){_inherits(CreateWarehouse,_React$Component);function CreateWarehouse(props){_classCallCheck(this,CreateWarehouse);var _this=_possibleConstructorReturn(this,(CreateWarehouse.__proto__||Object.getPrototypeOf(CreateWarehouse)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);data.iso_code=_this.branch;_this.props.createWarehouse(data);setTimeout(function(){_this.props.closeModal();},250);};_this.branch=Object(__WEBPACK_IMPORTED_MODULE_3__Utils_PrivilegeUtils__["a" /* currentBranch */])();_this.state={form:{name:'',address:'',detail_info:''}};return _this;}_createClass(CreateWarehouse,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Warehouse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Warehouse Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Warehouse Name',className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,rows:'3',placeholder:'Warehouse Address',className:'form-control',value:this.state.form.address,onChange:function onChange(event){return _this2._inputChange(event,'address');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Detail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,rows:'3',placeholder:'Warehouse Details',className:'form-control',value:this.state.form.detail_info,onChange:function onChange(event){return _this2._inputChange(event,'detail_info');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateWarehouse;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createWarehouse:function createWarehouse(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].createWarehouseRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateWarehouse));

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateWarehouse=function(_React$Component){_inherits(UpdateWarehouse,_React$Component);function UpdateWarehouse(props){_classCallCheck(this,UpdateWarehouse);var _this=_possibleConstructorReturn(this,(UpdateWarehouse.__proto__||Object.getPrototypeOf(UpdateWarehouse)).call(this,props));_this._inputChange=function(event,field){var value=event.target.value;var warehouse=Object.assign({},_this.state.warehouse);warehouse[field]=value;_this.setState({warehouse:warehouse});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.warehouse);var data={id:_this.props.detail.id,form:form};_this.props.updateWarehouse(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={warehouse:{id:props.detail.id||'',name:props.detail.name||'',address:props.detail.address||'',detail_info:props.detail.detail_info||''}};return _this;}_createClass(UpdateWarehouse,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Warehouse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Warehouse name',className:'form-control',value:this.state.warehouse.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,rows:'3',placeholder:'Warehouse name',className:'form-control',value:this.state.warehouse.address,onChange:function onChange(event){return _this2._inputChange(event,'address');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,rows:'3',placeholder:'Warehouse Name',className:'form-control',value:this.state.warehouse.detail_info,onChange:function onChange(event){return _this2._inputChange(event,'detail_info');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateWarehouse;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateWarehouse:function updateWarehouse(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].updateWarehouseRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateWarehouse));

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_EllipsisModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_CreateInventory__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_ManageInventoryImage__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateInventory__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Ecommerce_ViewInventoryImage__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ManageEcommerceProduct from '../../Containers/Ecommerce/ManageEcommerceProduct'
var ManageInventory=function(_React$Component){_inherits(ManageInventory,_React$Component);function ManageInventory(props){_classCallCheck(this,ManageInventory);var _this=_possibleConstructorReturn(this,(ManageInventory.__proto__||Object.getPrototypeOf(ManageInventory)).call(this,props));_this.componentDidMount=function(){_this._fetchInventory();_this.props.getCategory();_this.props.getSupplier();_this.props.getBrand();};_this._fetchInventory=function(event){if(event){event.preventDefault();}var data=Object.assign({},_this.state.filter);_this.props.getInventory(data);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter);filter.page=page;_this.props.getInventory(filter);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId&&!_this.props.inventory.err){_this._fetchInventory();}};_this._filterChange=function(data,field){var filter=Object.assign({},_this.state.filter);filter[field]=data;_this.setState({filter:filter});};_this._selectItem=function(item,action){if(action==='update-inventory'){_this.setState({selectedBrand:{value:!item.brand_id?'':item.brand_id,label:!item.brand?'':item.brand.name},selectedCategory:{value:!item.category_id?'':item.category_id,label:!item.category?'':item.category.name},selectedSupplier:{value:!item.supplier_detail?'':item.supplier_detail.id,label:!item.supplier_detail?'':item.supplier_detail.name}});}_this.setState({detail:item});_this._toggleModal(action);};_this._deleteInventory=function(){_this.props.deleteInventory(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this.dateformat='Y-MM-DD';_this.filterOrigin=[{label:'ALL',value:'',restriction:'PH'},{label:'Passpod ID',value:'ID',restriction:'PH'},{label:'Passpod PH',value:'PH'}];_this.state={showModal:null,detail:{},filter:{page:1,title:'',category:'',brand:'',supplier:'',iso_code:''},selectedCategory:{value:'',label:''},selectedSupplier:{value:'',label:''},selectedBrand:{value:'',label:''}};return _this;}_createClass(ManageInventory,[{key:'render',value:function render(){var _this2=this;var inventory=this.props.inventory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Inventory',(inventory.fetching||inventory.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},inventory.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-inventory');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchInventory(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Product Title',className:'form-control',value:this.state.filter.title,onChange:function onChange(event){return _this2._filterChange(event.target.value,'title');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Categories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.category,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'category');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Category -- '),this.props.category.data.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:category.id,key:index},' ',category.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.brand,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'brand');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Brand -- '),this.props.brand.data.map(function(brand,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:brand.id,key:index},' ',brand.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Supplier'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.supplier,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'supplier');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Supplier -- '),this.props.supplier.data.map(function(supplier,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:supplier.id,key:index},' ',supplier.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Origin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.iso_code,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'iso_code');}},this.filterOrigin.map(function(origin,index){if(origin.restriction!==Object(__WEBPACK_IMPORTED_MODULE_12__Utils_PrivilegeUtils__["a" /* currentBranch */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:origin.value,key:index},' ',origin.label,' ');}else{return false;}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{minWidth:'165%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(inventory.fetching||inventory.processing)&&inventory.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},inventory.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__["a" /* default */],{colSpan:17,header:[{field:'Name',className:'text-left',style:{minWidth:'200px'}},{field:'Master SKU'},{field:'Category'},{field:'Brand'},{field:'Discount Type'},{field:'Buy Price'},{field:'Normal Price'},{field:'Final Price'},{field:'Weight'},{field:'Supplier'},{field:'Description'},{field:'Status'},{field:'Featured'},{field:'Origin'},{field:'Images',colSpan:'2'},{field:'Edit Inventory'},{field:'Delete Inventory'}],body:inventory.data.data&&inventory.data.data.length>0&&inventory.data.data.map(function(x){return[{field:x.name,className:'text-left',style:{minWidth:'200px'}},{field:x.sku_m},{field:x.category.name},{field:x.brand.name},{field:x.discount_type},{field:Object(__WEBPACK_IMPORTED_MODULE_15__Utils_FormatMoney__["a" /* default */])(x.buy_price)},{field:Object(__WEBPACK_IMPORTED_MODULE_15__Utils_FormatMoney__["a" /* default */])(x.normal_price)},{field:Object(__WEBPACK_IMPORTED_MODULE_15__Utils_FormatMoney__["a" /* default */])(x.final_price)},{field:x.weight},{field:x.supplier_detail?x.supplier_detail.name:'-'},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_EllipsisModal__["a" /* default */],{descriptor:'Inventory Description',name:x.name,description:x.description,type:'string'})},{field:x.status===1?'Active':'Inactive'},{field:x.is_featured===1?'Yes':'No'},{field:x.iso_code},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-2',onClick:function onClick(){return _this2._selectItem(x,'view-inventory-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-2',onClick:function onClick(){return _this2._selectItem(x,'manage-inventory-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(x,'update-inventory');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit mr-2'}),'Edit')},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(x,'delete-inventory');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash mr-2'}),'Delete')}];})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},inventory.data&&inventory.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:inventory.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:inventory.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='create-inventory',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_CreateInventory__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='update-inventory',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Ecommerce_UpdateInventory__["a" /* default */],{detail:this.state.detail,selectedBrand:this.state.selectedBrand,selectedCategory:this.state.selectedCategory,selectedSupplier:this.state.selectedSupplier,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='view-inventory-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Ecommerce_ViewInventoryImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='manage-inventory-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Ecommerce_ManageInventoryImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='delete-inventory',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,'Confirm deletion for "',this.state.detail.name,'" category?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteInventory();}},'Delete')))));}}]);return ManageInventory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{inventory:state.inventory,category:state.category,supplier:state.supplier,brand:state.brand};};var dispatchToProps=function dispatchToProps(dispatch){return{getInventory:function getInventory(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_11__Redux_InventoryRedux__["b" /* default */].getInventoryRequest(filter));},deleteInventory:function deleteInventory(id){return dispatch(__WEBPACK_IMPORTED_MODULE_11__Redux_InventoryRedux__["b" /* default */].deleteInventoryRequest(id));},getSupplier:function getSupplier(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_14__Redux_SupplierRedux__["b" /* default */].getSupplierRequest(filter));},getBrand:function getBrand(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_13__Redux_BrandRedux__["b" /* default */].getBrandRequest(filter));},getCategory:function getCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_10__Redux_CategoryRedux__["b" /* default */].getCategoryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageInventory));

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateInventory=function(_React$Component){_inherits(CreateInventory,_React$Component);function CreateInventory(props){_classCallCheck(this,CreateInventory);var _this=_possibleConstructorReturn(this,(CreateInventory.__proto__||Object.getPrototypeOf(CreateInventory)).call(this,props));_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);if(field==='is_featured'){var value=event.target.checked;var featured=_this.state.featured;form.is_featured=value;featured=!featured;_this.setState({form:form,featured:featured});}else if(field==='status'){var _value=event.target.checked;var status=_this.state.status;form.status=_value;status=!status;_this.setState({form:form,status:status});}else{var _value2=event.target.value;form[field]=_value2;_this.setState({form:form});}};_this._discountTypeChange=function(event){var form=Object.assign({},_this.state.form);var value=event.target.value;if(value==='PERCENTAGE_CUT'){_this.setState({isDiscount:true,discount:0});}else if(value==='PRICE_CUT'){_this.setState({isDiscount:false,discount:0});}form.discount_type=value;_this.setState({form:form});};_this._categoryChange=function(selectedCategory){var form=Object.assign({},_this.state.form);var selectedNum=selectedCategory.selectedNum;form.category_id=selectedCategory.value;_this.setState({selectedBrand:'',selectedCategory:selectedCategory,selectedNum:selectedNum,form:form});};_this._brandChange=function(selectedBrand){var form=Object.assign({},_this.state.form);form.brand_id=selectedBrand.value;_this.setState({selectedBrand:selectedBrand,form:form});};_this._supplierChange=function(selectedSupplier){var form=Object.assign({},_this.state.form);form.supplier_id=selectedSupplier.value;_this.setState({selectedSupplier:selectedSupplier,form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.state.featured===true?form.is_featured=1:form.is_featured=0;_this.state.status===true?form.status=1:form.status=0;form.currency_code=form.iso_code==='PH'?'PHP':'IDR';_this.props.createInventory(form);setTimeout(function(){_this.props.closeModal();},250);};_this.discount_type=[{value:'PRICE_CUT',label:'PRICE_CUT'},{value:'PERCENTAGE_CUT',label:'PERCENTAGE_CUT'}];_this.iso_code=[{value:'ID',label:'ID'},{value:'PH',label:'PH'}];_this.state={selectedNum:undefined,selectedCategory:'',selectedBrand:'',selectedSupplier:'',featured:false,status:false,isDiscount:false,form:{sku_m:'',category_id:'',brand_id:'',supplier_id:'',name:'',status:false,is_featured:false,buy_price:'',normal_price:'',discount_type:'PRICE_CUT',discount:0,weight:'',dimension:'',description:'',supplier:'',iso_code:Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])(),currency_code:''}};return _this;}_createClass(CreateInventory,[{key:'componentDidMount',value:function componentDidMount(){this.props.getSupplier();}},{key:'render',value:function render(){var _this2=this;var category=this.props.category;var categoryPicker=[];var brandPicker=[];var supplierPicker=[];category.data.map(function(item,i){categoryPicker[i]={value:item.id,label:item.name,selectedNum:i};return categoryPicker;});if(category.data.length>0){if(this.state.selectedNum===undefined){brandPicker=[];}else{category.data[this.state.selectedNum].brand.map(function(item,i){brandPicker[i]={value:item.id,label:item.name};return brandPicker;});}}this.props.supplier.data.map(function(supplier){supplierPicker.push({value:supplier.id,label:supplier.name});return supplier;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a,{checked:this.state.status,onChange:function onChange(event){return _this2._inputChange(event,'status');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Featured')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a,{checked:this.state.featured,onChange:function onChange(event){return _this2._inputChange(event,'is_featured');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'SKU Master')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.sku_m,onChange:function onChange(event){return _this2._inputChange(event,'sku_m');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:categoryPicker,name:'category-picker',required:true,placeholder:'Pick a Category',value:this.state.selectedCategory,onChange:function onChange(selectedCategory){return _this2._categoryChange(selectedCategory);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{isDisabled:this.state.selectedNum===undefined,options:brandPicker,name:'brand-picker',placeholder:'Pick a Brand',value:this.state.selectedBrand,onChange:function onChange(selectedBrand){return _this2._brandChange(selectedBrand);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Buy Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.buy_price,onChange:function onChange(event){return _this2._inputChange(event,'buy_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Normal Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.normal_price,onChange:function onChange(event){return _this2._inputChange(event,'normal_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.form.discount_type,className:'form-control',onChange:function onChange(event){return _this2._discountTypeChange(event);}},this.discount_type.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),this.state.isDiscount===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,max:100,className:'form-control',value:this.state.form.discount,onChange:function onChange(event){return _this2._inputChange(event,'discount');}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.form.discount,onChange:function onChange(event){return _this2._inputChange(event,'discount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Weight')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.weight,onChange:function onChange(event){return _this2._inputChange(event,'weight');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Dimension')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Length x Width x Height',className:'form-control',value:this.state.form.dimension,onChange:function onChange(event){return _this2._inputChange(event,'dimension');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Supplier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:supplierPicker,name:'suplier-picker',required:true,value:this.state.selectedSupplier,onChange:function onChange(selectedSupplier){return _this2._supplierChange(selectedSupplier);},placeholder:'Pick a Suplier'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:'3',className:'form-control',value:this.state.form.description,onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),Object(__WEBPACK_IMPORTED_MODULE_6__Utils_PrivilegeUtils__["a" /* currentBranch */])()!=='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Source')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.form.iso_code,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'iso_code');}},this.iso_code.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateInventory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{category:state.category,supplier:state.supplier};};var dispatchToProps=function dispatchToProps(dispatch){return{createInventory:function createInventory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__["b" /* default */].createInventoryRequest(data));},getSupplier:function getSupplier(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__["b" /* default */].getSupplierRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateInventory));

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageInventoryImage=function(_React$Component){_inherits(ManageInventoryImage,_React$Component);function ManageInventoryImage(props){_classCallCheck(this,ManageInventoryImage);var _this=_possibleConstructorReturn(this,(ManageInventoryImage.__proto__||Object.getPrototypeOf(ManageInventoryImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image1=newProps.files.data.upload[0].filename;form.image2=newProps.files.data.upload[0].filename;form.image3=newProps.files.data.upload[0].filename;form.image4=newProps.files.data.upload[0].filename;form.image5=newProps.files.data.upload[0].filename;}};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','inventory');data.append('image_type');_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.updateInventoryImage(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{image1:null,image2:null,image3:null,image4:null,image5:null},image_type:'',file:null,uploaded:false};return _this;}_createClass(ManageInventoryImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Inventory Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image 1')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{required:true,setting:{type:'inventory',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image1');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image 2')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'inventory',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image2');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image 3')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'inventory',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image3');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image 4')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'inventory',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image4');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image 5')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FileUploader__["a" /* default */],{setting:{type:'inventory',image_type:'image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image5');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save')))));}}]);return ManageInventoryImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadReset());},updateInventoryImage:function updateInventoryImage(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__["b" /* default */].updateInventoryImageRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageInventoryImage));

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateInventory=function(_React$Component){_inherits(UpdateInventory,_React$Component);function UpdateInventory(props){_classCallCheck(this,UpdateInventory);var _this=_possibleConstructorReturn(this,(UpdateInventory.__proto__||Object.getPrototypeOf(UpdateInventory)).call(this,props));_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);if(field==='is_featured'){var value=event.target.checked;var featured=_this.state.featured;form.is_featured=value;featured=!featured;_this.setState({form:form,featured:featured});}else if(field==='status'){var _value=event.target.checked;var status=_this.state.status;form.status=_value;status=!status;_this.setState({form:form,status:status});}else{var _value2=event.target.value;form[field]=_value2;_this.setState({form:form});}};_this._discountTypeChange=function(event){var form=Object.assign({},_this.state.form);var value=event.target.value;if(value==='PERCENTAGE_CUT'){_this.setState({isDiscount:true});}else if(value==='PRICE_CUT'){_this.setState({isDiscount:false});}form.discount_type=value;_this.setState({form:form});};_this._categoryChange=function(selectedCategory){var form=Object.assign({},_this.state.form);var selectedNum=selectedCategory.selectedNum;form.category_id=selectedCategory.value;_this.setState({selectedBrand:'',selectedCategory:selectedCategory,selectedNum:selectedNum,form:form});};_this._brandChange=function(selectedBrand){var form=Object.assign({},_this.state.form);form.brand_id=selectedBrand.value;_this.setState({selectedBrand:selectedBrand,form:form});};_this._supplierChange=function(selectedSupplier){var form=Object.assign({},_this.state.form);form.supplier_id=selectedSupplier.value;_this.setState({selectedSupplier:selectedSupplier,form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);_this.state.featured===true?form.is_featured=1:form.is_featured=0;_this.state.status===true?form.status=1:form.status=0;var data={id:_this.props.detail.id,form:form};_this.props.updateInventory(data);setTimeout(function(){_this.props.closeModal();},250);};_this.discount_type=[{value:'PRICE_CUT',label:'PRICE_CUT'},{value:'PERCENTAGE_CUT',label:'PERCENTAGE_CUT'}];_this.iso_code=[{value:'ID',label:'ID'},{value:'PH',label:'PH'}];_this.state={selectedNum:undefined,selectedCategory:props.selectedCategory,selectedBrand:props.selectedBrand,selectedSupplier:props.selectedSupplier,featured:props.detail.is_featured===1,status:props.detail.status===1,isDiscount:props.detail.discount_type==='PERCENTAGE_CUT',form:{sku_m:props.detail.sku_m,category_id:props.detail.category_id,brand_id:props.detail.brand_id,supplier_id:props.detail.supplier_id,name:props.detail.name,status:props.detail.status,is_featured:props.detail.is_featured,buy_price:props.detail.buy_price,normal_price:props.detail.normal_price,discount_type:props.detail.discount_type,discount:props.detail.discount,weight:props.detail.weight,dimension:props.detail.dimension,description:props.detail.description,supplier:props.detail.supplier,iso_code:props.detail.iso_code,currency_code:props.detail.currency_code}};return _this;}_createClass(UpdateInventory,[{key:'componentDidMount',value:function componentDidMount(){this.props.getSupplier();}},{key:'render',value:function render(){var _this2=this;var category=this.props.category;var categoryPicker=[];var brandPicker=[];var supplierPicker=[];category.data.map(function(item,i){categoryPicker[i]={value:item.id,label:item.name,selectedNum:i};return categoryPicker;});if(category.data.length>0){if(this.state.selectedNum===undefined){brandPicker=[];}else{category.data[this.state.selectedNum].brand.map(function(item,i){brandPicker[i]={value:item.id,label:item.name};return brandPicker;});}}this.props.supplier.data.map(function(supplier){supplierPicker.push({value:supplier.id,label:supplier.name});return supplier;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a,{checked:this.state.status,onChange:function onChange(event){return _this2._inputChange(event,'status');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Featured')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a,{checked:this.state.featured,onChange:function onChange(event){return _this2._inputChange(event,'is_featured');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'SKU Master')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.sku_m,onChange:function onChange(event){return _this2._inputChange(event,'sku_m');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Category')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:categoryPicker,name:'category-picker',required:true,value:this.state.selectedCategory,onChange:function onChange(selectedCategory){return _this2._categoryChange(selectedCategory);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Brand')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{isDisabled:this.state.selectedNum===undefined,options:brandPicker,name:'brand-picker',value:this.state.selectedBrand,onChange:function onChange(selectedBrand){return _this2._brandChange(selectedBrand);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Buy Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.buy_price,onChange:function onChange(event){return _this2._inputChange(event,'buy_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Normal Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.normal_price,onChange:function onChange(event){return _this2._inputChange(event,'normal_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.form.discount_type,className:'form-control',onChange:function onChange(event){return _this2._discountTypeChange(event);}},this.discount_type.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Discount Amount')),this.state.isDiscount===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,max:100,className:'form-control',value:this.state.form.discount,onChange:function onChange(event){return _this2._inputChange(event,'discount');}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:0,className:'form-control',value:this.state.form.discount,onChange:function onChange(event){return _this2._inputChange(event,'discount');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Weight')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.weight,onChange:function onChange(event){return _this2._inputChange(event,'weight');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Dimension')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Length x Width x Height',className:'form-control',value:this.state.form.dimension,onChange:function onChange(event){return _this2._inputChange(event,'dimension');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Supplier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:supplierPicker,name:'suplier-picker',required:true,value:this.state.selectedSupplier,onChange:function onChange(selectedSupplier){return _this2._supplierChange(selectedSupplier);},placeholder:'Pick a Suplier'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:'5',className:'form-control',value:this.state.form.description,onChange:function onChange(event){return _this2._inputChange(event,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Source')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.form.iso_code,className:'form-control',onChange:function onChange(event){return _this2._inputChange(event,'iso_code');}},this.iso_code.map(function(list,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:list.value},list.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateInventory;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{category:state.category,supplier:state.supplier};};var dispatchToProps=function dispatchToProps(dispatch){return{updateInventory:function updateInventory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_InventoryRedux__["b" /* default */].updateInventoryRequest(data));},getSupplier:function getSupplier(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__["b" /* default */].getSupplierRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateInventory));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewInventoryImage=function(_React$Component){_inherits(ViewInventoryImage,_React$Component);function ViewInventoryImage(props){_classCallCheck(this,ViewInventoryImage);var _this=_possibleConstructorReturn(this,(ViewInventoryImage.__proto__||Object.getPrototypeOf(ViewInventoryImage)).call(this,props));_this.state={};return _this;}_createClass(ViewInventoryImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Inventory Images')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.detail.inventory_images.length>0?this.props.detail.inventory_images.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image No. ',i+1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'img img-responsive img-border',style:{width:'100%'},alt:_this2.props.detail.inventory_images[i].image_file,title:_this2.props.detail.inventory_images[i].image_file,src:_this2.props.detail.inventory_images[i].image_url}));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'--No Image--'))));}}]);return ViewInventoryImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewInventoryImage));

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateSupplier__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateSupplier__ = __webpack_require__(1212);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageSupplier=function(_React$Component){_inherits(ManageSupplier,_React$Component);function ManageSupplier(props){_classCallCheck(this,ManageSupplier);var _this=_possibleConstructorReturn(this,(ManageSupplier.__proto__||Object.getPrototypeOf(ManageSupplier)).call(this,props));_this._fetchSupplier=function(event){if(event){event.preventDefault();}var filter={page:_this.state.page,limit:_this.state.limit};_this.props.getSupplier(filter);};_this._changePage=function(page){_this.setState({page:page});setTimeout(function(){_this._fetchSupplier();},250);};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._fetchSupplier();}};_this._deleteSupplier=function(){_this.props.deleteSupplier(_this.state.detail.id);setTimeout(function(){_this._toggleModal();},250);};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this.componentDidMount=function(){_this._fetchSupplier();};_this.dateformat='Y-MM-DD';_this.state={showModal:null,detail:{},page:1};return _this;}_createClass(ManageSupplier,[{key:'render',value:function render(){var _this2=this;var supplier=this.props.supplier;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Suppliers',(supplier.fetching||supplier.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},supplier.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-supplier');}},'Create New Supplier'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(supplier.fetching||supplier.processing)&&supplier.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},supplier.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'200px'}},'Province'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!supplier.data||!supplier.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'6',className:'text-center'},'No data')):supplier.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-left'},item.supplier_address?item.supplier_address.address+', '+item.supplier_address.address_sub_district+', '+item.supplier_address.district.name+', '+item.supplier_address.city.name:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.supplier_address?item.supplier_address.province.name:''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-supplier');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete-supplier');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),'Delete')));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,supplier.data&&supplier.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:supplier.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:supplier.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='create-supplier',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Ecommerce_CreateSupplier__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='edit-supplier',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Ecommerce_UpdateSupplier__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='delete-supplier',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Supplier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Confirm deletion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._deleteSupplier();}},'Delete')))));}}]);return ManageSupplier;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{supplier:state.supplier};};var dispatchToProps=function dispatchToProps(dispatch){return{getSupplier:function getSupplier(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_SupplierRedux__["b" /* default */].getSupplierRequest(filter));},deleteSupplier:function deleteSupplier(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_SupplierRedux__["b" /* default */].deleteSupplierRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageSupplier));

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateSupplier=function(_React$Component){_inherits(CreateSupplier,_React$Component);function CreateSupplier(props){_classCallCheck(this,CreateSupplier);var _this=_possibleConstructorReturn(this,(CreateSupplier.__proto__||Object.getPrototypeOf(CreateSupplier)).call(this,props));_this.componentDidMount=function(){_this.props.getProvince();};_this._inputChange=function(event,field){var value=event.target.value;_this.setState(_defineProperty({},field,value));};_this._locationProvinceChange=function(selectedProvince){_this.props.getCities(selectedProvince.value);_this.setState({selectedProvince:selectedProvince,selectedCity:{},selectedDistrict:{}});};_this._locationCityChange=function(selectedCity){_this.props.getDistricts(selectedCity.value);_this.setState({selectedCity:selectedCity,selectedDistrict:{}});};_this._locationDistrictChange=function(selectedDistrict){_this.setState({selectedDistrict:selectedDistrict});};_this.validateSupplier=function(){var valid=true;var form=Object.assign({},_this.state);var error=Object.assign({},_this.state.error);if(form.name===''){valid=false;error.name='required';}if(form.address===''){valid=false;error.address='required';}if(form.postal_code===''){valid=false;error.postal_code='required';}if(!form.selectedProvince.value){valid=false;error.selectedProvince='required';}if(!form.selectedCity.value){valid=false;error.selectedCity='required';}if(!form.selectedDistrict.value){valid=false;error.selectedDistrict='required';}if(form.address_sub_district===''){valid=false;error.address_sub_district='required';}_this.setState({error:error});return valid;};_this._submit=function(event){event.preventDefault();var form=_this.state;console.log('itss work');if(_this.validateSupplier()===true){var data={name:form.name,address:{address:form.address,address_province_id:form.selectedProvince.value,address_city_id:form.selectedCity.value,address_district_id:form.selectedDistrict.value,address_sub_district:form.address_sub_district,postal_code:form.postal_code}};_this.props.createSupplier(data);setTimeout(function(){_this.props.closeModal();},250);}};_this.state={name:'',selectedProvince:{},selectedCity:{},selectedDistrict:{},address_sub_district:'',address:'',postal_code:'',error:{name:'',province:'',selectedCity:'',selectedDistrict:'',address_sub_district:'',address:'',postal_code:''}};return _this;}_createClass(CreateSupplier,[{key:'render',value:function render(){var _this2=this;var province=[];var location=this.props.location;location.province.map(function(dataProvince){var objProvince={value:dataProvince.id,label:dataProvince.name};return province.push(objProvince);});var city=[];location.city.map(function(dataCity){var objCity={value:dataCity.id,label:dataCity.name};return city.push(objCity);});var district=[];location.district.map(function(dataDistrict){var objDistrict={value:dataDistrict.id,label:dataDistrict.name};return district.push(objDistrict);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create Supplier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Supplier Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Supplier Name',className:'form-control',value:this.state.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:'3',className:'form-control',value:this.state.address,onChange:function onChange(event){return _this2._inputChange(event,'address');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Province')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:province,name:'province-picker',required:true,placeholder:'Select Province',value:this.state.selectedProvince,onChange:function onChange(selected){return _this2._locationProvinceChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedProvince))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'City')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:city,name:'city-picker',required:true,placeholder:'Select City',value:this.state.selectedCity,onChange:function onChange(selected){return _this2._locationCityChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedCity))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'District')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:district,name:'district-picker',required:true,placeholder:'Select District',value:this.state.selectedDistrict,onChange:function onChange(selected){return _this2._locationDistrictChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedDistrict))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Sub District')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Sub District',className:'form-control',value:this.state.address_sub_district,onChange:function onChange(event){return _this2._inputChange(event,'address_sub_district');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Postal Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,placeholder:'Postal Code',className:'form-control',value:this.state.postal_code,onChange:function onChange(event){return _this2._inputChange(event,'postal_code');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateSupplier;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{location:state.location};};var dispatchToProps=function dispatchToProps(dispatch){return{createSupplier:function createSupplier(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__["b" /* default */].createSupplierRequest(data));},getProvince:function getProvince(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getProvinceRequest());},getCities:function getCities(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getCityRequest(id));},getDistricts:function getDistricts(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getDistrictRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateSupplier));

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__ = __webpack_require__(160);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSupplier=function(_React$Component){_inherits(UpdateSupplier,_React$Component);function UpdateSupplier(props){_classCallCheck(this,UpdateSupplier);var _this=_possibleConstructorReturn(this,(UpdateSupplier.__proto__||Object.getPrototypeOf(UpdateSupplier)).call(this,props));_this.componentDidMount=function(){var state=Object.assign({},_this.state);var detail=_this.props.detail;state.name=detail.name;if(detail.supplier_address){state.address=detail.supplier_address.address;state.postal_code=detail.supplier_address.postal_code;state.address_sub_district=detail.supplier_address.address_sub_district;state.selectedDistrict={value:detail.supplier_address.district.id,label:detail.supplier_address.district.name};state.selectedCity={value:detail.supplier_address.city.id,label:detail.supplier_address.city.name};state.selectedProvince={value:detail.supplier_address.province.id,label:detail.supplier_address.province.name};_this.props.getCities(state.selectedProvince.value);_this.props.getDistricts(state.selectedCity.value);}_this.setState(state);_this.props.getProvince();};_this._inputChange=function(event,field){var value=event.target.value;_this.setState(_defineProperty({},field,value));};_this._locationProvinceChange=function(selectedProvince){_this.props.getCities(selectedProvince.value);_this.setState({selectedProvince:selectedProvince,selectedCity:{},selectedDistrict:{}});};_this._locationCityChange=function(selectedCity){_this.props.getDistricts(selectedCity.value);_this.setState({selectedCity:selectedCity,selectedDistrict:{}});};_this._locationDistrictChange=function(selectedDistrict){_this.setState({selectedDistrict:selectedDistrict});};_this.validateSupplier=function(){var valid=true;var form=Object.assign({},_this.state);var error=Object.assign({},_this.state.error);if(form.name===''){valid=false;error.name='required';}if(form.address===''){valid=false;error.address='required';}if(form.postal_code===''){valid=false;error.postal_code='required';}if(!form.selectedProvince.value){valid=false;error.selectedProvince='required';}if(!form.selectedCity.value){valid=false;error.selectedCity='required';}if(!form.selectedDistrict.value){valid=false;error.selectedDistrict='required';}if(form.address_sub_district===''){valid=false;error.address_sub_district='required';}_this.setState({error:error});return valid;};_this._submit=function(event){event.preventDefault();var form=_this.state;if(_this.validateSupplier()===true){var data={id:_this.props.detail.id,form:{name:form.name,address:{address:form.address,address_province_id:form.selectedProvince.value,address_city_id:form.selectedCity.value,address_district_id:form.selectedDistrict.value,address_sub_district:form.address_sub_district,postal_code:form.postal_code}}};_this.props.updateSupplier(data);setTimeout(function(){_this.props.closeModal();},250);}};_this.state={name:'',selectedProvince:{},selectedCity:{},selectedDistrict:{},address_sub_district:'',address:'',postal_code:'',error:{name:'',province:'',selectedCity:'',selectedDistrict:'',address_sub_district:'',address:'',postal_code:''}};return _this;}_createClass(UpdateSupplier,[{key:'render',value:function render(){var _this2=this;var province=[];var location=this.props.location;location.province.map(function(dataProvince){var objProvince={value:dataProvince.id,label:dataProvince.name};return province.push(objProvince);});var city=[];location.city.map(function(dataCity){var objCity={value:dataCity.id,label:dataCity.name};return city.push(objCity);});var district=[];location.district.map(function(dataDistrict){var objDistrict={value:dataDistrict.id,label:dataDistrict.name};return district.push(objDistrict);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Supplier')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Supplier Name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Supplier Name',className:'form-control',value:this.state.name,onChange:function onChange(event){return _this2._inputChange(event,'name');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Address')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:'3',className:'form-control',value:this.state.address,onChange:function onChange(event){return _this2._inputChange(event,'address');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Province')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:province,name:'province-picker',required:true,placeholder:'Select Province',value:this.state.selectedProvince,onChange:function onChange(selected){return _this2._locationProvinceChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedProvince))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'City')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:city,name:'city-picker',required:true,placeholder:'Select City',value:this.state.selectedCity,onChange:function onChange(selected){return _this2._locationCityChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedCity))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'District')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{options:district,name:'district-picker',required:true,placeholder:'Select District',value:this.state.selectedDistrict,onChange:function onChange(selected){return _this2._locationDistrictChange(selected);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'offset-3 col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'13px',color:'#FF4444'}},this.state.error.selectedDistrict))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Sub District')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Sub District',className:'form-control',value:this.state.address_sub_district,onChange:function onChange(event){return _this2._inputChange(event,'address_sub_district');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Postal Code')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,placeholder:'Postal Code',className:'form-control',value:this.state.postal_code,onChange:function onChange(event){return _this2._inputChange(event,'postal_code');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateSupplier;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{location:state.location};};var dispatchToProps=function dispatchToProps(dispatch){return{updateSupplier:function updateSupplier(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SupplierRedux__["b" /* default */].updateSupplierRequest(data));},getProvince:function getProvince(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getProvinceRequest());},getCities:function getCities(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getCityRequest(id));},getDistricts:function getDistricts(id){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_LocationRedux__["b" /* default */].getDistrictRequest(id));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSupplier));

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_EllipsisModal__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Ecommerce_CreateEcommerceProduct__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Ecommerce_UpdateEcommerceProduct__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Containers_Ecommerce_AddEcommerceStock__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_toggle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageEcommerceProduct=function(_React$Component){_inherits(ManageEcommerceProduct,_React$Component);function ManageEcommerceProduct(props){_classCallCheck(this,ManageEcommerceProduct);var _this=_possibleConstructorReturn(this,(ManageEcommerceProduct.__proto__||Object.getPrototypeOf(ManageEcommerceProduct)).call(this,props));_initialiseProps.call(_this);_this.dateformat='Y-MM-DD';_this.filterOrigin=[{label:'ALL',value:'',restriction:'PH'},{label:'Passpod ID',value:'ID',restriction:'PH'},{label:'Passpod PH',value:'PH'}];_this.state={showModal:null,errorMsg:'',detail:{},page:1,ecommerceProductID:'',inventoryID:'',inventoryName:'',selectedSize:{value:'',label:''},selectedColour:{value:'',label:''},selectedWarehouse:{value:'',label:''},filter:{page:1,title:'',category:'',brand:'',supplier:'',iso_code:''}};return _this;}_createClass(ManageEcommerceProduct,[{key:'render',value:function render(){var _this2=this;var ecommerceProduct=this.props.ecommerceProduct;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Product',(ecommerceProduct.fetching||ecommerceProduct.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},ecommerceProduct.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchInventory(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Product Title',className:'form-control',value:this.state.filter.title,onChange:function onChange(event){return _this2._filterChange(event.target.value,'title');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Categories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.category,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'category');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Category -- '),this.props.category.data.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:category.id,key:index},' ',category.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.brand,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'brand');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Brand -- '),this.props.brand.data.map(function(brand,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:brand.id,key:index},' ',brand.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Supplier'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.supplier,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'supplier');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},' -- Select Supplier -- '),this.props.supplier.data.map(function(supplier,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:supplier.id,key:index},' ',supplier.name,' ');}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Origin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.filter.iso_code,className:'form-control',onChange:function onChange(event){return _this2._filterChange(event.target.value,'iso_code');}},this.filterOrigin.map(function(origin,index){if(origin.restriction!==Object(__WEBPACK_IMPORTED_MODULE_12__Utils_PrivilegeUtils__["a" /* currentBranch */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:origin.value,key:index},' ',origin.label,' ');}else{return false;}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(ecommerceProduct.fetching||ecommerceProduct.processing)&&ecommerceProduct.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},ecommerceProduct.err),this.state.errorMsg&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},this.state.errorMsg),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Inventory Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!ecommerceProduct.data.data||!ecommerceProduct.data.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'12',className:'text-center'},'No data')):ecommerceProduct.data.data.map(function(items,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-toggle':'collapse','data-target':'#collapse-'+i,className:'btn btn-info mr-2',type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}),' Variants'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,items.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'SKU Master'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Brand'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Discount Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Buy Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Normal Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Final Price'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},items.sku_m||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},items.category.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},items.brand.name||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},items.discount_type||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(items.buy_price)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(items.normal_price)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(items.final_price)||'-'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapse',id:'collapse-'+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary text-center',onClick:function onClick(){return _this2._selectItem(items,null,'add-ecommerce-product');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add Variant')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'SKU Variant'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'In Stock'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Buy Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Subtype'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Vending Machine ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Warehouse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Stock History'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!items.inventory_items||!items.inventory_items.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'13'},' --No Data-- ')):items.inventory_items.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.sku_v||'No data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.itemIn-item.itemOut||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.price)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},Object(__WEBPACK_IMPORTED_MODULE_4__Utils_FormatMoney__["a" /* default */])(item.buy_price)||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.varian_colour!==null?item.varian_colour.name:'No data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.varian_size!==null?item.varian_size.name:'No data'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.vm_product_id?item.vm_product_id:'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_EllipsisModal__["a" /* default */],{type:'array',descriptor:'Warehouse',name:item.warehouse.name,description:[{label:'Address: ',content:item.warehouse.address},{label:'Details: ',content:item.warehouse.detail_info}]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_toggle___default.a,{checked:item.availability===1,onChange:function onChange(){return _this2._toggleAvailability(item,item.id,items.id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'text-center btn btn-info align-middle',onClick:function onClick(){return _this2._selectItem(item,items,'view-ecommerce-product');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-book'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'text-center btn btn-primary align-middle',onClick:function onClick(){return _this2._selectItem(item,items,'update-ecommerce-product');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'text-center btn btn-danger align-middle',onClick:function onClick(){return _this2._selectItem(item,items,'delete-ecommerce-product');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})))))));})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},ecommerceProduct.data&&ecommerceProduct.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:ecommerceProduct.data.page||this.state.page,itemsCountPerPage:10,totalItemsCount:ecommerceProduct.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='add-ecommerce-product',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Ecommerce_CreateEcommerceProduct__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-ecommerce-product',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Containers_Ecommerce_AddEcommerceStock__["a" /* default */],{inventoryID:this.state.inventoryID,ecommerceProductID:this.state.ecommerceProductID,inventoryName:this.state.inventoryName,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-ecommerce-product',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Ecommerce_UpdateEcommerceProduct__["a" /* default */],{detail:this.state.detail,inventoryID:this.state.inventoryID,selectedSize:this.state.selectedSize,selectedColour:this.state.selectedColour,selectedWarehouse:this.state.selectedWarehouse,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='delete-ecommerce-product',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'30vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete product')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._deleteEcommerceProduct();}},'Delete')))));}}]);return ManageEcommerceProduct;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3._fetchInventory();_this3.props.getCategory();_this3.props.getSupplier();_this3.props.getBrand();};this.componentDidUpdate=function(prevProps){if(_this3.props.ecommerceProduct.err!==prevProps.ecommerceProduct.err&&_this3.props.ecommerceProduct.err!==null){_this3.setState({errorMsg:_this3.props.ecommerceProduct.err});}};this._fetchInventory=function(event){if(event){event.preventDefault();}var data=Object.assign({},_this3.state.filter);_this3.props.getEcommerceProduct(data);};this._filterChange=function(data,field){var filter=Object.assign({},_this3.state.filter);filter[field]=data;_this3.setState({filter:filter});};this._changePage=function(page){var filter=Object.assign({},_this3.state.filter);filter.page=page;_this3.props.getEcommerceProduct(filter);};this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this3.setState({showModal:modalId});if(!modalId){_this3._fetchInventory();}};this._selectItem=function(child,parent,action){if(action==='update-ecommerce-product'){_this3.setState({inventoryID:parent.id,selectedSize:{value:!child.varian_size?'':child.varian_size.id,label:!child.varian_size?'':child.varian_size.name},selectedColour:{value:!child.varian_colour?'':child.varian_colour.id,label:!child.varian_colour?'':child.varian_colour.name},selectedWarehouse:{value:!child.warehouse?'':child.warehouse.id,label:!child.warehouse?'':child.warehouse.name},detail:child});_this3._toggleModal(action);}else if(action==='delete-ecommerce-product'){_this3.setState({inventoryID:parent.id,ecommerceProductID:child.id});_this3._toggleModal(action);}else if(action==='add-ecommerce-product'){_this3.setState({detail:child});_this3._toggleModal(action);}else if(action==='view-ecommerce-product'){_this3.setState({inventoryID:parent.id,ecommerceProductID:child.id,inventoryName:parent.name});_this3._toggleModal(action);}};this._toggleAvailability=function(item,ecommerceProductID,inventoryID){var form={sku_v:item.sku_v,warehouse_id:item.warehouse.id,availability:undefined};item.availability===0?form.availability=1:form.availability=0;var data={ecommerceProductID:ecommerceProductID,inventoryID:inventoryID,form:form};_this3.props.updateEcommerceProduct(data);setTimeout(function(){_this3._fetchInventory();},300);};this._deleteEcommerceProduct=function(){var payload={inventoryID:_this3.state.inventoryID,ecommerceProductID:_this3.state.ecommerceProductID};_this3.props.deleteEcommerceProduct(payload);setTimeout(function(){_this3._toggleModal();},250);};this._manipulateState=function(props){var filter=Object.assign({},props);filter.page=_this3.state.filter.page;_this3.setState({filter:filter});};};var stateToProps=function stateToProps(state){return{ecommerceProduct:state.ecommerceProduct,category:state.category,supplier:state.supplier,brand:state.brand};};var dispatchToProps=function dispatchToProps(dispatch){return{getEcommerceProduct:function getEcommerceProduct(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_EcommerceProductRedux__["b" /* default */].getEcommerceProductRequest(filter));},updateEcommerceProduct:function updateEcommerceProduct(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_EcommerceProductRedux__["b" /* default */].updateEcommerceProductRequest(data));},deleteEcommerceProduct:function deleteEcommerceProduct(payload){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_EcommerceProductRedux__["b" /* default */].deleteEcommerceProductRequest(payload));},getCategory:function getCategory(data){return dispatch(__WEBPACK_IMPORTED_MODULE_7__Redux_CategoryRedux__["b" /* default */].getCategoryRequest(data));},getSupplier:function getSupplier(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_9__Redux_SupplierRedux__["b" /* default */].getSupplierRequest(filter));},getBrand:function getBrand(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_BrandRedux__["b" /* default */].getBrandRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageEcommerceProduct));

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateEcommerceProduct=function(_React$Component){_inherits(CreateEcommerceProduct,_React$Component);function CreateEcommerceProduct(props){_classCallCheck(this,CreateEcommerceProduct);var _this=_possibleConstructorReturn(this,(CreateEcommerceProduct.__proto__||Object.getPrototypeOf(CreateEcommerceProduct)).call(this,props));_this.componentDidMount=function(){_this.props.getColour();_this.props.getSize();_this.props.getWarehouse();var _this$props=_this.props,colour=_this$props.colour,size=_this$props.size,warehouse=_this$props.warehouse;var colourPicker=[];var sizePicker=[];var warehousePicker=[];colour.dataAll.map(function(item,i){colourPicker[i]={value:item.id,label:item.name};return colourPicker;});_this.colourPicker=colourPicker;size.dataAll.map(function(item,i){sizePicker[i]={value:item.id,label:item.name};return sizePicker;});_this.sizePicker=sizePicker;warehouse.data.map(function(item,i){warehousePicker[i]={value:item.id,label:item.name};return warehousePicker;});_this.warehousePicker=warehousePicker;};_this._inputChange=function(event,field){var ecommerceProduct=Object.assign({},_this.state.ecommerceProduct);if(field==='varian_size_id'){ecommerceProduct.varian_size_id=event.value;_this.setState({selectedSize:event,ecommerceProduct:ecommerceProduct});}else if(field==='varian_colour_id'){ecommerceProduct.varian_colour_id=event.value;_this.setState({selectedColour:event,ecommerceProduct:ecommerceProduct});}else if(field==='warehouse_id'){ecommerceProduct.warehouse_id=event.value;_this.setState({selectedWarehouse:event,ecommerceProduct:ecommerceProduct});}else{var value=event.target.value;ecommerceProduct[field]=value;_this.setState({ecommerceProduct:ecommerceProduct});}};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.ecommerceProduct);var data={id:_this.state.id,form:form};_this.props.createEcommerceProduct(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={id:props.detail.id,name:props.detail.name,selectedSize:'',selectedColour:'',selectedWarehouse:'',ecommerceProduct:{inventory_id:'',sku_v:'',varian_size_id:'',varian_colour_id:'',quantity:'',supplier:'',price:0,buy_price:0,warehouse_id:'',vm_product_id:''}};return _this;}_createClass(CreateEcommerceProduct,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'60vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Add Product Variant')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'control-label text-center'},this.state.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'SKU Varian')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'text',className:'form-control',value:this.state.ecommerceProduct.sku_v,onChange:function onChange(event){return _this2._inputChange(event,'sku_v');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:this.colourPicker,name:'colour-picker',required:true,placeholder:'Pick available type',value:this.state.selectedColour,onChange:function onChange(selectedColour){return _this2._inputChange(selectedColour,'varian_colour_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:this.sizePicker,name:'size-picker',required:true,placeholder:'Pick available subtype',value:this.state.selectedSize,onChange:function onChange(selectedSize){return _this2._inputChange(selectedSize,'varian_size_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Vending Machine ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.ecommerceProduct.vm_product_id,onChange:function onChange(event){return _this2._inputChange(event,'vm_product_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'number',min:'0',className:'form-control',value:this.state.ecommerceProduct.price,onChange:function onChange(event){return _this2._inputChange(event,'price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Buy Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',className:'form-control',value:this.state.ecommerceProduct.buy_price,onChange:function onChange(event){return _this2._inputChange(event,'buy_price');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Warehouse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:this.warehousePicker,name:'warehouse-picker',required:true,placeholder:'Pick available warehouse',value:this.state.selectedWarehouse,onChange:function onChange(selectedWarehouse){return _this2._inputChange(selectedWarehouse,'warehouse_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'number',min:'1',className:'form-control',value:this.state.ecommerceProduct.quantity,onChange:function onChange(event){return _this2._inputChange(event,'quantity');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return CreateEcommerceProduct;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{size:state.size,colour:state.colour,warehouse:state.warehouse};};var dispatchToProps=function dispatchToProps(dispatch){return{getSize:function getSize(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SizeRedux__["b" /* default */].getAllSizeRequest());},getColour:function getColour(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ColourRedux__["b" /* default */].getAllColourRequest());},getWarehouse:function getWarehouse(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_WarehouseRedux__["b" /* default */].getWarehouseRequest());},createEcommerceProduct:function createEcommerceProduct(form){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductRequest(form));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateEcommerceProduct));

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_WarehouseRedux__ = __webpack_require__(108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateEcommerceProduct=function(_React$Component){_inherits(UpdateEcommerceProduct,_React$Component);function UpdateEcommerceProduct(props){_classCallCheck(this,UpdateEcommerceProduct);var _this=_possibleConstructorReturn(this,(UpdateEcommerceProduct.__proto__||Object.getPrototypeOf(UpdateEcommerceProduct)).call(this,props));_this.componentDidMount=function(){_this.props.getSize();_this.props.getColour();_this.props.getWarehouse();};_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);var val=event.target.value;form[field]=val;_this.setState({form:form});};_this._selectChange=function(event,field){var form=Object.assign({},_this.state.form);form[field]=event.value;if(field==='varian_size_id'){_this.setState({selectedSize:event,form:form});}else if(field==='varian_colour_id'){_this.setState({selectedColour:event,form:form});}else if(field==='warehouse_id'){_this.setState({selectedWarehouse:event,form:form});}};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={inventoryID:_this.state.inventoryID,ecommerceProductID:_this.state.ecommerceProductID,form:form};_this.props.updateEcommerceProduct(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={ecommerceProductID:props.detail.id,inventoryID:props.inventoryID,selectedSize:props.selectedSize,selectedColour:props.selectedColour,selectedWarehouse:props.selectedWarehouse,form:{sku_v:props.detail.sku_v||'',varian_size_id:props.detail.varian_size.id||'',varian_colour_id:props.detail.varian_colour.id||'',price:props.detail.price||0,buy_price:props.detail.buy_price||0,warehouse_id:props.detail.warehouse.id||'',vm_product_id:props.detail.vm_product_id||''}};return _this;}_createClass(UpdateEcommerceProduct,[{key:'render',value:function render(){var _this2=this;var _props=this.props,colour=_props.colour,size=_props.size,warehouse=_props.warehouse;var colourPicker=[];var sizePicker=[];var warehousePicker=[];colour.dataAll.map(function(item,i){colourPicker[i]={value:item.id,label:item.name};return colourPicker;});size.dataAll.map(function(item,i){sizePicker[i]={value:item.id,label:item.name};return sizePicker;});warehouse.data.map(function(item,i){warehousePicker[i]={value:item.id,label:item.name};return warehousePicker;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Product Variant')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Edit SKU Variant')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.sku_v,onChange:function onChange(event){return _this2._inputChange(event,'sku_v');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:colourPicker,value:this.state.selectedColour,required:true,placeholder:'Pick available type',onChange:function onChange(selectedColour){return _this2._selectChange(selectedColour,'varian_colour_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtype')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:sizePicker,value:this.state.selectedSize,required:true,placeholder:'Pick available subtype',onChange:function onChange(selectedSize){return _this2._selectChange(selectedSize,'varian_size_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Vending Machine ID')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.form.vm_product_id,onChange:function onChange(event){return _this2._inputChange(event,'vm_product_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,type:'number',min:'0',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,'price');},className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Buy Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'0',value:this.state.form.buy_price,onChange:function onChange(event){return _this2._inputChange(event,'buy_price');},className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Warehouse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:warehousePicker,value:this.state.selectedWarehouse,required:true,onChange:function onChange(selectedWarehouse){return _this2._selectChange(selectedWarehouse,'warehouse_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateEcommerceProduct;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{size:state.size,colour:state.colour,warehouse:state.warehouse};};var dispatchToProps=function dispatchToProps(dispatch){return{getSize:function getSize(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_SizeRedux__["b" /* default */].getAllSizeRequest());},getColour:function getColour(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_ColourRedux__["b" /* default */].getAllColourRequest());},getWarehouse:function getWarehouse(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_WarehouseRedux__["b" /* default */].getWarehouseRequest());},updateEcommerceProduct:function updateEcommerceProduct(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__["b" /* default */].updateEcommerceProductRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateEcommerceProduct));

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddEcommerceStock=function(_React$Component){_inherits(AddEcommerceStock,_React$Component);function AddEcommerceStock(props){_classCallCheck(this,AddEcommerceStock);var _this=_possibleConstructorReturn(this,(AddEcommerceStock.__proto__||Object.getPrototypeOf(AddEcommerceStock)).call(this,props));_this.componentDidMount=function(){_this._fetchViewEcommerceProduct();};_this._addEcommerceProductStock=function(event){event.preventDefault();var form=Object.assign({},_this.state.ecommerceProduct);var data={inventoryID:_this.props.inventoryID,ecommerceProductID:_this.props.ecommerceProductID,form:form};_this.props.createEcommerceProductStock(data);setTimeout(function(){_this.props.closeModal();},250);};_this._inputChange=function(event,field){var ecommerceProduct=Object.assign({},_this.state.ecommerceProduct);var value=event.target.value;ecommerceProduct[field]=value;_this.setState({ecommerceProduct:ecommerceProduct});};_this._fetchViewEcommerceProduct=function(){var data={inventoryID:_this.props.inventoryID,ecommerceProductID:_this.props.ecommerceProductID};_this.props.viewEcommerceProduct(data);};_this.dateformat='Y-MM-DD';_this.state={ecommerceProduct:{qty:''}};return _this;}_createClass(AddEcommerceStock,[{key:'render',value:function render(){var _this2=this;var data_view=this.props.data_view;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Add Stock of ',this.props.inventoryName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._addEcommerceProductStock(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form=group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Add Stock')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:'1',className:'form-control',value:this.state.ecommerceProduct.qty,placeholder:'Stock quantity',onChange:function onChange(event){return _this2._inputChange(event,'qty');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 mt-3 mb-3 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Created At'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'QTY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,data_view.inventory_item_stock&&data_view.inventory_item_stock.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(item.created_at).format(_this2.dateformat)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.qty));}))));}}]);return AddEcommerceStock;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{data_view:state.ecommerceProduct.data_view};};var dispatchToProps=function dispatchToProps(dispatch){return{viewEcommerceProduct:function viewEcommerceProduct(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__["b" /* default */].viewEcommerceProductRequest(data));},createEcommerceProductStock:function createEcommerceProductStock(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductStockRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AddEcommerceStock));

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Ecommerce_ViewShippingDetail__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_EcommerceOrderRedux__ = __webpack_require__(161);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManageEcommerceOrder=function(_React$Component){_inherits(ManageEcommerceOrder,_React$Component);function ManageEcommerceOrder(props){_classCallCheck(this,ManageEcommerceOrder);var _this=_possibleConstructorReturn(this,(ManageEcommerceOrder.__proto__||Object.getPrototypeOf(ManageEcommerceOrder)).call(this,props));_this.componentDidMount=function(){_this._customFetch();};_this._customFetch=function(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{page:1};var event=arguments[1];if(event)event.preventDefault();var params=Object.assign({},_this.state.filter,filter);_this.props.getEcommerceOrder(params);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this._customFetch({page:page});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._customFetch(_this.state.filter.page);}};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this.dateformat='Y-MM-DD';_this.state={showModal:null,detail:{},filter:{page:1,limit:10}};return _this;}_createClass(ManageEcommerceOrder,[{key:'render',value:function render(){var _this2=this;var ecommerceOrder=this.props.ecommerceOrder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Ecommerce Order',(ecommerceOrder.fetching||ecommerceOrder.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(ecommerceOrder.fetching||ecommerceOrder.processing)&&ecommerceOrder.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},ecommerceOrder.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Order Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Phone Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Email Address'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Shipping Detail'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,ecommerceOrder.data&&ecommerceOrder.data.data&&ecommerceOrder.data.data.length?ecommerceOrder.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.order_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.salutation,' ',item.first_name,' ',item.last_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.phone_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this2._selectItem(item,'view-shipping');},disabled:item.status!=='confirmed'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-book'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'6'},'--No Data--'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},ecommerceOrder.data&&ecommerceOrder.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:ecommerceOrder.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:ecommerceOrder.data.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='view-shipping',onClose:function onClose(){return _this2._toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Ecommerce_ViewShippingDetail__["a" /* default */],{uuid:this.state.detail.id,closeModal:function closeModal(){return _this2._toggleModal();}}))));}}]);return ManageEcommerceOrder;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{ecommerceOrder:state.ecommerceOrder};};var dispatchToProps=function dispatchToProps(dispatch){return{getEcommerceOrder:function getEcommerceOrder(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderRequest(filter));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ManageEcommerceOrder));

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__ = __webpack_require__(161);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewShippingDetail=function(_React$Component){_inherits(ViewShippingDetail,_React$Component);function ViewShippingDetail(props){_classCallCheck(this,ViewShippingDetail);var _this=_possibleConstructorReturn(this,(ViewShippingDetail.__proto__||Object.getPrototypeOf(ViewShippingDetail)).call(this,props));_this.componentDidMount=function(){_this._customFetch();};_this._customFetch=function(){_this.props.getEcommerceOrderShipping({uuid:_this.props.uuid});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});if(!modalId){_this._customFetch();}};_this._editMode=function(editMode){_this.setState({editMode:editMode});if(editMode){_this.setState({form:{note:_this.state.detail.note,status:_this.state.detail.status}});}else{_this.setState({form:{note:'',status:''}});}};_this._toggleForm=function(item){_this.setState({detail:item});setTimeout(function(){_this._editMode(true);},50);};_this._selectItem=function(item,action){_this.setState({detail:item});setTimeout(function(){_this._toggleModal(action);},50);};_this._inputChange=function(event,field){event.preventDefault();var value=event.target.value;var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._delete=function(){var data={uuid:_this.state.detail.order_id,shippingUUID:_this.state.detail.id};_this.props.deleteEcommerceOrderShipping(data);setTimeout(function(){_this._toggleModal();},250);};_this._submit=function(event){event.preventDefault();_this._editMode(false);if(_this.state.editMode===false){var form=Object.assign({},_this.state.form);var uuid=_this.props.uuid;var data={uuid:uuid,form:form};_this.props.postEcommerceOrderShipping(data);}else{var _form=Object.assign({},_this.state.form);var _data={uuid:_this.state.detail.order_id,shippingUUID:_this.state.detail.id,form:_form};_this.props.putEcommerceOrderShipping(_data);}setTimeout(function(){_this._customFetch();},250);};_this._renderForm=function(ORDER_NUMBER){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Order Number')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-control'},!_this.state.editMode?ORDER_NUMBER:ORDER_NUMBER+' (EDIT)'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Shipping Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:_this.state.form.status,onChange:function onChange(event){return _this._inputChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'Choose shipping status'),_this.status.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:item.value},item.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Shipping notes')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Write shipping status here ...',rows:'3',className:'form-control',value:_this.state.form.note,onChange:function onChange(event){return _this._inputChange(event,'note');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},_this.state.editMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this._editMode(false);}},'Cancel'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},_this.state.editMode?'Save':'Submit'))));};_this._renderTable=function(ORDER_SHIPPING_HISTORIES){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',style:{minWidth:'250px'}},'Note'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,ORDER_SHIPPING_HISTORIES&&ORDER_SHIPPING_HISTORIES.length>0?ORDER_SHIPPING_HISTORIES.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.status),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.note),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._toggleForm(item);},disabled:_this.state.editMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._selectItem(item,'delete-shipping');},disabled:_this.state.editMode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'4'},'--No Data--'))));};_this._renderModal=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:_this.state.showModal==='delete-shipping',onClose:function onClose(){return _this.toggleModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Confirm Delete Shipping')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this.state.detail.status))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Note'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this.state.detail.note))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mt-3 mb-3 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._toggleModal();},className:'btn btn-secondary mr-2',type:'button'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._delete();},className:'btn btn-danger'},'Delete'))));};_this.state={editMode:false,showModal:null,detail:{},form:{note:'',status:''}};_this.status=[{value:'ready-to-deliver',label:'ready-to-deliver'},{value:'deliver-to-courier',label:'deliver-to-courier'},{value:'delivered',label:'delivered'},{value:'reject-by-customer',label:'reject-by-customer'},{value:'missing',label:'missing'}];return _this;}_createClass(ViewShippingDetail,[{key:'render',value:function render(){var DATA_DETAIL=this.props.DATA_DETAIL;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Shipping Detail')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},this._renderForm(DATA_DETAIL.order_number)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},this._renderTable(DATA_DETAIL.order_shipping_histories))),this._renderModal());}}]);return ViewShippingDetail;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{DATA_DETAIL:state.ecommerceOrder.DATA_DETAIL};};var dispatchToProps=function dispatchToProps(dispatch){return{getEcommerceOrderShipping:function getEcommerceOrderShipping(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderShippingRequest(data));},postEcommerceOrderShipping:function postEcommerceOrderShipping(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].postEcommerceOrderShippingRequest(data));},putEcommerceOrderShipping:function putEcommerceOrderShipping(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].putEcommerceOrderShippingRequest(data));},deleteEcommerceOrderShipping:function deleteEcommerceOrderShipping(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].deleteEcommerceOrderShippingRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ViewShippingDetail));

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotFound__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Misc_Banners__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Misc_Markup__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Misc_ExchangeRate__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Misc_SectionPage__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Misc_ShippingPreset__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Misc_AttractionPromo__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Misc_FailedTransaction__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Misc_PromoSectionPage__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Misc_Scheduler__ = __webpack_require__(1251);
var subList={Banners:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Misc_Banners__["a" /* default */],null),Markup:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Misc_Markup__["a" /* default */],null),ExchangeRate:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Misc_ExchangeRate__["a" /* default */],null),SectionPage:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Misc_SectionPage__["a" /* default */],null),ShippingPreset:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Misc_ShippingPreset__["a" /* default */],null),AttractionPromo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Misc_AttractionPromo__["a" /* default */],null),FailedTransaction:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Misc_FailedTransaction__["a" /* default */],null),PromoSection:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Misc_PromoSectionPage__["a" /* default */],null),Scheduler:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Misc_Scheduler__["a" /* default */],null)};var SubComponent=function SubComponent(_ref){var _ref$subname=_ref.subname,subname=_ref$subname===undefined?'list':_ref$subname;var index=subname;index=index.split('-');if(!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(index)){index=__WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(index);}else{index=index.map(function(el){return __WEBPACK_IMPORTED_MODULE_2_lodash_upperFirst___default()(el);});index=index.join('');}if(__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(subList,index)){return subList[index];}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NotFound__["a" /* default */],null);}};var MiscPage=function MiscPage(_ref2){var location=_ref2.location,match=_ref2.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubComponent,{subname:match.params.sub,location:location});};/* harmony default export */ __webpack_exports__["a"] = (MiscPage);

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Banner_FormCreate__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Banner_UpdateContent__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Banner_UpdateImage__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filterData_json__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filterData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__filterData_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Banners=function(_React$Component){_inherits(Banners,_React$Component);function Banners(props){_classCallCheck(this,Banners);var _this=_possibleConstructorReturn(this,(Banners.__proto__||Object.getPrototypeOf(Banners)).call(this,props));_initialiseProps.call(_this);_this.state={showModal:null,filter:{title:'',iso_code:''},detail:{}};return _this;}_createClass(Banners,[{key:'componentDidMount',value:function componentDidMount(){this._fetchBanner();}},{key:'render',value:function render(){var _this2=this;var banner=this.props.banner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Banner List',banner.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create');}},'Register New Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_AdvancedFilter__["a" /* default */],{filters:__WEBPACK_IMPORTED_MODULE_10__filterData_json___default.a.bannerFilters,manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._fetchBanner(event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(banner.fetching||banner.processing)&&banner.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},banner.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_AdvancedTable__["a" /* default */],{colSpan:9,header:[{field:'Title',className:'text-left'},{field:'Origin'},{field:'Priority'},{field:'Status'},{field:'Web'},{field:'Mobile'},{field:'Update',colSpan:2},{field:'Delete'}],body:banner.data&&banner.data.length>0&&banner.data.map(function(item){return[{field:item.title,className:'text-left'},{field:item.iso_code},{field:item.priority},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_toggle___default.a,{checked:item.status==='active',onChange:function onChange(){return _this2._handleToggle(item);}})},{field:item.image_url.web?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url.web,alt:'',className:'img img-responsive',height:'65px'}):'- No Image -'},{field:item.image_url.mobile?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url.mobile,alt:'',className:'img img-responsive',height:'65px'}):'- No Image -'},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-content');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Content')},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info mr-2',onClick:function onClick(){return _this2._selectItem(item,'edit-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),'Image')},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Banner_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='edit-content',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Banner_UpdateContent__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='edit-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Banner_UpdateImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Delete Banner?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.detail.title||'-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-danger',onClick:function onClick(){return _this2._delete();}},'Delete'))))));}}]);return Banners;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this3.setState({showModal:modalId});if(!modalId){_this3._fetchBanner();}};this._handleToggle=function(item){var status=void 0;if(item.status==='active'){status='inactive';}else if(item.status==='inactive'){status='active';}var data={id:item.id,form:{iso_code:item.iso_code,status:status}};_this3.props.updateBanner(data);setTimeout(function(){_this3._fetchBanner();},300);};this._fetchBanner=function(event){if(event){event.preventDefault();}var data=_this3.state.filter;_this3.props.getBanners(data);};this._selectItem=function(item,action){_this3.setState({detail:item});_this3._toggleModal(action);};this._delete=function(){_this3.props.deleteBanner(_this3.state.detail.id);setTimeout(function(){_this3._toggleModal();},250);};this._manipulateState=function(props){_this3.setState({filter:props});};};var stateToProps=function stateToProps(state){return{banner:state.banner};};var dispatchToProps=function dispatchToProps(dispatch){return{getBanners:function getBanners(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_BannerRedux__["b" /* default */].bannerRequest(filter));},deleteBanner:function deleteBanner(id){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_BannerRedux__["b" /* default */].bannerDeleteRequest({id:id}));},updateBanner:function updateBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_BannerRedux__["b" /* default */].bannerUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Banners));

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form.image_file[field]=filename;if(field==='web'){form.image_file['original']=filename;}_this.setState({form:form});};_this._submit=function(event){event.preventDefault();_this.props.createBanner(_this.state.form);setTimeout(function(){_this.props.closeModal();},250);};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}var form=Object.assign({},_this.state.form);form.priority=val;_this.setState({form:form});};_this.state={form:{title:'',priority:'1',image_file:{web:'',mobile:'',original:''},link:'',iso_code:'ID'}};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Register New Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Banner Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Banner Link',className:'form-control',value:this.state.form.link,onChange:function onChange(event){return _this2._inputChange(event,'link');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},'URL must contain https://'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Source')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.iso_code,onChange:function onChange(event){return _this2._inputChange(event,'iso_code');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ID'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PH'},'PH')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Web (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1049x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{required:true,setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'web');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'335x320'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{required:true,setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'mobile');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{createBanner:function createBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__["b" /* default */].bannerCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateContent=function(_React$Component){_inherits(UpdateContent,_React$Component);function UpdateContent(props){_classCallCheck(this,UpdateContent);var _this=_possibleConstructorReturn(this,(UpdateContent.__proto__||Object.getPrototypeOf(UpdateContent)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value.replace(/[^\x20-\x7E]/g,'');if(event.target.type==='number'){val=parseInt(val,10);}var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>1000){val=1000;}else if(parseFloat(val)<1){val=1;}var form=Object.assign({},_this.state.form);form.priority=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:_this.state.form};_this.props.updateBanner(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{title:props.detail.title,priority:props.detail.priority,link:props.detail.link,iso_code:props.detail.iso_code}};return _this;}_createClass(UpdateContent,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Banner Title',className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,placeholder:'Link Banner',className:'form-control',value:this.state.form.link,onChange:function onChange(event){return _this2._inputChange(event,'link');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},'URL must contain https://'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,className:'form-control',value:this.state.form.priority,onChange:function onChange(event){return _this2._valueChange(event);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Source')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:this.state.form.iso_code,onChange:function onChange(event){return _this2._inputChange(event,'iso_code');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'ID'},'ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'PH'},'PH')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return UpdateContent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBanner:function updateBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateContent));

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateImage=function(_React$Component){_inherits(UpdateImage,_React$Component);function UpdateImage(props){_classCallCheck(this,UpdateImage);var _this=_possibleConstructorReturn(this,(UpdateImage.__proto__||Object.getPrototypeOf(UpdateImage)).call(this,props));_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form.image_file[field]=filename;if(field==='web'){form.image_file['original']=filename;}_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:_this.state.form};_this.props.updateBanner(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{image_file:{web:props.detail.image_file.web,mobile:props.detail.image_file.mobile,original:props.detail.image_file.original},iso_code:props.detail.iso_code}};return _this;}_createClass(UpdateImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Web (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1049x433'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'web');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner Mobile (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'335x320'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Containers_FileUploader__["a" /* default */],{setting:{type:'banner'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'mobile');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Save'))));}}]);return UpdateImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateBanner:function updateBanner(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_BannerRedux__["b" /* default */].bannerUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateImage));

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = {"bannerFilters":[{"type":"text","name":"Title","placeholder":"Banner Title","field":"title"},{"type":"selector","name":"Origin","field":"iso_code","selectors":[{"label":"ALL","value":"","restriction":"PH"},{"label":"Passpod","value":"ID","restriction":"PH"},{"label":"Passpod PH","value":"PH"}]}]}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_tooltip__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_MarkupRedux__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Utils_PrecisionRound__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Markup_FormCreate__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Markup_FormUpdate__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Markup_FormDelete__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Markup_PriceComparison__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Markup_ComparisonDetails__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Markup=function(_React$Component){_inherits(Markup,_React$Component);function Markup(props){_classCallCheck(this,Markup);var _this=_possibleConstructorReturn(this,(Markup.__proto__||Object.getPrototypeOf(Markup)).call(this,props));_this.componentDidMount=function(){_this.props.getBranch();_this._fetchMarkup();};_this._searchMarkup=function(event){if(event)event.preventDefault();var filter={q:_this.state.q};_this.props.getMarkup(filter);};_this._fetchMarkup=function(event,custom){if(event)event.preventDefault();var filter=Object.assign({page:_this.state.page,q:_this.state.q,sort:{value:_this.state.sort.value}},custom);filter.sort=filter.sort.value;_this.props.getMarkup(filter);};_this._toggleSort=function(field){var sort=Object.assign({},_this.state.sort);if(sort[field]===field){sort[field]='-'+field;}else{sort[field]=field;}_this.setState({sort:sort});_this._fetchMarkup(null,{sort:sort});};_this._changePage=function(page){_this.setState({page:page});_this._fetchMarkup(null,{page:page});};_this._updateGeneralMarkup=function(event){event.preventDefault();var data={general_price_offset:_this.state.general_markup};_this.props.updateGeneralMarkup(data);_this._toggleModal();};_this._updateBranch=function(event,country,product){event.preventDefault();var data={country:country,product:product,value:parseInt(_this.state.branch.value,10)};_this.props.updateBranch(data);_this._toggleModal();};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalId});};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._selectGeneral=function(value,modalID){if(modalID==='edit-general'){_this.setState({general_markup:value});}else if(modalID==='branch-ph'){_this.setState({branch:{value:value}});}_this._toggleModal(modalID);};_this._valueChange=function(e,field){var value=e.target.value;if(parseFloat(value)>100){value=100;}else if(parseFloat(value)<-100){value=-100;}switch(field){case'general_markup':return _this.setState({general_markup:value});case'branch-ph':return _this.setState({branch:{value:value}});default:return null;}};_this._renderTable=function(markup){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this._searchMarkup(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'title',className:'control-label mr-2'},'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',placeholder:'Attraction Title',defaultValue:_this.state.q,onChange:function onChange(event){return _this.setState({q:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group ml-2 mt-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(markup.fetching||markup.processing)&&markup.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},markup.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'City'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center',role:'button',onClick:function onClick(){return _this._toggleSort('value');}},'Markup Value ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-'+(_this.state.sort.value==='-value'?'sort-amount-down':'sort-amount-up')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Current Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Predictive Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Predictive Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Package Markup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Delete'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,markup.data&&markup.data.data.length?markup.data.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.attraction&&item.attraction.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.attraction&&item.attraction.locations[0].city),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.attraction&&item.attraction.provider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-tip':'Click to change markup value',className:'text-center',role:'button',onClick:function onClick(){return _this._selectItem(item,'edit');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(item.value>1?'success':item.value===1?'light':'danger')},item.value>1&&'+',Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrecisionRound__["a" /* default */])((item.value-1)*100),' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__Utils_FormatMoney__["a" /* default */])(item.current_price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-tip':'Click to change predictive value',className:'text-center',role:'button',onClick:function onClick(){return _this._selectItem(item,'comparison');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_tooltip__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(item.test_value>1?'success':item.test_value===1?'light':'danger')},item.test_value>1&&'+',Object(__WEBPACK_IMPORTED_MODULE_7__Utils_PrecisionRound__["a" /* default */])((item.test_value-1)*100),' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},Object(__WEBPACK_IMPORTED_MODULE_14__Utils_FormatMoney__["a" /* default */])(item.preview_price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this._selectItem(item,'comparison-details');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._selectItem(item,'delete');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'9',className:'text-center'},'- NO DATA -'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},markup.data&&markup.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:markup.data.page||_this.state.page,itemsCountPerPage:10,totalItemsCount:markup.data.total,pageRangeDisplayed:5,onChange:_this._changePage})));};_this.state={showModal:null,detail:{},general_markup:'',branch:{country:'',product:'',value:''},q:'',sort:{value:'value'},page:1};return _this;}_createClass(Markup,[{key:'render',value:function render(){var _this2=this;var _props=this.props,markup=_props.markup,preset=_props.preset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Markup Price',(markup.fetching||markup.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},markup.fetching?'Loading':'Processing',' ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._toggleModal('create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add New Markup'))),Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])()==='ID'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2 mb-2'},'General Markup : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'mb-2'},preset.dataPresetOrder.general_price_offset,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-dark btn-sm btn-link mb-2',onClick:function onClick(){return _this2._selectGeneral(preset.dataPresetOrder.general_price_offset,'edit-general');}},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mb-2'},preset.fetchingPresetOrder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},'Saving ...'),preset.errPresetOrder&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-danger'},preset.errPresetOrder)))))),Object(__WEBPACK_IMPORTED_MODULE_13__Utils_PrivilegeUtils__["a" /* currentBranch */])()==='PH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2 mb-2'},'General Markup (PH): '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'mb-2'},preset.dataBranch&&preset.dataBranch.PH!==undefined&&preset.dataBranch.PH.attraction,' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-dark btn-sm btn-link mb-2',onClick:function onClick(){return _this2._selectGeneral(preset.dataBranch.PH.attraction,'branch-ph');}},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mb-2'},preset.fetchingBranch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-info'},'Fetching ...'),preset.errBranch&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-danger'},preset.errPresetOrder)))))),this._renderTable(markup),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='create',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Markup_FormCreate__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='edit',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Markup_FormUpdate__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='delete',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Markup_FormDelete__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='comparison',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Markup_PriceComparison__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='comparison-details',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Markup_ComparisonDetails__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='edit-general',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'General Markup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._updateGeneralMarkup(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'value',required:true,step:'any',max:100,className:'form-control',value:this.state.general_markup,onChange:function onChange(event){return _this2._valueChange(event,'general_markup');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='branch-ph',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'20vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'General Markup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._updateBranch(event,'PH','attraction');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',name:'value',required:true,step:'any',max:100,className:'form-control',value:this.state.branch.value,onChange:function onChange(event){return _this2._valueChange(event,'branch-ph');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save'))))));}}]);return Markup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{markup:state.markup,preset:state.preset};};var dispatchToProps=function dispatchToProps(dispatch){return{getMarkup:function getMarkup(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_MarkupRedux__["b" /* default */].markupRequest(filter));},updateGeneralMarkup:function updateGeneralMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_PresetRedux__["b" /* default */].presetOrderUpdateRequest(data));},getGeneralMarkup:function getGeneralMarkup(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_PresetRedux__["b" /* default */].presetOrderRequest());},getBranch:function getBranch(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_PresetRedux__["b" /* default */].getBranchRequest());},updateBranch:function updateBranch(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_PresetRedux__["b" /* default */].updateBranchRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Markup));

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_MarkupRedux__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormCreate=function(_React$Component){_inherits(FormCreate,_React$Component);function FormCreate(props){_classCallCheck(this,FormCreate);var _this=_possibleConstructorReturn(this,(FormCreate.__proto__||Object.getPrototypeOf(FormCreate)).call(this,props));_this.componentDidMount=function(){var data={q:_this.state.search,page:_this.state.page};_this.props.search(data);};_this._toggleAttractionModal=function(){_this.setState({showModal:!_this.state.showModal});if(_this.state.showModal){_this.setState({page:1,search:''});var data={q:'',page:1};_this.props.search(data);}};_this._inputSearchChange=function(event){var val=event.target.value;_this.setState({search:val});};_this._search=function(event){event.preventDefault();var data={q:_this.state.search,page:_this.state.page};_this.props.search(data);};_this._changePage=function(page){_this.setState({page:page});var data={q:_this.state.search,page:page};_this.props.search(data);};_this._selectAttraction=function(data){_this.setState({selectedAttraction:data,form:Object.assign({},_this.state.form,{attraction_id:data.id})});_this._toggleAttractionModal();};_this._save=function(event){event.preventDefault();var data=Object.assign({},_this.state.form,{value:_this.state.form.value/100+1});_this.props.createMarkup(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>100){val=100;}else if(parseFloat(val)<-100){val=-100;}var form=Object.assign({},_this.state.form);form.value=val;_this.setState({form:form});};_this.state={showModal:false,selectedAttraction:{title:''},form:{attraction_id:'',value:0,test_value:1},page:1,search:''};return _this;}_createClass(FormCreate,[{key:'render',value:function render(){var _this2=this;var attraction=this.props.attraction;var attraction_id=this.state.form.attraction_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Create New Markup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Attraction Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{role:'button',type:'text',className:'form-control',readOnly:true,value:this.state.selectedAttraction.title||'- Click to select -',onClick:function onClick(){return _this2._toggleAttractionModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group',style:{width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,step:'any',max:100,className:'form-control',value:this.state.form.value,onChange:function onChange(event){return _this2._valueChange(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!attraction_id,className:'btn btn-primary ml-2'},'Save'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal,closeOnOverlayClick:true,onClose:function onClose(){return _this2._toggleAttractionModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'60vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titile-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Select Attraction')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'row mb-2',onSubmit:function onSubmit(event){return _this2._search(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'search',name:'search',className:'form-control',placeholder:'Search Attraction',onChange:function onChange(event){return _this2._inputSearchChange(event);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-search'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'table-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'No'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Title'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Action'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!attraction.dataSearch.data||!attraction.dataSearch.data.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'3',className:'text-center'},'- No Data -')):attraction.dataSearch.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,i+1+(_this2.state.page-1)*10),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.provider),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._selectAttraction(item);},className:'btn btn-info'},'Select')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},attraction.dataSearch.total&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:attraction.dataSearch.page||this.state.page,itemsCountPerPage:10,totalItemsCount:attraction.dataSearch.total,pageRangeDisplayed:5,onChange:this._changePage})))));}}]);return FormCreate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{attraction:state.attraction};};var dispatchToProps=function dispatchToProps(dispatch){return{search:function search(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_AttractionRedux__["b" /* default */].attractionSearchRequest(data));},createMarkup:function createMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_MarkupRedux__["b" /* default */].markupCreateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormCreate));

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormUpdate=function(_React$Component){_inherits(FormUpdate,_React$Component);function FormUpdate(props){_classCallCheck(this,FormUpdate);var _this=_possibleConstructorReturn(this,(FormUpdate.__proto__||Object.getPrototypeOf(FormUpdate)).call(this,props));_this._save=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:{value:_this.state.form.value/100+1}};_this.props.updateMarkup(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>100){val=100;}else if(parseFloat(val)<-100){val=-100;}var form=Object.assign({},_this.state.form);form.value=val;_this.setState({form:form});};_this.state={showModal:false,form:{value:Object(__WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__["a" /* default */])((props.detail.value-1)*100)}};return _this;}_createClass(FormUpdate,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'35vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Change Markup Value')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,step:'any',max:100,className:'form-control',value:this.state.form.value,onChange:function onChange(event){return _this2._valueChange(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save'))));}}]);return FormUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateMarkup:function updateMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormUpdate));

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormDelete=function(_React$Component){_inherits(FormDelete,_React$Component);function FormDelete(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FormDelete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FormDelete.__proto__||Object.getPrototypeOf(FormDelete)).call.apply(_ref,[this].concat(args))),_this),_this._delete=function(event){event.preventDefault();var data={id:_this.props.detail.id};_this.props.deleteMarkup(data);_this.props.closeModal();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FormDelete,[{key:'render',value:function render(){var _this2=this;var detail=this.props.detail;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Delete Markup?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._delete(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,detail.attraction&&detail.attraction.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(detail.value>1?'success':detail.value===1?'light':'danger')},detail.value>1&&'+',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__["a" /* default */])((detail.value-1)*100),' %')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-danger ml-2'},'Delete'))));}}]);return FormDelete;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteMarkup:function deleteMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupDeleteRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FormDelete));

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__ = __webpack_require__(90);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PriceComparison=function(_React$Component){_inherits(PriceComparison,_React$Component);function PriceComparison(props){_classCallCheck(this,PriceComparison);var _this=_possibleConstructorReturn(this,(PriceComparison.__proto__||Object.getPrototypeOf(PriceComparison)).call(this,props));_this._save=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:{test_value:_this.state.form.test_value/100+1}};_this.props.updateMarkup(data);_this.props.closeModal();};_this._valueChange=function(event){var val=event.target.value;if(parseFloat(val)>100){val=100;}else if(parseFloat(val)<-100){val=-100;}var form=Object.assign({},_this.state.form);form.test_value=val;_this.setState({form:form});};_this.state={showModal:false,form:{test_value:Object(__WEBPACK_IMPORTED_MODULE_2__Utils_PrecisionRound__["a" /* default */])((props.detail.test_value-1)*100)}};return _this;}_createClass(PriceComparison,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'35vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Change Predictive Value')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._save(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Predictive Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,step:'any',max:100,className:'form-control',value:this.state.form.test_value,onChange:function onChange(event){return _this2._valueChange(event);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save'))));}}]);return PriceComparison;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{updateMarkup:function updateMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(PriceComparison));

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_PrecisionRound__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_tooltip__ = __webpack_require__(199);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AdvancedTable from '../../Components/AdvancedTable'
var ComparisonDetails=function(_React$Component){_inherits(ComparisonDetails,_React$Component);function ComparisonDetails(props){_classCallCheck(this,ComparisonDetails);var _this=_possibleConstructorReturn(this,(ComparisonDetails.__proto__||Object.getPrototypeOf(ComparisonDetails)).call(this,props));_this.componentDidMount=function(){_this._getMarkupItem(_this.props.detail.id);};_this._getMarkupItem=function(id){var data={id:id};_this.props.markupItemGet(data);};_this._precisionRound=function(args){return Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrecisionRound__["a" /* default */])((args-1)*100);};_this._precisionBadge=function(value,clickable,item){if(!clickable){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge badge-'+(value>1?'success':value===1?'light':'danger')},value>1&&'+',' ',_this._precisionRound(value),' %');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'data-tip':'Click to change value',role:'button',onClick:function onClick(){return _this._selectItem(item,'update','modal-update');},className:'badge badge-'+(value>1?'success':value===1?'light':'danger')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_tooltip__["a" /* default */],null),value>1&&'+',' ',_this._precisionRound(value),' %');}};_this._availabilityParse=function(prev){if(prev!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_3__Utils_FormatMoney__["a" /* default */])(prev));}else{return'Unavailable';}};_this._packageParse=function(args){return args.is_disabled&&args.is_expired?'Disabled & Expired':args.is_disabled?'Disabled':'Expired';};_this._attractionParse=function(args){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Attraction '+(args.is_disabled&&args.is_expired?'Disabled & Expired':args.is_disabled?'Disabled':'Expired')));};_this._renderItemButton=function(item,text,method,modalID,buttonStyle,iconStyle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn '+buttonStyle,onClick:function onClick(){return _this._selectItem(item,method,modalID);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa '+iconStyle}),' ',text);};_this._selectItem=function(item,method,modalID){if(method==='create'){var value=item.id;var form=Object.assign({},_this.state.form);form.attraction_package_id=value;_this.setState({detail:item,form:form});}else if(method==='update'){var _form=Object.assign({},_this.state.form);_form.value=_this._precisionRound(item.markup_item_price.value);var selectedUUID=item.markup_item_price.id;_this.setState({detail:item,form:_form,selectedUUID:selectedUUID});}else if(method==='delete'){var _selectedUUID=item.markup_item_price.id;_this.setState({detail:item,selectedUUID:_selectedUUID});}_this._toggleModal(modalID);};_this._toggleModal=function(modalID,postAction){if(postAction){_this._getMarkupItem(_this.props.detail.id);}if(!modalID){var form={markup_price_id:_this.props.detail.id,attraction_package_id:'',value:0};_this.setState({showModal:modalID,form:form,detail:{}});}else{_this.setState({showModal:modalID});}};_this._determineRender=function(provider,ATTRACTION_PACKAGES){switch(provider){case'BMG':return _this._renderBMG(ATTRACTION_PACKAGES);case'KLOOK':return _this._renderKLOOK(ATTRACTION_PACKAGES);default:return null;}};_this._handleChange=function(event,field){var form=Object.assign({},_this.state.form);var value=event.target.value;if(field==='value'){if(parseFloat(value)>100){value=100;}else if(parseFloat(value)<-100){value=-100;}}form[field]=value;_this.setState({form:form});};_this._markupItemCreate=function(event){if(event){event.preventDefault();}var form=Object.assign({},_this.state.form);form.value=form.value/100+1;var data={form:form};_this.props.markupItemCreate(data);setTimeout(function(){_this._toggleModal(null,true);},300);};_this._markupItemUpdate=function(event){if(event){event.preventDefault();}var form=Object.assign({},_this.state.form);form.value=form.value/100+1;var data={uuid:_this.state.selectedUUID,form:form};_this.props.markupItemUpdate(data);setTimeout(function(){_this._toggleModal(null,true);},300);};_this._markupItemDelete=function(){var data={uuid:_this.state.selectedUUID};_this.props.markupItemDelete(data);setTimeout(function(){_this._toggleModal(null,true);},300);};_this._renderBMG=function(ATTRACTION_PACKAGES){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'300px'}},'Package Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Package Markup Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Adults'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Children'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Senior'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Manage'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,ATTRACTION_PACKAGES.length>0?ATTRACTION_PACKAGES.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'300px'}},item.title||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.markup_item_price!==null?_this._precisionBadge(item.markup_item_price.value,true,item):'Not set'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.is_disabled&&!item.is_expired?_this._availabilityParse(item.prices.adults):_this._packageParse(item)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.is_disabled&&!item.is_expired?_this._availabilityParse(item.prices.children):_this._packageParse(item)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.is_disabled&&!item.is_expired?_this._availabilityParse(item.prices.seniors):_this._packageParse(item)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.markup_item_price&&_this._renderItemButton(item,'Set','create','modal-create','btn-primary','fa-plus'),item.markup_item_price&&_this._renderItemButton(item,'Remove','delete','modal-delete','btn-danger','fa-trash')));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center',colSpan:'6'},'-No Data-')))));};_this._renderKLOOK=function(ATTRACTION_PACKAGES){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Attraction Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Package Markup Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Package Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Manage'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,ATTRACTION_PACKAGES.length>0?ATTRACTION_PACKAGES.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{width:'30%'}},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},item.markup_item_price!==null?_this._precisionBadge(item.markup_item_price.value,true,item):'Not Set'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,item.prices.map(function(x,y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:y},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,x.name,':'),' ',Object(__WEBPACK_IMPORTED_MODULE_3__Utils_FormatMoney__["a" /* default */])(x.price));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},!item.markup_item_price&&_this._renderItemButton(item,'Set','create','modal-create','btn-primary','fa-plus'),item.markup_item_price&&_this._renderItemButton(item,'Remove','delete','modal-delete','btn-danger','fa-trash')));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'4',className:'text-center'},'- No Data-')))));};_this.state={selectedUUID:'',form:{markup_price_id:props.detail.id,attraction_package_id:'',value:0},detail:{},showModal:null};return _this;}_createClass(ComparisonDetails,[{key:'render',value:function render(){var _this2=this;var _props=this.props,detail=_props.detail,markup=_props.markup;var data_item=markup.data_item;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'90vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Package Markup',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description ml-2'},detail.attraction.title,' (',detail.attraction.provider,') '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'mb-3',style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Base Markup Value')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,this._precisionBadge(data_item.value,false,null))))),data_item!==null&&!data_item.attraction.is_disabled&&!data_item.attraction.is_expired?this._determineRender(data_item.attraction.provider,data_item.attraction.attraction_packages):this._attractionParse(data_item.attraction),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2.props.closeModal();}},'Close')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='modal-create',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'35vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title mr-auto'},'Create Package Markup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description ml-1'},this.state.detail.title,' (',this.state.detail.provider,')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._markupItemCreate(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Markup Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,step:'any',max:100,className:'form-control',value:this.state.form.value,onChange:function onChange(event){return _this2._handleChange(event,'value');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2._toggleModal(null);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Submit'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='modal-update',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'35vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title mr-auto'},'Update Package Markup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description ml-1'},this.state.detail.title,' (',this.state.detail.provider,')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._markupItemUpdate(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Package Markup Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',required:true,step:'any',max:100,className:'form-control',value:this.state.form.value,onChange:function onChange(event){return _this2._handleChange(event,'value');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-group-append'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'input-group-text'},'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2._toggleModal(null);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},'Save'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_responsive_modal__["a" /* default */],{center:true,open:this.state.showModal==='modal-delete',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'35vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title mr-auto'},'Remove Package Markup')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},this.state.detail.markup_item_price&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.detail.title,' (',this.state.detail.provider,') ',this._precisionBadge(this.state.detail.markup_item_price.value,false))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2._toggleModal(null);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-danger',onClick:function onClick(){return _this2._markupItemDelete();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash mr-2'}),'Remove')))));}}]);return ComparisonDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{markup:state.markup};};var dispatchToProps=function dispatchToProps(dispatch){return{updateMarkup:function updateMarkup(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__["b" /* default */].markupUpdateRequest(data));},markupItemCreate:function markupItemCreate(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__["b" /* default */].markupItemCreateRequest(data));},markupItemUpdate:function markupItemUpdate(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__["b" /* default */].markupItemUpdateRequest(data));},markupItemDelete:function markupItemDelete(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__["b" /* default */].markupItemDeleteRequest(data));},markupItemGet:function markupItemGet(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_MarkupRedux__["b" /* default */].markupItemGetRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ComparisonDetails));

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_ExchangeRateRedux__ = __webpack_require__(218);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExchangeRate=function(_React$Component){_inherits(ExchangeRate,_React$Component);function ExchangeRate(props){_classCallCheck(this,ExchangeRate);var _this=_possibleConstructorReturn(this,(ExchangeRate.__proto__||Object.getPrototypeOf(ExchangeRate)).call(this,props));_this.componentDidMount=function(){_this.props.getExchangeRate();};_this._filterChange=function(event,field){var newState=Object.assign({},_this.state.filter);var val=event.target.value;newState[field]=val;_this.setState({filter:newState});if(field==='from'){__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_3_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="from"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="from"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('tr:hidden').show();}}if(field==='to'){__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_3_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="to"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="to"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('tr:hidden').show();}}if(field==='manual_updated'){__WEBPACK_IMPORTED_MODULE_3_jquery___default.a.expr[':'].contains=function(a,i,m){return __WEBPACK_IMPORTED_MODULE_3_jquery___default()(a).text().toUpperCase().indexOf(m[3].toUpperCase())>=0;};if(val){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="manual_updated"]:not(:contains("'+val+'"))').parent().hide();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('td[data-filter="manual_updated"]:contains("'+val+'")').parent().show();}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()('tr:hidden').show();}}};_this._selectItem=function(item,action){var form=Object.assign({},_this.state.form);form['rate']=item.rate;_this.setState({detail:item,form:form});_this._toggleModal(action);};_this._toggleModal=function(modalId){_this.setState({showModal:modalId});// if (!modalId) {
//   this.props.getExchangeRate()
// }
};_this._fieldChange=function(event,field){var form=Object.assign({},_this.state.form);var val=event.target.value;if(event.target.type==='number'){val=parseFloat(val);}form[field]=val;_this.setState({form:form});};_this._updateRate=function(event){event.preventDefault();var data={id:_this.state.detail.id,form:_this.state.form};_this.props.updateExchangeRate(data);_this._toggleModal();};_this.state={showModal:null,filter:{from:'',to:'',manual_updated:''},detail:{},form:{rate:0}};return _this;}_createClass(ExchangeRate,[{key:'render',value:function render(){var _this2=this;var exchangeRate=this.props.exchangeRate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Exchange Rate List',exchangeRate.fetching&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-inline'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'from',className:'control-label mr-2'},'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Currency Code',className:'form-control',value:this.state.filter.from,onChange:function onChange(event){return _this2._filterChange(event,'from');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'from',className:'control-label mr-2'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Currency Code',className:'form-control',value:this.state.filter.to,onChange:function onChange(event){return _this2._filterChange(event,'to');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'from',className:'control-label mr-2'},'Manual Updated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:String(this.state.filter.manual_updated),className:'form-control',onChange:function onChange(event){return _this2._filterChange(event,'manual_updated');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:''},'- ALL -'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'true'},'True'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'false'},'False')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(exchangeRate.fetching||exchangeRate.processing)&&exchangeRate.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},exchangeRate.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped',style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Rate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Manual Updated'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Update'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!exchangeRate.data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',className:'text-center'},'- No Data -')):exchangeRate.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'from'},item.from||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'to'},item.to||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.rate||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{'data-filter':'manual_updated'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'badge badge-'+(item.manual_updated?'success':'danger')},String(item.manual_updated))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'update');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-edit'}))));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{open:this.state.showModal==='update',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'25vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Exchange Rate')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._updateRate(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',value:this.state.detail.from,readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'To'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',value:this.state.detail.to,readOnly:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Rate'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',className:'form-control',value:this.state.form.rate,onChange:function onChange(event){return _this2._fieldChange(event,'rate');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary',onClick:function onClick(){return _this2._toggleModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary ml-2'},'Save')))))));}}]);return ExchangeRate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{exchangeRate:state.exchangeRate};};var dispatchToProps=function dispatchToProps(dispatch){return{getExchangeRate:function getExchangeRate(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateRequest());},updateExchangeRate:function updateExchangeRate(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ExchangeRate));

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Section_CreateSection__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Section_CreateSubSection__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Section_UpdateSection__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Section_UpdateSectionImage__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Section_UpdateSubSection__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Section_UpdateSubsectionImage__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Section_UpdateSubsectionPDF__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Containers_Section_DeleteSection__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Containers_Section_DeleteSubSection__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Components_EllipsisModal__ = __webpack_require__(138);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SectionPage=function(_React$Component){_inherits(SectionPage,_React$Component);function SectionPage(props){_classCallCheck(this,SectionPage);var _this=_possibleConstructorReturn(this,(SectionPage.__proto__||Object.getPrototypeOf(SectionPage)).call(this,props));_this.componentDidMount=function(){_this._fetchSection();};_this._fetchSection=function(){_this.props.getSection();};_this._selectItem=function(item,modalID){_this.setState({detail:item});_this._toggleModal(modalID);};_this._toggleModal=function(){var modalID=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({showModal:modalID});if(!modalID){_this._fetchSection();}};_this._renderSection=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{'data-toggle':'collapse','data-target':'#collapse-'+data.id,className:'btn btn-info text-center',type:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}),' View Subsection')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered',style:{maxWidth:'100vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{style:{overflowX:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle'},'Title ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle'},'Title EN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle'},'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle'},'Banner'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle',colSpan:'2'},'Edit Section'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{minWidth:'200px'},className:'text-center align-middle'},'Delete section'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},data.title_id||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},data.title_en||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,data.status==='active'?'Active':'Inactive')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!data.image_file,className:'btn btn-info',onClick:function onClick(){return _this._selectItem(data,'modal-VIEW-BANNER');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(data,'modal-PUT');}},'Contents ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(data,'modal-PUT-IMAGE');}},'Banner ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._selectItem(data,'modal-DELETE');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapse',id:'collapse-'+data.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-left mt-3 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(data,'modal-POST-SUB');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add Subsection')),_this._renderSubSection(data.section_data)));};_this._renderSubSection=function(data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table-bordered'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Title ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Title EN'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Subtitle'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Image file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'PDF file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle',colSpan:'3'},'Edit Subsection'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Delete Subsection'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!data||data.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle',colSpan:'9'},'--No Data--')):data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.title_id||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.title_en||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},item.subtitle||'-'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Components_EllipsisModal__["a" /* default */],{descriptor:'Description',name:item.title,description:item.description,type:'string'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:!item.image_file,className:'btn btn-info',onClick:function onClick(){return _this._selectItem(item,'modal-VIEW-IMAGE');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-eye'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},!item.pdf_file?'--':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:item.pdf_url,target:'_blank'},item.pdf_file)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(item,'modal-PUT-SUB');}},'Contents ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(item,'modal-PUT-SUB-IMAGE');}},'Image ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this._selectItem(item,'modal-PUT-SUB-PDF');}},'PDF ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this._selectItem(item,'modal-DELETE-SUB');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))));})));};_this.state={showModal:null,detail:{}};return _this;}_createClass(SectionPage,[{key:'render',value:function render(){var _this2=this;var section=this.props.section;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'Manage Sections',(section.fetching||section.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('modal-POST');}},'Create Section ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-striped table-hover'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center align-middle'},'Section Data'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!section.data||section.data.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle',colSpan:'2'},'--No Data--')):section.data.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center align-middle'},_this2._renderSection(item)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-VIEW-BANNER',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title'},'View Banner Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center align-middle align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{maxWidth:'65vw',maxHeight:'65vh'},src:this.state.detail.image_url,alt:this.state.detail.image_file,className:'img img-responsive'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'mt-3'},'Banner for: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.state.detail.image_url,target:'_blank'},this.state.detail.title_id))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mt-3',onClick:function onClick(){return _this2._toggleModal();}},'Close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-VIEW-IMAGE',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title'},'View Boxed Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center align-middle align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{maxWidth:'65vw',maxHeight:'65vh'},src:this.state.detail.image_url,alt:this.state.detail.image_file,className:'img img-responsive text-center align-middle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center align-middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h6',{className:'mt-3'},'Banner for: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.state.detail.image_url,target:'_blank'},this.state.detail.title_id))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mt-3',onClick:function onClick(){return _this2._toggleModal();}},'Close')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-POST',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Section_CreateSection__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-POST-SUB',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Section_CreateSubSection__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-PUT',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Section_UpdateSection__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-PUT-IMAGE',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Section_UpdateSectionImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-PUT-SUB',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Section_UpdateSubSection__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-PUT-SUB-IMAGE',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Section_UpdateSubsectionImage__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-PUT-SUB-PDF',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Section_UpdateSubsectionPDF__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-DELETE',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Containers_Section_DeleteSection__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='modal-DELETE-SUB',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Containers_Section_DeleteSubSection__["a" /* default */],{detail:this.state.detail,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return SectionPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section};};var dispatchToProps=function dispatchToProps(dispatch){return{getSection:function getSection(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__["b" /* default */].getSectionRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(SectionPage));

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateSection=function(_React$Component){_inherits(CreateSection,_React$Component);function CreateSection(props){_classCallCheck(this,CreateSection);var _this=_possibleConstructorReturn(this,(CreateSection.__proto__||Object.getPrototypeOf(CreateSection)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','section-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._inputChange=function(event,field){if(event)event.preventDefault();var value=void 0;var form=Object.assign({},_this.state.form);if(field!=='status'){value=event.target.value;form[field]=value;_this.setState({form:form});}else{if(form.status==='active'){form.status='inactive';}else{form.status='active';}_this.setState({form:form});}};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){if(event)event.preventDefault();var form=Object.assign({},_this.state.form);var data={form:form};_this.props.postSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{title_id:'',title_en:'',status:'inactive',image_file:''},file:null,uploaded:false};_this.selector=[{label:'Inactive',value:'inactive'},{label:'Active',value:'active'}];return _this;}_createClass(CreateSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Create new Section')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_id,className:'form-control',placeholder:'Input name',onChange:function onChange(event){return _this2._inputChange(event,'title_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_en,className:'form-control',placeholder:'Input name',onChange:function onChange(event){return _this2._inputChange(event,'title_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:this.state.form.status==='active',name:'status',onChange:function onChange(){return _this2._inputChange(null,'status');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Banner Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FileUploader__["a" /* default */],{required:true,setting:{type:'section-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Submit')))));}}]);return CreateSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section,files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_FilesRedux__["b" /* default */].filesUploadReset());},postSection:function postSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__["b" /* default */].postSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateSection));

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateSection=function(_React$Component){_inherits(CreateSection,_React$Component);function CreateSection(props){_classCallCheck(this,CreateSection);var _this=_possibleConstructorReturn(this,(CreateSection.__proto__||Object.getPrototypeOf(CreateSection)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._inputChange=function(e,f){e.preventDefault();var v=e.target.value;var form=Object.assign({},_this.state.form);form[f]=v;_this.setState({form:form});};_this._submit=function(e){if(e)e.preventDefault();var form=Object.assign({},_this.state.form);var data={form:form};_this.props.postSubSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{title_id:'',title_en:'',subtitle:'',description:'',section_id:props.detail.id,image_file:'',pdf_file:''},pdfIncluded:false};return _this;}_createClass(CreateSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Add Subsection')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this2._submit(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_id,className:'form-control',placeholder:'Input title',onChange:function onChange(e){return _this2._inputChange(e,'title_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_en,className:'form-control',placeholder:'Input title',onChange:function onChange(e){return _this2._inputChange(e,'title_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.form.subtitle,className:'form-control',placeholder:'Input subtitle',onChange:function onChange(e){return _this2._inputChange(e,'subtitle');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.form.description,className:'form-control',placeholder:'Input description',onChange:function onChange(e){return _this2._inputChange(e,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Boxed Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'section-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{'data-toggle':'collapse',href:'#collapse',role:'button'},'Add PDF File?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collapse',id:'collapse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'company-disclosure'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'pdf_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Submit')))));}}]);return CreateSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section,files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{postSubSection:function postSubSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].postSubSectionRequest(data));},upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateSection));

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSection=function(_React$Component){_inherits(UpdateSection,_React$Component);function UpdateSection(props){_classCallCheck(this,UpdateSection);var _this=_possibleConstructorReturn(this,(UpdateSection.__proto__||Object.getPrototypeOf(UpdateSection)).call(this,props));_this._inputChange=function(e,f){if(e)e.preventDefault();var v=void 0;var form=Object.assign({},_this.state.form);if(f!=='status'){v=e.target.value;form[f]=v;_this.setState({form:form});}else{if(form.status==='active'){form.status='inactive';}else{form.status='active';}_this.setState({form:form});}};_this._submit=function(e){if(e)e.preventDefault();var form=Object.assign({},_this.state.form);var uuid=_this.props.detail.id;var data={uuid:uuid,form:form};_this.props.putSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{title_id:props.detail.title_id||'',title_en:props.detail.title_en||'',status:props.detail.status||''}};return _this;}_createClass(UpdateSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Edit Section')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this2._submit(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_id,className:'form-control',placeholder:'Input name (id)',onChange:function onChange(e){return _this2._inputChange(e,'title_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_en,className:'form-control',placeholder:'Input title (en)',onChange:function onChange(e){return _this2._inputChange(e,'title_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:this.state.form.status==='active',name:'status',onChange:function onChange(){return _this2._inputChange(null,'status');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Submit')))));}}]);return UpdateSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section};};var dispatchToProps=function dispatchToProps(dispatch){return{putSection:function putSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SectionRedux__["b" /* default */].putSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSection));

/***/ }),
/* 1236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSectionImage=function(_React$Component){_inherits(UpdateSectionImage,_React$Component);function UpdateSectionImage(props){_classCallCheck(this,UpdateSectionImage);var _this=_possibleConstructorReturn(this,(UpdateSectionImage.__proto__||Object.getPrototypeOf(UpdateSectionImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','section-image');_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var uuid=_this.props.detail.id;var form=Object.assign({},_this.state.form);var data={uuid:uuid,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{image_file:''},file:null,uploaded:false};return _this;}_createClass(UpdateSectionImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Section Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{maxWidth:'65vw',maxHeight:'65vh'},alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'1440x900'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'section-image',product_type:this.state.form.product_type},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.image_file,className:'btn btn-primary'},'Save')))));}}]);return UpdateSectionImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSectionImage));

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSection=function(_React$Component){_inherits(UpdateSection,_React$Component);function UpdateSection(props){_classCallCheck(this,UpdateSection);var _this=_possibleConstructorReturn(this,(UpdateSection.__proto__||Object.getPrototypeOf(UpdateSection)).call(this,props));_this._inputChange=function(e,f){if(e)e.preventDefault();var v=e.target.value;var form=Object.assign({},_this.state.form);form[f]=v;_this.setState({form:form});};_this._submit=function(e){if(e)e.preventDefault();var form=Object.assign({},_this.state.form);var uuid=_this.props.detail.id;var data={uuid:uuid,form:form};_this.props.putSubSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{title_id:props.detail.title_id||'',title_en:props.detail.title_en||'',subtitle:props.detail.subtitle||'',description:props.detail.description||''}};return _this;}_createClass(UpdateSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Edit Subsection')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(e){return _this2._submit(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (ID)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_id,className:'form-control',placeholder:'Input Title (ID)',onChange:function onChange(e){return _this2._inputChange(e,'title_id');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title (EN)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:this.state.form.title_en,className:'form-control',placeholder:'Input Title (EN)',onChange:function onChange(e){return _this2._inputChange(e,'title_en');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.form.subtitle,className:'form-control',placeholder:'Input Subtitle',onChange:function onChange(e){return _this2._inputChange(e,'subtitle');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{rows:'5',cols:'50',value:this.state.form.description,className:'form-control',onChange:function onChange(e){return _this2._inputChange(e,'description');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Submit')))));}}]);return UpdateSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section};};var dispatchToProps=function dispatchToProps(dispatch){return{putSubSection:function putSubSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSubSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSection));

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSubsectionImage=function(_React$Component){_inherits(UpdateSubsectionImage,_React$Component);function UpdateSubsectionImage(props){_classCallCheck(this,UpdateSubsectionImage);var _this=_possibleConstructorReturn(this,(UpdateSubsectionImage.__proto__||Object.getPrototypeOf(UpdateSubsectionImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var uuid=_this.props.detail.id;var form=Object.assign({},_this.state.form);var data={uuid:uuid,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{image_file:''},file:null,uploaded:false};return _this;}_createClass(UpdateSubsectionImage,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Section Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{maxWidth:'65vw',maxHeight:'65vh'},alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'640x480'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'section-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.image_file,className:'btn btn-primary'},'Save')))));}}]);return UpdateSubsectionImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSubSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSubsectionImage));

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateSubsectionPDF=function(_React$Component){_inherits(UpdateSubsectionPDF,_React$Component);function UpdateSubsectionPDF(props){_classCallCheck(this,UpdateSubsectionPDF);var _this=_possibleConstructorReturn(this,(UpdateSubsectionPDF.__proto__||Object.getPrototypeOf(UpdateSubsectionPDF)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.pdf_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var uuid=_this.props.detail.id;var form=Object.assign({},_this.state.form);var data={uuid:uuid,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={form:{pdf_file:''},file:null,uploaded:false};return _this;}_createClass(UpdateSubsectionPDF,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit Section Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current PDF')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.detail.pdf_url,target:'_blank'},this.props.detail.pdf_file))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Choose PDF')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'company-disclosure'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'pdf_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.pdf_file,className:'btn btn-primary'},'Save')))));}}]);return UpdateSubsectionPDF;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSubSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateSubsectionPDF));

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteSection=function(_React$Component){_inherits(DeleteSection,_React$Component);function DeleteSection(props){_classCallCheck(this,DeleteSection);var _this=_possibleConstructorReturn(this,(DeleteSection.__proto__||Object.getPrototypeOf(DeleteSection)).call(this,props));_this._delete=function(uuid){var data={uuid:uuid};_this.props.deleteSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={};return _this;}_createClass(DeleteSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete section')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Delete this section?'),this.props.detail.title_id,' / ',this.props.detail.title_en),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-danger',onClick:function onClick(){return _this2._delete(_this2.props.detail.id);}},'Confirm'))));}}]);return DeleteSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteSection:function deleteSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeleteSection));

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteSubSection=function(_React$Component){_inherits(DeleteSubSection,_React$Component);function DeleteSubSection(props){_classCallCheck(this,DeleteSubSection);var _this=_possibleConstructorReturn(this,(DeleteSubSection.__proto__||Object.getPrototypeOf(DeleteSubSection)).call(this,props));_this._delete=function(uuid){var data={uuid:uuid};_this.props.deleteSubSection(data);setTimeout(function(){_this.props.closeModal();},500);};_this.state={};return _this;}_createClass(DeleteSubSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Delete Subsection')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Delete this section?'),this.props.detail.title_id,' / ',this.props.detail.title_en),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-danger',onClick:function onClick(){return _this2._delete(_this2.props.detail.id);}},'Confirm'))));}}]);return DeleteSubSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{section:state.section};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteSubSection:function deleteSubSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSubSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeleteSubSection));

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_PresetRedux__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShippingPreset=function(_React$Component){_inherits(ShippingPreset,_React$Component);function ShippingPreset(props){_classCallCheck(this,ShippingPreset);var _this=_possibleConstructorReturn(this,(ShippingPreset.__proto__||Object.getPrototypeOf(ShippingPreset)).call(this,props));_this.componentDidMount=function(){_this.props.get();};_this.componentDidUpdate=function(prevProps){var dataShipping=_this.props.preset.dataShipping;if(prevProps!==_this.props){if(dataShipping.ID){_this._populateToggle(dataShipping.ID,'ID');}}};_this._populateToggle=function(args,country){_this.setState({toggle:_defineProperty({},country,{'airport':args['airport'],'by-myself':args['by-myself'],'courier':args['courier']})});};_this._disableToggle=function(args,method){switch(method){case'airport':return!args['by-myself']&&!args['courier'];case'by-myself':return!args['airport']&&!args['courier'];case'courier':return!args['airport']&&!args['by-myself'];default:return false;}};_this._renderCard=function(preset,country,title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Shipping Method'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{className:'text-center'},'Active'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,_this._renderToggle(preset,country,'airport','Airport'),_this._renderToggle(preset,country,'by-myself','Self Pickup'),_this._renderToggle(preset,country,'courier','Courier'))))));};_this._renderToggle=function(preset,country,method,title){var toggle=_this.state.toggle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{disabled:_this._disableToggle(toggle[country],method),checked:toggle[country][method],onChange:function onChange(){return _this._handleToggle(method,country,preset.dataShipping[country][method]);}})));};_this._handleToggle=function(keys,country,currentValue){var value=!currentValue;var data={keys:keys,country:country,value:value};_this.props.post(data);};_this.state={toggle:{ID:{'airport':false,'by-myself':false,'courier':false}}};return _this;}_createClass(ShippingPreset,[{key:'render',value:function render(){var preset=this.props.preset;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Shipping Preset',preset.fetchingShipping&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ml-2 badge badge-info'},'Loading ...')))),this._renderCard(preset,'ID','Indonesia'));}}]);return ShippingPreset;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{preset:state.preset};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_PresetRedux__["b" /* default */].getShipping());},post:function post(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_PresetRedux__["b" /* default */].updateShipping(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ShippingPreset));

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_AttractionPromo_Create__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_AttractionPromo_Update__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_AttractionPromo_Image__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_AttractionPromo_Delete__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_js_pagination__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AttractionPromo=function(_React$Component){_inherits(AttractionPromo,_React$Component);function AttractionPromo(props){_classCallCheck(this,AttractionPromo);var _this=_possibleConstructorReturn(this,(AttractionPromo.__proto__||Object.getPrototypeOf(AttractionPromo)).call(this,props));_initialiseProps.call(_this);_this.state={page:1,modal:null,detail:{},selectedCountry:{},filter:{page:1},countrySelector:[{label:'ALL',value:''}]};return _this;}_createClass(AttractionPromo,[{key:'render',value:function render(){var _this2=this;var attractionPromo=this.props.attractionPromo;var _attractionPromo$data=attractionPromo.data,data=_attractionPromo$data.data,meta=_attractionPromo$data.meta;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Attraction Promo Email',(attractionPromo.fetching||attractionPromo.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:function onClick(){return _this2._triggerModal('create');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create New')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_AdvancedFilter__["a" /* default */],{filters:[{type:'selector',name:'Country',field:'country',selectors:this.state.countrySelector}],manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._fetchAttractionPromo(event);}}),!(attractionPromo.processing||attractionPromo.fetching)&&attractionPromo.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},attractionPromo.err)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Components_AdvancedTable__["a" /* default */],{colSpan:9,header:[{field:'Name'},{field:'Country'},{field:'Coupon Code'},{field:'URL'},{field:'Description'},{field:'Discount'},{field:'Image'},{field:'Edit'},{field:'Delete'}],body:data&&data.length>0&&data.map(function(item){return[{field:item.name},{field:item.country.name},{field:item.coupon_code},{field:item.url},{field:item.description},{field:item.discount_amount},{field:_this2._renderImageContainer(item)},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'update','selectCountry');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem(item,'delete','default');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section text-center'},meta&&meta.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:meta.page||this.state.page,itemsCountPerPage:meta.limit,totalItemsCount:meta.total,pageRangeDisplayed:5,onChange:this._changePage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.modal==='create',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_AttractionPromo_Create__["a" /* default */],{closeModal:function closeModal(){return _this2._triggerModal(null);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.modal==='update',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_AttractionPromo_Update__["a" /* default */],{closeModal:function closeModal(){return _this2._triggerModal(null);},detail:this.state.detail,selectedCountry:this.state.selectedCountry})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.modal==='image',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_AttractionPromo_Image__["a" /* default */],{closeModal:function closeModal(){return _this2._triggerModal(null);},detail:this.state.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.modal==='delete',onClose:function onClose(){return _this2._triggerModal(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_AttractionPromo_Delete__["a" /* default */],{uuid:this.state.detail.id,name:this.state.detail.name,closeModal:function closeModal(){return _this2._triggerModal(null);}})));}}]);return AttractionPromo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this._selectItem=function(detail,modal,method){switch(method){case'default':_this3.setState({detail:detail});break;case'selectCountry':var selectedCountry={value:detail.country.id,label:detail.country.name};_this3.setState({detail:detail,selectedCountry:selectedCountry});break;default:return null;}_this3._triggerModal(modal);};this._triggerModal=function(modal){_this3.setState({modal:modal});};this._manipulateState=function(props){_this3.setState({filter:props});};this._changePage=function(page){_this3.setState({page:page});_this3._fetchAttractionPromo(null,page);};this._renderImageContainer=function(detail){if((detail.image_file||detail.image_url)===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this3._selectItem(detail,'image','default');},className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Assign');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{onClick:function onClick(){return _this3._selectItem(detail,'image','default');},src:detail.image_url,alt:detail.image_file,height:'100px',width:'100px',style:{cursor:'pointer'}});}};this._fetchAttractionPromo=function(event,page){if(event){event.preventDefault();}var filter=Object.assign({},_this3.state.filter);if(page)filter.page=page;var data=filter;_this3.props.get(data);};this._getCountrySelector=function(meta){var countrySelector=_this3.state.countrySelector;if(meta){meta.list_country.map(function(item,i){return countrySelector[i+1]={label:item.name,value:item.id};});_this3.setState({countrySelector:countrySelector});}};this.componentDidUpdate=function(prevProps){var meta=_this3.props.attractionPromo.data.meta;if(prevProps!==_this3.props){_this3._getCountrySelector(meta);}};this.componentDidMount=function(){_this3.props.get();};};var stateToProps=function stateToProps(state){return{attractionPromo:state.attractionPromo};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionPromoRedux__["b" /* default */].attractionPromoRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(AttractionPromo));

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Create=function(_React$Component){_inherits(Create,_React$Component);function Create(props){_classCallCheck(this,Create);var _this=_possibleConstructorReturn(this,(Create.__proto__||Object.getPrototypeOf(Create)).call(this,props));_this._submit=function(event){event.preventDefault();var data=Object.assign({},_this.state.form);_this.props.post(data);setTimeout(function(){_this.props.closeModal();},250);};_this._selectChange=function(selectedCountry,field){var form=Object.assign({},_this.state.form);form[field]=selectedCountry.value;_this.setState({selectedCountry:selectedCountry,form:form});};_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);var value=event.target.value;form[field]=value;_this.setState({form:form});};_this._selectRow=function(field){var dataCountries=_this.props.dataCountries;var countrySelector=[];dataCountries.map(function(item,i){return countrySelector[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{required:true,options:countrySelector,value:_this.state.selectedCountry,onChange:function onChange(selectedCountry){return _this._selectChange(selectedCountry,field);}});};_this._inputRow=function(properties,field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:properties.type,required:properties.required,min:properties.min,max:properties.max,minLength:properties.minLength,maxLength:properties.maxLength,placeholder:properties.placeholder,value:_this.state.form[field],onChange:function onChange(event){return _this._inputChange(event,field);}});};_this._formRow=function(type,properties,label,field){switch(type){case'input':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},_this._inputRow(properties,field)));case'select':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},_this._selectRow(field)));default:return null;}};_this.state={form:{country_id:'',name:'',coupon_code:'',url:'',description:'',discount_amount:''},selectedCountry:null};return _this;}_createClass(Create,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Create Attraction Promo Email')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},this._formRow('select',null,'Country','country_id'),this._formRow('input',{type:'text',required:true,placeholder:'Promo name'},'Name','name'),this._formRow('input',{type:'text',placeholder:'Coupon code (7 letters max)',minLength:4,maxLength:7},'Coupon Code','coupon_code'),this._formRow('input',{type:'text',required:true,placeholder:'Must be https://'},'URL','url'),this._formRow('input',{type:'text'},'Promo description','description'),this._formRow('input',{type:'text'},'Discount','discount_amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},' Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Submit'))));}}]);return Create;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{dataCountries:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{post:function post(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].postAttractionPromoRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Create));

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Update=function(_React$Component){_inherits(Update,_React$Component);function Update(props){_classCallCheck(this,Update);var _this=_possibleConstructorReturn(this,(Update.__proto__||Object.getPrototypeOf(Update)).call(this,props));_this._submit=function(event){event.preventDefault();var uuid=_this.props.detail.id;var form=Object.assign({},_this.state.form);var data={uuid:uuid,form:form};_this.props.put(data);setTimeout(function(){_this.props.closeModal();},250);};_this._selectChange=function(selectedCountry,field){var form=Object.assign({},_this.state.form);form[field]=selectedCountry.value;_this.setState({selectedCountry:selectedCountry,form:form});};_this._inputChange=function(event,field){var form=Object.assign({},_this.state.form);var value=event.target.value;form[field]=value;_this.setState({form:form});};_this._selectRow=function(field){var dataCountries=_this.props.dataCountries;var countrySelector=[];dataCountries.map(function(item,i){return countrySelector[i]={value:item.id,label:item.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{required:true,options:countrySelector,value:_this.state.selectedCountry,onChange:function onChange(selectedCountry){return _this._selectChange(selectedCountry,field);}});};_this._inputRow=function(properties,field){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',type:properties.type,required:properties.required,min:properties.min,max:properties.max,minLength:properties.minLength,maxLength:properties.maxLength,placeholder:properties.placeholder,value:_this.state.form[field],onChange:function onChange(event){return _this._inputChange(event,field);}});};_this._formRow=function(type,properties,label,field){switch(type){case'input':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},_this._inputRow(properties,field)));case'select':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},_this._selectRow(field)));default:return null;}};_this.state={form:{country_id:props.detail.country_id||'',name:props.detail.name||'',coupon_code:props.detail.coupon_code||'',url:props.detail.url||'',description:props.detail.description||'',discount_amount:props.detail.discount_amount||''},selectedCountry:props.selectedCountry};return _this;}_createClass(Update,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Update Attraction Promo',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},this.props.detail.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},this._formRow('select',null,'Country','country_id'),this._formRow('input',{type:'text',required:true,placeholder:'Promo name'},'Name','name'),this._formRow('input',{type:'text',placeholder:'Coupon code (7 letters max)',minLength:4,maxLength:7},'Coupon Code','coupon_code'),this._formRow('input',{type:'text',required:true,placeholder:'Must be https://'},'URL','url'),this._formRow('input',{type:'text'},'Promo description','description'),this._formRow('input',{type:'text'},'Discount','discount_amount'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Submit'))));}}]);return Update;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{dataCountries:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{put:function put(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].putAttractionPromoRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Update));

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Containers_FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Image=function(_React$Component){_inherits(Image,_React$Component);function Image(props){_classCallCheck(this,Image);var _this=_possibleConstructorReturn(this,(Image.__proto__||Object.getPrototypeOf(Image)).call(this,props));_this._fileUploaded=function(filename){var form=Object.assign({},_this.state.form);form.image_file=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var uuid=_this.props.detail.id;var form=Object.assign({},_this.state.form);var data={uuid:uuid,form:form};_this.props.put(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{country_id:props.detail.country_id,image_file:undefined}};return _this;}_createClass(Image,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Edit Attraction Promo Image',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},this.props.detail.name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},this.props.detail.image_file&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',style:{maxWidth:'65vw',maxHeight:'65vh'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'155x155'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Containers_FileUploader__["a" /* default */],{setting:{type:'attraction-promo'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',type:'button',onClick:function onClick(){return _this2.props.closeModal();}},' Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-lg btn-primary',type:'submit'},'Submit'))));}}]);return Image;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{put:function put(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].putAttractionPromoRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Image));

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Delete=function(_React$Component){_inherits(Delete,_React$Component);function Delete(props){_classCallCheck(this,Delete);var _this=_possibleConstructorReturn(this,(Delete.__proto__||Object.getPrototypeOf(Delete)).call(this,props));_this._delete=function(event){var data=_this.props.uuid;_this.props.delete(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={};return _this;}_createClass(Delete,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Delete Attraction Promo')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'text-center'},'Confirm deletion of (',this.props.name,') ?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},' Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._delete();}},' Delete'))));}}]);return Delete;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{delete:function _delete(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].deleteAttractionPromoRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Delete));

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redux_FailedTransactionRedux__ = __webpack_require__(219);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FailedTransaction=function(_React$Component){_inherits(FailedTransaction,_React$Component);function FailedTransaction(props){_classCallCheck(this,FailedTransaction);var _this=_possibleConstructorReturn(this,(FailedTransaction.__proto__||Object.getPrototypeOf(FailedTransaction)).call(this,props));_this.componentDidMount=function(){var data={page:_this.state.page};_this.props.get(data);};_this._fetch=function(page){var data={page:page};_this.props.get(data);};_this._handleResend=function(event){event&&event.preventDefault();_this.props.trigger();setTimeout(function(){_this._fetch(_this.state.page);},250);};_this._handleModal=function(){var modal=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;_this.setState({modal:modal});};_this._handleSelect=function(item,modal){_this.setState({detail:item.data,orderid:item.orderid});_this._handleModal(modal);};_this._handleChangePage=function(page){_this.setState({page:page});_this._fetch(page);};_this.dateFormat='DD MMM YYYY';_this.state={page:'1',modal:null,counter:0,detail:{},orderid:''};return _this;}_createClass(FailedTransaction,[{key:'render',value:function render(){var _this2=this;var failedTransaction=this.props.failedTransaction;var data=failedTransaction.data;var _state=this.state,detail=_state.detail,orderid=_state.orderid;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(HeaderHelper,{state:failedTransaction,title:'Failed Transactions List',_handleResend:function _handleResend(event){return _this2._handleResend(event);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedTable__["a" /* default */],{colSpan:5,header:[{field:'Order ID'},{field:'Attempts'},{field:'Status'},{field:'Date'},{field:'View Details'}],body:data.data&&data.data.length>0&&data.data.map(function(item){return[{field:item.orderid},{field:item.hit_count},{field:item.status},{field:__WEBPACK_IMPORTED_MODULE_0_moment___default()(item.created_at).format(_this2.dateFormat)},{field:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._handleSelect(item,'data');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-eye'}),' View')}];})}),data.meta&&data.meta.count>10&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PaginationHelper,{meta:data.meta,statePage:this.state.page,_handleChangePage:this._handleChangePage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.modal==='data',onClose:this._handleModal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DetailHelper,{orderid:orderid,detail:detail,_handleModal:function _handleModal(){return _this2._handleModal(null);}})));}}]);return FailedTransaction;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var HeaderHelper=function HeaderHelper(_ref){var state=_ref.state,title=_ref.title,_handleResend=_ref._handleResend;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'title'},title,(state.fetching||state.processing)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'badge badge-info ml-2'},'Loading ...')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary ml-auto',onClick:_handleResend},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-upload'}),' Resend All')));};var DetailHelper=function DetailHelper(_ref2){var orderid=_ref2.orderid,detail=_ref2.detail,_handleModal=_ref2._handleModal;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'title'},'Failed Transaction Detail'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{className:'form-text text-muted'},'Order ID: ',orderid)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'table table-hover table-striped table-bordered'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'text-center'},'Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'text-center'},'Value'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,detail&&Object.keys(detail).map(function(key,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:i},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'text-center'},key),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'text-center'},detail[key]||'No Data'));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'form-group d-flex justify-content-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:_handleModal},'Close')));};var PaginationHelper=function PaginationHelper(_ref3){var meta=_ref3.meta,currentPage=_ref3.currentPage,_handleChangePage=_ref3._handleChangePage;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:meta.page||currentPage,itemsCountPerPage:10,totalItemsCount:meta.count,pageRangeDisplayed:5,onChange:_handleChangePage}));};var stateToProps=function stateToProps(state){return{failedTransaction:state.failedTransaction};};var dispatchToProps=function dispatchToProps(dispatch){return{get:function get(data){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_FailedTransactionRedux__["b" /* default */].getFailedTransactionRequest(data));},trigger:function trigger(){return dispatch(__WEBPACK_IMPORTED_MODULE_6__Redux_FailedTransactionRedux__["b" /* default */].triggerFailedTransactionRequest());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(FailedTransaction));

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Containers_Promo_UpdatePromoSection__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_PromoSectionRedux__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PromoSectionPage=function(_React$Component){_inherits(PromoSectionPage,_React$Component);function PromoSectionPage(props){_classCallCheck(this,PromoSectionPage);var _this=_possibleConstructorReturn(this,(PromoSectionPage.__proto__||Object.getPrototypeOf(PromoSectionPage)).call(this,props));_this._toggleStatus=function(value){var data=Object.assign({},_this.props.promoSection.data);var form={title:data.title,status:data.status,url:data.url,image_file:data.image_file};if(value==='active'){form.status='inactive';}else{form.status='active';}console.log(form.status);_this.props.updatePromoSection({id:data.id,form:form});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(!modalId)_this.props.getPromoSection();_this.setState({showModal:modalId});};_this.state={showModal:'',detail:{}};return _this;}_createClass(PromoSectionPage,[{key:'componentDidMount',value:function componentDidMount(){this.props.getPromoSection();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.promoSection.processing!==this.props.promoSection.processing&&this.props.promoSection.processing===false){this.props.getPromoSection();}}},{key:'render',value:function render(){var _this2=this;var promoSection=this.props.promoSection;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title'},'Section Promo',(promoSection.fetching||promoSection.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},promoSection.fetching?'Loading':'Processing',' ...')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card card-block'},!(promoSection.fetching||promoSection.processing)&&promoSection.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},promoSection.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:promoSection.data.image_url,className:'img-fluid rounded',alt:promoSection.data.title})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-8'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Title:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,promoSection.data.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Subtitle:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,promoSection.data.subtitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Content:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{whiteSpace:'pre'}},promoSection.data.content)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CTA:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:promoSection.data.url},promoSection.data.url)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-block mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Active :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{disabled:promoSection.processing||promoSection.fetching,checked:promoSection.data.status==='active',onChange:function onChange(){return _this2._toggleStatus(promoSection.data.status);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary btn-lg',onClick:function onClick(){return _this2._toggleModal('change-promo');}},'Edit'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{className:{modal:'modal-large'},open:this.state.showModal==='change-promo',onClose:this._toggleModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Containers_Promo_UpdatePromoSection__["a" /* default */],{detail:promoSection.data,closeModal:function closeModal(){return _this2._toggleModal();}})));}}]);return PromoSectionPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{promoSection:state.promoSection};};var dispatchToProps=function dispatchToProps(dispatch){return{getPromoSection:function getPromoSection(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_PromoSectionRedux__["b" /* default */].getPromoSectionRequest());},updatePromoSection:function updatePromoSection(data){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_PromoSectionRedux__["b" /* default */].updatePromoSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(PromoSectionPage));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Containers_FileUploader__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_PromoSectionRedux__ = __webpack_require__(163);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdatePromoSection=function(_React$Component){_inherits(UpdatePromoSection,_React$Component);function UpdatePromoSection(props){_classCallCheck(this,UpdatePromoSection);var _this=_possibleConstructorReturn(this,(UpdatePromoSection.__proto__||Object.getPrototypeOf(UpdatePromoSection)).call(this,props));_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._inputChange=function(value,field){var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._toggleField=function(value){var form=Object.assign({},_this.state.form);if(value==='active'){form['status']='inactive';}else{form['status']='active';}_this.setState({form:form});};_this._submitData=function(event){event.preventDefault();var data={id:_this.props.detail.id,form:_this.state.form};_this.props.update(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{title:props.detail.title||'',subtitle:props.detail.subtitle||'',status:props.detail.status||'',url:props.detail.url||'',image_file:props.detail.image_file||'',content:props.detail.content||''}};return _this;}_createClass(UpdatePromoSection,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Promo Section')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submitData(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event.target.value,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Subtitle')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',className:'form-control',value:this.state.form.subtitle,onChange:function onChange(event){return _this2._inputChange(event.target.value,'subtitle');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Content')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{required:true,className:'form-control',rows:5,value:this.state.form.content,onChange:function onChange(event){return _this2._inputChange(event.target.value,'content');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Containers_FileUploader__["a" /* default */],{setting:{type:'section-image'},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Link URL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'form-text text-muted'},'URL must contain https://')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',required:true,className:'form-control',value:this.state.form.url,onChange:function onChange(event){return _this2._inputChange(event.target.value,'url');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Active')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:this.state.form.status==='active',onChange:function onChange(){return _this2._toggleField(_this2.state.form.status);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-lg btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-lg btn-primary'},'Save'))));}}]);return UpdatePromoSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{promoSection:state.promoSection};};var dispatchToProps=function dispatchToProps(dispatch){return{update:function update(data){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_PromoSectionRedux__["b" /* default */].updatePromoSectionRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdatePromoSection));

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Scheduler_CreateScheduler__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Containers_Scheduler_DeleteScheduler__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Containers_Scheduler_SchedulerName__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Scheduler_ModularScheduler__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Redux_SchedulerRedux__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Scheduler=function(_React$Component){_inherits(Scheduler,_React$Component);function Scheduler(props){_classCallCheck(this,Scheduler);var _this=_possibleConstructorReturn(this,(Scheduler.__proto__||Object.getPrototypeOf(Scheduler)).call(this,props));_initialiseProps.call(_this);_this.dateformat='ddd, D MMM YYYY h:mm a';_this.timeformat='h:mm:ss a';_this.state={showModal:null,filter:{page:1},type:'',item:{}};return _this;}_createClass(Scheduler,[{key:'render',value:function render(){var _this2=this;var scheduler=this.props.scheduler;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('header',{className:'title-block d-flex mb-3 justify-content-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',{className:'title mr-auto'},'Manage Scheduler',(scheduler.fetching||scheduler.processing)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'badge badge-info ml-2'},scheduler.fetching?'Loading':scheduler.processing?'Processing':'',' ...')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._toggleModal('create-scheduler');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create New Scheduler')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_AdvancedFilter__["a" /* default */],{filters:[{type:'text',name:'Title',placeholder:'Search by Title',field:'q'},{type:'selector',name:'Type',field:'p',selectors:[{label:'ALL',value:''},{label:'Wifi Product',value:'modems'},{label:'Banner',value:'banners'},{label:'Attraction',value:'attractions'}]}],manipulateState:function manipulateState(props){return _this2._manipulateState(props);},callback:function callback(event){return _this2._fetchScheduler(null,event);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_AdvancedTable__["a" /* default */],{colSpan:6,header:[{field:'Title'},{field:'Date/Time'},{field:'Type'},{field:'Status'},{field:'Schedule Details'},{field:'Delete'}],body:scheduler.data.data&&scheduler.data.data.length>0&&scheduler.data.data.map(function(item){return[{field:_this2._editableName(item)},{field:__WEBPACK_IMPORTED_MODULE_0_moment___default()(item.date).format(_this2.dateformat)},{field:_this2._determineProductType(item.product)},{field:item.is_finish===0?'On Progress':'Finished'},{field:_this2._determineModal(item)},{field:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._selectItem('delete-scheduler',item);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})}),this._renderPagination(scheduler.data.meta),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='delete-scheduler',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Containers_Scheduler_DeleteScheduler__["a" /* default */],Object.assign({},this.props,this.state.item,{closeModal:function closeModal(){return _this2._toggleModal(null);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='create-scheduler',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Scheduler_CreateScheduler__["a" /* default */],Object.assign({},this.props,{closeModal:function closeModal(){return _this2._toggleModal(null);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='view-ultimate',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Scheduler_ModularScheduler__["a" /* default */],Object.assign({},this.props,{detail:this.state.item,type:this.state.type,closeModal:function closeModal(){return _this2._toggleModal(null);}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive_modal__["a" /* default */],{center:true,classNames:{modal:'modal-large'},open:this.state.showModal==='edit-scheduler-title',onClose:function onClose(){return _this2._toggleModal(null);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Containers_Scheduler_SchedulerName__["a" /* default */],Object.assign({},this.props,{detail:this.state.item,closeModal:function closeModal(){return _this2._toggleModal(null);}}))));}}]);return Scheduler;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3._fetchScheduler();};this._fetchScheduler=function(filter,event){var data={};if(event){event.preventDefault();data=Object.assign({},_this3.state.filter);data.page=1;_this3.props.getScheduler(data);}else if(!event){if(!filter){data=Object.assign({},_this3.state.filter);_this3.props.getScheduler(data);}else if(filter){_this3.props.getScheduler(filter);}}};this._selectItem=function(modalID,item,type){_this3.setState({item:item,type:type});_this3._toggleModal(modalID);};this._toggleModal=function(modalID){if(!modalID){_this3._fetchScheduler();}_this3.setState({showModal:modalID});};this._determineModal=function(item){var modalID='view-ultimate';var type=item.product;if(type!=='attractions'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-info',onClick:function onClick(){return _this3._selectItem(modalID,item,type);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-book'}),' View');}};this._determineProductType=function(product){switch(product){case'modems':return'Wifi Product';case'banners':return'Banner';case'attractions':return'Attraction';default:return null;}};this._editableName=function(item){var value=void 0;if(item.title){value=item.title;}else{value='Untitled';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'d-flex justify-content-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'mr-2'},value),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'btn btn-primary btn-sm',onClick:function onClick(){return _this3._selectItem('edit-scheduler-title',item);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit'));};this._changePage=function(page){var filter=Object.assign({},_this3.state.filter,{page:page});_this3.setState({filter:filter});_this3._fetchScheduler(filter);};this._renderPagination=function(meta){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('section',{className:'text-center'},meta&&meta.count>10&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:meta.page||_this3.state.filter.page,itemsCountPerPage:meta.limit,totalItemsCount:meta.count,pageRangeDisplayed:5,onChange:_this3._changePage}));};this._manipulateState=function(props){var filter=Object.assign({},_this3.state.filter);filter.q=props.q;filter.p=props.p;_this3.setState({filter:filter});};};var stateToProps=function stateToProps(state){return{scheduler:state.scheduler,product:state.product};};var dispatchToProps=function dispatchToProps(dispatch){return{getScheduler:function getScheduler(data){return dispatch(__WEBPACK_IMPORTED_MODULE_11__Redux_SchedulerRedux__["b" /* default */].getSchedulerRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(Scheduler));

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datetime__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateScheduler=function(_React$Component){_inherits(CreateScheduler,_React$Component);function CreateScheduler(props){_classCallCheck(this,CreateScheduler);var _this=_possibleConstructorReturn(this,(CreateScheduler.__proto__||Object.getPrototypeOf(CreateScheduler)).call(this,props));_this._handleDateTimeChange=function(event,field){var value=void 0;switch(field){case'product':case'title':value=event.target.value;break;case'date':if(Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["isObject"])(event)){value=event;}break;default:return null;}var form=Object.assign({},_this.state.form);form[field]=value;_this.setState({form:form});};_this._submit=function(event){event&&event.preventDefault();var data=Object.assign({},_this.state.form);_this.props.postScheduler(data);setTimeout(function(){_this.props.closeModal();},500);};_this.productType=[{label:'Wifi Products',value:'modems'},// { label: 'Attractions', value: 'attractions' },
{label:'Banners',value:'banners'}];_this.state={form:{product:'',date:null,title:'',items:[]}};return _this;}_createClass(CreateScheduler,[{key:'render',value:function render(){var _this2=this;var scheduler=this.props.scheduler;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw',height:'70vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Create Scheduler')),scheduler.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},scheduler.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,placeholder:'Insert Title ...',className:'form-control',onChange:function onChange(e){return _this2._handleDateTimeChange(e,'title');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{defaultValue:'',required:true,className:'form-control',onChange:function onChange(e){return _this2._handleDateTimeChange(e,'product');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'',disabled:true},'-Select Product Type-'),this.productType.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:option.value},option.label);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Date / Time')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_datetime___default.a,{inputProps:{required:true},isValidDate:function isValidDate(current){return current.isAfter(__WEBPACK_IMPORTED_MODULE_5_moment___default()());},onChange:function onChange(date){return _this2._handleDateTimeChange(date,'date');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}),' Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Create')))));}}]);return CreateScheduler;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{scheduler:state.scheduler};};var dispatchToProps=function dispatchToProps(dispatch){return{postScheduler:function postScheduler(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].postSchedulerRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(CreateScheduler));

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeleteScheduler=function(_React$Component){_inherits(DeleteScheduler,_React$Component);function DeleteScheduler(props){_classCallCheck(this,DeleteScheduler);var _this=_possibleConstructorReturn(this,(DeleteScheduler.__proto__||Object.getPrototypeOf(DeleteScheduler)).call(this,props));_this._submit=function(){var data={id:_this.props.id};setTimeout(function(){_this.props.deleteScheduler(data);setTimeout(function(){_this.props.closeModal();},300);},300);};_this.dateformat='DD-MM-YYYY / h:mm:ss a';_this.state={};return _this;}_createClass(DeleteScheduler,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Delete Scheduler')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Scheduler Name: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Date / Time: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.props.date).format(this.dateformat))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'text-center'},'Product Type: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,this.props.product))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-right col-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-danger',onClick:function onClick(){return _this2._submit();}},'Delete'))));}}]);return DeleteScheduler;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{scheduler:state.scheduler};};var dispatchToProps=function dispatchToProps(dispatch){return{deleteScheduler:function deleteScheduler(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].deleteSchedulerRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(DeleteScheduler));

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchedulerName=function(_React$Component){_inherits(SchedulerName,_React$Component);function SchedulerName(props){_classCallCheck(this,SchedulerName);var _this=_possibleConstructorReturn(this,(SchedulerName.__proto__||Object.getPrototypeOf(SchedulerName)).call(this,props));_this._inputChange=function(event,field){event&&event.preventDefault();var form=Object.assign({},_this.state.form);var value=event.target.value;form[field]=value;_this.setState({form:form});};_this._submit=function(event){event&&event.preventDefault();var data={id:_this.state.id,form:_this.state.form};setTimeout(function(){_this.props.putScheduler(data);setTimeout(function(){_this.props.closeModal();},300);},300);};_this.state={id:props.detail.id,form:{title:props.detail.title,product:props.detail.product,date:props.detail.date,items:props.detail.items}};return _this;}_createClass(SchedulerName,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},' Edit Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Title')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{value:this.state.form.title,onChange:function onChange(event){return _this2._inputChange(event,'title');},placeholder:'Insert Title ...',className:'form-control'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return _this2.props.closeModal();},className:'btn btn-secondary mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}),' Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'}),' Save')))));}}]);return SchedulerName;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProp=function stateToProp(state){return{scheduler:state.scheduler};};var dispatchToProps=function dispatchToProps(dispatch){return{putScheduler:function putScheduler(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].putSchedulerRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProp,dispatchToProps)(SchedulerName));

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_AdvancedTable__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Utils_FauxArrayUtils__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__ = __webpack_require__(36);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModularScheduler=function(_React$Component){_inherits(ModularScheduler,_React$Component);function ModularScheduler(props){_classCallCheck(this,ModularScheduler);var _this=_possibleConstructorReturn(this,(ModularScheduler.__proto__||Object.getPrototypeOf(ModularScheduler)).call(this,props));_this.componentDidMount=function(){_this._fetchSchedulerDetails();_this._determineGetter(_this.props.type);};_this._fetchSchedulerDetails=function(){var data={id:_this.state.id};_this.props.getSchedulerDetail(data);};_this._determineGetter=function(type){switch(type){case'modems':_this.props.getProductCustom();break;case'banners':_this.props.bannerCustomRequest();break;case'attractions':default:return null;}};_this.componentDidUpdate=function(prevProps){var _this$props=_this.props,product=_this$props.product,banner=_this$props.banner,type=_this$props.type;if(type==='modems'){if(product!==prevProps.product){if(product.custom!==null&&product.custom.length>0){_this._populateModemPicker(product.custom);}}}else if(type==='banners'){if(banner!==prevProps.banner){if(banner.custom!==null&&banner.custom.length>0){_this._populateBannerPicker(banner.custom);}}}};_this._populateModemPicker=function(custom){var modemPicker=[];custom.map(function(item,i){return modemPicker[i]={value:item.id,label:item.title,name:item.title,status:item.status};});_this.setState({modemPicker:modemPicker});};_this._populateBannerPicker=function(custom){var bannerPicker=[];custom.map(function(item,i){return(// array1[i] = {
bannerPicker[i]={value:item.id,label:item.title,name:item.title,status:item.status});});_this.setState({bannerPicker:bannerPicker});};_this._determineProductType=function(type){switch(type){case'modems':return'Wifi Product';case'banners':return'Banner';case'attractions':return'Attraction';default:return null;}};_this._toggleModal=function(showModal,reset){_this.setState({showModal:showModal});if(reset){var form=Object.assign({},_this.state.form);form.items=_this.preserveArray;_this.setState({form:form,extraDetails:'',editMode:null});}};_this._selectChange=function(method,selected){var newArray=_this.state.newArray;newArray[0].id=selected.value;newArray[0].name=selected.name;if(method==='modems'){_this.setState({selectedModem:selected,newArray:newArray});}else if(method==='banners'){_this.setState({selectedBanner:selected,newArray:newArray});}};_this._inputChange=function(event,field){var value=event.target.value;var newArray=_this.state.newArray;newArray[0][field]=value;_this.setState({newArray:newArray});};_this._editItem=function(editMode,item,type){var newArray=_this.state.newArray;if(item){newArray[0].status=item.status;newArray[0].value=item.value;newArray[0].name=item.name;newArray[0].id=item.id;if(type==='modems'){_this.setState({selectedModem:{value:item.id,label:item.name}});}else if(type==='banners'){_this.setState({selectedBanner:{value:item.id,label:item.name}});}_this.setState({newArray:newArray});}else if(!item){newArray[0].status='';newArray[0].value='';newArray[0].name='';newArray[0].id='';_this.setState({selectedModem:{value:'',label:''},selectedBanner:{value:'',label:''},newArray:newArray});}_this.setState({editMode:editMode});};_this._prepareFauxDelete=function(item){var form=Object.assign({},_this.state.form);form.items=Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FauxArrayUtils__["b" /* fauxDelete */])(_this.state.form.items,item.id);_this.setState({form:form,extraDetails:item.name});_this._toggleModal('delete');};_this._prepareFauxPut=function(event){event&&event.preventDefault();var form=Object.assign({},_this.state.form);if(_this.state.editMode){form.items=Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FauxArrayUtils__["c" /* fauxUpdate */])(_this.state.form.items,_this.state.newArray,_this.state.newArray[0].id);}else{form.items=Object(__WEBPACK_IMPORTED_MODULE_8__Utils_FauxArrayUtils__["a" /* fauxCreate */])(_this.state.form.items,_this.state.newArray);}_this.setState({form:form,extraDetails:_this.state.newArray[0].name});_this._toggleModal('confirmation');};_this._finalizeSubmit=function(){var data={id:_this.state.id,form:_this.state.form};_this.props.putScheduler(data);_this._toggleModal(null,false);_this._editItem(null);};_this._renderForm=function(type){switch(type){case'modems':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this._prepareFauxPut(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Product')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{placeholder:'Select Wifi Product To Add ...',isDisabled:_this.state.editMode!==null,isOptionDisabled:function isOptionDisabled(option){return option.isDisabled;},options:_this.state.modemPicker,value:_this.state.selectedModem,onChange:function onChange(selectedModem){return _this._selectChange('modems',selectedModem);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:_this.state.newArray[0].status,required:true,onChange:function onChange(event){return _this._inputChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'--Select Status--'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'active'},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'inactive'},'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:_this.state.newArray[0].value,min:1,type:'number',className:'form-control',onChange:function onChange(event){return _this._inputChange(event,'value');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},_this.state.editMode!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._editItem(null);},className:'btn btn-secondary mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}),' Cancel'),_this.state.editMode===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'}),' Save'))));case'banners':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this._prepareFauxPut(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Banner')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{placeholder:'Select Banner To Add ...',isDisabled:_this.state.editMode!==null,options:_this.state.bannerPicker,value:_this.state.selectedBanner,onChange:function onChange(selectedBanner){return _this._selectChange('banners',selectedBanner);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Status')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'form-control',value:_this.state.newArray[0].status,required:true,onChange:function onChange(event){return _this._inputChange(event,'status');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{disabled:true,value:''},'--Select Status--'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'active'},'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'inactive'},'Inactive')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Priority')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{required:true,value:_this.state.newArray[0].value,type:'number',className:'form-control',onChange:function onChange(event){return _this._inputChange(event,'value');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},_this.state.editMode!==null&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this._editItem(null);},className:'btn btn-secondary mr-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-times'}),' Cancel'),_this.state.editMode===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-plus'}),' Add'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'}),' Save'))));case'attractions':default:return null;}};_this._renderTable=function(detail,type){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_AdvancedTable__["a" /* default */],{colSpan:5,header:[{field:'Name'},{field:'Status'},{field:type==='modems'?'Price':'Priority'},{field:'Edit'},{field:'Delete'}],body:detail.items&&detail.items.length>0&&detail.items.map(function(item){return[{field:item.name},{field:item.status},{field:type==='modems'?Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(item.value):item.value},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this.state.editMode!==null,className:'btn btn-primary',onClick:function onClick(){return _this._editItem('update',item,_this.props.type);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))},{field:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:_this.state.editMode!==null,className:'btn btn-danger',onClick:function onClick(){return _this._prepareFauxDelete(item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}))}];})});};_this.preserveArray=props.detail.items;_this.state={showModal:null,editMode:null,modemPicker:[],bannerPicker:[],selectedModem:{value:'',label:''},selectedBanner:{value:'',label:''},id:props.detail.id,newArray:[{status:'',value:'',name:'',id:''}],form:{product:props.detail.product,date:props.detail.date,items:props.detail.items},extraDetails:''};return _this;}_createClass(ModularScheduler,[{key:'render',value:function render(){var _this2=this;var _props=this.props,scheduler=_props.scheduler,type=_props.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},this._determineProductType(this.props.type),' Scheduler',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'ml-2'},'for ',this.props.detail.title),(scheduler.fetching||scheduler.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},scheduler.fetching?'Loading':'Processing',' ...'))),scheduler.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},scheduler.err),this._renderForm(type),this._renderTable(scheduler.detail,type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='confirmation',onClose:function onClose(){return _this2._toggleModal(null,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'45vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Confirm ',this.state.editMode===null?'Add Item':'Edit Item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.extraDetails)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-secondary btn mr-2',onClick:function onClick(){return _this2._toggleModal(null,true);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._finalizeSubmit();},type:'button',className:'btn-primary btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-save'}),'Confirm'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},center:true,open:this.state.showModal==='delete',onClose:function onClose(){return _this2._toggleModal(null,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'45vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'title'},'Confirm Delete Item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.state.extraDetails)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row mt-3 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-secondary btn mr-2',onClick:function onClick(){return _this2._toggleModal(null,true);}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2._finalizeSubmit();},type:'button',className:'btn-danger btn'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-trash'}),'Confirm'))))));}}]);return ModularScheduler;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{scheduler:state.scheduler,product:state.product,banner:state.banner};};var dispatchToProps=function dispatchToProps(dispatch){return{getProductCustom:function getProductCustom(){return dispatch(__WEBPACK_IMPORTED_MODULE_4__Redux_ProductRedux__["b" /* default */].getProductCustomRequest());},bannerCustomRequest:function bannerCustomRequest(){return dispatch(__WEBPACK_IMPORTED_MODULE_5__Redux_BannerRedux__["b" /* default */].bannerCustomRequest());},getSchedulerDetail:function getSchedulerDetail(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SchedulerRedux__["b" /* default */].getSchedulerDetailRequest(data));},putScheduler:function putScheduler(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_SchedulerRedux__["b" /* default */].putSchedulerRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(ModularScheduler));

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fauxCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fauxUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fauxDelete; });
var fauxCreate=function fauxCreate(oldArray,newArray){return oldArray.concat(newArray);};var fauxUpdate=function fauxUpdate(oldArray,newArray,uuid){var index=oldArray.findIndex(function(x){return x.id===uuid;});return oldArray.slice(0,index).concat(newArray).concat(oldArray.slice(index+1));};var fauxDelete=function fauxDelete(oldArray,uuid){return oldArray.filter(function(x){return x.id!==uuid;});};

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Containers_Esim_UpdateEsim__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Containers_Esim_EsimCountry__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Containers_Esim_UpdateEsimImage__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_EsimRedux__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Containers_Esim_UpdateVarianEsim__ = __webpack_require__(1261);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Tooltip from 'react-tooltip'
// import PriceComparison from '../../Containers/Markup/PriceComparison'
// import ComparisonDetails from '../../Containers/Markup/ComparisonDetails'
var EsimPage=function(_React$Component){_inherits(EsimPage,_React$Component);function EsimPage(props){_classCallCheck(this,EsimPage);var _this=_possibleConstructorReturn(this,(EsimPage.__proto__||Object.getPrototypeOf(EsimPage)).call(this,props));_this.componentDidMount=function(){_this.props.getAllEsims(_this.state.filter);};_this._fetchEsims=function(event){event.preventDefault();_this.props.getAllEsims(_this.state.filter);};_this._filterChange=function(event,field){var filter=Object.assign({},_this.state.filter);filter[field]=event.target.value;if(field==='order_status'){filter['status']='';}_this.setState({filter:filter});};_this._toggleModal=function(){var modalId=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;if(!modalId)_this.props.getAllEsims(_this.state.filter);_this.setState({showModal:modalId});};_this._selectItem=function(item,action){_this.setState({detail:item});_this._toggleModal(action);};_this._selectItemVariant=function(item,variant,action){_this.setState({detail:item,variant:variant});_this._toggleModal(action);};_this._toggleField=function(item,field,event){var form={image_file:item.image_file,description:item.description,is_featured:item.is_featured,is_active:item.is_active};form[field]=event.target.checked;_this.props.updateEsim({id:item.id,form:form});setTimeout(function(){_this.props.getAllEsims(_this.state.filter);},750);};_this._toggleVariantField=function(item,variant,event){var formData={id:item.id,variant_id:variant.id,form:{availability:event.target.checked}};_this.props.updateEsimVariant(formData);setTimeout(function(){_this.props.getAllEsims(_this.state.filter);},750);};_this._changePage=function(page){var filter=Object.assign({},_this.state.filter,{page:page});_this.setState({filter:filter});_this.props.getAllEsims(filter);};_this.state={showModal:null,detail:{},variant:{},filter:{sort:'title',page:1,q:''}};return _this;}_createClass(EsimPage,[{key:'render',value:function render(){var _this2=this;var esims=this.props.esims;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block d-flex mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'title mr-auto'},'eSIM Product',(esims.fetching||esims.processing)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge badge-info ml-2'},esims.fetching?'Loading':'Processing',' ...'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title-description'},'Filter:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'form-inline',onSubmit:function onSubmit(event){return _this2._fetchEsims(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label mr-2'},'Search'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{width:'250px'},type:'text',placeholder:'Name / Desc',className:'form-control',value:this.state.filter.q,onChange:function onChange(event){return _this2._filterChange(event,'q');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group mr-2 mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Apply Filter'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card'},!(esims.fetching||esims.processing)&&esims.err&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alert alert-danger'},esims.err),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'card-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-hover table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Featured'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Active'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,!esims.data||!esims.data.data?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:'5',className:'text-center'},'- NO DATA -')):esims.data.data.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.image_url,width:100,alt:item.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:item.is_featured,onChange:function onChange(event){return _this2._toggleField(item,"is_featured",event);},disabled:esims.fetching||esims.processing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:item.is_active,onChange:function onChange(event){return _this2._toggleField(item,"is_active",event);},disabled:esims.fetching||esims.processing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'d-flex mb-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'update');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}),' Edit Content'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary mr-2',onClick:function onClick(){return _this2._selectItem(item,'esim-countries');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-globe'}),' Country'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-primary',onClick:function onClick(){return _this2._selectItem(item,'esim-image');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-image'}),' Images')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'table table-bordered table-striped'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Data Size'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Days'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Base Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Availability'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,item.variants?item.variants.length!==0?item.variants.map(function(variant){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:variant.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,variant.data_size),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,variant.day||0,' day'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'IDR ',Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(variant.base_price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'IDR ',Object(__WEBPACK_IMPORTED_MODULE_9__Utils_FormatMoney__["a" /* default */])(variant.price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:variant.availability,onChange:function onChange(event){return _this2._toggleVariantField(item,variant,event);},disabled:esims.fetching||esims.processing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn btn-sm btn-info',onClick:function onClick(){return _this2._selectItemVariant(item,variant,'update-variant');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fa fa-edit'}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:4},'- No Data -')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:3},'- No Data -'))))));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'text-center'},esims.data&&esims.data.total>10&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_js_pagination___default.a,{innerClass:'pagination',itemClass:'page-item',linkClass:'page-link',activePage:esims.data.page||this.state.filter.page,itemsCountPerPage:10,totalItemsCount:esims.data.total,pageRangeDisplayed:5,onChange:this._changePage}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Containers_Esim_UpdateEsim__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},detail:this.state.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='update-variant',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Containers_Esim_UpdateVarianEsim__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},detail:this.state.detail,variant:this.state.variant})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='esim-countries',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Containers_Esim_EsimCountry__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},detail:this.state.detail})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_responsive_modal__["a" /* default */],{classNames:{modal:'modal-large'},open:this.state.showModal==='esim-image',onClose:this._toggleModal,closeOnOverlayClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Containers_Esim_UpdateEsimImage__["a" /* default */],{closeModal:function closeModal(){return _this2._toggleModal();},detail:this.state.detail})));}}]);return EsimPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{esims:state.esims};};var dispatchToProps=function dispatchToProps(dispatch){return{getAllEsims:function getAllEsims(filter){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_EsimRedux__["b" /* default */].getAllEsimsRequest(filter));},updateEsim:function updateEsim(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_EsimRedux__["b" /* default */].esimUpdateRequest(data));},updateEsimVariant:function updateEsimVariant(data){return dispatch(__WEBPACK_IMPORTED_MODULE_8__Redux_EsimRedux__["b" /* default */].esimUpdateVariantRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EsimPage));

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EsimRedux__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateEsim=function(_React$Component){_inherits(UpdateEsim,_React$Component);function UpdateEsim(props){_classCallCheck(this,UpdateEsim);var _this=_possibleConstructorReturn(this,(UpdateEsim.__proto__||Object.getPrototypeOf(UpdateEsim)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._toggleChange=function(event,field){var val=event.target.checked;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{image_file:props.detail.image_file,description:props.detail.description,is_featured:props.detail.is_featured,is_active:props.detail.is_active}};return _this;}_createClass(UpdateEsim,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update eSIM - ',this.props.detail.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Featured')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:this.state.form.is_featured,onChange:function onChange(event){return _this2._toggleChange(event,"is_featured");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Active')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a,{checked:this.state.form.is_active,onChange:function onChange(event){return _this2._toggleChange(event,"is_active");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Description')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'form-control',rows:15,value:this.state.form.description,onChange:function onChange(event){return _this2._inputChange(event,"description");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateEsim;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EsimRedux__["b" /* default */].esimUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateEsim));

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EsimRedux__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EsimCountry=function(_React$Component){_inherits(EsimCountry,_React$Component);function EsimCountry(props){_classCallCheck(this,EsimCountry);var _this=_possibleConstructorReturn(this,(EsimCountry.__proto__||Object.getPrototypeOf(EsimCountry)).call(this,props));_this._selectChange=function(selectedCountry){_this.setState({selectedCountry:selectedCountry});};_this._submit=function(event){event.preventDefault();var form={countries:[]};_this.state.selectedCountry.forEach(function(country){form.countries.push(country.value);});_this.props.submit({id:_this.props.detail.id,form:form});setTimeout(function(){_this.props.closeModal();},250);};var countries=[];props.country_list.map(function(item,i){countries[i]={value:item.id,label:item.name};return countries;});var detailCountry=[];props.detail.countries.forEach(function(country){detailCountry.push({value:country.id,label:country.name});});_this.countries=countries;_this.state={selectedCountry:[].concat(detailCountry)};return _this;}_createClass(EsimCountry,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'50vw',minHeight:'30vh'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Country List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */],{isMulti:true,options:this.countries,value:this.state.selectedCountry,onChange:function onChange(selectedCountry){return _this2._selectChange(selectedCountry);},placeholder:'Select country to assign ...'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Assign')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.props.closeModal();},className:'btn btn-secondary mr-2'},'Close'))));}}]);return EsimCountry;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{country_list:state.preset.dataCountries};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_EsimRedux__["b" /* default */].esimUpdateCountryRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(EsimCountry));

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileUploader__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateEsimImage=function(_React$Component){_inherits(UpdateEsimImage,_React$Component);function UpdateEsimImage(props){_classCallCheck(this,UpdateEsimImage);var _this=_possibleConstructorReturn(this,(UpdateEsimImage.__proto__||Object.getPrototypeOf(UpdateEsimImage)).call(this,props));_this.componentDidMount=function(){_this.props.resetFile();};_this.componentWillReceiveProps=function(newProps){if(newProps.files.data){var form=Object.assign({},_this.state.form);form.image_file=newProps.files.data.upload[0].filename;_this.setState({form:form});}};_this._fileSelect=function(event){var file=event.target;_this.setState({file:file});};_this._upload=function(event){event.preventDefault();var data=new FormData();data.append('files',_this.state.file.files[0]);data.append('type','product');data.append('product_type',_this.state.form.product_type);_this.props.upload(data);_this.setState({uploaded:true});};_this._fileUploaded=function(filename,field){var form=Object.assign({},_this.state.form);form[field]=filename;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var form=Object.assign({},_this.state.form);var data={id:_this.props.detail.id,form:form};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{image_file:'',product_type:'esim'},country:'',file:null,uploaded:false};return _this;}_createClass(UpdateEsimImage,[{key:'render',value:function render(){var _this2=this;// const { files } = this.props
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Edit eSIM Image')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Current Image'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:this.props.detail.image_file,title:this.props.detail.image_file,className:'img img-responsive img-border',style:{maxWidth:'100%'},src:this.props.detail.image_url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'image',className:'control-label'},'Image File (',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-orange'},'270x160'),')')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FileUploader__["a" /* default */],{setting:{type:'esim',product_type:this.state.form.product_type},onUploaded:function onUploaded(filename){return _this2._fileUploaded(filename,'image_file');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',disabled:!this.state.form.image_file,className:'btn btn-primary'},'Save')))));}}]);return UpdateEsimImage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{files:state.files};};var dispatchToProps=function dispatchToProps(dispatch){return{upload:function upload(data){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadRequest(data));},resetFile:function resetFile(){return dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_FilesRedux__["b" /* default */].filesUploadReset());},submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateEsimImage));

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__ = __webpack_require__(111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UpdateVarianEsim=function(_React$Component){_inherits(UpdateVarianEsim,_React$Component);function UpdateVarianEsim(props){_classCallCheck(this,UpdateVarianEsim);var _this=_possibleConstructorReturn(this,(UpdateVarianEsim.__proto__||Object.getPrototypeOf(UpdateVarianEsim)).call(this,props));_this._inputChange=function(event,field){var val=event.target.value;var form=Object.assign({},_this.state.form);form[field]=val;_this.setState({form:form});};_this._submit=function(event){event.preventDefault();var data={id:_this.props.detail.id,variant_id:_this.props.variant.id,form:{price:_this.state.form.price}};_this.props.submit(data);setTimeout(function(){_this.props.closeModal();},250);};_this.state={form:{price:props.variant.price||0}};return _this;}_createClass(UpdateVarianEsim,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'section',style:{width:'40vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title mr-auto'},'Update Varian - ',this.props.variant.data_size,'/',this.props.variant.day,' day')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(event){return _this2._submit(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Base Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',value:this.props.variant.base_price,disabled:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'form-group row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'control-label'},'Price')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-9'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'form-control',value:this.state.form.price,onChange:function onChange(event){return _this2._inputChange(event,"price");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-12 text-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',className:'btn btn-secondary mr-2',onClick:function onClick(){return _this2.props.closeModal();}},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit',className:'btn btn-primary'},'Save')))));}}]);return UpdateVarianEsim;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var stateToProps=function stateToProps(state){return{esims:state.esims};};var dispatchToProps=function dispatchToProps(dispatch){return{submit:function submit(data){return dispatch(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateVariantRequest(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(stateToProps,dispatchToProps)(UpdateVarianEsim));

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PopularAttractionRedux__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CouponProviderRedux__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EventsRedux__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MarkupRedux__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ExchangeRateRedux__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TransferHistoryRedux__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ReviewRedux__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__DbRedux__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__LocationRedux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__EcommerceOrderRedux__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FailedTransactionRedux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__CronReportRedux__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__PromoSectionRedux__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__EsimRedux__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__store__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Sagas___ = __webpack_require__(1278);
/* harmony default export */ __webpack_exports__["a"] = (function(initialState,options){/* ------------- Assemble The Reducers ------------- */var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({auth:__WEBPACK_IMPORTED_MODULE_1__AuthRedux__["c" /* reducer */],files:__WEBPACK_IMPORTED_MODULE_2__FilesRedux__["c" /* reducer */],destination:__WEBPACK_IMPORTED_MODULE_3__DestinationRedux__["c" /* reducer */],attraction:__WEBPACK_IMPORTED_MODULE_4__AttractionRedux__["c" /* reducer */],popularAttraction:__WEBPACK_IMPORTED_MODULE_6__PopularAttractionRedux__["c" /* reducer */],preset:__WEBPACK_IMPORTED_MODULE_5__PresetRedux__["c" /* reducer */],coupon:__WEBPACK_IMPORTED_MODULE_7__CouponRedux__["c" /* reducer */],couponProvider:__WEBPACK_IMPORTED_MODULE_8__CouponProviderRedux__["c" /* reducer */],couponPreset:__WEBPACK_IMPORTED_MODULE_9__CouponPresetRedux__["c" /* reducer */],product:__WEBPACK_IMPORTED_MODULE_10__ProductRedux__["c" /* reducer */],banner:__WEBPACK_IMPORTED_MODULE_13__BannerRedux__["c" /* reducer */],markup:__WEBPACK_IMPORTED_MODULE_14__MarkupRedux__["c" /* reducer */],exchangeRate:__WEBPACK_IMPORTED_MODULE_15__ExchangeRateRedux__["c" /* reducer */],user:__WEBPACK_IMPORTED_MODULE_16__UserRedux__["c" /* reducer */],order:__WEBPACK_IMPORTED_MODULE_17__OrderRedux__["c" /* reducer */],transfer_history:__WEBPACK_IMPORTED_MODULE_18__TransferHistoryRedux__["c" /* reducer */],review:__WEBPACK_IMPORTED_MODULE_19__ReviewRedux__["c" /* reducer */],database:__WEBPACK_IMPORTED_MODULE_20__DbRedux__["c" /* reducer */],category:__WEBPACK_IMPORTED_MODULE_21__CategoryRedux__["c" /* reducer */],size:__WEBPACK_IMPORTED_MODULE_22__SizeRedux__["c" /* reducer */],colour:__WEBPACK_IMPORTED_MODULE_23__ColourRedux__["c" /* reducer */],brand:__WEBPACK_IMPORTED_MODULE_24__BrandRedux__["c" /* reducer */],warehouse:__WEBPACK_IMPORTED_MODULE_25__WarehouseRedux__["c" /* reducer */],inventory:__WEBPACK_IMPORTED_MODULE_26__InventoryRedux__["c" /* reducer */],supplier:__WEBPACK_IMPORTED_MODULE_27__SupplierRedux__["c" /* reducer */],location:__WEBPACK_IMPORTED_MODULE_28__LocationRedux__["c" /* reducer */],ecommerceProduct:__WEBPACK_IMPORTED_MODULE_29__EcommerceProductRedux__["c" /* reducer */],ecommerceOrder:__WEBPACK_IMPORTED_MODULE_30__EcommerceOrderRedux__["c" /* reducer */],events:__WEBPACK_IMPORTED_MODULE_11__EventsRedux__["c" /* reducer */],insurance:__WEBPACK_IMPORTED_MODULE_12__InsuranceRedux__["c" /* reducer */],section:__WEBPACK_IMPORTED_MODULE_31__SectionRedux__["c" /* reducer */],attractionPromo:__WEBPACK_IMPORTED_MODULE_32__AttractionPromoRedux__["c" /* reducer */],failedTransaction:__WEBPACK_IMPORTED_MODULE_33__FailedTransactionRedux__["c" /* reducer */],scheduler:__WEBPACK_IMPORTED_MODULE_34__SchedulerRedux__["c" /* reducer */],cronReport:__WEBPACK_IMPORTED_MODULE_35__CronReportRedux__["c" /* reducer */],promoSection:__WEBPACK_IMPORTED_MODULE_36__PromoSectionRedux__["c" /* reducer */],esims:__WEBPACK_IMPORTED_MODULE_37__EsimRedux__["c" /* reducer */]});return Object(__WEBPACK_IMPORTED_MODULE_38__store__["a" /* default */])(rootReducer,__WEBPACK_IMPORTED_MODULE_39__Sagas___["a" /* default */],initialState);});

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Config_ReduxPersist__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Config_AppConfig__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Services_RehydrationService__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_seamless_immutable__);
// the logger master switch
// const USE_LOGGING =  AppConfig.DEBUG
var USE_LOGGING=__WEBPACK_IMPORTED_MODULE_6__Config_AppConfig__["a" /* default */].NODE_ENV==='development';// silence these saga-based messages
var SAGA_LOGGING_BLACKLIST=['EFFECT_TRIGGERED','EFFECT_RESOLVED','EFFECT_REJECTED','persist/REHYDRATE'];// create the logger
var logger=Object(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])({predicate:function predicate(getState,_ref){var type=_ref.type;return USE_LOGGING&&Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["not"])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["contains"])(type,SAGA_LOGGING_BLACKLIST));}});var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["b" /* default */])();var enhancers=[];var middleware=[];/* harmony default export */ __webpack_exports__["a"] = (function(rootReducer,rootSaga,initialState){// create the saga middleware
middleware.push(sagaMiddleware);if(USE_LOGGING){middleware.push(logger);}// add our normal middleware to the list
enhancers.push(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */].apply(undefined,middleware));if(__WEBPACK_IMPORTED_MODULE_5__Config_ReduxPersist__["a" /* default */].active){enhancers.push(Object(__WEBPACK_IMPORTED_MODULE_4_redux_persist__["a" /* autoRehydrate */])());}// a function which can create our store and auto-persist the data
// if (!store) {
var store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(rootReducer,__WEBPACK_IMPORTED_MODULE_8_seamless_immutable___default()(initialState),__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */].apply(undefined,enhancers));// }
if(__WEBPACK_IMPORTED_MODULE_5__Config_ReduxPersist__["a" /* default */].active){__WEBPACK_IMPORTED_MODULE_7__Services_RehydrationService__["a" /* default */].updateReducers(store);}// kick off the root saga
sagaMiddleware.run(rootSaga);return store;});

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(450);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(141);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(141);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(61);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(61);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(142);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(451);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoRehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__ = __webpack_require__(1271);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(inboundState[key]) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isStatePlainEnough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(224);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(a)) return false;
  return true;
}

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (createTransform);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getStoredState__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistor__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__ = __webpack_require__(456);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistor__["a" /* default */])(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__getStoredState__["a" /* default */])(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return _extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* REHYDRATE */],
    payload: payload,
    error: error
  };
}

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_seamless_immutable__);
// is this object already Immutable?
var isImmutable=__WEBPACK_IMPORTED_MODULE_0_ramda___default.a.has('asMutable');// change this Immutable object into a JS object
var convertToJs=function convertToJs(state){return state.asMutable({deep:true});};// optionally convert this object into a JS object if it is Immutable
var fromImmutable=__WEBPACK_IMPORTED_MODULE_0_ramda___default.a.when(isImmutable,convertToJs);// convert this JS object into an Immutable object
var toImmutable=function toImmutable(raw){return __WEBPACK_IMPORTED_MODULE_1_seamless_immutable___default()(raw);};// the transform interface that redux-persist is expecting
/* harmony default export */ __webpack_exports__["a"] = ({out:function out(state){// console.log({ retrieving: state })
// --- HACKZORZ ---
// Attach a empty-ass function to the object called `mergeDeep`.
// This tricks redux-persist into just placing our Immutable object into the state tree
// instead of trying to convert it to a POJO
// https://github.com/rt2zz/redux-persist/blob/master/src/autoRehydrate.js#L55
//
// Another equal terrifying option would be to try to pass their other check
// which is lodash isPlainObject.
// --- END HACKZORZ ---
state.mergeDeep=__WEBPACK_IMPORTED_MODULE_0_ramda___default.a.identity;return toImmutable(state);},in:function _in(raw){// console.log({ storing: raw })
return fromImmutable(raw);}});

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Config_ReduxPersist__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_StartupRedux__ = __webpack_require__(1277);
var updateReducers=function updateReducers(store,isServer){var reducerVersion=__WEBPACK_IMPORTED_MODULE_0__Config_ReduxPersist__["a" /* default */].reducerVersion;var config=__WEBPACK_IMPORTED_MODULE_0__Config_ReduxPersist__["a" /* default */].storeConfig;var startup=function startup(){return store.dispatch(__WEBPACK_IMPORTED_MODULE_3__Redux_StartupRedux__["a" /* default */].startup());};// Check to ensure latest reducer version
__WEBPACK_IMPORTED_MODULE_1_localforage___default.a.getItem('reducerVersion').then(function(localVersion){if(localVersion!==reducerVersion){// Purge store
Object(__WEBPACK_IMPORTED_MODULE_2_redux_persist__["b" /* persistStore */])(store,config,startup).purge();__WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem('reducerVersion',reducerVersion);}else{Object(__WEBPACK_IMPORTED_MODULE_2_redux_persist__["b" /* persistStore */])(store,config,startup);}}).catch(function(err){if(err.message!=='No available storage method found.'){Object(__WEBPACK_IMPORTED_MODULE_2_redux_persist__["b" /* persistStore */])(store,config,startup);__WEBPACK_IMPORTED_MODULE_1_localforage___default.a.setItem('reducerVersion',reducerVersion);}});};/* harmony default export */ __webpack_exports__["a"] = ({updateReducers:updateReducers});

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StartupTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reduxsauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__);
/* ------------- Types and Action Creators ------------- */var _createActions=Object(__WEBPACK_IMPORTED_MODULE_0_reduxsauce__["createActions"])({startup:null}),Types=_createActions.Types,Creators=_createActions.Creators;var StartupTypes=Types;/* harmony default export */ __webpack_exports__["a"] = (Creators);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthSagas__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DestinationSagas__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttractionSagas__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PresetSagas__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FilesSagas__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PopularAttractionSagas__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CouponSagas__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CouponProviderSagas__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CouponPresetSagas__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductSagas__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EventsSagas__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__BannerSagas__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MarkupSagas__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ExchangeRateSagas__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__UserSagas__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__OrderSagas__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReviewSagas__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DbSagas__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CategorySagas__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SizeSagas__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ColourSagas__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__BrandSagas__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__WarehouseSagas__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__InventorySagas__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SupplierSagas__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__LocationSagas__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__SectionSagas__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FailedTransactionSagas__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__CronReportSagas__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__PromoSectionSagas__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__EsimSagas__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Services_Api__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Services_GetToken__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Redux_PopularAttractionRedux__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Redux_CouponProviderRedux__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Redux_CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Redux_ExchangeRateRedux__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Redux_ReviewRedux__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Redux_DbRedux__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Redux_WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Redux_LocationRedux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Redux_FailedTransactionRedux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Redux_PromoSectionRedux__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Redux_EsimRedux__ = __webpack_require__(111);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);// sagas
// client sagas
// api
// Redux
/* ------------- API ------------- */// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
var api=__WEBPACK_IMPORTED_MODULE_39__Services_Api__["a" /* default */].create();var token=__WEBPACK_IMPORTED_MODULE_40__Services_GetToken__["a" /* getToken */];// register all sagas here
function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__AuthSagas__["b" /* login */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__AuthSagas__["a" /* checkLogin */],api,token),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_41__Redux_AuthRedux__["a" /* AuthTypes */].AUTH_LOGOUT,__WEBPACK_IMPORTED_MODULE_2__AuthSagas__["c" /* logout */]),// PRESET NO TOKEN
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["c" /* getCurrencies */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["d" /* getLanguages */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["b" /* getCountries */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["e" /* getPresetOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].PRESET_ORDER_REQUEST,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["e" /* getPresetOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].PRESET_ORDER_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["h" /* updatePresetOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].PRESET_ORDER_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["e" /* getPresetOrder */],api),// PRESET-BRANCH
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].GET_BRANCH_REQUEST,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["a" /* getBranch */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].UPDATE_BRANCH_REQUEST,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["g" /* updateBranch */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].UPDATE_BRANCH_SUCCESS,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["a" /* getBranch */],api),// PRESET-SHIPPING
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].GET_SHIPPING,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["f" /* getShipping */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].UPDATE_SHIPPING,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["i" /* updateShipping */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_43__Redux_PresetRedux__["a" /* PresetTypes */].UPDATE_SHIPPING_SUCCESS,__WEBPACK_IMPORTED_MODULE_5__PresetSagas__["f" /* getShipping */],api),// DESTINATION
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["h" /* getDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["c" /* createDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["e" /* deleteDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["i" /* updateDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].CONTINENT_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["g" /* getContinent */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_CREATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["h" /* getDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["h" /* getDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DESTINATION_DELETE_SUCCESS,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["h" /* getDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].ADD_ATTRACTION_TO_DESTINATION_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["a" /* addAttractionToDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].ADD_ATTRACTION_TO_DESTINATION_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["c" /* getAttractionByDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DELETE_ATTRACTION_FROM_DESTINATION_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["d" /* deleteAttractionFromDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DELETE_ATTRACTION_FROM_DESTINATION_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["c" /* getAttractionByDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].ADD_PLACE_TO_DESTINATION_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["b" /* addPlaceToDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].ADD_PLACE_TO_DESTINATION_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["f" /* getPlacesByDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DELETE_PLACE_FROM_DESTINATION_REQUEST,__WEBPACK_IMPORTED_MODULE_3__DestinationSagas__["f" /* deletePlaceFromDestination */],api),// the side effect upon deletion below is removed to prevent forceful reload
// takeLatest(DestinationTypes.DELETE_PLACE_FROM_DESTINATION_SUCCESS, attractionSagas.getPlacesByDestination, api),
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_42__Redux_DestinationRedux__["a" /* DestinationTypes */].DELETE_PLACE_FROM_DESTINATION_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["a" /* attractionClearCache */],api),// ATTRACTION
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["c" /* getAttractionByDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].PLACE_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["f" /* getPlacesByDestination */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].GET_PLACES_V2_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["g" /* getPlacesV2 */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_DETAIL_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["d" /* getAttractionDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].PLACE_DETAIL_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["e" /* getPlaceDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["j" /* updateAttractionDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["a" /* attractionClearCache */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_SEARCH_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["h" /* searchAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].PLACE_SEARCH_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["i" /* searchPlace */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].ATTRACTION_CLEAR_CACHE_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["a" /* attractionClearCache */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_45__Redux_AttractionRedux__["a" /* AttractionTypes */].DOWNLOAD_ATTRACTION_DATA_REQUEST,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["b" /* downloadAttractionData */],api),// POPULAR ATTRACTION
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_46__Redux_PopularAttractionRedux__["a" /* PopularAttractionTypes */].POPULAR_ATTRACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_7__PopularAttractionSagas__["c" /* getPopularAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_46__Redux_PopularAttractionRedux__["a" /* PopularAttractionTypes */].POPULAR_ATTRACTION_SAVE_REQUEST,__WEBPACK_IMPORTED_MODULE_7__PopularAttractionSagas__["d" /* savePopularAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_46__Redux_PopularAttractionRedux__["a" /* PopularAttractionTypes */].POPULAR_ATTRACTION_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_7__PopularAttractionSagas__["a" /* deletePopularAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_46__Redux_PopularAttractionRedux__["a" /* PopularAttractionTypes */].POPULAR_ATTRACTION_EDIT_REQUEST,__WEBPACK_IMPORTED_MODULE_7__PopularAttractionSagas__["b" /* editPopularAttraction */],api),// COUPON
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["j" /* getAllCoupon */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["c" /* createNewCoupon */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["r" /* updateCoupon */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].BUSINESS_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["q" /* updateBusiness */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["e" /* deleteCoupon */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].BUSINESS_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["d" /* deleteBusiness */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_TAG_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["k" /* getAllCouponTag */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_GENERATE_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["h" /* generateCoupon */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_SPREADSHEET_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["b" /* couponSpreadsheet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].COUPON_DETAIL_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["l" /* getCouponDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].HISTORY_SPREADSHEET_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["n" /* historySpreadsheet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].GET_COUPON_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["m" /* getCouponItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].POST_COUPON_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["o" /* postCouponItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].POST_COUPON_ITEM_TAG_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["p" /* postCouponItemTag */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].DELETE_COUPON_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["f" /* deleteCouponItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].DELETE_COUPON_ITEM_TAG_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["g" /* deleteCouponItemTag */],api),// COUPON PROVIDER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_48__Redux_CouponProviderRedux__["a" /* CouponProviderTypes */].GET_COUPON_PROVIDER_REQUEST,__WEBPACK_IMPORTED_MODULE_9__CouponProviderSagas__["b" /* getCouponProvider */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_48__Redux_CouponProviderRedux__["a" /* CouponProviderTypes */].POST_COUPON_PROVIDER_REQUEST,__WEBPACK_IMPORTED_MODULE_9__CouponProviderSagas__["c" /* postCouponProvider */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_48__Redux_CouponProviderRedux__["a" /* CouponProviderTypes */].PUT_COUPON_PROVIDER_REQUEST,__WEBPACK_IMPORTED_MODULE_9__CouponProviderSagas__["d" /* putCouponProvider */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_48__Redux_CouponProviderRedux__["a" /* CouponProviderTypes */].DELETE_COUPON_PROVIDER_REQUEST,__WEBPACK_IMPORTED_MODULE_9__CouponProviderSagas__["a" /* deleteCouponProvider */],api),// COUPON PRESET
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_49__Redux_CouponPresetRedux__["a" /* CouponPresetTypes */].GET_COUPON_PRESET_REQUEST,__WEBPACK_IMPORTED_MODULE_10__CouponPresetSagas__["b" /* getCouponPreset */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_49__Redux_CouponPresetRedux__["a" /* CouponPresetTypes */].POST_COUPON_PRESET_REQUEST,__WEBPACK_IMPORTED_MODULE_10__CouponPresetSagas__["c" /* postCouponPreset */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_49__Redux_CouponPresetRedux__["a" /* CouponPresetTypes */].PUT_COUPON_PRESET_REQUEST,__WEBPACK_IMPORTED_MODULE_10__CouponPresetSagas__["d" /* putCouponPreset */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_49__Redux_CouponPresetRedux__["a" /* CouponPresetTypes */].DELETE_COUPON_PRESET_REQUEST,__WEBPACK_IMPORTED_MODULE_10__CouponPresetSagas__["a" /* deleteCouponPreset */],api),// COUPON AFFILIATES (PISCES)
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].GET_AFFILIATES_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["i" /* getAffiliates */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_47__Redux_CouponRedux__["a" /* CouponTypes */].AFFILIATE_TRANSFER_REQUEST,__WEBPACK_IMPORTED_MODULE_8__CouponSagas__["a" /* affiliateTransfer */],api),// PRODUCT
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["g" /* getProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PRODUCT_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["a" /* createProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PRODUCT_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["b" /* deleteProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PRODUCT_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["s" /* updateProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].GET_PRODUCT_COUNTRY_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["i" /* getProductCountry */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_COUNTRY_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["n" /* postProductCountry */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_COUNTRY_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["d" /* deleteProductCountry */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].GET_PRODUCT_CAMPAIGN_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["h" /* getProductCampaign */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_CAMPAIGN_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["m" /* postProductCampaign */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PUT_PRODUCT_CAMPAIGN_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["q" /* putProductCampaign */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_CAMPAIGN_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["c" /* deleteProductCampaign */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].GET_PRODUCT_VARIANT_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["k" /* getProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_VARIANT_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["o" /* postProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_VARIANT_SUCCESS,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["k" /* getProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PUT_PRODUCT_VARIANT_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["r" /* putProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].PUT_PRODUCT_VARIANT_SUCCESS,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["k" /* getProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_VARIANT_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["e" /* deleteProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_VARIANT_SUCCESS,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["k" /* getProductVariant */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].GET_PRODUCT_VARIANT_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["l" /* getProductVariantItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_VARIANT_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["p" /* postProductVariantItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].POST_PRODUCT_VARIANT_ITEM_SUCCESS,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["l" /* getProductVariantItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_VARIANT_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["f" /* deleteProductVariantItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].DELETE_PRODUCT_VARIANT_ITEM_SUCCESS,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["l" /* getProductVariantItem */],api),// E-SIM
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_77__Redux_EsimRedux__["a" /* EsimsTypes */].GET_ALL_ESIMS_REQUEST,__WEBPACK_IMPORTED_MODULE_38__EsimSagas__["a" /* getAllEsims */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_77__Redux_EsimRedux__["a" /* EsimsTypes */].ESIM_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_38__EsimSagas__["c" /* updateEsimData */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_77__Redux_EsimRedux__["a" /* EsimsTypes */].ESIM_UPDATE_COUNTRY_REQUEST,__WEBPACK_IMPORTED_MODULE_38__EsimSagas__["b" /* updateEsimCountry */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_77__Redux_EsimRedux__["a" /* EsimsTypes */].ESIM_UPDATE_VARIANT_REQUEST,__WEBPACK_IMPORTED_MODULE_38__EsimSagas__["d" /* updateEsimVarian */],api),// EVENTS
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].GET_ALL_EVENTS_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["a" /* getAllEvents */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].GET_EVENTS_CATEGORIES_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["c" /* getEventsCategories */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].GET_ALL_POPULAR_EVENTS_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["b" /* getAllPopularEvents */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].SET_POPULAR_EVENT_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["e" /* setPopularEvent */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].RESET_EVENT_DESCRIPTION_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["d" /* resetEventDescription */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].RESET_EVENT_DESCRIPTION_SUCCESS,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["a" /* getAllEvents */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].UPDATE_EVENT_DESCRIPTION_REQUEST,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["f" /* updateEventDescription */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_51__Redux_EventsRedux__["a" /* EventsTypes */].UPDATE_EVENT_DESCRIPTION_SUCCESS,__WEBPACK_IMPORTED_MODULE_12__EventsSagas__["a" /* getAllEvents */],api),// INSURANCE: TRAVEL PACKAGE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].GET_TRAVEL_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["d" /* getTravelPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].POST_TRAVEL_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["f" /* postTravelPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].PUT_TRAVEL_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["i" /* putTravelPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].DELETE_TRAVEL_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["b" /* deleteTravelPackage */],api),// INSURANCE: TRAVEL PACKAGE PRICE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].VIEW_TRAVEL_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["l" /* viewTravelPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].POST_TRAVEL_PACKAGE_PRICE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["g" /* postTravelPackagePrice */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].PUT_TRAVEL_PACKAGE_PRICE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["j" /* putTravelPackagePrice */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].SWITCH_TRAVEL_PACKAGE_PRICE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["k" /* switchTravelPackagePrice */],api),// INSURANCE: TICKET
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].GET_TICKET_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["c" /* getTicketPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].POST_TICKET_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["e" /* postTicketPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].PUT_TICKET_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["h" /* putTicketPackage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_52__Redux_InsuranceRedux__["a" /* InsuranceTypes */].DELETE_TICKET_PACKAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_13__InsuranceSagas__["a" /* deleteTicketPackage */],api),// BANNER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__["a" /* BannerTypes */].BANNER_REQUEST,__WEBPACK_IMPORTED_MODULE_14__BannerSagas__["d" /* getBanners */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__["a" /* BannerTypes */].BANNER_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_14__BannerSagas__["a" /* createBanner */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__["a" /* BannerTypes */].BANNER_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_14__BannerSagas__["b" /* deleteBanner */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__["a" /* BannerTypes */].BANNER_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_14__BannerSagas__["e" /* updateBanner */],api),// MARKUP
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["c" /* getMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["a" /* createMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_CREATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["c" /* getMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["h" /* updateMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["c" /* getMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["b" /* deleteMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_DELETE_SUCCESS,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["c" /* getMarkup */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_ITEM_GET_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["f" /* markupItemGet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_ITEM_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["d" /* markupItemCreate */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_ITEM_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["g" /* markupItemUpdate */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_54__Redux_MarkupRedux__["a" /* MarkupTypes */].MARKUP_ITEM_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_15__MarkupSagas__["e" /* markupItemDelete */],api),// EXCHANGE RATE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_55__Redux_ExchangeRateRedux__["a" /* ExchangeRateTypes */].EXCHANGE_RATE_REQUEST,__WEBPACK_IMPORTED_MODULE_16__ExchangeRateSagas__["a" /* getExchangeRate */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_55__Redux_ExchangeRateRedux__["a" /* ExchangeRateTypes */].EXCHANGE_RATE_SINGLE_REQUEST,__WEBPACK_IMPORTED_MODULE_16__ExchangeRateSagas__["b" /* getSingleExchangeRate */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_55__Redux_ExchangeRateRedux__["a" /* ExchangeRateTypes */].EXCHANGE_RATE_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_16__ExchangeRateSagas__["c" /* updateExchangeRate */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_55__Redux_ExchangeRateRedux__["a" /* ExchangeRateTypes */].EXCHANGE_RATE_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_16__ExchangeRateSagas__["a" /* getExchangeRate */],api),// USER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["d" /* getUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_COUNT_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["e" /* getUserCount */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_CREATE_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["a" /* createUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_CREATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["d" /* getUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["f" /* updateUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["d" /* getUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_DELETE_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["b" /* deleteUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_DELETE_SUCCESS,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["d" /* getUser */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_56__Redux_UserRedux__["a" /* UserTypes */].USER_LIST_REQUEST,__WEBPACK_IMPORTED_MODULE_17__UserSagas__["c" /* downloadUserList */],api),// ORDER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["d" /* getOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_SINGLE_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["h" /* getOrderSingle */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_DETAIL_LIST_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["e" /* getOrderDetailList */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_CONFIRM_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["a" /* confirmOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_CONFIRM_SUCCESS,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["d" /* getOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["o" /* updateOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_CHECKOUT_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["n" /* updateCheckoutOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["d" /* getOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_UPDATE_AMOUNT_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["p" /* updateOrderAmount */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_UPDATE_AMOUNT_SUCCESS,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["d" /* getOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_LIST_DOWNLOAD_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["j" /* orderListSpreadsheet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_DETAIL_LIST_DOWNLOAD_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["i" /* orderDetailListSpreadsheet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].ORDER_INVOICE_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["b" /* downloadOrderInvoice */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].RESEND_ORDER_VOUCHER_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["m" /* resendOrderVoucher */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].GET_ORDER_REPORT_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["f" /* getOrderReport */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].GET_ORDER_REPORT_SPREADSHEET_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["g" /* getOrderReportSpreadsheet */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].REFUND_DANA_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["l" /* refundDana */],api),// ORDER (CHATBOT)
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].GET_CHATBOT_ORDER_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["c" /* getChatbotOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_57__Redux_OrderRedux__["a" /* OrderTypes */].POST_CHATBOT_ORDER_REQUEST,__WEBPACK_IMPORTED_MODULE_18__OrderSagas__["k" /* postChatbotOrder */],api),// TRANSFER HISTORY
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__["a" /* TransferHistoryTypes */].TRANSFER_HISTORY_REQUEST,__WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__["a" /* getTransferHistory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__["a" /* TransferHistoryTypes */].TRANSFER_HISTORY_MATCHES_REQUEST,__WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__["b" /* getTransferHistoryMatches */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__["a" /* TransferHistoryTypes */].TRANSFER_HISTORY_UPDATE_REQUEST,__WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__["d" /* updateTransferHistory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__["a" /* TransferHistoryTypes */].TRANSFER_HISTORY_UPDATE_SUCCESS,__WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__["a" /* getTransferHistory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_58__Redux_TransferHistoryRedux__["a" /* TransferHistoryTypes */].TRANSFER_HISTORY_LIST_DOWNLOAD_REQUEST,__WEBPACK_IMPORTED_MODULE_19__TransferHistorySagas__["c" /* transferHistoryListSpreadsheet */],api),// FILES
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_44__Redux_FilesRedux__["a" /* FilesTypes */].FILES_UPLOAD_REQUEST,__WEBPACK_IMPORTED_MODULE_6__FilesSagas__["a" /* uploadFiles */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_44__Redux_FilesRedux__["a" /* FilesTypes */].FILES_UPLOAD_SUCCESS,__WEBPACK_IMPORTED_MODULE_4__AttractionSagas__["a" /* attractionClearCache */],api),// REVIEW
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_59__Redux_ReviewRedux__["a" /* ReviewTypes */].REVIEW_LIST_REQUEST,__WEBPACK_IMPORTED_MODULE_20__ReviewSagas__["b" /* getReviews */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_59__Redux_ReviewRedux__["a" /* ReviewTypes */].REVIEW_APPROVE_REQUEST,__WEBPACK_IMPORTED_MODULE_20__ReviewSagas__["a" /* approveReview */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_59__Redux_ReviewRedux__["a" /* ReviewTypes */].REVIEW_APPROVE_SUCCESS,__WEBPACK_IMPORTED_MODULE_20__ReviewSagas__["b" /* getReviews */],api),// DATABASE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_60__Redux_DbRedux__["a" /* DbTypes */].DB_DUMP_REQUEST,__WEBPACK_IMPORTED_MODULE_21__DbSagas__["a" /* dbDump */],api),// ECOMMERCE-MANAGE-CATEGORY
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_61__Redux_CategoryRedux__["a" /* CategoryTypes */].GET_CATEGORY_REQUEST,__WEBPACK_IMPORTED_MODULE_22__CategorySagas__["b" /* getCategory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_61__Redux_CategoryRedux__["a" /* CategoryTypes */].GET_SINGLE_CATEGORY_REQUEST,__WEBPACK_IMPORTED_MODULE_22__CategorySagas__["c" /* getSingleCategory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_61__Redux_CategoryRedux__["a" /* CategoryTypes */].CREATE_CATEGORY_REQUEST,__WEBPACK_IMPORTED_MODULE_22__CategorySagas__["a" /* createCategory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_61__Redux_CategoryRedux__["a" /* CategoryTypes */].UPDATE_CATEGORY_REQUEST,__WEBPACK_IMPORTED_MODULE_22__CategorySagas__["d" /* updateCategory */],api),// ECOMMERCE-MANAGE-VARIANT-SIZE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__["a" /* SizeTypes */].GET_SIZE_REQUEST,__WEBPACK_IMPORTED_MODULE_23__SizeSagas__["d" /* getSize */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__["a" /* SizeTypes */].GET_ALL_SIZE_REQUEST,__WEBPACK_IMPORTED_MODULE_23__SizeSagas__["c" /* getAllSize */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__["a" /* SizeTypes */].CREATE_SIZE_REQUEST,__WEBPACK_IMPORTED_MODULE_23__SizeSagas__["a" /* createSize */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__["a" /* SizeTypes */].UPDATE_SIZE_REQUEST,__WEBPACK_IMPORTED_MODULE_23__SizeSagas__["e" /* updateSize */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_62__Redux_SizeRedux__["a" /* SizeTypes */].DELETE_SIZE_REQUEST,__WEBPACK_IMPORTED_MODULE_23__SizeSagas__["b" /* deleteSize */],api),// ECOMMERCE-MANAGE-VARIANT-COLOUR
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__["a" /* ColourTypes */].GET_COLOUR_REQUEST,__WEBPACK_IMPORTED_MODULE_24__ColourSagas__["d" /* getColour */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__["a" /* ColourTypes */].GET_ALL_COLOUR_REQUEST,__WEBPACK_IMPORTED_MODULE_24__ColourSagas__["c" /* getAllColour */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__["a" /* ColourTypes */].CREATE_COLOUR_REQUEST,__WEBPACK_IMPORTED_MODULE_24__ColourSagas__["a" /* createColour */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__["a" /* ColourTypes */].UPDATE_COLOUR_REQUEST,__WEBPACK_IMPORTED_MODULE_24__ColourSagas__["e" /* updateColour */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_63__Redux_ColourRedux__["a" /* ColourTypes */].DELETE_COLOUR_REQUEST,__WEBPACK_IMPORTED_MODULE_24__ColourSagas__["b" /* deleteColour */],api),// ECOMMERCE-MANAGE-BRAND
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].GET_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["e" /* getBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].CREATE_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["a" /* createBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].UPDATE_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["g" /* updateBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].DELETE_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["c" /* deleteBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].GET_SINGLE_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["f" /* getSingleBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].CREATE_CATEGORY_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["b" /* createCategoryBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].UPDATE_CATEGORY_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["h" /* updateCategoryBrand */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_64__Redux_BrandRedux__["a" /* BrandTypes */].DELETE_CATEGORY_BRAND_REQUEST,__WEBPACK_IMPORTED_MODULE_25__BrandSagas__["d" /* deleteCategoryBrand */],api),// ECOMMERCE-MANAGE-WAREHOUSE
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_65__Redux_WarehouseRedux__["a" /* WarehouseTypes */].GET_WAREHOUSE_REQUEST,__WEBPACK_IMPORTED_MODULE_26__WarehouseSagas__["c" /* getWarehouse */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_65__Redux_WarehouseRedux__["a" /* WarehouseTypes */].CREATE_WAREHOUSE_REQUEST,__WEBPACK_IMPORTED_MODULE_26__WarehouseSagas__["a" /* createWarehouse */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_65__Redux_WarehouseRedux__["a" /* WarehouseTypes */].UPDATE_WAREHOUSE_REQUEST,__WEBPACK_IMPORTED_MODULE_26__WarehouseSagas__["d" /* updateWarehouse */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_65__Redux_WarehouseRedux__["a" /* WarehouseTypes */].DELETE_WAREHOUSE_REQUEST,__WEBPACK_IMPORTED_MODULE_26__WarehouseSagas__["b" /* deleteWarehouse */],api),// ECOMMERCE-MANAGE-SUPPLIER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_66__Redux_SupplierRedux__["a" /* SupplierTypes */].GET_SUPPLIER_REQUEST,__WEBPACK_IMPORTED_MODULE_28__SupplierSagas__["c" /* getSupplier */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_66__Redux_SupplierRedux__["a" /* SupplierTypes */].CREATE_SUPPLIER_REQUEST,__WEBPACK_IMPORTED_MODULE_28__SupplierSagas__["a" /* createSupplier */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_66__Redux_SupplierRedux__["a" /* SupplierTypes */].UPDATE_SUPPLIER_REQUEST,__WEBPACK_IMPORTED_MODULE_28__SupplierSagas__["d" /* updateSupplier */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_66__Redux_SupplierRedux__["a" /* SupplierTypes */].DELETE_SUPPLIER_REQUEST,__WEBPACK_IMPORTED_MODULE_28__SupplierSagas__["b" /* deleteSupplier */],api),// Ecommerce manage location
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_67__Redux_LocationRedux__["a" /* LocationTypes */].GET_PROVINCE_REQUEST,__WEBPACK_IMPORTED_MODULE_29__LocationSagas__["c" /* getProvince */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_67__Redux_LocationRedux__["a" /* LocationTypes */].GET_CITY_REQUEST,__WEBPACK_IMPORTED_MODULE_29__LocationSagas__["a" /* getCities */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_67__Redux_LocationRedux__["a" /* LocationTypes */].GET_DISTRICT_REQUEST,__WEBPACK_IMPORTED_MODULE_29__LocationSagas__["b" /* getDistricts */],api),// ECOMMERCE-MANAGE-INVENTORY
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].GET_INVENTORY_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["c" /* getInventory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].CREATE_INVENTORY_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["a" /* createInventory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].UPDATE_INVENTORY_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["e" /* updateInventory */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].UPDATE_INVENTORY_IMAGE_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["f" /* updateInventoryImage */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].DELETE_INVENTORY_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["b" /* deleteInventory */],api),// ECOMMERCE-MANAGE-ECOMMERCE-PRODUCT
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].GET_ECOMMERCE_PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["d" /* getEcommerceProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].VIEW_ECOMMERCE_PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["f" /* viewEcommerceProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].CREATE_ECOMMERCE_PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["a" /* createEcommerceProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].CREATE_ECOMMERCE_PRODUCT_STOCK_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["b" /* createEcommerceProductStock */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].UPDATE_ECOMMERCE_PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["e" /* updateEcommerceProduct */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_69__Redux_EcommerceProductRedux__["a" /* EcommerceProductTypes */].DELETE_ECOMMERCE_PRODUCT_REQUEST,__WEBPACK_IMPORTED_MODULE_30__EcommerceProductSagas__["c" /* deleteEcommerceProduct */],api),// ECOMMERCE-MANAGE-ECOMMERCE-ORDER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__["a" /* EcommerceOrderTypes */].GET_ECOMMERCE_ORDER_REQUEST,__WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__["b" /* getEcommerceOrder */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__["a" /* EcommerceOrderTypes */].GET_ECOMMERCE_ORDER_SHIPPING_REQUEST,__WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__["c" /* getEcommerceOrderShipping */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__["a" /* EcommerceOrderTypes */].POST_ECOMMERCE_ORDER_SHIPPING_REQUEST,__WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__["d" /* postEcommerceOrderShipping */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__["a" /* EcommerceOrderTypes */].PUT_ECOMMERCE_ORDER_SHIPPING_REQUEST,__WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__["e" /* putEcommerceOrderShipping */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_70__Redux_EcommerceOrderRedux__["a" /* EcommerceOrderTypes */].DELETE_ECOMMERCE_ORDER_SHIPPING_REQUEST,__WEBPACK_IMPORTED_MODULE_31__EcommerceOrderSagas__["a" /* deleteEcommerceOrderShipping */],api),// SECTIONS
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].GET_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["c" /* getSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].POST_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["d" /* postSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].PUT_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["f" /* putSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].DELETE_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["a" /* deleteSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].POST_SUB_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["e" /* postSubSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].PUT_SUB_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["g" /* putSubSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_71__Redux_SectionRedux__["a" /* SectionTypes */].DELETE_SUB_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_32__SectionSagas__["b" /* deleteSubSection */],api),// ATTRACTION PROMO
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].ATTRACTION_PROMO_REQUEST,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["b" /* getAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].POST_ATTRACTION_PROMO_REQUEST,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["c" /* postAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].POST_ATTRACTION_PROMO_SUCCESS,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["b" /* getAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].PUT_ATTRACTION_PROMO_REQUEST,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["d" /* putAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].PUT_ATTRACTION_PROMO_SUCCESS,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["b" /* getAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].DELETE_ATTRACTION_PROMO_REQUEST,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["a" /* deleteAttractionPromo */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_72__Redux_AttractionPromoRedux__["a" /* AttractionPromoTypes */].DELETE_ATTRACTION_PROMO_SUCCESS,__WEBPACK_IMPORTED_MODULE_33__AttractionPromoSagas__["b" /* getAttractionPromo */],api),// FAILED TRANSACTION
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_73__Redux_FailedTransactionRedux__["a" /* FailedTransactionTypes */].GET_FAILED_TRANSACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_34__FailedTransactionSagas__["a" /* getFailedTransaction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_73__Redux_FailedTransactionRedux__["a" /* FailedTransactionTypes */].TRIGGER_FAILED_TRANSACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_34__FailedTransactionSagas__["b" /* triggerFailedTransaction */],api),// CUSTOM SAGAS FOR SELECTORS
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_50__Redux_ProductRedux__["a" /* ProductTypes */].GET_PRODUCT_CUSTOM_REQUEST,__WEBPACK_IMPORTED_MODULE_11__ProductSagas__["j" /* getProductCustom */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_53__Redux_BannerRedux__["a" /* BannerTypes */].BANNER_CUSTOM_REQUEST,__WEBPACK_IMPORTED_MODULE_14__BannerSagas__["c" /* getBannerCustom */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_68__Redux_InventoryRedux__["a" /* InventoryTypes */].GET_INVENTORY_CUSTOM_REQUEST,__WEBPACK_IMPORTED_MODULE_27__InventorySagas__["d" /* getInventoryCustom */],api),// SCHEDULER
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].GET_SCHEDULER_REQUEST,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["b" /* getScheduler */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].GET_SCHEDULER_DETAIL_REQUEST,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["c" /* getSchedulerDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].POST_SCHEDULER_REQUEST,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["d" /* postScheduler */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].PUT_SCHEDULER_REQUEST,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["e" /* putScheduler */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].PUT_SCHEDULER_SUCCESS,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["c" /* getSchedulerDetail */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_74__Redux_SchedulerRedux__["a" /* SchedulerTypes */].DELETE_SCHEDULER_REQUEST,__WEBPACK_IMPORTED_MODULE_35__SchedulerSagas__["a" /* deleteScheduler */],api),// cronReport
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].GET_CRON_REPORT_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["d" /* getCronReport */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].GET_CRON_REPORT_ITEM_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["e" /* getCronReportItem */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].DISABLE_ATTRACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["b" /* disableAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].ENABLE_ATTRACTION_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["c" /* enableAttraction */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].GET_WHITELIST_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["f" /* getWhitelist */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].PUT_WHITELIST_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["g" /* putWhitelist */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_75__Redux_CronReportRedux__["a" /* CronReportTypes */].DELETE_WHITELIST_REQUEST,__WEBPACK_IMPORTED_MODULE_36__CronReportSagas__["a" /* deleteWhitelist */],api),// Promo Section
Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_76__Redux_PromoSectionRedux__["a" /* PromoSectionTypes */].GET_PROMO_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_37__PromoSectionSagas__["a" /* getPromoSection */],api),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_76__Redux_PromoSectionRedux__["a" /* PromoSectionTypes */].UPDATE_PROMO_SECTION_REQUEST,__WEBPACK_IMPORTED_MODULE_37__PromoSectionSagas__["b" /* updatePromoSection */],api)]);case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1280);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = login;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkLogin;
/* unused harmony export fetchLoginAPI */
/* unused harmony export fetchCheckLoginAPI */
/* harmony export (immutable) */ __webpack_exports__["c"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Config_Validator__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Validations_AuthValidations__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BaseSaga__ = __webpack_require__(14);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(login),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(checkLogin),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchLoginAPI),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchCheckLoginAPI),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(logout);// attempts to login
function login(api){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function login$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__BaseSaga__["d" /* baseListen */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["a" /* AuthTypes */].AUTH_REQUEST,fetchLoginAPI,api);case 2:case'end':return _context.stop();}}},_marked,this);}function checkLogin(api,getToken){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function checkLogin$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__BaseSaga__["d" /* baseListen */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["a" /* AuthTypes */].AUTH_CHECK_REQUEST,fetchCheckLoginAPI,api,getToken);case 2:case'end':return _context2.stop();}}},_marked2,this);}function fetchLoginAPI(api,_ref){var data=_ref.data;var hasError,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchLoginAPI$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:hasError=Object(__WEBPACK_IMPORTED_MODULE_4__Config_Validator__["a" /* default */])(data,__WEBPACK_IMPORTED_MODULE_5__Validations_AuthValidations__["a" /* default */].loginConstraints,{format:'custom'});if(!hasError){_context3.next=6;break;}_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authFailure(hasError));case 4:_context3.next=37;break;case 6:_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.login,data);case 8:res=_context3.sent;if(res.ok){_context3.next=12;break;}_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 12:if(res.data.error){_context3.next=35;break;}if(!(res.data.data.role==='user')){_context3.next=20;break;}_context3.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authLogout());case 16:_context3.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authFailure('Access Denied!'));case 18:_context3.next=33;break;case 20:_context3.next=22;return __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.setItem('access_token',res.data.data.token);case 22:_context3.next=24;return window.localStorage.setItem('user_role',res.data.data.role);case 24:if(res.data.data.branch_code){_context3.next=29;break;}_context3.next=27;return window.localStorage.setItem('branch','ID');case 27:_context3.next=31;break;case 29:_context3.next=31;return window.localStorage.setItem('branch',res.data.data.branch_code);case 31:_context3.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authSuccess(res.data.data));case 33:_context3.next=37;break;case 35:_context3.next=37;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authFailure(res.data.message));case 37:case'end':return _context3.stop();}}},_marked3,this);}function fetchCheckLoginAPI(api,getToken,_ref2){var data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchCheckLoginAPI$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__BaseSaga__["b" /* baseFetchToken */])(api.checkLogin,data,getToken,__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_AuthRedux__["b" /* default */].authFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function logout(){var pathname;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function logout$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.removeItem('access_token');case 2:_context5.next=4;return window.localStorage.removeItem('user_role');case 4:_context5.next=6;return window.localStorage.removeItem('branch');case 6:pathname=window.location.pathname;if(pathname!=='/login'){window.location.href='/login';}case 8:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validate_js__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_validate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_validate_js__);
__WEBPACK_IMPORTED_MODULE_0_validate_js___default.a.formatters.custom=function(errors){return errors.length>0?errors[0].error:false;};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_validate_js___default.a);

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * validate.js 0.11.1
 *
 * (c) 2013-2016 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {
  "use strict";

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      , attr
      , validator;

    for (attr in results) {
      for (validator in results[attr]) {
        if (v.isPromise(results[attr][validator])) {
          throw new Error("Use validate.async if you want support for promises");
        }
      }
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 11,
      patch: 1,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value) {
      return v.prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[input.name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[input.name] || null;
          }
        }
        values[input.name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
            if (option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          value = v.sanitizeFormValue(input.options[input.selectedIndex].value, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = [];
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(v.prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {value: v.stringifyValue(errorInfo.value)});
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , lastObject
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          };

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: v.prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of seconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
    }),
    equality: function(value, options, attribute, attributes) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        };

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: v.prettify(options.attribute)});
      }
    },

    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false;

      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    }
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, __webpack_require__(461));
}).call(this,
         true ? /* istanbul ignore next */ exports : null,
         true ? /* istanbul ignore next */ module : null,
        __webpack_require__(461));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(144)(module)))

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var loginConstraints={email:{email:true,presence:true},password:{presence:true,length:{minimum:5}}};/* harmony default export */ __webpack_exports__["a"] = ({loginConstraints:loginConstraints});

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getDestination;
/* harmony export (immutable) */ __webpack_exports__["c"] = createDestination;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteDestination;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateDestination;
/* harmony export (immutable) */ __webpack_exports__["a"] = addAttractionToDestination;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteAttractionFromDestination;
/* harmony export (immutable) */ __webpack_exports__["b"] = addPlaceToDestination;
/* harmony export (immutable) */ __webpack_exports__["f"] = deletePlaceFromDestination;
/* harmony export (immutable) */ __webpack_exports__["g"] = getContinent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getDestination),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createDestination),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteDestination),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateDestination),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addAttractionToDestination),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteAttractionFromDestination),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addPlaceToDestination),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deletePlaceFromDestination),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getContinent);function getDestination(api,action){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getDestination$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getDestination);case 2:response=_context.sent;_context.prev=3;if(!response.ok){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationSuccess(response.data.data));case 7:_context.next=11;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationFailure(response.data.message));case 11:_context.next=17;break;case 13:_context.prev=13;_context.t0=_context['catch'](3);_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationFailure(_context.t0));case 17:case'end':return _context.stop();}}},_marked,this,[[3,13]]);}function createDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createDestination$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationCreateFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function deleteDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteDestination$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationDeleteFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateDestination$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].destinationUpdateFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function addAttractionToDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addAttractionToDestination$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.addAttractionToDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].addAttractionToDestinationSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].addAttractionToDestinationFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function deleteAttractionFromDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteAttractionFromDestination$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteAttractionFromDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].deleteAttractionFromDestinationSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].deleteAttractionFromDestinationFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function addPlaceToDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addPlaceToDestination$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.addPlaceToDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].addPlaceToDestinationSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].addPlaceToDestinationFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function deletePlaceFromDestination(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deletePlaceFromDestination$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deletePlaceFromDestination,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].deletePlaceFromDestinationSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].deletePlaceFromDestinationFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}function getContinent(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getContinent$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getContinent,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].continentSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_DestinationRedux__["b" /* default */].continentFailure);case 2:case'end':return _context9.stop();}}},_marked9,this);}

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getAttractionByDestination;
/* harmony export (immutable) */ __webpack_exports__["g"] = getPlacesV2;
/* harmony export (immutable) */ __webpack_exports__["f"] = getPlacesByDestination;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAttractionDetail;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPlaceDetail;
/* harmony export (immutable) */ __webpack_exports__["j"] = updateAttractionDetail;
/* harmony export (immutable) */ __webpack_exports__["a"] = attractionClearCache;
/* harmony export (immutable) */ __webpack_exports__["h"] = searchAttraction;
/* harmony export (immutable) */ __webpack_exports__["i"] = searchPlace;
/* harmony export (immutable) */ __webpack_exports__["b"] = downloadAttractionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAttractionByDestination),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPlacesV2),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPlacesByDestination),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAttractionDetail),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPlaceDetail),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateAttractionDetail),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attractionClearCache),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(searchAttraction),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(searchPlace),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(downloadAttractionData);function getAttractionByDestination(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAttractionByDestination$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAttractionByDestination,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getPlacesV2(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPlacesV2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getPlacesV2,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].getPlacesV2Success,__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].getPlacesV2Failure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function getPlacesByDestination(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPlacesByDestination$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context3.sent;if(token){_context3.next=9;break;}_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context3.next=27;break;case 9:_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getPlacesByDestination,token,action.data);case 11:res=_context3.sent;if(res.ok){_context3.next=17;break;}_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context3.next=27;break;case 17:if(res.data.error){_context3.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context3.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeSuccess(DATA_WITH_PAGE));case 23:_context3.next=27;break;case 25:_context3.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeFailure(res.data.message));case 27:_context3.next=33;break;case 29:_context3.prev=29;_context3.t0=_context3['catch'](0);_context3.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeFailure());case 33:case'end':return _context3.stop();}}},_marked3,this,[[0,29]]);}function getAttractionDetail(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAttractionDetail$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getAttractionDetail,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function getPlaceDetail(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPlaceDetail$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getPlaceDetail,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionDetailFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function updateAttractionDetail(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateAttractionDetail$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateAttractionDetail,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionUpdateFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function attractionClearCache(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attractionClearCache$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.clearAttractionCache,action,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionClearCacheSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionClearCacheFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function searchAttraction(api,_ref){var data=_ref.data;var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function searchAttraction$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context8.sent;if(token){_context8.next=9;break;}_context8.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context8.next=27;break;case 9:_context8.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.searchAttraction,token,data);case 11:res=_context8.sent;if(res.ok){_context8.next=17;break;}_context8.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSearchFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context8.next=27;break;case 17:if(res.data.error){_context8.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context8.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSearchSuccess(DATA_WITH_PAGE));case 23:_context8.next=27;break;case 25:_context8.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSearchFailure(res.data.message));case 27:_context8.next=33;break;case 29:_context8.prev=29;_context8.t0=_context8['catch'](0);_context8.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].attractionSearchFailure());case 33:case'end':return _context8.stop();}}},_marked8,this,[[0,29]]);}function searchPlace(api,_ref2){var data=_ref2.data;var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function searchPlace$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context9.sent;if(token){_context9.next=9;break;}_context9.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context9.next=27;break;case 9:_context9.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.searchPlaces,token,data);case 11:res=_context9.sent;if(res.ok){_context9.next=17;break;}_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeSearchFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context9.next=27;break;case 17:if(res.data.error){_context9.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context9.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeSearchSuccess(DATA_WITH_PAGE));case 23:_context9.next=27;break;case 25:_context9.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeSearchFailure(res.data.message));case 27:_context9.next=33;break;case 29:_context9.prev=29;_context9.t0=_context9['catch'](0);_context9.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].placeSearchFailure());case 33:case'end':return _context9.stop();}}},_marked9,this,[[0,29]]);}function downloadAttractionData(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function downloadAttractionData$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context10.sent;if(token){_context10.next=9;break;}_context10.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context10.next=24;break;case 9:_context10.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.downloadAttractionData,token,action.filter);case 11:res=_context10.sent;if(res.ok){_context10.next=17;break;}_context10.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].downloadAttractionDataFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context10.next=24;break;case 17:if(res.data.error){_context10.next=22;break;}_context10.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].downloadAttractionDataSuccess(res.data));case 20:_context10.next=24;break;case 22:_context10.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].downloadAttractionDataFailure(res.data.message));case 24:_context10.next=30;break;case 26:_context10.prev=26;_context10.t0=_context10['catch'](0);_context10.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AttractionRedux__["b" /* default */].downloadAttractionDataFailure());case 30:case'end':return _context10.stop();}}},_marked10,this,[[0,26]]);}

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getCurrencies;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLanguages;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCountries;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPresetOrder;
/* harmony export (immutable) */ __webpack_exports__["h"] = updatePresetOrder;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBranch;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateBranch;
/* harmony export (immutable) */ __webpack_exports__["f"] = getShipping;
/* harmony export (immutable) */ __webpack_exports__["i"] = updateShipping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCurrencies),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getLanguages),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCountries),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPresetOrder),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updatePresetOrder),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getBranch),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateBranch),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getShipping),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateShipping);function getCurrencies(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCurrencies$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["a" /* baseFetchNoToken */])(api.getCurrencies,action,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].currencySuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].currencyFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getLanguages(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getLanguages$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["a" /* baseFetchNoToken */])(api.getLanguages,action,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].languageSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].languageFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function getCountries(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCountries$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["a" /* baseFetchNoToken */])(api.getCountries,action,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].countriesSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].countriesFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function getPresetOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPresetOrder$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["a" /* baseFetchNoToken */])(api.getPresetOrder,action,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].presetOrderSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].presetOrderFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updatePresetOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updatePresetOrder$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updatePresetOrder,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].presetOrderUpdateSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].presetOrderUpdateFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function getBranch(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBranch$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getBranch,action,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].getBranchSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].getBranchFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function updateBranch(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateBranch$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateBranch,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].updateBranchSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].updateBranchFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function getShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getShipping$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["a" /* baseFetchNoToken */])(api.getShipping,action,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].getShippingSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].getShippingFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}function updateShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateShipping$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateShipping,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].updateShippingSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_PresetRedux__["b" /* default */].updateShippingFailure);case 2:case'end':return _context9.stop();}}},_marked9,this);}

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uploadFiles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Redux_FilesRedux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(uploadFiles);// import { call, put } from 'redux-saga/effects'
function uploadFiles(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function uploadFiles$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.uploadFiles,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_1__Redux_FilesRedux__["b" /* default */].filesUploadSuccess,__WEBPACK_IMPORTED_MODULE_1__Redux_FilesRedux__["b" /* default */].filesUploadFailure);case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getPopularAttraction;
/* harmony export (immutable) */ __webpack_exports__["d"] = savePopularAttraction;
/* harmony export (immutable) */ __webpack_exports__["a"] = deletePopularAttraction;
/* harmony export (immutable) */ __webpack_exports__["b"] = editPopularAttraction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPopularAttraction),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(savePopularAttraction),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deletePopularAttraction),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(editPopularAttraction);// import { call, put } from 'redux-saga/effects'
function getPopularAttraction(api,_ref){var data=_ref.data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPopularAttraction$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getPopularAttraction,data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function savePopularAttraction(api,_ref2){var data=_ref2.data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function savePopularAttraction$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.savePopularAttraction,data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionSaveSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionSaveFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function deletePopularAttraction(api,_ref3){var data=_ref3.data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deletePopularAttraction$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deletePopularAttraction,data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionDeleteSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionDeleteFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function editPopularAttraction(api,_ref4){var data=_ref4.data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function editPopularAttraction$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.editPopularAttraction,data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionEditSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PopularAttractionRedux__["b" /* default */].popularAttractionEditFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = getAllCoupon;
/* harmony export (immutable) */ __webpack_exports__["k"] = getAllCouponTag;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCouponDetail;
/* harmony export (immutable) */ __webpack_exports__["c"] = createNewCoupon;
/* harmony export (immutable) */ __webpack_exports__["h"] = generateCoupon;
/* harmony export (immutable) */ __webpack_exports__["r"] = updateCoupon;
/* harmony export (immutable) */ __webpack_exports__["q"] = updateBusiness;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteCoupon;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteBusiness;
/* harmony export (immutable) */ __webpack_exports__["b"] = couponSpreadsheet;
/* harmony export (immutable) */ __webpack_exports__["n"] = historySpreadsheet;
/* harmony export (immutable) */ __webpack_exports__["m"] = getCouponItem;
/* harmony export (immutable) */ __webpack_exports__["o"] = postCouponItem;
/* harmony export (immutable) */ __webpack_exports__["p"] = postCouponItemTag;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteCouponItem;
/* harmony export (immutable) */ __webpack_exports__["g"] = deleteCouponItemTag;
/* harmony export (immutable) */ __webpack_exports__["i"] = getAffiliates;
/* harmony export (immutable) */ __webpack_exports__["a"] = affiliateTransfer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllCoupon),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllCouponTag),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCouponDetail),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createNewCoupon),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(generateCoupon),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateCoupon),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateBusiness),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCoupon),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteBusiness),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(couponSpreadsheet),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(historySpreadsheet),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCouponItem),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postCouponItem),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postCouponItemTag),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCouponItem),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCouponItemTag),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAffiliates),_marked18=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(affiliateTransfer);function getAllCoupon(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllCoupon$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAllCoupon,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getAllCouponTag(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllCouponTag$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context2.sent;if(token){_context2.next=9;break;}_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context2.next=27;break;case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAllCouponTag,token,action.data);case 11:res=_context2.sent;if(res.ok){_context2.next=17;break;}_context2.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponTagFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context2.next=27;break;case 17:if(res.data.error){_context2.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context2.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponTagSuccess(data_with_page));case 23:_context2.next=27;break;case 25:_context2.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponTagFailure(res.data.message));case 27:_context2.next=33;break;case 29:_context2.prev=29;_context2.t0=_context2['catch'](0);_context2.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponTagFailure());case 33:case'end':return _context2.stop();}}},_marked2,this,[[0,29]]);}function getCouponDetail(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCouponDetail$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getCouponDetail,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponDetailSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponDetailFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function createNewCoupon(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createNewCoupon$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createNewCoupon,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponCreateFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function generateCoupon(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function generateCoupon$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.generateCoupon,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponGenerateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponGenerateFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function updateCoupon(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateCoupon$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateCoupon,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponUpdateFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function updateBusiness(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateBusiness$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateBusiness,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].businessUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].businessUpdateFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function deleteCoupon(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCoupon$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteCoupon,action.id,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponDeleteFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}function deleteBusiness(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteBusiness$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteBusiness,action.id,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].businessDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].businessDeleteFailure);case 2:case'end':return _context9.stop();}}},_marked9,this);}function couponSpreadsheet(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function couponSpreadsheet$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context10.sent;if(token){_context10.next=9;break;}_context10.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context10.next=24;break;case 9:_context10.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.couponSpreadsheet,token,action.data);case 11:res=_context10.sent;if(res.ok){_context10.next=17;break;}_context10.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponSpreadsheetFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context10.next=24;break;case 17:if(res.data.error){_context10.next=22;break;}_context10.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponSpreadsheetSuccess(res.data));case 20:_context10.next=24;break;case 22:_context10.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponSpreadsheetFailure(res.data.message));case 24:_context10.next=30;break;case 26:_context10.prev=26;_context10.t0=_context10['catch'](0);_context10.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponSpreadsheetFailure());case 30:case'end':return _context10.stop();}}},_marked10,this,[[0,26]]);}function historySpreadsheet(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function historySpreadsheet$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context11.sent;if(token){_context11.next=9;break;}_context11.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context11.next=24;break;case 9:_context11.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.historySpreadsheet,token,action.data);case 11:res=_context11.sent;if(res.ok){_context11.next=17;break;}_context11.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].historySpreadsheetFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context11.next=24;break;case 17:if(res.data.error){_context11.next=22;break;}_context11.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].historySpreadsheetSuccess(res.data));case 20:_context11.next=24;break;case 22:_context11.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].couponCreateFailure(res.data.message));case 24:_context11.next=30;break;case 26:_context11.prev=26;_context11.t0=_context11['catch'](0);_context11.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].historySpreadsheetFailure());case 30:case'end':return _context11.stop();}}},_marked11,this,[[0,26]]);}function getCouponItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCouponItem$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getCouponItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getCouponItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getCouponItemFailure);case 2:case'end':return _context12.stop();}}},_marked12,this);}function postCouponItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postCouponItem$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postCouponItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemFailure);case 2:case'end':return _context13.stop();}}},_marked13,this);}function postCouponItemTag(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postCouponItemTag$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postCouponItemTag,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemTagSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].postCouponItemTagFailure);case 2:case'end':return _context14.stop();}}},_marked14,this);}function deleteCouponItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCouponItem$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteCouponItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].deleteCouponItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].deleteCouponItemFailure);case 2:case'end':return _context15.stop();}}},_marked15,this);}function deleteCouponItemTag(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCouponItemTag$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteCouponItemTag,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].deleteCouponItemTagSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].deleteCouponItemTagFailure);case 2:case'end':return _context16.stop();}}},_marked16,this);}function getAffiliates(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAffiliates$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.prev=0;_context17.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context17.sent;if(token){_context17.next=9;break;}_context17.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context17.next=27;break;case 9:_context17.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAffiliates,token,action.data);case 11:res=_context17.sent;if(res.ok){_context17.next=17;break;}_context17.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getAffiliatesFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context17.next=27;break;case 17:if(res.data.error){_context17.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context17.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getAffiliatesSuccess(DATA_WITH_PAGE));case 23:_context17.next=27;break;case 25:_context17.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getAffiliatesFailure(res.data.message));case 27:_context17.next=33;break;case 29:_context17.prev=29;_context17.t0=_context17['catch'](0);_context17.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].getAffiliatesFailure());case 33:case'end':return _context17.stop();}}},_marked17,this,[[0,29]]);}function affiliateTransfer(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function affiliateTransfer$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.affiliateTransfer,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].affiliateTransferSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_CouponRedux__["b" /* default */].affiliateTransferFailure);case 2:case'end':return _context18.stop();}}},_marked18,this);}

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCouponProvider;
/* harmony export (immutable) */ __webpack_exports__["c"] = postCouponProvider;
/* harmony export (immutable) */ __webpack_exports__["d"] = putCouponProvider;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCouponProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCouponProvider),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postCouponProvider),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putCouponProvider),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCouponProvider);function getCouponProvider(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCouponProvider$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getCouponProvider,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].getCouponProviderSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].getCouponProviderFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function postCouponProvider(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postCouponProvider$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postCouponProvider,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].postCouponProviderSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].postCouponProviderFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function putCouponProvider(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putCouponProvider$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putCouponProvider,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].putCouponProviderSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].putCouponProviderFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteCouponProvider(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCouponProvider$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteCouponProvider,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].deleteCouponProviderSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponProviderRedux__["b" /* default */].deleteCouponProviderFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCouponPreset;
/* harmony export (immutable) */ __webpack_exports__["c"] = postCouponPreset;
/* harmony export (immutable) */ __webpack_exports__["d"] = putCouponPreset;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCouponPreset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCouponPreset),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postCouponPreset),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putCouponPreset),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCouponPreset);function getCouponPreset(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCouponPreset$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getCouponPreset,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].getCouponPresetSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].getCouponPresetFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function postCouponPreset(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postCouponPreset$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postCouponPreset,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].postCouponPresetSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].postCouponPresetFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function putCouponPreset(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putCouponPreset$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putCouponPreset,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].putCouponPresetSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].putCouponPresetFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteCouponPreset(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCouponPreset$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteCouponPreset,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].deleteCouponPresetSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CouponPresetRedux__["b" /* default */].deleteCouponPresetFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getProduct;
/* harmony export (immutable) */ __webpack_exports__["j"] = getProductCustom;
/* harmony export (immutable) */ __webpack_exports__["a"] = createProduct;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteProduct;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateProduct;
/* harmony export (immutable) */ __webpack_exports__["i"] = getProductCountry;
/* harmony export (immutable) */ __webpack_exports__["n"] = postProductCountry;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteProductCountry;
/* harmony export (immutable) */ __webpack_exports__["h"] = getProductCampaign;
/* harmony export (immutable) */ __webpack_exports__["m"] = postProductCampaign;
/* harmony export (immutable) */ __webpack_exports__["q"] = putProductCampaign;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteProductCampaign;
/* harmony export (immutable) */ __webpack_exports__["k"] = getProductVariant;
/* harmony export (immutable) */ __webpack_exports__["o"] = postProductVariant;
/* harmony export (immutable) */ __webpack_exports__["r"] = putProductVariant;
/* harmony export (immutable) */ __webpack_exports__["e"] = deleteProductVariant;
/* harmony export (immutable) */ __webpack_exports__["l"] = getProductVariantItem;
/* harmony export (immutable) */ __webpack_exports__["p"] = postProductVariantItem;
/* harmony export (immutable) */ __webpack_exports__["f"] = deleteProductVariantItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProduct),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductCustom),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createProduct),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteProduct),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateProduct),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductCountry),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postProductCountry),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteProductCountry),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductCampaign),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postProductCampaign),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putProductCampaign),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteProductCampaign),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductVariant),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postProductVariant),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putProductVariant),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteProductVariant),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductVariantItem),_marked18=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postProductVariantItem),_marked19=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteProductVariantItem);function getProduct(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProduct$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getProduct,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getProductCustom(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductCustom$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getProductCustom,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCustomSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCustomFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createProduct$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productCreateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteProduct$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productDeleteFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updateProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateProduct$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].productUpdateFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function getProductCountry(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductCountry$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getProductCountry,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCountrySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCountryFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function postProductCountry(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postProductCountry$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postProductCountry,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductCountrySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductCountryFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function deleteProductCountry(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteProductCountry$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteProductCountry,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductCountrySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductCountryFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}function getProductCampaign(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductCampaign$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getProductCampaign,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCampaignSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductCampaignFailure);case 2:case'end':return _context9.stop();}}},_marked9,this);}function postProductCampaign(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postProductCampaign$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postProductCampaign,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductCampaignSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductCampaignFailure);case 2:case'end':return _context10.stop();}}},_marked10,this);}function putProductCampaign(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putProductCampaign$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.putProductCampaign,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].putProductCampaignSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].putProductCampaignFailure);case 2:case'end':return _context11.stop();}}},_marked11,this);}function deleteProductCampaign(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteProductCampaign$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteProductCampaign,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductCampaignSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductCampaignFailure);case 2:case'end':return _context12.stop();}}},_marked12,this);}function getProductVariant(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductVariant$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getProductVariant,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductVariantSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductVariantFailure);case 2:case'end':return _context13.stop();}}},_marked13,this);}function postProductVariant(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postProductVariant$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postProductVariant,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductVariantSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductVariantFailure);case 2:case'end':return _context14.stop();}}},_marked14,this);}function putProductVariant(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putProductVariant$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.putProductVariant,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].putProductVariantSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].putProductVariantFailure);case 2:case'end':return _context15.stop();}}},_marked15,this);}function deleteProductVariant(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteProductVariant$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteProductVariant,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductVariantSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductVariantFailure);case 2:case'end':return _context16.stop();}}},_marked16,this);}function getProductVariantItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductVariantItem$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getProductVariantItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductVariantItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].getProductVariantItemFailure);case 2:case'end':return _context17.stop();}}},_marked17,this);}function postProductVariantItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postProductVariantItem$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postProductVariantItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductVariantItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].postProductVariantItemFailure);case 2:case'end':return _context18.stop();}}},_marked18,this);}function deleteProductVariantItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteProductVariantItem$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteProductVariantItem,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductVariantItemSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ProductRedux__["b" /* default */].deleteProductVariantItemFailure);case 2:case'end':return _context19.stop();}}},_marked19,this);}

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllEvents;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAllPopularEvents;
/* harmony export (immutable) */ __webpack_exports__["c"] = getEventsCategories;
/* harmony export (immutable) */ __webpack_exports__["e"] = setPopularEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = resetEventDescription;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateEventDescription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllEvents),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllPopularEvents),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEventsCategories),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setPopularEvent),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resetEventDescription),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateEventDescription);function getAllEvents(api,action){var token,res,page,total,paginatedData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllEvents$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAllEvents,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllEventsFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;paginatedData={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllEventsSuccess(paginatedData));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllEventsFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllEventsFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getAllPopularEvents(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllPopularEvents$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getAllPopularEvents,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllPopularEventsSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getAllPopularEventsFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function getEventsCategories(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEventsCategories$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getEventsCategories,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getEventsCategoriesSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].getEventsCategoriesFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function setPopularEvent(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setPopularEvent$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.setPopularEvent,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].setPopularEventSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].setPopularEventFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function resetEventDescription(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resetEventDescription$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.resetEventDescription,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].resetEventDescriptionSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].resetEventDescriptionFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function updateEventDescription(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateEventDescription$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateEventDescription,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].updateEventDescriptionSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EventsRedux__["b" /* default */].updateEventDescriptionFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getTravelPackage;
/* harmony export (immutable) */ __webpack_exports__["f"] = postTravelPackage;
/* harmony export (immutable) */ __webpack_exports__["i"] = putTravelPackage;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteTravelPackage;
/* harmony export (immutable) */ __webpack_exports__["l"] = viewTravelPackage;
/* harmony export (immutable) */ __webpack_exports__["g"] = postTravelPackagePrice;
/* harmony export (immutable) */ __webpack_exports__["j"] = putTravelPackagePrice;
/* harmony export (immutable) */ __webpack_exports__["k"] = switchTravelPackagePrice;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTicketPackage;
/* harmony export (immutable) */ __webpack_exports__["e"] = postTicketPackage;
/* harmony export (immutable) */ __webpack_exports__["h"] = putTicketPackage;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteTicketPackage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTravelPackage),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postTravelPackage),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putTravelPackage),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteTravelPackage),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(viewTravelPackage),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postTravelPackagePrice),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putTravelPackagePrice),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(switchTravelPackagePrice),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTicketPackage),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postTicketPackage),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putTicketPackage),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteTicketPackage);// import AuthActions from '../Redux/AuthRedux'
// import { call, put } from 'redux-saga/effects'
function getTravelPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTravelPackage$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getTravelPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTravelPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTravelPackageFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function postTravelPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postTravelPackage$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postTravelPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTravelPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTravelPackageFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function putTravelPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putTravelPackage$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putTravelPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTravelPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTravelPackageFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteTravelPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteTravelPackage$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteTravelPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTravelPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTravelPackageFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function viewTravelPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function viewTravelPackage$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.viewTravelPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].viewTravelPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].viewTravelPackageFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function postTravelPackagePrice(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postTravelPackagePrice$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postTravelPackagePrice,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTravelPackagePriceSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTravelPackagePriceFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function putTravelPackagePrice(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putTravelPackagePrice$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putTravelPackagePrice,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTravelPackagePriceSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTravelPackagePriceFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function switchTravelPackagePrice(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function switchTravelPackagePrice$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.switchTravelPackagePrice,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].switchTravelPackagePriceSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].switchTravelPackagePriceFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}function getTicketPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTicketPackage$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getTicketPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTicketPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].getTravelPackageFailure);case 2:case'end':return _context9.stop();}}},_marked9,this);}function postTicketPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postTicketPackage$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postTicketPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTicketPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].postTicketPackageFailure);case 2:case'end':return _context10.stop();}}},_marked10,this);}function putTicketPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putTicketPackage$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putTicketPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTicketPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].putTicketPackageFailure);case 2:case'end':return _context11.stop();}}},_marked11,this);}function deleteTicketPackage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteTicketPackage$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteTicketPackage,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTicketPackageSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_InsuranceRedux__["b" /* default */].deleteTicketPackageFailure);case 2:case'end':return _context12.stop();}}},_marked12,this);}

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getBanners;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBannerCustom;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBanner;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteBanner;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateBanner;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getBanners),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getBannerCustom),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createBanner),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteBanner),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateBanner);// import { call, put } from 'redux-saga/effects'
// import AuthActions from '../Redux/AuthRedux'
function getBanners(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBanners$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getBanners,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getBannerCustom(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBannerCustom$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getBannerCustom,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerCustomSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerCustomFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createBanner(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createBanner$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createBanner,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerCreateSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerCreateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteBanner(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteBanner$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteBanner,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerDeleteSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerDeleteFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updateBanner(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateBanner$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateBanner,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerUpdateSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BannerRedux__["b" /* default */].bannerUpdateFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getMarkup;
/* harmony export (immutable) */ __webpack_exports__["a"] = createMarkup;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateMarkup;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteMarkup;
/* harmony export (immutable) */ __webpack_exports__["f"] = markupItemGet;
/* harmony export (immutable) */ __webpack_exports__["d"] = markupItemCreate;
/* harmony export (immutable) */ __webpack_exports__["g"] = markupItemUpdate;
/* harmony export (immutable) */ __webpack_exports__["e"] = markupItemDelete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getMarkup),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createMarkup),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateMarkup),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteMarkup),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markupItemGet),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markupItemCreate),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markupItemUpdate),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markupItemDelete);function getMarkup(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getMarkup$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getMarkup,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupSuccess(data_with_page));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function createMarkup(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createMarkup$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createMarkup,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupCreateFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateMarkup(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateMarkup$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateMarkup,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupUpdateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteMarkup(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteMarkup$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteMarkup,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupDeleteFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function markupItemGet(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markupItemGet$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.markupItemGet,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemGetSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemGetFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function markupItemCreate(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markupItemCreate$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.markupItemCreate,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemCreateFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function markupItemUpdate(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markupItemUpdate$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.markupItemUpdate,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemUpdateFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function markupItemDelete(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markupItemDelete$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.markupItemDelete,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_MarkupRedux__["b" /* default */].markupItemDeleteFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExchangeRate;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSingleExchangeRate;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateExchangeRate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getExchangeRate),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSingleExchangeRate),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateExchangeRate);function getExchangeRate(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getExchangeRate$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getExchangeRate,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getSingleExchangeRate(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSingleExchangeRate$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSingleExchangeRate,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateSingleSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateSingleFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateExchangeRate(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateExchangeRate$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateExchangeRate,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateUpdateSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ExchangeRateRedux__["b" /* default */].exchangeRateUpdateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = createUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateUser;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = downloadUserList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getUser),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getUserCount),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createUser),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateUser),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteUser),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(downloadUserList);function getUser(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getUser$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getUser,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userSuccess(data_with_page));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getUserCount(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getUserCount$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getUserCount,action.filter,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userCountSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userCountFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createUser(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createUser$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createUser,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userCreateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userCreateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateUser(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateUser$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateUser,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userUpdateFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function deleteUser(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteUser$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteUser,action.id,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userDeleteSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userDeleteFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function downloadUserList(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function downloadUserList$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context6.sent;if(token){_context6.next=9;break;}_context6.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context6.next=24;break;case 9:_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.downloadUserList,token,action.data);case 11:res=_context6.sent;if(res.ok){_context6.next=17;break;}_context6.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(downloadUserList.userListFailure('Failed'));case 15:_context6.next=24;break;case 17:if(res.data.error){_context6.next=22;break;}_context6.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userListSuccess(res.data));case 20:_context6.next=24;break;case 22:_context6.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userListFailure(res.data.message));case 24:_context6.next=30;break;case 26:_context6.prev=26;_context6.t0=_context6['catch'](0);_context6.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_UserRedux__["b" /* default */].userListFailure());case 30:case'end':return _context6.stop();}}},_marked6,this,[[0,26]]);}

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getOrder;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOrderSingle;
/* harmony export (immutable) */ __webpack_exports__["o"] = updateOrder;
/* harmony export (immutable) */ __webpack_exports__["n"] = updateCheckoutOrder;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateOrderAmount;
/* harmony export (immutable) */ __webpack_exports__["e"] = getOrderDetailList;
/* harmony export (immutable) */ __webpack_exports__["a"] = confirmOrder;
/* harmony export (immutable) */ __webpack_exports__["j"] = orderListSpreadsheet;
/* harmony export (immutable) */ __webpack_exports__["i"] = orderDetailListSpreadsheet;
/* harmony export (immutable) */ __webpack_exports__["b"] = downloadOrderInvoice;
/* harmony export (immutable) */ __webpack_exports__["m"] = resendOrderVoucher;
/* harmony export (immutable) */ __webpack_exports__["f"] = getOrderReport;
/* harmony export (immutable) */ __webpack_exports__["g"] = getOrderReportSpreadsheet;
/* harmony export (immutable) */ __webpack_exports__["c"] = getChatbotOrder;
/* harmony export (immutable) */ __webpack_exports__["k"] = postChatbotOrder;
/* harmony export (immutable) */ __webpack_exports__["l"] = refundDana;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getOrder),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getOrderSingle),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateOrder),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateCheckoutOrder),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateOrderAmount),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getOrderDetailList),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(confirmOrder),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(orderListSpreadsheet),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(orderDetailListSpreadsheet),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(downloadOrderInvoice),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resendOrderVoucher),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getOrderReport),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getOrderReportSpreadsheet),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getChatbotOrder),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postChatbotOrder),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(refundDana);function getOrder(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrder$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getOrder,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderSuccess(data_with_page));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getOrderSingle(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrderSingle$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getOrderSingle,action.id,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderSingleSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderSingleFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateOrder$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateOrder,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderUpdateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateCheckoutOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateCheckoutOrder$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateCheckoutOrder,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderCheckoutSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderCheckoutFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updateOrderAmount(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateOrderAmount$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateOrderAmount,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderUpdateAmountSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderUpdateAmountFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function getOrderDetailList(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrderDetailList$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context6.sent;if(token){_context6.next=9;break;}_context6.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context6.next=27;break;case 9:_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getOrderDetailList,token,action.filter);case 11:res=_context6.sent;if(res.ok){_context6.next=17;break;}_context6.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context6.next=27;break;case 17:if(res.data.error){_context6.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context6.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListSuccess(data_with_page));case 23:_context6.next=27;break;case 25:_context6.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListFailure(res.data.message));case 27:_context6.next=33;break;case 29:_context6.prev=29;_context6.t0=_context6['catch'](0);_context6.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListFailure());case 33:case'end':return _context6.stop();}}},_marked6,this,[[0,29]]);}function confirmOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function confirmOrder$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.confirmOrder,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderConfirmSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderConfirmFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function orderListSpreadsheet(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function orderListSpreadsheet$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context8.sent;if(token){_context8.next=9;break;}_context8.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context8.next=24;break;case 9:_context8.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.orderListSpreadsheet,token,action.filter);case 11:res=_context8.sent;if(res.ok){_context8.next=17;break;}_context8.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context8.next=24;break;case 17:if(res.data.error){_context8.next=22;break;}_context8.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderListDownloadSuccess(res.data));case 20:_context8.next=24;break;case 22:_context8.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderListDownloadFailure(res.data.message));case 24:_context8.next=30;break;case 26:_context8.prev=26;_context8.t0=_context8['catch'](0);_context8.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderListDownloadFailure());case 30:case'end':return _context8.stop();}}},_marked8,this,[[0,26]]);}function orderDetailListSpreadsheet(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function orderDetailListSpreadsheet$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context9.sent;if(token){_context9.next=9;break;}_context9.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context9.next=24;break;case 9:_context9.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.orderDetailListSpreadsheet,token,action.filter);case 11:res=_context9.sent;if(res.ok){_context9.next=17;break;}_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context9.next=24;break;case 17:if(res.data.error){_context9.next=22;break;}_context9.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListDownloadSuccess(res.data));case 20:_context9.next=24;break;case 22:_context9.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListDownloadFailure(res.data.message));case 24:_context9.next=30;break;case 26:_context9.prev=26;_context9.t0=_context9['catch'](0);_context9.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderDetailListDownloadFailure());case 30:case'end':return _context9.stop();}}},_marked9,this,[[0,26]]);}function downloadOrderInvoice(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function downloadOrderInvoice$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.downloadOrderInvoice,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderInvoiceSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].orderInvoiceFailure);case 2:case'end':return _context10.stop();}}},_marked10,this);}function resendOrderVoucher(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resendOrderVoucher$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context11.sent;if(token){_context11.next=9;break;}_context11.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context11.next=24;break;case 9:_context11.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.resendOrderVoucher,token,action.data);case 11:res=_context11.sent;if(res.ok){_context11.next=17;break;}_context11.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].resendOrderVoucherFailure('Failed'));case 15:_context11.next=24;break;case 17:if(res.data.erorr){_context11.next=22;break;}_context11.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].resendOrderVoucherSuccess(res.data));case 20:_context11.next=24;break;case 22:_context11.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].resendOrderVoucherFailure(res.data.message));case 24:_context11.next=30;break;case 26:_context11.prev=26;_context11.t0=_context11['catch'](0);_context11.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].resendOrderVoucherFailure());case 30:case'end':return _context11.stop();}}},_marked11,this,[[0,26]]);}function getOrderReport(api,action){var token,res,page,data,total,metaTravypass,stat_modem_passpod,DATA_APPEND;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrderReport$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.prev=0;_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context12.sent;if(token){_context12.next=9;break;}_context12.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context12.next=30;break;case 9:_context12.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getOrderReport,token,action.filter);case 11:res=_context12.sent;if(res.ok){_context12.next=17;break;}_context12.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportFailure('Terjadi kesalahan'));case 15:_context12.next=30;break;case 17:if(res.data.error){_context12.next=28;break;}page=parseInt(res.data.meta.page,10);data=res.data.data;total=res.data.meta.count;metaTravypass=res.data.meta.metaTravypass;stat_modem_passpod=res.data.meta.metaTravypass.stat_modem_passpod;DATA_APPEND={data:data,page:page,total:total,metaTravypass:metaTravypass,stat_modem_passpod:stat_modem_passpod};_context12.next=26;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportSuccess(DATA_APPEND));case 26:_context12.next=30;break;case 28:_context12.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportFailure(res.data.message));case 30:_context12.next=36;break;case 32:_context12.prev=32;_context12.t0=_context12['catch'](0);_context12.next=36;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportFailure());case 36:case'end':return _context12.stop();}}},_marked12,this,[[0,32]]);}function getOrderReportSpreadsheet(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getOrderReportSpreadsheet$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getOrderReportSpreadsheet,action.filter,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportSpreadsheetSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getOrderReportSpreadsheetFailure);case 2:case'end':return _context13.stop();}}},_marked13,this);}function getChatbotOrder(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getChatbotOrder$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.prev=0;_context14.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context14.sent;if(token){_context14.next=9;break;}_context14.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context14.next=27;break;case 9:_context14.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getChatbotOrder,token,action.filter);case 11:res=_context14.sent;if(res.ok){_context14.next=17;break;}_context14.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getChatbotOrderFailure('ERR_MSG_CHB_ORDER_FAILURE'));case 15:_context14.next=27;break;case 17:if(res.data.error){_context14.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context14.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getChatbotOrderSuccess(DATA_WITH_PAGE));case 23:_context14.next=27;break;case 25:_context14.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getChatbotOrderFailure(res.data.message));case 27:_context14.next=33;break;case 29:_context14.prev=29;_context14.t0=_context14['catch'](0);_context14.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].getChatbotOrderFailure());case 33:case'end':return _context14.stop();}}},_marked14,this,[[0,29]]);}function postChatbotOrder(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postChatbotOrder$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postChatbotOrder,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].postChatbotOrderSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].postChatbotOrderFailure);case 2:case'end':return _context15.stop();}}},_marked15,this);}function refundDana(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refundDana$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.refundDana,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].refundDanaSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_OrderRedux__["b" /* default */].refundDanaFailure);case 2:case'end':return _context16.stop();}}},_marked16,this);}

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransferHistory;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTransferHistoryMatches;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateTransferHistory;
/* harmony export (immutable) */ __webpack_exports__["c"] = transferHistoryListSpreadsheet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTransferHistory),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTransferHistoryMatches),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateTransferHistory),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(transferHistoryListSpreadsheet);function getTransferHistory(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTransferHistory$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getTransferHistory,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistorySuccess(data_with_page));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getTransferHistoryMatches(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTransferHistoryMatches$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getTransferHistoryMatches,null,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryMatchesSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryMatchesFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateTransferHistory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateTransferHistory$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateTransferHistory,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryUpdateSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryUpdateFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function transferHistoryListSpreadsheet(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function transferHistoryListSpreadsheet$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context4.sent;if(token){_context4.next=9;break;}_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context4.next=24;break;case 9:_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.transferHistoryListSpreadsheet,token,action.filter);case 11:res=_context4.sent;if(res.ok){_context4.next=17;break;}_context4.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context4.next=24;break;case 17:if(res.data.error){_context4.next=22;break;}_context4.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryListDownloadSuccess(res.data));case 20:_context4.next=24;break;case 22:_context4.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryListDownloadFailure(res.data.message));case 24:_context4.next=30;break;case 26:_context4.prev=26;_context4.t0=_context4['catch'](0);_context4.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_TransferHistoryRedux__["b" /* default */].transferHistoryListDownloadFailure());case 30:case'end':return _context4.stop();}}},_marked4,this,[[0,26]]);}

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getReviews;
/* harmony export (immutable) */ __webpack_exports__["a"] = approveReview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getReviews),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(approveReview);function getReviews(api,action){var token,res,page,total,data_with_page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getReviews$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getReviewList,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;data_with_page={list:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewListSuccess(data_with_page));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewListFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function approveReview(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function approveReview$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.approveReview,action.id,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewApproveSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_ReviewRedux__["b" /* default */].reviewApproveFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dbDump;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_DbRedux__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dbDump);// import { baseFetchToken } from './BaseSaga'
function dbDump(api,action){var token,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dbDump$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=24;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.dumpDatabase,token);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_DbRedux__["b" /* default */].dbDumpFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=24;break;case 17:if(res.data.error){_context.next=22;break;}_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_DbRedux__["b" /* default */].dbDumpSuccess());case 20:_context.next=24;break;case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_DbRedux__["b" /* default */].dbDumpFailure(res.data.message));case 24:_context.next=30;break;case 26:_context.prev=26;_context.t0=_context['catch'](0);_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_DbRedux__["b" /* default */].dbDumpFailure());case 30:case'end':return _context.stop();}}},_marked,this,[[0,26]]);}

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getCategory;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSingleCategory;
/* harmony export (immutable) */ __webpack_exports__["a"] = createCategory;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateCategory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCategory),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSingleCategory),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createCategory),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateCategory);function getCategory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCategory$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getCategory,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].getCategorySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].getCategoryFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getSingleCategory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSingleCategory$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSingleCategory,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].getSingleCategorySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].getSingleCategoryFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createCategory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createCategory$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createCategory,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].createCategorySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].createCategoryFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateCategory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateCategory$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateCategory,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].updateCategorySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CategoryRedux__["b" /* default */].updateCategoryFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = createSize;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateSize;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AuthRedux__ = __webpack_require__(26);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSize),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllSize),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createSize),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateSize),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSize);function getSize(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSize$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_5__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(api.getSize,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getSizeFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getSizeSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getSizeFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getSizeFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getAllSize(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllSize$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getAllSize,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getAllSizeSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].getAllSizeFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createSize(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createSize$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createSize,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].createSizeSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].createSizeFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateSize(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateSize$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateSize,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].updateSizeSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].updateSizeFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function deleteSize(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSize$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteSize,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].deleteSizeSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SizeRedux__["b" /* default */].deleteSizeFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getColour;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllColour;
/* harmony export (immutable) */ __webpack_exports__["a"] = createColour;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateColour;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteColour;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redux_AuthRedux__ = __webpack_require__(26);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getColour),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllColour),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createColour),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateColour),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteColour);function getColour(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getColour$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_5__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(api.getColour,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getColourFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getColourSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getColourFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getColourFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getAllColour(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllColour$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getAllColour,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getAllColourSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].getAllColourFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createColour(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createColour$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createColour,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].createColourSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].createColourFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateColour(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateColour$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateColour,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].updateColourSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].updateColourFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function deleteColour(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteColour$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteColour,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].deleteColourSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_ColourRedux__["b" /* default */].deleteColourFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getBrand;
/* harmony export (immutable) */ __webpack_exports__["a"] = createBrand;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateBrand;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteBrand;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSingleBrand;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCategoryBrand;
/* harmony export (immutable) */ __webpack_exports__["h"] = updateCategoryBrand;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteCategoryBrand;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getBrand),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createBrand),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateBrand),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteBrand),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSingleBrand),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createCategoryBrand),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateCategoryBrand),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteCategoryBrand);function getBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getBrand$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].getBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].getBrandFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function createBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createBrand$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createBrandFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateBrand$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].updateBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].updateBrandFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteBrand$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].deleteBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].deleteBrandFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function getSingleBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSingleBrand$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSingleBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].getSingleBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].getSingleBrandFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function createCategoryBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createCategoryBrand$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createCategoryBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createCategoryBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].createCategoryBrandFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function updateCategoryBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateCategoryBrand$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateCategoryBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].updateCategoryBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].updateCategoryBrandFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}function deleteCategoryBrand(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteCategoryBrand$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteCategoryBrand,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].deleteCategoryBrandSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_BrandRedux__["b" /* default */].deleteCategoryBrandFailure);case 2:case'end':return _context8.stop();}}},_marked8,this);}

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getWarehouse;
/* harmony export (immutable) */ __webpack_exports__["a"] = createWarehouse;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateWarehouse;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteWarehouse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getWarehouse),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createWarehouse),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateWarehouse),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteWarehouse);function getWarehouse(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getWarehouse$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getWarehouse,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].getWarehouseSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].getWarehouseFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function createWarehouse(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createWarehouse$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createWarehouse,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].createWarehouseSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].createWarehouseFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateWarehouse(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateWarehouse$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateWarehouse,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].updateWarehouseSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].updateWarehouseFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteWarehouse(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteWarehouse$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteWarehouse,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].deleteWarehouseSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_WarehouseRedux__["b" /* default */].deleteWarehouseFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getInventory;
/* harmony export (immutable) */ __webpack_exports__["d"] = getInventoryCustom;
/* harmony export (immutable) */ __webpack_exports__["a"] = createInventory;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateInventory;
/* harmony export (immutable) */ __webpack_exports__["f"] = updateInventoryImage;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteInventory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getInventory),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getInventoryCustom),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createInventory),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateInventory),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateInventoryImage),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteInventory);function getInventory(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getInventory$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getInventory,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventoryFailure('GET_INVENTORY_FAILURE'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventorySuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventoryFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventoryFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getInventoryCustom(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getInventoryCustom$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getInventoryCustom,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventoryCustomSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].getInventoryCustomFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createInventory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createInventory$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createInventory,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].createInventorySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].createInventoryFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateInventory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateInventory$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateInventory,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].updateInventorySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].updateInventoryFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updateInventoryImage(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateInventoryImage$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateInventoryImage,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].updateInventoryImageSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].updateInventoryImageFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function deleteInventory(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteInventory$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteInventory,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].deleteInventorySuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_InventoryRedux__["b" /* default */].deleteInventoryFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSupplier;
/* harmony export (immutable) */ __webpack_exports__["a"] = createSupplier;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateSupplier;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteSupplier;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSupplier),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createSupplier),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateSupplier),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSupplier);function getSupplier(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSupplier$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSupplier,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].getSupplierSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].getSupplierFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function createSupplier(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createSupplier$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.createSupplier,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].createSupplierSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].createSupplierFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateSupplier(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateSupplier$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updateSupplier,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].updateSupplierSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].updateSupplierFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteSupplier(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSupplier$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteSupplier,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].deleteSupplierSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SupplierRedux__["b" /* default */].deleteSupplierFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getProvince;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCities;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDistricts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProvince),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCities),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getDistricts);function getProvince(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProvince$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getProvince,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getProvinceSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getProvinceFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getCities(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCities$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getCities,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getCitySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getCityFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function getDistricts(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getDistricts$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getDistricts,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getDistrictSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_LocationRedux__["b" /* default */].getDistrictFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getEcommerceProduct;
/* harmony export (immutable) */ __webpack_exports__["f"] = viewEcommerceProduct;
/* harmony export (immutable) */ __webpack_exports__["a"] = createEcommerceProduct;
/* harmony export (immutable) */ __webpack_exports__["b"] = createEcommerceProductStock;
/* harmony export (immutable) */ __webpack_exports__["e"] = updateEcommerceProduct;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteEcommerceProduct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEcommerceProduct),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(viewEcommerceProduct),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createEcommerceProduct),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createEcommerceProductStock),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateEcommerceProduct),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteEcommerceProduct);function getEcommerceProduct(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEcommerceProduct$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getEcommerceProduct,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].getEcommerceProductFailure('GET_ECOMMERCE_PRODUCT_FAILURE'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].getEcommerceProductSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].getEcommerceProductFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].getEcommerceProductFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function viewEcommerceProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function viewEcommerceProduct$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.viewEcommerceProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].viewEcommerceProductSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].viewEcommerceProductFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function createEcommerceProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createEcommerceProduct$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createEcommerceProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function createEcommerceProductStock(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createEcommerceProductStock$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.createEcommerceProductStock,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductStockSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].createEcommerceProductStockFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function updateEcommerceProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateEcommerceProduct$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.updateEcommerceProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].updateEcommerceProductSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].updateEcommerceProductFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function deleteEcommerceProduct(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteEcommerceProduct$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteEcommerceProduct,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].deleteEcommerceProductSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceProductRedux__["b" /* default */].deleteEcommerceProductFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getEcommerceOrder;
/* harmony export (immutable) */ __webpack_exports__["c"] = getEcommerceOrderShipping;
/* harmony export (immutable) */ __webpack_exports__["d"] = postEcommerceOrderShipping;
/* harmony export (immutable) */ __webpack_exports__["e"] = putEcommerceOrderShipping;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteEcommerceOrderShipping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEcommerceOrder),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEcommerceOrderShipping),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postEcommerceOrderShipping),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putEcommerceOrderShipping),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteEcommerceOrderShipping);function getEcommerceOrder(api,action){var token,res,page,total,DATA_WITH_PAGE;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEcommerceOrder$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_4__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getEcommerceOrder,token,action.filter);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderFailure('ERR_MSG_GET_ECOMMERCE_ORDER'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;DATA_WITH_PAGE={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderSuccess(DATA_WITH_PAGE));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].orderFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function getEcommerceOrderShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEcommerceOrderShipping$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.getEcommerceOrderShipping,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderShippingSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].getEcommerceOrderShippingFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function postEcommerceOrderShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postEcommerceOrderShipping$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.postEcommerceOrderShipping,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].postEcommerceOrderShippingSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].postEcommerceOrderShippingFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function putEcommerceOrderShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putEcommerceOrderShipping$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.putEcommerceOrderShipping,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].putEcommerceOrderShippingSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].putEcommerceOrderShippingFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function deleteEcommerceOrderShipping(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteEcommerceOrderShipping$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2__BaseSaga__["b" /* baseFetchToken */])(api.deleteEcommerceOrderShipping,action.data,__WEBPACK_IMPORTED_MODULE_5__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].deleteEcommerceOrderShippingSuccess,__WEBPACK_IMPORTED_MODULE_3__Redux_EcommerceOrderRedux__["b" /* default */].deleteEcommerceOrderShippingFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSection;
/* harmony export (immutable) */ __webpack_exports__["d"] = postSection;
/* harmony export (immutable) */ __webpack_exports__["f"] = putSection;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteSection;
/* harmony export (immutable) */ __webpack_exports__["e"] = postSubSection;
/* harmony export (immutable) */ __webpack_exports__["g"] = putSubSection;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteSubSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSection),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postSection),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putSection),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSection),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postSubSection),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putSubSection),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSubSection);function getSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSection$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].getSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].getSectionFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function postSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postSection$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].postSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].postSectionFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function putSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putSection$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSectionFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSection$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSectionFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function postSubSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postSubSection$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postSubSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].postSubSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].postSubSectionFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function putSubSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putSubSection$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putSubSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSubSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].putSubSectionFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function deleteSubSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSubSection$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteSubSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSubSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SectionRedux__["b" /* default */].deleteSubSectionFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getAttractionPromo;
/* harmony export (immutable) */ __webpack_exports__["c"] = postAttractionPromo;
/* harmony export (immutable) */ __webpack_exports__["d"] = putAttractionPromo;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteAttractionPromo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAttractionPromo),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postAttractionPromo),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putAttractionPromo),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteAttractionPromo);function getAttractionPromo(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAttractionPromo$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getAttractionPromo,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].attractionPromoSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].attractionPromoFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function postAttractionPromo(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postAttractionPromo$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postAttractionPromo,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].postAttractionPromoSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].postAttractionPromoFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function putAttractionPromo(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putAttractionPromo$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putAttractionPromo,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].putAttractionPromoSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].putAttractionPromoFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function deleteAttractionPromo(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteAttractionPromo$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteAttractionPromo,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].deleteAttractionPromoSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_AttractionPromoRedux__["b" /* default */].deleteAttractionPromoFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFailedTransaction;
/* harmony export (immutable) */ __webpack_exports__["b"] = triggerFailedTransaction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_FailedTransactionRedux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getFailedTransaction),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(triggerFailedTransaction);function getFailedTransaction(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getFailedTransaction$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getFailedTransaction,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_FailedTransactionRedux__["b" /* default */].getFailedTransactionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_FailedTransactionRedux__["b" /* default */].getFailedTransactionFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function triggerFailedTransaction(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function triggerFailedTransaction$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.triggerFailedTransaction,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_FailedTransactionRedux__["b" /* default */].triggerFailedTransactionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_FailedTransactionRedux__["b" /* default */].triggerFailedTransactionFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getScheduler;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSchedulerDetail;
/* harmony export (immutable) */ __webpack_exports__["d"] = postScheduler;
/* harmony export (immutable) */ __webpack_exports__["e"] = putScheduler;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteScheduler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getScheduler),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSchedulerDetail),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(postScheduler),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putScheduler),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteScheduler);function getScheduler(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getScheduler$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getScheduler,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].getSchedulerSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].getSchedulerFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getSchedulerDetail(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSchedulerDetail$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getSchedulerDetail,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].getSchedulerDetailSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].getSchedulerDetailFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function postScheduler(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function postScheduler$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.postScheduler,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].postSchedulerSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].postSchedulerFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function putScheduler(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putScheduler$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putScheduler,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].putSchedulerSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].putSchedulerFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function deleteScheduler(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteScheduler$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteScheduler,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].deleteSchedulerSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_SchedulerRedux__["b" /* default */].deleteSchedulerFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getCronReport;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCronReportItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = disableAttraction;
/* harmony export (immutable) */ __webpack_exports__["c"] = enableAttraction;
/* harmony export (immutable) */ __webpack_exports__["f"] = getWhitelist;
/* harmony export (immutable) */ __webpack_exports__["g"] = putWhitelist;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteWhitelist;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCronReport),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getCronReportItem),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(disableAttraction),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(enableAttraction),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getWhitelist),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(putWhitelist),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteWhitelist);function getCronReport(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCronReport$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getCronReport,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getCronReportSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getCronReportFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function getCronReportItem(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getCronReportItem$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["c" /* baseFetchTokenFullResponse */])(api.getCronReportItem,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getCronReportItemSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getCronReportItemFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function disableAttraction(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function disableAttraction$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.disableAttraction,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].disableAttractionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].disableAttractionFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function enableAttraction(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function enableAttraction$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.enableAttraction,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].enableAttractionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].enableAttractionFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}function getWhitelist(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getWhitelist$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getWhitelist,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getWhitelistSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].getWhitelistFailure);case 2:case'end':return _context5.stop();}}},_marked5,this);}function putWhitelist(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function putWhitelist$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.putWhitelist,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].putWhitelistSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].putWhitelistFailure);case 2:case'end':return _context6.stop();}}},_marked6,this);}function deleteWhitelist(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteWhitelist$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.deleteWhitelist,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].deleteWhitelistSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_CronReportRedux__["b" /* default */].deleteWhitelistFailure);case 2:case'end':return _context7.stop();}}},_marked7,this);}

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPromoSection;
/* harmony export (immutable) */ __webpack_exports__["b"] = updatePromoSection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseSaga__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_PromoSectionRedux__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Services_GetToken__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPromoSection),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updatePromoSection);function getPromoSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPromoSection$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.getPromoSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PromoSectionRedux__["b" /* default */].getPromoSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PromoSectionRedux__["b" /* default */].getPromoSectionFailure);case 2:case'end':return _context.stop();}}},_marked,this);}function updatePromoSection(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updatePromoSection$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__BaseSaga__["b" /* baseFetchToken */])(api.updatePromoSection,action.data,__WEBPACK_IMPORTED_MODULE_3__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_PromoSectionRedux__["b" /* default */].updatePromoSectionSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_PromoSectionRedux__["b" /* default */].updatePromoSectionFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllEsims;
/* harmony export (immutable) */ __webpack_exports__["c"] = updateEsimData;
/* harmony export (immutable) */ __webpack_exports__["b"] = updateEsimCountry;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateEsimVarian;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Services_GetToken__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BaseSaga__ = __webpack_require__(14);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAllEsims),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateEsimData),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateEsimCountry),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateEsimVarian);function getAllEsims(api,action){var token,res,page,total,paginatedData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAllEsims$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */]);case 3:token=_context.sent;if(token){_context.next=9;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3__Redux_AuthRedux__["b" /* default */].authLogout());case 7:_context.next=27;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(api.getAllEsims,token,action.data);case 11:res=_context.sent;if(res.ok){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].getAllEsimsFailure('Terjadi kesalahan, ulangi beberapa saat lagi'));case 15:_context.next=27;break;case 17:if(res.data.error){_context.next=25;break;}page=parseInt(res.data.meta.page,10);total=res.data.meta.count;paginatedData={data:res.data.data,page:page,total:total};_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].getAllEsimsSuccess(paginatedData));case 23:_context.next=27;break;case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].getAllEsimsFailure(res.data.message));case 27:_context.next=33;break;case 29:_context.prev=29;_context.t0=_context['catch'](0);_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].getAllEsimsFailure());case 33:case'end':return _context.stop();}}},_marked,this,[[0,29]]);}function updateEsimData(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateEsimData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__BaseSaga__["b" /* baseFetchToken */])(api.updateEsimData,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateFailure);case 2:case'end':return _context2.stop();}}},_marked2,this);}function updateEsimCountry(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateEsimCountry$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__BaseSaga__["b" /* baseFetchToken */])(api.updateEsimCountry,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateCountrySuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateCountryFailure);case 2:case'end':return _context3.stop();}}},_marked3,this);}function updateEsimVarian(api,action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateEsimVarian$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__BaseSaga__["b" /* baseFetchToken */])(api.updateEsimVariant,action.data,__WEBPACK_IMPORTED_MODULE_4__Services_GetToken__["a" /* getToken */],__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateVariantSuccess,__WEBPACK_IMPORTED_MODULE_2__Redux_EsimRedux__["b" /* default */].esimUpdateVariantFailure);case 2:case'end':return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apisauce__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apisauce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_apisauce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Config_AppConfig__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
// a library to wrap and simplify api calls
var apiURL=__WEBPACK_IMPORTED_MODULE_1__Config_AppConfig__["a" /* default */].apiURL;// our "constructor"
var create=function create(){var baseURL=arguments.length>0&&arguments[0]!==undefined?arguments[0]:apiURL;// ------
// STEP 1
// ------
//
// Create and configure an apisauce-based api object.
//
var apiWrapper=__WEBPACK_IMPORTED_MODULE_0_apisauce___default.a.create({// base URL is read from the "constructor"
baseURL:apiURL,// 10 second timeout... | extended timeout to 1 minute
timeout:60000});var headerWithToken=function headerWithToken(Authorization){return{headers:{Authorization:Authorization}};};// Wrap api's addMonitor to allow the calling code to attach
// additional monitors in the future.  But only in __DEV__ and only
// if we've attached Reactotron to console (it isn't during unit tests).
if(__WEBPACK_IMPORTED_MODULE_1__Config_AppConfig__["a" /* default */].NODE_ENV==='development'){var naviMonitor=function naviMonitor(response){return console.log('DEBUG RESPONSE:',response);};apiWrapper.addMonitor(naviMonitor);}// ------
// STEP 2
// ------
//
// Define some functions that call the api.  The goal is to provide
// a thin wrapper of the api layer providing nicer feeling functions
// rather than "get", "post" and friends.
//
// I generally don't like wrapping the output at this level because
// sometimes specific actions need to be take on `403` or `401`, etc.
//
// Since we can't hide from that, we embrace it by getting out of the
// way at this level.
//
// example get data
var getUserData=function getUserData(userId){return apiWrapper.get('/users/'+userId);};// example get data with token
var getDatawithToken=function getDatawithToken(token){return apiWrapper.get('/url/',{},headerWithToken(token));};// example post data
var postData=function postData(data){return apiWrapper.post('/url/action',{data:data});};// PRESET
var getCurrencies=function getCurrencies(){return apiWrapper.get('/presets/currencies');};var getLanguages=function getLanguages(){return apiWrapper.get('/presets/languages');};var getCountries=function getCountries(){return apiWrapper.get('/locations/countries');};var getPresetOrder=function getPresetOrder(){var filter={currency_code:Object(__WEBPACK_IMPORTED_MODULE_4__Utils_PrivilegeUtils__["b" /* currentCurrency */])()};return apiWrapper.get('/presets/orders',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter));};var updatePresetOrder=function updatePresetOrder(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/presets/orders',data,headerWithToken('JWT '+token));};// WIP PRESET BRANCH
var getBranch=function getBranch(token){return apiWrapper.get('/presets/branches',null,headerWithToken('JWT '+token));};var updateBranch=function updateBranch(token,data){return apiWrapper.put('/presets/branches',data,headerWithToken('JWT '+token));};// PRESET SHIPPING
var getShipping=function getShipping(){return apiWrapper.get('/presets/shippings');};var updateShipping=function updateShipping(token,data){return apiWrapper.put('presets/shippings',data,headerWithToken('JWT '+token));};// AUTH COLLECTIONS
var login=function login(data){return apiWrapper.post('/auth/login',data);};var checkLogin=function checkLogin(token){return apiWrapper.get('/users/me',{},headerWithToken('JWT '+token));};// DESTINATION COLLECTIONS
var getDestination=function getDestination(token){return apiWrapper.get('/destinations',{},headerWithToken('JWT '+token));};var createDestination=function createDestination(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/destinations',data,headerWithToken('JWT '+token));};var deleteDestination=function deleteDestination(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/destinations/'+data.id,{},headerWithToken('JWT '+token));};var updateDestination=function updateDestination(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/destinations/'+data.id,data.content,headerWithToken('JWT '+token));};var addAttractionToDestination=function addAttractionToDestination(token,data){return apiWrapper.post('/destinations/'+data.destination_id+'/attractions',{attractions_ids:data.attraction_id},headerWithToken('JWT '+token));};var deleteAttractionFromDestination=function deleteAttractionFromDestination(token,data){return apiWrapper.delete('/destinations/'+data.destination_id+'/attractions/'+data.attraction_id,null,headerWithToken('JWT '+token));};var getContinent=function getContinent(token){return apiWrapper.get('/locations',null,headerWithToken('JWT '+token));};// PLACES MAPPING
var addPlaceToDestination=function addPlaceToDestination(token,data){return apiWrapper.post('/destinations/'+data.destination_id+'/places',{places:data.places},headerWithToken('JWT '+token));};var deletePlaceFromDestination=function deletePlaceFromDestination(token,data){return apiWrapper.delete('/destinations/'+data.destination_id+'/places/'+data.place_id+'/'+data.type,null,headerWithToken('JWT '+token));};var getPlacesV2=function getPlacesV2(token,_ref){var destination=_ref.destination,provider=_ref.provider,page=_ref.page,q=_ref.q;var filter={provider:provider,page:page,q:q};return apiWrapper.get('/places/destinations/'+destination,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getPlacesByDestination=function getPlacesByDestination(token,data){var filter={page:1,limit:null,language_code:'EN',currency_code:'IDR',order:'title',// type: null,
type:'attraction',provider:'BMG',date:null};if(data){filter=Object.assign({},filter,data.filter);}var destination=null;if(data.destination){__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('savedDestinationId',data.destination);destination=data.destination;}else{destination=__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('savedDestinationId');}return apiWrapper.get('/places/destinations/'+destination,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var searchPlaces=function searchPlaces(token,_ref2){var _ref2$q=_ref2.q,q=_ref2$q===undefined?null:_ref2$q,_ref2$page=_ref2.page,page=_ref2$page===undefined?1:_ref2$page,_ref2$limit=_ref2.limit,limit=_ref2$limit===undefined?10:_ref2$limit,_ref2$language_code=_ref2.language_code,language_code=_ref2$language_code===undefined?'EN':_ref2$language_code,_ref2$currency_code=_ref2.currency_code,currency_code=_ref2$currency_code===undefined?'IDR':_ref2$currency_code,_ref2$attraction_type=_ref2.attraction_type_id,attraction_type_id=_ref2$attraction_type===undefined?null:_ref2$attraction_type,_ref2$order=_ref2.order,order=_ref2$order===undefined?null:_ref2$order,_ref2$date=_ref2.date,date=_ref2$date===undefined?null:_ref2$date,_ref2$c=_ref2.c,c=_ref2$c===undefined?null:_ref2$c,_ref2$provider=_ref2.provider,provider=_ref2$provider===undefined?null:_ref2$provider;var params={q:q,page:page,limit:limit,language_code:language_code,currency_code:currency_code,attraction_type_id:attraction_type_id,order:order,date:date,c:c,provider:provider};return apiWrapper.get('/search-places',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(params),headerWithToken('JWT '+token));};// ATTRACTION COLLECTIONS
var getAttractionByDestination=function getAttractionByDestination(token,data){var filter={page:1,limit:null,language_code:'',currency_code:'',// order: 'title',
date:null};if(data){filter=Object.assign({},filter,data.filter);}var destination=null;if(data.destination){__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('savedDestinationId',data.destination);destination=data.destination;}else{destination=__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('savedDestinationId');}return apiWrapper.get('v2/attractions/destinations/'+destination,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getAttractionDetail=function getAttractionDetail(token,_ref3){var id=_ref3.id,filter=_ref3.filter;return apiWrapper.get('/attractions/'+id,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getPlaceDetail=function getPlaceDetail(token,data){var filter={language_code:'EN',currency_code:'IDR',date:null};if(data){filter=Object.assign({},filter,data.filter);}var id=null;if(data){__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.set('getAttractionDetail',data.id);id=data.id;}else{id=__WEBPACK_IMPORTED_MODULE_3_js_cookie___default.a.get('getAttractionDetail');}return apiWrapper.get('/landmarks/'+id,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var updateAttractionDetail=function updateAttractionDetail(token,_ref4){var _ref4$id=_ref4.id,id=_ref4$id===undefined?null:_ref4$id,_ref4$form=_ref4.form,form=_ref4$form===undefined?{}:_ref4$form;var body=Object.assign({is_ignored_on_update:true},form);return apiWrapper.put('/attractions/'+id,body,headerWithToken('JWT '+token));};var searchAttraction=function searchAttraction(token,_ref5){var _ref5$q=_ref5.q,q=_ref5$q===undefined?null:_ref5$q,_ref5$page=_ref5.page,page=_ref5$page===undefined?1:_ref5$page,_ref5$limit=_ref5.limit,limit=_ref5$limit===undefined?10:_ref5$limit,_ref5$language_code=_ref5.language_code,language_code=_ref5$language_code===undefined?'EN':_ref5$language_code,_ref5$currency_code=_ref5.currency_code,currency_code=_ref5$currency_code===undefined?'IDR':_ref5$currency_code,_ref5$attraction_type=_ref5.attraction_type_id,attraction_type_id=_ref5$attraction_type===undefined?null:_ref5$attraction_type,_ref5$order=_ref5.order,order=_ref5$order===undefined?null:_ref5$order,_ref5$date=_ref5.date,date=_ref5$date===undefined?null:_ref5$date,_ref5$c=_ref5.c,c=_ref5$c===undefined?null:_ref5$c,_ref5$provider=_ref5.provider,provider=_ref5$provider===undefined?null:_ref5$provider;var params={q:q,page:page,limit:limit,language_code:language_code,currency_code:currency_code,attraction_type_id:attraction_type_id,order:order,date:date,c:c,provider:provider};return apiWrapper.get('/search',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(params),headerWithToken('JWT '+token));};var clearAttractionCache=function clearAttractionCache(token){return apiWrapper.get('/admin/clearCache',null,headerWithToken('JWT '+token));};var downloadAttractionData=function downloadAttractionData(token,filter){filter=Object.assign({destinationId:null},filter);var params=[];if(filter.destinationId){params.push('destinationId='+filter.destinationId);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/attractions/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='passpod_bmg_attraction_data.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success downloading attraction data',status:true};});};// FILES COLLECTIONS
var uploadFiles=function uploadFiles(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/files',data,headerWithToken('JWT '+token));};// POPULAR ATTRACTION
var getPopularAttraction=function getPopularAttraction(token,_ref6){var _ref6$modifier=_ref6.modifier,modifier=_ref6$modifier===undefined?'origin':_ref6$modifier,_ref6$modifier_value=_ref6.modifier_value,modifier_value=_ref6$modifier_value===undefined?'id':_ref6$modifier_value;return apiWrapper.get('v2/attractions/populars/'+modifier+'/'+modifier_value,null,headerWithToken('JWT '+token));};var savePopularAttraction=function savePopularAttraction(token,data){return apiWrapper.post('/attractions/populars',data,headerWithToken('JWT '+token));};var deletePopularAttraction=function deletePopularAttraction(token,id){return apiWrapper.delete('/attractions/populars/'+id,null,headerWithToken('JWT '+token));};var editPopularAttraction=function editPopularAttraction(token,data){return apiWrapper.put('/attractions/populars/'+data.id,data.form,headerWithToken('JWT '+token));};// COUPON COLLECTIONS
var getAllCoupon=function getAllCoupon(token,filter){filter['show_claimers']=true;filter['show_history']=true;filter['complete_history']=true;return apiWrapper.get('/coupons',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getCouponDetail=function getCouponDetail(token){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{id:null,filter:{}};var filter=Object.assign({},data.filter);filter['show_history']=true;filter['complete_history']=true;return apiWrapper.get('/coupons/'+data.id,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getAllCouponTag=function getAllCouponTag(token,filter){filter['show_stats']=true;filter['type']='BUSINESS';return apiWrapper.get('/coupons/tags',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createNewCoupon=function createNewCoupon(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupons',data,headerWithToken('JWT '+token));};var updateCoupon=function updateCoupon(token,_ref7){var id=_ref7.id,form=_ref7.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/coupons/'+id,form,headerWithToken('JWT '+token));};var updateBusiness=function updateBusiness(token,_ref8){var tag=_ref8.tag,form=_ref8.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/coupons/tags/'+tag,form,headerWithToken('JWT '+token));};var deleteCoupon=function deleteCoupon(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/coupons/'+id,null,headerWithToken('JWT '+token));};var deleteBusiness=function deleteBusiness(token,_ref9){var tag=_ref9.tag,body=_ref9.body;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/coupons/tags/'+tag,body,headerWithToken('JWT '+token));};var generateCoupon=function generateCoupon(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupons/tools/generate-coupon',data,headerWithToken('JWT '+token));};var couponSpreadsheet=function couponSpreadsheet(token){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{type:null,tag:null};var params=[];if(data.type){params.push('type='+data.type);}if(data.tag){params.push('tag='+data.tag);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/coupons/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download=data.tag+'-'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'-coupon-list.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success getting coupon tags list',status:true};});};var historySpreadsheet=function historySpreadsheet(token){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{type:null,tag:null};var params=[];if(data.type){params.push('type='+data.type);}if(data.tag){params.push('tag='+data.tag);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/coupons/spreadsheet?'+params.join('&')+'&used=1',responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download=data.tag+'-'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'-coupon-history.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success getting coupon history list',status:true};});};// INDIVIDUAL COUPON COLLECTIONS
var getCouponItem=function getCouponItem(token,data){return apiWrapper.get('/coupons/'+data.uuid+'/items/',null,headerWithToken('JWT '+token));};var postCouponItem=function postCouponItem(token,_ref10){var uuid=_ref10.uuid,form=_ref10.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupons/'+uuid+'/items',form,headerWithToken('JWT '+token));};var postCouponItemTag=function postCouponItemTag(token,_ref11){var tag=_ref11.tag,form=_ref11.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupons-business/tags/'+tag,form,headerWithToken('JWT '+token));};var deleteCouponItem=function deleteCouponItem(token,_ref12){var couponUUID=_ref12.couponUUID,couponItemId=_ref12.couponItemId;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/coupons/'+couponUUID+'/items/'+couponItemId,null,headerWithToken('JWT '+token));};var deleteCouponItemTag=function deleteCouponItemTag(token,_ref13){var tagName=_ref13.tagName,couponItemId=_ref13.couponItemId;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/coupons-business/tags/'+tagName+'/'+couponItemId,null,headerWithToken('JWT '+token));};// COUPON PROVIDER COLLECTIONS
var getCouponProvider=function getCouponProvider(token,filter){return apiWrapper.get('/coupon-providers/',null,headerWithToken('JWT '+token));};var postCouponProvider=function postCouponProvider(token,form){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupon-providers/',form,headerWithToken('JWT '+token));};var putCouponProvider=function putCouponProvider(token,_ref14){var id=_ref14.id,form=_ref14.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/coupon-providers/'+id,form,headerWithToken('JWT '+token));};var deleteCouponProvider=function deleteCouponProvider(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/coupon-providers/'+id,null,headerWithToken('JWT '+token));};// COUPON PRESET COLLECTIONS
var getCouponPreset=function getCouponPreset(token,filter){return apiWrapper.get('/coupon-providers/preset',null,headerWithToken('JWT '+token));};var postCouponPreset=function postCouponPreset(token,form){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupon-providers/preset',form,headerWithToken('JWT '+token));};var putCouponPreset=function putCouponPreset(token,_ref15){var id=_ref15.id,form=_ref15.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/coupon-providers/preset/'+id,form,headerWithToken('JWT '+token));};var deleteCouponPreset=function deleteCouponPreset(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/coupon-providers/preset/'+id,null,headerWithToken('JWT '+token));};// COUPON AFFILIATES (pisces)
var getAffiliates=function getAffiliates(token,filter){return apiWrapper.get('/coupons/affiliates',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var affiliateTransfer=function affiliateTransfer(token,_ref16){var uuid=_ref16.uuid,form=_ref16.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/coupons/affiliates/'+uuid,form,headerWithToken('JWT '+token));};// PRODUCT COLLECTIONS
var getProduct=function getProduct(token,filter){filter=Object.assign({// type: null,
// sort: 'title',
// currency_code: 'IDR',
// page: 1,
// q: null,
limit:10},filter);return apiWrapper.get('/products',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createProduct=function createProduct(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/products',data,headerWithToken('JWT '+token));};var deleteProduct=function deleteProduct(token,data){return apiWrapper.delete('/products/'+data.id,null,headerWithToken('JWT '+token));};var updateProduct=function updateProduct(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/products/'+data.id,data.form,headerWithToken('JWT '+token));};var getProductCountry=function getProductCountry(token,data){return apiWrapper.get('/products/'+data.uuid+'/countries',null,headerWithToken('JWT '+token));};var postProductCountry=function postProductCountry(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/products/set-country',data,headerWithToken('JWT '+token));};var deleteProductCountry=function deleteProductCountry(token,_ref17){var uuid=_ref17.uuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/products/countries/'+uuid,null,headerWithToken('JWT '+token));};var getProductCampaign=function getProductCampaign(token,_ref18){var uuid=_ref18.uuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/products/'+uuid+'/campaigns',null,headerWithToken('JWT '+token));};var postProductCampaign=function postProductCampaign(token,_ref19){var form=_ref19.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/products/campaigns',form,headerWithToken('JWT '+token));};var putProductCampaign=function putProductCampaign(token,_ref20){var form=_ref20.form,variantUUID=_ref20.variantUUID;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/products/campaigns/'+variantUUID,form,headerWithToken('JWT '+token));};var deleteProductCampaign=function deleteProductCampaign(token,_ref21){var variantUUID=_ref21.variantUUID;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/products/campaigns/'+variantUUID,null,headerWithToken('JWT '+token));};var getProductVariant=function getProductVariant(token,_ref22){var product_id=_ref22.product_id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/products/'+product_id+'/variants',null,headerWithToken('JWT '+token));};var postProductVariant=function postProductVariant(token,_ref23){var form=_ref23.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/products/variants',form,headerWithToken('JWT '+token));};var putProductVariant=function putProductVariant(token,_ref24){var form=_ref24.form,id=_ref24.id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/products/variants/'+id,form,headerWithToken('JWT '+token));};var deleteProductVariant=function deleteProductVariant(token,_ref25){var id=_ref25.id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/products/variants/'+id,null,headerWithToken('JWT '+token));};var getProductVariantItem=function getProductVariantItem(token,_ref26){var variant_id=_ref26.variant_id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/products/variants/'+variant_id+'/items',null,headerWithToken('JWT '+token));};var postProductVariantItem=function postProductVariantItem(token,_ref27){var variant_id=_ref27.variant_id,form=_ref27.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/products/variants/'+variant_id+'/items',form,headerWithToken('JWT '+token));};var deleteProductVariantItem=function deleteProductVariantItem(token,_ref28){var productvariantitemuuid=_ref28.productvariantitemuuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/products/variants/items/'+productvariantitemuuid,null,headerWithToken('JWT '+token));};// E-SIM Collecteopn
var getAllEsims=function getAllEsims(token,filter){filter=Object.assign({page:1,limit:10},filter);return apiWrapper.get('/esim',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var updateEsimData=function updateEsimData(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/esim/'+data.id,data.form,headerWithToken('JWT '+token));};var updateEsimCountry=function updateEsimCountry(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/esim/'+data.id+'/countries',data.form,headerWithToken('JWT '+token));};var updateEsimVariant=function updateEsimVariant(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/esim/'+data.id+'/variants/'+data.variant_id,data.form,headerWithToken('JWT '+token));};// EVENTS COLLECTIONS
var getAllEvents=function getAllEvents(token,filter){filter=Object.assign({page:1,limit:10},filter);return apiWrapper.get('/events',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getEventsCategories=function getEventsCategories(token,filter){filter=Object.assign({page:1,limit:12},filter);return apiWrapper.get('/events/categories',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getAllPopularEvents=function getAllPopularEvents(token,filter){return apiWrapper.get('/events/popular',null,headerWithToken('JWT '+token));};var setPopularEvent=function setPopularEvent(token,_ref29){var event_id=_ref29.event_id,form=_ref29.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/event/popular/'+event_id,form,headerWithToken('JWT '+token));};var resetEventDescription=function resetEventDescription(token,_ref30){var event_id=_ref30.event_id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/event/'+event_id+'?reset=true',null,headerWithToken('JWT '+token));};var updateEventDescription=function updateEventDescription(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/event/'+data.event_id,data,headerWithToken('JWT '+token));};// INSURANCE COLLECTIONS: TRAVEL PACKAGE
var getTravelPackage=function getTravelPackage(token){return apiWrapper.get('/travel-packages-admin',null,headerWithToken('JWT '+token));};var postTravelPackage=function postTravelPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/travel-packages',data,headerWithToken('JWT '+token));};var putTravelPackage=function putTravelPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/travel-packages/'+data.id,data.form,headerWithToken('JWT '+token));};var deleteTravelPackage=function deleteTravelPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/travel-packages/'+data.id,data.form,headerWithToken('JWT '+token));};// INSURANCE COLLECTIONS: TRAVEL PACKAGE PRICE
var viewTravelPackage=function viewTravelPackage(token,data){return apiWrapper.get('/travel-packages-admin/'+data.id,null,headerWithToken('JWT '+token));};var putTravelPackagePrice=function putTravelPackagePrice(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/travel-packages/'+data.parent_id+'/prices/'+data.child_id,data.form,headerWithToken('JWT '+token));};var postTravelPackagePrice=function postTravelPackagePrice(token,data){return apiWrapper.post('/travel-packages/'+data.id+'/prices',data.form,headerWithToken('JWT '+token));};var switchTravelPackagePrice=function switchTravelPackagePrice(token,_ref31){var parent_id=_ref31.parent_id,child_id=_ref31.child_id,form=_ref31.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/travel-packages/'+parent_id+'/prices/'+child_id,form,headerWithToken('JWT '+token));};// INSURANCE COLLECTIONS: TICKET PACKAGE
var getTicketPackage=function getTicketPackage(token){return apiWrapper.get('/ticket-packages',null,headerWithToken('JWT '+token));};var postTicketPackage=function postTicketPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/ticket-packages',data,headerWithToken('JWT '+token));};var putTicketPackage=function putTicketPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/ticket-packages/'+data.id,data.form,headerWithToken('JWT '+token));};var deleteTicketPackage=function deleteTicketPackage(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/ticket-packages/'+data.id,data.form,headerWithToken('JWT '+token));};// BANNER COLLECTIONS
var getBanners=function getBanners(token,filter){filter=Object.assign({platform:null,q:null,iso_code:null},filter);return apiWrapper.get('/banners',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createBanner=function createBanner(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/banners',data,headerWithToken('JWT '+token));};var deleteBanner=function deleteBanner(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/banners/'+data.id,null,headerWithToken('JWT '+token));};var updateBanner=function updateBanner(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/banners/'+data.id,data.form,headerWithToken('JWT '+token));};// MARKUP COLLECTIONS
var getMarkup=function getMarkup(token){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{q:'',page:1,sort:'value'};apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/markup-prices',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createMarkup=function createMarkup(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/markup-prices',data,headerWithToken('JWT '+token));};var updateMarkup=function updateMarkup(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/markup-prices/'+data.id,data.form,headerWithToken('JWT '+token));};var deleteMarkup=function deleteMarkup(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/markup-prices/'+data.id,null,headerWithToken('JWT '+token));};// MARKUP COLLECTIONS - INDIVIDUAL PACKAGE
var markupItemCreate=function markupItemCreate(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/markup-prices/items',data.form,headerWithToken('JWT '+token));};var markupItemUpdate=function markupItemUpdate(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/markup-prices/items/'+data.uuid,data.form,headerWithToken('JWT '+token));};var markupItemDelete=function markupItemDelete(token,data){return apiWrapper.delete('/markup-prices/items/'+data.uuid,null,headerWithToken('JWT '+token));};var markupItemGet=function markupItemGet(token,data){return apiWrapper.get('/markup-prices/'+data.id,null,headerWithToken('JWT '+token));};// EXCHANGE RATE COLLECTIONS
var getExchangeRate=function getExchangeRate(token){return apiWrapper.get('/exchange-rates',null,headerWithToken('JWT '+token));};var getSingleExchangeRate=function getSingleExchangeRate(token,data){return apiWrapper.get('/exchange-rates/'+data.id,null,headerWithToken('JWT '+token));};var updateExchangeRate=function updateExchangeRate(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/exchange-rates/'+data.id,data.form,headerWithToken('JWT '+token));};// ORDERS COLLECTIONS
var getOrder=function getOrder(token,filter){filter=Object.assign({page:1,limit:10,from:null,type:'all',inventory_type:'',until:null,q:'',status:'',order_status:null,payment_method:'',transaction_amount_from:'',transaction_amount_to:''},filter);apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/orders',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getOrderSingle=function getOrderSingle(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/orders/'+id,null,headerWithToken('JWT '+token));};var getChatbotOrder=function getChatbotOrder(token,filter){return apiWrapper.get('/chatbot/orders',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var postChatbotOrder=function postChatbotOrder(token,_ref32){var uuid=_ref32.uuid,form=_ref32.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/chatbot/orders/'+uuid+'/confirm',form,headerWithToken('JWT '+token));};var getOrderDetailList=function getOrderDetailList(token,filter){filter=Object.assign({page:1,limit:10,created_from:null,created_until:null,type:'',status:''},filter);apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/orders',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var confirmOrder=function confirmOrder(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/orders/'+data.id+'/confirm',data.form,headerWithToken('JWT '+token));};var updateOrder=function updateOrder(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/orders/'+data.id,data.form,headerWithToken('JWT '+token));};var updateCheckoutOrder=function updateCheckoutOrder(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/orders/',data.form,headerWithToken('JWT '+token));};var updateOrderAmount=function updateOrderAmount(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/orders/'+data.id+'/amount',data.form,headerWithToken('JWT '+token));};var getTransferHistory=function getTransferHistory(token){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{page:1,limit:10};return apiWrapper.get('/transfer-histories',filter,headerWithToken('JWT '+token));};var getTransferHistoryMatches=function getTransferHistoryMatches(token){return apiWrapper.get('/transfer-histories/matches',null,headerWithToken('JWT '+token));};var updateTransferHistory=function updateTransferHistory(token){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{id:null,form:{}};return apiWrapper.put('/transfer-histories/'+data.id,data.form,headerWithToken('JWT '+token));};var transferHistoryListSpreadsheet=function transferHistoryListSpreadsheet(token,filter){filter=Object.assign({from:null,until:null,status:null},filter);var params=[];if(filter.from){params.push('from='+filter.from);}if(filter.until){params.push('until='+filter.until);}if(filter.status){params.push('status='+filter.status);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/transfer-histories/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='transfer_history-'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success getting transfer history list',status:true};});};var orderListSpreadsheet=function orderListSpreadsheet(token,filter){filter=Object.assign({from:null,until:null,code:'',status:'',order_status:null,payment_method:''},filter);var params=[];if(filter.from){params.push('from='+filter.from);}if(filter.until){params.push('until='+filter.until);}if(filter.status){params.push('status='+filter.status);}if(filter.code){params.push('code='+filter.code);}if(filter.order_status){params.push('order_status='+filter.order_status);}if(filter.payment_method){params.push('payment_method='+filter.payment_method);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/orders/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='order_list-'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success getting order list',status:true};});};var orderDetailListSpreadsheet=function orderDetailListSpreadsheet(token,filter){filter=Object.assign({created_from:null,created_until:null,code:'',status:'',type:'modem'},filter);var params=[];if(filter.created_from){params.push('created_from='+filter.created_from);}if(filter.created_until){params.push('created_until='+filter.created_until);}if(filter.code){params.push('code='+filter.code);}if(filter.status){params.push('status='+filter.status);}if(filter.type){params.push('type='+filter.type);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/order-details/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='order_detail_list-'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success getting order detail list',status:true};});};var downloadOrderInvoice=function downloadOrderInvoice(token,data){var id=data.id,order_number=data.order_number;return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/orders/'+id+'/invoice',responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/pdf'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='INVOICE-'+order_number+'.pdf';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success download invoice',status:true};});};var resendOrderVoucher=function resendOrderVoucher(token,data){var id=data.id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('hooks/bookings/resend-voucher/'+id,null,headerWithToken('JWT '+token));};var getOrderReport=function getOrderReport(token,filter){filter=Object.assign({page:1,limit:10,from:null,until:null,type:'modem'},filter);apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/orders/report',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getOrderReportSpreadsheet=function getOrderReportSpreadsheet(token,filter){// filter = { ...filter }
var from=filter.from,until=filter.until,type=filter.type;var params=[];params.push('from='+from);params.push('until='+until);params.push('type='+type);return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/orders/report/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='travypass_order_report_'+type+'_'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'SUCCESS',message:'Success download travy order report',status:true};});};var refundDana=function refundDana(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/payment/'+data.uuid+'/refund-dana',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(data.form),headerWithToken('JWT '+token));};// USERS COLLECTIONS
var getUser=function getUser(token,filter){var initFilter={page:1,limit:10,q:'',registration_from:null,registration_until:null// only_admins: true
};filter=Object.assign({},initFilter,filter);apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/users',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getUserCount=function getUserCount(token){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{from:'',until:''};return apiWrapper.get('/users/stats/registration-rate',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createUser=function createUser(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/auth/register',data,headerWithToken('JWT '+token));};var updateUser=function updateUser(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/users/'+data.id,data.form,headerWithToken('JWT '+token));};var deleteUser=function deleteUser(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/users/'+id,null,headerWithToken('JWT '+token));};var downloadUserList=function downloadUserList(token,data){data=Object.assign({type:null},data);var params=[];if(data.type){params.push('type='+data.type);}return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/users-list/spreadsheet?'+params.join('&'),responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='user_list_'+(data.type!==''?data.type:'all')+'_'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.xlsx';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success download user list',status:true};});};// REVIEW
var getReviewList=function getReviewList(token){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{page:1,limit:10,status:null};return apiWrapper.get('/reviews',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var approveReview=function approveReview(token,id){return apiWrapper.put('/reviews/'+id+'/verify',{},headerWithToken('JWT '+token));};// DATABASE
var dumpDatabase=function dumpDatabase(token){return __WEBPACK_IMPORTED_MODULE_5_axios___default()({method:'get',url:apiURL+'/dump-database',responseType:'arraybuffer',headers:{authorization:'JWT '+token}}).then(function(response){var blob=new Blob([response.data],{type:'application/zip'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='passpod_db_'+__WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YMMDDhhmmss')+'.zip';document.body.appendChild(link);link.click();document.body.removeChild(link);return{ok:true,data:'success',message:'Success dump database',status:true};});};// ECOMMERCE CATEGORY COLLECTIONS
var getCategory=function getCategory(token,filter){filter=Object.assign({page:1,limit:100,q:null},filter);return apiWrapper.get('/categories',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getSingleCategory=function getSingleCategory(token,id){return apiWrapper.get('/categories/'+id,null,headerWithToken('JWT '+token));};var createCategory=function createCategory(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/categories',data,headerWithToken('JWT '+token));};var updateCategory=function updateCategory(token,_ref33){var id=_ref33.id,form=_ref33.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/categories/'+id,form,headerWithToken('JWT '+token));};// ECOMMERCE VARIAN-SIZES COLLECTIONS
var getSize=function getSize(token,filter){filter=Object.assign({page:1,limit:100,q:null},filter);return apiWrapper.get('/varian-sizes',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getAllSize=function getAllSize(token,filter){return apiWrapper.get('/varian-sizes',null,headerWithToken('JWT '+token));};var createSize=function createSize(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/varian-sizes',data,headerWithToken('JWT '+token));};var updateSize=function updateSize(token,_ref34){var id=_ref34.id,form=_ref34.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/varian-sizes/'+id,form,headerWithToken('JWT '+token));};var deleteSize=function deleteSize(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/varian-sizes/'+id,null,headerWithToken('JWT '+token));};// ECOMMERCE VARIAN-COLOURS COLLECTIONS
var getColour=function getColour(token,filter){filter=Object.assign({page:1,limit:100,q:null},filter);return apiWrapper.get('/varian-colours',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getAllColour=function getAllColour(token,filter){return apiWrapper.get('/varian-colours',null,headerWithToken('JWT '+token));};var createColour=function createColour(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/varian-colours',data,headerWithToken('JWT '+token));};var updateColour=function updateColour(token,_ref35){var id=_ref35.id,form=_ref35.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/varian-colours/'+id,form,headerWithToken('JWT '+token));};var deleteColour=function deleteColour(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/varian-colours/'+id,null,headerWithToken('JWT '+token));};// ECOMMERCE BRAND COLLECTIONS
var getBrand=function getBrand(token,filter){filter=Object.assign({page:1,limit:100,q:null},filter);return apiWrapper.get('/brands',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createBrand=function createBrand(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/brands',data,headerWithToken('JWT '+token));};var updateBrand=function updateBrand(token,_ref36){var id=_ref36.id,form=_ref36.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/brands/'+id,form,headerWithToken('JWT '+token));};var deleteBrand=function deleteBrand(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/brands/'+id,null,headerWithToken('JWT '+token));};var getSingleBrand=function getSingleBrand(token,id){return apiWrapper.get('/brands/'+id,null,headerWithToken('JWT '+token));};var createCategoryBrand=function createCategoryBrand(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/category-brands',data,headerWithToken('JWT '+token));};var updateCategoryBrand=function updateCategoryBrand(token,_ref37){var id=_ref37.id,form=_ref37.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/category-brands/'+id,form,headerWithToken('JWT '+token));};var deleteCategoryBrand=function deleteCategoryBrand(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/category-brands/'+id,null,headerWithToken('JWT '+token));};// ECOMMERCE WAREHOUSE COLLECTIONS
var getWarehouse=function getWarehouse(token,filter){filter=Object.assign({page:1,limit:100,q:null},filter);return apiWrapper.get('/warehouses',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createWarehouse=function createWarehouse(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/warehouses',data,headerWithToken('JWT '+token));};var updateWarehouse=function updateWarehouse(token,_ref38){var id=_ref38.id,form=_ref38.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/warehouses/'+id,form,headerWithToken('JWT '+token));};var deleteWarehouse=function deleteWarehouse(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/warehouses/'+id,null,headerWithToken('JWT '+token));};// ECOMMERCE SUPPLIER COLLECTIONS
var getSupplier=function getSupplier(token,filter){filter=Object.assign({q:null,limit:100},filter);return apiWrapper.get('/suppliers',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createSupplier=function createSupplier(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/suppliers',data,headerWithToken('JWT '+token));};var updateSupplier=function updateSupplier(token,_ref39){var id=_ref39.id,form=_ref39.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/suppliers/'+id,form,headerWithToken('JWT '+token));};var deleteSupplier=function deleteSupplier(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/suppliers/'+id,null,headerWithToken('JWT '+token));};// Location API
var getProvince=function getProvince(token,filter){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/addresses/provinces');};var getCities=function getCities(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/addresses/cities/',{province_id:id});};var getDistricts=function getDistricts(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/addresses/districts/',{parent_id:id});};// ECOMMERCE INVENTORY COLLECTIONS
var getInventory=function getInventory(token,filter){filter=Object.assign({page:1,limit:10,q:null},filter);return apiWrapper.get('/inventories',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var createInventory=function createInventory(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/inventories',data,headerWithToken('JWT '+token));};var updateInventory=function updateInventory(token,_ref40){var id=_ref40.id,form=_ref40.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/inventories/'+id,form,headerWithToken('JWT '+token));};var updateInventoryImage=function updateInventoryImage(token,_ref41){var id=_ref41.id,form=_ref41.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/inventories/'+id+'/images',form,headerWithToken('JWT '+token));};var deleteInventory=function deleteInventory(token,id){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/inventories/'+id,null,headerWithToken('JWT '+token));};// ECOMMERCE PRODUCT COLLECTIONS
var getEcommerceProduct=function getEcommerceProduct(token,filter){filter=Object.assign({page:1,limit:10,q:null},filter);return apiWrapper.get('/inventories',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var viewEcommerceProduct=function viewEcommerceProduct(token,_ref42){var inventoryID=_ref42.inventoryID,ecommerceProductID=_ref42.ecommerceProductID;return apiWrapper.get('/inventories/'+inventoryID+'/items/'+ecommerceProductID,null,headerWithToken('JWT '+token));};var createEcommerceProduct=function createEcommerceProduct(token,_ref43){var id=_ref43.id,form=_ref43.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/inventories/'+id+'/items',form,headerWithToken('JWT '+token));};var createEcommerceProductStock=function createEcommerceProductStock(token,_ref44){var inventoryID=_ref44.inventoryID,ecommerceProductID=_ref44.ecommerceProductID,form=_ref44.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/inventories/'+inventoryID+'/items/'+ecommerceProductID+'/stocks',form,headerWithToken('JWT '+token));};var updateEcommerceProduct=function updateEcommerceProduct(token,_ref45){var inventoryID=_ref45.inventoryID,ecommerceProductID=_ref45.ecommerceProductID,form=_ref45.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/inventories/'+inventoryID+'/items/'+ecommerceProductID,form,headerWithToken('JWT '+token));};var deleteEcommerceProduct=function deleteEcommerceProduct(token,_ref46){var inventoryID=_ref46.inventoryID,ecommerceProductID=_ref46.ecommerceProductID;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/inventories/'+inventoryID+'/items/'+ecommerceProductID,null,headerWithToken('JWT '+token));};// ECOMMERCE ORDER COLLECTIONS
var getEcommerceOrder=function getEcommerceOrder(token,filter){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('order-products',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(filter),headerWithToken('JWT '+token));};var getEcommerceOrderShipping=function getEcommerceOrderShipping(token,_ref47){var uuid=_ref47.uuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/order-products/'+uuid+'/shipping',null,headerWithToken('JWT '+token));};var postEcommerceOrderShipping=function postEcommerceOrderShipping(token,_ref48){var uuid=_ref48.uuid,form=_ref48.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/order-products/'+uuid+'/shipping',form,headerWithToken('JWT '+token));};var putEcommerceOrderShipping=function putEcommerceOrderShipping(token,_ref49){var uuid=_ref49.uuid,shippingUUID=_ref49.shippingUUID,form=_ref49.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/order-products/'+uuid+'/shipping/'+shippingUUID,form,headerWithToken('JWT '+token));};var deleteEcommerceOrderShipping=function deleteEcommerceOrderShipping(token,_ref50){var uuid=_ref50.uuid,shippingUUID=_ref50.shippingUUID;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/order-products/'+uuid+'/shipping/'+shippingUUID,null,headerWithToken('JWT '+token));};// SECTION REQUESTS
var getSection=function getSection(token){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/sections',null,headerWithToken('JWT '+token));};var postSection=function postSection(token,_ref51){var form=_ref51.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/sections',form,headerWithToken('JWT '+token));};var putSection=function putSection(token,_ref52){var uuid=_ref52.uuid,form=_ref52.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/sections/'+uuid,form,headerWithToken('JWT '+token));};var deleteSection=function deleteSection(token,_ref53){var uuid=_ref53.uuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/sections/'+uuid,null,headerWithToken('JWT '+token));};var getSubSection=function getSubSection(token,_ref54){var uuid=_ref54.uuid;};// will eventually replace props-based detail modal
var postSubSection=function postSubSection(token,_ref55){var form=_ref55.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/sub-sections/',form,headerWithToken('JWT '+token));};var putSubSection=function putSubSection(token,_ref56){var uuid=_ref56.uuid,form=_ref56.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/sub-sections/'+uuid,form,headerWithToken('JWT '+token));};var deleteSubSection=function deleteSubSection(token,_ref57){var uuid=_ref57.uuid;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/sub-sections/'+uuid,null,headerWithToken('JWT '+token));};// ATTRACTION PROMO REQUESTS
var getAttractionPromo=function getAttractionPromo(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('attraction-promotions',data,headerWithToken('JWT '+token));};var postAttractionPromo=function postAttractionPromo(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('attraction-promotions',data,headerWithToken('JWT '+token));};var putAttractionPromo=function putAttractionPromo(token,_ref58){var uuid=_ref58.uuid,form=_ref58.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('attraction-promotions/'+uuid,form,headerWithToken('JWT '+token));};var deleteAttractionPromo=function deleteAttractionPromo(token,uuid){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('attraction-promotions/'+uuid,null,headerWithToken('JWT '+token));};// FAILED TRANSACTION REQUESTS
var getFailedTransaction=function getFailedTransaction(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/failed-transactions',data,headerWithToken('JWT '+token));};var triggerFailedTransaction=function triggerFailedTransaction(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/cron?key=resend-transaction',null,headerWithToken('JWT '+token));};// CUSTOM REQUESTS
var getProductCustom=function getProductCustom(token){return apiWrapper.get('/products',null,headerWithToken('JWT '+token));};var getBannerCustom=function getBannerCustom(token){return apiWrapper.get('/banners',null,headerWithToken('JWT '+token));};var getInventoryCustom=function getInventoryCustom(token){return apiWrapper.get('/inventories',null,headerWithToken('JWT '+token));};// SCHEDULER REQUESTS
var getScheduler=function getScheduler(token,filter){return apiWrapper.get('/schedulers',filter,headerWithToken('JWT '+token));};var getSchedulerDetail=function getSchedulerDetail(token,_ref59){var id=_ref59.id;return apiWrapper.get('/schedulers/'+id,null,headerWithToken('JWT '+token));};var postScheduler=function postScheduler(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.post('/schedulers',Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(data),headerWithToken('JWT '+token));};var putScheduler=function putScheduler(token,_ref60){var id=_ref60.id,form=_ref60.form;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/schedulers/'+id,Object(__WEBPACK_IMPORTED_MODULE_2__Utils_ObjectCleaner__["a" /* default */])(form),headerWithToken('JWT '+token));};var deleteScheduler=function deleteScheduler(token,_ref61){var id=_ref61.id;apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.delete('/schedulers/'+id,null,headerWithToken('JWT '+token));};// CRON-REPORT REQUESTS
var getCronReport=function getCronReport(token,filter){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/cron/report',filter,headerWithToken('JWT '+token));};var getCronReportItem=function getCronReportItem(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/cron/report/'+data.id,data.filter,headerWithToken('JWT '+token));};var disableAttraction=function disableAttraction(token,body){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/cron/disable-attraction',body,headerWithToken('JWT '+token));};var enableAttraction=function enableAttraction(token,body){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/cron/enable-attraction',body,headerWithToken('JWT '+token));};var getWhitelist=function getWhitelist(token){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/whitelisted-attraction/',null,headerWithToken('JWT '+token));};var putWhitelist=function putWhitelist(token,body){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/whitelisted-attraction?process=update',body,headerWithToken('JWT '+token));};var deleteWhitelist=function deleteWhitelist(token,body){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/whitelisted-attraction?process=delete',body,headerWithToken('JWT '+token));};var getPromoSection=function getPromoSection(token){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.get('/sections/promo',null,headerWithToken('JWT '+token));};var updatePromoSection=function updatePromoSection(token,data){apiWrapper.setHeader('Content-Type','application/json');return apiWrapper.put('/sections/promo/'+data.id,data.form,headerWithToken('JWT '+token));};// ------
// STEP 3
// ------
//
// Return back a collection of functions that we would consider our
// interface.  Most of the time it'll be just the list of all the
// methods in step 2.
//
// Notice we're not returning back the `api` created in step 1?  That's
// because it is scoped privately.  This is one way to create truly
// private scoped goodies in JavaScript.
//
return{// a list of the API functions from step 2
getUserData:getUserData,getDatawithToken:getDatawithToken,postData:postData,login:login,checkLogin:checkLogin,getCurrencies:getCurrencies,getLanguages:getLanguages,getCountries:getCountries,getPresetOrder:getPresetOrder,updatePresetOrder:updatePresetOrder,getBranch:getBranch,updateBranch:updateBranch,getShipping:getShipping,updateShipping:updateShipping,getDestination:getDestination,createDestination:createDestination,deleteDestination:deleteDestination,updateDestination:updateDestination,addAttractionToDestination:addAttractionToDestination,deleteAttractionFromDestination:deleteAttractionFromDestination,getContinent:getContinent,addPlaceToDestination:addPlaceToDestination,deletePlaceFromDestination:deletePlaceFromDestination,getPlacesV2:getPlacesV2,getPlacesByDestination:getPlacesByDestination,searchPlaces:searchPlaces,getAttractionByDestination:getAttractionByDestination,getAttractionDetail:getAttractionDetail,getPlaceDetail:getPlaceDetail,updateAttractionDetail:updateAttractionDetail,clearAttractionCache:clearAttractionCache,downloadAttractionData:downloadAttractionData,searchAttraction:searchAttraction,getPopularAttraction:getPopularAttraction,savePopularAttraction:savePopularAttraction,deletePopularAttraction:deletePopularAttraction,editPopularAttraction:editPopularAttraction,getAllCoupon:getAllCoupon,getCouponDetail:getCouponDetail,createNewCoupon:createNewCoupon,updateCoupon:updateCoupon,updateBusiness:updateBusiness,deleteCoupon:deleteCoupon,deleteBusiness:deleteBusiness,getAllCouponTag:getAllCouponTag,generateCoupon:generateCoupon,couponSpreadsheet:couponSpreadsheet,historySpreadsheet:historySpreadsheet,getCouponItem:getCouponItem,postCouponItem:postCouponItem,postCouponItemTag:postCouponItemTag,deleteCouponItem:deleteCouponItem,deleteCouponItemTag:deleteCouponItemTag,getCouponProvider:getCouponProvider,postCouponProvider:postCouponProvider,putCouponProvider:putCouponProvider,deleteCouponProvider:deleteCouponProvider,getCouponPreset:getCouponPreset,postCouponPreset:postCouponPreset,putCouponPreset:putCouponPreset,deleteCouponPreset:deleteCouponPreset,getAffiliates:getAffiliates,affiliateTransfer:affiliateTransfer,getProduct:getProduct,createProduct:createProduct,deleteProduct:deleteProduct,updateProduct:updateProduct,getProductCountry:getProductCountry,postProductCountry:postProductCountry,deleteProductCountry:deleteProductCountry,getProductCampaign:getProductCampaign,postProductCampaign:postProductCampaign,putProductCampaign:putProductCampaign,deleteProductCampaign:deleteProductCampaign,getProductVariant:getProductVariant,postProductVariant:postProductVariant,putProductVariant:putProductVariant,deleteProductVariant:deleteProductVariant,getProductVariantItem:getProductVariantItem,postProductVariantItem:postProductVariantItem,deleteProductVariantItem:deleteProductVariantItem,getAllEsims:getAllEsims,updateEsimData:updateEsimData,updateEsimCountry:updateEsimCountry,updateEsimVariant:updateEsimVariant,getAllEvents:getAllEvents,// getEvents,
getEventsCategories:getEventsCategories,getAllPopularEvents:getAllPopularEvents,setPopularEvent:setPopularEvent,resetEventDescription:resetEventDescription,updateEventDescription:updateEventDescription,getTravelPackage:getTravelPackage,viewTravelPackage:viewTravelPackage,postTravelPackage:postTravelPackage,postTravelPackagePrice:postTravelPackagePrice,putTravelPackage:putTravelPackage,putTravelPackagePrice:putTravelPackagePrice,deleteTravelPackage:deleteTravelPackage,switchTravelPackagePrice:switchTravelPackagePrice,getTicketPackage:getTicketPackage,postTicketPackage:postTicketPackage,putTicketPackage:putTicketPackage,deleteTicketPackage:deleteTicketPackage,getBanners:getBanners,createBanner:createBanner,deleteBanner:deleteBanner,updateBanner:updateBanner,getMarkup:getMarkup,createMarkup:createMarkup,updateMarkup:updateMarkup,deleteMarkup:deleteMarkup,markupItemCreate:markupItemCreate,markupItemUpdate:markupItemUpdate,markupItemDelete:markupItemDelete,markupItemGet:markupItemGet,getExchangeRate:getExchangeRate,getSingleExchangeRate:getSingleExchangeRate,updateExchangeRate:updateExchangeRate,getUser:getUser,getUserCount:getUserCount,createUser:createUser,updateUser:updateUser,deleteUser:deleteUser,downloadUserList:downloadUserList,getOrder:getOrder,getOrderSingle:getOrderSingle,getChatbotOrder:getChatbotOrder,postChatbotOrder:postChatbotOrder,getOrderDetailList:getOrderDetailList,confirmOrder:confirmOrder,getTransferHistory:getTransferHistory,getTransferHistoryMatches:getTransferHistoryMatches,updateOrder:updateOrder,updateCheckoutOrder:updateCheckoutOrder,updateOrderAmount:updateOrderAmount,updateTransferHistory:updateTransferHistory,orderListSpreadsheet:orderListSpreadsheet,orderDetailListSpreadsheet:orderDetailListSpreadsheet,transferHistoryListSpreadsheet:transferHistoryListSpreadsheet,downloadOrderInvoice:downloadOrderInvoice,resendOrderVoucher:resendOrderVoucher,getOrderReport:getOrderReport,getOrderReportSpreadsheet:getOrderReportSpreadsheet,refundDana:refundDana,uploadFiles:uploadFiles,getReviewList:getReviewList,approveReview:approveReview,dumpDatabase:dumpDatabase,getCategory:getCategory,getSingleCategory:getSingleCategory,createCategory:createCategory,updateCategory:updateCategory,getColour:getColour,getAllColour:getAllColour,createColour:createColour,updateColour:updateColour,deleteColour:deleteColour,getSize:getSize,getAllSize:getAllSize,createSize:createSize,updateSize:updateSize,deleteSize:deleteSize,getBrand:getBrand,createBrand:createBrand,updateBrand:updateBrand,deleteBrand:deleteBrand,getSingleBrand:getSingleBrand,createCategoryBrand:createCategoryBrand,updateCategoryBrand:updateCategoryBrand,deleteCategoryBrand:deleteCategoryBrand,getWarehouse:getWarehouse,createWarehouse:createWarehouse,updateWarehouse:updateWarehouse,deleteWarehouse:deleteWarehouse,getSupplier:getSupplier,createSupplier:createSupplier,updateSupplier:updateSupplier,deleteSupplier:deleteSupplier,getProvince:getProvince,getCities:getCities,getDistricts:getDistricts,getInventory:getInventory,createInventory:createInventory,updateInventory:updateInventory,updateInventoryImage:updateInventoryImage,deleteInventory:deleteInventory,getEcommerceProduct:getEcommerceProduct,viewEcommerceProduct:viewEcommerceProduct,createEcommerceProduct:createEcommerceProduct,createEcommerceProductStock:createEcommerceProductStock,updateEcommerceProduct:updateEcommerceProduct,deleteEcommerceProduct:deleteEcommerceProduct,getEcommerceOrder:getEcommerceOrder,getEcommerceOrderShipping:getEcommerceOrderShipping,postEcommerceOrderShipping:postEcommerceOrderShipping,putEcommerceOrderShipping:putEcommerceOrderShipping,deleteEcommerceOrderShipping:deleteEcommerceOrderShipping,getSection:getSection,postSection:postSection,putSection:putSection,deleteSection:deleteSection,getSubSection:getSubSection,postSubSection:postSubSection,putSubSection:putSubSection,deleteSubSection:deleteSubSection,getAttractionPromo:getAttractionPromo,postAttractionPromo:postAttractionPromo,putAttractionPromo:putAttractionPromo,deleteAttractionPromo:deleteAttractionPromo,getFailedTransaction:getFailedTransaction,triggerFailedTransaction:triggerFailedTransaction,getProductCustom:getProductCustom,getBannerCustom:getBannerCustom,getInventoryCustom:getInventoryCustom,getScheduler:getScheduler,getSchedulerDetail:getSchedulerDetail,postScheduler:postScheduler,putScheduler:putScheduler,deleteScheduler:deleteScheduler,getCronReport:getCronReport,getCronReportItem:getCronReportItem,disableAttraction:disableAttraction,enableAttraction:enableAttraction,getWhitelist:getWhitelist,putWhitelist:putWhitelist,deleteWhitelist:deleteWhitelist,getPromoSection:getPromoSection,updatePromoSection:updatePromoSection};};// let's return back our create method as the default.
/* harmony default export */ __webpack_exports__["a"] = ({create:create});

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var _default23=_interopDefault(__webpack_require__(372)),_default22=_interopDefault(__webpack_require__(181)),_default21=_interopDefault(__webpack_require__(66)),_default20=_interopDefault(__webpack_require__(357)),_default19=_interopDefault(__webpack_require__(247)),_default18=_interopDefault(__webpack_require__(369)),_default17=_interopDefault(__webpack_require__(175)),_default16=_interopDefault(__webpack_require__(113)),_default15=_interopDefault(__webpack_require__(360)),_default14=_interopDefault(__webpack_require__(379)),_default13=_interopDefault(__webpack_require__(378)),_default12=_interopDefault(__webpack_require__(359)),_default11=_interopDefault(__webpack_require__(239)),_default10=_interopDefault(__webpack_require__(255)),_default9=_interopDefault(__webpack_require__(234)),_default8=_interopDefault(__webpack_require__(340)),_default7=_interopDefault(__webpack_require__(250)),_default6=_interopDefault(__webpack_require__(132)),_default5=_interopDefault(__webpack_require__(231)),_default4=_interopDefault(__webpack_require__(187)),_default3=_interopDefault(__webpack_require__(150)),_default2=_interopDefault(__webpack_require__(177)),_default=_interopDefault(__webpack_require__(246)),axios=_interopDefault(__webpack_require__(462)),__assign=Object.assign||function(e){for(var t,r=1,a=arguments.length;r<a;r++){t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},__awaiter=function(e,t,r,a){return new(r||(r=Promise))(function(n,u){function i(e){try{o(a.next(e))}catch(e){u(e)}}function R(e){try{o(a.throw(e))}catch(e){u(e)}}function o(e){e.done?n(e.value):new r(function(t){t(e.value)}).then(i,R)}o((a=a.apply(e,t||[])).next())})},__generator=function(e,t){function r(r){return function(i){return function(r){if(a)throw new TypeError("Generator is already executing.");for(;R;)try{if(a=1,n&&(u=n[2&r[0]?"return":r[0]?"throw":"next"])&&!(u=u.call(n,r[1])).done)return u;switch(n=0,u&&(r=[0,u.value]),r[0]){case 0:case 1:u=r;break;case 4:return R.label++,{value:r[1],done:!1};case 5:R.label++,n=r[1],r=[0];continue;case 7:r=R.ops.pop(),R.trys.pop();continue;default:if(u=R.trys,!(u=u.length>0&&u[u.length-1])&&(6===r[0]||2===r[0])){R=0;continue}if(3===r[0]&&(!u||r[1]>u[0]&&r[1]<u[3])){R.label=r[1];break}if(6===r[0]&&R.label<u[1]){R.label=u[1],u=r;break}if(u&&R.label<u[2]){R.label=u[2],R.ops.push(r);break}u[2]&&R.ops.pop(),R.trys.pop();continue}r=t.call(e,R)}catch(e){r=[6,e],n=0}finally{a=u=0}if(5&r[0])throw r[1];return{value:r[0]?r[1]:void 0,done:!0}}([r,i])}}var a,n,u,i,R={label:0,sent:function(){if(1&u[0])throw u[1];return u[1]},trys:[],ops:[]};return i={next:r(0),throw:r(1),return:r(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i},_this=void 0,toNumber=_default([[_default2,_default3],[_default4(Number),_default3],[_default5,function(e){return Number(e)}]]),isWithin=_default6(function(e,t,r){var a=_default4(Number);return a(e)&&a(t)&&a(r)&&_default7(r,e)&&_default7(t,r)}),containsText=function(e){return function(t){return _default8(t,e)}},isInvalidConfig=_default9([_default2,_default10,_default11(_default12("baseURL")),_default11(_default13(String,"baseURL")),_default14(_default10,"baseURL")]),isPromise=function(e){return!!e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof e.then},DEFAULT_HEADERS={Accept:"application/json","Content-Type":"application/json"},DEFAULT_CONFIG={timeout:0},NONE=null,CLIENT_ERROR="CLIENT_ERROR",SERVER_ERROR="SERVER_ERROR",TIMEOUT_ERROR="TIMEOUT_ERROR",CONNECTION_ERROR="CONNECTION_ERROR",NETWORK_ERROR="NETWORK_ERROR",UNKNOWN_ERROR="UNKNOWN_ERROR",CANCEL_ERROR="CANCEL_ERROR",TIMEOUT_ERROR_CODES=["ECONNABORTED"],NODEJS_CONNECTION_ERROR_CODES=["ENOTFOUND","ECONNREFUSED","ECONNRESET"],in200s=isWithin(200,299),in400s=isWithin(400,499),in500s=isWithin(500,599),statusNil=_default15(_default2,_default16(void 0),_default17("status")),create=function(e){if(isInvalidConfig(e))throw new Error("config must have a baseURL");var t=_default18(DEFAULT_HEADERS,e.headers||{}),r=_default18(DEFAULT_CONFIG,_default19("headers",e)),a=axios.create(r),n=[],u=[],i=[],R=[],o=function(e,r){return t[e]=r,a},l=function(e,t,r,a){return void 0===r&&(r={}),void 0===a&&(a={}),s(_default18({url:t,params:r,method:e},a))},f=function(e,t,r,a){return void 0===r&&(r=null),void 0===a&&(a={}),s(_default18({url:t,method:e,data:r},a))},s=function(e){return __awaiter(_this,void 0,void 0,function(){var r,n,R;return __generator(this,function(o){switch(o.label){case 0:if(e.headers=__assign({},t,e.headers),u.length>0&&_default20(function(t){return t(e)},u),!(i.length>0))return[3,6];r=0,o.label=1;case 1:return r<i.length?(n=i[r](e),isPromise(n)?[4,n]:[3,3]):[3,6];case 2:return o.sent(),[3,5];case 3:return[4,n(e)];case 4:o.sent(),o.label=5;case 5:return r++,[3,1];case 6:return R=_default22(d(toNumber(new Date)),_),[2,a.request(e).then(R).catch(R)]}})})},_=function(e){return n.forEach(function(t){try{t(e)}catch(e){}}),e},d=_default6(function(e,t){var r=toNumber(new Date)-e,a=t instanceof Error||axios.isCancel(t),n=t,u=a?t.response:n,i=u&&u.status||null,o=a?E(t):c(i),l=in200s(i),f=t.config||null,s={duration:r,problem:o,ok:l,status:i,headers:u&&u.headers||null,config:f,data:u&&u.data||null};return R.length>0&&_default20(function(e){return e(s)},R),s}),E=function(e){return"Network Error"===e.message?NETWORK_ERROR:axios.isCancel(e)?CANCEL_ERROR:_default([[_default2,function(){return c(statusNil(e.response))}],[containsText(TIMEOUT_ERROR_CODES),_default16(TIMEOUT_ERROR)],[containsText(NODEJS_CONNECTION_ERROR_CODES),_default16(CONNECTION_ERROR)],[_default5,_default16(UNKNOWN_ERROR)]])(e.code)},c=function(e){return _default([[_default2,_default16(UNKNOWN_ERROR)],[in200s,_default16(NONE)],[in400s,_default16(CLIENT_ERROR)],[in500s,_default16(SERVER_ERROR)],[_default5,_default16(UNKNOWN_ERROR)]])(e)};return{axiosInstance:a,monitors:n,addMonitor:function(e){n.push(e)},requestTransforms:u,asyncRequestTransforms:i,responseTransforms:R,addRequestTransform:function(e){return u.push(e)},addAsyncRequestTransform:function(e){return i.push(e)},addResponseTransform:function(e){return R.push(e)},setHeader:o,setHeaders:function(e){return _default20(function(t){return o(t,e[t])},_default21(e)),a},deleteHeader:function(e){return delete t[e],a},headers:t,setBaseURL:function(e){return a.defaults.baseURL=e,a},getBaseURL:function(){return a.defaults.baseURL},get:_default23(l,["get"]),delete:_default23(l,["delete"]),head:_default23(l,["head"]),post:_default23(f,["post"]),put:_default23(f,["put"]),patch:_default23(f,["patch"]),link:_default23(l,["link"]),unlink:_default23(l,["unlink"])}},apisauce={DEFAULT_HEADERS:DEFAULT_HEADERS,NONE:NONE,CLIENT_ERROR:CLIENT_ERROR,SERVER_ERROR:SERVER_ERROR,TIMEOUT_ERROR:TIMEOUT_ERROR,CONNECTION_ERROR:CONNECTION_ERROR,NETWORK_ERROR:NETWORK_ERROR,UNKNOWN_ERROR:UNKNOWN_ERROR,create:create};exports.DEFAULT_HEADERS=DEFAULT_HEADERS,exports.NONE=NONE,exports.CLIENT_ERROR=CLIENT_ERROR,exports.SERVER_ERROR=SERVER_ERROR,exports.TIMEOUT_ERROR=TIMEOUT_ERROR,exports.CONNECTION_ERROR=CONNECTION_ERROR,exports.NETWORK_ERROR=NETWORK_ERROR,exports.UNKNOWN_ERROR=UNKNOWN_ERROR,exports.CANCEL_ERROR=CANCEL_ERROR,exports.create=create,exports.default=apisauce;


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var bind = __webpack_require__(463);
var Axios = __webpack_require__(1325);
var defaults = __webpack_require__(294);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(467);
axios.CancelToken = __webpack_require__(1339);
axios.isCancel = __webpack_require__(466);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1340);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(294);
var utils = __webpack_require__(62);
var InterceptorManager = __webpack_require__(1334);
var dispatchRequest = __webpack_require__(1335);
var isAbsoluteURL = __webpack_require__(1337);
var combineURLs = __webpack_require__(1338);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(465);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);
var transformData = __webpack_require__(1336);
var isCancel = __webpack_require__(466);
var defaults = __webpack_require__(294);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(62);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(467);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c015307e.js